(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function() {
return (window["webpackJsonp"] = window["webpackJsonp"] || []).push([[5],{

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

/*@ngInject*/
angular.module('gw-um-grid-data-browser', ['umCore']).constant('gridDataBrowserConstant', {
  event: {
    BULK_ACTION_COMPLETE: 'gridDataBrowserModule.BulkActionComplete'
  }
}).run(function () {});
__webpack_require__(566);
module.exports = 'gw-um-grid-data-browser';

/***/ }),

/***/ 1837:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);
__webpack_require__(2);
__webpack_require__(26);
__webpack_require__(50);
__webpack_require__(139);
var authModule = __webpack_require__(110);
var coreModule = __webpack_require__(58);
var headerModule = __webpack_require__(564);
var gridDataBrowserModule = __webpack_require__(109);
var emailEditorModule = __webpack_require__(163);
var extensions = __webpack_require__(565);
angular.module('ums', [coreModule, authModule, 'ums.configuration', headerModule, gridDataBrowserModule, emailEditorModule, extensions]).constant('umStudioConstant', {
  event: {
    BULK_FORM_TEMPLATE_EXPORT: 'formTemplate.BulkFormTemplateExport',
    BULK_FORM_TEMPLATE_EXPORT_COMPLETE: 'formTemplate.BulkFormTemplateExportComplete',
    BULK_FORM_TEMPLATE_MARK_IN_PRODUCTION: 'formTemplate.BulkFormTemplateMarkInProduction',
    BULK_FORM_TEMPLATE_MARK_IN_PRODUCTION_COMPLETE: 'formTemplate.BulkFormTemplateMarkInProductionComplete',
    FOCUS_ON_RULE_NAME: 'ruleBuilder.FocusOnRuleName',
    RULE_UPDATED: 'ruleBuilder.RuleUpdated',
    RULE_STATUS_UPDATED: 'ruleBuilder.RuleStatusUpdated',
    RULE_VARIABLE_VALUE_CHANGED: 'ruleBuilder.RuleVariableValueChanged',
    FIELD_RULE_SELECTED: 'formTemplate.ruleBuilder.FieldRuleSelected',
    FORM_RULE_SELECTED: 'formTemplate.ruleBuilder.FormRuleSelected',
    RESET_RULE_SELECTION: 'formTemplate.ruleBuilder.ResetRuleSelection',
    CREATE_NEW_FIELD_RULE: 'formTemplate.ruleBuilder.CreateNewFieldRule'
  }
}).config(function () {}).run(["appTypeConfigurationModel", "coreConstant", function (appTypeConfigurationModel, coreConstant) {
  appTypeConfigurationModel.setConsoleType(coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO);
}]).baseURL = './';
__webpack_require__(1838);
__webpack_require__(1839);
__webpack_require__(1840);
__webpack_require__(1844);
__webpack_require__(1845);
__webpack_require__(1846);
__webpack_require__(1848);

/***/ }),

/***/ 1838:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ApplicationController = function ApplicationController($rootScope, $scope, $state, $location, $timeout, coreConstant, localization, authorizationConstants, coreMediator, notificationPopupUtil, authenticationUtil, refreshLoginTokenUtil, uiPerformanceLogger, adminFunctionHeaderButtonsMediator, adminFunctionHeaderButtonsModel) {
  var bootstrapRedirect,
    timeoutList = [],
    notificationLoadingBarPromise = null,
    notificationLoadingBarScope = null,
    fadingNotificationScope = null;
  $scope.appIsReady = false;
  function goToLoginPage() {
    $scope.appIsReady = true;
    if ($state.current.name !== 'password' && !$location.search().token) {
      if (!bootstrapRedirect) {
        bootstrapRedirect = $location.url();
        if (_.startsWith(bootstrapRedirect, '/login') || bootstrapRedirect === '') {
          bootstrapRedirect = null;
        }
      }
      $state.go('login', {
        username: $location.search().username,
        login: $location.search().login,
        externalToken: $location.search().externalToken
      });
    }
  }
  function bootstrapApplication(skipRedirection) {
    coreMediator.bootstrapApplication().then(function () {
      $scope.appIsReady = true;
      var tabList = [];
      if (!skipRedirection) {
        if (bootstrapRedirect) {
          $location.url(bootstrapRedirect);
          bootstrapRedirect = null;
        } else {
          adminFunctionHeaderButtonsMediator.getAvailableAdminFunctions().then(function (actions) {
            _.each(actions, function (value, key) {
              var item = {};
              item.name = key;
              item.subTabs = actions[key];
              tabList.push(item);
            });
            if (tabList.length > 0) {
              var tab = tabList[0];
              var subTabs = tab.subTabs;
              var stateMap = adminFunctionHeaderButtonsModel.getStateMappings(tab.name, subTabs[0]);
              $state.go(stateMap.state, stateMap.params);
            } else {
              $state.go('configuration.defaultHomePage');
            }
          });
        }
      }
    });
  }
  $scope.$on(coreConstant.event.BOOT_APPLICATION, function () {
    bootstrapApplication();
  });
  $scope.$on(coreConstant.event.INVALID_SESSION, function () {
    // Remove the login details if there was an invalid session error, as this may indicate the token has
    // expired.
    coreMediator.removeLoginToken();
    coreMediator.removeClientId();
    refreshLoginTokenUtil.stop();
    goToLoginPage();
  });
  $scope.$on(coreConstant.event.SHOW_FADING_NOTIFICATION, function (event, notification) {
    timeoutList.push($timeout(function () {
      fadingNotificationScope = $rootScope.$new(true);
      fadingNotificationScope.notification = notification;
      notificationPopupUtil.displayNotificationPopup(fadingNotificationScope);
    }, 0));
  });
  $scope.$on(coreConstant.event.SHOW_FADING_NOTIFICATION_LOADING_BAR, function (event, notification) {
    notificationLoadingBarScope = $rootScope.$new(true);
    notificationLoadingBarScope.notification = notification;
    notificationLoadingBarScope.isLoadingBar = true;
    notificationLoadingBarPromise = notificationPopupUtil.displayNotificationPopup(notificationLoadingBarScope);
  });
  $scope.$on(coreConstant.event.CONCLUDE_FADING_NOTIFICATION_LOADING_BAR, function (event, notification) {
    if (!_.isNil(notificationLoadingBarScope)) {
      notificationLoadingBarScope.notification = notification;
      notificationLoadingBarScope.isLoadingBar = false;
    }
  });
  $scope.$on(coreConstant.event.HIDE_FADING_NOTIFICATION_LOADING_BAR, function (event, isHard) {
    if (!_.isNil(notificationLoadingBarPromise)) {
      notificationLoadingBarPromise.then(function (notification) {
        notification.kill(isHard);
      });
      notificationLoadingBarPromise = null;
    }
  });
  $scope.$on(coreConstant.event.START_UI_PERFORMANCE_LOG, function (event, logAction, message) {
    uiPerformanceLogger.startLog(logAction, message);
  });
  $scope.$on(coreConstant.event.END_UI_PERFORMANCE_LOG, function (event, logAction, status, newMessage) {
    uiPerformanceLogger.endLog(logAction, status, newMessage);
  });
  $scope.$on(coreConstant.event.END_UI_PERFORMANCE_LOG_WITHOUT_LOGGING, function (event, logAction) {
    uiPerformanceLogger.endLogWithoutLogging(logAction);
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
  localization.getTranslations().then(function () {
    authenticationUtil.attemptAutoAuthentication().then(bootstrapApplication, goToLoginPage);
  });
};
ApplicationController.$inject = ["$rootScope", "$scope", "$state", "$location", "$timeout", "coreConstant", "localization", "authorizationConstants", "coreMediator", "notificationPopupUtil", "authenticationUtil", "refreshLoginTokenUtil", "uiPerformanceLogger", "adminFunctionHeaderButtonsMediator", "adminFunctionHeaderButtonsModel"];
angular.module('ums').controller('applicationController', ApplicationController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 1839:
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1840:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(1841);
var locale = __webpack_require__(74);

/*@ngInject*/
var UIBusinessCardDirective = function UIBusinessCardDirective($window, $document, $rootScope, $timeout, $state, coreMediator, coreConstant, authorizationConstants, currentUserModel, organizationType) {
  var linkFunction = function linkFunction($scope, $elm, $attrs) {
    $scope.i18n = locale;
    $scope.isBusinessCardClicked = false;
    $scope.isCardOpenTemporary = true;
    $scope.mayCloseCard = true;
    $scope.isCardHasMouseFocus = false;
    $scope.LEFT_ARROW = 1;
    $scope.RIGHT_ARROW = 2;
    $scope.TOP_ARROW = 3;
    $scope.BOTTOM_ARROW = 4;
    $scope.RIGHT_BOTTOM_ARROW = 5;
    $scope.xPos = -9999;
    $scope.yPos = -9999;
    $scope.cardWidth = 400;
    $scope.showSendEmailLink = true;
    $scope.timeoutList = [];
    $scope.onCardClick = function () {
      $scope.mayCloseCard = false;
      if ($scope.showBusinessCard) {
        $scope.isBusinessCardClicked = true;
        $scope.isCardOpenTemporary = false;
        $rootScope.isBusinessCardFreezed = true;
      }
    };
    $scope.onCloseButtonClicked = function () {
      cleanData();
    };
    $scope.onMouseEnter = function () {
      $scope.isCardHasMouseFocus = true;
    };
    $scope.onMouseLeave = function () {
      $scope.isCardHasMouseFocus = false;
      $scope.timeoutList.push($timeout(function () {
        if (!$scope.isBusinessCardClicked && $scope.isCardOpenTemporary && $scope.showBusinessCard) {
          $scope.showBusinessCard = false;
        }
      }, 1000));
    };
    $scope.$on(coreConstant.event.HIDE_BUSINESS_CARD, function () {
      if ($scope.isCardOpenTemporary && !$scope.isCardHasMouseFocus) {
        cleanData();
      }
    });
    $scope.$on(coreConstant.event.SHOW_ORGANIZATION_CARD, function (arg1, event, organizationId) {
      var xPos = event.pageX - event.offsetX;
      var yPos = event.pageY - event.offsetY;
      $scope.isUserCard = false;
      coreMediator.loadOrganizationById(organizationId).then(function (organizationSummary) {
        organizationSummary.organizationType = organizationSummary.organizationType === organizationType.AGENCY ? 'AGENCY' : 'CARRIER';
        formatAddress(organizationSummary);
        showBusinessCardContinue(event, organizationSummary, xPos, yPos, true);
      });
    });
    function formatAddress(organizationSummary) {
      var city = organizationSummary.city,
        state = organizationSummary.state,
        postalCode = organizationSummary.postalCode,
        values = [];
      if (!_.isNil(city)) {
        values.push(city);
      }
      if (!_.isNil(state)) {
        values.push(state);
      }
      if (!_.isNil(postalCode)) {
        values.push(postalCode);
      }
      if (!_.isEmpty(values)) {
        organizationSummary.addressLine3 = _.join(values, ', ');
      }
    }
    $scope.$on(coreConstant.event.SHOW_USER_BUSINESS_CARD, function (arg1, event, usersummary, userid, isGroup, submissionId, hasBusinessCard) {
      var xPos = event.pageX - event.offsetX;
      var yPos = event.pageY - event.offsetY;
      $scope.isUserCard = true;
      if (isGroup) {
        return;
      }
      if (!_.isNil(usersummary)) {
        showBusinessCardContinue(event, JSON.parse(usersummary), xPos, yPos, hasBusinessCard);
      } else {
        if (_.isEmpty(userid) /*system user*/) {
          coreMediator.loadUserById(userid).then(function (userProfile) {
            showBusinessCardContinue(event, userProfile, xPos, yPos, hasBusinessCard);
          });
        }
      }
      $scope.isGroup = isGroup;
      $scope.submissionId = submissionId;
    });
    $scope.$on('$destroy', function () {
      $document.off('click', handleDocumentClick);
      _.each($scope.timeoutList, function (item) {
        if (item) {
          $timeout.cancel(item);
        }
      });
    });
    function showBusinessCardContinue(event, dataObject, xPos, yPos, hasBusinessCard) {
      $scope.showBusinessCard = true;
      $scope.xPos = xPos;
      $scope.yPos = yPos;
      if (!_.isNil($(event.target).closest('.userBusinessCard')) && hasBusinessCard) {
        var targetElem = $(event.target).closest('.userBusinessCard'),
          rect;
        if (_.isNil(targetElem[0])) {
          targetElem = $(event.target).closest('.organizationCard');
        }
        rect = targetElem[0].getBoundingClientRect();
        if ($window.innerWidth > 768) {
          if (isBottomDirection()) {
            $scope.xPos = rect.left + 2;
            $scope.yPos -= rect.height + 10;
            setBottomArrow();
          } else {
            $scope.xPos = rect.left + rect.width - 20;
            $scope.yPos = rect.top + rect.height / 2;
            setLeftArrow();
          }
        }
      } else {
        if (isBottomDirection()) {
          if (isRightDirection()) {
            setRightBottomArrow();
          } else {
            setBottomArrow();
          }
        } else if (isRightDirection()) {
          setRightArrow();
        } else if (isLeftDirection()) {
          if (canDisplayWithBottomArrow()) {
            setBottomArrow();
          } else {
            setLeftArrow();
          }
        } else {
          setTopArrow();
        }
      }
      $scope.locationStyle = {
        'left': $scope.xPos,
        'top': $scope.yPos
      };
      $scope.viewModel = dataObject;
      $scope.mayCloseCard = false;
      showProfileImage();
    }
    function setBottomArrow() {
      // business card with bottom arrow
      $scope.direction = $scope.BOTTOM_ARROW;
      $scope.xPos -= 45;
      $scope.yPos -= 150;
    }
    function setLeftArrow() {
      // business card with left arrow
      $scope.direction = $scope.LEFT_ARROW;
      $scope.xPos += 35;
      $scope.yPos -= 30;
    }
    function setRightArrow() {
      // business card with right arrow
      $scope.direction = $scope.RIGHT_ARROW;
      $scope.xPos -= $scope.cardWidth + 15;
      $scope.yPos -= 25;
    }
    function setTopArrow() {
      // business card with top arrow
      $scope.direction = $scope.TOP_ARROW;
      $scope.xPos -= 55;
      $scope.yPos += 40;
    }
    function setRightBottomArrow() {
      // business card with right-bottom arrow
      $scope.direction = $scope.RIGHT_BOTTOM_ARROW;
      $scope.xPos -= $scope.cardWidth + 15;
      $scope.yPos -= 75;
    }
    function isRightDirection() {
      return $scope.xPos > $scope.cardWidth + 90;
    }
    function isLeftDirection() {
      return $window.innerWidth > 768 && !isRightDirection();
    }
    function isTopDirection() {
      return $window.innerWidth > 768 && $window.innerWidth < 970;
    }
    function isBottomDirection() {
      return $window.innerHeight < $scope.yPos + 200;
    }
    function canDisplayWithBottomArrow() {
      return $scope.yPos > 200;
    }
    function showProfileImage() {
      var sendMailUserId = $scope.viewModel.id;
      $scope.showSendEmailLink = false;
      if ($scope.isUserCard) {
        coreMediator.loadProfileImage(sendMailUserId).then(function (underwriterImage) {
          $scope.hasAvatar = !!underwriterImage;
          $scope.underwriterImage = 'data:image/png;base64,' + underwriterImage;
        });
        $scope.showSendEmailLink = false;
      }
    }
    function cleanData() {
      $scope.showBusinessCard = false;
      $rootScope.isBusinessCardFreezed = false;
      $scope.isCardHasMouseFocus = false;
      $scope.isBusinessCardClicked = false;
      $scope.isCardOpenTemporary = true;
      $scope.viewModel = {};
      $scope.hasAvatar = false;
      $scope.underwriterImage = null;
    }
    function handleDocumentClick() {
      $scope.$apply(function () {
        if ($scope.mayCloseCard) {
          cleanData();
        }
        $scope.mayCloseCard = true;
      });
    }
    $document.on('click', handleDocumentClick);
  };
  return {
    restrict: 'AE',
    link: linkFunction,
    templateUrl: '/common/businessCard/uiBusinessCard.tpl.html'
  };
};
UIBusinessCardDirective.$inject = ["$window", "$document", "$rootScope", "$timeout", "$state", "coreMediator", "coreConstant", "authorizationConstants", "currentUserModel", "organizationType"];
angular.module('umCore').directive('uiBusinessCard', UIBusinessCardDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),

/***/ 1841:
/***/ (function(module, exports, __webpack_require__) {

var path = '/common/businessCard/uiBusinessCard.tpl.html';
var html = "<div class=\"businessCardCallOut\"\n     ng-show=\"showBusinessCard\"\n     ng-mouseenter=\"onMouseEnter()\"\n     ng-mouseleave=\"onMouseLeave()\"\n     ng-click=\"onCardClick()\"\n     ng-style=\"locationStyle\" \n     ng-class=\"{'businessCardLeftArrow' : direction === LEFT_ARROW,\n                'businessCardRightArrow' : direction === RIGHT_ARROW,\n                'businessCardTopArrow' : direction === TOP_ARROW,\n                'businessCardBottomArrow': direction === BOTTOM_ARROW,\n                'businessCardRightBttomArrow': direction === RIGHT_BOTTOM_ARROW\n            }\">\n    \n    <span class=\"closeButton glyphicon glyphicon-remove\" ng-click=\"onCloseButtonClicked()\"></span>\n\n    <div class=\"cardRow\" ng-if=\"isUserCard\">\n        <div class=\"cardCol\">\n            <img class=\"userImage\"\n                 ng-src=\"{{underwriterImage}}\"\n                 ng-if=\"hasAvatar && !isGroup\">\n            <img ng-src=\"" + __webpack_require__(1842) + "\"\n                 ng-if=\"!hasAvatar && !isGroup\">\n            <img ng-src=\"" + __webpack_require__(1843) + "\"\n                 ng-if=\"isGroup\">\n        </div>\n        \n        <div class=\"cardCol\">\n            <div class=\"item\">\n                <label class=\"name\">{{viewModel.name}}\n                    <span ng-if=\"viewModel.availableToChat\"\n                          class=\"glyphicon glyphicon-online\"></span>\n                    <span ng-if=\"!viewModel.availableToChat\"\n                          class=\"glyphicon glyphicon-offline\"></span></label>\n            </div>\n            <div class=\"item\" ng-if=\"viewModel.phoneNumber\">\n                <span class=\"glyphicon glyphicon-earphone icon\"></span>{{::viewModel.phoneNumber}}\n                <label class=\"phoneLabel\">{{::i18n.businessCard.work}}</label>\n            </div>\n            <div class=\"item\" ng-if=\"viewModel.cellPhoneNumber\">\n                <span class=\"glyphicon glyphicon-earphone icon\"></span>{{::viewModel.cellPhoneNumber}}\n                <label class=\"phoneLabel\">{{::i18n.businessCard.mobile}}</label>\n            </div>\n            <div class=\"item\" ng-if=\"viewModel.faxNumber\">\n                <span class=\"glyphicon glyphicon-print icon\"></span>{{::viewModel.faxNumber}}\n            </div>\n            <div class=\"item\" ng-if=\"viewModel.emailAddress\">\n                <span class=\"glyphicon glyphicon-envelope icon\"></span>\n                <a href=\"mailto:{{viewModel.emailAddress}}\" target=\"_top\" >{{::viewModel.emailAddress}}</a>\n            </div>\n           \n        </div>\n    </div>\n\n    <div class=\"cardRow\" ng-if=\"!isUserCard\">\n        <div class=\"cardCol\">\n            <div class=\"fa fa-building-o orgImage\"></div>\n        </div>\n\n        <div class=\"cardCol orgCol\">\n            <div class=\"orgItem\">\n                <label class=\"header\">{{viewModel.organizationType}}</label>\n            </div>\n            <div class=\"orgItem\">\n                <label class=\"name organizationName\"\n                       uib-tooltip=\"{{ viewModel.name }}\"\n                       tooltip-popup-delay=\"500\">{{viewModel.name}}</label>\n            </div>\n            <div class=\"orgItem\" ng-if=\"viewModel.code\">\n                <label class=\"leading code\">{{::i18n.businessCard.code}}</label>\n                <label class=\"data codeLabel\"\n                       uib-tooltip=\"{{ viewModel.code }}\"\n                       tooltip-popup-delay=\"500\">{{viewModel.code}}</label>\n            </div>\n            <div class=\"orgItem\" ng-if=\"viewModel.addressLine1\">\n                <label class=\"leading address\">{{::i18n.businessCard.address}}</label>\n                <label class=\"data addressLabel addressLabel1\"\n                       uib-tooltip=\"{{ viewModel.addressLine1 }}\"\n                       tooltip-popup-delay=\"500\">{{viewModel.addressLine1}}</label>\n            </div>\n            <div class=\"orgItem\" ng-if=\"viewModel.addressLine2\">\n                <label class=\"leading address\"></label>\n                <label class=\"data addressLabel addressLabel2\"\n                       uib-tooltip=\"{{ viewModel.addressLine2 }}\"\n                       tooltip-popup-delay=\"500\">{{viewModel.addressLine2}}</label>\n            </div>\n            <div class=\"orgItem\" ng-if=\"viewModel.addressLine3\">\n                <label class=\"leading address\"></label>\n                <label class=\"data addressLabel addressLabel3\"\n                       uib-tooltip=\"{{ viewModel.addressLine3 }}\"\n                       tooltip-popup-delay=\"500\">{{viewModel.addressLine3}}</label>\n            </div>\n            <div class=\"orgItem\" ng-if=\"viewModel.phoneNumber\">\n                <span class=\"glyphicon glyphicon-earphone phoneIcon leading\"></span>\n                <label class=\"data phone\"\n                       uib-tooltip=\"{{ viewModel.phoneNumber }}\"\n                       tooltip-popup-delay=\"500\">{{viewModel.phoneNumber}}</label>\n            </div>\n\n            <div class=\"orgItem parentHeader\" ng-if=\"viewModel.parentName\">\n                <label class=\"header\">{{::i18n.businessCard.parent}}</label>\n            </div>\n            <div class=\"orgItem parentSection\" ng-if=\"viewModel.parentName\">\n                <span class=\"parentName\"\n                      uib-tooltip=\"{{ viewModel.parentName }}\"\n                      tooltip-popup-delay=\"500\">{{viewModel.parentName}}</span>\n                <span class=\"parentCode\"\n                      uib-tooltip=\"{{ viewModel.parentCode }}\"\n                      tooltip-popup-delay=\"500\">{{viewModel.parentCode}}</span>\n            </div>\n\n        </div>\n    </div>\n\n    <iframe src=\"about:blank\" class=\"ieMaskFrame\" ui-browser-detection></iframe>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 1842:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fac3a19bbed393ffc20c8403d845f315.png";

/***/ }),

/***/ 1843:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0ffa6ddcadfedaffccfce459b67b9104.png";

/***/ }),

/***/ 1844:
/***/ (function(module) {

module.exports = JSON.parse("{\"appHeader\":{\"userProfileDropdown\":{\"menuItems\":{\"profile\":\"Profile\",\"changePassword\":\"Change Password\",\"logout\":\"Logout\"}}}}");

/***/ }),

/***/ 1845:
/***/ (function(module, exports) {

var path = '/common/header/appHeader.tpl.html';
var html = "<ui-header show-chat-icon=\"false\"\n           logo-url=\"umStudioLogoPath\"\n           menu-items=\"viewModel.menuItems\">\n\n    <ui-header-left-side></ui-header-left-side>\n\n    <ui-header-right-side>\n        <ui-help></ui-help>\n        <ui-manage-operation ng-if=\"viewModel.hasViewDetailHistoryPermission || viewModel.hasManageBackupRestorePermission || viewModel.hasManageImportDataPermission || viewModel.hasGenerateDataDictionaryPermission\"\n                             has-view-detail-history-permission=\"viewModel.hasViewDetailHistoryPermission\"\n                             has-manage-backup-restore-permission=\"viewModel.hasManageBackupRestorePermission\"\n                             has-manage-import-data-permission=\"viewModel.hasManageImportDataPermission\"\n                             has-generate-data-dictionary-permission=\"viewModel.hasGenerateDataDictionaryPermission\">\n        </ui-manage-operation>\n\n    </ui-header-right-side>\n</ui-header>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 1846:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var umStudioLogo = __webpack_require__(1847);

/*@ngInject*/
var AppHeaderController = function AppHeaderController($scope, localization, coreMediator, modalUtil, authenticationMediator, currentUserModel, authorizationConstants, userLoginType) {
  $scope.umStudioLogoPath = umStudioLogo;
  $scope.viewModel = {
    hasViewDetailHistoryPermission: false,
    hasManageBackupRestorePermission: false,
    hasManageImportDataPermission: false,
    hasGenerateDataDictionaryPermission: false
  };
  $scope.viewModel.hasViewDetailHistoryPermission = currentUserModel.hasAuthorization(authorizationConstants.VIEW_CONFIG_DETAILED_HISTORY);
  $scope.viewModel.hasManageBackupRestorePermission = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_BACKUP_RESTORE);
  $scope.viewModel.hasManageImportDataPermission = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_IMPORT_DATA);
  $scope.viewModel.hasGenerateDataDictionaryPermission = currentUserModel.hasAuthorization(authorizationConstants.AUTHORIZATION_GENERATE_DATA_DICTIONARY);
  function init() {
    localization.getTranslationByKey('appHeader').then(function (translations) {
      var profileMenuItem = {
          identifier: 'profile',
          enabled: true,
          iconClass: 'glyphicon-user',
          label: _.get(translations, 'userProfileDropdown.menuItems.profile'),
          action: showUserProfile
        },
        logoutMenuItem = {
          identifier: 'logout',
          enabled: true,
          iconClass: 'glyphicon-log-out',
          label: _.get(translations, 'userProfileDropdown.menuItems.logout'),
          action: logout
        };
      $scope.viewModel.menuItems = [profileMenuItem, logoutMenuItem];
      coreMediator.loadDefaultPreferences().then(function (preferences) {
        var changePasswordMenuItem;
        if (preferences['system.disablePasswordAndProfileManagementConfigurator'].value === 'false' && currentUserModel.getCurrentUser().loginType !== userLoginType.SINGLE_SIGN_ON) {
          changePasswordMenuItem = {
            identifier: 'changePassword',
            enabled: true,
            iconClass: 'glyphicon-lock',
            label: _.get(translations, 'userProfileDropdown.menuItems.changePassword'),
            action: showChangePassword
          };
          $scope.viewModel.menuItems.splice(1, 0, changePasswordMenuItem);
          $scope.viewModel.menuItems.join();
        }
      }.bind(this));
    });
  }
  function showUserProfile() {
    modalUtil.showUserProfile();
  }
  function showChangePassword() {
    authenticationMediator.showChangePasswordPopup();
  }
  function logout() {
    coreMediator.logout();
  }
  init();
};
AppHeaderController.$inject = ["$scope", "localization", "coreMediator", "modalUtil", "authenticationMediator", "currentUserModel", "authorizationConstants", "userLoginType"];
angular.module('ums').controller('appHeaderController', AppHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 1847:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bf0d14d6822521c1132a3884f9a2e718.svg";

/***/ }),

/***/ 1848:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75);
__webpack_require__(108);
__webpack_require__(65);
__webpack_require__(66);
__webpack_require__(78);
__webpack_require__(1849);
__webpack_require__(1850);
__webpack_require__(2267);
angular.module('ums.configuration', ['ux', 'summernote', 'ui.ace']).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('configuration', {
    url: '/config',
    abstract: true,
    views: {
      'header': {
        templateUrl: '/common/header/appHeader.tpl.html',
        controller: 'appHeaderController'
      },
      'content': {
        templateUrl: '/configuration/configuration.tpl.html'
      }
    }
  }).state('configuration.rulesBrowser', {
    url: '/rule/browser',
    views: {
      'view': {
        templateUrl: '/configuration/rulesBrowser/rulesBrowser.tpl.html',
        controller: 'rulesBrowserController'
      }
    }
  }).state('configuration.ruleBuilder', {
    url: '/rule/:ruleId',
    views: {
      'view': {
        templateUrl: '/configuration/ruleBuilder/ruleBuilder.tpl.html',
        controller: 'ruleBuilderController'
      }
    }
  }).state('configuration.formTemplateBrowser', {
    url: '/template/browser',
    views: {
      'view': {
        templateUrl: '/configuration/formTemplateBrowser/formTemplateBrowser.tpl.html',
        controller: 'formTemplateBrowserController'
      }
    }
  }).state('configuration.dataSetBrowser', {
    url: '/dataSet/browser',
    views: {
      'view': {
        templateUrl: '/configuration/dataSetBrowser/dataSetBrowser.tpl.html',
        controller: 'dataSetBrowserController'
      }
    }
  }).state('configuration.dataSetEditor', {
    url: '/dataSet/:dataSetName/:type',
    views: {
      'view': {
        templateUrl: '/configuration/dataSetEditor/dataSetEditor.tpl.html',
        controller: 'dataSetEditorController'
      }
    }
  }).state('configuration.dataSetEditor.dataItems', {
    url: '/dataItems',
    views: {
      'tabView': {
        templateUrl: '/configuration/dataSetEditor/content/dataItems/dataItems.tpl.html',
        controller: 'dataItemsController'
      }
    }
  }).state('configuration.dataSetEditor.dynamicCriteria', {
    url: '/dynamicCriteria',
    views: {
      'tabView': {
        templateUrl: '/configuration/dataSetEditor/content/dynamicCriteria/dynamicCriteria.tpl.html',
        controller: 'dynamicCriteriaController'
      }
    }
  }).state('configuration.dataSetEditor.repeatingForm', {
    url: '/repeatingForm',
    views: {
      'tabView': {
        templateUrl: '/configuration/dataSetEditor/content/repeatingForm/repeatingForm.tpl.html',
        controller: 'repeatingFormController'
      }
    }
  }).state('configuration.formEditor', {
    url: '/template/:uiFormTemplateId',
    abstract: true,
    views: {
      'view': {
        templateUrl: '/configuration/formEditor/formEditor.tpl.html',
        controller: 'formEditorController'
      }
    }
  }).state('configuration.formEditor.form', {
    url: '/builder',
    views: {
      'tabView': {
        templateUrl: '/configuration/formEditor/content/form/formBuilder.tpl.html',
        controller: 'formBuilderController'
      }
    }
  }).state('configuration.formEditor.rules', {
    url: '/rules/:ruleName',
    params: {
      ruleName: {
        value: null,
        squash: true
      }
    },
    views: {
      'tabView': {
        templateUrl: '/configuration/formEditor/content/rule/formRules.tpl.html',
        controller: 'formRulesController'
      }
    }
  }).state('configuration.formEditor.preview', {
    url: '/preview',
    views: {
      'tabView': {
        templateUrl: '/configuration/formEditor/content/preview/formPreview.tpl.html'
      }
    }
  }).state('configuration.productTemplateBrowser', {
    url: '/productTemplate/browser',
    views: {
      'view': {
        templateUrl: '/configuration/productTemplateBrowser/productTemplateBrowser.tpl.html',
        controller: 'productTemplateBrowserController'
      }
    }
  }).state('configuration.productTemplateEditor', {
    url: '/productTemplate/:productTemplateName/:productTemplateId',
    params: {
      productTemplateName: {
        value: null,
        squash: true
      },
      productTemplateId: {
        value: null,
        squash: true
      }
    },
    views: {
      'view': {
        templateUrl: '/configuration/productTemplateEditor/productTemplateEditor.tpl.html',
        controller: 'productTemplateEditorController'
      }
    }
  }).state('configuration.permissionsEditor', {
    url: '/permissions/:userType',
    views: {
      'view': {
        templateUrl: '/configuration/permissionsEditor/permissionsEditor.tpl.html',
        controller: 'permissionsEditorController'
      }
    }
  }).state('configuration.organizationBrowser', {
    url: '/organization/browser/:organizationType',
    views: {
      'view': {
        templateUrl: '/configuration/organizationBrowser/organizationBrowser.tpl.html',
        controller: 'organizationBrowserController'
      }
    }
  }).state('configuration.manageOrganization', {
    url: '/organization/manage/:organizationType/:organizationId',
    params: {
      organizationId: {
        value: null,
        squash: true
      },
      organizationType: {
        value: null,
        squash: true
      }
    },
    views: {
      'view': {
        templateUrl: '/configuration/organizationBrowser/manageOrganization/manageOrganization.tpl.html',
        controller: 'manageOrganizationController'
      }
    }
  }).state('configuration.manageOrganization.form', {
    url: '/form/:formId',
    params: {
      formId: {
        value: null,
        squash: true
      }
    },
    views: {
      'mainContent': {
        templateUrl: '/configuration/organizationBrowser/manageOrganization/formViewer/manageOrganizationFormViewer.tpl.html',
        controller: 'manageOrganizationFormViewerController'
      }
    }
  }).state('configuration.manageOrganization.formSummaryGridDetail', {
    url: '/form/:formId/detail/:ownerUriId/:formSummaryInstanceId',
    views: {
      'mainContent': {
        templateUrl: '/formViewer/component/formSummary/detail/formSummaryGridDetail.tpl.html',
        controller: 'formSummaryGridDetailController'
      }
    },
    resolve: {
      effectiveDate: function effectiveDate() {
        return {
          get: function get() {
            return null;
          }
        };
      },
      currencyCode: function currencyCode() {
        return {
          get: function get() {
            return null;
          }
        };
      },
      printable: function printable() {
        return {
          get: function get() {
            return false;
          }
        };
      }
    }
  }).state('configuration.emailBrowser', {
    url: '/notification/email/browser',
    views: {
      'view': {
        templateUrl: '/configuration/emailNotification/emailNotificationBrowser.tpl.html',
        controller: 'emailNotificationBrowserController'
      }
    }
  }).state('configuration.manageEmail', {
    url: '/notification/email/manage/:templateId',
    params: {
      templateId: {
        value: null,
        squash: true
      }
    },
    views: {
      'view': {
        templateUrl: '/configuration/emailNotification/manageEmailNotification/manageEmailNotification.tpl.html',
        controller: 'manageEmailNotificationController'
      }
    }
  }).state('configuration.popupBrowser', {
    url: '/notification/popup/browser',
    views: {
      'view': {
        templateUrl: '/configuration/popupNotification/popupNotificationBrowser.tpl.html',
        controller: 'popupNotificationBrowserController'
      }
    }
  }).state('configuration.managePopup', {
    url: '/notification/popup/manage/:templateId',
    params: {
      templateId: {
        value: null,
        squash: true
      }
    },
    views: {
      'view': {
        templateUrl: '/configuration/popupNotification/managePopupNotification/managePopupNotification.tpl.html',
        controller: 'managePopupNotificationController'
      }
    }
  }).state('configuration.sectionTemplateBrowser', {
    url: '/sectionTemplate/browser',
    views: {
      'view': {
        templateUrl: '/configuration/sectionTemplateBrowser/sectionTemplateBrowser.tpl.html',
        controller: 'sectionTemplateBrowserController'
      }
    }
  }).state('configuration.sectionTemplateEditor', {
    url: '/sectionTemplate/:sectionTemplateId',
    views: {
      'view': {
        templateUrl: '/configuration/sectionTemplateEditor/sectionTemplateEditor.tpl.html',
        controller: 'sectionTemplateEditorController'
      }
    }
  }).state('configuration.sectionTemplateEditor.properties', {
    url: '/properties',
    views: {
      'tabView': {
        templateUrl: '/configuration/sectionTemplateEditor/content/properties/sectionTemplateProperties.tpl.html',
        controller: 'sectionTemplatePropertiesController'
      }
    }
  }).state('configuration.sectionTemplateEditor.rule', {
    url: '/rule',
    views: {
      'tabView': {
        templateUrl: '/configuration/sectionTemplateEditor/content/rule/sectionTemplateRule.tpl.html',
        controller: 'sectionTemplateRuleController'
      }
    }
  }).state('configuration.systemPreferencesManager', {
    url: '/generalPreferences/manager',
    views: {
      'view': {
        templateUrl: '/configuration/systemPreferencesManager/systemPreferencesManager.tpl.html',
        controller: 'systemPreferencesManagerController'
      }
    }
  }).state('configuration.scoringRulesBrowser', {
    url: '/scoringRules/browser',
    views: {
      'view': {
        templateUrl: '/configuration/scoringRules/scoringRulesBrowser.tpl.html',
        controller: 'scoringRulesBrowserController'
      }
    }
  }).state('configuration.manageScoringRules', {
    url: '/manageScoringRules/:scoringRuleId/',
    views: {
      'view': {
        templateUrl: '/configuration/scoringRules/manageScoringRules/manageScoringRules.tpl.html',
        controller: 'manageScoringRulesController'
      }
    }
  }).state('configuration.rateStatus', {
    url: '/rateStatus/manager',
    views: {
      'view': {
        templateUrl: '/configuration/rateStatus/rateStatus.tpl.html',
        controller: 'rateStatusController'
      }
    }
  }).state('configuration.filesAndIconsManager', {
    url: '/filesAndIcons/manager',
    views: {
      view: {
        templateUrl: '/configuration/filesAndIconsManager/filesAndIconsManager.tpl.html',
        controller: 'filesAndIconsManagerController'
      }
    }
  }).state('configuration.defaultHomePage', {
    url: '/default/defaultHomePage',
    views: {
      'view': {
        templateUrl: '/configuration/defaultHomePage.tpl.html'
      }
    }
  });
}]).value('configurationConstant', {
  event: {
    OPTION_GROUP_INPUT_VALUE_CHANGED: 'configurationConstant.OptionGroupInputValueChanged',
    FORM_COMPONENT_SELECTED: 'configurationConstant.FormComponentSelected',
    FIELD_COMPONENT_SELECTED: 'configurationConstant.FieldComponentSelected',
    SELECTOR_WIDGET_UPDATED: 'selectorWidgetUpdated',
    DATA_SET_EDITOR_MODEL_UPDATED: 'configurationConstant.DataSetEditorModelUpdated',
    DATA_SET_ITEM_DRAG_DROP: 'configurationConstant.DataSetItemDragDrop',
    DATA_SET_ITEMS_GROUP_DRAG_DROP: 'configurationConstant.DataSetItemsGroupDragDrop',
    DATA_SET_ITEM_DRAG_DROP_FROM_UNSELECTED_ROW: 'configurationConstant.DataSetItemDragDropFromUnselectedRow',
    DATA_SET_ITEMS_GROUP_DRAG_DROP_FROM_UNSELECTED_GROUP: 'configurationConstant.DataSetItemsGroupDragDropFromUnselectedRow',
    DATA_SET_ITEM_GROUP_SET_SHIFT_SELECT_PIVOT: 'configurationConstant.DataSetItemGroupSetShiftSelectPivot',
    DATA_SET_ITEMS_GROUP_UPDATED: 'configurationConstant.DataSetItemsGroupUpdated',
    DATA_SET_SOURCE_FIELD_DEPENDENCY_UPDATED: 'configurationConstant.DataSetSourceFieldDependencyUpdated',
    DATA_SET_DYNAMIC_CRITERIA_UPDATED: 'configurationConstant.DataSetDynamicCriteriaUpdated',
    DATA_SET_DEPENDENCIES_UPDATED: 'configurationConstant.DataSetDependenciesUpdated',
    RULE_MODEL_UPDATED: 'configurationConstant.RuleModelUpdated',
    PRODUCT_TEMPLATE_UPDATED: 'configurationConstant.ProductTemplateUpdated',
    EMAIL_TEMPLATE_UPDATED: 'configurationConstant.EmailTemplateUpdated',
    PERMISSIONS_UPDATED: 'configurationConstant.PermissionsUpdated',
    SECTION_TEMPLATE_EDITOR_MODEL_UPDATED: 'configurationConstant.SectionTemplateEditorModelUpdated',
    SYSTEM_PREFERENCES_MANAGER_MODEL_UPDATED: 'configurationConstant.SystemPreferencesManagerModelUpdated',
    SCORING_RULE_UPDATED: 'configurationConstant.ScoringRuleUpdated',
    STATE_RATE_DELETED: 'configurationConstant.StateRateDeleted',
    STATE_RATE_COPY: 'configurationConstant.StateRateCopy',
    STATE_RATE_ROW_CLICKED: 'configurationConstant.StateRateRowClicked',
    FILES_AND_ICONS_MANAGER_MODEL_UPDATED: 'configurationConstant.FilesAndIconsManagerModelUpdated'
  },
  dataSet: {
    INSERT_BEFORE: 'configurationConstant.DataSetInsertBefore',
    INSERT_AFTER: 'configurationConstant.DataSetInsertAfter',
    MAX_SOURCE_FIELD_DEPENDENCIES: 3
  }
}).value('emailEditorConstant', {
  event: {
    EMAIL_UPDATE_COMPLETE: 'emailEditorModule.EmailUpdateComplete',
    PEOPLE_LIST_LOADED: 'emailModule.PeopleListLoaded'
  }
}).run(function () {});
__webpack_require__(2268);
__webpack_require__(2269);
__webpack_require__(2270);
__webpack_require__(2271);
__webpack_require__(2272);
__webpack_require__(2273);
__webpack_require__(2274);
__webpack_require__(2275);
__webpack_require__(2276);
__webpack_require__(2277);
__webpack_require__(2283);
__webpack_require__(2287);
__webpack_require__(2288);
__webpack_require__(2289);
__webpack_require__(2290);
__webpack_require__(2291);
__webpack_require__(2297);
__webpack_require__(2298);
__webpack_require__(2299);
__webpack_require__(2300);
__webpack_require__(2305);
__webpack_require__(2309);
__webpack_require__(2310);
__webpack_require__(2311);
__webpack_require__(2312);
__webpack_require__(2313);
__webpack_require__(2314);
__webpack_require__(2315);
__webpack_require__(2316);
__webpack_require__(2317);
__webpack_require__(2318);
__webpack_require__(2323);
__webpack_require__(2331);
__webpack_require__(2332);
__webpack_require__(2333);
__webpack_require__(2334);
__webpack_require__(2335);
__webpack_require__(2336);
__webpack_require__(2458);
__webpack_require__(2459);
__webpack_require__(2466);
__webpack_require__(2470);
__webpack_require__(2471);
__webpack_require__(2472);
__webpack_require__(2473);
__webpack_require__(2474);
__webpack_require__(2475);
__webpack_require__(2476);
__webpack_require__(2477);
__webpack_require__(2478);
__webpack_require__(2479);
__webpack_require__(2480);
__webpack_require__(2481);
__webpack_require__(2482);
__webpack_require__(2483);
__webpack_require__(2484);
__webpack_require__(2508);
__webpack_require__(2509);
__webpack_require__(2510);
__webpack_require__(2511);
__webpack_require__(2515);
__webpack_require__(2538);
__webpack_require__(2547);
__webpack_require__(2552);
__webpack_require__(2561);
__webpack_require__(2573);
__webpack_require__(2574);
__webpack_require__(2577);
__webpack_require__(2578);
__webpack_require__(2586);
__webpack_require__(2593);
__webpack_require__(782);
__webpack_require__(2596);
__webpack_require__(2600);
__webpack_require__(2607);
__webpack_require__(2613);
__webpack_require__(784);
__webpack_require__(2620);
__webpack_require__(2625);
__webpack_require__(2645);
__webpack_require__(2655);
__webpack_require__(2658);
__webpack_require__(2667);
__webpack_require__(2668);
__webpack_require__(2669);
__webpack_require__(2670);
__webpack_require__(782);
module.exports = 'ums.configuration';

/***/ }),

/***/ 2268:
/***/ (function(module, exports) {

var path = '/configuration/configuration.tpl.html';
var html = "<div class=\"content configurationContainer\" ui-view=\"view\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2269:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ConfigurationMediator = function ConfigurationMediator(dataSetActionRepository, dataSetBrowserActionRepository, dataSetManagementUtil, dataSetRepository, dataSetType, fieldReferencesRepository, fieldRuleBuilderRepository, formReferencesRepository, formActionRepository, formTemplateBrowserActionRepository, formTemplateSetRepository, formRuleBuilderRepository, objectRepository, uiFormTemplateRepository, rulesBrowserActionRepository, ruleRepository, ruleActionRepository, productTemplateBrowserActionRepository, productTemplateRepository, productTemplateEditorRepository, organizationBrowserActionRepository, organizationRepository, permissionsRepository, backupRepository, restoreRepository, popupNotificationRepository, emailNotificationRepository, sectionTemplateBrowserActionRepository, sectionTemplateRepository, sectionTemplateEditorRepository, sectionTemplateActionRepository, systemPreferencesManagerActionRepository, systemPreferencesRepository, scoringRulesRepository, userGroupEditorRepository, rateStatusRepository, importClassCodesRepository, filesAndIconsManagerActionRepository, filesAndIconsManagerRepository, generateDataDictionaryRepository) {
  this.createFormTemplate = function (uiFormTemplate) {
    return uiFormTemplateRepository.createFormTemplate(uiFormTemplate);
  };
  this.updateFormTemplate = function (uiFormTemplate, uiFormTemplateId) {
    return uiFormTemplateRepository.updateFormTemplate(uiFormTemplate, uiFormTemplateId);
  };
  this.getUiFormTemplatesByFilterUri = function (filterUri, requestParams) {
    return uiFormTemplateRepository.getUiFormTemplatesByFilterUri(filterUri, requestParams);
  };
  this.getFormTemplateById = function (formTemplateId) {
    return uiFormTemplateRepository.getUiFormTemplateById(formTemplateId);
  };
  this.getUIFormTemplatesByMatchingName = function (matchingName) {
    return uiFormTemplateRepository.getUIFormTemplatesByMatchingName(matchingName);
  };
  this.getFieldOptions = function (formTemplateUniqueName, fieldName) {
    return uiFormTemplateRepository.getFieldOptions(formTemplateUniqueName, fieldName);
  };
  this.getObjectNames = function (matchingName) {
    return objectRepository.getObjectNames(matchingName);
  };
  this.getObjectPropertyValues = function (objectName) {
    return objectRepository.getObjectPropertyValues(objectName);
  };
  this.getFieldRulesByUIFormTemplateId = function (uiFormTemplateId) {
    return uiFormTemplateRepository.getFieldRulesByUIFormTemplateId(uiFormTemplateId);
  };
  this.getFormReferences = function (uiFormTemplateId) {
    return formReferencesRepository.getFormReferences(uiFormTemplateId);
  };
  this.getFieldReferences = function (fieldTemplateId) {
    return fieldReferencesRepository.getFieldReferences(fieldTemplateId);
  };
  this.getRepeatingFormTemplateUniqueNames = function () {
    return uiFormTemplateRepository.getRepeatingFormTemplateUniqueNames();
  };
  this.loadUiFormTemplateActions = function (uri) {
    return formActionRepository.loadActions(uri);
  };
  this.loadFormTemplateBrowserActions = function () {
    return formTemplateBrowserActionRepository.loadActions();
  };
  this.publishFormTemplates = function (formTemplateIds) {
    return formTemplateSetRepository.publishFormTemplates(formTemplateIds);
  };
  this.publishFormTemplatesByFilterUri = function (filterUri, excludedFormTemplateIds) {
    return formTemplateSetRepository.publishFormTemplatesByFilterUri(filterUri, excludedFormTemplateIds);
  };
  this.createTestFormTemplateSet = function () {
    return formTemplateSetRepository.createTestFormTemplateSet();
  };
  this.createFormTemplate = function (uiFormTemplate) {
    return uiFormTemplateRepository.createFormTemplate(uiFormTemplate);
  };
  this.updateFormTemplate = function (uiFormTemplate, id) {
    return uiFormTemplateRepository.updateFormTemplate(uiFormTemplate, id);
  };
  this.deleteUIFormTemplate = function (uiFormTemplateId) {
    return uiFormTemplateRepository.deleteUIFormTemplates([uiFormTemplateId]);
  };
  this.deleteUIFormTemplates = function (uiFormTemplateIds) {
    return uiFormTemplateRepository.deleteUIFormTemplates(uiFormTemplateIds);
  };
  this.markFormTemplateInProduction = function (uiFormTemplateId) {
    return uiFormTemplateRepository.markFormTemplatesInProduction([uiFormTemplateId]);
  };
  this.markFormTemplatesInProduction = function (uiFormTemplateIds) {
    return uiFormTemplateRepository.markFormTemplatesInProduction(uiFormTemplateIds);
  };
  this.markFormTemplatesInProductionByFilterUri = function (filterUri, excludedUiFormTemplateIds) {
    return uiFormTemplateRepository.markFormTemplatesInProductionByFilterUri(filterUri, excludedUiFormTemplateIds);
  };
  this.importFormTemplates = function (file) {
    return uiFormTemplateRepository.importFormTemplates(file);
  };
  this.exportFormTemplate = function (formTemplateId) {
    return uiFormTemplateRepository.exportFormTemplates([formTemplateId]);
  };
  this.exportFormTemplates = function (formTemplateIds) {
    return uiFormTemplateRepository.exportFormTemplates(formTemplateIds);
  };
  this.exportFormTemplatesByFilterUri = function (filterUri, excludedFormTemplateIds) {
    return uiFormTemplateRepository.exportFormTemplatesByFilterUri(filterUri, excludedFormTemplateIds);
  };
  this.reloadFormRules = function (validate) {
    return uiFormTemplateRepository.reloadFormRules(validate);
  };
  this.reloadFieldRules = function (validate) {
    return uiFormTemplateRepository.reloadFieldRules(validate);
  };
  this.createDataSet = function (dataSet) {
    return dataSetRepository.createDataSet(dataSet);
  };
  this.deleteDataSet = function (name) {
    return dataSetRepository.deleteDataSet(name);
  };
  this.getDataSetsByFilterUri = function (filterUri, requestParams) {
    return dataSetRepository.getDataSetsByFilterUri(filterUri, requestParams);
  };
  this.getGeneratorDefinitions = function (type) {
    return dataSetRepository.getGeneratorDefinitions(type);
  };
  this.updateDataSet = function (dataSet, name) {
    // given a valid dataset, the last row of each group would have an "empty" data item
    // The empty data items need to be filtered out before saving, otherwise server will return a validation error
    // Same applies for sourceFieldDependencies
    var filteredItems = _.filter(dataSet.items, function (item) {
        return !dataSetManagementUtil.isEmptyDataItem(item);
      }),
      dependency = dataSet.dynamicDataSetDependency;
    if (dataSet.type === dataSetType.PRODUCT_FIELD_DEPENDENT) {
      dataSet.enhancedDynamicDataItems = filteredItems;
      dataSet.dependency = dataSet.dynamicDataSetDependency;
    } else {
      dataSet.items = filteredItems;
    }
    if (!_.isNil(dependency)) {
      var filteredSourceFieldDependencies = _.filter(dependency.sourceFieldDependencies, function (sourceFieldDependency) {
        return dataSetManagementUtil.isValidSourceFieldDependency(sourceFieldDependency);
      });

      // Build the source field dependency keys
      _.each(filteredSourceFieldDependencies, function (sourceFieldDependency) {
        sourceFieldDependency.key = sourceFieldDependency.formTemplateUniqueName + '|' + sourceFieldDependency.fieldName;
      });
      dependency.sourceFieldDependencies = filteredSourceFieldDependencies;
    }
    if (dataSet.type === dataSetType.CUSTOM || dataSet.type === dataSetType.PRODUCT_FIELD_DEPENDENT) {
      // Remove "no-op" dynamic data item criterion
      _.each(dataSet.items, function (dataItem) {
        dataItem.enhancedDynamicDataItemCriteriaList = _.filter(dataItem.enhancedDynamicDataItemCriteriaList, function (dynamicDataItemCriteria) {
          return dataSetManagementUtil.isValidDynamicDataItemCriteria(dynamicDataItemCriteria);
        });
      });
    }
    return dataSetRepository.updateDataSet(dataSet, name);
  };
  this.loadDataSetBrowserActions = function () {
    return dataSetBrowserActionRepository.loadActions();
  };
  this.loadDataSetActionByName = function (uri) {
    return dataSetActionRepository.loadDataSetActionByName(uri);
  };
  this.getDataSetReferences = function (name) {
    return dataSetActionRepository.getReferences(name);
  };
  this.deleteDataSetByName = function (name, forceDelete) {
    return dataSetActionRepository.deleteDataSetByName(name, forceDelete);
  };
  this.getJsBuilderOptions = function (uiFormTemplateId) {
    return uiFormTemplateRepository.getJsBuilderOptions(uiFormTemplateId);
  };
  this.validateRule = function (rule) {
    return formRuleBuilderRepository.validateRule(rule);
  };
  this.validateRegExp = function (regExp, value) {
    return uiFormTemplateRepository.validateRegExp(regExp, value);
  };
  this.exportDataSetsByName = function (dataSetNames) {
    return dataSetRepository.exportDataSetsByName(dataSetNames);
  };
  this.exportDataSetsByNameWithFilter = function (filterUri, excludedDataSetNames) {
    return dataSetRepository.exportDataSetsByNameWithFilter(filterUri, excludedDataSetNames);
  };
  this.loadRulesBrowserActions = function () {
    return rulesBrowserActionRepository.loadActions();
  };
  this.loadRuleBuilderActions = function (uri) {
    return ruleActionRepository.loadRuleAction(uri);
  };
  this.getRulesByFilterUri = function (filterUri, requestParams) {
    return ruleRepository.getRulesByFilterUri(filterUri, requestParams);
  };
  this.redeployRuleSets = function (ruleSetIds) {
    return ruleRepository.redeployRuleSets(ruleSetIds);
  };
  this.dataSetBackup = function () {
    return dataSetRepository.dataSetBackup();
  };
  this.backupProducts = function () {
    return productTemplateRepository.backupProducts();
  };
  this.rulesBackup = function () {
    return ruleRepository.rulesBackup();
  };
  this.formTemplateBackup = function () {
    return uiFormTemplateRepository.formTemplateBackup();
  };
  this.findUIFieldByUIFormTemplateUniqueNameAndFieldName = function (uiFormTemplateUniqueName, fieldName) {
    return uiFormTemplateRepository.findUIFieldByUIFormTemplateUniqueNameAndFieldName(uiFormTemplateUniqueName, fieldName);
  };
  this.loadProductTemplateActions = function (productTemplateName) {
    return productTemplateBrowserActionRepository.loadActions(productTemplateName);
  };
  this.getProductTemplatesByFilterUri = function (filterUri, requestParams) {
    return productTemplateRepository.getProductTemplatesByFilterUri(filterUri, requestParams);
  };
  this.loadProductTemplateById = function (productTemplateId) {
    return productTemplateEditorRepository.loadProductTemplateById(productTemplateId);
  };
  this.loadOrganizationActions = function (organizationId) {
    return organizationBrowserActionRepository.loadActions(organizationId);
  };
  this.getOrganizationsByFilterUriAndOrganizationType = function (filterUri, organizationType, requestParams) {
    return organizationRepository.getOrganizationsByFilterUriAndOrganizationType(filterUri, organizationType, requestParams);
  };
  this.loadPermissionActions = function (userType) {
    return permissionsRepository.loadPermissionActions(userType);
  };
  this.updatePermissions = function (permissions) {
    return permissionsRepository.updatePermissions(permissions);
  };
  this.backupOrganizations = function () {
    return organizationRepository.backupOrganizations();
  };
  this.getAvailableConditionalFieldTemplateIds = function (uiFormTemplateId) {
    return fieldRuleBuilderRepository.getAvailableConditionalFieldTemplateIds(uiFormTemplateId);
  };
  this.createNewOrganization = function (organizationType) {
    return organizationBrowserActionRepository.createNewOrganization(organizationType);
  };
  this.importCarrierLOAs = function (file, isMga) {
    return organizationBrowserActionRepository.importCarrierLOAs(file, isMga);
  };
  this.exportCarrierLOAs = function (isMga) {
    return organizationBrowserActionRepository.exportCarrierLOAs(isMga);
  };
  this.backup = function (sectionName) {
    return backupRepository.backup(sectionName);
  };
  this.restore = function (operation, file) {
    return restoreRepository.restore(operation, file);
  };
  this.importClassCodes = function (file) {
    return importClassCodesRepository.importClassCodes(file);
  };
  this.loadPopupNotificationActions = function () {
    return popupNotificationRepository.loadPopupNotificationActions();
  };
  this.loadEmailNotificationActions = function () {
    return emailNotificationRepository.loadEmailNotificationActions();
  };
  this.loadStateRateActions = function () {
    return rateStatusRepository.loadActions();
  };
  this.loadStateRates = function (params) {
    return rateStatusRepository.loadStateRates(params);
  };
  this.saveStateRates = function (stateRates) {
    return rateStatusRepository.saveStateRates(stateRates);
  };
  this.loadEmailNotification = function (params) {
    return emailNotificationRepository.loadEmailNotification(params);
  };
  this.loadPopupNotification = function (params) {
    return popupNotificationRepository.loadPopupNotification(params);
  };
  this.loadSectionTemplateBrowserActions = function () {
    return sectionTemplateBrowserActionRepository.loadActions();
  };
  this.getSectionTemplatesByName = function (nameSearchString, requestParams) {
    return sectionTemplateRepository.getSectionTemplatesByName(nameSearchString, requestParams);
  };
  this.getSectionTemplateById = function (sectionTemplateId) {
    return sectionTemplateEditorRepository.getSectionTemplateById(sectionTemplateId);
  };
  this.loadSectionTemplateActions = function (sectionTemplateId) {
    return sectionTemplateActionRepository.loadSectionTemplateActions(sectionTemplateId);
  };
  this.saveSectionTemplate = function (sectionTemplate) {
    return sectionTemplateRepository.saveSectionTemplate(sectionTemplate);
  };
  this.deleteSectionTemplate = function (sectionTemplateId) {
    return sectionTemplateRepository.deleteSectionTemplate(sectionTemplateId);
  };
  this.markSectionTemplateInProduction = function (sectionTemplateId) {
    return sectionTemplateRepository.markInProduction(sectionTemplateId);
  };
  this.uploadQuoteDocumentTemplateFile = function (sectionTemplate, quoteDocumentTemplateFile) {
    return sectionTemplateRepository.uploadQuoteDocumentTemplateFile(sectionTemplate, quoteDocumentTemplateFile);
  };
  this.loadRecipients = function () {
    return emailNotificationRepository.loadRecipients();
  };
  this.loadSystemPreferencesManagerActions = function () {
    return systemPreferencesManagerActionRepository.loadActions();
  };
  this.loadScoringRulesActions = function (scoringRuleId) {
    return scoringRulesRepository.loadActions(scoringRuleId);
  };
  this.getScoringRulesByParam = function (requestParam) {
    return scoringRulesRepository.getScoringRulesByParam(requestParam);
  };
  this.getScoringRuleById = function (scoringRuleId) {
    return scoringRulesRepository.getScoringRuleById(scoringRuleId);
  };
  this.saveScoringRule = function (scoringRule) {
    return scoringRulesRepository.saveScoringRule(scoringRule);
  };
  this.deleteScoringRule = function (scoringRuleId) {
    return scoringRulesRepository.deleteScoringRule(scoringRuleId);
  };
  this.copyScoringRule = function (scoringRuleId) {
    return scoringRulesRepository.copyScoringRule(scoringRuleId);
  };
  this.loadUserGroupById = function (userGroupId) {
    return userGroupEditorRepository.loadUserGroupById(userGroupId);
  };
  this.getStudioPreferences = function () {
    return systemPreferencesRepository.getStudioPreferences();
  };
  this.saveStudioPreferences = function (studioPreferences) {
    return systemPreferencesRepository.saveStudioPreferences(studioPreferences);
  };
  this.loadFilesAndIconsManagerActions = function () {
    return filesAndIconsManagerActionRepository.loadActions();
  };
  this.getConfiguredFiles = function () {
    return filesAndIconsManagerRepository.getConfiguredFiles();
  };
  this.saveConfiguredFile = function (configuredFile) {
    return filesAndIconsManagerRepository.saveConfiguredFile(configuredFile);
  };
  this.deleteConfiguredFile = function (configuredFileId) {
    return filesAndIconsManagerRepository.deleteConfiguredFile(configuredFileId);
  };
  this.generateDataDictionary = function () {
    return generateDataDictionaryRepository.generateDataDictionary();
  };
};
ConfigurationMediator.$inject = ["dataSetActionRepository", "dataSetBrowserActionRepository", "dataSetManagementUtil", "dataSetRepository", "dataSetType", "fieldReferencesRepository", "fieldRuleBuilderRepository", "formReferencesRepository", "formActionRepository", "formTemplateBrowserActionRepository", "formTemplateSetRepository", "formRuleBuilderRepository", "objectRepository", "uiFormTemplateRepository", "rulesBrowserActionRepository", "ruleRepository", "ruleActionRepository", "productTemplateBrowserActionRepository", "productTemplateRepository", "productTemplateEditorRepository", "organizationBrowserActionRepository", "organizationRepository", "permissionsRepository", "backupRepository", "restoreRepository", "popupNotificationRepository", "emailNotificationRepository", "sectionTemplateBrowserActionRepository", "sectionTemplateRepository", "sectionTemplateEditorRepository", "sectionTemplateActionRepository", "systemPreferencesManagerActionRepository", "systemPreferencesRepository", "scoringRulesRepository", "userGroupEditorRepository", "rateStatusRepository", "importClassCodesRepository", "filesAndIconsManagerActionRepository", "filesAndIconsManagerRepository", "generateDataDictionaryRepository"];
angular.module('ums.configuration').service('configurationMediator', ConfigurationMediator);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2270:
/***/ (function(module, exports) {

var path = '/configuration/defaultHomePage.tpl.html';
var html = "<!--This is an empty html file to display if no tabs are available on UMStudio successful login--!>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2271:
/***/ (function(module) {

module.exports = JSON.parse("{\"dataSetBrowser\":{\"title\":\"Manage Data Sets\",\"columns\":{\"name\":\"Name\",\"type\":\"Type\",\"description\":\"Description\",\"lastModifiedBy\":\"Last Edited By\",\"timeLastModified\":\"Last Modified Date\"},\"emptyGrid\":\"No matching data sets\",\"recordCountText\":\"Showing startIndex to endIndex of total Data Set\",\"recordsCountText\":\"Showing startIndex to endIndex of total Data Sets\",\"clearButton\":\"Clear All\",\"textInputFilter\":{\"nameSubstring\":{\"placeholder\":\"Search data sets\"}},\"bulkActionLabel\":\"Data Sets Selected\",\"bulkActionCancelButtonLabel\":\"Cancel\",\"selectFilter\":{\"types\":{\"placeholder\":\"All Types\"},\"productNames\":{\"placeholder\":\"All Products\"}},\"actions\":{\"name\":\"Actions\",\"new data set\":\"New Data Set\",\"export\":\"Export\",\"backup\":\"Backup\"},\"type\":{\"0\":\"Static\",\"1\":\"Custom\",\"2\":\"Product/Field Dependent\",\"3\":\"Repeating Form\"},\"export\":{\"bulkActionLabel\":\"Export\",\"loadingBar\":\"Exporting data set(s)\",\"successMessage\":\"Successfully exported data set(s)\"},\"backup\":{\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\",\"name\":\"Data Sets\"}}}");

/***/ }),

/***/ 2272:
/***/ (function(module, exports) {

var path = '/configuration/dataSetBrowser/dataSetBrowser.tpl.html';
var html = "<ui-grid-data-browser\n    identifier=\"'dataSetBrowser'\"\n    columns=\"columns\"\n    state-params=\"stateParams\"\n    advanced-filter-type=\"advancedFilterType\"\n    filter-type=\"filterType\"\n    translations=\"translations\"\n    initial-request-params=\"initialRequestParams\"\n    load-items-handler=\"loadItemsHandler\"\n    load-actions-handler=\"loadActionsHandler\"\n    notify-handle-action=\"handleAction(action, file)\"\n    notify-handle-bulk-action=\"handleBulkAction(action, selectedItems, excludedItems, filterUri)\">\n</ui-grid-data-browser>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2273:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DataSetBrowserController = function DataSetBrowserController($rootScope, $scope, $filter, $uibModal, localization, advancedFilterType, filterType, dataSetType, configurationMediator, dataSetAction, configurationActionsUtil, databaseDownloadSectionName, modalUtil, gridDataBrowserConstant) {
  localization.getTranslationByKey('dataSetBrowser').then(function (translations) {
    $scope.columns = [{
      name: 'name',
      label: _.get(translations, 'columns.name'),
      className: 'colName',
      getValue: function getValue(item) {
        return item.name;
      }
    }, {
      name: 'type',
      label: _.get(translations, 'columns.type'),
      className: 'colType',
      getValue: function getValue(item) {
        return _.get(translations, 'type.' + item.type);
      }
    }, {
      name: 'description',
      label: _.get(translations, 'columns.description'),
      className: 'colDescription',
      getValue: function getValue(item) {
        return item.description;
      }
    }, {
      name: 'lastModifiedBy',
      label: _.get(translations, 'columns.lastModifiedBy'),
      className: 'colLastModifiedBy',
      getValue: function getValue(item) {
        return item.lastModifiedBy;
      }
    }, {
      name: 'timeLastModified',
      label: _.get(translations, 'columns.timeLastModified'),
      className: 'colTimeLastModified',
      getValue: function getValue(item) {
        return $filter('date')(item.timeLastModified, 'MM/dd/yy hh:mma');
      }
    }];
    $scope.advancedFilterType = advancedFilterType.DATA_SET_BROWSER;
    $scope.filterType = filterType.TYPE_DATASET_FILTER;
    $scope.stateParams = {
      browser: 'configuration.dataSetBrowser',
      getDetailState: function getDetailState(dataSet) {
        var stateName;
        if (dataSet.type === dataSetType.REPEATING_FORM) {
          stateName = 'configuration.dataSetEditor.repeatingForm';
        } else {
          stateName = 'configuration.dataSetEditor.dataItems';
        }
        return {
          name: stateName,
          params: {
            dataSetName: dataSet.name,
            type: dataSet.type
          }
        };
      }
    };
    $scope.translations = {
      title: _.get(translations, 'title'),
      recordCountText: _.get(translations, 'recordCountText'),
      recordsCountText: _.get(translations, 'recordsCountText'),
      emptyGrid: _.get(translations, 'emptyGrid'),
      bulkActionLabel: _.get(translations, 'bulkActionLabel'),
      bulkActionCancelButtonLabel: _.get(translations, 'bulkActionCancelButtonLabel')
    };
    $scope.initialRequestParams = {
      key: 'name',
      startIndex: 0,
      pageSize: 25,
      sortType: 'asc'
    };
    $scope.loadActionsHandler = function () {
      return configurationMediator.loadDataSetBrowserActions().then(function (actions) {
        _.each(actions.actions, function (action) {
          if (action.name === dataSetAction.EXPORT) {
            action.isBulkAction = true;
            action.bulkActionLabel = _.get(translations, 'export.bulkActionLabel');
          }
        });
        actions.hiddenInputActions = {};
        return actions;
      });
    };
    $scope.loadItemsHandler = function (filterUri, requestParams) {
      return configurationMediator.getDataSetsByFilterUri(filterUri, requestParams).then(function (result) {
        _.each(result.records, function (dataSet) {
          dataSet.id = dataSet.name;
        });
        return result;
      });
    };
    $scope.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case dataSetAction.NEW_DATA_SET:
            $uibModal.open({
              templateUrl: '/configuration/dataSetSettings/dataSetSettingsTemplate.tpl.html',
              controller: 'dataSetSettingsController',
              windowClass: 'dataSetSettingsModal',
              resolve: {
                modalOptions: function modalOptions() {
                  return {
                    existingDataSetName: null
                  };
                }
              }
            });
            break;
          case dataSetAction.BACKUP:
            configurationActionsUtil.backup(databaseDownloadSectionName.DATA_SETS, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
    $scope.handleBulkAction = function (action, selectedItems, excludedItems, filterUri) {
      if (action.enabled) {
        switch (action.name) {
          case dataSetAction.EXPORT:
            configurationActionsUtil.exportDataSets(selectedItems, filterUri, excludedItems).then(function () {
              $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
            });
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
            break;
        }
      }
    };
  });
};
DataSetBrowserController.$inject = ["$rootScope", "$scope", "$filter", "$uibModal", "localization", "advancedFilterType", "filterType", "dataSetType", "configurationMediator", "dataSetAction", "configurationActionsUtil", "databaseDownloadSectionName", "modalUtil", "gridDataBrowserConstant"];
angular.module('ums.configuration').controller('dataSetBrowserController', DataSetBrowserController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2274:
/***/ (function(module, exports) {

/*@ngInject*/
var DataSetBrowserActionRepository = function DataSetBrowserActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadActions = function () {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.data.DataSet:null'
        }
      };
    return this.get(url, config);
  };
};
DataSetBrowserActionRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('dataSetBrowserActionRepository', DataSetBrowserActionRepository);

/***/ }),

/***/ 2275:
/***/ (function(module, exports) {

var path = '/configuration/dataSetEditor/dataSetEditor.tpl.html';
var html = "<div class=\"dataSetEditor\">\n\n    <ui-data-set-editor-header></ui-data-set-editor-header>\n\n    <ui-data-set-editor-nav\n        ng-if=\"viewModel.displayNavTabs\"></ui-data-set-editor-nav>\n\n    <div class=\"content\"\n         ui-view=\"tabView\"></div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2276:
/***/ (function(module, exports) {

/*@ngInject*/
var DataSetEditorController = function DataSetEditorController($scope, $stateParams, configurationConstant, dataSetType, dataSetEditorModel) {
  // UMS-20495 workaround
  var dataSetName;
  try {
    dataSetName = decodeURIComponent($stateParams.dataSetName);
  } catch (exception) {
    dataSetName = $stateParams.dataSetName;
  }
  $scope.viewModel = {
    displayNavTabs: parseInt($stateParams.type) !== dataSetType.STATIC && parseInt($stateParams.type) !== dataSetType.REPEATING_FORM,
    dataSetName: dataSetName
  };
  function init() {
    dataSetEditorModel.buildDataSet($scope.viewModel.dataSetName);
  }
  $scope.$on('$destroy', function () {
    dataSetEditorModel.reset($scope.viewModel.dataSetName);
  });
  $scope.$on(configurationConstant.event.DATA_SET_EDITOR_MODEL_UPDATED, function (event, dataSetName) {
    $scope.viewModel.dataSetName = dataSetName;
  });
  init();
};
DataSetEditorController.$inject = ["$scope", "$stateParams", "configurationConstant", "dataSetType", "dataSetEditorModel"];
angular.module('ums.configuration').controller('dataSetEditorController', DataSetEditorController);

/***/ }),

/***/ 2277:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2278);
__webpack_require__(2279);
__webpack_require__(2280);
__webpack_require__(2281);
__webpack_require__(2282);
var DataSetEditorHeaderComponent = {
  templateUrl: '/configuration/dataSetEditor/header/dataSetEditorHeader.tpl.html',
  controller: 'dataSetEditorHeaderController',
  bindings: {}
};
angular.module('ums').component('uiDataSetEditorHeader', DataSetEditorHeaderComponent);

/***/ }),

/***/ 2278:
/***/ (function(module, exports) {

var path = '/configuration/dataSetEditor/header/dataSetEditorHeader.tpl.html';
var html = "<div class=\"headerRow\">\n\n    <!--Status-->\n    <div class=\"nameColumn\">\n        <button type=\"button\"\n                class=\"btn-link backButton\"\n                ui-sref=\"configuration.dataSetBrowser\">\n            <span class=\"glyphicon glyphicon-arrow-left\"></span>\n            <span ui-translate>dataSetEditorHeader.title</span>\n        </button>\n\n        <div class=\"dataSetName\" uib-tooltip=\"{{ $ctrl.dataSet.name }}\">{{ $ctrl.dataSet.name }}</div>\n    </div>\n\n    <div class=\"descriptionTypeColumn\">\n\n        <!--Description-->\n        <div class=\"detailColumn\">\n            <div class=\"detailLabel\"\n                 ui-translate>dataSetEditorHeader.descriptionLabel\n            </div>\n\n            <div class=\"detailValue\"\n                 uib-tooltip=\"{{ $ctrl.dataSet.description }}\">\n                <span>{{ $ctrl.dataSet.description }}</span>\n            </div>\n        </div>\n\n        <!--Type-->\n        <div class=\"detailColumn\">\n            <div class=\"detailLabel\"\n                 ui-translate>dataSetEditorHeader.typeLabel\n            </div>\n\n            <div class=\"detailValue\">{{ $ctrl.getType() }}\n            </div>\n        </div>\n\n    </div>\n\n    <div class=\"actionButtonColumn\">\n        <action-buttons-bar context=\"$ctrl.context\"\n                            actions=\"$ctrl.actions\"\n                            action-sub-texts=\"$ctrl.actionSubTexts\"\n                            notify-action-clicked=\"$ctrl.handleAction(action, file)\"\n                            time-last-modified=\"$ctrl.actionsTimeLastModified\"></action-buttons-bar>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2279:
/***/ (function(module) {

module.exports = JSON.parse("{\"dataSetEditorHeader\":{\"title\":\"Manage Data Sets\",\"descriptionLabel\":\"Description:\",\"backButton\":\"Back\",\"typeLabel\":\"Type:\",\"type\":{\"0\":\"Static\",\"1\":\"Custom\",\"2\":\"Product/Field Dependent\",\"3\":\"Repeating Form\"},\"actions\":{\"name\":\"Actions\",\"data set settings\":\"Data Set Settings\",\"delete\":\"Delete\",\"export\":\"Export\",\"view references\":\"View References\",\"discard changes\":\"Discard\",\"save\":\"Save\"},\"deleteDataSetLoadingBar\":\"Deleting data set\",\"deleteDataSetSuccessLoadingBar\":\"Successfully deleted data set\",\"savingDataSetLoadingBar\":\"Saving data set\",\"savingDataSetSuccessLoadingBar\":\"Successfully saved data set\",\"unsavedChanges\":\"Unsaved changes\",\"invalidDataSet\":\"The data set is invalid. Please correct or discard your changes before leaving this page.\",\"discardConfirmation\":{\"title\":\"Discard\",\"summary\":\"Are you sure you want to discard your changes?\",\"success\":\"Your changes have been discarded.\",\"confirmButtonLabel\":\"Yes\",\"cancelButtonLabel\":\"No\"}}}");

/***/ }),

/***/ 2280:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DataSetEditorHeaderController = function DataSetEditorHeaderController($rootScope, $scope, $element, $stateParams, $state, $uibModal, localization, configurationConstant, configurationMediator, coreConstant, dataSetAction, dataSetActionsUtil, dataSetEditorModel, modalUtil) {
  var _this5 = this;
  // UMS-20495 workaround
  try {
    $stateParams.dataSetName = decodeURIComponent($stateParams.dataSetName);
  } catch (exception) {
    // do nothing
  }
  $element.addClass('dataSetEditorHeader');
  this.dataSet = null;
  this.translations = null;
  this.actions = [];
  this.context = {
    identifier: 'dataSetEditorHeader',
    actions: {},
    fallthrough: null,
    model: {
      contextType: coreConstant.CONTEXT_NONE
    }
  };
  this.context.actions[coreConstant.CONTEXT_NONE] = '';
  this.actionSubTexts = {};
  this.$onInit = function () {
    var _this = this;
    localization.getTranslationByKey('dataSetEditorHeader').then(function (translations) {
      _this.dataSet = dataSetEditorModel.getDataSet($stateParams.dataSetName);
      _this.translations = translations;
      _this.loadActions();
    });
  };
  this.loadActions = function () {
    var _this2 = this;
    configurationMediator.loadDataSetActionByName('com.firstbest.data.DataSet:' + $stateParams.dataSetName).then(function (actions) {
      var allActions = [];
      allActions.push({
        actions: actions.actions,
        contextType: _this2.context.model.contextType
      });
      _this2.processActions(allActions, /*enableSaveAndDiscard*/false);
    });
  };
  this.processActions = function (actions) {
    var _this3 = this;
    this.actions = actions;
    this.actionSubTexts = {};
    _.each(this.actions, function (subAction) {
      _.each(subAction.actions, function (action) {
        if (action.name === dataSetAction.SAVE) {
          action.enabled = false;
          if (dataSetEditorModel.hasUnsavedChanges($stateParams.dataSetName)) {
            _this3.actionSubTexts[action.name] = {
              class: 'unsavedChanges',
              text: _.get(_this3.translations, 'unsavedChanges')
            };
            if (dataSetEditorModel.isValidToSave($stateParams.dataSetName) && dataSetEditorModel.isValidDynamicCriterionToSave($stateParams.dataSetName) && dataSetEditorModel.isValidDependenciesToSave($stateParams.dataSetName)) {
              action.enabled = true;
            }
          }
        }
        if (action.name === dataSetAction.DISCARD_CHANGES) {
          action.enabled = false;
          if (dataSetEditorModel.hasUnsavedChanges($stateParams.dataSetName)) {
            action.enabled = true;
          }
        }
      });
    });
    this.actionsTimeLastModified = new Date().getTime();
  };
  this.getType = function () {
    if (!_.isNil(this.dataSet)) {
      return _.get(this.translations, 'type.' + this.dataSet.type);
    }
    return '';
  };
  this.handleAction = function (action, file) {
    var _this4 = this;
    if (action.enabled) {
      switch (action.name) {
        case dataSetAction.SAVE:
          dataSetActionsUtil.saveDataSet(this.dataSet);
          break;
        case dataSetAction.DELETE:
          dataSetActionsUtil.deleteDataSet(this.dataSet.name);
          break;
        case dataSetAction.EXPORT:
          dataSetActionsUtil.exportDataSet(this.dataSet.name);
          break;
        case dataSetAction.DATA_SET_SETTINGS:
          $uibModal.open({
            templateUrl: '/configuration/dataSetSettings/dataSetSettingsTemplate.tpl.html',
            controller: 'dataSetSettingsController',
            windowClass: 'dataSetSettingsModal',
            resolve: {
              modalOptions: function modalOptions() {
                return {
                  existingDataSetName: _this4.dataSet.name,
                  dataSet: _.cloneDeep(_this4.dataSet)
                };
              }
            }
          });
          break;
        case dataSetAction.NEW_DATA_SET:
          modalUtil.showActionNotImplementedModal(action.name);
          break;
        case dataSetAction.VIEW_REFERENCES:
          dataSetActionsUtil.viewDataSetReferences(this.dataSet.name);
          break;
        case dataSetAction.DISCARD_CHANGES:
          dataSetActionsUtil.discardChanges();
          break;
        default:
          modalUtil.showActionNotImplementedModal(action.name);
          break;
      }
    }
  };
  $scope.$on(configurationConstant.event.DATA_SET_EDITOR_MODEL_UPDATED, function (event, dataSetName) {
    if ($stateParams.dataSetName === dataSetName) {
      _this5.dataSet = dataSetEditorModel.getDataSet(dataSetName);
      _this5.processActions(_this5.actions);
    }
  });
  $scope.$on(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED, function () {
    _this5.processActions(_this5.actions);
  });
  $scope.$on(configurationConstant.event.DATA_SET_DYNAMIC_CRITERIA_UPDATED, function () {
    _this5.processActions(_this5.actions);
  });
  $scope.$on(configurationConstant.event.DATA_SET_DEPENDENCIES_UPDATED, function () {
    _this5.processActions(_this5.actions);
  });
  $scope.$on(coreConstant.event.RELOAD_ACTIONS, function () {
    _this5.loadActions();
  });
  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    var isCurrentStateDataSetEditor = _.startsWith(fromState.name, 'configuration.dataSetEditor'),
      isTargetSameAsCurrent = toState.name === fromState.name,
      dataSetName = toParams.dataSetName ? toParams.dataSetName : $stateParams.dataSetName;
    if (toState.name === 'login') {
      return;
    }
    if (dataSetEditorModel.hasUnsavedChanges(dataSetName) && isCurrentStateDataSetEditor && !isTargetSameAsCurrent) {
      event.preventDefault();
      if (dataSetEditorModel.isValidToSave(dataSetName)) {
        dataSetActionsUtil.saveDataSet(_this5.dataSet).then(function () {
          $state.go(toState, toParams);
        });
      } else {
        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(_this5.translations, 'invalidDataSet'));
      }
    } else {
      // there are no changes to be saved, do nothing
    }
  });
};
DataSetEditorHeaderController.$inject = ["$rootScope", "$scope", "$element", "$stateParams", "$state", "$uibModal", "localization", "configurationConstant", "configurationMediator", "coreConstant", "dataSetAction", "dataSetActionsUtil", "dataSetEditorModel", "modalUtil"];
angular.module('ums.configuration').controller('dataSetEditorHeaderController', DataSetEditorHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2281:
/***/ (function(module, exports) {

/*@ngInject*/
var DataSetActionRepository = function DataSetActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadDataSetActionByName = function (uri) {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: uri
        }
      };
    return this.get(url, config);
  };
  this.getReferences = function (dataSetName) {
    var url = '/rest/DataSet/references',
      config = {
        params: {
          dataSetName: dataSetName
        }
      };
    return this.get(url, config);
  };
  this.deleteDataSetByName = function (dataSetName, forceDelete) {
    var url = '/rest/DataSet/delete',
      config = {
        params: {
          forceDelete: forceDelete,
          dataSetName: dataSetName
        }
      };
    return this.delete(url, config);
  };
};
DataSetActionRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('dataSetActionRepository', DataSetActionRepository);

/***/ }),

/***/ 2282:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DataSetActionsUtil = function DataSetActionsUtil($rootScope, $state, $uibModal, coreMediator, configurationMediator, dataSetEditorModel, localization, loadingBarHandler, configurationActionsUtil, modalUtil, coreConstant) {
  localization.getTranslationByKey('dataSetEditorHeader').then(function (translations) {
    this.translations = translations;
    this.deleteDataSet = function (name) {
      configurationMediator.getDataSetReferences(name).then(function (result) {
        if (result.length > 0) {
          var modalInstance = $uibModal.open({
            templateUrl: '/configuration/dataSetReferences/dataSetReferencesModal.tpl.html',
            controller: 'dataSetReferencesController',
            windowClass: 'dataSetReferencesModal',
            resolve: {
              options: function options() {
                return {
                  dataSetName: name,
                  deleteDataSet: true
                };
              }
            }
          });
          modalInstance.result.then(function (options) {
            this.deleteDataSetContinue(options.dataSetName);
          }.bind(this));
        } else {
          this.deleteDataSetContinue(name);
        }
      }.bind(this));
    };
    this.viewDataSetReferences = function (name) {
      configurationMediator.getDataSetReferences(name).then(function (result) {
        var modalInstance = $uibModal.open({
          templateUrl: '/configuration/dataSetReferences/dataSetReferencesModal.tpl.html',
          controller: 'dataSetReferencesController',
          windowClass: 'dataSetReferencesModal',
          resolve: {
            options: function options() {
              return {
                dataSetName: name
              };
            }
          }
        });
      }.bind(this));
    };
    this.deleteDataSetContinue = function (dataSetName) {
      loadingBarHandler.showNotificationLoadingBar(_.get(this.translations, 'deleteDataSetLoadingBar'));
      configurationMediator.deleteDataSetByName(dataSetName, true).then(function () {
        dataSetEditorModel.setUnsavedChanges(dataSetName, false);
        $state.go('configuration.dataSetBrowser', {});
        loadingBarHandler.concludeNotificationLoadingBar(_.get(this.translations, 'deleteDataSetSuccessLoadingBar'));
      }.bind(this));
    };
    this.saveDataSet = function (dataSet) {
      var promise;
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'savingDataSetLoadingBar'));
      promise = configurationMediator.updateDataSet(dataSet, dataSet.name).then(function (result) {
        dataSetEditorModel.updateDataSet(result);
        loadingBarHandler.concludeNotificationLoadingBar(_.get(this.translations, 'savingDataSetSuccessLoadingBar'));
      }.bind(this));
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    };
    this.exportDataSet = function (dataSetName) {
      configurationActionsUtil.exportDataSet(dataSetName);
    };
    this.discardChanges = function () {
      localization.getTranslationByKey('dataSetEditorHeader').then(function (translations) {
        var message = _.get(translations, 'discardConfirmation.summary'),
          title = _.get(translations, 'discardConfirmation.title'),
          cancelButtonLabel = _.get(translations, 'discardConfirmation.cancelButtonLabel'),
          confirmButtonLabel = _.get(translations, 'discardConfirmation.confirmButtonLabel');
        function handleClose() {
          $state.reload();
          loadingBarHandler.showFadingNotificationLoadingBar(_.get(this.translations, 'discardConfirmation.success'));
        }
        modalUtil.showGenericConfirm({
          cancelButtonLabel: cancelButtonLabel,
          confirmActionButtonLabel: confirmButtonLabel,
          summary: message,
          title: title
        }).then(handleClose.bind(this));
      }.bind(this));
    };
  }.bind(this));
};
DataSetActionsUtil.$inject = ["$rootScope", "$state", "$uibModal", "coreMediator", "configurationMediator", "dataSetEditorModel", "localization", "loadingBarHandler", "configurationActionsUtil", "modalUtil", "coreConstant"];
angular.module('ums.configuration').service('dataSetActionsUtil', DataSetActionsUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2283:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2284);
__webpack_require__(2285);
__webpack_require__(2286);
var DataSetEditorNavComponent = {
  templateUrl: '/configuration/dataSetEditor/nav/dataSetEditorNav.tpl.html',
  controller: 'dataSetEditorNavController',
  bindings: {}
};
angular.module('ums').component('uiDataSetEditorNav', DataSetEditorNavComponent);

/***/ }),

/***/ 2284:
/***/ (function(module) {

module.exports = JSON.parse("{\"dataSetEditorNav\":{\"dataItems\":\"Data Items\",\"dynamicCriteria\":\"Dynamic Criteria\"}}");

/***/ }),

/***/ 2285:
/***/ (function(module, exports) {

var path = '/configuration/dataSetEditor/nav/dataSetEditorNav.tpl.html';
var html = "<div class=\"dataSetEditorNav\">\n    <button type=\"button\"\n            class=\"btn btn-link navButton\"\n            ui-sref=\"configuration.dataSetEditor.dataItems\"\n            ng-class=\"{ active: $ctrl.isActive('configuration.dataSetEditor.dataItems') }\">\n        <span ui-translate>dataSetEditorNav.dataItems</span>\n    </button>\n\n    <button type=\"button\"\n            class=\"btn btn-link navButton\"\n            ui-sref=\"configuration.dataSetEditor.dynamicCriteria\"\n            ng-class=\"{ active: $ctrl.isActive('configuration.dataSetEditor.dynamicCriteria') }\">\n        <span ui-translate>dataSetEditorNav.dynamicCriteria</span>\n    </button>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2286:
/***/ (function(module, exports) {

/*@ngInject*/
var DataSetEditorNavController = function DataSetEditorNavController($scope, $element, $state) {
  this.isActive = function (buttonName) {
    return $state.includes(buttonName);
  };
};
DataSetEditorNavController.$inject = ["$scope", "$element", "$state"];
angular.module('ums.configuration').controller('dataSetEditorNavController', DataSetEditorNavController);

/***/ }),

/***/ 2287:
/***/ (function(module) {

module.exports = JSON.parse("{\"dataItems\":{\"message\":\"Custom data sets are managed in the code, but you can still add dynamic criteria to a custom data set.\",\"addGroupLabel\":\"Add Group\",\"sorting\":{\"applySortingLabel\":\"Apply Sorting\",\"labelAscLabel\":\"By label ascending\",\"labelDescLabel\":\"By label descending\",\"valueAscLabel\":\"By value ascending\",\"valueDescLabel\":\"By value descending\"}}}");

/***/ }),

/***/ 2288:
/***/ (function(module, exports) {

var path = '/configuration/dataSetEditor/content/dataItems/dataItems.tpl.html';
var html = "<ng-form name=\"dataItemsForm\"\n         class=\"dataItems\"\n         ui-delete-data-items-and-groups>\n\n    <span class=\"staticText\"\n          ng-if=\"viewModel.isCustomDynamicDataSet\"\n          ui-translate>dataItems.message</span>\n\n    <div class=\"dataItemsContainer\"\n         ng-if=\"!viewModel.isCustomDynamicDataSet\">\n\n        <div class=\"groupSortingContainer\"\n             ng-if=\"!viewModel.isReadOnly\">\n\n            <ui-select class=\"groupSortingDropDown dropdownComponentSelect\"\n                       theme=\"select2\"\n                       ng-model=\"viewModel.groupSortingDropdownSelectedValue\"\n                       append-to-body=\"true\"\n                       ui-hide-select-on-scroll\n                       ui-hide-select-on-scroll-selector=\".dataSetEditor .content\"\n                       search-enabled=\"false\">\n                <ui-select-match>\n                    <span ng-bind=\"$select.selected.name\"></span>\n                </ui-select-match>\n                <ui-select-choices repeat=\"groupSorting in viewModel.groupSortingChoices\">\n                    <span ng-bind=\"groupSorting.name\"></span>\n                </ui-select-choices>\n            </ui-select>\n\n            <button class=\"btn btn-primary btn-outline applySortingButton\"\n                    ng-click=\"onApplySortingClicked()\"\n                    ng-disabled=\"!viewModel.isApplySortingEnabled\">\n\n                <span ui-translate>dataItems.sorting.applySortingLabel</span>\n            </button>\n        </div>\n\n        <div class=\"groupsContainer\">\n\n            <dataitems-group ng-repeat=\"dataItemsGroup in viewModel.dataItemsGroups\"\n                             ng-class=\"{ selected: dataItemsGroup.selected }\"\n                             dataset-name=\"viewModel.dataSetName\"\n                             dataitems-group=\"dataItemsGroup\"\n                             ng-form=\"dataItemsGroup{{dataItemsGroup.id}}\"\n                             is-product-or-field-dependent=\"viewModel.isProductOrFieldDependentDynamicDataSet\"\n                             is-delete-enabled=\"viewModel.dataItemsGroups.length > 1 && $index !== 0\"\n                             notify-delete-click=\"onDataItemsGroupDeleteClicked(dataItemsGroup.id)\"\n                             notify-data-items-group-selected-or-unselected=\"onDataItemsGroupSelectedOrUnselected(dataItemsGroup.id)\"\n                             notify-data-item-selected-or-unselected=\"onDataItemSelectedOrUnselected(dataItemsGroup.id)\"\n                             notify-text-input-focused=\"onTextInputFocused()\"\n                             time-last-modified=\"timeLastModified\"\n                             draggable=\"{{ dataItemsGroup.draggable }}\"\n                             group-index=\"$index\"\n                             ui-data-items-group-drag-manager></dataitems-group>\n        </div>\n\n        <div class=\"addGroupContainer\">\n\n            <a class=\"btn btn-primary addGroupButton\"\n               ng-if=\"!viewModel.isReadOnly\"\n               ng-click=\"onAddGroupClicked()\">\n                <span ui-translate>dataItems.addGroupLabel</span>\n            </a>\n        </div>\n    </div>\n\n</ng-form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2289:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DataItemsController = function DataItemsController($rootScope, $scope, $stateParams, $timeout, $document, localization, dataSetType, coreConstant, dataSetManagementUtil, dataItemSortingConstant, configurationConstant, dataSetEditorModel, currentUserModel, authorizationConstants) {
  var timeoutList = [];

  // UMS-20495 workaround
  try {
    $stateParams.dataSetName = decodeURIComponent($stateParams.dataSetName);
  } catch (exception) {
    // do nothing
  }
  function init() {
    localization.getTranslationByKey('dataItems').then(function (translation) {
      var dataSet = dataSetEditorModel.getDataSet($stateParams.dataSetName);
      $scope.viewModel = {
        isCustomDynamicDataSet: parseInt($stateParams.type) === dataSetType.CUSTOM,
        isProductOrFieldDependentDynamicDataSet: parseInt($stateParams.type) === dataSetType.PRODUCT_FIELD_DEPENDENT,
        isApplySortingEnabled: false,
        dataSetName: $stateParams.dataSetName,
        isReadOnly: !currentUserModel.hasAuthorization(authorizationConstants.MANAGE_DATASETS),
        dataItemsGroups: []
      };
      $scope.timeLastModified = new Date().getTime();
      buildDataItemsGroupings(dataSet);
      initGroupSortingChoices(translation, dataItemSortingConstant.LABEL_ASC);
      timeoutList.push($timeout(function () {
        $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, $scope.viewModel.groupSortingDropdownSelectedValue);
      }, 0));
    });
  }
  function buildDataItemsGroupings(dataSet) {
    var dataItemsGroups = {};
    if (!_.isNil(dataSet)) {
      // Organize the dataItems into their various 'grouping' and sort by 'ordering'
      // TODO is ordering guaranteed when returned from server? If so, we don't have to do the _.orderBy below

      if (_.isEmpty(dataSet.items)) {
        if (_.isEmpty($scope.viewModel.dataItemsGroups)) {
          $scope.viewModel.dataItemsGroups.push({
            id: dataSetManagementUtil.generateUUID(),
            name: '',
            dataSetName: $stateParams.dataSetName,
            items: []
          });
        }
      } else {
        _.each(dataSet.items, function (dataItem) {
          if (_.isNil(dataItem.grouping)) {
            dataItem.grouping = '';
          }
          if (!_.has(dataItemsGroups, dataItem.grouping)) {
            dataItemsGroups[dataItem.grouping] = [];
          }
          dataItemsGroups[dataItem.grouping].push({
            id: dataSetManagementUtil.generateUUID(),
            dataSetName: $stateParams.dataSetName,
            dataItem: dataItem
          });
        });
        _.forOwn(dataItemsGroups, function (dataItemViews, grouping) {
          dataItemsGroups[grouping] = _.orderBy(dataItemViews, 'dataItem.ordering');
        });
        $scope.viewModel.dataItemsGroups = _.transform(dataItemsGroups, function (result, dataItemViews, dataItemsGroupName) {
          var groupId = dataSetManagementUtil.generateUUID();
          _.each(dataItemViews, function (dataItemView) {
            dataItemView.groupId = groupId;
          });
          result.push({
            id: groupId,
            name: dataItemsGroupName,
            dataSetName: $stateParams.dataSetName,
            items: dataItemViews
          });
        }, []);
      }
    }
  }
  function initGroupSortingChoices(translation, selectedValue) {
    $scope.viewModel.groupSortingChoices = [{
      name: _.get(translation, 'sorting.labelAscLabel'),
      value: dataItemSortingConstant.LABEL_ASC
    }, {
      name: _.get(translation, 'sorting.labelDescLabel'),
      value: dataItemSortingConstant.LABEL_DESC
    }, {
      name: _.get(translation, 'sorting.valueAscLabel'),
      value: dataItemSortingConstant.VALUE_ASC
    }, {
      name: _.get(translation, 'sorting.valueDescLabel'),
      value: dataItemSortingConstant.VALUE_DESC
    }];
    $scope.viewModel.groupSortingDropdownSelectedValue = _.find($scope.viewModel.groupSortingChoices, function (item) {
      return item.value === selectedValue;
    });
  }
  $scope.onApplySortingClicked = function () {
    var sortProperty,
      ascending,
      preSortedDataItemGroups = [];
    switch ($scope.viewModel.groupSortingDropdownSelectedValue.value) {
      case dataItemSortingConstant.LABEL_ASC:
        sortProperty = 'name';
        ascending = true;
        break;
      case dataItemSortingConstant.LABEL_DESC:
        sortProperty = 'name';
        ascending = false;
        break;
      case dataItemSortingConstant.VALUE_ASC:
        sortProperty = 'value';
        ascending = true;
        break;
      case dataItemSortingConstant.VALUE_DESC:
        sortProperty = 'value';
        ascending = false;
        break;
    }
    _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      var numericSort = true;

      // Filter out invalid rows before sorting.
      dataItemsGroup.items = _.filter(dataItemsGroup.items, function (dataItemView) {
        var validDataItemForEvaluation = dataSetManagementUtil.isValidDataItemForEvaluation(dataItemView.dataItem);
        if (!validDataItemForEvaluation) {
          dataSetEditorModel.removeDataItem($stateParams.dataSetName, dataItemView.dataItem);
        }
        return validDataItemForEvaluation;
      });
      preSortedDataItemGroups.push(_.cloneDeep(dataItemsGroup));
      _.each(dataItemsGroup.items, function (dataItemView) {
        if (isNaN(_.toNumber(_.replace(dataItemView.dataItem[sortProperty], ',', '')))) {
          numericSort = false;
          return false;
        }
      });
      if (numericSort) {
        dataItemsGroup.items = _.sortBy(dataItemsGroup.items, function (dataItemView) {
          return _.toNumber(_.replace(dataItemView.dataItem[sortProperty], ',', ''));
        });
        if (!ascending) {
          dataItemsGroup.items = _.reverse(dataItemsGroup.items);
        }
      } else {
        dataItemsGroup.items = _.orderBy(dataItemsGroup.items, 'dataItem.' + sortProperty, ascending ? 'asc' : 'desc');
      }
    });
    calculateOrdering();
    if (!_.isEqual(preSortedDataItemGroups, $scope.viewModel.dataItemsGroups)) {
      dataSetEditorModel.setUnsavedChanges($scope.viewModel.dataSetName, /*hasUnsavedChanges*/true);
      $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
    }
    $scope.timeLastModified = new Date().getTime();
  };
  $scope.onDataItemsGroupDeleteClicked = function (dataItemsGroupId) {
    var dataItemsGroupIndex = _.findIndex($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      return dataItemsGroup.id === dataItemsGroupId;
    });
    _.each($scope.viewModel.dataItemsGroups[dataItemsGroupIndex].items, function (dataItemView) {
      dataSetEditorModel.removeDataItem($stateParams.dataSetName, dataItemView.dataItem);
    });
    $scope.viewModel.dataItemsGroups.splice(dataItemsGroupIndex, 1);
    calculateOrdering();
    dataSetEditorModel.setUnsavedChanges($scope.viewModel.dataSetName, /*hasUnsavedChanges*/true);
    $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
  };
  $scope.onAddGroupClicked = function () {
    $scope.viewModel.dataItemsGroups.push({
      id: dataSetManagementUtil.generateUUID(),
      name: '',
      dataSetName: $stateParams.dataSetName,
      items: []
    });
    dataSetEditorModel.setUnsavedChanges($scope.viewModel.dataSetName, /*hasUnsavedChanges*/true);
    $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
  };
  $scope.onDataItemsGroupSelectedOrUnselected = function (dataItemsGroupId) {
    // Unselect all data items groups *other than* the group id passed in, also unselect all data items
    _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      if (dataItemsGroup.id !== dataItemsGroupId) {
        dataItemsGroup.selected = false;
      }
      _.each(dataItemsGroup.items, function (dataItemView) {
        dataItemView.selected = false;
      });
    });
  };
  $scope.onDataItemSelectedOrUnselected = function (dataItemsGroupId) {
    // Unselect all data items in groups *other than* the group id passed in, also unselect all data items groups
    _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      dataItemsGroup.selected = false;
      if (dataItemsGroup.id !== dataItemsGroupId) {
        _.each(dataItemsGroup.items, function (dataItemView) {
          dataItemView.selected = false;
        });
      }
    });
    $scope.timeLastModified = new Date().getTime();
  };
  $scope.handleDeleteKeyEventAction = function () {
    deleteSelectedDataItems();
    deleteSelectedDataItemsGroups();
  };
  $scope.onTextInputFocused = function () {
    // Whenever a text input is focused (from the dataItemsGroups, unselect *everything*
    _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      dataItemsGroup.selected = false;
      _.each(dataItemsGroup.items, function (dataItemView) {
        dataItemView.selected = false;
      });
    });
  };
  $scope.$on(configurationConstant.event.DATA_SET_ITEM_DRAG_DROP, function (event, dragDropConfiguration) {
    var dragDataItemsGroupId = dragDropConfiguration.dragDataItemsGroupId,
      dropDataItemId = dragDropConfiguration.dropDataItemId,
      dropDataItemsGroupId = dragDropConfiguration.dropDataItemsGroupId,
      type = dragDropConfiguration.type,
      dragDataItemsGroupIndex,
      dropDataItemIndex,
      dropDataItemsGroupIndex,
      dragDataItemIndex,
      dragDataItemsGroup,
      dragDataItemViews,
      dropDataItemsGroup,
      dataItemMoved;
    dragDataItemsGroupIndex = _.findIndex($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      return dataItemsGroup.id === dragDataItemsGroupId;
    });
    dragDataItemsGroup = $scope.viewModel.dataItemsGroups[dragDataItemsGroupIndex];
    // Find the dragged items
    dragDataItemViews = _.filter(dragDataItemsGroup.items, function (dataItemView) {
      return dataItemView.selected === true;
    });
    dragDataItemIndex = _.findIndex(dragDataItemsGroup.items, function (dataItemView) {
      return dataItemView.selected === true;
    });

    // Remove the dragged items
    dragDataItemsGroup.items = _.filter(dragDataItemsGroup.items, function (dataItemView) {
      return dataItemView.selected === false;
    });
    dropDataItemsGroupIndex = _.findIndex($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      return dataItemsGroup.id === dropDataItemsGroupId;
    });
    dropDataItemsGroup = $scope.viewModel.dataItemsGroups[dropDataItemsGroupIndex];
    dropDataItemIndex = _.findIndex(dropDataItemsGroup.items, function (dataItemView) {
      return dataItemView.id === dropDataItemId;
    });
    if (type === configurationConstant.dataSet.INSERT_AFTER) {
      dropDataItemIndex++;
    }
    dataItemMoved = dragDataItemIndex !== dropDataItemIndex;

    // Insert the dragged item
    _.each(dragDataItemViews, function (dataItemView) {
      dataItemView.groupId = dropDataItemsGroup.id;
      dataItemView.dataItem.grouping = dropDataItemsGroup.name;
      dropDataItemsGroup.items.splice(dropDataItemIndex++, 0, dataItemView);
    });
    calculateOrdering();
    if (dataItemMoved) {
      dataSetEditorModel.setUnsavedChanges($scope.viewModel.dataSetName, /*hasUnsavedChanges*/true);
      $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
    }
    $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEM_GROUP_SET_SHIFT_SELECT_PIVOT, _.first(dragDataItemViews));
    timeoutList.push($timeout(function () {
      $scope.timeLastModified = new Date().getTime();
    }, 0));
  });
  $scope.$on(configurationConstant.event.DATA_SET_ITEMS_GROUP_DRAG_DROP, function (event, dragDropConfiguration) {
    var dragDataItemsGroupId = dragDropConfiguration.dragDataItemsGroupId,
      dropDataItemsGroupId = dragDropConfiguration.dropDataItemsGroupId,
      type = dragDropConfiguration.type,
      dragDataItemsGroupIndex,
      dropDataItemsGroupIndex,
      dragDataItemsGroup;
    dragDataItemsGroupIndex = _.findIndex($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      return dataItemsGroup.id === dragDataItemsGroupId;
    });
    // Remove the dragged group
    dragDataItemsGroup = $scope.viewModel.dataItemsGroups.splice(dragDataItemsGroupIndex, 1)[0];
    dropDataItemsGroupIndex = _.findIndex($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      return dataItemsGroup.id === dropDataItemsGroupId;
    });
    if (type === configurationConstant.dataSet.INSERT_AFTER) {
      dropDataItemsGroupIndex++;
    }
    // Insert the dragged group
    $scope.viewModel.dataItemsGroups.splice(dropDataItemsGroupIndex, 0, dragDataItemsGroup);
    calculateOrdering();

    // check if the group moved to a new location
    if (dragDataItemsGroupIndex !== dropDataItemsGroupIndex) {
      dataSetEditorModel.setUnsavedChanges($scope.viewModel.dataSetName, /*hasUnsavedChanges*/true);
      $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
    }
    timeoutList.push($timeout(function () {
      $scope.timeLastModified = new Date().getTime();
    }, 0));
  });
  $scope.$on(configurationConstant.event.DATA_SET_EDITOR_MODEL_UPDATED, function (event, dataSetName) {
    var dataSet;
    if ($stateParams.dataSetName === dataSetName) {
      dataSet = dataSetEditorModel.getDataSet(dataSetName);
      buildDataItemsGroupings(dataSet);
    }
  });
  $scope.$watch('viewModel.dataItemsGroups', function (newVal, oldVal) {
    var isDataSetValid, dataSet;

    // Determine if "Apply Sorting" button should be enabled
    $scope.viewModel.isApplySortingEnabled = false;
    _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      // Remove invalid rows before evaluation
      var items = _.filter(dataItemsGroup.items, function (dataItemView) {
        return dataSetManagementUtil.isValidDataItemForEvaluation(dataItemView.dataItem);
      });
      if (items.length >= 2) {
        $scope.viewModel.isApplySortingEnabled = true;
        return false;
      }
    });
    calculateOrdering();
    validateDataSet();
  }, true);
  function validateDataSet() {
    var previousValid = dataSetEditorModel.isValid($scope.viewModel.dataSetName),
      isDataSetValid = validateGroups() && validateDataItems();
    if ($scope.viewModel.dataSetName) {
      dataSetEditorModel.setValid($scope.viewModel.dataSetName, isDataSetValid);
    }
    if (previousValid !== isDataSetValid) {
      $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
    }
  }

  // A group is invalid if is has the same name as another group
  function validateGroups() {
    var groupNameToIds = {},
      invalidGroupIds = [],
      isValid = true;
    _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      if (_.isNil(groupNameToIds[dataItemsGroup.name])) {
        groupNameToIds[dataItemsGroup.name] = [dataItemsGroup.id];
      } else {
        groupNameToIds[dataItemsGroup.name].push(dataItemsGroup.id);
      }
    });

    //Find the invalid group ids.
    _.each(groupNameToIds, function (groupIds) {
      if (groupIds.length > 1) {
        invalidGroupIds = invalidGroupIds.concat(groupIds);
      }
    });
    _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      var isDataItemGroupValid = !_.includes(invalidGroupIds, dataItemsGroup.id);
      isValid = isDataItemGroupValid && isValid;
      setValidity('dataItemsGroup', isDataItemGroupValid, dataItemsGroup.id);
    });
    return isValid;
  }

  // A data item is invalid if it is not the last data item in a group and has a duplicate name or value,
  // or an empty name or value.
  function validateDataItems() {
    var dataItemNameToViewIds = {},
      dataItemValueToViewIds = {},
      invalidDataItemViewIds = [],
      isValid = true;

    // Build map of name/value to ids
    _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      var lastDataItemView = _.last(dataItemsGroup.items);
      _.each(dataItemsGroup.items, function (dataItemView) {
        if (_.isEmpty(dataItemView.dataItem.name) || _.isEmpty(dataItemView.dataItem.value)) {
          if (lastDataItemView !== dataItemView) {
            invalidDataItemViewIds.push(dataItemView.id);
          } else if (!_.isEmpty(dataItemView.dataItem.name) || !_.isEmpty(dataItemView.dataItem.value) || !_.isNil(dataItemView.dataItem.defaultPrecedence)) {
            invalidDataItemViewIds.push(dataItemView.id);
          }
        }
        if (!_.isEmpty(dataItemView.dataItem.name)) {
          if (_.isNil(dataItemNameToViewIds[dataItemView.dataItem.name])) {
            dataItemNameToViewIds[dataItemView.dataItem.name] = [dataItemView.id];
          } else {
            dataItemNameToViewIds[dataItemView.dataItem.name].push(dataItemView.id);
          }
        }
        if (!_.isEmpty(dataItemView.dataItem.value)) {
          if (_.isNil(dataItemValueToViewIds[dataItemView.dataItem.value])) {
            dataItemValueToViewIds[dataItemView.dataItem.value] = [dataItemView.id];
          } else {
            dataItemValueToViewIds[dataItemView.dataItem.value].push(dataItemView.id);
          }
        }
      });
    });

    // Find the invalid dataItem ids.
    _.each(dataItemNameToViewIds, function (dataItemIds, dataItemName) {
      if (dataItemIds.length > 1 || _.isEmpty(dataItemName)) {
        invalidDataItemViewIds = invalidDataItemViewIds.concat(dataItemIds);
      }
    });
    _.each(dataItemValueToViewIds, function (dataItemIds, dataItemValue) {
      if (dataItemIds.length > 1 || _.isEmpty(dataItemValue)) {
        invalidDataItemViewIds = invalidDataItemViewIds.concat(dataItemIds);
      }
    });
    _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      _.each(dataItemsGroup.items, function (dataItemView) {
        var isDataItemValid = !_.includes(invalidDataItemViewIds, dataItemView.id);
        isValid = isDataItemValid && isValid;
        setValidity('dataItem', isDataItemValid, dataItemsGroup.id, dataItemView.id);
      });
    });
    return isValid;
  }
  function setValidity(errorKey, isValid, groupId, dataItemViewId) {
    var formController = $scope.dataItemsForm['dataItemsGroup' + groupId];
    if (formController && dataItemViewId) {
      formController = formController['dataItemView' + dataItemViewId];
    }
    if (formController) {
      formController.$setValidity(errorKey, isValid);
    }
  }
  function deleteSelectedDataItems() {
    _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      dataItemsGroup.items = _.filter(dataItemsGroup.items, function (dataItemView) {
        var selected = dataItemView.selected;
        if (selected) {
          dataSetEditorModel.removeDataItem($stateParams.dataSetName, dataItemView.dataItem);
        }
        return !selected;
      });
    });
    calculateOrdering();
    $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEM_GROUP_SET_SHIFT_SELECT_PIVOT, {});
    dataSetEditorModel.setUnsavedChanges($scope.viewModel.dataSetName, /*hasUnsavedChanges*/true);
    $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
    timeoutList.push($timeout(function () {
      $scope.timeLastModified = new Date().getTime();
    }, 0));
  }
  ;
  function deleteSelectedDataItemsGroups() {
    var dataItemsGroup = _.find($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      return dataItemsGroup.selected;
    });
    if (!_.isNil(dataItemsGroup) && _.first($scope.viewModel.dataItemsGroups).id !== dataItemsGroup.id) {
      // Don't allow the first group to be deleted
      $scope.onDataItemsGroupDeleteClicked(dataItemsGroup.id);
      timeoutList.push($timeout(function () {
        $scope.timeLastModified = new Date().getTime();
      }, 0));
    }
  }
  ;
  function calculateOrdering() {
    var ordering = 0;

    // Make sure the 'ordering' of each data item is updated properly
    _.each($scope.viewModel.dataItemsGroups, function (dataItemsGroup) {
      _.each(dataItemsGroup.items, function (dataItemView) {
        dataItemView.dataItem.ordering = ordering++;
      });
    });
  }
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
  init();
};
DataItemsController.$inject = ["$rootScope", "$scope", "$stateParams", "$timeout", "$document", "localization", "dataSetType", "coreConstant", "dataSetManagementUtil", "dataItemSortingConstant", "configurationConstant", "dataSetEditorModel", "currentUserModel", "authorizationConstants"];
angular.module('ums.configuration').controller('dataItemsController', DataItemsController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2290:
/***/ (function(module, exports) {

/*@ngInject*/
var UIDeleteDataItemsAndGroupsDirective = function UIDeleteDataItemsAndGroupsDirective($rootScope, $document) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    function onKeydown(event) {
      if (event.keyCode === 46) {
        // Delete key
        $scope.handleDeleteKeyEventAction();
      }
    }
    $document.on('keydown.uiDeleteDataItemsAndGroups', onKeydown);
    $scope.$on('$destroy', function () {
      $document.off('keydown.uiDeleteDataItemsAndGroups', onKeydown);
    });
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
UIDeleteDataItemsAndGroupsDirective.$inject = ["$rootScope", "$document"];
angular.module('umCore').directive('uiDeleteDataItemsAndGroups', UIDeleteDataItemsAndGroupsDirective);

/***/ }),

/***/ 2291:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2292);
__webpack_require__(2293);
__webpack_require__(2294);
__webpack_require__(2295);
__webpack_require__(2296);
var DataItemsGroupComponent = {
  templateUrl: '/configuration/dataSetEditor/content/dataItems/dataItemsGroup/dataItemsGroup.tpl.html',
  controller: 'dataItemsGroupController',
  bindings: {
    datasetName: '<',
    dataitemsGroup: '<',
    isProductOrFieldDependent: '<',
    isDeleteEnabled: '<',
    notifyDeleteClick: '&',
    notifyDataItemsGroupSelectedOrUnselected: '&',
    notifyDataItemSelectedOrUnselected: '&',
    notifyTextInputFocused: '&',
    timeLastModified: '<',
    groupIndex: '<'
  }
};
angular.module('ums.configuration').component('dataitemsGroup', DataItemsGroupComponent);

/***/ }),

/***/ 2292:
/***/ (function(module) {

module.exports = JSON.parse("{\"dataItemsGroup\":{\"groupNamePlaceholder\":\"Enter a Group Name (optional)\",\"table\":{\"header\":{\"labelLabel\":\"Label\",\"valueLabel\":\"Value\",\"defaultValueLabel\":\"Set as Default Value\"},\"row\":{\"labelPlaceholder\":\"Enter Label\",\"valuePlaceholder\":\"Enter Value\",\"defaultValuePlaceholder\":\"Enter Priority\"}}}}");

/***/ }),

/***/ 2293:
/***/ (function(module, exports) {

var path = '/configuration/dataSetEditor/content/dataItems/dataItemsGroup/dataItemsGroup.tpl.html';
var html = "<div class=\"dataItemsGroupDragHandle\"\n     ng-mouseover=\"$ctrl.onDataItemsGroupDragHandleMouseOver()\"\n     ng-mouseleave=\"$ctrl.onDataItemsGroupDragHandleMouseLeave()\"\n     ng-mousedown=\"$ctrl.onDataItemsGroupDragHandleMouseDown($event)\"\n     ng-mouseup=\"$ctrl.onDataItemsGroupSelected($event)\">\n    <span class=\"glyphicon glyphicon-option-horizontal\"></span>\n</div>\n\n<div class=\"dataItemsGroupInnerContainer\"\n     group-id=\"{{$ctrl.groupIndex}}\">\n\n    <div class=\"dataItemsGroupHeader\">\n\n        <span class=\"dataItemsGroupName\">\n\n            <input type=\"text\"\n                   class=\"groupNameInput\"\n                   ng-model=\"$ctrl.dataitemsGroup.name\"\n                   ng-disabled=\"$ctrl.isReadOnly\"\n                   ng-blur=\"$ctrl.onGroupNameBlur($event)\"\n                   ng-focus=\"$ctrl.onTextInputFocused($event)\"\n                   ng-change=\"$ctrl.onDataItemChange()\"\n                   placeholder=\"{{ ::$ctrl.groupNamePlaceholder }}\">\n        </span>\n\n        <span ng-if=\"$ctrl.isDeleteEnabled && !$ctrl.isReadOnly\"\n              ng-click=\"$ctrl.onDeleteClicked()\"\n              class=\"glyphicon glyphicon-trash deleteGroup\"></span>\n    </div>\n\n    <div class=\"dataItemsGroupTable\">\n\n        <div class=\"dataItemsGroupTableHeader\">\n\n            <div class=\"dataItemsGroupTableHeaderCell dataItemsGroupTableHeaderLabel\"\n                 ui-translate>dataItemsGroup.table.header.labelLabel\n            </div>\n\n            <div class=\"dataItemsGroupTableHeaderCell dataItemsGroupTableHeaderValue\"\n                 ui-translate>dataItemsGroup.table.header.valueLabel\n            </div>\n\n            <div class=\"dataItemsGroupTableHeaderCell dataItemsGroupTableHeaderDefaultValue\"\n                 ng-if=\"$ctrl.isProductOrFieldDependent\"\n                 ui-translate>dataItemsGroup.table.header.defaultValueLabel\n            </div>\n        </div>\n\n        <div ng-form=\"dataItemView{{ dataItemView.id }}\"\n             class=\"dataItemsGroupTableRow\"\n             ng-class=\"{ selected: dataItemView.selected }\"\n             ng-repeat=\"dataItemView in $ctrl.dataitemsGroup.items\"\n             draggable=\"{{ dataItemView.draggable }}\"\n             row-id=\"{{$index}}\"\n             ui-data-item-drag-manager>\n\n            <div class=\"dataItemsGroupTableRowDragHandle\"\n                 ng-mouseover=\"$ctrl.onDataItemDragHandleMouseOver(dataItemView)\"\n                 ng-mouseleave=\"$ctrl.onDataItemDragHandleMouseLeave(dataItemView)\"\n                 ng-mousedown=\"$ctrl.onDataItemDragHandleMouseDown($event, dataItemView)\"\n                 ng-mouseup=\"$ctrl.onDataItemSelected($event, dataItemView)\">\n                <span class=\"glyphicon glyphicon-option-vertical\"></span>\n            </div>\n\n            <div class=\"dataItemsGroupTableRowCell dataItemsGroupTableRowLabel\">\n\n                <input type=\"text\"\n                       class=\"dataItemInputLabel\"\n                       ng-model=\"dataItemView.dataItem.name\"\n                       ng-disabled=\"$ctrl.isReadOnly\"\n                       ng-blur=\"$ctrl.onDataItemBlur($event, dataItemView)\"\n                       ng-focus=\"$ctrl.onTextInputFocused($event)\"\n                       ng-change=\"$ctrl.onDataItemChange()\"\n                       ui-enter=\"$ctrl.onDataItemBlur($event, dataItemView)\"\n                       placeholder=\"{{ ::$ctrl.dataItemLabelPlaceholder }}\"\n                       title=\"{{ dataItemView.labelTooltip }}\"\n                       tabindex=\"{{ $ctrl.groupIndex + ($index * 3) + 1 }}\"/>\n            </div>\n\n            <div class=\"dataItemsGroupTableRowCell dataItemsGroupTableRowValue\">\n\n                <input type=\"text\"\n                       class=\"dataItemInputValue\"\n                       ng-model=\"dataItemView.dataItem.value\"\n                       ng-disabled=\"$ctrl.isReadOnly\"\n                       ng-blur=\"$ctrl.onDataItemBlur($event, dataItemView)\"\n                       ng-focus=\"$ctrl.onTextInputFocused($event)\"\n                       ng-change=\"$ctrl.onDataItemChange()\"\n                       ui-enter=\"$ctrl.onDataItemBlur($event, dataItemView)\"\n                       placeholder=\"{{ ::$ctrl.dataItemValuePlaceholder }}\"\n                       title=\"{{ dataItemView.valueTooltip }}\"\n                       tabindex=\"{{ $ctrl.groupIndex + ($index * 3) + 2 }}\"/>\n            </div>\n\n            <div class=\"dataItemsGroupTableRowCell dataItemsGroupTableRowDefaultValue\"\n                 ng-if=\"$ctrl.isProductOrFieldDependent\">\n\n                <input type=\"number\"\n                       ng-model=\"dataItemView.dataItem.defaultPrecedence\"\n                       ng-disabled=\"$ctrl.isReadOnly\"\n                       ng-blur=\"$ctrl.onDataItemBlur($event, dataItemView)\"\n                       ng-focus=\"$ctrl.onTextInputFocused($event)\"\n                       ng-change=\"$ctrl.onDataItemChange()\"\n                       ui-enter=\"$ctrl.onDataItemBlur($event, dataItemView)\"\n                       placeholder=\"{{ ::$ctrl.dataItemDefaultValuePlaceholder }}\"\n                       tabindex=\"{{ $ctrl.groupIndex + ($index * 3) + 3 }}\"/>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2294:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DataItemsGroupController = function DataItemsGroupController($rootScope, $scope, $element, $timeout, localization, browserUtil, dataSetManagementUtil, uuidUtil, configurationConstant, dataSetEditorModel, currentUserModel, authorizationConstants) {
  $element.addClass('dataItemsGroup');
  localization.getTranslationByKey('dataItemsGroup').then(function (translations) {
    var shiftSelectPivotId = null,
      timeoutList = [];
    this.isReadOnly = !currentUserModel.hasAuthorization(authorizationConstants.MANAGE_DATASETS);
    this.init = function () {
      if (_.isNil(this.dataitemsGroup.items)) {
        this.dataitemsGroup.items = [];
      }
      this.groupNamePlaceholder = _.get(translations, 'groupNamePlaceholder');
      this.dataItemLabelPlaceholder = _.get(translations, 'table.row.labelPlaceholder');
      this.dataItemValuePlaceholder = _.get(translations, 'table.row.valuePlaceholder');
      this.dataItemDefaultValuePlaceholder = _.get(translations, 'table.row.defaultValuePlaceholder');
      this.buildTooltips();
      if (!this.isReadOnly) {
        this.addNewRowIfLastRowIsValid();
      }
    };
    this.buildTooltips = function () {
      _.each(this.dataitemsGroup.items, function (dataItemView) {
        if (!_.isNil(dataItemView.dataItem.name) && dataItemView.dataItem.name.length > 45) {
          dataItemView.labelTooltip = dataItemView.dataItem.name;
        } else {
          dataItemView.labelTooltip = '';
        }
        if (!_.isNil(dataItemView.dataItem.value) && dataItemView.dataItem.value.length > 45) {
          dataItemView.valueTooltip = dataItemView.dataItem.value;
        } else {
          dataItemView.valueTooltip = '';
        }
      });
    };
    this.addNewRowIfLastRowIsValid = function () {
      var emptyDataitems = this.dataitemsGroup.items.length === 0,
        lastRowIsValid = false,
        lastRow,
        dataItem;
      if (!emptyDataitems) {
        lastRow = _.last(this.dataitemsGroup.items);
        lastRowIsValid = dataSetManagementUtil.isValidDataItem(lastRow.dataItem);
      }
      if (emptyDataitems || lastRowIsValid) {
        dataItem = dataSetEditorModel.addDataItem(this.datasetName, this.dataitemsGroup.name);
        this.dataitemsGroup.items.push({
          id: dataSetManagementUtil.generateUUID(),
          groupId: this.dataitemsGroup.id,
          dataSetName: this.dataitemsGroup.dataSetName,
          dataItem: dataItem
        });
      }
    };
    this.removeEmptyLastRows = function () {
      var indexOfLastEmptyRow = -1,
        totalEmptyRows = 0;

      // Backwards-iterate through the data item views, removing the empty items from the model until we encounter a non-empty item
      // Store the total empties found along with the index of the last empty, for use below, splicing out the views
      _.forEachRight(this.dataitemsGroup.items, function (dataItemView, index) {
        var isEmptyDataItem = dataSetManagementUtil.isEmptyDataItem(dataItemView.dataItem);
        if (isEmptyDataItem) {
          indexOfLastEmptyRow = index;
          totalEmptyRows++;
          dataSetEditorModel.removeDataItem(this.datasetName, dataItemView.dataItem);
        } else {
          return false;
        }
      }.bind(this));
      this.dataitemsGroup.items.splice(indexOfLastEmptyRow, totalEmptyRows);
    };
    this.onDeleteClicked = function () {
      this.notifyDeleteClick();
    };
    this.onGroupNameBlur = function (event) {
      _.each(this.dataitemsGroup.items, function (dataItemView) {
        dataItemView.dataItem.grouping = this.dataitemsGroup.name;
      }.bind(this));
      if (this.currentFocusedValue !== event.currentTarget.value) {
        $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
      }
      this.buildTooltips();
    };
    this.onDataItemBlur = function (event, dataItemView) {
      var items = [];
      if (this.currentFocusedValue !== dataItemView.dataItem.value) {
        if (dataSetManagementUtil.isEmptyDataItem(dataItemView.dataItem)) {
          _.each(this.dataitemsGroup.items, function (itemView) {
            if (!dataSetManagementUtil.isEmptyDataItem(itemView.dataItem)) {
              items.push(itemView);
            }
          });
          this.dataitemsGroup.items = items;
        }
      }
      this.buildTooltips();
      this.removeEmptyLastRows();
      this.addNewRowIfLastRowIsValid();
    };
    this.onDataItemsGroupDragHandleMouseOver = function () {
      this.dataitemsGroup.draggable = true;
    };
    this.onDataItemsGroupDragHandleMouseLeave = function () {
      // Put this on a short timeout to allow for a drag to start if the drag is pulled and leaves the element before the
      // official drag start event fires.
      timeoutList.push($timeout(function () {
        this.dataitemsGroup.mouseDown = false;
        this.dataitemsGroup.draggable = false;
      }.bind(this), 100));
    };
    this.onDataItemsGroupDragHandleMouseDown = function (event) {
      if (event.button === 0) {
        // Left click only
        this.dataitemsGroup.mouseDown = true;
      }
    };
    this.onDataItemsGroupSelected = function (event) {
      if (event.button === 0) {
        // Left click only
        if (event.ctrlKey) {
          this.dataitemsGroup.selected = !this.dataitemsGroup.selected;
        } else {
          this.dataitemsGroup.selected = true;
        }
        this.notifyDataItemsGroupSelectedOrUnselected();
      }
    };
    this.onDataItemDragHandleMouseOver = function (dataItemView) {
      var isValidDataItem = dataSetManagementUtil.isValidDataItemForEvaluation(dataItemView.dataItem);
      if (isValidDataItem) {
        dataItemView.draggable = true;
      }
    };
    this.onDataItemDragHandleMouseLeave = function (dataItemView) {
      // Put this on a short timeout to allow for a drag to start if the drag is pulled and leaves the element before the
      // official drag start event fires.
      timeoutList.push($timeout(function () {
        dataItemView.mouseDown = false;
        dataItemView.draggable = false;
      }.bind(this), 100));
    };
    this.onDataItemDragHandleMouseDown = function (event, dataItemView) {
      var isValidDataItem;
      if (event.button === 0) {
        // Left click only
        isValidDataItem = dataSetManagementUtil.isValidDataItemForEvaluation(dataItemView.dataItem);
        if (isValidDataItem) {
          dataItemView.mouseDown = true;
        }
      }
    };
    this.onDataItemSelected = function (event, dataItemView) {
      var isValidDataItem,
        shiftSelectPivot = null;
      if (event.button === 0) {
        // Left click only
        isValidDataItem = dataSetManagementUtil.isValidDataItemForEvaluation(dataItemView.dataItem);
        if (event.ctrlKey) {
          dataItemView.selected = !dataItemView.selected;
        } else if (event.shiftKey) {
          if (!_.isNil(shiftSelectPivotId)) {
            shiftSelectPivot = _.find(this.dataitemsGroup.items, function (dataItemView) {
              return dataItemView.id === shiftSelectPivotId;
            });
          }
          if (_.isNil(shiftSelectPivot)) {
            if (isValidDataItem) {
              dataItemView.selected = true;
              shiftSelectPivotId = dataItemView.id;
            }
          } else {
            if (dataItemView.dataItem.ordering < shiftSelectPivot.dataItem.ordering) {
              _.each(this.dataitemsGroup.items, function (itemView) {
                var isValid = dataSetManagementUtil.isValidDataItemForEvaluation(itemView.dataItem);
                if (isValid && itemView.dataItem.ordering >= dataItemView.dataItem.ordering && itemView.dataItem.ordering <= shiftSelectPivot.dataItem.ordering) {
                  itemView.selected = true;
                } else {
                  itemView.selected = false;
                }
              });
            } else if (dataItemView.dataItem.ordering > shiftSelectPivot.dataItem.ordering) {
              _.each(this.dataitemsGroup.items, function (itemView) {
                var isValid = dataSetManagementUtil.isValidDataItemForEvaluation(itemView.dataItem);
                if (isValid && itemView.dataItem.ordering >= shiftSelectPivot.dataItem.ordering && itemView.dataItem.ordering <= dataItemView.dataItem.ordering) {
                  itemView.selected = true;
                } else {
                  itemView.selected = false;
                }
              });
            } else {
              _.each(this.dataitemsGroup.items, function (itemView) {
                itemView.selected = false;
              });
              dataItemView.selected = true;
            }
          }
        } else {
          if (isValidDataItem) {
            _.each(this.dataitemsGroup.items, function (itemView) {
              itemView.selected = false;
            });
            dataItemView.selected = true;
            shiftSelectPivotId = dataItemView.id;
          }
        }
        this.notifyDataItemSelectedOrUnselected();
      }
    };
    this.onTextInputFocused = function (event) {
      this.currentFocusedValue = event.currentTarget.value;
      this.notifyTextInputFocused();
    };
    this.onDataItemChange = function () {
      var previouslyUnsaved = dataSetEditorModel.hasUnsavedChanges(this.datasetName);
      // no need to broadcast more than once, otherwise event will broadcast on every key stroke
      if (!previouslyUnsaved) {
        dataSetEditorModel.setUnsavedChanges(this.datasetName, /*hasUnsavedChanges*/true);
        $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
      }
    };
    this.$onChanges = function (changes) {
      var anyItemsSelected = _.some(this.dataitemsGroup.items, function (dataItemView) {
        return dataItemView.selected === true;
      });
      if (!anyItemsSelected) {
        shiftSelectPivotId = false;
      }
      this.removeEmptyLastRows();
      this.addNewRowIfLastRowIsValid();
    };
    $scope.$on(configurationConstant.event.DATA_SET_ITEMS_GROUP_DRAG_DROP_FROM_UNSELECTED_GROUP, function (event, data) {
      var mockMouseEvent;
      if (data.dataItemsGroupId === this.dataitemsGroup.id) {
        mockMouseEvent = {
          button: 0,
          ctrlKey: false,
          shiftKey: false
        };
        timeoutList.push($timeout(function () {
          this.onDataItemsGroupSelected(mockMouseEvent);
        }.bind(this), 0));
      }
    }.bind(this));
    $scope.$on(configurationConstant.event.DATA_SET_ITEM_DRAG_DROP_FROM_UNSELECTED_ROW, function (event, data) {
      var dataItemView, mockMouseEvent;
      if (data.dataItemsGroupId === this.dataitemsGroup.id) {
        dataItemView = _.find(this.dataitemsGroup.items, function (dataItemView) {
          return dataItemView.id === data.dataItemId;
        });
        mockMouseEvent = {
          button: 0,
          ctrlKey: false,
          shiftKey: false
        };
        timeoutList.push($timeout(function () {
          this.onDataItemSelected(mockMouseEvent, dataItemView);
        }.bind(this), 0));
      }
    }.bind(this));
    $scope.$on(configurationConstant.event.DATA_SET_ITEM_GROUP_SET_SHIFT_SELECT_PIVOT, function (event, dataItemView) {
      if (dataItemView.groupId === this.dataitemsGroup.id) {
        shiftSelectPivotId = dataItemView.id;
      } else {
        shiftSelectPivotId = null;
      }
    }.bind(this));
    $scope.$on('$destroy', function () {
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
    this.init();
  }.bind(this));
};
DataItemsGroupController.$inject = ["$rootScope", "$scope", "$element", "$timeout", "localization", "browserUtil", "dataSetManagementUtil", "uuidUtil", "configurationConstant", "dataSetEditorModel", "currentUserModel", "authorizationConstants"];
angular.module('ums.configuration').controller('dataItemsGroupController', DataItemsGroupController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2295:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIDataItemDragManagerDirective = function UIDataItemDragManagerDirective($rootScope, configurationConstant, dataSetEditorModel) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var element = $($elm),
      dataSetName = $scope.dataItemView.dataSetName,
      isTopDropAttempt,
      isBottomDropAttempt;
    function onDragStart(event) {
      var isDraggingDataItem = _.includes(event.target.classList, 'dataItemsGroupTableRow'),
        dataTransfer,
        dragDropConfiguration;
      if (isDraggingDataItem) {
        if ($scope.dataItemView.mouseDown) {
          dataTransfer = event.originalEvent.dataTransfer;
          dragDropConfiguration = {
            dragDataItemsGroupId: $scope.dataItemView.groupId
          };
          dataSetEditorModel.setDraggingDataItems(dataSetName, true);
          element.addClass('draggingDataItem');
          if (!$scope.dataItemView.selected) {
            $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEM_DRAG_DROP_FROM_UNSELECTED_ROW, {
              dataItemId: $scope.dataItemView.id,
              dataItemsGroupId: $scope.dataItemView.groupId
            });
          } else {
            $('.dataItemsGroupTableRow.selected').each(function (index, selectedItem) {
              $(selectedItem).addClass('draggingDataItem');
            });
          }

          // Disable pointer events on all data item cells in the UI to prevent issues
          $('.dataItemsGroupTableRowCell').each(function (index, selectedItem) {
            $(selectedItem).css('pointer-events', 'none');
          });
          dataTransfer.setData('text', JSON.stringify(dragDropConfiguration));
          dataTransfer.effectAllowed = 'move';
        } else {
          event.preventDefault();
        }
      }
    }
    function onDragOver(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        currentDropTarget = $(event.currentTarget),
        isElementBeingDragged = currentDropTarget.hasClass('draggingDataItem'),
        isDraggingDataItems = dataSetEditorModel.isDraggingDataItems(dataSetName),
        isLastChild = currentDropTarget.is(':last-child'),
        isFirstChild = currentDropTarget.is(':first-child'),
        moveAllowed = false,
        offsetY,
        halfheight;
      if (!isElementBeingDragged && isDraggingDataItems) {
        offsetY = event.offsetY;
        halfheight = currentDropTarget.height() / 2;
        isTopDropAttempt = offsetY < halfheight;
        isBottomDropAttempt = offsetY >= halfheight;
        currentDropTarget.removeClass('dragOverTopDataItem');
        currentDropTarget.removeClass('dragOverBottomDataItem');
        if (isTopDropAttempt) {
          currentDropTarget.addClass('dragOverTopDataItem');
          moveAllowed = true;
        } else if (isBottomDropAttempt && !isLastChild) {
          currentDropTarget.addClass('dragOverBottomDataItem');
          moveAllowed = true;
        }
        if (moveAllowed) {
          dataTransfer.dropEffect = 'move';
          event.preventDefault();
        }
      }
    }
    function onDragLeave(event) {
      var currentDropTarget = $(event.currentTarget);
      currentDropTarget.removeClass('dragOverTopDataItem');
      currentDropTarget.removeClass('dragOverBottomDataItem');
    }
    function onDrop(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        dragDropConfiguration = JSON.parse(dataTransfer.getData('text')),
        currentDropTarget = $(event.currentTarget),
        isDraggingDataItems = dataSetEditorModel.isDraggingDataItems(dataSetName);
      if (isDraggingDataItems) {
        handleDropOperation(currentDropTarget, dragDropConfiguration);
        event.preventDefault();
        return false;
      }
    }
    function handleDropOperation(currentDropTarget, dragDropConfiguration) {
      var takeAction = isTopDropAttempt || isBottomDropAttempt;
      element.removeClass('draggingDataItem');
      currentDropTarget.removeClass('dragOverTopDataItem');
      currentDropTarget.removeClass('dragOverBottomDataItem');
      if (takeAction) {
        dragDropConfiguration.dropDataItemId = $scope.dataItemView.id;
        dragDropConfiguration.dropDataItemsGroupId = $scope.dataItemView.groupId;
        if (isTopDropAttempt) {
          dragDropConfiguration.type = configurationConstant.dataSet.INSERT_BEFORE;
        } else if (isBottomDropAttempt) {
          dragDropConfiguration.type = configurationConstant.dataSet.INSERT_AFTER;
        }
        $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEM_DRAG_DROP, dragDropConfiguration);
      }
    }
    function onDragEnd() {
      element.removeClass('draggingDataItem');
      $('.dataItemsGroupTableRow.selected').each(function (index, selectedItem) {
        $(selectedItem).removeClass('draggingDataItem');
      });
      $('.dataItemsGroupTableRowCell').each(function (index, selectedItem) {
        $(selectedItem).css('pointer-events', 'auto');
      });
      dataSetEditorModel.setDraggingDataItems(dataSetName, false);
    }
    element.on('dragstart', onDragStart);
    element.on('dragover', onDragOver);
    element.on('dragleave', onDragLeave);
    element.on('drop', onDrop);
    element.on('dragend', onDragEnd);
    $scope.$on('$destroy', function () {
      element.off('dragstart', onDragStart);
      element.off('dragover', onDragOver);
      element.off('dragleave', onDragLeave);
      element.off('drop', onDrop);
      element.off('dragend', onDragEnd);
    });
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
UIDataItemDragManagerDirective.$inject = ["$rootScope", "configurationConstant", "dataSetEditorModel"];
angular.module('umCore').directive('uiDataItemDragManager', UIDataItemDragManagerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),

/***/ 2296:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIDataItemsGroupDragManagerDirective = function UIDataItemsGroupDragManagerDirective($rootScope, configurationConstant, dataSetEditorModel) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var element = $($elm),
      dataSetName = $scope.dataItemsGroup.dataSetName,
      isTopDropAttempt,
      isBottomDropAttempt;
    function onDragStart(event) {
      var isDraggingDataItemsGroup = _.includes(event.target.classList, 'dataItemsGroup'),
        dataTransfer,
        dragDropConfiguration;
      if (isDraggingDataItemsGroup) {
        if ($scope.dataItemsGroup.mouseDown) {
          dataTransfer = event.originalEvent.dataTransfer;
          dragDropConfiguration = {
            dragDataItemsGroupId: $scope.dataItemsGroup.id
          };
          dataSetEditorModel.setDraggingDataItemsGroup(dataSetName, true);
          element.addClass('draggingDataItemsGroup');
          if (!$scope.dataItemsGroup.selected) {
            $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_DRAG_DROP_FROM_UNSELECTED_GROUP, {
              dataItemsGroupId: $scope.dataItemsGroup.id
            });
          }

          // Disable pointer events on all data items groups in the UI to prevent issues
          $('.dataItemsGroupInnerContainer').each(function (index, selectedItem) {
            $(selectedItem).css('pointer-events', 'none');
          });
          dataTransfer.setData('text', JSON.stringify(dragDropConfiguration));
          dataTransfer.effectAllowed = 'move';
        } else {
          event.preventDefault();
        }
      }
    }
    function onDragOver(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        currentDropTarget = $(event.currentTarget),
        isElementBeingDragged = currentDropTarget.hasClass('draggingDataItemsGroup'),
        isDraggingDataItemsGroup = dataSetEditorModel.isDraggingDataItemsGroup(dataSetName),
        offsetY,
        halfheight;
      if (!isElementBeingDragged && isDraggingDataItemsGroup) {
        offsetY = event.offsetY;
        halfheight = currentDropTarget.height() / 2;
        isTopDropAttempt = offsetY < halfheight;
        isBottomDropAttempt = offsetY >= halfheight;
        currentDropTarget.removeClass('dragOverTopDataItemsGroup');
        currentDropTarget.removeClass('dragOverBottomDataItemsGroup');
        if (isTopDropAttempt) {
          currentDropTarget.addClass('dragOverTopDataItemsGroup');
        } else if (isBottomDropAttempt) {
          currentDropTarget.addClass('dragOverBottomDataItemsGroup');
        }
        dataTransfer.dropEffect = 'move';
        event.preventDefault();
      }
    }
    function onDragLeave(event) {
      var currentDropTarget = $(event.currentTarget);
      currentDropTarget.removeClass('dragOverTopDataItemsGroup');
      currentDropTarget.removeClass('dragOverBottomDataItemsGroup');
    }
    function onDrop(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        dragDropConfiguration = JSON.parse(dataTransfer.getData('text')),
        currentDropTarget = $(event.currentTarget),
        isDraggingDataItemsGroup = dataSetEditorModel.isDraggingDataItemsGroup(dataSetName);
      if (isDraggingDataItemsGroup) {
        handleDropOperation(currentDropTarget, dragDropConfiguration);
        event.preventDefault();
        return false;
      }
    }
    function handleDropOperation(currentDropTarget, dragDropConfiguration) {
      var takeAction = isTopDropAttempt || isBottomDropAttempt;
      element.removeClass('draggingDataItemsGroup');
      currentDropTarget.removeClass('dragOverTopDataItemsGroup');
      currentDropTarget.removeClass('dragOverBottomDataItemsGroup');
      if (takeAction) {
        dragDropConfiguration.dropDataItemsGroupId = $scope.dataItemsGroup.id;
        if (isTopDropAttempt) {
          dragDropConfiguration.type = configurationConstant.dataSet.INSERT_BEFORE;
        } else if (isBottomDropAttempt) {
          dragDropConfiguration.type = configurationConstant.dataSet.INSERT_AFTER;
        }
        $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_DRAG_DROP, dragDropConfiguration);
      }
    }
    function onDragEnd() {
      element.removeClass('draggingDataItemsGroup');
      $('.dataItemsGroupInnerContainer').each(function (index, selectedItem) {
        $(selectedItem).css('pointer-events', 'auto');
      });
      dataSetEditorModel.setDraggingDataItemsGroup(dataSetName, false);
    }
    element.on('dragstart', onDragStart);
    element.on('dragover', onDragOver);
    element.on('dragleave', onDragLeave);
    element.on('drop', onDrop);
    element.on('dragend', onDragEnd);
    $scope.$on('$destroy', function () {
      element.off('dragstart', onDragStart);
      element.off('dragover', onDragOver);
      element.off('dragleave', onDragLeave);
      element.off('drop', onDrop);
      element.off('dragend', onDragEnd);
    });
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
UIDataItemsGroupDragManagerDirective.$inject = ["$rootScope", "configurationConstant", "dataSetEditorModel"];
angular.module('umCore').directive('uiDataItemsGroupDragManager', UIDataItemsGroupDragManagerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),

/***/ 2297:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DynamicCriteriaController = function DynamicCriteriaController($rootScope, $scope, $stateParams, configurationConstant, dataSetType, dataSetEditorModel, dataSetManagementUtil, currentUserModel, authorizationConstants) {
  function init() {
    // UMS-20495 workaround
    try {
      $stateParams.dataSetName = decodeURIComponent($stateParams.dataSetName);
    } catch (exception) {
      // do nothing
    }
    var dataSet = dataSetEditorModel.getDataSet($stateParams.dataSetName);
    $scope.viewModel = {
      dataSet: dataSet,
      anyDependenciesSelected: false,
      isProductOrFieldDependentDynamicDataSet: parseInt($stateParams.type) === dataSetType.PRODUCT_FIELD_DEPENDENT,
      isCustomDynamicDataSet: parseInt($stateParams.type) === dataSetType.CUSTOM,
      isReadOnly: !currentUserModel.hasAuthorization(authorizationConstants.MANAGE_DATASETS)
    };
    if (!$scope.viewModel.isReadOnly) {
      addNewSourceFieldDependencyIfLastIsValid();
    }
    updateDependenciesSelected();
  }
  function removeInvalidSourceFieldDependencies() {
    var dataSet = dataSetEditorModel.getDataSet($stateParams.dataSetName);
    _.forEachRight(dataSet.dynamicDataSetDependency.sourceFieldDependencies, function (sourceFieldDependency) {
      var isValidSourceFieldDependency = dataSetManagementUtil.isValidSourceFieldDependency(sourceFieldDependency);
      if (!isValidSourceFieldDependency) {
        dataSetEditorModel.removeSourceFieldDependency($stateParams.dataSetName, sourceFieldDependency);
      }
    });
  }
  function addNewSourceFieldDependencyIfLastIsValid() {
    var dataSet = dataSetEditorModel.getDataSet($stateParams.dataSetName),
      lastSourceFieldDependencyIsValid = false,
      numberOfSourceFieldDependencies,
      noSourceFieldDependencies,
      lastSourceFieldDependency;
    if (!_.isNil(dataSet)) {
      numberOfSourceFieldDependencies = _.size(dataSet.dynamicDataSetDependency.sourceFieldDependencies);
      noSourceFieldDependencies = numberOfSourceFieldDependencies === 0;
      if (!noSourceFieldDependencies) {
        lastSourceFieldDependency = _.last(dataSet.dynamicDataSetDependency.sourceFieldDependencies);
        lastSourceFieldDependencyIsValid = dataSetManagementUtil.isValidSourceFieldDependency(lastSourceFieldDependency);
      }
      if (noSourceFieldDependencies || lastSourceFieldDependencyIsValid && numberOfSourceFieldDependencies < configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES) {
        dataSetEditorModel.addSourceFieldDependency($stateParams.dataSetName);
      }
    }
  }
  function updateDependenciesSelected() {
    var dataSet = dataSetEditorModel.getDataSet($stateParams.dataSetName),
      anyDependenciesSelected = false,
      sourceFieldDependencies,
      numberOfSourceFieldDependencies,
      firstSourceFieldDependency;
    if (!_.isNil(dataSet)) {
      sourceFieldDependencies = dataSet.dynamicDataSetDependency.sourceFieldDependencies;
      numberOfSourceFieldDependencies = _.size(sourceFieldDependencies);
      firstSourceFieldDependency = _.first(sourceFieldDependencies);
      if (dataSet.dynamicDataSetDependency.productDependent || numberOfSourceFieldDependencies > 1 || numberOfSourceFieldDependencies === 1 && dataSetManagementUtil.isValidSourceFieldDependency(firstSourceFieldDependency)) {
        anyDependenciesSelected = true;
      }
    }
    $scope.viewModel.anyDependenciesSelected = anyDependenciesSelected;
  }
  function handleDependencyChange() {
    dataSetEditorModel.setUnsavedChanges($stateParams.dataSetName, /*hasUnsavedChanges*/true);
    validateDependencies();
  }
  function validateDependencies() {
    var previousValid = dataSetEditorModel.isValidDependencies($stateParams.dataSetName),
      areDependenciesValid = true; // We currently have no necessary validation for dependencies, but if/when we do, the helper method can be called here.

    dataSetEditorModel.setValidDependencies($stateParams.dataSetName, areDependenciesValid);
    if (previousValid !== areDependenciesValid) {
      $rootScope.$broadcast(configurationConstant.event.DATA_SET_DEPENDENCIES_UPDATED);
    }
  }
  $scope.productDependentCheckboxChanged = function () {
    updateDependenciesSelected();
    handleDependencyChange();
  };
  $scope.$on(configurationConstant.event.DATA_SET_EDITOR_MODEL_UPDATED, function (event, dataSetName) {
    var dataSet;
    if ($stateParams.dataSetName === dataSetName) {
      dataSet = dataSetEditorModel.getDataSet(dataSetName);
      $scope.viewModel.dataSet = dataSet;
      if (!$scope.viewModel.isReadOnly) {
        addNewSourceFieldDependencyIfLastIsValid();
      }
      updateDependenciesSelected();
    }
  });
  $scope.$on(configurationConstant.event.DATA_SET_SOURCE_FIELD_DEPENDENCY_UPDATED, function () {
    removeInvalidSourceFieldDependencies();
    addNewSourceFieldDependencyIfLastIsValid();
    updateDependenciesSelected();
    handleDependencyChange();
  });
  init();
};
DynamicCriteriaController.$inject = ["$rootScope", "$scope", "$stateParams", "configurationConstant", "dataSetType", "dataSetEditorModel", "dataSetManagementUtil", "currentUserModel", "authorizationConstants"];
angular.module('ums.configuration').controller('dynamicCriteriaController', DynamicCriteriaController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2298:
/***/ (function(module) {

module.exports = JSON.parse("{\"dynamicCriteria\":{\"dependenciesLabel\":\"Dependencies\",\"productLabel\":\"Product\",\"message\":\"Choose a product or a form field dependency to add data item dependencies.\"}}");

/***/ }),

/***/ 2299:
/***/ (function(module, exports) {

var path = '/configuration/dataSetEditor/content/dynamicCriteria/dynamicCriteria.tpl.html';
var html = "<div class=\"dynamicCriteria\">\n\n    <div class=\"dependenciesOptionsContainer\">\n\n        <div class=\"dependenciesLabel\"\n             ui-translate>dynamicCriteria.dependenciesLabel\n        </div>\n\n        <div class=\"dependenciesProduct\">\n\n            <label class=\"dependenciesProductLabel\"\n                   ng-class=\"{ disabled: viewModel.isReadOnly }\">\n\n                <input type=\"checkbox\"\n                       class=\"dependenciesProductCheckbox\"\n                       ng-model=\"viewModel.dataSet.dynamicDataSetDependency.productDependent\"\n                       ng-change=\"productDependentCheckboxChanged()\"\n                       ng-disabled=\"viewModel.isReadOnly\"/>\n\n                <span ui-translate>dynamicCriteria.productLabel</span>\n            </label>\n        </div>\n\n        <source-field-dependency ng-repeat=\"sourceFieldDependency in viewModel.dataSet.dynamicDataSetDependency.sourceFieldDependencies\"\n                                 source-field-dependency=\"sourceFieldDependency\"></source-field-dependency>\n    </div>\n\n    <span class=\"staticText\"\n          ng-if=\"!viewModel.anyDependenciesSelected && viewModel.isProductOrFieldDependentDynamicDataSet\"\n          ui-translate>dynamicCriteria.message</span>\n\n    <dynamic-data-item-criterion\n        ng-if=\"viewModel.anyDependenciesSelected && viewModel.isProductOrFieldDependentDynamicDataSet\"\n        dataset-name=\"viewModel.dataSet.name\"></dynamic-data-item-criterion>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2300:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2301);
__webpack_require__(2302);
__webpack_require__(2303);
__webpack_require__(2304);
var DynamicDataItemCriterionComponent = {
  templateUrl: '/configuration/dataSetEditor/content/dynamicCriteria/dynamicDataItemCriterion/dynamicDataItemCriterion.tpl.html',
  controller: 'dynamicDataItemCriterionController',
  bindings: {
    datasetName: '<'
  }
};
angular.module('ums.configuration').component('dynamicDataItemCriterion', DynamicDataItemCriterionComponent);

/***/ }),

/***/ 2301:
/***/ (function(module) {

module.exports = JSON.parse("{\"dynamicDataItemCriterion\":{\"table\":{\"header\":{\"dataItemsLabel\":\"Label\",\"productDependencyLabel\":\"Product Dependency\",\"formFieldDependencyLabel\":\"Field\"},\"dataItemPlaceholder\":\"Select a data item\",\"productPlaceholder\":\"Select a product dependency\",\"dropdownValuePlaceholder\":\"Select a Value\",\"textValuePlaceholder\":\"Enter a Value\"}}}");

/***/ }),

/***/ 2302:
/***/ (function(module, exports) {

var path = '/configuration/dataSetEditor/content/dynamicCriteria/dynamicDataItemCriterion/dynamicDataItemCriterion.tpl.html';
var html = "<div class=\"dynamicDataItemCriterionContainer\"\n     ui-delete-dynamic-criteria>\n\n    <div class=\"dynamicDataItemCriterionTable\">\n\n        <div class=\"dynamicDataItemCriterionTableHeader\">\n\n            <div class=\"dynamicDataItemCriterionTableHeaderCell dynamicDataItemCriterionTableHeaderDataItems\">\n\n                <div class=\"dynamicDataItemCriterionTableHeaderCellContents\">\n\n                    <div class=\"dynamicDataItemCriterionTableHeaderCellSortInteractContents\"\n                         ng-class=\"{ sorted: $ctrl.sort === 'value' }\"\n                         ng-click=\"$ctrl.changeSort('value')\">\n\n                        <span ui-translate>dynamicDataItemCriterion.table.header.dataItemsLabel</span>\n                        <span ng-if=\"$ctrl.sort === 'value' && !$ctrl.sortAsc\"\n                              class=\"glyphicon glyphicon-chevron-down\"></span>\n                        <span ng-if=\"$ctrl.sort === 'value' && $ctrl.sortAsc\"\n                              class=\"glyphicon glyphicon-chevron-up\"></span>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"dynamicDataItemCriterionTableHeaderCell dynamicDataItemCriterionTableHeaderProductDependency\"\n                 ng-if=\"$ctrl.dataSet.dynamicDataSetDependency.productDependent\">\n\n                <div class=\"dynamicDataItemCriterionTableHeaderCellContents\">\n\n                    <div class=\"dynamicDataItemCriterionTableHeaderCellSortInteractContents\"\n                         ng-class=\"{ sorted: $ctrl.sort === 'productName' }\"\n                         ng-click=\"$ctrl.changeSort('productName')\">\n\n                        <span ui-translate>dynamicDataItemCriterion.table.header.productDependencyLabel</span>\n                        <span ng-if=\"$ctrl.sort === 'productName' && !$ctrl.sortAsc\"\n                              class=\"glyphicon glyphicon-chevron-down\"></span>\n                        <span ng-if=\"$ctrl.sort === 'productName' && $ctrl.sortAsc\"\n                              class=\"glyphicon glyphicon-chevron-up\"></span>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"dynamicDataItemCriterionTableHeaderCell dynamicDataItemCriterionTableHeaderFormFieldDependency\"\n                 ng-repeat=\"sourceFieldDependency in $ctrl.dataSet.dynamicDataSetDependency.sourceFieldDependencies | filter: $ctrl.filterSourceFieldDependencies\">\n\n                <div class=\"dynamicDataItemCriterionTableHeaderCellContents\">\n\n                    <div class=\"dynamicDataItemCriterionTableHeaderCellSortInteractContents\"\n                         ng-class=\"{ sorted: $ctrl.sort === 'fieldValue' + ($index + 1) }\"\n                         ng-click=\"$ctrl.changeSort('fieldValue' + ($index + 1))\">\n\n                        <div class=\"dynamicDataItemCriterionTableHeaderFormFieldDependencyFieldName\" ng-attr-title = \"{{sourceFieldDependency.fieldName}}\">\n\n                            <span class=\"fieldDependencyFieldName\">{{ sourceFieldDependency.fieldName }}</span>\n                            <span ng-if=\"$ctrl.sort === 'fieldValue' + ($index + 1) && !$ctrl.sortAsc\"\n                                  class=\"glyphicon glyphicon-chevron-down\"></span>\n                            <span ng-if=\"$ctrl.sort === 'fieldValue' + ($index + 1) && $ctrl.sortAsc\"\n                                  class=\"glyphicon glyphicon-chevron-up\"></span>\n                        </div>\n                    </div>\n\n                    <div class=\"dynamicDataItemCriterionTableHeaderFormFieldDependencyFieldIndex\">\n\n                        <span ui-translate>dynamicDataItemCriterion.table.header.formFieldDependencyLabel</span>\n                        <span>{{ $index + 1 }}</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"dynamicDataItemCriterionTableRow\"\n             ng-class=\"{ selected: dynamicDataItemCriteriaView.selected }\"\n             ng-repeat=\"dynamicDataItemCriteriaView in $ctrl.dynamicDataItemCriteriaViews\"\n             ng-init=\"rowIndex = $index\">\n\n            <div class=\"dynamicDataItemCriteriaSelectHandle\"\n                 ng-class=\"{ selectable: dynamicDataItemCriteriaView.selectable }\"\n                 ng-click=\"$ctrl.onDynamicDataItemCriteriaSelected($event, dynamicDataItemCriteriaView)\">\n                <span class=\"glyphicon glyphicon-option-vertical\"></span>\n            </div>\n\n            <div class=\"dynamicDataItemCriterionTableRowCell dynamicDataItemCriterionTableRowDataItems\">\n\n                <ui-select class=\"dynamicDataItemCriterionDropDown dropdownComponentSelect\"\n                           ng-class=\"{ disabled: $ctrl.isReadOnly }\"\n                           theme=\"select2\"\n                           ng-model=\"dynamicDataItemCriteriaView.dataItemDropdownSelectedValue\"\n                           ng-change=\"$ctrl.onDataItemChange($event, dynamicDataItemCriteriaView)\"\n                           ng-click=\"$ctrl.onDynamicCriteriaFocused()\"\n                           ng-disabled=\"$ctrl.isReadOnly\"\n                           placeholder=\"{{ $ctrl.isReadOnly ? '' : $ctrl.dataItemPlaceholder }}\"\n                           title=\"{{ dynamicDataItemCriteriaView.dataItemTooltip }}\"\n                           ui-hide-select-on-scroll\n                           ui-hide-select-on-scroll-selector=\".dataSetEditor .content\"\n                           search-enabled=\"false\">\n\n                    <ui-select-match placeholder=\"{{ $ctrl.isReadOnly ? '' : $ctrl.dataItemPlaceholder }}\"\n                                     allow-clear=\"true\">\n                        <span ng-bind=\"$select.selected.name\"></span>\n                    </ui-select-match>\n\n                    <ui-select-choices repeat=\"dataItem in $ctrl.dataSet.items | filter: $ctrl.filterDataItems\">\n                        <span ng-bind=\"dataItem.name\"></span>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n\n            <div class=\"dynamicDataItemCriterionTableRowCell dynamicDataItemCriterionTableRowProductDependency\"\n                 ng-if=\"$ctrl.dataSet.dynamicDataSetDependency.productDependent\">\n\n                <ui-select class=\"dynamicDataItemCriterionDropDown dropdownComponentSelect\"\n                           ng-class=\"{ disabled: $ctrl.isReadOnly }\"\n                           theme=\"select2\"\n                           ng-model=\"dynamicDataItemCriteriaView.productDropdownSelectedValue\"\n                           ng-change=\"$ctrl.onProductDependencyChange($event, dynamicDataItemCriteriaView)\"\n                           ng-click=\"$ctrl.onDynamicCriteriaFocused()\"\n                           ng-disabled=\"$ctrl.isReadOnly\"\n                           placeholder=\"{{ $ctrl.isReadOnly ? '' : $ctrl.productPlaceholder }}\"\n                           title=\"{{ dynamicDataItemCriteriaView.productTooltip }}\"\n                           ui-hide-select-on-scroll\n                           ui-hide-select-on-scroll-selector=\".dataSetEditor .content\"\n                           search-enabled=\"false\">\n\n                    <ui-select-match placeholder=\"{{ $ctrl.isReadOnly ? '' : $ctrl.productPlaceholder }}\"\n                                     allow-clear=\"true\">\n                        <span ng-bind=\"$select.selected.name\"></span>\n                    </ui-select-match>\n\n                    <ui-select-choices repeat=\"product in $ctrl.allProducts\">\n                        <span ng-bind=\"product.name\"></span>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n\n            <div class=\"dynamicDataItemCriterionTableRowCell dynamicDataItemCriterionTableRowFormFieldDependency\"\n                 ng-class=\"{ dropdownInput: $ctrl.sourceFieldDependencyDataSetItems[$index] }\"\n                 ng-repeat=\"sourceFieldDependency in $ctrl.dataSet.dynamicDataSetDependency.sourceFieldDependencies | filter: $ctrl.filterSourceFieldDependencies\">\n\n                <ui-select ng-if=\"$ctrl.sourceFieldDependencyDataSetItems[$index]\"\n                           class=\"dynamicDataItemCriterionDropDown dropdownComponentSelect\"\n                           ng-class=\"{ disabled: $ctrl.isReadOnly }\"\n                           theme=\"select2\"\n                           ng-model=\"dynamicDataItemCriteriaView.fieldValues[$index].dropdownSelectedValue\"\n                           ng-change=\"$ctrl.onFieldDependencyDropdownChange($event, dynamicDataItemCriteriaView, $index)\"\n                           ng-click=\"$ctrl.onDynamicCriteriaFocused()\"\n                           ng-disabled=\"$ctrl.isReadOnly\"\n                           placeholder=\"{{ $ctrl.isReadOnly ? '' : $ctrl.dropdownValuePlaceholder }}\"\n                           title=\"{{ dynamicDataItemCriteriaView.fieldValues[$index].tooltip }}\"\n                           ui-hide-select-on-scroll\n                           ui-hide-select-on-scroll-selector=\".dataSetEditor .content\"\n                           search-enabled=\"false\">\n\n                    <ui-select-match placeholder=\"{{ $ctrl.isReadOnly ? '' : $ctrl.dropdownValuePlaceholder }}\"\n                                     allow-clear=\"true\">\n                        <span ng-bind=\"$select.selected.name\"></span>\n                    </ui-select-match>\n\n                    <ui-select-choices repeat=\"dataItem in $ctrl.sourceFieldDependencyDataSetItems[$index]\">\n                        <span ng-bind=\"dataItem.name\"></span>\n                    </ui-select-choices>\n                </ui-select>\n\n                <input ng-if=\"!$ctrl.sourceFieldDependencyDataSetItems[$index]\"\n                       type=\"text\"\n                       ng-model=\"dynamicDataItemCriteriaView.fieldValues[$index].value\"\n                       ng-blur=\"$ctrl.onFieldDependencyTextInputBlur($event, dynamicDataItemCriteriaView, $index)\"\n                       ng-focus=\"$ctrl.onDynamicCriteriaFocused()\"\n                       ng-disabled=\"$ctrl.isReadOnly\"\n                       ui-enter=\"$ctrl.onFieldDependencyTextInputBlur($event)\"\n                       placeholder=\"{{ $ctrl.isReadOnly ? '' : $ctrl.textValuePlaceholder }}\"\n                       title=\"{{ dynamicDataItemCriteriaView.fieldValues[$index].tooltip }}\"\n                       tabindex=\"{{ (rowIndex * $ctrl.maxSourceFieldDependencies) + $index + 1 }}\"/>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2303:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DynamicDataItemCriterionController = function DynamicDataItemCriterionController($rootScope, $scope, $element, $q, $timeout, dataSetEditorModel, configurationConstant, dataSetManagementUtil, localization, coreMediator, configurationMediator, type, currentUserModel, authorizationConstants, dataSetType) {
  var timeoutList = [],
    shiftSelectPivotId = null;
  $element.addClass('dynamicDataItemCriterion');
  this.$onInit = function () {
    localization.getTranslationByKey('dynamicDataItemCriterion').then(function (translations) {
      this.dataItemPlaceholder = _.get(translations, 'table.dataItemPlaceholder');
      this.productPlaceholder = _.get(translations, 'table.productPlaceholder');
      this.dropdownValuePlaceholder = _.get(translations, 'table.dropdownValuePlaceholder');
      this.textValuePlaceholder = _.get(translations, 'table.textValuePlaceholder');
    }.bind(this));
    this.maxSourceFieldDependencies = configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES;
    this.isReadOnly = !currentUserModel.hasAuthorization(authorizationConstants.MANAGE_DATASETS);
    this.initializeCriteriaViewModel();
  };
  this.initializeCriteriaViewModel = function () {
    var promiseList = [];
    this.dataSet = dataSetEditorModel.getDataSet(this.datasetName);
    if (!_.isNil(this.dataSet)) {
      this.dynamicDataItemCriteriaViews = [];
      this.allProducts = [];
      this.sourceFieldDependencyDataSetItems = [];
      _.each(_.range(0, configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES), function () {
        this.sourceFieldDependencyDataSetItems.push(null);
      }.bind(this));
      promiseList.push(coreMediator.getDynamicDataSetItems({
        name: 'All Products'
      }).then(function (items) {
        this.allProducts = items;
      }.bind(this)));
      _.each(this.dataSet.dynamicDataSetDependency.sourceFieldDependencies, function (sourceFieldDependency, index) {
        promiseList.push(this.processSourceFieldDependency(sourceFieldDependency, index));
      }.bind(this));
      $q.all(promiseList).then(function () {
        _.each(this.dataSet.items, function (dataItem) {
          if (!_.isEmpty(dataItem.enhancedDynamicDataItemCriteriaList)) {
            _.each(dataItem.enhancedDynamicDataItemCriteriaList, function (dynamicDataItemCriteria) {
              var dataItemDropdownSelectedValue = _.find(this.dataSet.items, function (dataItem) {
                  return dynamicDataItemCriteria.value === dataItem.value;
                }),
                productDropdownSelectedValue = _.find(this.allProducts, function (product) {
                  return dynamicDataItemCriteria.productName === product.name;
                }),
                fieldValues = this.processFieldValues(dynamicDataItemCriteria),
                validDataItemDropdownSelectedValue = !_.isNil(dataItemDropdownSelectedValue),
                validProductDropdownSelectedValue = !_.isNil(productDropdownSelectedValue),
                dataItemTooltip = validDataItemDropdownSelectedValue ? dataItemDropdownSelectedValue.name : '',
                productTooltip = validProductDropdownSelectedValue ? productDropdownSelectedValue.name : '';
              this.dynamicDataItemCriteriaViews.push({
                id: dataSetManagementUtil.generateUUID(),
                selected: false,
                selectable: true,
                dataItemDropdownSelectedValue: dataItemDropdownSelectedValue,
                productDropdownSelectedValue: productDropdownSelectedValue,
                fieldValues: fieldValues,
                dataItemTooltip: dataItemTooltip,
                productTooltip: productTooltip,
                dynamicDataItemCriteria: dynamicDataItemCriteria
              });
            }.bind(this));
          }
        }.bind(this));
        this.sort = 'value';
        this.sortAsc = true;
        this.applySorting();
        if (!this.isReadOnly) {
          this.addNewRowIfLastRowIsValid();
        }
      }.bind(this));
    }
  };
  this.processSourceFieldDependency = function (sourceFieldDependency, index) {
    if (dataSetManagementUtil.isValidSourceFieldDependency(sourceFieldDependency)) {
      return configurationMediator.getFieldOptions(sourceFieldDependency.formTemplateUniqueName, sourceFieldDependency.fieldName).then(function (result) {
        var dataSetName;
        if (_.size(result) === 1) {
          result = result[0];
          dataSetName = result.dataSetName;
        }
        if (!_.isNil(dataSetName)) {
          return coreMediator.getCachedDataSetByName(dataSetName).then(function (dataSet) {
            if (dataSet.type === dataSetType.CUSTOM) {
              this.sourceFieldDependencyDataSetItems[index] = null;
            } else {
              this.sourceFieldDependencyDataSetItems[index] = dataSet.items;
            }
          }.bind(this));
        } else {
          this.sourceFieldDependencyDataSetItems[index] = null;
        }
      }.bind(this));
    } else {
      return $q.when();
    }
  };
  this.processFieldValues = function (dynamicDataItemCriteria) {
    var fieldValues = [];
    _.each(_.range(0, configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES), function (fieldValueIndex) {
      var fieldValue = dynamicDataItemCriteria['fieldValue' + (fieldValueIndex + 1)],
        dropdownSelectedValue,
        isValidDropdownSelectedValue;
      if (!_.isNil(this.sourceFieldDependencyDataSetItems[fieldValueIndex])) {
        dropdownSelectedValue = _.find(this.sourceFieldDependencyDataSetItems[fieldValueIndex], function (dataItem) {
          return fieldValue === dataItem.value;
        });
        isValidDropdownSelectedValue = !_.isNil(dropdownSelectedValue);
        fieldValues.push({
          dropdownSelectedValue: dropdownSelectedValue,
          tooltip: isValidDropdownSelectedValue ? dropdownSelectedValue.name : ''
        });
      } else {
        fieldValues.push({
          value: fieldValue,
          tooltip: fieldValue
        });
      }
    }.bind(this));
    return fieldValues;
  };
  this.removeInvalidRows = function () {
    this.dynamicDataItemCriteriaViews = _.filter(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView) {
      return dataSetManagementUtil.isValidDynamicDataItemCriteriaForEvaluation(dynamicDataItemCriteriaView.dynamicDataItemCriteria);
    });
  };
  this.addNewRowIfLastRowIsValid = function () {
    var emptyDynamicDataItemCriteriaViews = this.dynamicDataItemCriteriaViews.length === 0,
      lastRowIsValid = false,
      lastRow;
    if (!emptyDynamicDataItemCriteriaViews) {
      lastRow = _.last(this.dynamicDataItemCriteriaViews);
      lastRowIsValid = dataSetManagementUtil.isValidDynamicDataItemCriteriaForEvaluation(lastRow.dynamicDataItemCriteria);
    }
    if (emptyDynamicDataItemCriteriaViews || lastRowIsValid) {
      this.dynamicDataItemCriteriaViews.push({
        id: dataSetManagementUtil.generateUUID(),
        selected: false,
        selectable: false,
        dataItemDropdownSelectedValue: null,
        productDropdownSelectedValue: null,
        fieldValues: [],
        dataItemTooltip: '',
        productTooltip: '',
        dynamicDataItemCriteria: {
          dataSetName: this.datasetName,
          fieldValue1: null,
          fieldValue2: null,
          fieldValue3: null,
          ordering: 0,
          productName: null,
          value: null
        }
      });
    }
  };
  this.filterSourceFieldDependencies = function (sourceFieldDependency) {
    return dataSetManagementUtil.isValidSourceFieldDependency(sourceFieldDependency);
  };
  this.filterDataItems = function (dataItem) {
    return dataSetManagementUtil.isValidDataItem(dataItem);
  };
  this.handleDynamicCriteriaChange = function () {
    this.removeInvalidRows();
    _.each(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView) {
      dynamicDataItemCriteriaView.selectable = true;
    });
    this.addNewRowIfLastRowIsValid();
    dataSetEditorModel.setUnsavedChanges(this.datasetName, /*hasUnsavedChanges*/true);
    this.validateDynamicDataItemCriterion();
  };
  this.validateDynamicDataItemCriterion = function () {
    var previousValid = dataSetEditorModel.isValidDynamicCriterion(this.datasetName),
      areDynamicCriterionValid = true; // We currently have no necessary validation for dynamic data item criterion, but if/when we do, the helper method can be called here.

    dataSetEditorModel.setValidDynamicCriterion(this.datasetName, areDynamicCriterionValid);
    if (previousValid !== areDynamicCriterionValid) {
      $rootScope.$broadcast(configurationConstant.event.DATA_SET_DYNAMIC_CRITERIA_UPDATED);
    }
  };
  this.onDataItemChange = function (event, dynamicDataItemCriteriaView) {
    var dropdownSelectedValue = dynamicDataItemCriteriaView.dataItemDropdownSelectedValue,
      dataItemValue = !_.isNil(dropdownSelectedValue) ? dropdownSelectedValue.value : null,
      validDataItemDropdownSelectedValue = !_.isNil(dynamicDataItemCriteriaView.dataItemDropdownSelectedValue);
    dynamicDataItemCriteriaView.dataItemTooltip = validDataItemDropdownSelectedValue ? dynamicDataItemCriteriaView.dataItemDropdownSelectedValue.name : '';
    dataSetEditorModel.moveDynamicDataItemCriteria(this.datasetName, dynamicDataItemCriteriaView.dynamicDataItemCriteria, dataItemValue);
    if (this.sort === 'value') {
      this.changeSort('');
    }
    this.handleDynamicCriteriaChange();
  };
  this.onProductDependencyChange = function (event, dynamicDataItemCriteriaView) {
    var dropdownSelectedValue = dynamicDataItemCriteriaView.productDropdownSelectedValue,
      validProductDropdownSelectedValue = !_.isNil(dynamicDataItemCriteriaView.productDropdownSelectedValue);
    dynamicDataItemCriteriaView.productTooltip = validProductDropdownSelectedValue ? dynamicDataItemCriteriaView.productDropdownSelectedValue.name : '';
    dynamicDataItemCriteriaView.dynamicDataItemCriteria.productName = !_.isNil(dropdownSelectedValue) ? dropdownSelectedValue.name : null;
    if (this.sort === 'productName') {
      this.changeSort('');
    }
    this.handleDynamicCriteriaChange();
  };
  this.onFieldDependencyDropdownChange = function (event, dynamicDataItemCriteriaView, index) {
    var dropdownSelectedValue = dynamicDataItemCriteriaView.fieldValues[index].dropdownSelectedValue,
      value = !_.isNil(dropdownSelectedValue) ? dropdownSelectedValue.value : null,
      tooltip = !_.isNil(dropdownSelectedValue) ? dropdownSelectedValue.name : '';
    updateFieldDependencyModel(dynamicDataItemCriteriaView, index, value, tooltip);
    if (this.sort === 'fieldValue' + (index + 1)) {
      this.changeSort('');
    }
    this.handleDynamicCriteriaChange();
  };
  this.onFieldDependencyTextInputBlur = function (event, dynamicDataItemCriteriaView, index) {
    var value;
    if (!_.isNil(dynamicDataItemCriteriaView.fieldValues[index])) {
      value = dynamicDataItemCriteriaView.fieldValues[index].value;
      updateFieldDependencyModel(dynamicDataItemCriteriaView, index, value, /*tooltip*/value);
      if (this.sort === 'fieldValue' + (index + 1)) {
        this.changeSort('');
      }
      this.handleDynamicCriteriaChange();
    }
  };
  function updateFieldDependencyModel(dynamicDataItemCriteriaView, index, value, tooltip) {
    dynamicDataItemCriteriaView.dynamicDataItemCriteria['fieldValue' + (index + 1)] = _.isEmpty(value) ? null : value;
    dynamicDataItemCriteriaView.fieldValues[index].tooltip = tooltip;
  }
  this.changeSort = function (sortLabel) {
    if (this.sort === sortLabel) {
      this.sortAsc = !this.sortAsc;
    } else {
      this.sort = sortLabel;
      this.sortAsc = true;
    }
    this.applySorting();
  };
  this.applySorting = function () {
    if (!this.isReadOnly) {
      this.removeInvalidRows();
    }
    this.dynamicDataItemCriteriaViews = _.orderBy(this.dynamicDataItemCriteriaViews, 'dynamicDataItemCriteria.' + this.sort, this.sortAsc ? 'asc' : 'desc');
    if (!this.isReadOnly) {
      this.addNewRowIfLastRowIsValid();
    }

    // Update the transient view ordering property to allow for shift-select
    _.each(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView, index) {
      dynamicDataItemCriteriaView.ordering = index;
    });
  };
  this.onDynamicDataItemCriteriaSelected = function (event, dynamicDataItemCriteriaView) {
    var isValidDynamicDataItemCriteria,
      shiftSelectPivot = null;
    if (event.button === 0) {
      // Left click only
      isValidDynamicDataItemCriteria = dataSetManagementUtil.isValidDynamicDataItemCriteriaForEvaluation(dynamicDataItemCriteriaView.dynamicDataItemCriteria);
      if (event.ctrlKey) {
        dynamicDataItemCriteriaView.selected = !dynamicDataItemCriteriaView.selected;
      } else if (event.shiftKey) {
        if (!_.isNil(shiftSelectPivotId)) {
          shiftSelectPivot = _.find(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView) {
            return dynamicDataItemCriteriaView.id === shiftSelectPivotId;
          });
        }
        if (_.isNil(shiftSelectPivot)) {
          if (isValidDynamicDataItemCriteria) {
            dynamicDataItemCriteriaView.selected = true;
            shiftSelectPivotId = dynamicDataItemCriteriaView.id;
          }
        } else {
          if (dynamicDataItemCriteriaView.ordering < shiftSelectPivot.ordering) {
            _.each(this.dynamicDataItemCriteriaViews, function (itemView) {
              var isValid = dataSetManagementUtil.isValidDynamicDataItemCriteriaForEvaluation(itemView.dynamicDataItemCriteria);
              if (isValid && itemView.ordering >= dynamicDataItemCriteriaView.ordering && itemView.ordering <= shiftSelectPivot.ordering) {
                itemView.selected = true;
              } else {
                itemView.selected = false;
              }
            });
          } else if (dynamicDataItemCriteriaView.ordering > shiftSelectPivot.ordering) {
            _.each(this.dynamicDataItemCriteriaViews, function (itemView) {
              var isValid = dataSetManagementUtil.isValidDynamicDataItemCriteriaForEvaluation(itemView.dynamicDataItemCriteria);
              if (isValid && itemView.ordering >= shiftSelectPivot.ordering && itemView.ordering <= dynamicDataItemCriteriaView.ordering) {
                itemView.selected = true;
              } else {
                itemView.selected = false;
              }
            });
          } else {
            _.each(this.dynamicDataItemCriteriaViews, function (itemView) {
              itemView.selected = false;
            });
            dynamicDataItemCriteriaView.selected = true;
          }
        }
      } else {
        if (isValidDynamicDataItemCriteria) {
          _.each(this.dynamicDataItemCriteriaViews, function (itemView) {
            itemView.selected = false;
          });
          dynamicDataItemCriteriaView.selected = true;
          shiftSelectPivotId = dynamicDataItemCriteriaView.id;
        }
      }
    }
  };
  this.onDynamicCriteriaFocused = function () {
    _.each(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView) {
      dynamicDataItemCriteriaView.selected = false;
    });
    shiftSelectPivotId = null;
  };
  this.handleDeleteKeyEventAction = function () {
    timeoutList.push($timeout(function () {
      this.deleteSelectedDynamicCriteria();
    }.bind(this), 0));
  };
  this.deleteSelectedDynamicCriteria = function () {
    _.each(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView) {
      if (dynamicDataItemCriteriaView.selected) {
        // To delete a criteria, we remove all it's dependencies (except the data item it's associated with), and then 'move' it using the model
        // function, to trigger it to be unlinked from the model
        // We then trigger the usual code to cleanup the invalid rows.
        dynamicDataItemCriteriaView.dynamicDataItemCriteria.productName = null;
        _.each(_.range(1, configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES + 1), function (fieldValueIndex) {
          dynamicDataItemCriteriaView.dynamicDataItemCriteria['fieldValue' + fieldValueIndex] = null;
        });
        dataSetEditorModel.moveDynamicDataItemCriteria(this.datasetName, dynamicDataItemCriteriaView.dynamicDataItemCriteria, /*destinationDataItemValue*/null);
      }
    }.bind(this));
    this.handleDynamicCriteriaChange();
    shiftSelectPivotId = null;
  };
  $scope.$on(configurationConstant.event.DATA_SET_EDITOR_MODEL_UPDATED, function (event, dataSetName) {
    if (this.datasetName === dataSetName) {
      this.initializeCriteriaViewModel();
    }
  }.bind(this));
  $scope.$on(configurationConstant.event.DATA_SET_SOURCE_FIELD_DEPENDENCY_UPDATED, function () {
    var promiseList = [];
    _.each(this.dataSet.dynamicDataSetDependency.sourceFieldDependencies, function (sourceFieldDependency, index) {
      promiseList.push(this.processSourceFieldDependency(sourceFieldDependency, index));
    }.bind(this));
    $q.all(promiseList).then(function () {
      // Re-evaluate the 'fieldValues' view attached to each dynamicDataItemCriteriaView to make sure everything is still in sync
      _.each(this.dynamicDataItemCriteriaViews, function (dynamicDataItemCriteriaView) {
        dynamicDataItemCriteriaView.fieldValues = this.processFieldValues(dynamicDataItemCriteriaView.dynamicDataItemCriteria);
      }.bind(this));
    }.bind(this));
  }.bind(this));
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
};
DynamicDataItemCriterionController.$inject = ["$rootScope", "$scope", "$element", "$q", "$timeout", "dataSetEditorModel", "configurationConstant", "dataSetManagementUtil", "localization", "coreMediator", "configurationMediator", "type", "currentUserModel", "authorizationConstants", "dataSetType"];
angular.module('ums.configuration').controller('dynamicDataItemCriterionController', DynamicDataItemCriterionController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2304:
/***/ (function(module, exports) {

/*@ngInject*/
var UIDeleteDynamicCriteriaDirective = function UIDeleteDynamicCriteriaDirective($rootScope, $document) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    function onKeydown(event) {
      if (event.keyCode === 46) {
        // Delete key
        $scope.$ctrl.handleDeleteKeyEventAction();
      }
    }
    $document.on('keydown.uiDeleteDynamicCriteria', onKeydown);
    $scope.$on('$destroy', function () {
      $document.off('keydown.uiDeleteDynamicCriteria', onKeydown);
    });
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
UIDeleteDynamicCriteriaDirective.$inject = ["$rootScope", "$document"];
angular.module('umCore').directive('uiDeleteDynamicCriteria', UIDeleteDynamicCriteriaDirective);

/***/ }),

/***/ 2305:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2306);
__webpack_require__(2307);
__webpack_require__(2308);
var SourceFieldDependencyComponent = {
  templateUrl: '/configuration/dataSetEditor/content/dynamicCriteria/sourceFieldDependency/sourceFieldDependency.tpl.html',
  controller: 'sourceFieldDependencyController',
  bindings: {
    sourceFieldDependency: '<'
  }
};
angular.module('ums.configuration').component('sourceFieldDependency', SourceFieldDependencyComponent);

/***/ }),

/***/ 2306:
/***/ (function(module) {

module.exports = JSON.parse("{\"sourceFieldDependency\":{}}");

/***/ }),

/***/ 2307:
/***/ (function(module, exports) {

var path = '/configuration/dataSetEditor/content/dynamicCriteria/sourceFieldDependency/sourceFieldDependency.tpl.html';
var html = "<div class=\"sourceFieldDependencyContainer\">\n    <ui-multi-step-selector-widget mode=\"$ctrl.formFieldDependenciesMode\"\n                                   step-1-item-name=\"$ctrl.sourceFieldDependency.formTemplateUniqueName\"\n                                   step-2-item-name=\"$ctrl.sourceFieldDependency.fieldName\"\n                                   is-disabled=\"$ctrl.isReadOnly\"></ui-multi-step-selector-widget>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2308:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SourceFieldDependencyController = function SourceFieldDependencyController($rootScope, $scope, $element, configurationConstant, currentUserModel, authorizationConstants) {
  $element.addClass('sourceFieldDependency');
  this.$onInit = function () {
    this.formFieldDependenciesMode = 'forms';
    this.isReadOnly = !currentUserModel.hasAuthorization(authorizationConstants.MANAGE_DATASETS);
  };
  $scope.$on(configurationConstant.event.SELECTOR_WIDGET_UPDATED, function (event, item1Name, item2) {
    if (_.isEmpty(item1Name) && _.isEmpty(item2)) {
      this.sourceFieldDependency.formTemplateUniqueName = '';
      this.sourceFieldDependency.fieldName = '';
    } else {
      this.sourceFieldDependency.formTemplateUniqueName = item1Name;
      this.sourceFieldDependency.fieldName = item2.fieldName;
    }
    $rootScope.$broadcast(configurationConstant.event.DATA_SET_SOURCE_FIELD_DEPENDENCY_UPDATED);
  }.bind(this));
};
SourceFieldDependencyController.$inject = ["$rootScope", "$scope", "$element", "configurationConstant", "currentUserModel", "authorizationConstants"];
angular.module('ums.configuration').controller('sourceFieldDependencyController', SourceFieldDependencyController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2309:
/***/ (function(module, exports) {

/*@ngInject*/
var RepeatingFormController = function RepeatingFormController() {};
angular.module('ums.configuration').controller('repeatingFormController', RepeatingFormController);

/***/ }),

/***/ 2310:
/***/ (function(module) {

module.exports = JSON.parse("{\"repeatingForm\":{\"message\":\"Repeating Form data sets are managed in the code.\"}}");

/***/ }),

/***/ 2311:
/***/ (function(module, exports) {

var path = '/configuration/dataSetEditor/content/repeatingForm/repeatingForm.tpl.html';
var html = "<div class=\"repeatingForm\">\n\n    <span class=\"staticText\"\n          ui-translate>repeatingForm.message</span>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2312:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DataSetReferencesController = function DataSetReferencesController($rootScope, $scope, $state, options, configurationMediator, localization, coreConstant, navigationStateModel) {
  localization.getTranslationsByKeys([this.translationsKey, 'dataSetReferences']).then(function (translations) {
    $scope.viewModel = {
      title: translations.title,
      okButton: options.deleteDataSet || options.modifyDataSet ? translations.yesButton : translations.okButton,
      cancelButton: options.deleteDataSet || options.modifyDataSet ? translations.cancelButton : '',
      dataSetReferenceList: null,
      dataSetParams: {
        key: 'name',
        sortType: 'asc'
      }
    };
    $scope.getType = function (type) {
      return _.get(translations, 'type.' + type);
    };
    $scope.onSort = function (event, params) {
      $scope.viewModel.dataSetParams = params;
      $scope.viewModel.dataSetReferenceList = _.orderBy($scope.viewModel.dataSetReferenceList, [params.key], [params.sortType]);
    };
    $scope.onConfirm = function () {
      $scope.$close({
        dataSetName: options.dataSetName
      });
    };
    $scope.onCancel = function () {
      $scope.$dismiss();
    };
    $scope.init = function () {
      configurationMediator.getDataSetReferences(options.dataSetName).then(function (result) {
        $scope.viewModel.dataSetReferenceList = _.orderBy(result, [$scope.viewModel.dataSetParams.key], [$scope.viewModel.dataSetParams.sortType]);
        if (options.deleteDataSet) {
          $scope.viewModel.dataSetReferencesMessage = _.replace(translations['dataSetReferencesFoundForDelete'], '{0}', result.length);
        } else if (options.modifyDataSet) {
          $scope.viewModel.dataSetReferencesMessage = _.replace(translations['dataSetReferencesFoundForModify'], '{0}', result.length);
        } else {
          $scope.viewModel.dataSetReferencesMessage = _.replace(translations['dataSetReferencesFound'], '{0}', result.length);
        }
        $scope.viewModel.dataSetReferencesMessage = _.replace($scope.viewModel.dataSetReferencesMessage, '{1}', '<b>' + options.dataSetName + '</b>');
      });
    };
    $scope.init();
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
DataSetReferencesController.$inject = ["$rootScope", "$scope", "$state", "options", "configurationMediator", "localization", "coreConstant", "navigationStateModel"];
angular.module('ums.configuration').controller('dataSetReferencesController', DataSetReferencesController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2313:
/***/ (function(module) {

module.exports = JSON.parse("{\"dataSetReferences\":{\"title\":\"Data Set References\",\"nameHeader\":\"Name\",\"typeHeader\":\"Type\",\"versionHeader\":\"Version\",\"dataSetReferencesFound\":\"Found {0} reference(s) for fields on Data set {1}.\",\"dataSetReferencesFoundForDelete\":\"Found {0} reference(s) for fields on data set {1}. Are you sure you want to delete this Data set?\",\"dataSetReferencesFoundForModify\":\"Found {0} reference(s) for fields on data set {1}. Are you sure you want to modify this Data set?\",\"yesButton\":\"Yes\",\"okButton\":\"OK\",\"cancelButton\":\"No\",\"type\":{\"2\":\"Field\",\"3\":\"Rule\"}}}");

/***/ }),

/***/ 2314:
/***/ (function(module, exports) {

var path = '/configuration/dataSetReferences/dataSetReferencesModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\"\n    ok-button-class=\"viewModel.buttonClass\">\n\n    <div ui-browser-detection class=\"modal-body\">\n\n        <div class=\"messageBox\">\n            <span ng-bind-html=\"viewModel.dataSetReferencesMessage\"></span>\n        </div>\n\n        <div class=\"referencesContainer\" ng-if=\"viewModel.dataSetReferenceList.length > 0\">\n\n            <div class=\"tableHeader\">\n                <div class=\"typeHeader\"\n                     ui-grid-sortable-header\n                     request-params=\"viewModel.dataSetParams\"\n                     item-name=\"type\"\n                     item-label=\"dataSetReferences.typeHeader\"\n                     on-toggle=\"onSort($event, params)\"></div>\n\n                <div class=\"nameHeader\"\n                     ui-grid-sortable-header\n                     request-params=\"viewModel.dataSetParams\"\n                     item-name=\"name\"\n                     item-label=\"dataSetReferences.nameHeader\"\n                     on-toggle=\"onSort($event, params)\"></div>\n\n                <div class=\"versionHeader\"\n                     ui-grid-sortable-header\n                     request-params=\"viewModel.dataSetParams\"\n                     item-name=\"version\"\n                     item-label=\"dataSetReferences.versionHeader\"\n                     on-toggle=\"onSort($event, params)\"></div>\n\n            </div>\n            <div class=\"dataSetTemplateTable\">\n                <div class=\"dataSetReferencesRow\" ng-repeat=\"dataSetReferences in viewModel.dataSetReferenceList\">\n                    <div class=\"typeColumn\">\n                        <span>{{getType(dataSetReferences.type)}}</span>\n                    </div>\n                    <div class=\"nameColumn\">\n                        <span>{{dataSetReferences.name}}</span>\n                    </div>\n                    <div class=\"versionColumn\">\n                        <span>{{dataSetReferences.version}}</span>\n                    </div>\n                </div>\n\n            </div>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2315:
/***/ (function(module) {

module.exports = JSON.parse("{\"dataSetSettings\":{\"newDataSetTitle\":\"Create New Data Set\",\"title\":\"Data Set Settings\",\"description\":\"Description\",\"type\":\"Type\",\"name\":\"Name\",\"saveButton\":\"Save\",\"cancelButton\":\"Cancel\",\"createDataSet\":\"Create New Data Set\",\"dynamicDefault\":\"Dynamic Default\",\"charactersLimit\":\"Minimum Characters Required to Search\",\"supportSearch\":\"Server-side Search\",\"generatorBeanName\":\"Generator Bean Name\",\"generatorBeanNamePlaceHolder\":\"Select a Generator Bean Name\",\"repeatingFormTemplateUniqueName\":\"Repeating Form Template\",\"repeatingFormTemplateUniqueNamePlaceHolder\":\"Select a Repeating Form Template\",\"static\":\"Static\",\"custom\":\"Custom\",\"repeatingForm\":\"Repeating Form\",\"productFieldDependent\":\"Product/Field Dependent\",\"enable\":\"Enable\",\"disable\":\"Disable\",\"savingDataSet\":\"Saving Data Set\",\"saveSucceeded\":\"Data Set Saved\",\"clearInvalidValueOnRegenerate\":\"Clear Invalid Value on Regenerate\",\"clearInvalidValueOnRegenerateTrue\":\"True\",\"clearInvalidValueOnRegenerateFalse\":\"False\"}}");

/***/ }),

/***/ 2316:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DataSetSettingsController = function DataSetSettingsController($scope, $state, $rootScope, $stateParams, $q, $uibModal, $uibModalInstance, authorizationConstants, dataSetEditorModel, configurationMediator, currentUserModel, coreConstant, dataSetType, loadingBarHandler, localization, navigationStateModel, modalOptions) {
  var translations;
  $scope.viewModel = {
    dataSetDefinition: {},
    originalDataSetDefinition: {},
    title: '',
    confirmButtonLabel: '',
    dataSetTypes: dataSetType,
    canManageDataSets: false,
    repeatingFormTemplateUniqueNameList: null,
    generatorDefinitionList: null,
    selectedGeneratorDefinition: null,
    generatorBeanNamePlaceHolder: '',
    repeatingFormTemplateUniqueNamePlaceHolder: '',
    defaultMinSearchStringLength: 3,
    isSubmitDisabled: false
  };
  $scope.viewModel.canManageDataSets = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_DATASETS);
  localization.getTranslationsByKeys(['dataSetSettings']).then(function (result) {
    translations = result;
    $scope.viewModel.title = _.isNil(modalOptions.existingDataSetName) ? translations.newDataSetTitle : translations.title;
    $scope.viewModel.confirmButtonLabel = _.isNil(modalOptions.existingDataSetName) ? translations.createDataSet : translations.saveButton;
    $scope.viewModel.generatorBeanNamePlaceHolder = translations.generatorBeanNamePlaceHolder;
    $scope.viewModel.repeatingFormTemplateUniqueNamePlaceHolder = translations.repeatingFormTemplateUniqueNamePlaceHolder;
  });
  function init() {
    if (!_.isNil(modalOptions.dataSet)) {
      $scope.viewModel.dataSetDefinition = modalOptions.dataSet;
      // set initial values on properties that are undefined to allow for proper equality comparison to determine if save button is enabled
      if (_.isNil($scope.viewModel.dataSetDefinition.description)) {
        // set to an empty string since input of a description will set to an empty string upon clearing an input
        // i.e. user starts to put in a description, but then decides to clear the input; then the description should be equivalent to when it started as "empty"
        $scope.viewModel.dataSetDefinition.description = '';
      }
      if (_.isUndefined($scope.viewModel.dataSetDefinition.dynamicDefault)) {
        $scope.viewModel.dataSetDefinition.dynamicDefault = null;
      }
      if (_.isUndefined($scope.viewModel.dataSetDefinition.generatorBeanName)) {
        $scope.viewModel.dataSetDefinition.generatorBeanName = null;
      }
      if (_.isUndefined($scope.viewModel.dataSetDefinition.repeatingFormTemplateUniqueName)) {
        $scope.viewModel.dataSetDefinition.repeatingFormTemplateUniqueName = null;
      }
      if (_.isUndefined($scope.viewModel.dataSetDefinition.supportSearch)) {
        $scope.viewModel.dataSetDefinition.supportSearch = false;
      }
      if (_.isUndefined($scope.viewModel.dataSetDefinition.clearInvalidFieldValue)) {
        $scope.viewModel.dataSetDefinition.clearInvalidFieldValue = true;
      }
      $scope.viewModel.originalDataSetDefinition = _.cloneDeep($scope.viewModel.dataSetDefinition);
      loadData().then(function () {
        $scope.viewModel.selectedGeneratorDefinition = _.find($scope.viewModel.generatorDefinitionList, function (generatorDefinition) {
          return generatorDefinition.beanName === modalOptions.dataSet.generatorBeanName;
        });
      });
    } else {
      $scope.viewModel.dataSetDefinition.type = dataSetType.STATIC;
      $scope.viewModel.dataSetDefinition.dynamicDefault = false;
      $scope.viewModel.dataSetDefinition.supportSearch = false;
      $scope.viewModel.dataSetDefinition.minSearchStringLength = $scope.viewModel.defaultMinSearchStringLength;
      $scope.viewModel.dataSetDefinition.clearInvalidFieldValue = true;
    }
  }
  function loadData() {
    var promiseList = [];
    if ($scope.viewModel.dataSetDefinition.type === dataSetType.CUSTOM || $scope.viewModel.dataSetDefinition.type === dataSetType.REPEATING_FORM || $scope.viewModel.dataSetDefinition.type === dataSetType.PRODUCT_FIELD_DEPENDENT) {
      promiseList.push(configurationMediator.getGeneratorDefinitions($scope.viewModel.dataSetDefinition.type).then(function (result) {
        $scope.viewModel.generatorDefinitionList = result;
      }));
    }
    if ($scope.viewModel.dataSetDefinition.type === dataSetType.REPEATING_FORM) {
      promiseList.push(configurationMediator.getRepeatingFormTemplateUniqueNames().then(function (result) {
        $scope.viewModel.repeatingFormTemplateUniqueNameList = result;
      }));
    }
    return $q.all(promiseList);
  }
  function saveSuccess(dataSet) {
    var navigationModel = {
      parentState: 'configuration.dataSetBrowser',
      currentState: 'configuration.dataSetEditor.dataItems',
      data: {
        dataSetName: dataSet.name,
        type: dataSet.type
      }
    };
    loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'saveSucceeded'));
    dataSetEditorModel.updateDataSet(dataSet);
    if (dataSet.type === dataSetType.REPEATING_FORM) {
      $state.go('configuration.dataSetEditor.repeatingForm', {
        dataSetName: dataSet.name,
        type: dataSet.type
      });
    } else {
      $state.go('configuration.dataSetEditor.dataItems', {
        dataSetName: dataSet.name,
        type: dataSet.type
      });
    }
    navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
    $uibModalInstance.close();
  }
  $scope.onSelectDataSetType = function () {
    $scope.viewModel.dataSetDefinition.generatorBeanName = null;
    $scope.viewModel.selectedGeneratorDefinition = null;
    $scope.viewModel.dataSetDefinition.repeatingFormTemplateUniqueName = null;
    if ($scope.viewModel.dataSetDefinition.type === dataSetType.STATIC) {
      $scope.viewModel.dataSetDefinition.dynamicDefault = null;
    } else {
      $scope.viewModel.dataSetDefinition.dynamicDefault = false;
    }
    loadData().then(function () {
      if ($scope.viewModel.dataSetDefinition.type === dataSetType.PRODUCT_FIELD_DEPENDENT) {
        $scope.viewModel.selectedGeneratorDefinition = _.find($scope.viewModel.generatorDefinitionList, function (generatorDefinition) {
          return generatorDefinition.beanName === 'enhancedDynamicDataSetGenerator';
        });
        $scope.viewModel.dataSetDefinition.generatorBeanName = 'enhancedDynamicDataSetGenerator';
      }
    });
  };
  $scope.onUpdateSelectedGeneratorDefinition = function () {
    $scope.viewModel.dataSetDefinition.generatorBeanName = $scope.viewModel.selectedGeneratorDefinition.beanName;
  };
  $scope.handleMinSearchStringLengthChange = function () {
    var isNegativeNumericValue = _.indexOf($scope.viewModel.dataSetDefinition.minSearchStringLength, '-') !== -1;
    if (isNegativeNumericValue) {
      $scope.viewModel.dataSetDefinition.minSearchStringLength = 1;
    }
    if ($scope.viewModel.dataSetDefinition.minSearchStringLength === '') {
      $scope.viewModel.dataSetDefinition.minSearchStringLength = $scope.viewModel.defaultMinSearchStringLength;
    }
    if (!_.isNumber($scope.viewModel.dataSetDefinition.minSearchStringLength)) {
      $scope.viewModel.dataSetDefinition.minSearchStringLength = _.parseInt($scope.viewModel.dataSetDefinition.minSearchStringLength);
    }
  };
  $scope.onConfirm = function () {
    $scope.viewModel.isSubmitDisabled = true;
    if (_.isNil(modalOptions.existingDataSetName)) {
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'savingDataSet'));
      configurationMediator.createDataSet($scope.viewModel.dataSetDefinition).then(saveSuccess, function () {
        // On Error
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
        $scope.viewModel.isSubmitDisabled = false;
      });
    } else {
      if (modalOptions.existingDataSetName !== $scope.viewModel.dataSetDefinition.name) {
        configurationMediator.getDataSetReferences(modalOptions.existingDataSetName).then(function (result) {
          if (result.length > 0) {
            var modalInstance = $uibModal.open({
              templateUrl: '/configuration/dataSetReferences/dataSetReferencesModal.tpl.html',
              controller: 'dataSetReferencesController',
              windowClass: 'dataSetReferencesModal',
              resolve: {
                options: function options() {
                  return {
                    dataSetName: modalOptions.existingDataSetName,
                    modifyDataSet: true
                  };
                }
              }
            });
            modalInstance.result.then(function () {
              updateDataSet();
            }, function () {
              $scope.viewModel.isSubmitDisabled = false;
            });
          } else {
            updateDataSet();
          }
        });
      } else {
        updateDataSet();
      }
    }
  };
  function updateDataSet() {
    loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'savingDataSet'));
    dataSetEditorModel.renameDataSet(modalOptions.existingDataSetName, $scope.viewModel.dataSetDefinition.name);
    if (!$scope.viewModel.dataSetDefinition.supportSearch) {
      $scope.viewModel.dataSetDefinition.minSearchStringLength = $scope.viewModel.defaultMinSearchStringLength;
    }
    configurationMediator.updateDataSet($scope.viewModel.dataSetDefinition, modalOptions.existingDataSetName).then(saveSuccess, function () {
      // on error
      loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
      $scope.viewModel.isSubmitDisabled = false;
    });
  }
  $scope.canEnableConfirmButton = function () {
    var typeIsNotNil = !_.isNil($scope.viewModel.dataSetDefinition.type),
      nameIsNotEmpty = !_.isEmpty($scope.viewModel.dataSetDefinition.name),
      dynamicDefaultIsNotNil = !_.isNil($scope.viewModel.dataSetDefinition.dynamicDefault),
      supportSearchIsNotNil = !_.isNil($scope.viewModel.dataSetDefinition.supportSearch),
      supportSearchFalseOrSupportSearchTrueAndMinSearchStringLengthNotEmpty = !$scope.viewModel.dataSetDefinition.supportSearch || _.isNumber($scope.viewModel.dataSetDefinition.minSearchStringLength),
      generatorBeanNameIsNotEmpty = !_.isEmpty($scope.viewModel.dataSetDefinition.generatorBeanName),
      clearInvalidFieldValueIsNotNil = !_.isNil($scope.viewModel.dataSetDefinition.clearInvalidFieldValue),
      repeatingFormTemplateUniqueNameIsNotEmpty = !_.isEmpty($scope.viewModel.dataSetDefinition.repeatingFormTemplateUniqueName),
      existingDataSet = !_.isNil(modalOptions.existingDataSetName);
    var canEnableConfirmButton = false,
      hasChanged = false;
    if (typeIsNotNil) {
      switch ($scope.viewModel.dataSetDefinition.type) {
        case dataSetType.STATIC:
          canEnableConfirmButton = typeIsNotNil && nameIsNotEmpty;
          break;
        case dataSetType.PRODUCT_FIELD_DEPENDENT:
        case dataSetType.CUSTOM:
          canEnableConfirmButton = typeIsNotNil && nameIsNotEmpty && dynamicDefaultIsNotNil && supportSearchIsNotNil && supportSearchFalseOrSupportSearchTrueAndMinSearchStringLengthNotEmpty && generatorBeanNameIsNotEmpty && clearInvalidFieldValueIsNotNil;
          break;
        case dataSetType.REPEATING_FORM:
          canEnableConfirmButton = typeIsNotNil && nameIsNotEmpty && dynamicDefaultIsNotNil && supportSearchIsNotNil && supportSearchFalseOrSupportSearchTrueAndMinSearchStringLengthNotEmpty && generatorBeanNameIsNotEmpty && clearInvalidFieldValueIsNotNil && repeatingFormTemplateUniqueNameIsNotEmpty;
          break;
      }
    }
    if (existingDataSet) {
      hasChanged = !_.isEqual($scope.viewModel.originalDataSetDefinition, $scope.viewModel.dataSetDefinition);
      canEnableConfirmButton = canEnableConfirmButton && hasChanged;
    }
    return canEnableConfirmButton;
  };
  $scope.$on('modal.closing', function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $scope.onCancel = function () {
    $uibModalInstance.close();
  };
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  init();
};
DataSetSettingsController.$inject = ["$scope", "$state", "$rootScope", "$stateParams", "$q", "$uibModal", "$uibModalInstance", "authorizationConstants", "dataSetEditorModel", "configurationMediator", "currentUserModel", "coreConstant", "dataSetType", "loadingBarHandler", "localization", "navigationStateModel", "modalOptions"];
angular.module('ums.configuration').controller('dataSetSettingsController', DataSetSettingsController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2317:
/***/ (function(module, exports) {

var path = '/configuration/dataSetSettings/dataSetSettingsTemplate.tpl.html';
var html = "<div class=\"dataSetSettings\">\n\n    <div class=\"modal-header\">\n        <h3 class=\"title\">{{::viewModel.title}}</h3>\n        <button class=\"close\"\n                ng-click=\"onCancel()\">\n            <span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </div>\n\n    <div ui-browser-detection class=\"modal-body\">\n\n        <div class=\"dataSetBox\">\n            <div class=\"leftBox\">\n\n                <div class=\"dataSetRow\">\n\n                    <div class=\"dataSetLabel\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.dataSetDefinition.name}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>dataSetSettings.name</span>\n                    </div>\n                    <input type=\"text\"\n                           class=\"name\"\n                           ng-disabled=\"!viewModel.canManageDataSets || viewModel.dataSetDefinition.required\"\n                           ng-model=\"viewModel.dataSetDefinition.name\"\n                           maxlength=\"1000\">\n                </div>\n\n                <div class=\"dataSetRow\">\n                    <div class=\"dataSetLabel\">\n                        <span ui-translate>dataSetSettings.description</span>\n                    </div>\n                    <textarea class=\"dataSetDescriptionTextArea\"\n                              ng-disabled=\"!viewModel.canManageDataSets\"\n                              ng-model=\"viewModel.dataSetDefinition.description\"\n                              maxlength=\"1000\">\n                    </textarea>\n                </div>\n            </div>\n\n            <!--rightBox-->\n            <div class=\"rightBox\">\n\n                <div class=\"dataSetRow\">\n                    <div class=\"dataSetLabel\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.dataSetDefinition.type}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>dataSetSettings.type</span>\n                    </div>\n\n                    <div class=\"radioButtonGroup\" ng-disabled=\"!viewModel.canManageDataSets\">\n                        <div class=\"dataSetTypeBox\">\n                            <input type=\"radio\"\n                                   class=\"staticDataSetItem\"\n                                   ng-value=\"::viewModel.dataSetTypes.STATIC\"\n                                   ng-model=\"viewModel.dataSetDefinition.type\"\n                                   ng-change=\"onSelectDataSetType()\">\n                            <span ui-translate>dataSetSettings.static</span>\n                        </div>\n                        <div class=\"dataSetTypeBox\">\n                            <input type=\"radio\"\n                                   class=\"customDataSetItem\"\n                                   ng-value=\"::viewModel.dataSetTypes.CUSTOM\"\n                                   ng-model=\"viewModel.dataSetDefinition.type\"\n                                   ng-change=\"onSelectDataSetType()\">\n                            <span ui-translate>dataSetSettings.custom</span>\n                        </div>\n                        <div class=\"dataSetTypeBox\">\n                            <input type=\"radio\"\n                                   class=\"repeatingFormDataSetItem\"\n                                   ng-value=\"::viewModel.dataSetTypes.REPEATING_FORM\"\n                                   ng-model=\"viewModel.dataSetDefinition.type\"\n                                   ng-change=\"onSelectDataSetType()\">\n                            <span ui-translate>dataSetSettings.repeatingForm</span>\n                        </div>\n                        <div class=\"dataSetTypeBox\">\n                            <input type=\"radio\"\n                                   class=\"productFieldDependentDataSetItem\"\n                                   ng-value=\"::viewModel.dataSetTypes.PRODUCT_FIELD_DEPENDENT\"\n                                   ng-model=\"viewModel.dataSetDefinition.type\"\n                                   ng-change=\"onSelectDataSetType()\">\n                            <span ui-translate>dataSetSettings.productFieldDependent</span>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"dataSetRow\" ng-if=\"viewModel.dataSetDefinition.type != viewModel.dataSetTypes.STATIC\">\n                    <div class=\"dataSetLabel\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.dataSetDefinition.dynamicDefault}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>dataSetSettings.dynamicDefault</span>\n                    </div>\n\n                    <div class=\"radioButtonGroup\" ng-disabled=\"!viewModel.canManageDataSets\">\n                        <input type=\"radio\"\n                               class=\"dynamicDefaultEnable\"\n                               ng-model=\"viewModel.dataSetDefinition.dynamicDefault\"\n                               ng-value=\"true\">\n                        <span ui-translate>dataSetSettings.enable</span>\n                        <input type=\"radio\"\n                               class=\"dynamicDefaultDisable\"\n                               ng-model=\"viewModel.dataSetDefinition.dynamicDefault\"\n                               ng-value=\"false\">\n                        <span ui-translate>dataSetSettings.disable</span>\n                    </div>\n                </div>\n\n\n                <div class=\"dataSetRow\" ng-if=\"viewModel.dataSetDefinition.type != viewModel.dataSetTypes.STATIC\">\n                    <div class=\"dataSetLabel\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.dataSetDefinition.supportSearch}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>dataSetSettings.supportSearch</span>\n                    </div>\n\n                    <div class=\"radioButtonGroup\" ng-disabled=\"!viewModel.canManageDataSets\">\n                        <input type=\"radio\"\n                               class=\"serverSideSearchEnable\"\n                               ng-model=\"viewModel.dataSetDefinition.supportSearch\"\n                               ng-value=\"true\">\n                        <span ui-translate>dataSetSettings.enable</span>\n                        <input type=\"radio\"\n                               class=\"serverSideSearchDisable\"\n                               ng-model=\"viewModel.dataSetDefinition.supportSearch\"\n                               ng-value=\"false\">\n                        <span ui-translate>dataSetSettings.disable</span>\n                    </div>\n                </div>\n\n                <div class=\"dataSetRow\"\n                     ng-if=\"viewModel.dataSetDefinition.type != viewModel.dataSetTypes.STATIC && viewModel.dataSetDefinition.supportSearch === true\">\n                    <div class=\"dataSetLabel\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.dataSetDefinition.minSearchStringLength}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>dataSetSettings.charactersLimit</span>\n                    </div>\n\n                    <input type=\"text\"\n                           ng-disabled=\"!viewModel.canManageDataSets\"\n                           ng-model=\"viewModel.dataSetDefinition.minSearchStringLength\"\n                           ng-change=\"handleMinSearchStringLengthChange()\"\n                           keypress-restrict=\"^$|[1-9][0-9]*$\"\n                           maxlength=\"2\">\n                </div>\n\n\n                <div class=\"dataSetRow\" ng-if=\"viewModel.dataSetDefinition.type != viewModel.dataSetTypes.STATIC\">\n                    <div class=\"dataSetLabel\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.dataSetDefinition.generatorBeanName}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>dataSetSettings.generatorBeanName</span>\n                    </div>\n\n                    <ui-select class=\"dropdownFormComponent dropdownComponentSelect generatorBeanName\"\n                               theme=\"select2\"\n                               ng-model=\"viewModel.selectedGeneratorDefinition\"\n                               ng-disabled=\"!viewModel.canManageDataSets\"\n                               ng-change=\"onUpdateSelectedGeneratorDefinition()\"\n                               append-to-body=\"true\">\n\n                        <ui-select-match placeholder=\"{{::viewModel.generatorBeanNamePlaceHolder}}\">\n                            <span>{{ $select.selected.label }}</span>\n                        </ui-select-match>\n\n                        <ui-select-choices\n                            repeat=\"item in (viewModel.generatorDefinitionList | filter: $select.search) track by $index\">\n                            <span>{{ item.label }}</span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n\n                <div class=\"dataSetRow\" ng-if=\"viewModel.dataSetDefinition.type != viewModel.dataSetTypes.STATIC\">\n                    <div class=\"dataSetLabel\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.dataSetDefinition.clearInvalidFieldValue}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>dataSetSettings.clearInvalidValueOnRegenerate</span>\n                    </div>\n                    <div class=\"radioButtonGroup\" ng-disabled=\"!viewModel.canManageDataSets\">\n                        <div class=\"clearInvalidValueOnRegenerate\">\n                            <input type=\"radio\"\n                                   ng-value=\"true\"\n                                   ng-model=\"viewModel.dataSetDefinition.clearInvalidFieldValue\">\n                            <span ui-translate>dataSetSettings.clearInvalidValueOnRegenerateTrue</span>\n                        </div>\n                        <div class=\"clearInvalidValueOnRegenerate\">\n                            <input type=\"radio\"\n                                   ng-value=\"false\"\n                                   ng-model=\"viewModel.dataSetDefinition.clearInvalidFieldValue\">\n                            <span ui-translate>dataSetSettings.clearInvalidValueOnRegenerateFalse</span>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"dataSetRow\" ng-if=\"viewModel.dataSetDefinition.type == viewModel.dataSetTypes.REPEATING_FORM\">\n                    <div class=\"dataSetLabel\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.dataSetDefinition.repeatingFormTemplateUniqueName}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>dataSetSettings.repeatingFormTemplateUniqueName</span>\n                    </div>\n\n                    <ui-select class=\"dropdownFormComponent dropdownComponentSelect repeatingFormTemplate\"\n                               theme=\"select2\"\n                               ng-model=\"viewModel.dataSetDefinition.repeatingFormTemplateUniqueName\"\n                               ng-disabled=\"!viewModel.canManageDataSets\"\n                               append-to-body=\"true\">\n\n                        <ui-select-match placeholder=\"{{::viewModel.repeatingFormTemplateUniqueNamePlaceHolder}}\">\n                            <span>{{ $select.selected }}</span>\n                        </ui-select-match>\n\n                        <ui-select-choices\n                            repeat=\"item in (viewModel.repeatingFormTemplateUniqueNameList | filter: $select.search) track by $index\">\n                            <span>{{ item }}</span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n\n            </div>\n\n        </div>\n    </div>\n\n\n    <!--Footer-->\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-success saveSettings\"\n                ng-click=\"onConfirm()\"\n                ng-disabled=\"!canEnableConfirmButton() || !viewModel.canManageDataSets || viewModel.isSubmitDisabled\">\n            <span>{{viewModel.confirmButtonLabel}}</span>\n        </button>\n        <button class=\"btn btn-default\"\n                ng-click=\"onCancel()\">\n            <span ui-translate>dataSetSettings.cancelButton</span>\n        </button>\n    </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2318:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2319);
__webpack_require__(2320);
__webpack_require__(2321);
__webpack_require__(2322);

/*@ngInject*/
var EmailNotificationBrowserController = function EmailNotificationBrowserController($rootScope, $scope, $timeout, $state, localization, coreConstant, configurationMediator, notificationPreferencesType, notificationPreferencesAction, modalUtil, navigationStateModel, configurationActionsUtil, databaseDownloadSectionName, emailStateModel) {
  localization.getTranslationByKey('emailNotificationBrowser').then(function (translations) {
    $scope.viewModel = {
      totalEmailNotifications: 0,
      recordCountText: _.get(translations, 'recordCountText'),
      recordsCountText: _.get(translations, 'recordsCountText'),
      isGridEmpty: true,
      totalEmailNotification: 0,
      requestParams: {
        key: 'name',
        startIndex: 0,
        pageSize: 25,
        sortType: 'asc',
        searchString: ''
      },
      searchPrompt: _.get(translations, 'searchPrompt'),
      shortDateTimeFormat: 'MM/dd/yy hh:mma'
    };
    $scope.actions = [];
    $scope.context = {
      identifier: 'emailNotificationBrowser',
      actions: {},
      fallthrough: null,
      model: {
        contextType: coreConstant.CONTEXT_NONE
      }
    };
    $scope.context.actions[coreConstant.CONTEXT_NONE] = '';
    function loadActions() {
      configurationMediator.loadEmailNotificationActions().then(function (actions) {
        var allActions = [];
        allActions.push({
          actions: actions.actions,
          contextType: $scope.context.model.contextType
        });
        $scope.actions = allActions;
        $scope.actionsTimeLastModified = new Date().getTime();
      });
    }
    ;
    function loadEmails() {
      $scope.viewModel.isLoading = true;
      configurationMediator.loadEmailNotification($scope.viewModel.requestParams).then(function (emailNotifications) {
        $scope.viewModel.emailNotifications = emailNotifications.records;
        $scope.viewModel.totalEmailNotification = emailNotifications.totalRecords;
        $scope.viewModel.isGridEmpty = $scope.viewModel.emailNotifications.length === 0;
        $timeout(function () {
          $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
          $scope.viewModel.isLoading = false;
        }, 0);
      });
      emailStateModel.saveViewState('configuration.emailBrowser', null);
      navigationStateModel.saveViewState('configuration.emailBrowser', null);
    }
    function checkPreviousViewState() {
      emailStateModel.restoreViewState($state.name, $scope.viewModel);
      loadEmails();
    }
    $scope.onPagingChange = function ($event, params) {
      $scope.viewModel.requestParams.startIndex = params.startIndex;
      emailStateModel.saveViewState('configuration.emailBrowser', null);
      loadEmails();
    };
    $scope.onSortChange = function (event, params) {
      $scope.viewModel.requestParams.key = params.key;
      $scope.viewModel.requestParams.sortType = params.sortType;
      emailStateModel.saveViewState('configuration.emailBrowser', null);
      loadEmails();
    };
    $scope.getStatus = function (item) {
      return item.enabled ? _.get(translations, 'status.active') : _.get(translations, 'status.inactive');
    };
    $scope.onSearchInputChange = _.debounce(function () {
      $scope.viewModel.requestParams.startIndex = 0;
      $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
      loadEmails();
    }, 200);
    $scope.onClearSearchTerm = function () {
      $scope.viewModel.requestParams.searchString = '';
      $scope.viewModel.requestParams.startIndex = 0;
      $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
      loadEmails();
    };
    $scope.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case notificationPreferencesAction.NEW_EMAIL:
            $state.go('configuration.manageEmail');
            break;
          case notificationPreferencesAction.BACKUP:
            configurationActionsUtil.backup(databaseDownloadSectionName.NOTIFICATION_EMAIL_TEMPLATES, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
    $scope.onClickRow = function (event, item) {
      var navigationModel = {
        parentState: 'configuration.emailBrowser',
        currentState: 'configuration.manageEmail',
        data: {
          templateId: item.id
        }
      };
      $state.go('configuration.manageEmail', {
        templateId: item.id
      });
      emailStateModel.saveViewState(navigationModel.parentState, $scope.viewModel);
      navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
    };
    $scope.$on('$destroy', function () {
      emailStateModel.saveViewState($state.name, $scope.viewModel);
    });
    loadActions();
    checkPreviousViewState();
  });
  $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
    $scope.$apply();
  });
};
EmailNotificationBrowserController.$inject = ["$rootScope", "$scope", "$timeout", "$state", "localization", "coreConstant", "configurationMediator", "notificationPreferencesType", "notificationPreferencesAction", "modalUtil", "navigationStateModel", "configurationActionsUtil", "databaseDownloadSectionName", "emailStateModel"];
angular.module('ums.configuration').controller('emailNotificationBrowserController', EmailNotificationBrowserController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2319:
/***/ (function(module) {

module.exports = JSON.parse("{\"emailNotificationBrowser\":{\"title\":\"Manage Emails\",\"actions\":{\"name\":\"Actions\",\"new email\":\"New Email\",\"backup\":\"Backup\"},\"columns\":{\"name\":\"Name\",\"status\":\"Status\",\"lastEditedBy\":\"Last Edited By\",\"lastModifiedDate\":\"Last Modified Date\"},\"status\":{\"active\":\"Active\",\"inactive\":\"Inactive\"},\"backup\":{\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\",\"name\":\"Email Templates\"},\"emptyGrid\":\"No matching Email\",\"recordCountText\":\"Showing startIndex to endIndex of total Email\",\"recordsCountText\":\"Showing startIndex to endIndex of total Emails\",\"searchPrompt\":\"Search name or message\"}}");

/***/ }),

/***/ 2320:
/***/ (function(module, exports, __webpack_require__) {

var path = '/configuration/emailNotification/emailNotificationBrowser.tpl.html';
var html = "<div class=\"emailNotificationBrowser\">\n    <div class=\"header\">\n        <div class=\"headerContent\">\n            <div class=\"headerLabel\" ui-translate>emailNotificationBrowser.title</div>\n\n            <action-buttons-bar context=\"context\"\n                                actions=\"actions\"\n                                notify-action-clicked=\"handleAction(action, file)\"\n                                time-last-modified=\"actionsTimeLastModified\"></action-buttons-bar>\n        </div>\n    </div>\n    <div class=\"tools\">\n        <div class=\"toolsContent\">\n            <div class=\"emailNotificationSearch\">\n            <span class=\"glyphicon glyphicon-search\"></span>\n                <input type=\"text\"\n                       ng-model=\"viewModel.requestParams.searchString\"\n                       placeholder=\"{{::viewModel.searchPrompt}}\"\n                       ng-change=\"onSearchInputChange()\"/>\n                <span class=\"glyphicon glyphicon-remove\"\n                   ng-if=\"viewModel.requestParams.searchString\"\n                   ng-click=\"onClearSearchTerm()\"></span>\n            </div>\n        </div>\n    </div>\n    <div class=\"grid\">\n        <div class=\"gridContainer\">\n            <div class=\"columnHeader\">\n                <div class=\"columnRow\">\n                    <div class=\"colHover\"></div>\n                    <div class=\"colName\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"name\"\n                         item-label=\"emailNotificationBrowser.columns.name\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                    <div class=\"colStatus\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"enabled\"\n                         item-label=\"emailNotificationBrowser.columns.status\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                    <div class=\"colLastEditedBy\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"lastModifiedBy\"\n                         item-label=\"emailNotificationBrowser.columns.lastEditedBy\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                    <div class=\"colLastModifiedDate\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"timeLastModified\"\n                         item-label=\"emailNotificationBrowser.columns.lastModifiedDate\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                </div>\n            </div>\n\n            <div class=\"datagrid table\"\n                 ux-datagrid=\"viewModel.emailNotifications\"\n                 ng-if=\"!viewModel.isLoading\"\n                 ui-scroll-detection\n                 ui-scroll-detection-target=\".columnHeader\">\n\n                <script type=\"template/html\"\n                        data-template-item=\"item\"\n                        data-template-name=\"default\">\n\n                    <div class=\"columnRow\">\n                        <div class=\"columnRowWrapper\">\n                            <div class=\"col colName\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.name }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.nameTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.nameTooltip\">{{ ::item.name }}</span>\n                            </div>\n                            <div class=\"col colStatus\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::getStatus(item) }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.statusTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.statusTooltip\">{{:: getStatus(item) }}</span>\n                            </div>\n                            <div class=\"col colLastEditedBy\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.lastModifiedBy.name }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.lastModifiedByTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.lastEditedByTooltip\">{{::item.lastModifiedBy.name}}</span>\n                            </div>\n                            <div class=\"col colLastModifiedDate\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.timeLastModified | date: viewModel.shortDateTimeFormat }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.timeLastModifiedTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.lastModifiedDateTooltip\">{{::item.timeLastModified | date: viewModel.shortDateTimeFormat }}</span>\n                            </div>\n                        </div>\n                    </div>\n                </script>\n            </div>\n\n            <ui-grid-paging-component\n                start-index=\"viewModel.requestParams.startIndex\"\n                page-size=\"viewModel.requestParams.pageSize\"\n                total-records=\"viewModel.totalEmailNotification\"\n                record-count-text=\"viewModel.recordCountText\"\n                records-count-text=\"viewModel.recordsCountText\"\n                on-change=\"onPagingChange($event, params)\"></ui-grid-paging-component>\n\n            <div class=\"gridEmpty\"\n                 ng-if=\"viewModel.isGridEmpty && !viewModel.isLoading\" ui-translate>emailNotificationBrowser.emptyGrid</div>\n\n            <div class=\"icon-spinner\"\n                 ng-if=\"viewModel.isLoading\">\n                <img src=\"" + __webpack_require__(52) + "\"/>\n            </div>\n        </div>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2321:
/***/ (function(module, exports) {

/*@ngInject*/
var EmailNotificationRepository = function EmailNotificationRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadEmailNotificationActions = function () {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.underwriting.notification.NotificationEmailTemplate'
        }
      };
    return this.get(url, config);
  };
  this.loadEmailNotification = function (requestParams) {
    var url = '/rest/NotificationEmailTemplate',
      config = {
        params: {
          sortBy: requestParams.key,
          sortDirection: requestParams.sortType,
          startIndex: requestParams.startIndex,
          numberOfRows: requestParams.pageSize,
          searchString: requestParams.searchString
        }
      };
    return this.get(url, config);
  };
  this.loadRecipients = function () {
    var url = '/rest/User/recipients';
    return this.get(url);
  };
};
EmailNotificationRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('emailNotificationRepository', EmailNotificationRepository);

/***/ }),

/***/ 2322:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var EmailStateModel = function EmailStateModel($state) {
  var stateModelStorage, templateId;
  this.init = function () {
    stateModelStorage = {};
    templateId = null;
  };
  this.saveViewState = function (stateName, stateModel) {
    stateModelStorage[stateName] = _.cloneDeep(stateModel);
  };
  this.restoreViewState = function (stateName, viewModel) {
    var previousState = stateModelStorage[stateName];
    if (previousState) {
      return _.merge(viewModel, previousState);
    }
  };
  this.init();
};
EmailStateModel.$inject = ["$state"];
angular.module('ums.configuration').service('emailStateModel', EmailStateModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2323:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2324);
__webpack_require__(2325);
__webpack_require__(2326);
__webpack_require__(2327);

/*@ngInject*/
var ManageEmailNotificationController = function ManageEmailNotificationController($scope, $rootScope, $stateParams, localization, configurationConstant, notificationPreferencesAction, notificationEmailTemplateRepository, notificationEmailTemplateModel, emailEditorConstant, configurationMediator, currentUserModel, authorizationConstants) {
  localization.getTranslations('manageEmailNotification').then(function (translations) {
    $scope.viewModel = {
      backButtonLabel: _.get(translations, 'backButtonLabel'),
      notificationPreferencesAction: notificationPreferencesAction,
      templateId: $stateParams.templateId,
      notificationEmailTemplate: {
        enabled: true,
        defaultSelectedOption: 'STANDARD',
        deletable: true
      },
      namePrompt: translations.manageEmailNotification.namePrompt,
      recipientList: [],
      isReadOnly: !currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_EMAIL),
      emailOptions: {
        email: {}
      }
    };
    if ($stateParams.templateId) {
      notificationEmailTemplateRepository.getNotificationEmailTemplate($stateParams.templateId).then(function (notificationEmailTemplate) {
        $scope.viewModel.notificationEmailTemplate = _.cloneDeep(notificationEmailTemplate);
        notificationEmailTemplateModel.reset();
        notificationEmailTemplateModel.notificationEmailTemplate = $scope.viewModel.notificationEmailTemplate;
        $scope.viewModel.emailOptions.email = $scope.viewModel.notificationEmailTemplate;
        if (!_.isNil($scope.viewModel.emailOptions.email.body)) {
          $scope.viewModel.emailOptions.email.body = $scope.viewModel.emailOptions.email.body.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;nbsp;/g, ' ');
        }
        _.each($scope.viewModel.emailOptions.email.to, function (item) {
          return item.valid = true;
        });
        _.each($scope.viewModel.emailOptions.email.cc, function (item) {
          return item.valid = true;
        });
        _.each($scope.viewModel.emailOptions.email.bcc, function (item) {
          return item.valid = true;
        });
        $rootScope.$broadcast(configurationConstant.event.EMAIL_TEMPLATE_UPDATED);
      });
    }
    configurationMediator.loadRecipients().then(function (recipients) {
      _.each(recipients['Submission Roles'], function (recipient) {
        recipient.grouping = 'Submission Roles';
        recipient.group = 'Submission Roles';
      });
      _.each(recipients['Carrier Users'], function (carrierRecipient) {
        carrierRecipient.grouping = 'Carrier Users';
        carrierRecipient.group = 'Carrier Users';
        carrierRecipient.name = carrierRecipient.firstName + ' ' + carrierRecipient.lastName;
      });
      var recipientList = recipients['Carrier Users'].concat(recipients['Submission Roles']);
      $rootScope.$broadcast(emailEditorConstant.event.PEOPLE_LIST_LOADED, recipientList);
    });
    notificationEmailTemplateModel.notificationEmailTemplate = $scope.viewModel.notificationEmailTemplate;
  });
  $scope.handleChange = function () {
    notificationEmailTemplateModel.hasUnsavedChanges = true;
    notificationEmailTemplateModel.isValid = isValid();
    $rootScope.$broadcast(configurationConstant.event.EMAIL_TEMPLATE_UPDATED);
  };
  function isValid() {
    var hasName = !_.isEmpty(notificationEmailTemplateModel.notificationEmailTemplate.name),
      hasStatus = notificationEmailTemplateModel.notificationEmailTemplate.enabled !== null,
      hasDefaultSelected = !_.isEmpty(notificationEmailTemplateModel.notificationEmailTemplate.defaultSelectedOption);
    var result = false; // we need to always return something if the method is intended to return something

    if (hasName && hasStatus && hasDefaultSelected) {
      result = true;
    }
    return result;
  }
  function getRecipient(recipients) {
    var recipientList = [];
    _.each(recipients, function (emailRecipient) {
      var recipient = {};
      if (!_.isNil(emailRecipient.emailAddress)) {
        if (emailRecipient.emailAddress.indexOf('@') > 0) {
          recipient.email = emailRecipient.emailAddress;
        } else {
          recipient.email = emailRecipient.emailAddress;
          recipient.role = emailRecipient.emailAddress;
        }
      } else {
        if (!_.isNil(emailRecipient.description)) {
          recipient.email = emailRecipient.description;
          recipient.role = emailRecipient.description;
        } else {
          recipient.email = emailRecipient.name;
        }
      }
      recipientList.push(recipient);
    });
    return recipientList;
  }
  $scope.$on(emailEditorConstant.event.EMAIL_UPDATE_COMPLETE, function (event, email, isEmailBodyChange) {
    if (!isEmailBodyChange || isEmailBodyChange && notificationEmailTemplateModel.notificationEmailTemplate.body !== email.body) {
      notificationEmailTemplateModel.hasUnsavedChanges = true;
      notificationEmailTemplateModel.isValid = isValid();
      $rootScope.$broadcast(configurationConstant.event.EMAIL_TEMPLATE_UPDATED);
    }
    notificationEmailTemplateModel.notificationEmailTemplate.to = getRecipient(email.to);
    notificationEmailTemplateModel.notificationEmailTemplate.bcc = getRecipient(email.bcc);
    notificationEmailTemplateModel.notificationEmailTemplate.cc = getRecipient(email.cc);
    notificationEmailTemplateModel.notificationEmailTemplate.subject = !_.isNil(email.subject) ? email.subject : '';
    notificationEmailTemplateModel.notificationEmailTemplate.body = !_.isNil(email.body) ? email.body : '';
    notificationEmailTemplateModel.notificationEmailTemplate.type = !_.isNil(email.type) ? email.type : '';
  });
};
ManageEmailNotificationController.$inject = ["$scope", "$rootScope", "$stateParams", "localization", "configurationConstant", "notificationPreferencesAction", "notificationEmailTemplateRepository", "notificationEmailTemplateModel", "emailEditorConstant", "configurationMediator", "currentUserModel", "authorizationConstants"];
angular.module('ums.configuration').controller('manageEmailNotificationController', ManageEmailNotificationController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2324:
/***/ (function(module) {

module.exports = JSON.parse("{\"manageEmailNotification\":{\"backButtonLabel\":\"Manage Email\",\"name\":\"Name\",\"namePrompt\":\"Email Name\",\"status\":\"Status\",\"statusValues\":{\"active\":\"Active\",\"inactive\":\"Inactive\"},\"defaultSelected\":\"Default Selected\",\"defaultSelectedValues\":{\"standard\":\"Standard\",\"custom\":\"Custom\",\"noEmail\":\"No Email\"},\"message\":\"Message\"}}");

/***/ }),

/***/ 2325:
/***/ (function(module, exports) {

var path = '/configuration/emailNotification/manageEmailNotification/manageEmailNotification.tpl.html';
var html = "<div class=\"manageEmailNotification\">\n    <!--Header-->\n    <div class=\"header\">\n        <ui-manage-email-notification-header\n            template-id=\"viewModel.templateId\">\n        </ui-manage-email-notification-header>\n    </div>\n\n    <div class=\"formContainer\">\n        <fieldset class=\"subContainer\">\n\n            <div class=\"content\">\n                <div>\n                    <div class=\"requiredRow\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.notificationEmailTemplate.name}}\">\n                        </ui-required-indicator>\n                        <div class=\"rowItem\">\n                            <span ui-translate>manageEmailNotification.name</span>\n                        </div>\n                        <input type=\"text\"\n                               ng-model=\"viewModel.notificationEmailTemplate.name\"\n                               ng-disabled=\"!viewModel.notificationEmailTemplate.deletable\"\n                               ng-change=\"handleChange()\"\n                               value=\"{{ viewModel.notificationEmailTemplate.name }}\"\n                               placeholder=\"{{::viewModel.namePrompt}}\"\n                               class=\"textInput emailNotificationName\">\n                    </div>\n\n                    <div class=\"requiredRow\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.notificationEmailTemplate.enabled!=null}}\">\n                        </ui-required-indicator>\n                        <div class=\"rowItem\">\n                            <span ui-translate>manageEmailNotification.status</span>\n                        </div>\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   class=\"activeStatus\"\n                                   ng-model=\"viewModel.notificationEmailTemplate.enabled\"\n                                   data-ng-value=\"true\"\n                                   ng-change=\"handleChange()\"\n                                   ng-disabled=\"::viewModel.isReadOnly\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>manageEmailNotification.statusValues.active</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.notificationEmailTemplate.enabled\"\n                                   data-ng-value=\"false\"\n                                   ng-change=\"handleChange()\"\n                                   ng-disabled=\"::viewModel.isReadOnly\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>manageEmailNotification.statusValues.inactive</span>\n                        </div>\n                    </div>\n\n                    <div class=\"requiredRow\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.notificationEmailTemplate.defaultSelectedOption}}\">\n                        </ui-required-indicator>\n                        <div class=\"rowItem\">\n                            <span ui-translate>manageEmailNotification.defaultSelected</span>\n                        </div>\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   class=\"standardNotificationType\"\n                                   ng-model=\"viewModel.notificationEmailTemplate.defaultSelectedOption\"\n                                   value=\"STANDARD\"\n                                   ng-change=\"handleChange()\"\n                                   ng-disabled=\"::viewModel.isReadOnly\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>manageEmailNotification.defaultSelectedValues.standard</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.notificationEmailTemplate.defaultSelectedOption\"\n                                   value=\"CUSTOM\"\n                                   ng-change=\"handleChange()\"\n                                   ng-disabled=\"::viewModel.isReadOnly\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>manageEmailNotification.defaultSelectedValues.custom</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.notificationEmailTemplate.defaultSelectedOption\"\n                                   value=\"NONE\"\n                                   ng-change=\"handleChange()\"\n                                   ng-disabled=\"::viewModel.isReadOnly\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>manageEmailNotification.defaultSelectedValues.noEmail</span>\n                        </div>\n                    </div>\n\n\n                    <div class=\"emailRow\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>manageEmailNotification.message</span>\n                        </div>\n                        <div class=\"editorContainer\">\n                            <ui-email-editor class=\"editor notification\"\n                                              options=\"viewModel.emailOptions\"\n                                              show-attachment=\"false\"\n                                              close-popup=\"closePopup()\"\n                                              show-footer=\"false\"\n                                              user-list=\"viewModel.recipientList\"\n                                              read-only  =\"::viewModel.isReadOnly\">\n                            </ui-email-editor>\n                        </div>\n\n                    </div>\n\n\n\n\n                </div>\n            </div>\n        </fieldset>\n    </div>\n\n    <div class=\"bottomContent\">\n\n\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2326:
/***/ (function(module, exports) {

var NotificationEmailTemplateModel = function NotificationEmailTemplateModel() {
  this.notificationEmailTemplate = {};
  this.hasUnsavedChanges = false;
  this.isValid = false;
  this.reset = function () {
    this.notificationEmailTemplate = {};
    this.hasUnsavedChanges = false;
    this.isValid = false;
  };
};
angular.module('ums.configuration').service('notificationEmailTemplateModel', NotificationEmailTemplateModel);

/***/ }),

/***/ 2327:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2328);
__webpack_require__(2329);
__webpack_require__(2330);
var ManageEmailNotificationHeaderComponent = {
  templateUrl: '/configuration/emailNotification/manageEmailNotification/header/manageEmailNotificationHeader.tpl.html',
  controller: 'manageEmailNotificationHeaderController',
  bindings: {
    templateId: '<'
  }
};
angular.module('ums.configuration').component('uiManageEmailNotificationHeader', ManageEmailNotificationHeaderComponent);

/***/ }),

/***/ 2328:
/***/ (function(module) {

module.exports = JSON.parse("{\"manageEmailNotificationHeader\":{\"title\":\"Manage Emails\",\"typeLabel\":\"Type:\",\"actions\":{\"name\":\"Actions\",\"discard\":\"Discard\",\"save\":\"Save\",\"delete\":\"Delete\"},\"unsavedChanges\":\"Unsaved changes\",\"invalidNotificationEmailTemplate\":\"The email template is invalid. Please correct or discard your changes before leaving this page.\",\"discardConfirmation\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"success\":\"Your changes have been discarded.\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"deleteConfirmation\":{\"title\":\"Delete Email Template\",\"summary\":\"Are you sure you want to delete the email template?\",\"success\":\"The email template has been deleted.\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"saveNotificationEmailTemplate\":{\"loadingBar\":\"Saving email notification...\",\"savingNotificationEmailTemplateSuccessLoadingBar\":\"Successfully saved email notification\"}}}");

/***/ }),

/***/ 2329:
/***/ (function(module, exports) {

var path = '/configuration/emailNotification/manageEmailNotification/header/manageEmailNotificationHeader.tpl.html';
var html = "<div class=\"headerRow\">\n    <!--Status-->\n    <div class=\"nameColumn\">\n        <button type=\"button\"\n                class=\"btn-link backButton\"\n                ng-click=\"$ctrl.navigateToEmail()\">\n            <span class=\"glyphicon glyphicon-arrow-left\"></span>\n            <span ui-translate>manageEmailNotificationHeader.title</span>\n        </button>\n        <div class=\"emailTemplateName\" uib-tooltip=\"{{ $ctrl.notificationEmailTemplateModel.notificationEmailTemplate.name }}\">{{ $ctrl.notificationEmailTemplateModel.notificationEmailTemplate.name }}</div>\n    </div>\n\n    <div class=\"actionButtonColumn\">\n        <action-buttons-bar context=\"$ctrl.context\"\n                            actions=\"$ctrl.actions\"\n                            action-sub-texts=\"$ctrl.actionSubTexts\"\n                            notify-action-clicked=\"$ctrl.handleAction(action, file)\"\n                            time-last-modified=\"$ctrl.actionsTimeLastModified\"></action-buttons-bar>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2330:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ManageEmailNotificationHeaderController = function ManageEmailNotificationHeaderController($rootScope, $scope, $element, $stateParams, $state, $uibModal, localization, configurationConstant, notificationEmailTemplateRepository, notificationEmailTemplateModel, configurationMediator, coreConstant, modalUtil, notificationPreferencesAction, configurationActionsUtil, loadingBarHandler, navigationStateModel) {
  var _this2 = this;
  $element.addClass('manageEmailNotificationHeader');
  this.notificationEmailTemplateModel = notificationEmailTemplateModel;
  this.translations = null;
  this.actions = [];
  this.context = {
    identifier: 'manageEmailNotificationHeader',
    actions: {},
    fallthrough: null,
    model: {
      contextType: coreConstant.CONTEXT_NONE
    }
  };
  this.context.actions[coreConstant.CONTEXT_NONE] = '';
  this.actionSubTexts = {};
  this.actionsTimeLastModified = '';
  this.$onInit = function () {
    var _this = this;
    localization.getTranslationByKey('manageEmailNotificationHeader').then(function (translations) {
      _this.translations = translations;
      _this.actions = [];
      _this.loadActions();
    });
  };
  $scope.$on(configurationConstant.event.EMAIL_TEMPLATE_UPDATED, function () {
    _this2.processActions(_this2.actions);
  });
  this.loadActions = function () {
    var _this3 = this;
    var templateId = $stateParams.templateId;
    if (!templateId) {
      // new template, pass a dummy id
      templateId = -1;
    }
    notificationEmailTemplateRepository.loadActions(templateId).then(function (actions) {
      var allActions = [];
      allActions.push({
        actions: actions.actions,
        contextType: _this3.context.model.contextType
      });
      _this3.actions = allActions;
      _this3.actionsTimeLastModified = new Date().getTime();
      _this3.processActions(allActions, false);
    });
  };
  this.processActions = function (actions) {
    var _this4 = this;
    this.actions = actions;
    this.actionSubTexts = {};
    _.each(this.actions, function (subAction) {
      _.each(subAction.actions, function (action) {
        if (action.name === notificationPreferencesAction.SAVE) {
          action.enabled = notificationEmailTemplateModel.hasUnsavedChanges && notificationEmailTemplateModel.isValid;
        } else if (action.name === notificationPreferencesAction.DISCARD) {
          action.enabled = notificationEmailTemplateModel.hasUnsavedChanges || !$stateParams.templateId;
        } else if (action.name === notificationPreferencesAction.DELETE) {
          action.enabled = !_.isEmpty($stateParams.templateId);
        }
        if (action.name === notificationPreferencesAction.SAVE && notificationEmailTemplateModel.hasUnsavedChanges) {
          _this4.actionSubTexts[action.name] = {
            class: 'unsavedChanges',
            text: _.get(_this4.translations, 'unsavedChanges')
          };
        }
      });
    });
    this.actionsTimeLastModified = new Date().getTime();
  };
  $scope.$on(configurationConstant.event.PRODUCT_TEMPLATE_UPDATED, function () {
    _this2.processActions(_this2.actions);
  });
  this.handleAction = function (action) {
    var _this5 = this;
    if (action.enabled) {
      switch (action.name) {
        case notificationPreferencesAction.SAVE:
          configurationActionsUtil.saveNotificationEmailTemplate(notificationEmailTemplateModel.notificationEmailTemplate).then(function (emailTemplate) {
            notificationEmailTemplateModel.hasUnsavedChanges = false;
            if (!_.isNil(emailTemplate)) {
              $stateParams.templateId = emailTemplate.id;
            }
            $state.reload();
          });
          break;
        case notificationPreferencesAction.DISCARD:
          modalUtil.showConfirmationModal(null, null, null, 'manageEmailNotificationHeader.discardConfirmation', null, true, function () {
            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(_this5.translations, 'discardConfirmation.success'));
            notificationEmailTemplateModel.hasUnsavedChanges = false;
            if ($stateParams.templateId) {
              $state.reload();
            } else {
              $state.go('configuration.emailBrowser', {});
            }
          });
          break;
        case notificationPreferencesAction.DELETE:
          modalUtil.showConfirmationModal(null, null, null, 'manageEmailNotificationHeader.deleteConfirmation', null, true, function () {
            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(_this5.translations, 'deleteConfirmation.success'));
            return notificationEmailTemplateRepository.deleteNotificationEmailTemplate(notificationEmailTemplateModel.notificationEmailTemplate.id).then(function () {
              notificationEmailTemplateModel.hasUnsavedChanges = false;
              $state.go('configuration.emailBrowser', {});
            });
          });
          break;
        default:
          modalUtil.showActionNotImplementedModal(action.name);
          break;
      }
    }
  };
  this.navigateToEmail = function () {
    $state.go('configuration.emailBrowser', null);
    navigationStateModel.saveViewState('configuration.emailBrowser', null);
  };
  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    var isCurrentStateNotificationEmailTemplateManager = _.startsWith(fromState.name, 'configuration.manageEmail'),
      isTargetSameAsCurrent = toState.name === fromState.name;
    if (toState.name === 'login') {
      return;
    }
    if (notificationEmailTemplateModel.hasUnsavedChanges && isCurrentStateNotificationEmailTemplateManager && !isTargetSameAsCurrent && notificationEmailTemplateModel.notificationEmailTemplate) {
      event.preventDefault();
      if (notificationEmailTemplateModel.isValid) {
        loadingBarHandler.showNotificationLoadingBar(_.get(_this2.translations, 'saveNotificationEmailTemplate.loadingBar'));
        notificationEmailTemplateRepository.saveNotificationEmailTemplate(notificationEmailTemplateModel.notificationEmailTemplate).then(function () {
          loadingBarHandler.concludeNotificationLoadingBar(_.get(_this2.translations, 'saveNotificationEmailTemplate.savingNotificationEmailTemplateSuccessLoadingBar'));
          notificationEmailTemplateModel.reset();
          $state.go(toState, toParams);
        });
      } else {
        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(_this2.translations, 'invalidNotificationEmailTemplate'));
      }
    } else {
      // there are no changes to be saved, do nothing
    }
  });
};
ManageEmailNotificationHeaderController.$inject = ["$rootScope", "$scope", "$element", "$stateParams", "$state", "$uibModal", "localization", "configurationConstant", "notificationEmailTemplateRepository", "notificationEmailTemplateModel", "configurationMediator", "coreConstant", "modalUtil", "notificationPreferencesAction", "configurationActionsUtil", "loadingBarHandler", "navigationStateModel"];
angular.module('ums.configuration').controller('manageEmailNotificationHeaderController', ManageEmailNotificationHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2331:
/***/ (function(module) {

module.exports = JSON.parse("{\"fieldReferences\":{\"title\":\"Field References\",\"summary\":\"Found {referencesCount} reference(s) for field {variableName}.\",\"nameHeader\":\"Name\",\"typeHeader\":\"Type\",\"versionHeader\":\"Version\",\"type\":{\"1\":\"Field Expression\",\"2\":\"Linked Field\",\"3\":\"Rule\",\"4\":\"Scoring Rule\",\"5\":\"Supplemental Form\",\"6\":\"Dynamic Data Set\"},\"confirmButtonLabel\":\"OK\"},\"fieldReferencesConfirmVariableChange\":{\"title\":\"Change Variable Name\",\"summary\":\"Found {referencesCount} reference(s) for field {variableName}. Are you sure you want to change the variable name?\",\"confirmButtonLabel\":\"Yes\",\"cancelButtonLabel\":\"No\"}}");

/***/ }),

/***/ 2332:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FieldReferencesController = function FieldReferencesController($rootScope, $scope, $state, options, configurationMediator, localization, coreConstant, navigationStateModel) {
  localization.getTranslationsByKeys([this.translationsKey, 'fieldReferences']).then(function (translations) {
    $scope.viewModel = {
      title: options.title,
      cancelButton: options.cancelButtonLabel,
      okButton: options.confirmButtonLabel,
      buttonClass: options.showConfirmationButtons ? 'btn-success' : '',
      fieldReferencesMessage: options.summary,
      displayTypeColumn: false,
      fieldReferenceList: options.fieldReferenceList,
      fieldParams: {
        key: 'name',
        sortType: 'asc'
      }
    };
    $scope.onSort = function (event, params) {
      $scope.viewModel.fieldParams = params;
      $scope.viewModel.fieldReferenceList = _.orderBy($scope.viewModel.fieldReferenceList, [params.key], [params.sortType]);
    };
    $scope.getType = function (type) {
      return translations.type[type];
    };
    $scope.onConfirm = function () {
      $scope.$close(true);
    };
    $scope.onCancel = function () {
      $scope.$close(false);
    };
    $scope.openFormTemplate = function (referenceUri) {
      var referenceArray = _.split(referenceUri, ':'),
        navigationModel = {};
      if (_.endsWith(referenceArray[0], 'UIFormTemplate')) {
        navigationModel = {
          parentState: 'configuration.formTemplateBrowser',
          currentState: 'configuration.formEditor.form',
          data: {
            uiFormTemplateId: referenceArray[1]
          }
        };
        $state.go('configuration.formEditor.form', {
          uiFormTemplateId: referenceArray[1]
        });
        navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
        $scope.$dismiss();
      }
    };
    $scope.init = function () {
      $scope.viewModel.fieldReferenceList = _.orderBy($scope.viewModel.fieldReferenceList, $scope.viewModel.fieldParams.key, $scope.viewModel.fieldParams.sortType);
    };
    $scope.init();
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
FieldReferencesController.$inject = ["$rootScope", "$scope", "$state", "options", "configurationMediator", "localization", "coreConstant", "navigationStateModel"];
angular.module('ums.configuration').controller('fieldReferencesController', FieldReferencesController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2333:
/***/ (function(module, exports) {

var path = '/configuration/fieldReferences/fieldReferencesModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\"\n    ok-button-class=\"viewModel.buttonClass\">\n\n    <div ui-browser-detection>\n\n        <div class=\"messageBox\">\n            <span>{{::viewModel.fieldReferencesMessage}}</span>\n        </div>\n\n        <div class=\"referencesContainer\" ng-if=\"viewModel.fieldReferenceList.length > 0\">\n\n            <div class=\"tableHeader\">\n                <div class=\"typeHeader\"\n                     ui-grid-sortable-header\n                     request-params=\"viewModel.fieldParams\"\n                     item-name=\"type\"\n                     item-label=\"fieldReferences.typeHeader\"\n                     on-toggle=\"onSort($event, params)\"></div>\n\n                <div class=\"nameHeader\"\n                     ui-grid-sortable-header\n                     request-params=\"viewModel.fieldParams\"\n                     item-name=\"name\"\n                     item-label=\"fieldReferences.nameHeader\"\n                     on-toggle=\"onSort($event, params)\"></div>\n\n                <div class=\"versionHeader\"\n                     ui-grid-sortable-header\n                     request-params=\"viewModel.fieldParams\"\n                     item-name=\"version\"\n                     item-label=\"fieldReferences.versionHeader\"\n                     on-toggle=\"onSort($event, params)\"></div>\n\n            </div>\n            <div class=\"fieldTemplateTable\">\n                <div class=\"fieldReferencesRow\" ng-repeat=\"fieldReferences in viewModel.fieldReferenceList\">\n                    <div class=\"typeColumn\">\n                        <span>{{getType(fieldReferences.type)}}</span>\n                    </div>\n                    <div class=\"nameColumn\">\n                        <span><a ng-click=\"openFormTemplate(fieldReferences.referenceUri)\">{{fieldReferences.name}}</a></span>\n                    </div>\n                    <div class=\"versionColumn\">\n                        <span>{{fieldReferences.version}}</span>\n                    </div>\n                </div>\n\n            </div>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2334:
/***/ (function(module, exports) {

/*@ngInject*/
var FieldReferencesRepository = function FieldReferencesRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getFieldReferences = function (fieldTemplateId) {
    var url = '/rest/UIFormTemplate/findReferencesByFieldTemplateId',
      config = {
        params: {
          fieldTemplateId: fieldTemplateId
        }
      };
    return this.get(url, config);
  };
};
FieldReferencesRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('fieldReferencesRepository', FieldReferencesRepository);

/***/ }),

/***/ 2335:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/formEditor.tpl.html';
var html = "<div class=\"formEditor\">\n\n    <ui-form-editor-header></ui-form-editor-header>\n\n    <ui-form-editor-nav></ui-form-editor-nav>\n\n    <div class=\"content\" ui-view=\"tabView\"></div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2336:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2337);
__webpack_require__(2338);
__webpack_require__(2339);
__webpack_require__(2340);
__webpack_require__(2341);
__webpack_require__(2344);
__webpack_require__(2348);
__webpack_require__(2352);
__webpack_require__(2364);
__webpack_require__(2368);
__webpack_require__(2372);
__webpack_require__(2373);
__webpack_require__(2374);
__webpack_require__(2375);
__webpack_require__(2379);
__webpack_require__(2384);
__webpack_require__(2389);
__webpack_require__(2393);
__webpack_require__(2394);
__webpack_require__(2395);
__webpack_require__(2396);

/*@ngInject*/
var FormEditorController = function FormEditorController() {};
angular.module('ums.configuration').controller('formEditorController', FormEditorController);

/***/ }),

/***/ 2337:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RuleMediator = function RuleMediator(ruleRepository, ruleUtil, ruleModel, ruleConditionType) {
  this.typeToConditionTypes = {};
  this.findRuleById = function (id) {
    return ruleRepository.findRuleById(id);
  };
  this.updateRule = function (rule) {
    return ruleRepository.updateRule(rule);
  };
  this.deleteRule = function (id) {
    // prevent auto save
    ruleModel.setUnsavedChanges(id, false);
    return ruleRepository.deleteRule(id);
  };
  this.activateRule = function (id) {
    return ruleRepository.activateRule(id);
  };
  this.deactivateRule = function (id) {
    return ruleRepository.deactivateRule(id);
  };
  this.getRuleActions = function (ruleType) {
    return ruleRepository.getRuleActions(ruleType);
  };
  this.getConditionTypes = function () {
    return ruleRepository.getConditionTypes();
  };
  this.addCondition = function (ruleConditionGroup, conditionType) {
    var condition = _.cloneDeep(this.typeToConditionTypes[conditionType]);
    ruleConditionGroup.subconditions.push(condition);
  };
  this.addGroup = function (ruleConditionGroup) {
    var compositeCondition = this.createCompositeCondition();
    ruleConditionGroup.subconditions.push(compositeCondition);
  };
  this.deleteSubcondition = function (parentRuleCondition, subconditionToDelete) {
    _.remove(parentRuleCondition.subconditions, function (subcondition) {
      return subcondition === subconditionToDelete;
    });
  };
  this.deleteSubAction = function (parentRuleAction, actionToDelete) {
    _.remove(parentRuleAction, function (action) {
      return action === actionToDelete;
    });
  };
  this.addSubAction = function (ruleActionGroup, action) {
    ruleActionGroup.push(action);
  };
  this.createCompositeCondition = function () {
    var compositeCondition = _.cloneDeep(this.typeToConditionTypes[ruleConditionType.COMPOSITE]);
    return compositeCondition;
  };
  this.addAction = function (ruleAction) {};
  this.deleteAction = function (ruleAction) {};
  this.getOperators = function (type, isField) {
    return ruleRepository.getOperators(type, isField);
  };
  this.getSearchableValues = function (formTemplateUniqueName, fieldName) {
    return ruleRepository.getSearchableValues(formTemplateUniqueName, fieldName);
  };
  this.createConditionValue = function (valueType, typeName) {
    var value = {
      objectUri: '/' + valueType + '/',
      typeName: typeName
    };
    return value;
  };
  this.createFieldRule = function (fieldRules) {
    var ordinal,
      newFieldRule = {
        objectUri: '/Rule',
        name: 'New Rule'
      },
      compositeCondition = this.createCompositeCondition();
    newFieldRule.actions = [{
      createdBy: null,
      description: null,
      id: null,
      lastModifiedBy: null,
      name: null,
      objectUri: "/RawAction",
      rawExpression: "",
      timeCreated: null,
      timeLastModified: null,
      transformVariables: {},
      uri: 'com.firstbest.rules.model.RawAction:null'
    }];
    newFieldRule.condition = compositeCondition;
    ordinal = _.reduce(fieldRules, function (count, fieldRule) {
      if (_.startsWith(fieldRule.name, 'New Rule')) {
        return count + 1;
      } else {
        return count;
      }
    }, 1);
    newFieldRule.name += ' ' + ordinal;
    return newFieldRule;
  };
  this.convertToUnaryCondition = function (ruleConditionGroup, condition) {
    var unaryCondition = {
      operator: 'not',
      subcondition: condition,
      objectUri: '/UnaryCondition'
    };
    var conditionIndex = _.findIndex(ruleConditionGroup.subconditions, function (subcondition) {
      return subcondition === condition;
    });
    ruleConditionGroup.subconditions[conditionIndex] = unaryCondition;
    return unaryCondition;
  };
  this.convertFromUnaryCondition = function (ruleConditionGroup, condition) {
    var conditionIndex = _.findIndex(ruleConditionGroup.subconditions, function (subcondition) {
      return subcondition === condition;
    });
    ruleConditionGroup.subconditions[conditionIndex] = condition.subcondition;
    return condition.subcondition;
  };
  this.createVariableValueList = function (ruleConditionGroup) {
    var variableValueList = ruleUtil.createVariableValueList(ruleConditionGroup);
    ruleModel.setVariableValueList(variableValueList);
  };
  this.createRule = function (rule) {
    return ruleRepository.createRule(rule);
  };
  this.getMatchingTags = function (tagName) {
    return ruleRepository.getMatchingTags(tagName);
  };
  this.createTag = function (tag) {
    return ruleRepository.createTag(tag);
  };
  this.getTypeToConditionTypes = function () {
    var typeToConditionTypes = {};
    ruleRepository.getConditionTypes().then(function (result) {
      _.each(result, function (conditionType) {
        typeToConditionTypes[conditionType.name] = conditionType;
      }.bind(this));
    }.bind(this));
    this.typeToConditionTypes = typeToConditionTypes;
  };
  this.getTypeToConditionTypes();
};
RuleMediator.$inject = ["ruleRepository", "ruleUtil", "ruleModel", "ruleConditionType"];
angular.module('ums.configuration').service('ruleMediator', RuleMediator);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2338:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RuleModel = function RuleModel($rootScope, $timeout, coreMediator, configurationConstant, ruleRepository) {
  var ruleModel = {};
  var variableValueList = [];
  this.reset = function (ruleId) {
    if (!_.isNil(ruleId)) {
      ruleModel[ruleId] = {
        rule: null,
        hasUnsavedChanges: false
      };
    } else {
      ruleModel = {};
    }
  };
  this.buildRule = function (ruleId) {
    this.reset(ruleId);
    return ruleRepository.findRuleById(ruleId).then(function (rule) {
      this.updateRule(rule);
    }.bind(this));
  };
  this.getRule = function (ruleId) {
    var model = ruleModel[ruleId];
    return model.rule;
  };
  this.setUnsavedChanges = function (ruleId, hasUnsavedChanges) {
    var model = ruleModel[ruleId];
    model.hasUnsavedChanges = hasUnsavedChanges;
  };
  this.hasUnsavedChanges = function (ruleId) {
    var model = ruleModel[ruleId];
    return model.hasUnsavedChanges;
  };
  this.updateRule = function (rule) {
    var model = {
      rule: _.cloneDeep(rule),
      hasUnsavedChanges: false
    };
    ruleModel[rule.id] = model;
    $rootScope.$broadcast(configurationConstant.event.RULE_MODEL_UPDATED, rule.id);
  };
  this.getVariableValueList = function () {
    return variableValueList;
  };
  this.setVariableValueList = function (newVariableValueList) {
    variableValueList.splice(0, variableValueList.length);
    _.each(newVariableValueList, function (variableValue) {
      variableValueList.push(variableValue);
    });
  };
};
RuleModel.$inject = ["$rootScope", "$timeout", "coreMediator", "configurationConstant", "ruleRepository"];
angular.module('ums.configuration').service('ruleModel', RuleModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2339:
/***/ (function(module, exports) {

/*@ngInject*/
var RuleRepository = function RuleRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.findRuleById = function (id) {
    var url = '/rest/Rule/' + id,
      config = {
        params: {}
      };
    return this.get(url, config);
  };
  this.deleteRule = function (id) {
    var url = '/rest/Rule/' + id;
    return this.delete(url, id);
  };
  this.activateRule = function (id) {
    var url = '/rest/Rule/' + id + '/activate';
    return this.post(url, id);
  };
  this.deactivateRule = function (id) {
    var url = '/rest/Rule/' + id + '/deactivate';
    return this.post(url, id);
  };
  this.getRuleActions = function (ruleType) {
    var url = '/rest/Rule/ruleActions',
      config = {
        params: {
          ruleType: ruleType
        }
      };
    return this.get(url, config);
  };
  this.getConditionTypes = function () {
    var url = '/rest/Rule/conditionTypes';
    return this.get(url);
  };
  this.updateRule = function (rule) {
    var url = '/rest/Rule/' + rule.id;
    return this.post(url, rule);
  };
  this.getOperators = function (type, isField) {
    var url = '/rest/Rule/operators',
      config = {
        params: {
          type: type,
          isField: isField
        }
      };
    return this.get(url, config);
  };
  this.getSearchableValues = function (formTemplateUniqueName, fieldName) {
    var url = '/rest/Rule/searchableValues',
      config = {
        params: {
          formTemplateUniqueName: formTemplateUniqueName,
          fieldName: fieldName
        }
      };
    return this.get(url, config);
  };
  this.getRulesByFilterUri = function (filterUri, requestParams) {
    var url = '/rest/Rule/filter',
      config = {
        params: {
          filterUri: filterUri,
          sortBy: requestParams.key,
          sortDirection: requestParams.sortType,
          startIndex: requestParams.startIndex,
          numberOfRows: requestParams.pageSize
        }
      };
    return this.get(url, config);
  };
  this.createRule = function (rule) {
    var url = '/rest/Rule';
    return this.post(url, rule);
  };
  this.getMatchingTags = function (tagName) {
    var url = '/rest/RuleTag/getMatchingTags',
      config = {
        params: {
          tagName: tagName
        }
      };
    return this.get(url, config);
  };
  this.createTag = function (tag) {
    var url = '/rest/RuleTag';
    return this.post(url, tag);
  };
  this.redeployRuleSets = function (ruleSetIds) {
    var url = '/rest/Rule/redeploy',
      config = {
        params: {
          ruleSetIds: ruleSetIds
        },
        headers: {
          'Content-Type': 'application/json'
        }
      };
    return this.post(url, {}, config);
  };
};
RuleRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('ruleRepository', RuleRepository);

/***/ }),

/***/ 2340:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RuleUtil = function RuleUtil($rootScope, $uibModal, configurationMediator, coreConstant, loadingBarHandler, localization, uiPerformanceLoggerConstant) {
  this.typeNameToVariableMethodMap = {
    'String': 'stringValue',
    'Boolean': 'booleanValue',
    'Integer': 'intValue',
    'Double': 'doubleValue',
    'Date': 'dateValue'
  };
  this.getRuleSetName = function (rule) {
    if (!_.isNil(rule)) {
      return _.first(_.split(rule.parentPath, '/'));
    }
    return '';
  };
  this.getConditionType = function (objectUri) {
    var type;
    if (objectUri.lastIndexOf('/') > 0) {
      type = objectUri.substr(1, _.lastIndexOf(objectUri, '/') - 1);
    } else {
      type = objectUri.substr(1);
    }
    return type;
  };
  this.getRuleNameSubstring = function (rule) {
    var nameSubstring;
    if (!_.isNil(rule) && !_.isNil(rule.name)) {
      nameSubstring = rule.name.lastIndexOf('-#') !== -1 ? rule.name.substr(0, rule.name.lastIndexOf('-#')) : rule.name;
    }
    return nameSubstring;
  };
  this.updateUiFieldTriggerRuleNames = function (uiFormTemplate, oldTriggerRuleName, newTriggerRuleName) {
    _.each(uiFormTemplate.sections, function (section) {
      _.each(section.rows, function (row) {
        _.each(row.fields, function (field) {
          if (field.fieldTemplate.triggerRuleName === oldTriggerRuleName) {
            field.fieldTemplate.triggerRuleName = newTriggerRuleName;
          }
        });
      });
    });
    _.each(uiFormTemplate.formTemplate.fieldTemplates, function (fieldTemplate) {
      if (fieldTemplate.triggerRuleName === oldTriggerRuleName) {
        fieldTemplate.triggerRuleName = newTriggerRuleName;
      }
    });
  };
  this.cleanUpUiFieldsByTriggerRuleName = function (uiFormTemplate, triggerRuleName) {
    _.each(uiFormTemplate.sections, function (section) {
      _.each(section.rows, function (row) {
        _.each(row.fields, function (field) {
          if (field.fieldTemplate.triggerRuleName === triggerRuleName) {
            field.fieldTemplate.triggerRuleName = null;
            field.fieldTemplate.untriggerBehavior = 0;
          }
        });
      });
    });
    _.each(uiFormTemplate.formTemplate.fieldTemplates, function (fieldTemplate) {
      if (fieldTemplate.triggerRuleName === triggerRuleName) {
        fieldTemplate.triggerRuleName = null;
        fieldTemplate.untriggerBehavior = 0;
      }
    });
  };
  this.createVariableValueList = function (ruleConditionGroup) {
    var variableValueList = [];
    _.each(ruleConditionGroup.subconditions, function (subcondition) {
      variableValueList = _.concat(variableValueList, this.processVariablesFromCondition(subcondition));
    }.bind(this));
    return variableValueList;
  };
  this.processVariablesFromCondition = function (condition) {
    var variableValueList = [],
      conditionType = this.getConditionType(condition.objectUri);
    if (conditionType === 'CompositeCondition') {
      variableValueList = _.concat(variableValueList, this.createVariableValueList(condition));
    } else if (conditionType === 'UnaryCondition') {
      variableValueList = _.concat(variableValueList, this.processVariablesFromCondition(condition.subcondition, variableValueList));
    } else if (conditionType === 'BinaryCondition') {
      if (condition.lhs && condition.lhs.variableName && !_.startsWith(condition.lhs.objectUri, '/VariableValue')) {
        variableValueList.push({
          variableName: condition.lhs.variableName,
          typeName: condition.lhs.typeName,
          variableMethod: this.typeNameToVariableMethodMap[condition.lhs.typeName]
        });
      }
      if (condition.rhs && condition.rhs.variableName && !_.startsWith(condition.rhs.objectUri, '/VariableValue')) {
        variableValueList.push({
          variableName: condition.rhs.variableName,
          typeName: condition.rhs.typeName,
          variableMethod: this.typeNameToVariableMethodMap[condition.rhs.typeName]
        });
      }
    } else if (conditionType === 'ParameterizedCondition') {
      _.each(condition.parameters, function (parameter) {
        if (parameter.variableName) {
          variableValueList.push({
            variableName: parameter.variableName,
            typeName: parameter.typeName,
            variableMethod: this.typeNameToVariableMethodMap[parameter.typeName]
          });
        }
      }.bind(this));
    }
    return variableValueList;
  };
  this.redeployRuleSets = function (defaultRuleSetId) {
    var modalInstance = $uibModal.open({
      templateUrl: '/configuration/rulesBrowser/redeployRuleSets/redeployRuleSets.tpl.html',
      controller: 'redeployRuleSetsController',
      windowClass: 'redeployRuleSetsModal',
      resolve: {
        options: {
          defaultRuleSetId: defaultRuleSetId
        }
      }
    });
    modalInstance.result.then(function (response) {
      localization.getTranslationByKey('redeployRuleSets').then(function (translations) {
        var logAction = uiPerformanceLoggerConstant.REDEPLOY_RULE_SETS,
          numRuleSets = !_.isNil(response.ruleSetIds) ? response.ruleSetIds.length : 0,
          successMessage = _.replace(_.get(translations, 'successMessage'), '{numRuleSets}', numRuleSets),
          loadingBar = _.replace(_.get(translations, 'loadingBar'), '{numRuleSets}', numRuleSets);
        function onSuccess(response) {
          loadingBarHandler.concludeNotificationLoadingBar(successMessage);
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
        }
        function onError() {
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
        }
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction);
        loadingBarHandler.showNotificationLoadingBar(loadingBar);
        configurationMediator.redeployRuleSets(response.ruleSetIds).then(onSuccess, onError);
      }.bind(this));
    });
  };
};
RuleUtil.$inject = ["$rootScope", "$uibModal", "configurationMediator", "coreConstant", "loadingBarHandler", "localization", "uiPerformanceLoggerConstant"];
angular.module('ums.configuration').service('ruleUtil', RuleUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2341:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2342);
__webpack_require__(2343);
var RuleActionComponent = {
  templateUrl: '/common/rule/ruleAction/ruleAction.tpl.html',
  controller: 'ruleActionController',
  bindings: {
    ruleAction: '<',
    displayExpression: '<',
    onDeleteSubAction: '&',
    canUserManageFormRules: '<'
  }
};
angular.module('ums').component('uiRuleAction', RuleActionComponent);

/***/ }),

/***/ 2342:
/***/ (function(module, exports) {

var path = '/common/rule/ruleAction/ruleAction.tpl.html';
var html = "<div class=\"ruleActionContainer\"\n     ng-switch on=\"$ctrl.getActionType()\">\n\n    <label ng-if=\"$ctrl.ruleAction.parameters.length === 0\">\n        {{$ctrl.ruleAction.name}}\n    </label>\n\n    <div ng-switch-when=\"ParameterizedAction\"\n         class=\"parameterizedAction\">\n        <ui-parameterized-action ng-repeat=\"action in $ctrl.ruleAction.parameters\"\n                                 parameter=\"action\"\n                                 display-expression=\"$ctrl.ruleAction.expression.displayExpression\"\n                                 can-user-manage-form-rules=\"::$ctrl.canUserManageFormRules\"></ui-parameterized-action>\n    </div>\n\n    <div class=\"rawAction\"\n         ng-switch-when=\"RawAction\">\n        <textarea ng-model=\"$ctrl.ruleAction.rawExpression\"\n                  ng-change=\"$ctrl.onRawActionChange()\"\n                  ng-disabled=\"!$ctrl.canUserManageFormRules\"></textarea>\n    </div>\n\n    <div class=\"deleteActionContainer\">\n        <button class=\"glyphicon glyphicon-trash deleteActionBtn\"\n                ng-click=\"$ctrl.deleteAction()\"\n                ng-if=\"$ctrl.canUserManageFormRules\"></button>\n    </div>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2343:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RuleActionController = function RuleActionController($rootScope, $element, localization, umStudioConstant) {
  $element.addClass('ruleAction');
  localization.getTranslations().then(function (translations) {
    this.getActionType = function () {
      var type,
        objectUri = this.ruleAction.objectUri;
      if (_.lastIndexOf(objectUri, '/') > 0) {
        type = objectUri.substr(1, _.lastIndexOf(objectUri, '/') - 1);
      } else {
        type = objectUri.substr(1);
      }
      return type;
    };
    this.deleteAction = function () {
      this.onDeleteSubAction({
        subAction: this.ruleAction
      });
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    this.onRawActionChange = function () {
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
  }.bind(this));
};
RuleActionController.$inject = ["$rootScope", "$element", "localization", "umStudioConstant"];
angular.module('umCore').controller('ruleActionController', RuleActionController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2344:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2345);
__webpack_require__(2346);
__webpack_require__(2347);
var ParameterizedActionComponent = {
  templateUrl: '/common/rule/ruleAction/parameterizedAction/parameterizedAction.tpl.html',
  controller: 'parameterizedActionController',
  bindings: {
    parameter: '<',
    displayExpression: '<',
    canUserManageFormRules: '<'
  }
};
angular.module('umCore').component('uiParameterizedAction', ParameterizedActionComponent);

/***/ }),

/***/ 2345:
/***/ (function(module) {

module.exports = JSON.parse("{\"parameterizedAction\":{\"dropdownPrompt\":\"Please Choose\",\"ruleVariablesGroupingLabel\":\"Rule Variable(s)\"}}");

/***/ }),

/***/ 2346:
/***/ (function(module, exports) {

var path = '/common/rule/ruleAction/parameterizedAction/parameterizedAction.tpl.html';
var html = "<div class=\"parameterizedActionContainer\">\n\n    <label class=\"actionText\">{{$ctrl.getLabel()}}</label>\n    <div class=\"actionContainer\">\n\n        <div ng-if=\"$ctrl.getActionType()==='/VariableValue' || $ctrl.getActionType()==='/DataSetItemValue'\">\n            <um-dropdown class-name=\"dataSet\"\n                         option-list=\"$ctrl.itemsList\"\n                         selected-value=\"$ctrl.selectedPrompt.value\"\n                         on-change=\"$ctrl.changeDataSetValue(selectedOption)\"\n                         required=\"'true'\"\n                         is-disabled=\"!$ctrl.canUserManageFormRules\">\n            </um-dropdown>\n        </div>\n\n        <div class=\"literalValue\" ng-if=\"$ctrl.getActionType()==='/LiteralValue'\">\n            <input type=\"text\"\n                   class=\"reason\"\n                   ng-if=\"$ctrl.parameter.value.typeName === 'String'\"\n                   ng-change=\"$ctrl.onLiteralValueChange()\"\n                   ng-model=\"$ctrl.parameter.value.valueString\"\n                   ui-tooltip\n                   ng-disabled=\"!$ctrl.canUserManageFormRules\"/>\n\n            <input type=\"checkbox\"\n                   class=\"variableName\"\n                   ng-if=\"$ctrl.parameter.value.typeName === 'Boolean'\"\n                   ng-change=\"$ctrl.onLiteralValueChange()\"\n                   ng-model=\"$ctrl.parameter.value.valueString\"\n                   ng-disabled=\"!$ctrl.canUserManageFormRules\"/>\n        </div>\n\n        <div class=\"form\" ng-if=\"$ctrl.getActionType()==='/FormTemplateValue'\"\n             ng-disabled=\"!$ctrl.canUserManageFormRules\">\n            <ui-multi-step-selector-widget\n                class=\"multiStepSelectorWidget\"\n                mode=\"'forms'\"\n                step-1-item-name=\"$ctrl.parameter.value.formTemplateUniqueName\">\n            </ui-multi-step-selector-widget>\n        </div>\n\n        <div class=\"form\" ng-if=\"$ctrl.getActionType()==='/FieldValue'\"\n             ng-disabled=\"!$ctrl.canUserManageFormRules\">\n            <ui-multi-step-selector-widget\n                class=\"multiStepSelectorWidget\"\n                mode=\"'forms'\"\n                step-1-item-name=\"$ctrl.parameter.value.formTemplateUniqueName\"\n                step-2-item-name=\"$ctrl.parameter.value.fieldName\">\n            </ui-multi-step-selector-widget>\n        </div>\n\n        <div ng-if=\"$ctrl.getActionType()==='/EntityUriValue'\">\n            <um-dropdown class-name=\"entity\"\n                         option-list=\"$ctrl.activeList\"\n                         selected-value=\"\"\n                         on-change=\"\"\n                         required=\"'true'\"\n                         is-disabled=\"!$ctrl.canUserManageFormRules\">\n            </um-dropdown>\n        </div>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2347:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ParameterizedActionController = function ParameterizedActionController($rootScope, $scope, $element, $stateParams, $timeout, coreMediator, dataSetUtil, localization, ruleMediator, umStudioConstant, ruleModel, ruleUtil, dataSetType) {
  var _this = this;
  localization.getTranslations().then(function (translations) {
    _this.defaultPrompt = {
      name: _.get(translations, 'parameterizedAction.dropdownPrompt')
    };
    _this.defaultPrompt.value = _this.defaultPrompt.name;
    _this.variables = [];
    _this.selectedPrompt = {
      name: '',
      value: ''
    };
    _this.selectedPrompt.value = _this.selectedPrompt.name;
    _this.init = function () {
      var _this2 = this;
      if (this.getActionType() === '/VariableValue') {
        this.selectedPrompt = {
          name: this.parameter.value.variableName,
          isVariableValue: true
        };
        this.selectedPrompt.value = this.selectedPrompt.name;
      } else if (this.getActionType() === '/DataSetItemValue') {
        var dataSetParams = {
          name: this.parameter.value.datasetName
        };
        dataSetUtil.getDataSet(dataSetParams).then(function (result) {
          _this2.dataSetItems = result.items;
          _this2.dataSetType = result.type;
          _this2.setSelectedPrompt();
          _this2.buildItemsList();
        });
      } else if (this.getActionType() === '/EntityUriValue') {
        this.activeList = {};
      }
      this.tooltip = {};
      this.tooltip.type = '';
      this.tooltip.message = this.parameter.value.valueString;
      this.getVariables();
    };
    _this.getActionType = function () {
      return _.split(this.parameter.value.objectUri, '/' + this.parameter.value.id)[0];
    };
    _this.onLiteralValueChange = _.debounce(function () {
      $timeout(function () {
        $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
      }, 0);
    }, 250);
    _this.changeDataSetValue = function (item) {
      var name = _.isEmpty(item) ? '' : item.value || item.variableName;
      this.selectedPrompt = {
        name: name,
        value: name
      };
      if (item.variableName) {
        this.parameter.value = {};
        this.parameter.value.objectUri = '/VariableValue';
        this.parameter.value.variableName = item.variableName;
        if (this.parameter.typeName) {
          this.parameter.value.variableMethod = ruleUtil.typeNameToVariableMethodMap[this.parameter.typeName];
        }
      } else {
        if (this.dataSetType === dataSetType.PRODUCT_FIELD_DEPENDENT) {
          this.parameter.value.entityUri = "com.firstbest.underwriting.data.EnhancedDynamicDataItem:com.firstbest.data.DataItemKey::".concat(this.parameter.value.datasetName, "::").concat(name);
        } else {
          this.parameter.value.entityUri = "com.firstbest.data.DataItem:com.firstbest.data.DataItemKey::".concat(this.parameter.value.datasetName, "::").concat(name);
        }
      }
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    _this.getLabel = function () {
      var name = "{".concat(this.parameter.name, "}");
      var array = _.split(this.displayExpression, name);
      var array2 = _.split(array[0], ', ');
      return array2[array2.length - 1];
    };
    _this.setSelectedPrompt = function () {
      var _this3 = this;
      var promptValue = this.parameter.value.variableName,
        selectedPromptPresent = false;
      if (!promptValue) {
        promptValue = _.split(this.parameter.value.entityUri, '::', 3)[2];
      }
      this.selectedPrompt = this.defaultPrompt;
      // select in dataSetItems
      _.each(this.dataSetItems, function (item) {
        if (item.value === promptValue) {
          selectedPromptPresent = true;
          _this3.selectedPrompt = {
            name: item.name,
            value: item.value
          };
        }
      });

      // select in variables
      if (!selectedPromptPresent) {
        _.each(this.variables, function (variable) {
          if (promptValue === variable.variableName) {
            _this3.selectedPrompt = {
              name: variable.variableName,
              isVariableValue: true
            };
            _this3.selectedPrompt.value = _this3.selectedPrompt.name;
          }
        });
      }
    };
    _this.getVariables = function () {
      var _this4 = this;
      this.variables = [];
      this.allSubConditions = [];
      var rule = ruleModel.getRule(parseInt($stateParams.ruleId));
      var selectedPromptPresent = false;
      this.setAllSubConditions(rule.condition.subconditions);
      _.each(this.allSubConditions, function (item) {
        if (!_.isNil(item.lhs) && !_.isEmpty(item.lhs.variableName)) {
          var lhsObject = {};
          lhsObject.variableName = item.lhs.variableName;
          if (_this4.selectedPrompt.value === item.lhs.variableName) {
            selectedPromptPresent = true;
          }
          _this4.variables.push(lhsObject);
        }
        if (!_.isNil(item.rhs) && !_.isEmpty(item.rhs.variableName)) {
          var rhsObject = {};
          rhsObject.variableName = item.rhs.variableName;
          if (_this4.selectedPrompt.value === item.rhs.variableName) {
            selectedPromptPresent = true;
          }
          _this4.variables.push(rhsObject);
        }
      });
      if (!selectedPromptPresent) {
        this.selectedPrompt = this.defaultPrompt;
      }
      this.buildItemsList();
    };
    _this.buildItemsList = function () {
      var _this5 = this;
      this.itemsList = [];
      _.each(this.variables, function (variable) {
        variable.name = variable.variableName;
        variable.value = variable.name;
        variable.grouping = _.get(translations, 'parameterizedAction.ruleVariablesGroupingLabel');
        _this5.itemsList.push(variable);
      });
      _.each(this.dataSetItems, function (dataSetItem) {
        _this5.itemsList.push(dataSetItem);
      });
    };
    _this.setAllSubConditions = function (subconditions) {
      var _this6 = this;
      _.each(subconditions, function (item) {
        if (_.isNil(item.subconditions)) {
          _this6.allSubConditions.push(item);
        } else {
          _this6.setAllSubConditions(item.subconditions);
        }
      });
    };
    $scope.$on(umStudioConstant.event.RULE_VARIABLE_VALUE_CHANGED, function () {
      _this.variables = [];
      _this.variables = ruleModel.getVariableValueList();
      _this.buildItemsList();
      if (_this.selectedPrompt.isVariableValue) {
        var selectedPromptPresent = false;
        _.each(_this.variables, function (variable) {
          if (_this.selectedPrompt.value === variable.variableName) {
            selectedPromptPresent = true;
          }
        });
        if (!selectedPromptPresent) {
          _this.selectedPrompt = _this.defaultPrompt;
          _this.parameter.value.variableName = null;
        }
      }
    });
    _this.init();
  });
};
ParameterizedActionController.$inject = ["$rootScope", "$scope", "$element", "$stateParams", "$timeout", "coreMediator", "dataSetUtil", "localization", "ruleMediator", "umStudioConstant", "ruleModel", "ruleUtil", "dataSetType"];
angular.module('umCore').controller('parameterizedActionController', ParameterizedActionController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2348:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2349);
__webpack_require__(2350);
__webpack_require__(2351);
var RuleActionGroupComponent = {
  templateUrl: '/common/rule/ruleActionGroup/ruleActionGroup.tpl.html',
  controller: 'ruleActionGroupController',
  bindings: {
    ruleActionGroup: '<',
    ruleSetName: '<',
    onDeleteSubAction: '&',
    canUserManageFormRules: '<'
  }
};
angular.module('ums').component('uiRuleActionGroup', RuleActionGroupComponent);

/***/ }),

/***/ 2349:
/***/ (function(module) {

module.exports = JSON.parse("{\"ruleActionGroup\":{\"then\":\"Then\",\"addAction\":\"Add Action\"}}");

/***/ }),

/***/ 2350:
/***/ (function(module, exports) {

var path = '/common/rule/ruleActionGroup/ruleActionGroup.tpl.html';
var html = "<div class=\"groupHeader\">\n    <div class=\"thenContainer\"\n         ui-translate>ruleActionGroup.then\n    </div>\n</div>\n<div class=\"groupContainer\"\n     ng-class=\"{ topLevelGroupContainer: $ctrl.isTopLevel }\">\n\n    <div class=\"groupBody\">\n        <div class=\"ruleActionsContainer\">\n\n            <ui-rule-action ng-repeat=\"ruleAction in $ctrl.ruleActionGroup track by $index\"\n                            on-delete-sub-action=\"$ctrl.doDeleteSubAction(ruleAction)\"\n                            rule-action=\"ruleAction\"\n                            can-user-manage-form-rules=\"$ctrl.canUserManageFormRules\"></ui-rule-action>\n\n            <div class=\"addActionDropdown\"\n                 uib-dropdown\n                 ng-class=\"{'dropup' : $ctrl.isDropup()}\"\n                 ng-if=\"$ctrl.canUserManageFormRules\">\n                <button class=\"btn dropdownLabel addAction\"\n                        uib-dropdown-toggle>\n                    <span ui-translate>ruleActionGroup.addAction</span>\n                    <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                </button>\n\n                <ul uib-dropdown-menu>\n                    <li ng-repeat=\"action in $ctrl.actions\">\n                        <button class=\"btn btn-link \"\n                                ng-class=\"$ctrl.getActionClassName(action.name)\"\n                                ng-click=\"$ctrl.addAction(action)\">\n                            {{action.name}}\n                        </button>\n                    </li>\n                </ul>\n            </div>\n        </div>\n\n    </div>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2351:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {/*@ngInject*/
var RuleActionGroupController = function RuleActionGroupController($element, $stateParams, $rootScope, umStudioConstant, configurationConstant, localization, ruleUtil, ruleMediator, ruleModel) {
  $element.addClass('ruleActionGroup');
  localization.getTranslations().then(function (translations) {
    this.doDeleteSubAction = function (subAction) {
      ruleMediator.deleteSubAction(this.ruleActionGroup, subAction);
      ruleModel.setUnsavedChanges($stateParams.ruleId, /*hasUnsavedChanges*/true);
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    this.addAction = function (action) {
      ruleMediator.addSubAction(this.ruleActionGroup, action);
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
      this.getActions();
    };
    this.getActionClassName = function (name) {
      return _.lowerFirst(_.replace(name, ' ', ''));
    };
    this.getActions = function () {
      ruleMediator.getRuleActions(this.ruleSetName.toLowerCase()).then(function (actions) {
        this.actions = actions;
      }.bind(this));
    };
    this.isDropup = function () {
      var dropmenu = $('.addActionDropdown');
      if (dropmenu.offset().top + dropmenu.outerHeight() + 300 /*height of the selectorMenu*/ > $(window).innerHeight() + $(window).scrollTop()) {
        return true;
      }
      return false;
    };
    this.getActions();
    $rootScope.$on(configurationConstant.event.RULE_MODEL_UPDATED, function (event, ruleId) {
      if (ruleId === parseInt($stateParams.ruleId)) {
        var rule = ruleModel.getRule(parseInt($stateParams.ruleId));
        this.ruleSetName = ruleUtil.getRuleSetName(rule);
        this.getActions();
      }
    }.bind(this));
  }.bind(this));
};
RuleActionGroupController.$inject = ["$element", "$stateParams", "$rootScope", "umStudioConstant", "configurationConstant", "localization", "ruleUtil", "ruleMediator", "ruleModel"];
angular.module('umCore').controller('ruleActionGroupController', RuleActionGroupController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),

/***/ 2352:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2353);
__webpack_require__(2354);
__webpack_require__(2355);
__webpack_require__(2356);
__webpack_require__(2360);
var RuleConditionComponent = {
  templateUrl: '/common/rule/ruleCondition/ruleCondition.tpl.html',
  controller: 'ruleConditionController',
  bindings: {
    ruleCondition: '<',
    onDeleteSubcondition: '&',
    onToggleNegation: '&',
    isUnaryCondition: '<',
    canUserManageFormRules: '<',
    defaultFormTemplateUniqueName: '<'
  }
};
angular.module('ums').component('uiRuleCondition', RuleConditionComponent);

/***/ }),

/***/ 2353:
/***/ (function(module) {

module.exports = JSON.parse("{\"ruleCondition\":{\"is\":\"is\",\"negateCondition\":\"Negate Condition\",\"removeNegation\":\"Remove Negation\"}}");

/***/ }),

/***/ 2354:
/***/ (function(module, exports) {

var path = '/common/rule/ruleCondition/ruleCondition.tpl.html';
var html = "<div class=\"ruleConditionContainer\"\n     ng-switch on=\"$ctrl.getConditionType()\">\n\n    <div class=\"togglerButton\"\n         uib-tooltip=\"{{ ::$ctrl.getNegationTooltip() }}\"\n         tooltip-enable=\"$ctrl.canUserManageFormRules\">\n\n        <a class=\"btn btn-default btn-outline btn-icon\"\n           ng-click=\"$ctrl.canUserManageFormRules && $ctrl.toggleNegation()\"\n           ng-class=\"{negated: $ctrl.isUnaryCondition, notNegated: !$ctrl.isUnaryCondition}\"\n           ng-disabled=\"!$ctrl.canUserManageFormRules\">\n            <span class=\"glyphicon glyphicon-minus\"></span>\n        </a>\n    </div>\n\n    <ui-binary-condition ng-switch-when=\"BinaryCondition\"\n                         rule-condition=\"$ctrl.ruleCondition\"\n                         can-user-manage-form-rules=\"::$ctrl.canUserManageFormRules\"\n                         default-form-template-unique-name=\"$ctrl.defaultFormTemplateUniqueName\"></ui-binary-condition>\n\n    <div class=\"rawCondition\"\n         ng-switch-when=\"RawCondition\">\n        <textarea ng-model=\"$ctrl.ruleCondition.rawExpression\"\n                  ng-change=\"$ctrl.onRawConditionChange()\"\n                  ng-disabled=\"!$ctrl.canUserManageFormRules\"></textarea>\n    </div>\n\n    <div class=\"parameterizedCondition\"\n         ng-switch-when=\"ParameterizedCondition\">\n        {{ $ctrl.ruleCondition.expression.displayExpression }}\n    </div>\n\n    <ui-rule-condition-group ng-switch-when=\"CompositeCondition\"\n                             rule-condition-group=\"$ctrl.ruleCondition\"\n                             is-top-level=\"false\"\n                             on-delete-group=\"$ctrl.doDeleteGroup(ruleConditionGroup)\"\n                             can-user-manage-form-rules=\"::$ctrl.canUserManageFormRules\"></ui-rule-condition-group>\n\n    <div class=\"deleteConditionContainer\"\n         ng-if=\"$ctrl.getConditionType() !== 'CompositeCondition'\">\n        <button class=\"glyphicon glyphicon-trash deleteConditionBtn\"\n                ng-click=\"$ctrl.deleteCondition()\"\n                ng-if=\"$ctrl.canUserManageFormRules\"></button>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2355:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RuleConditionController = function RuleConditionController($rootScope, $stateParams, $element, localization, ruleMediator, ruleUtil, umStudioConstant, ruleModel) {
  $element.addClass('ruleCondition');
  localization.getTranslations().then(function (translations) {
    this.getConditionType = function () {
      return ruleUtil.getConditionType(this.ruleCondition.objectUri);
    };
    this.doDeleteGroup = function (ruleConditionGroup) {
      this.onDeleteSubcondition({
        subcondition: ruleConditionGroup
      });
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    this.deleteCondition = function () {
      this.onDeleteSubcondition({
        subcondition: this.ruleCondition
      });
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    this.onRawConditionChange = function () {
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    this.getConditionString = function () {
      var conditionString = '';
      if (this.ruleCondition.lhs.objectUri.indexOf('FieldValue') !== -1) {
        conditionString += this.ruleCondition.lhs.formTemplateUniqueName + ':' + this.ruleCondition.lhs.fieldName;
      } else if (this.ruleCondition.lhs.objectUri.indexOf('PropertyValue') !== -1) {
        conditionString += this.ruleCondition.lhs.objectName + ':' + this.ruleCondition.lhs.propertyName;
      }
      conditionString += ' ' + this.ruleCondition.operatorName;
      conditionString += ' ' + this.ruleCondition.rhs.valueString;
      return conditionString;
    };
    this.getNegationTooltip = function () {
      if (this.isUnaryCondition) {
        return _.get(translations, 'ruleCondition.removeNegation');
      }
      return _.get(translations, 'ruleCondition.negateCondition');
    };
    this.toggleNegation = function () {
      this.onToggleNegation({
        ruleCondition: this.ruleCondition,
        isUnaryCondition: this.isUnaryCondition
      });
    };
  }.bind(this));
};
RuleConditionController.$inject = ["$rootScope", "$stateParams", "$element", "localization", "ruleMediator", "ruleUtil", "umStudioConstant", "ruleModel"];
angular.module('umCore').controller('ruleConditionController', RuleConditionController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2356:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2357);
__webpack_require__(2358);
__webpack_require__(2359);
var RuleConditionValueComponent = {
  templateUrl: '/common/rule/ruleCondition/ruleConditionValue/ruleConditionValue.tpl.html',
  controller: 'ruleConditionValueController',
  bindings: {
    ruleConditionValue: '<',
    showLiteralValueOption: '<',
    showLeftSideFieldValueOption: '<',
    showLeftSideFieldValueClassCodeOption: '<',
    showFieldValueMultiSelectOption: '<',
    showFieldValueClassCodeMultiSelectOption: '<',
    notifyValueChanged: '&',
    canUserManageFormRules: '<',
    defaultType: '<',
    defaultFormTemplateUniqueName: '<',
    leftSideFormTemplateUniqueName: '<',
    leftSideFieldName: '<'
  }
};
angular.module('ums').component('uiRuleConditionValue', RuleConditionValueComponent);

/***/ }),

/***/ 2357:
/***/ (function(module) {

module.exports = JSON.parse("{\"ruleConditionValue\":{\"leftSideFieldValue\":\"Left side field value\",\"leftSideFieldValuePlaceholder\":\"Please choose\",\"leftSideFieldValueClassCode\":\"Left side field value\",\"fieldValue\":\"Form field\",\"propertyValue\":\"Object property\",\"variableValue\":\"Variable\",\"literalValue\":\"Literal\",\"literalValuePrompt\":\"Enter literal value\",\"as\":\"as\",\"variableNamePrompt\":\"Enter Variable Name\",\"variableValuePrompt\":\"Select a variable\"}}");

/***/ }),

/***/ 2358:
/***/ (function(module, exports) {

var path = '/common/rule/ruleCondition/ruleConditionValue/ruleConditionValue.tpl.html';
var html = "<div class=\"ruleConditionValueContainer\">\n    <div class=\"valueTypeDropdown\"\n         uib-dropdown\n         ng-disabled=\"!$ctrl.canUserManageFormRules\">\n        <div class=\"dropdownLabel\"\n             uib-dropdown-toggle\n             ng-disabled=\"!$ctrl.canUserManageFormRules\">\n            {{ $ctrl.getValueTypeText() }}\n            <div class=\"glyphicon glyphicon-chevron-down\"></div>\n        </div>\n        <ul uib-dropdown-menu>\n            <li ng-if=\"$ctrl.shouldShowLeftSideFieldValueOption()\">\n                <button class=\"btn btn-link\"\n                        ng-click=\"$ctrl.changeValueType('LeftSideFieldValue')\"\n                        ui-translate>ruleConditionValue.leftSideFieldValue\n                </button>\n            </li>\n            <li ng-if=\"$ctrl.shouldShowLeftSideFieldValueClassCodeOption()\">\n                <button class=\"btn btn-link\"\n                        ng-click=\"$ctrl.changeValueType('LeftSideFieldValueClassCode')\"\n                        ui-translate>ruleConditionValue.leftSideFieldValueClassCode\n                </button>\n            </li>\n            <li>\n                <button class=\"btn btn-link\"\n                        ng-click=\"$ctrl.changeValueType('FieldValue')\"\n                        ui-translate>ruleConditionValue.fieldValue\n                </button>\n            </li>\n            <li>\n                <button class=\"btn btn-link\"\n                        ng-click=\"$ctrl.changeValueType('PropertyValue')\"\n                        ui-translate>ruleConditionValue.propertyValue\n                </button>\n            </li>\n            <li>\n                <button class=\"btn btn-link\"\n                        ng-click=\"$ctrl.changeValueType('VariableValue')\"\n                        ui-translate>ruleConditionValue.variableValue\n                </button>\n            </li>\n            <li ng-if=\"$ctrl.showLiteralValueOption\">\n                <button class=\"btn btn-link\"\n                        ng-click=\"$ctrl.changeValueType('LiteralValue')\"\n                        ui-translate>ruleConditionValue.literalValue\n                </button>\n            </li>\n        </ul>\n    </div>\n    <div class=\"valueContainer\"\n         ng-switch on=\"$ctrl.valueType\">\n\n        <div ng-switch-when=\"LeftSideFieldValue\"\n             class=\"leftSideFieldValue\"\n             ng-class=\"{ multiSelectContainer: $ctrl.showFieldValueMultiSelectOption }\">\n\n            <ui-select ng-if=\"!$ctrl.showFieldValueMultiSelectOption\"\n                       class=\"dropdownFormComponent dropdownComponentSelect rulerBuilderDropdown\"\n                       ng-model=\"$ctrl.fieldSearchableValueNgModel\"\n                       theme=\"select2\"\n                       search-enabled=\"true\"\n                       append-to-body=\"true\"\n                       on-select=\"$ctrl.setFieldSearchableValue($select.selected)\"\n                       ng-disabled=\"::!$ctrl.canUserManageFormRules\"\n                       placeholder=\"{{ ::$ctrl.leftSideFieldValuePlaceholder }}\">\n\n                <ui-select-match class=\"leftSideFieldValueMatch\"\n                                 placeholder=\"{{ ::$ctrl.leftSideFieldValuePlaceholder }}\"\n                                 allow-clear=\"true\">\n                    <span>{{ $ctrl.getFieldSearchableValueName() }}</span>\n                    <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                </ui-select-match>\n\n                <ui-select-choices\n                    repeat=\"fieldSearchableValue in $ctrl.fieldSearchableValues | filter: $select.search\">\n                    <div>{{ fieldSearchableValue.name }}</div>\n                </ui-select-choices>\n            </ui-select>\n\n            <ui-multi-select\n                ng-if=\"$ctrl.showFieldValueMultiSelectOption\"\n                class=\"multiSelect\"\n                items-list=\"$ctrl.fieldSearchableValues\"\n                item-name=\"'name'\"\n                selected-value=\"$ctrl.ruleConditionValue.valueString\"\n                append-to-body=\"true\"\n                delimiter=\"','\"\n                on-change=\"$ctrl.handleMultiSelectFieldValueChange(selectedValueList)\">\n            </ui-multi-select>\n        </div>\n\n        <div ng-switch-when=\"LeftSideFieldValueClassCode\"\n             class=\"leftSideFieldValueClassCode\">\n            <ui-class-code ng-if=\"$ctrl.leftSideFieldValueClassCodeMockFieldStructure && !$ctrl.showFieldValueClassCodeMultiSelectOption\"\n                           field-structure=\"$ctrl.leftSideFieldValueClassCodeMockFieldStructure\"\n                           hide-label=\"'true'\"\n                           effective-date=\"$ctrl.leftSideFieldValueClassCodeMockEffectiveDate\"\n                           on-select=\"$ctrl.handleLeftSideFieldValueClassCodeValueChange(classCodeValue)\">\n            </ui-class-code>\n\n            <ui-multi-select-class-code ng-if=\"$ctrl.leftSideFieldValueClassCodeMockFieldStructure && $ctrl.showFieldValueClassCodeMultiSelectOption\"\n                                        class=\"classCode\"\n                                        field-structure=\"$ctrl.leftSideFieldValueClassCodeMockFieldStructure\"\n                                        effective-date=\"$ctrl.leftSideFieldValueClassCodeMockEffectiveDate\"\n                                        on-select=\"$ctrl.handleLeftSideFieldValueClassCodeValueChange(classCodeValue)\">\n            </ui-multi-select-class-code>\n        </div>\n\n        <div class=\"fieldValue\"\n             ng-switch-when=\"FieldValue\">\n            <div class=\"formFieldContainer\">\n                <ui-multi-step-selector-widget class=\"multiStepSelectorWidget\"\n                                               mode=\"$ctrl.getMode()\"\n                                               step-1-item-name=\"$ctrl.ruleConditionValue.formTemplateUniqueName\"\n                                               step-2-item-name=\"$ctrl.ruleConditionValue.fieldName\"\n                                               is-disabled=\"::!$ctrl.canUserManageFormRules\"></ui-multi-step-selector-widget>\n            </div>\n            <div class=\"editVariableContainer labelContainer\"\n                 ng-if=\"$ctrl.showVariableName\">\n                <div class=\"asContainer\"\n                     ui-translate>\n                    ruleConditionValue.as\n                </div>\n            </div>\n            <div class=\"variableNameContainer\"\n                 ng-if=\"$ctrl.showVariableName\">\n                <input type=\"text\"\n                       class=\"variableName\"\n                       ng-model=\"$ctrl.ruleConditionValue.variableName\"\n                       ui-auto-focus=\"true\"\n                       ui-set-focus=\"variableNameFocus\"\n                       placeholder=\"{{::$ctrl.variableNamePrompt}}\"\n                       ng-disabled=\"!$ctrl.canUserManageFormRules\"\n                       ng-change=\"$ctrl.onVariableNameChange()\"/>\n            </div>\n            <div class=\"editVariableContainer\"\n                 ng-click=\"$ctrl.canUserManageFormRules && $ctrl.toggleShowVariableName()\">\n                <div class=\"glyphicon glyphicon-pencil\">\n                </div>\n            </div>\n        </div>\n        <div class=\"propertyValue\"\n             ng-switch-when=\"PropertyValue\">\n            <ui-multi-step-selector-widget class=\"multiStepSelectorWidget\"\n                                           mode=\"$ctrl.getMode()\"\n                                           step-1-item-name=\"$ctrl.ruleConditionValue.objectName\"\n                                           step-2-item-name=\"$ctrl.ruleConditionValue.propertyName\"\n                                           is-disabled=\"::!$ctrl.canUserManageFormRules\"></ui-multi-step-selector-widget>\n        </div>\n        <div class=\"literalValue\"\n             ng-switch-when=\"LiteralValue\">\n\n            <input type=\"text\"\n                   ng-model=\"$ctrl.ruleConditionValue.valueString\"\n                   ng-change=\"$ctrl.notifyLiteralValueChanged()\"\n                   placeholder=\"{{ $ctrl.literalValuePrompt }}\"\n                   ng-disabled=\"!$ctrl.canUserManageFormRules\"/>\n        </div>\n        <div class=\"variableValue\"\n             ng-switch-when=\"VariableValue\">\n            <div class=\"variableDropdown\"\n                 uib-dropdown\n                 ng-disabled=\"!$ctrl.canUserManageFormRules\">\n                <div class=\"dropdownLabel\"\n                     ng-class=\"{placeholder: !$ctrl.ruleConditionValue.variableName}\"\n                     uib-dropdown-toggle\n                     ng-disabled=\"!$ctrl.canUserManageFormRules\">\n                    {{ $ctrl.getVariableName() }}\n                    <div class=\"glyphicon glyphicon-chevron-down\"></div>\n                </div>\n                <ul uib-dropdown-menu>\n                    <li ng-repeat=\"variableValue in $ctrl.variableValueList\">\n                        <button class=\"btn btn-link\"\n                                ng-click=\"$ctrl.setVariableValue(variableValue)\">\n                            {{ variableValue.variableName }}\n                        </button>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2359:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RuleConditionValueController = function RuleConditionValueController($rootScope, $scope, $element, $stateParams, configurationConstant, localization, ruleMediator, ruleModel, umStudioConstant, uiFormTemplateModel, configurationMediator, fieldType) {
  this.$onInit = function () {
    var _this = this;
    $element.addClass('ruleConditionValue');
    this.variableValueList = ruleModel.getVariableValueList();
    this.fieldSearchableValues = [];
    this.switchedToLiteral = false;
    this.valueType = null;
    this.showVariableName = false;
    this.fieldSearchableValueNgModel = '';
    this.leftSideFieldValueClassCodeMockEffectiveDate = new Date();
    localization.getTranslationByKey('ruleConditionValue').then(function (translations) {
      _this.literalValuePrompt = _.get(translations, 'literalValuePrompt');
      _this.variableNamePrompt = _.get(translations, 'variableNamePrompt');
      _this.variableValuePrompt = _.get(translations, 'variableValuePrompt');
      _this.leftSideFieldValuePlaceholder = _.get(translations, 'leftSideFieldValuePlaceholder');
      _this.getValueTypeText = function () {
        if (this.valueType) {
          return _.get(translations, _.camelCase(this.valueType));
        }
        return null;
      };
    });
    $scope.$watch('$ctrl.defaultType', function (value) {
      if (value && (_this.valueType === 'LiteralValue' || _this.valueType === 'LeftSideFieldValue' || _this.valueType === 'LeftSideFieldValueClassCode')) {
        _this.ruleConditionValue.typeName = value;
      }
    });
    $scope.$watch('$ctrl.leftSideFieldName', function (newValue, oldValue) {
      if (newValue) {
        if (newValue !== oldValue) {
          _this.ruleConditionValue.valueString = null;
          _this.fieldSearchableValues = [];
          _this.leftSideFieldValueClassCodeMockFieldStructure = null;
        }
        _this.setupClassCode(_this.leftSideFormTemplateUniqueName, _this.leftSideFieldName);
        _this.getSearchableValues(_this.leftSideFormTemplateUniqueName, _this.leftSideFieldName);
      }
    });
    $scope.$watch('$ctrl.showLeftSideFieldValueOption', function (newValue, oldValue) {
      if (oldValue && !newValue && _this.valueType === 'LeftSideFieldValue') {
        _this.changeValueType('LiteralValue');
      }
    });
    $scope.$watch('$ctrl.showLeftSideFieldValueClassCodeOption', function (newValue, oldValue) {
      if (oldValue && !newValue && _this.valueType === 'LeftSideFieldValueClassCode') {
        _this.changeValueType('LiteralValue');
      }
    });
    $scope.$on(configurationConstant.event.SELECTOR_WIDGET_UPDATED, function (event, item1Name, item2) {
      var typeName = item2.typeName,
        isField = false;
      if (_this.valueType === 'PropertyValue') {
        _this.ruleConditionValue.objectName = item1Name;
        _this.ruleConditionValue.propertyName = item2.propertyName;
        _this.ruleConditionValue.objectType = _.capitalize(item1Name);
      } else {
        if (!_.isEmpty(item1Name) && !_.isEmpty(item2)) {
          _this.ruleConditionValue.formTemplateUniqueName = item1Name;
          _this.ruleConditionValue.fieldName = item2.fieldName;
          isField = true;
        } else {
          _this.ruleConditionValue.formTemplateUniqueName = null;
          _this.ruleConditionValue.fieldName = null;
          _this.ruleConditionValue.variableName = null;
        }
      }
      _this.ruleConditionValue.typeName = typeName;
      _this.notifyValueChanged({
        ruleConditionValue: _this.ruleConditionValue,
        type: typeName,
        isField: isField
      });
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    });
    if (!this.valueType) {
      this.determineValueType();
    }
    if (_.isEmpty(this.ruleConditionValue.formTemplateUniqueName) && _.isEmpty(this.ruleConditionValue.fieldName)) {
      this.ruleConditionValue.formTemplateUniqueName = this.defaultFormTemplateUniqueName;
      this.ruleConditionValue.fieldName = '';
    }
  };
  this.$onChanges = function (changes) {
    if (!this.valueType) {
      this.determineValueType();
    }
    if (!_.isNil(changes.showFieldValueClassCodeMultiSelectOption) && !_.isNil(changes.showFieldValueClassCodeMultiSelectOption.currentValue) && !_.isNil(changes.showFieldValueClassCodeMultiSelectOption.previousValue)) {
      if (this.valueType === 'LeftSideFieldValueClassCode') {
        this.setupClassCode(this.leftSideFormTemplateUniqueName, this.leftSideFieldName);
      }
    }
    if (!_.isNil(changes.showFieldValueMultiSelectOption) && !_.isNil(changes.showFieldValueMultiSelectOption.currentValue) && !_.isNil(changes.showFieldValueMultiSelectOption.previousValue)) {
      if (this.valueType === 'LeftSideFieldValue') {
        this.getSearchableValues(this.leftSideFormTemplateUniqueName, this.leftSideFieldName);
      }
    }
  };
  this.determineValueType = function () {
    var _this2 = this;
    var valueType = 'LiteralValue',
      isLiteralValue,
      valueInSearchableList,
      valueInSearchableListOrEmpty,
      listOfSelectedNames,
      listOfSelectedSearchItems,
      ruleConditionValueString;
    if (this.ruleConditionValue.objectUri) {
      if (_.lastIndexOf(this.ruleConditionValue.objectUri, '/') > 0) {
        valueType = this.ruleConditionValue.objectUri.substr(1, _.lastIndexOf(this.ruleConditionValue.objectUri, '/') - 1);
      } else {
        valueType = this.ruleConditionValue.objectUri.substr(1);
      }
    }
    isLiteralValue = valueType === 'LiteralValue';
    if (this.showFieldValueMultiSelectOption) {
      ruleConditionValueString = this.ruleConditionValue.valueString || '';
      listOfSelectedNames = ruleConditionValueString.split(',');
      listOfSelectedSearchItems = _.filter(this.fieldSearchableValues, function (item) {
        return _.indexOf(listOfSelectedNames, item.value) !== -1;
      });
      valueInSearchableList = listOfSelectedSearchItems.length > 0;
    } else {
      valueInSearchableList = _.find(this.fieldSearchableValues, function (fieldSearchableValue) {
        return fieldSearchableValue.value === _this2.ruleConditionValue.valueString;
      });
    }
    valueInSearchableListOrEmpty = valueInSearchableList || _.isEmpty(this.ruleConditionValue.valueString);
    if (isLiteralValue) {
      if (this.showLeftSideFieldValueOption && !_.isEmpty(this.fieldSearchableValues) && valueInSearchableListOrEmpty) {
        valueType = 'LeftSideFieldValue';
      } else if (this.shouldShowLeftSideFieldValueClassCodeOption()) {
        valueType = 'LeftSideFieldValueClassCode';
      }
    }
    this.valueType = valueType;
    return valueType;
  };
  this.changeValueType = function (newValueType) {
    this.valueType = newValueType;
    this.ruleConditionValue = ruleMediator.createConditionValue(newValueType, this.defaultType);
    this.fieldSearchableValueNgModel = '';
    if (this.leftSideFieldValueClassCodeMockFieldStructure) {
      this.leftSideFieldValueClassCodeMockFieldStructure.fieldModel = {};
    }
    this.notifyValueChanged({
      ruleConditionValue: this.ruleConditionValue,
      type: this.defaultType,
      isField: false
    });
    $rootScope.$broadcast(umStudioConstant.event.RULE_VARIABLE_VALUE_CHANGED);
    $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
  };
  this.getMode = function () {
    var mode = 'forms';
    if (this.valueType === 'PropertyValue') {
      mode = 'objects';
    }
    return mode;
  };
  this.notifyLiteralValueChanged = function () {
    $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
  };
  this.onVariableNameChange = function () {
    $rootScope.$broadcast(umStudioConstant.event.RULE_VARIABLE_VALUE_CHANGED);
    $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
  };
  this.getVariableName = function () {
    if (this.ruleConditionValue.variableName) {
      return this.ruleConditionValue.variableName;
    }
    return this.variableValuePrompt;
  };
  this.setVariableValue = function (variableValue) {
    var isField = false;
    this.ruleConditionValue.objectUri = '/VariableValue';
    this.ruleConditionValue.variableName = variableValue.variableName;
    this.ruleConditionValue.typeName = variableValue.typeName;
    this.ruleConditionValue.variableMethod = variableValue.variableMethod;
    this.notifyValueChanged({
      ruleConditionValue: this.ruleConditionValue,
      type: variableValue.typeName,
      isField: isField
    });
    $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
  };
  this.getFieldSearchableValueName = function () {
    var _this3 = this;
    var matchingName = '',
      matchingNameValue;
    if (!_.isEmpty(this.fieldSearchableValues)) {
      matchingNameValue = _.find(this.fieldSearchableValues, function (fieldSearchableValue) {
        return fieldSearchableValue.value === _this3.ruleConditionValue.valueString;
      });
      matchingName = matchingNameValue ? matchingNameValue.name : '';
    }
    return matchingName;
  };
  this.setFieldSearchableValue = function (fieldSearchableValue) {
    var isField = false;
    this.ruleConditionValue.objectUri = '/LiteralValue';
    this.ruleConditionValue.valueString = !_.isNil(fieldSearchableValue) ? fieldSearchableValue.value : null;
    this.ruleConditionValue.typeName = this.defaultType;
    this.fieldSearchableValueNgModel = fieldSearchableValue;
    this.notifyValueChanged({
      ruleConditionValue: this.ruleConditionValue,
      type: this.defaultType,
      isField: isField
    });
    $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
  };
  this.handleLeftSideFieldValueClassCodeValueChange = function (classCodeValue) {
    var isField = false;
    this.ruleConditionValue.objectUri = '/LiteralValue';
    this.ruleConditionValue.valueString = !_.isEmpty(classCodeValue) ? classCodeValue : null;
    this.ruleConditionValue.typeName = this.defaultType;
    this.notifyValueChanged({
      ruleConditionValue: this.ruleConditionValue,
      type: this.defaultType,
      isField: isField
    });
    $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
  };
  this.getSearchableValues = function (formTemplateUniqueName, fieldName) {
    var _this4 = this;
    this.fieldSearchableValueNgModel = null;
    ruleMediator.getSearchableValues(formTemplateUniqueName, fieldName).then(function (searchableValues) {
      var selectedSearchableValueName, ruleConditionValueString;
      if (!_.isEmpty(searchableValues)) {
        _this4.fieldSearchableValues = searchableValues;
        if (_this4.showFieldValueMultiSelectOption) {
          ruleConditionValueString = _this4.ruleConditionValue.valueString || '';
          selectedSearchableValueName = ruleConditionValueString.split(',');
          _this4.fieldSearchableValueNgModel = _.filter(_this4.fieldSearchableValues, function (item) {
            return _.indexOf(selectedSearchableValueName, item.value) !== -1;
          });
        } else {
          selectedSearchableValueName = _this4.getFieldSearchableValueName();
          _this4.fieldSearchableValueNgModel = _.find(_this4.fieldSearchableValues, function (item) {
            return item.name === selectedSearchableValueName;
          });
        }
        _this4.determineValueType();
      }
    });
  };
  this.setupClassCode = function (uiFormTemplateUniqueName, fieldName) {
    var _this5 = this;
    this.leftSideFieldValueClassCodeMockFieldStructure = null;
    configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName(uiFormTemplateUniqueName, fieldName).then(function (uiField) {
      if (uiField.fieldTemplate.type === fieldType.CLASSCODEFINDER) {
        _this5.leftSideFieldValueClassCodeMockFieldStructure = {
          rootFormId: null,
          parentForm: {
            hasWriteAccess: _this5.canUserManageFormRules
          },
          uiField: uiField,
          fieldModel: {
            value: _this5.ruleConditionValue.valueString
          },
          dynamicProperties: {},
          isConfigurableComponent: true
        };
        _this5.determineValueType();
      } else {
        _this5.leftSideFieldValueClassCodeMockFieldStructure = null;
      }
    });
  };
  this.shouldShowLeftSideFieldValueOption = function () {
    return this.showLeftSideFieldValueOption && !_.isEmpty(this.fieldSearchableValues);
  };
  this.shouldShowLeftSideFieldValueClassCodeOption = function () {
    return this.showLeftSideFieldValueClassCodeOption && !_.isNil(this.leftSideFieldValueClassCodeMockFieldStructure);
  };
  this.toggleShowVariableName = function () {
    this.showVariableName = !this.showVariableName;
  };
  this.handleMultiSelectFieldValueChange = function (selectedValueList) {
    var listOfSelectedItemValue = _.map(selectedValueList, function (item) {
      return item.value;
    });
    this.setFieldSearchableValue({
      value: listOfSelectedItemValue.toString()
    });
  };
};
RuleConditionValueController.$inject = ["$rootScope", "$scope", "$element", "$stateParams", "configurationConstant", "localization", "ruleMediator", "ruleModel", "umStudioConstant", "uiFormTemplateModel", "configurationMediator", "fieldType"];
angular.module('umCore').controller('ruleConditionValueController', RuleConditionValueController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2360:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2361);
__webpack_require__(2362);
__webpack_require__(2363);
var BinaryConditionComponent = {
  templateUrl: '/common/rule/ruleCondition/binaryCondition/binaryCondition.tpl.html',
  controller: 'binaryConditionController',
  bindings: {
    ruleCondition: '<',
    canUserManageFormRules: '<',
    defaultFormTemplateUniqueName: '<'
  }
};
angular.module('ums').component('uiBinaryCondition', BinaryConditionComponent);

/***/ }),

/***/ 2361:
/***/ (function(module) {

module.exports = JSON.parse("{\"binaryCondition\":{\"operatorDropdownPrompt\":\"Select operator\",\"operators\":{\"is in class code list\":\"is in list\"}}}");

/***/ }),

/***/ 2362:
/***/ (function(module, exports) {

var path = '/common/rule/ruleCondition/binaryCondition/binaryCondition.tpl.html';
var html = "<div class=\"binaryConditionContainer\">\n\n    <ui-rule-condition-value class=\"binaryRuleCondition\"\n                             rule-condition-value=\"$ctrl.ruleCondition.lhs\"\n                             show-literal-value-option=\"false\"\n                             show-left-side-field-value-option=\"false\"\n                             should-show-field-value-multi-select-option=\"false\"\n                             notify-value-changed=\"$ctrl.notifyLhsValueChange(ruleConditionValue, type, isField)\"\n                             can-user-manage-form-rules=\"::$ctrl.canUserManageFormRules\"\n                             default-form-template-unique-name=\"$ctrl.defaultFormTemplateUniqueName\"></ui-rule-condition-value>\n\n    <div class=\"operatorDropdown\"\n         ng-if=\"$ctrl.ruleCondition.lhs.typeName\"\n         uib-dropdown\n         ng-disabled=\"!$ctrl.canUserManageFormRules\">\n\n        <div class=\"dropdownLabel\"\n             uib-dropdown-toggle\n             ng-disabled=\"!$ctrl.canUserManageFormRules\">\n            {{ $ctrl.getOperatorName() }}\n            <span class=\"glyphicon glyphicon-chevron-down\"></span>\n        </div>\n\n        <ul uib-dropdown-menu>\n            <li ng-repeat=\"operator in $ctrl.operators track by $index\"\n                ng-click=\"$ctrl.changeOperator(operator)\">\n                <button class=\"btn btn-link\">\n                    {{ $ctrl.getOperator18n(operator) }}\n                </button>\n            </li>\n        </ul>\n    </div>\n\n    <ui-rule-condition-value class=\"binaryRuleCondition\"\n                             ng-if=\"$ctrl.ruleCondition.operatorName && $ctrl.ruleCondition.operatorName !== 'exists'\"\n                             rule-condition-value=\"$ctrl.ruleCondition.rhs\"\n                             notify-value-changed=\"$ctrl.notifyRhsValueChange(ruleConditionValue, type, isField)\"\n                             show-literal-value-option=\"true\"\n                             show-left-side-field-value-option=\"$ctrl.shouldShowLeftSideFieldValueOption()\"\n                             show-left-side-field-value-class-code-option=\"$ctrl.shouldShowLeftSideFieldValueClassCodeOption()\"\n                             show-field-value-multi-select-option=\"$ctrl.isInListOptionSelected\"\n                             show-field-value-class-code-multi-select-option=\"$ctrl.isInClassCodeListOptionSelected\"\n                             left-side-form-template-unique-name=\"$ctrl.ruleCondition.lhs.formTemplateUniqueName\"\n                             left-side-field-name=\"$ctrl.ruleCondition.lhs.fieldName\"\n                             can-user-manage-form-rules=\"::$ctrl.canUserManageFormRules\"\n                             default-type=\"$ctrl.ruleCondition.lhs.typeName\"\n                             default-form-template-unique-name=\"$ctrl.defaultFormTemplateUniqueName\"></ui-rule-condition-value>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2363:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var BinaryConditionController = function BinaryConditionController($element, $rootScope, $stateParams, localization, ruleMediator, umStudioConstant, ruleModel, configurationMediator, fieldType) {
  var _this = this;
  $element.addClass('binaryCondition');
  this.IS_IN_LIST = 'is in list';
  this.IS_IN_CLASS_CODE_LIST = 'is in class code list';
  this.operators = [];
  this.operatorDropdownPrompt = '';
  localization.getTranslationByKey('binaryCondition').then(function (translations) {
    var typeName, isField;
    _this.operatorDropdownPrompt = _.get(translations, 'operatorDropdownPrompt');
    _this.getOperatorName = function () {
      var operatorName = this.operatorDropdownPrompt;
      if (!_.isNil(this.ruleCondition.operatorName)) {
        operatorName = this.getOperator18n(this.ruleCondition.operatorName);
      }
      return operatorName;
    };
    _this.changeOperator = function (operator) {
      var _this2 = this;
      if (this.ruleCondition.operatorName !== operator) {
        if (this.ruleCondition.operatorName === 'exists') {
          configurationMediator.getFieldOptions(this.ruleCondition.lhs.formTemplateUniqueName, this.ruleCondition.lhs.fieldName).then(function (result) {
            var fieldOption = {};
            if (!_.isEmpty(result)) {
              fieldOption = result[0];
            }
            _this2.ruleCondition.lhs.typeName = fieldOption.typeName;
          });
        }
        this.ruleCondition.operatorName = operator;
        this.isInListOptionSelected = operator === this.IS_IN_LIST;
        this.isInClassCodeListOptionSelected = operator === this.IS_IN_CLASS_CODE_LIST;
        if (operator === 'exists') {
          this.ruleCondition.rhs = null;
        } else if (this.isInListOptionSelected || this.isInClassCodeListOptionSelected) {
          this.ruleCondition.rhs = {
            objectUri: '/LiteralValue'
          };
        } else {
          this.ruleCondition.rhs = {
            objectUri: '/LiteralValue'
          };
        }
        $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
      }
    };
    _this.getOperator18n = function (operator) {
      var translation = _.get(translations, "operators.".concat(operator));
      if (_.isNil(translation)) {
        translation = operator;
      }
      return translation;
    };
    _this.notifyLhsValueChange = function (ruleConditionValue, type, isField) {
      this.ruleCondition.lhs = ruleConditionValue;
      if (type) {
        this.refreshOperators(type, isField);
      } else {
        this.ruleCondition.operatorName = null;
        this.ruleCondition.rhs = {
          objectUri: '/LiteralValue'
        };
      }
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    _this.notifyRhsValueChange = function (ruleConditionValue) {
      this.ruleCondition.rhs = ruleConditionValue;
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    _this.refreshOperators = function (type, isField) {
      var _this3 = this;
      if (this.ruleCondition.operatorName === 'exists') {
        configurationMediator.getFieldOptions(this.ruleCondition.lhs.formTemplateUniqueName, this.ruleCondition.lhs.fieldName).then(function (result) {
          var fieldOption = {};
          if (!_.isEmpty(result)) {
            fieldOption = result[0];
          }
          ruleMediator.getOperators(fieldOption.typeName ? fieldOption.typeName : type, isField).then(function (operators) {
            _this3.operators = operators;
          });
        });
      } else {
        ruleMediator.getOperators(type, isField).then(function (operators) {
          _this3.operators = operators;
          if (!_.isEmpty(_this3.ruleCondition.lhs.formTemplateUniqueName) && !_.isEmpty(_this3.ruleCondition.lhs.fieldName)) {
            configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName(_this3.ruleCondition.lhs.formTemplateUniqueName, _this3.ruleCondition.lhs.fieldName).then(function (uiField) {
              if (uiField.fieldTemplate.type === fieldType.CLASSCODEFINDER) {
                // Filter out the "is in list" operator
                _this3.operators = _.filter(_this3.operators, function (operator) {
                  return operator !== _this3.IS_IN_LIST;
                });
              } else {
                // Filter out the "is in class code list" operator
                _this3.operators = _.filter(_this3.operators, function (operator) {
                  return operator !== _this3.IS_IN_CLASS_CODE_LIST;
                });
              }
            });
          } else {
            // Filter out the "is in class code list" operator
            _this3.operators = _.filter(_this3.operators, function (operator) {
              return operator !== _this3.IS_IN_CLASS_CODE_LIST;
            });
          }
        });
      }
    };
    _this.shouldShowLeftSideFieldValueOption = function () {
      return this.ruleCondition.lhs.formTemplateUniqueName && this.ruleCondition.lhs.fieldName && (this.ruleCondition.operatorName === '==' || this.ruleCondition.operatorName === this.IS_IN_LIST);
    };
    _this.shouldShowLeftSideFieldValueClassCodeOption = function () {
      return this.ruleCondition.lhs.formTemplateUniqueName && this.ruleCondition.lhs.fieldName && (this.ruleCondition.operatorName === '==' || this.ruleCondition.operatorName === this.IS_IN_CLASS_CODE_LIST);
    };
    if (_this.ruleCondition.lhs && _this.ruleCondition.lhs.typeName) {
      typeName = _this.ruleCondition.lhs.typeName;
      isField = _this.ruleCondition.lhs.fieldName ? true : false;
      _this.refreshOperators(typeName, isField);
      _this.isInListOptionSelected = _this.ruleCondition.operatorName === _this.IS_IN_LIST;
      _this.isInClassCodeListOptionSelected = _this.ruleCondition.operatorName === _this.IS_IN_CLASS_CODE_LIST;
    }
  });
};
BinaryConditionController.$inject = ["$element", "$rootScope", "$stateParams", "localization", "ruleMediator", "umStudioConstant", "ruleModel", "configurationMediator", "fieldType"];
angular.module('umCore').controller('binaryConditionController', BinaryConditionController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2364:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2365);
__webpack_require__(2366);
__webpack_require__(2367);
var RuleConditionGroupComponent = {
  templateUrl: '/common/rule/ruleConditionGroup/ruleConditionGroup.tpl.html',
  controller: 'ruleConditionGroupController',
  bindings: {
    ruleConditionGroup: '<',
    isTopLevel: '<',
    onDeleteGroup: '&',
    canUserManageFormRules: '<',
    defaultFormTemplateUniqueName: '<'
  }
};
angular.module('ums').component('uiRuleConditionGroup', RuleConditionGroupComponent);

/***/ }),

/***/ 2365:
/***/ (function(module) {

module.exports = JSON.parse("{\"ruleConditionGroup\":{\"if\":\"If\",\"any\":\"Any\",\"all\":\"All\",\"addCondition\":\"Add Condition\",\"addGroup\":\"Add Group\",\"binaryCondition\":\"Regular Condition\",\"rawCondition\":\"Custom Condition\"}}");

/***/ }),

/***/ 2366:
/***/ (function(module, exports) {

var path = '/common/rule/ruleConditionGroup/ruleConditionGroup.tpl.html';
var html = "<div class=\"topLevel\"\n     ng-if=\"$ctrl.isTopLevel\">\n    <div class=\"ifContainer\" ui-translate>ruleConditionGroup.if</div>\n    <div class=\"dottedLine\"></div>\n</div>\n<div class=\"groupContainer\"\n     ng-class=\"{ topLevelGroupContainer: $ctrl.isTopLevel }\">\n    <div class=\"groupHeader\">\n        <div class=\"logicalConjunctionDropdown\"\n             uib-dropdown\n             ng-disabled=\"!$ctrl.canUserManageFormRules\">\n            <div class=\"dropdownLabel\"\n                 uib-dropdown-toggle\n                 ng-disabled=\"!$ctrl.canUserManageFormRules\">\n                {{ $ctrl.getOperatorText() }}\n                <div class=\"glyphicon glyphicon-chevron-down\"></div>\n            </div>\n            <ul uib-dropdown-menu>\n                <li>\n                    <button class=\"btn btn-link\"\n                            ng-click=\"$ctrl.changeOperator('or')\"\n                            ui-translate>ruleConditionGroup.any\n                    </button>\n                </li>\n                <li>\n                    <button class=\"btn btn-link\"\n                            ng-click=\"$ctrl.changeOperator('and')\"\n                            ui-translate>ruleConditionGroup.all\n                    </button>\n                </li>\n            </ul>\n        </div>\n        <div class=\"spacer\">\n\n        </div>\n        <div class=\"deleteGroupContainer\"\n             ng-if=\"!$ctrl.isTopLevel\">\n            <button class=\"glyphicon glyphicon-trash\"\n                    ng-click=\"$ctrl.deleteGroup()\"\n                    ng-if=\"$ctrl.canUserManageFormRules\"></button>\n        </div>\n    </div>\n\n    <div class=\"groupBody\">\n        <div class=\"ruleConditionsContainer\">\n            <ui-rule-condition ng-repeat=\"ruleCondition in $ctrl.ruleConditionGroup.subconditions\"\n                               rule-condition=\"$ctrl.getCondition(ruleCondition)\"\n                               on-delete-subcondition=\"$ctrl.doDeleteSubcondition(ruleCondition)\"\n                               on-toggle-negation=\"$ctrl.doToggleNegation(ruleCondition, isUnaryCondition)\"\n                               is-unary-condition=\"$ctrl.isUnaryCondition(ruleCondition)\"\n                               default-form-template-unique-name=\"$ctrl.defaultFormTemplateUniqueName\"\n                               ng-class=\"{negated: $ctrl.isUnaryCondition(ruleCondition), group: $ctrl.isGroup(ruleCondition), ruleNo{{$index}} : $index < 100 }\"\n                               can-user-manage-form-rules=\"::$ctrl.canUserManageFormRules\"></ui-rule-condition>\n\n            <div class=\"groupButtonContainer\">\n                <div class=\"addConditionDropdown\"\n                     uib-dropdown>\n                    <button class=\"btn dropdownLabel\"\n                            uib-dropdown-toggle\n                            ng-if=\"$ctrl.canUserManageFormRules\">\n                        <span ui-translate>ruleConditionGroup.addCondition</span>\n                        <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                    </button>\n\n                    <ul class=\"scrollable-menu condition-menu\" uib-dropdown-menu aria-labelledby=\"simple-dropdown\">\n                        <li ng-repeat=\"conditionType in $ctrl.ruleConditionTypes\">\n                            <button class=\"btn btn-link\"\n                                    ng-click=\"$ctrl.addCondition(conditionType.name)\"\n                                    ui-translate>{{ $ctrl.getConditionName(conditionType.name) }}\n                            </button>\n                        </li>\n                    </ul>\n\n\n                </div>\n                <button ng-click=\"$ctrl.addGroup()\"\n                        class=\"btn addGroupBtn\"\n                        ng-if=\"$ctrl.canUserManageFormRules\">\n\n                    <span ui-translate>ruleConditionGroup.addGroup</span>\n\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2367:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RuleConditionGroupController = function RuleConditionGroupController($rootScope, $scope, $element, $stateParams, localization, ruleMediator, ruleUtil, umStudioConstant, ruleModel, ruleConditionType) {
  $element.addClass('ruleConditionGroup');
  localization.getTranslations().then(function (translations) {
    this.any = _.get(translations, 'ruleConditionGroup.any');
    this.all = _.get(translations, 'ruleConditionGroup.all');
    this.changeOperator = function (operator) {
      this.ruleConditionGroup.operator = operator;
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    this.getOperatorText = function () {
      if (this.ruleConditionGroup && this.ruleConditionGroup.operator === 'and') {
        return this.all;
      } else {
        return this.any;
      }
    };
    this.addCondition = function (conditionType) {
      ruleMediator.addCondition(this.ruleConditionGroup, conditionType);
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    this.addGroup = function () {
      ruleMediator.addGroup(this.ruleConditionGroup);
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    this.deleteGroup = function () {
      this.onDeleteGroup({
        ruleConditionGroup: this.ruleConditionGroup
      });
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    this.doDeleteSubcondition = function (subcondition) {
      ruleMediator.deleteSubcondition(this.ruleConditionGroup, subcondition);
      $rootScope.$broadcast(umStudioConstant.event.RULE_VARIABLE_VALUE_CHANGED);
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    this.getCondition = function (condition) {
      if (this.isUnaryCondition(condition)) {
        return condition.subcondition;
      }
      return condition;
    };
    this.ruleConditionTypes = null;
    this.getConditionTypes = function () {
      var ruleConditionTypes = [];
      ruleMediator.getConditionTypes().then(function (result) {
        _.each(result, function (conditionType) {
          if (conditionType.name === ruleConditionType.BINARY || conditionType.name === ruleConditionType.RAW) {
            ruleConditionTypes.push(conditionType);
          }
        }.bind(this));
      }.bind(this));
      this.ruleConditionTypes = ruleConditionTypes;
    };
    this.getConditionName = function (name) {
      return _.get(translations, 'ruleConditionGroup.' + name + 'Condition');
    };
    this.isUnaryCondition = function (subcondition) {
      if (subcondition) {
        var conditionType = ruleUtil.getConditionType(subcondition.objectUri);
        return conditionType === 'UnaryCondition';
      }
      return false;
    };
    this.isGroup = function (subcondition) {
      if (subcondition) {
        if (this.isUnaryCondition(subcondition)) {
          return this.isGroup(subcondition.subcondition);
        } else if (ruleUtil.getConditionType(subcondition.objectUri) === 'CompositeCondition') {
          return true;
        }
      }
      return false;
    };
    this.doToggleNegation = function (ruleCondition, isUnaryCondition) {
      var unaryCondition;
      if (isUnaryCondition) {
        unaryCondition = _.find(this.ruleConditionGroup.subconditions, function (subcondition) {
          return this.isUnaryCondition(subcondition) && subcondition.subcondition === ruleCondition;
        }.bind(this));
        ruleCondition = ruleMediator.convertFromUnaryCondition(this.ruleConditionGroup, unaryCondition);
      } else {
        ruleCondition = ruleMediator.convertToUnaryCondition(this.ruleConditionGroup, ruleCondition);
      }
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    this.createVariableValueList = function () {
      if (this.isTopLevel) {
        ruleMediator.createVariableValueList(this.ruleConditionGroup);
      }
    };
    $scope.$on(umStudioConstant.event.RULE_VARIABLE_VALUE_CHANGED, function () {
      this.createVariableValueList();
    }.bind(this));
    this.createVariableValueList();
    this.getConditionTypes();
  }.bind(this));
};
RuleConditionGroupController.$inject = ["$rootScope", "$scope", "$element", "$stateParams", "localization", "ruleMediator", "ruleUtil", "umStudioConstant", "ruleModel", "ruleConditionType"];
angular.module('umCore').controller('ruleConditionGroupController', RuleConditionGroupController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2368:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2369);
__webpack_require__(2370);
__webpack_require__(2371);
var RuleHeaderComponent = {
  templateUrl: '/common/rule/ruleHeader/ruleHeader.tpl.html',
  controller: 'ruleHeaderController',
  bindings: {
    rule: '<',
    isNew: '<',
    canUserManageRules: '<',
    isFieldRule: '<'
  }
};
angular.module('ums').component('uiRuleHeader', RuleHeaderComponent);

/***/ }),

/***/ 2369:
/***/ (function(module) {

module.exports = JSON.parse("{\"ruleHeader\":{\"addADescription\":\"Add a description\",\"errorModal\":{\"blankRule\":\"Rule name must not be blank.\",\"okButtonLabel\":\"OK\",\"title\":\"Error\",\"uniqueRule\":\"This name already exists. Please choose another name.\"},\"status\":{\"0\":\"Inactive\",\"1\":\"Active\",\"2\":\"Invalid\"},\"review\":\"Review\",\"reviewRule\":{\"notificationMessage\":\"Validating rule\",\"reviewRuleModal\":{\"title\":\"Review Rule\",\"rulesText\":\"Rules Text\",\"errors\":\"Errors\",\"ok\":\"Done\"}},\"ruleNamePlaceholder\":\"Enter a rule name\"}}");

/***/ }),

/***/ 2370:
/***/ (function(module, exports) {

var path = '/common/rule/ruleHeader/ruleHeader.tpl.html';
var html = "<div class=\"ruleHeaderContainer\">\n    <div class=\"ruleInfo\">\n        <input class=\"ruleName\"\n               ng-attr-placeholder=\"{{ ::$ctrl.ruleNamePlaceholder }}\"\n               ui-max-chars=\"100\"\n               ng-model=\"$ctrl.ruleNameSubstring\"\n               ng-change=\"$ctrl.onRuleNameChange()\"\n               ng-blur=\"$ctrl.onRuleNameBlur()\"\n               ui-set-focus=\"{{::$ctrl.umStudioConstant.event.FOCUS_ON_RULE_NAME}}\"\n               ng-disabled=\"::!$ctrl.canUserManageRules\">\n\n        <textarea class=\"description\"\n                  ng-model=\"$ctrl.rule.description\"\n                  ng-attr-placeholder=\"{{ ::$ctrl.descriptionPlaceholder }}\"\n                  ng-change=\"$ctrl.onDescriptionChange()\"\n                  maxlength=\"255\"\n                  rows=\"1\"\n                  ui-auto-expand\n                  ng-disabled=\"::!$ctrl.canUserManageRules\"></textarea>\n\n        <div class=\"reviewRow\">\n                <span class=\"review btn-link\" ui-translate\n                      ng-click=\"$ctrl.reviewRule()\">\n                      ruleHeader.review\n                </span>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2371:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RuleHeaderController = function RuleHeaderController($rootScope, $scope, $element, $uibModal, configurationMediator, formViewerConstant, loadingBarHandler, localization, modalUtil, ruleUtil, uiFormTemplateModel, umStudioConstant, ruleModel) {
  $element.addClass('ruleHeader');
  this.umStudioConstant = umStudioConstant;
  localization.getTranslationByKey('ruleHeader').then(function (translations) {
    this.descriptionPlaceholder = _.get(translations, 'addADescription');
    this.ruleNamePlaceholder = _.get(translations, 'ruleNamePlaceholder');
    this.ruleNameSubstring = ruleUtil.getRuleNameSubstring(this.rule);
    this.$onChanges = function () {
      this.ruleNameSubstring = ruleUtil.getRuleNameSubstring(this.rule);
    };
    this.onRuleNameChange = function () {
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    this.onRuleNameBlur = function () {
      var ruleNameParts,
        oldRuleNameSubstring = ruleUtil.getRuleNameSubstring(this.rule),
        fieldRules = uiFormTemplateModel.getUiFormTemplate().fieldRules,
        duplicateFieldRuleIndex = -1,
        _options;
      if (this.ruleNameSubstring !== oldRuleNameSubstring) {
        if (_.isEmpty(this.ruleNameSubstring)) {
          this.ruleNameSubstring = oldRuleNameSubstring;
          $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
          _options = {};
          _options.title = _.get(translations, 'errorModal.title');
          _options.summary = _.get(translations, 'errorModal.blankRule');
          _options.confirmActionButtonLabel = _.get(translations, 'errorModal.okButtonLabel');
          var modalInstance = $uibModal.open({
            templateUrl: '/ui/modal/modal.tpl.html',
            controller: 'modalController',
            windowClass: 'genericModal',
            resolve: {
              options: function options() {
                return _options;
              }
            }
          });
          $scope.$broadcast(umStudioConstant.event.FOCUS_ON_RULE_NAME);
        } else {
          if (this.isFieldRule) {
            duplicateFieldRuleIndex = _.findIndex(fieldRules, function (fieldRule) {
              return ruleUtil.getRuleNameSubstring(fieldRule) === this.ruleNameSubstring;
            }.bind(this));
          }
          if (duplicateFieldRuleIndex !== -1) {
            this.ruleNameSubstring = oldRuleNameSubstring;
            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
            _options = {};
            _options.title = _.get(translations, 'errorModal.title');
            _options.summary = _.get(translations, 'errorModal.uniqueRule');
            _options.confirmActionButtonLabel = _.get(translations, 'errorModal.okButtonLabel');
            var modalInstance = $uibModal.open({
              templateUrl: '/ui/modal/modal.tpl.html',
              controller: 'modalController',
              windowClass: 'genericModal',
              resolve: {
                options: function options() {
                  return _options;
                }
              }
            });
            $scope.$broadcast(umStudioConstant.event.FOCUS_ON_RULE_NAME);
          } else {
            ruleUtil.updateUiFieldTriggerRuleNames(uiFormTemplateModel.getUiFormTemplate(), oldRuleNameSubstring, this.ruleNameSubstring);
            if (!_.isNil(this.rule.name) && this.rule.name.lastIndexOf('-#') !== -1) {
              ruleNameParts = _.split(this.rule.name, '-#');
              this.rule.name = this.ruleNameSubstring + '-#' + ruleNameParts[1];
            } else {
              this.rule.name = this.ruleNameSubstring;
            }
          }
        }
      }
    };
    this.onDescriptionChange = function () {
      $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    };
    this.reviewRule = function () {
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'reviewRule.notificationMessage'));
      return configurationMediator.validateRule(this.rule).then(function (result) {
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
        showValidateRuleModal(result);
      }, function (error) {
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
      });
    };
    function showValidateRuleModal(validateRuleResult) {
      var instance = $uibModal.open({
        templateUrl: '/configuration/formEditor/content/rule/reviewRule/validateRuleModal.tpl.html',
        controller: 'validateRuleModalController',
        windowClass: 'validateRuleModal',
        resolve: {
          options: function options() {
            return {
              ruleText: validateRuleResult.ruleText,
              error: validateRuleResult.errors
            };
          }
        }
      });
      return instance.result;
    }
  }.bind(this));
};
RuleHeaderController.$inject = ["$rootScope", "$scope", "$element", "$uibModal", "configurationMediator", "formViewerConstant", "loadingBarHandler", "localization", "modalUtil", "ruleUtil", "uiFormTemplateModel", "umStudioConstant", "ruleModel"];
angular.module('umCore').controller('ruleHeaderController', RuleHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2372:
/***/ (function(module) {

module.exports = JSON.parse("{\"formRules\":{\"conditionalMessage\":\"Field Rules can only be created when one or more fields on the form are conditional.\",\"createANewRuleNow\":\"Create a new rule now\",\"noFieldRulesMessage\":\"No field rules have been created yet.\"}}");

/***/ }),

/***/ 2373:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/rule/formRules.tpl.html';
var html = "<div class=\"formRules\">\n\n    <div class=\"ruleBuilderLeftNavContainer\">\n        <ui-rule-builder-left-nav class=\"open\"\n                                  show-new-rule-button=\"!showConditionalMessage()\"\n                                  ui-form-template=\"viewModel.uiFormTemplate\"\n                                  can-user-manage-form-rules=\"viewModel.canUserManageFormRules\"></ui-rule-builder-left-nav>\n    </div>\n\n    <div class=\"ruleBuilderContainer\">\n        <ui-form-rule-builder\n            ng-if=\"viewModel.formRule\"\n            form-rule=\"viewModel.formRule\"\n            can-user-manage-form-rules=\"viewModel.canUserManageFormRules\"></ui-form-rule-builder>\n        <ui-field-rule-builder\n            ng-if=\"viewModel.fieldRule\"\n            field-rule=\"viewModel.fieldRule\"\n            can-user-manage-form-rules=\"viewModel.canUserManageFormRules\"\n            focus-on-rule-name=\"viewModel.focusOnRuleName\"></ui-field-rule-builder>\n\n        <div class=\"infoMessage\"\n             ng-if=\"showConditionalMessage()\">\n            <div class=\"glyphicon glyphicon-exclamation-sign\">\n\n            </div>\n            <div ui-translate>\n                formRules.conditionalMessage\n            </div>\n        </div>\n\n        <div class=\"infoMessage\"\n             ng-if=\"!showConditionalMessage() && showNoFieldRulesMessage()\">\n            <div class=\"glyphicon glyphicon-exclamation-sign\">\n\n            </div>\n            <div ui-translate>\n                formRules.noFieldRulesMessage\n            </div>\n            <div class=\"linkContainer\">\n                <a class=\"newRuleLink\"\n                   ng-click=\"createNewFieldRule()\"\n                   ui-translate>\n                    formRules.createANewRuleNow\n                </a>\n            </div>\n        </div>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2374:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormRulesController = function FormRulesController($element, $rootScope, $scope, $stateParams, $q, authorizationConstants, configurationMediator, currentUserModel, formTemplateStatus, formViewerConstant, localization, uiFormTemplateModel, umStudioConstant, formViewerModel, loadingBarHandler, configurationActionsUtil) {
  $element.addClass('formRules');
  $scope.viewModel = {
    formRule: null,
    fieldRule: null,
    uiFormTemplate: null,
    focusOnRuleName: false,
    doSave: false
  };
  function initialize(uiFormTemplate) {
    uiFormTemplateModel.setUiFormTemplate(uiFormTemplate);
    $scope.viewModel.uiFormTemplate = uiFormTemplate;
    $scope.viewModel.formRule = uiFormTemplate.triggerRule;
    $scope.viewModel.canUserManageFormRules = canManageFormRules(uiFormTemplate);
    if (!_.isNil($stateParams.ruleName)) {
      uiFormTemplateModel.setSelectedFieldRuleName($stateParams.ruleName);
    }
  }
  function canManageFormRules(uiFormTemplate) {
    var isAuthorizedToManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);
    return formTemplateStatus.IN_PRODUCTION !== uiFormTemplate.formTemplate.status && isAuthorizedToManageForms;
  }
  $scope.$on(umStudioConstant.event.RULE_UPDATED, function () {
    $scope.viewModel.doSave = true;
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
  });
  $scope.$on(formViewerConstant.event.formBuilder.FORM_TEMPLATE_SAVED, function () {
    $scope.viewModel.doSave = false;
  });
  configurationMediator.getFormTemplateById($stateParams.uiFormTemplateId).then(initialize);
  $scope.$on(umStudioConstant.event.FORM_RULE_SELECTED, function () {
    $scope.saveFormTemplate().then(function () {
      $scope.viewModel.formRule = uiFormTemplateModel.getUiFormTemplate().triggerRule;
      $scope.viewModel.fieldRule = null;
      uiFormTemplateModel.setCurrentSelectedRule('formRule');
    });
  });
  $scope.$on(umStudioConstant.event.FIELD_RULE_SELECTED, function (event, fieldRule, focusOnRuleName, isNewRule) {
    if (!_.isNil(isNewRule) && $scope.viewModel.doSave) {
      $scope.viewModel.doSave = false;
      $scope.viewModel.fieldRule = fieldRule;
      $scope.viewModel.formRule = null;
      $scope.viewModel.focusOnRuleName = focusOnRuleName;
      uiFormTemplateModel.setCurrentSelectedRule('fieldRule');
    } else {
      if (_.isNil(fieldRule) || _.isNil($scope.viewModel.fieldRule) || fieldRule.name !== $scope.viewModel.fieldRule.name) $scope.saveFormTemplate().then(function () {
        $scope.viewModel.fieldRule = fieldRule;
        $scope.viewModel.formRule = null;
        $scope.viewModel.focusOnRuleName = focusOnRuleName;
        uiFormTemplateModel.setCurrentSelectedRule('fieldRule');
        uiFormTemplateModel.setSelectedFieldRuleName(fieldRule.name.substr(0, _.indexOf(fieldRule.name, '-')));
      });
    }
  });
  $scope.$on(umStudioConstant.event.RESET_RULE_SELECTION, function (event) {
    $scope.viewModel.fieldRule = null;
    $scope.viewModel.formRule = null;
  });
  $scope.saveFormTemplate = function () {
    var formStructure,
      uiFormTemplate,
      uiFormTemplateId = $scope.viewModel.uiFormTemplate.id,
      deferred = $q.defer();
    if ($scope.viewModel.doSave) {
      formStructure = formViewerModel.getFormStructure(uiFormTemplateId);
      if (formStructure) {
        configurationActionsUtil.populateUiFormTemplateModel(uiFormTemplateId);
        uiFormTemplate = formStructure.uiFormTemplate;
      } else {
        uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();
      }
      loadingBarHandler.showLoadingBar('formEditor.saveUiFormTemplate.loadingBar');
      if (_.isNil(uiFormTemplate.id)) {
        configurationMediator.createFormTemplate(uiFormTemplate).then(function (uiFormTemplate) {
          loadingBarHandler.hideLoadingBar();
          configurationActionsUtil.handleUiFormTemplateSave(uiFormTemplate, false).then(function () {
            $scope.viewModel.doSave = false;
            $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_SAVED, uiFormTemplate);
            deferred.resolve();
          });
        });
      } else {
        configurationMediator.updateFormTemplate(uiFormTemplate, uiFormTemplate.id).then(function (uiFormTemplate) {
          loadingBarHandler.hideLoadingBar();
          configurationActionsUtil.handleUiFormTemplateSave(uiFormTemplate, false).then(function () {
            $scope.viewModel.doSave = false;
            $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_SAVED, uiFormTemplate);
            deferred.resolve();
          });
        });
      }
    } else {
      deferred.resolve();
    }
    return deferred.promise;
  };
  $scope.showConditionalMessage = function () {
    var conditionalFieldCount = 0;
    if (!_.isNil($scope.viewModel.uiFormTemplate) && _.isNil($scope.viewModel.formRule) && _.isNil($scope.viewModel.fieldRule)) {
      conditionalFieldCount = _.reduce($scope.viewModel.uiFormTemplate.formTemplate.fieldTemplates, function (count, fieldTemplate) {
        if (fieldTemplate.hidden) {
          count++;
        }
        return count;
      }, 0);
      return conditionalFieldCount === 0;
    }
    return false;
  };
  $scope.showNoFieldRulesMessage = function () {
    if (!_.isNil($scope.viewModel.uiFormTemplate) && _.isNil($scope.viewModel.formRule) && _.isNil($scope.viewModel.fieldRule) && _.isEmpty($scope.viewModel.uiFormTemplate.fieldRules)) {
      return true;
    }
    return false;
  };
  $scope.createNewFieldRule = function () {
    $rootScope.$broadcast(umStudioConstant.event.CREATE_NEW_FIELD_RULE);
  };
  $scope.$on('$destroy', function () {
    uiFormTemplateModel.setUiFormTemplate(null);
  });
};
FormRulesController.$inject = ["$element", "$rootScope", "$scope", "$stateParams", "$q", "authorizationConstants", "configurationMediator", "currentUserModel", "formTemplateStatus", "formViewerConstant", "localization", "uiFormTemplateModel", "umStudioConstant", "formViewerModel", "loadingBarHandler", "configurationActionsUtil"];
angular.module('ums.configuration').controller('formRulesController', FormRulesController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2375:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2376);
__webpack_require__(2377);
__webpack_require__(2378);
var FieldRuleActionComponent = {
  templateUrl: '/configuration/formEditor/content/rule/fieldRuleBuilder/fieldRuleAction.tpl.html',
  controller: 'fieldRuleActionController',
  bindings: {
    fieldRule: '<',
    fieldsInRule: '<',
    canUserManageFormRules: '<',
    onFieldsInRuleUpdated: '&'
  }
};
angular.module('ums').component('uiFieldRuleAction', FieldRuleActionComponent);

/***/ }),

/***/ 2376:
/***/ (function(module) {

module.exports = JSON.parse("{\"fieldRuleAction\":{\"selectFieldsPrompt\":\"Select one or more fields on this form\",\"showFields\":\"Show field(s)\",\"thisForm\":\"This form\"}}");

/***/ }),

/***/ 2377:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/rule/fieldRuleBuilder/fieldRuleAction.tpl.html';
var html = "<div class=\"showFieldsContainer\"\n     ui-translate>fieldRuleAction.showFields\n</div>\n<ui-multi-select class=\"multiSelect\"\n                 items-list=\"$ctrl.availableConditionalFieldList\"\n                 prompt-value=\"$ctrl.selectFieldsPrompt\"\n                 item-name=\"$ctrl.selectFieldWidgetName\"\n                 selected-value=\"$ctrl.selectedFields\"\n                 append-to-body=\"true\"\n                 optional-prefix=\"$ctrl.thisForm\"\n                 is-disabled=\"::!$ctrl.canUserManageFormRules\">\n</ui-multi-select>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2378:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FieldRuleActionController = function FieldRuleActionController($element, $scope, localization, coreConstant, configurationMediator, uiFormTemplateModel) {
  $element.addClass('fieldRuleAction');
  this.selectFieldWidgetName = 'selectConditionalField';
  this.availableConditionalFieldList = [];
  this.selectedFields = '';
  this.thisForm = '';
  this.uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();
  localization.getTranslations().then(function (translations) {
    this.selectFieldsPrompt = _.get(translations, 'fieldRuleAction.selectFieldsPrompt');
    this.thisForm = _.get(translations, 'fieldRuleAction.thisForm');
  }.bind(this));
  this.getRuleNameSubstring = function () {
    var nameSubstring = this.fieldRule.name.lastIndexOf('-#') !== -1 ? this.fieldRule.name.substr(0, this.fieldRule.name.lastIndexOf('-#')) : this.fieldRule.name;
    return nameSubstring;
  };
  this.reset = function () {
    this.availableConditionalFieldList = [];
    this.selectedFields = '';
  };
  this.processAvailableConditionalFieldTemplates = function () {
    var existingAvailableConditionalField;
    _.each(this.fieldsInRule, function (fieldInRule) {
      existingAvailableConditionalField = _.find(this.availableConditionalFieldList, function (availableConditionalField) {
        return fieldInRule.id === parseInt(availableConditionalField.value);
      });
      if (_.isNil(existingAvailableConditionalField)) {
        this.availableConditionalFieldList.push({
          name: fieldInRule.variableName,
          value: fieldInRule.id.toString(),
          grouping: 'Conditional Fields',
          fieldTemplate: fieldInRule
        });
      }
      this.selectedFields += fieldInRule.id + '::';
    }.bind(this));
  };
  this.getAvailableConditionalFieldTemplateIds = _.debounce(function () {
    configurationMediator.getAvailableConditionalFieldTemplateIds(this.uiFormTemplate.id).then(function (result) {
      this.reset();
      _.each(result, function (fieldTemplateId) {
        _.each(this.uiFormTemplate.formTemplate.fieldTemplates, function (fieldTemplate) {
          if (fieldTemplate.id === fieldTemplateId) {
            this.availableConditionalFieldList.push({
              name: fieldTemplate.variableName,
              value: fieldTemplate.id.toString(),
              grouping: 'Conditional Fields',
              fieldTemplate: fieldTemplate
            });
          }
        }.bind(this));
      }.bind(this));
      this.processAvailableConditionalFieldTemplates();
    }.bind(this));
  }.bind(this), 500);
  this.$onInit = function () {
    this.getAvailableConditionalFieldTemplateIds();
  };
  this.$onChanges = function () {
    this.getAvailableConditionalFieldTemplateIds();
  };
  $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, _.debounce(function (event, itemName) {
    var existingFieldInRule,
      conditionalFieldsNotInRule = [];
    if (itemName === this.selectFieldWidgetName) {
      _.each(this.availableConditionalFieldList, function (availableConditionalField) {
        if (!availableConditionalField.selected) {
          availableConditionalField.fieldTemplate.triggerRuleName = null;
          conditionalFieldsNotInRule.push(availableConditionalField.fieldTemplate);
          _.remove(this.fieldsInRule, function (fieldInRule) {
            return parseInt(availableConditionalField.value) === fieldInRule.id;
          });
        } else {
          existingFieldInRule = _.find(this.fieldsInRule, function (fieldInRule) {
            return fieldInRule.id === parseInt(availableConditionalField.value);
          });
          if (_.isNil(existingFieldInRule)) {
            availableConditionalField.fieldTemplate.triggerRuleName = this.getRuleNameSubstring();
            this.fieldsInRule.push(availableConditionalField.fieldTemplate);
          }
        }
      }.bind(this));
      this.selectedFields = '';
      this.processAvailableConditionalFieldTemplates();
      this.onFieldsInRuleUpdated({
        conditionalFieldsNotInRule: conditionalFieldsNotInRule
      });
    }
  }.bind(this)), 500);
};
FieldRuleActionController.$inject = ["$element", "$scope", "localization", "coreConstant", "configurationMediator", "uiFormTemplateModel"];
angular.module('ums.configuration').controller('fieldRuleActionController', FieldRuleActionController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2379:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2380);
__webpack_require__(2381);
__webpack_require__(2382);
__webpack_require__(2383);
var FieldRuleBuilderComponent = {
  templateUrl: '/configuration/formEditor/content/rule/fieldRuleBuilder/fieldRuleBuilder.tpl.html',
  controller: 'fieldRuleBuilderController',
  bindings: {
    fieldRule: '<',
    canUserManageFormRules: '<',
    focusOnRuleName: '<'
  }
};
angular.module('ums').component('uiFieldRuleBuilder', FieldRuleBuilderComponent);

/***/ }),

/***/ 2380:
/***/ (function(module) {

module.exports = JSON.parse("{\"fieldRuleBuilder\":{\"deleteTheseFields\":\"Delete these fields\",\"else\":\"Else\",\"hideTheseFields\":\"Hide these fields\",\"then\":\"Then\"}}");

/***/ }),

/***/ 2381:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/rule/fieldRuleBuilder/fieldRuleBuilder.tpl.html';
var html = "<div class=\"fieldRuleBuilderContainer\">\n\n    <ui-rule-header rule=\"$ctrl.fieldRule\"\n                    can-user-manage-rules=\"::$ctrl.canUserManageFormRules\"\n                    is-field-rule=\"true\"></ui-rule-header>\n\n    <div class=\"ruleContent\">\n        <div class=\"ruleConditions\">\n            <ui-rule-condition-group rule-condition-group=\"$ctrl.fieldRule.condition\"\n                                     is-top-level=\"true\"\n                                     default-form-template-unique-name=\"$ctrl.uiFormTemplate.formTemplate.uniqueName\"\n                                     can-user-manage-form-rules=\"::$ctrl.canUserManageFormRules\"></ui-rule-condition-group>\n        </div>\n\n        <div class=\"thenContainer\"\n             ui-translate>fieldRuleBuilder.then\n        </div>\n\n        <div class=\"thenSubContainer\">\n            <div class=\"dottedLine\"></div>\n            <ui-field-rule-action\n                field-rule=\"$ctrl.fieldRule\"\n                fields-in-rule=\"$ctrl.fieldsInRule\"\n                can-user-manage-form-rules=\"::$ctrl.canUserManageFormRules\"\n                on-fields-in-rule-updated=\"$ctrl.doFieldsInRuleUpdated(conditionalFieldsNotInRule)\"></ui-field-rule-action>\n        </div>\n\n        <div class=\"elseContainer\"\n             ui-translate>fieldRuleBuilder.else\n        </div>\n\n        <div class=\"hideOrDeleteContainer\">\n            <div class=\"hideOrDeleteDropdown\"\n                 uib-dropdown\n                 ng-disabled=\"!$ctrl.canUserManageFormRules\">\n\n                <div class=\"dropdownLabel hideOrDeleteDropdownLabel\"\n                     uib-dropdown-toggle\n                     ng-disabled=\"!$ctrl.canUserManageFormRules\">\n                    {{ $ctrl.getHideOrDeleteLabel() }}\n                    <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                </div>\n\n                <ul uib-dropdown-menu>\n                    <li ng-click=\"$ctrl.hideFields()\">\n                        <button class=\"btn btn-link\">\n                            {{ $ctrl.hideTheseFields }}\n                        </button>\n                    </li>\n                    <li ng-click=\"$ctrl.deleteFields()\">\n                        <button class=\"btn btn-link\">\n                            {{ $ctrl.deleteTheseFields }}\n                        </button>\n                    </li>\n                </ul>\n\n            </div>\n        </div>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2382:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FieldRuleBuilderController = function FieldRuleBuilderController($element, $rootScope, $scope, $timeout, formViewerConstant, localization, ruleUtil, uiFormTemplateModel, umStudioConstant) {
  var timeoutList = [];
  $element.addClass('fieldRuleBuilder');
  this.hideTheseFields = '';
  this.deleteTheseFields = '';
  this.hide = false;
  this.uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();
  this.fieldsInRule = [];
  localization.getTranslations().then(function (translations) {
    this.hideTheseFields = _.get(translations, 'fieldRuleBuilder.hideTheseFields');
    this.deleteTheseFields = _.get(translations, 'fieldRuleBuilder.deleteTheseFields');
    this.getHideOrDeleteLabel = function () {
      if (this.hide) {
        return this.hideTheseFields;
      } else {
        return this.deleteTheseFields;
      }
    };
  }.bind(this));
  this.isDescriptionSet = function () {
    return !_.isEmpty(this.fieldRule.description);
  };
  this.$onInit = function () {
    this.initialize();
  };
  this.$onChanges = function () {
    this.initialize();
  };
  this.initialize = function () {
    this.setUpHideOrDelete();
    if (this.focusOnRuleName) {
      timeoutList.push($timeout(function () {
        $scope.$broadcast(umStudioConstant.event.FOCUS_ON_RULE_NAME);
      }, 0));
    }
  };
  this.setUpHideOrDelete = function () {
    var fieldTemplate;
    this.fieldsInRule = [];
    this.fieldsInRule = _.filter(this.uiFormTemplate.formTemplate.fieldTemplates, function (fieldTemplate) {
      return fieldTemplate.triggerRuleName === ruleUtil.getRuleNameSubstring(this.fieldRule);
    }.bind(this));
    if (!_.isEmpty(this.fieldsInRule)) {
      fieldTemplate = this.fieldsInRule[0];
      this.hide = fieldTemplate.untriggerBehavior;
    }
  };
  this.findUiField = function (fieldTemplateId) {
    var foundUiField;
    _.each(this.uiFormTemplate.sections, function (section) {
      _.each(section.rows, function (row) {
        _.each(row.fields, function (field) {
          if (field.fieldTemplate.id === fieldTemplateId) {
            foundUiField = field;
            return false;
          }
        });
      });
    });
    return foundUiField;
  };
  this.updateFieldsInRule = function (untriggerBehavior, conditionalFieldsNotInRule) {
    _.each(this.fieldsInRule, function (fieldInRule) {
      fieldInRule.untriggerBehavior = untriggerBehavior;
      this.updateUiFieldFieldTemplate(fieldInRule);
    }.bind(this));
    _.each(conditionalFieldsNotInRule, function (field) {
      this.updateUiFieldFieldTemplate(field);
    }.bind(this));
    $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
    $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
  };
  this.updateUiFieldFieldTemplate = function (fieldTemplate) {
    var uiField = this.findUiField(fieldTemplate.id);
    if (!_.isNil(uiField)) {
      uiField.fieldTemplate = fieldTemplate;
    }
  };
  this.hideFields = function () {
    this.hide = true;
    this.updateFieldsInRule(1);
  };
  this.deleteFields = function () {
    this.hide = false;
    this.updateFieldsInRule(0);
  };
  this.doFieldsInRuleUpdated = function (conditionalFieldsNotInRule) {
    var untriggerBehavior = this.hide ? 1 : 0;
    this.updateFieldsInRule(untriggerBehavior, conditionalFieldsNotInRule);
  };
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
};
FieldRuleBuilderController.$inject = ["$element", "$rootScope", "$scope", "$timeout", "formViewerConstant", "localization", "ruleUtil", "uiFormTemplateModel", "umStudioConstant"];
angular.module('ums.configuration').controller('fieldRuleBuilderController', FieldRuleBuilderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2383:
/***/ (function(module, exports) {

/*@ngInject*/
var FieldRuleBuilderRepository = function FieldRuleBuilderRepository(baseSharedPromiseRepository) {
  var sharedPromiseCache = {};
  angular.extend(this, baseSharedPromiseRepository);
  this.getGETSharedPromiseCache = function () {
    return sharedPromiseCache;
  };
  this.getAvailableConditionalFieldTemplateIds = function (uiFormTemplateId) {
    var url = '/rest/UIFormTemplate/' + uiFormTemplateId + '/availableConditionalFieldTemplateIds',
      cacheKey = 'fieldRuleBuilderRepository:' + uiFormTemplateId;
    return this.get(cacheKey, url);
  };
};
FieldRuleBuilderRepository.$inject = ["baseSharedPromiseRepository"];
angular.module('ums.configuration').service('fieldRuleBuilderRepository', FieldRuleBuilderRepository);

/***/ }),

/***/ 2384:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2385);
__webpack_require__(2386);
__webpack_require__(2387);
__webpack_require__(2388);
var FormRuleBuilderComponent = {
  templateUrl: '/configuration/formEditor/content/rule/formRuleBuilder/formRuleBuilder.tpl.html',
  controller: 'formRuleBuilderController',
  bindings: {
    formRule: '<',
    canUserManageFormRules: '<'
  }
};
angular.module('ums').component('uiFormRuleBuilder', FormRuleBuilderComponent);

/***/ }),

/***/ 2385:
/***/ (function(module) {

module.exports = JSON.parse("{\"formRuleBuilder\":{\"showThisForm\":\"Show this form\"}}");

/***/ }),

/***/ 2386:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/rule/formRuleBuilder/formRuleBuilder.tpl.html';
var html = "<div class=\"formRuleBuilderContainer\">\n\n    <ui-rule-header rule=\"$ctrl.formRule\"\n                    can-user-manage-rules=\"::$ctrl.canUserManageFormRules\"\n                    is-field-rule=\"false\"></ui-rule-header>\n\n    <div class=\"ruleContent\">\n        <div class=\"ruleConditions\">\n            <ui-rule-condition-group rule-condition-group=\"$ctrl.formRule.condition\"\n                                     is-top-level=\"true\"\n                                     default-form-template-unique-name=\"$ctrl.uiFormTemplate.precedingFieldFormTemplateUniqueName\"\n                                     can-user-manage-form-rules=\"::$ctrl.canUserManageFormRules\"></ui-rule-condition-group>\n        </div>\n        <div class=\"groupHeader\">\n            <div class=\"thenContainer\"\n                 ui-translate>ruleActionGroup.then\n            </div>\n        </div>\n        <div class=\"ruleActionGroup\" ui-translate>\n            formRuleBuilder.showThisForm\n        </div>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2387:
/***/ (function(module, exports) {

/*@ngInject*/
var FormRuleBuilderController = function FormRuleBuilderController($element, uiFormTemplateModel) {
  $element.addClass('formRuleBuilder');
  this.uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();
};
FormRuleBuilderController.$inject = ["$element", "uiFormTemplateModel"];
angular.module('ums.configuration').controller('formRuleBuilderController', FormRuleBuilderController);

/***/ }),

/***/ 2388:
/***/ (function(module, exports) {

/*@ngInject*/
var FormRuleBuilderRepository = function FormRuleBuilderRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.validateRule = function (rule) {
    var url = '/rest/Rule/validate';
    return this.post(url, rule);
  };
};
FormRuleBuilderRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('formRuleBuilderRepository', FormRuleBuilderRepository);

/***/ }),

/***/ 2389:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2390);
__webpack_require__(2391);
__webpack_require__(2392);
var RuleBuilderLeftNavComponent = {
  templateUrl: '/configuration/formEditor/content/rule/leftNav/ruleBuilderLeftNav.tpl.html',
  controller: 'ruleBuilderLeftNavController',
  bindings: {
    uiFormTemplate: '<',
    showNewRuleButton: '<',
    onSelectedItemChange: '&',
    canUserManageFormRules: '<'
  }
};
angular.module('ums.configuration').component('uiRuleBuilderLeftNav', RuleBuilderLeftNavComponent);

/***/ }),

/***/ 2390:
/***/ (function(module) {

module.exports = JSON.parse("{\"ruleBuilderLeftNav\":{\"supplementalFormRule\":\"Supplemental Form Rule\",\"conditionalFormRule\":\"Conditional Form Rule\",\"fieldRules\":\"Field Rules\",\"newRule\":\"New Rule\",\"deleteConfirmation\":{\"cancel\":\"No\",\"confirm\":\"Yes\",\"summary\":\"Are you sure you want to delete this field rule?\",\"title\":\"Delete Field Rule\"}}}");

/***/ }),

/***/ 2391:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/rule/leftNav/ruleBuilderLeftNav.tpl.html';
var html = "<ui-collapsible-left-nav collapsible=\"true\">\n    <ui-accordion-button ng-repeat=\"item in $ctrl.navigationItemList\"\n                         label=\"item.name\"\n                         value=\"item.value\"\n                         has-children=\"$ctrl.hasChildren(item)\"\n                         notify-accordion-button-click=\"$ctrl.onNavItemClick(value)\"\n                         disable-chevron=\"true\"\n                         disable-user-interaction=\"item.value === 'fieldRules'\"\n                         is-open=\"true\"\n                         is-active=\"$ctrl.selectedItem && $ctrl.selectedItem.value === item.value\"\n                         show-custom-button=\"$ctrl.showNewRuleButton && item.value === 'fieldRules' && $ctrl.canUserManageFormRules\"\n                         custom-button-label=\"$ctrl.newRuleText\"\n                         notify-custom-button-click=\"$ctrl.onNewRuleClick()\">\n        <div class=\"childButtons\">\n            <div class=\"btn-link childButton\"\n                    ng-repeat=\"childItem in item.children\"\n                    ng-click=\"$ctrl.onNavChildItemClick(childItem)\"\n                    ng-class=\"{ active: $ctrl.selectedItem.value === childItem.value }\">\n\n                <div class=\"activeBar\"></div>\n                <div class=\"buttonLabel\"\n                     tooltip-append-to-body=\"true\"\n                     tooltip-popup-delay=\"500\"\n                     tooltip-enable=\"{{ childItem.nameTooltip }}\"\n                     ui-is-tooltip-enabled=\"childItem.nameTooltip\"\n                     uib-tooltip=\"{{childItem.name}}\"><span class=\"fieldRuleLabel\">{{ ::childItem.name }}</span></div>\n                <div class=\"trashContainer\">\n                    <a class=\"glyphicon glyphicon-trash\"\n                       ng-if=\"$ctrl.selectedItem.value === childItem.value && $ctrl.canUserManageFormRules\"\n                       ng-click=\"$ctrl.onDeleteFieldRuleClick(item, childItem, childItem.value)\"></a>\n                </div>\n            </div>\n        </div>\n\n    </ui-accordion-button>\n</ui-collapsible-left-nav>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2392:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RuleBuilderLeftNavController = function RuleBuilderLeftNavController($scope, $element, $rootScope, $state, authorizationConstants, coreConstant, currentUserModel, formViewerConstant, localization, modalUtil, ruleMediator, ruleUtil, umStudioConstant, configurationMediator, configurationActionsUtil, loadingBarHandler, uiFormTemplateModel) {
  $element.addClass('ruleBuilderLeftNav');
  localization.getTranslations().then(function (translations) {
    this.navigationItemList = [];
    this.selectedItem = null;
    this.userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);
    this.newRuleText = _.get(translations, 'ruleBuilderLeftNav.newRule');
    this.$onInit = function () {
      this.constructNavigationItemList();
    };
    this.$onChanges = function () {
      this.constructNavigationItemList();
    };
    this.constructNavigationItemList = function () {
      var fieldRuleNavItems = [],
        navItem,
        firstChildItem,
        selectedItemInList;
      this.navigationItemList = [];
      this.isSupplemental = !this.uiFormTemplate.formTemplate.root && !_.isNil(this.uiFormTemplate.triggerRule);
      this.isConditional = this.uiFormTemplate.formTemplate.root && !_.isNil(this.uiFormTemplate.triggerRule);
      if (this.isConditional) {
        this.navigationItemList.push({
          name: _.get(translations, 'ruleBuilderLeftNav.conditionalFormRule'),
          children: null,
          value: 'conditionalFormRule'
        });
      } else if (this.isSupplemental) {
        this.navigationItemList.push({
          name: _.get(translations, 'ruleBuilderLeftNav.supplementalFormRule'),
          children: null,
          value: 'supplementalFormRule'
        });
      }
      if (this.uiFormTemplate.fieldRules) {
        _.each(this.uiFormTemplate.fieldRules, function (fieldRule) {
          var nameSubstring = fieldRule.name.lastIndexOf('-#') !== -1 ? fieldRule.name.substr(0, fieldRule.name.lastIndexOf('-#')) : fieldRule.name;
          var navItem = {
            name: nameSubstring,
            children: null,
            value: fieldRule
          };
          var fieldRuleName = uiFormTemplateModel.getSelectedFieldRuleName() ? uiFormTemplateModel.getSelectedFieldRuleName() : $state.params.ruleName;
          fieldRuleNavItems.push(navItem);
          if (fieldRuleName && nameSubstring === fieldRuleName) {
            this.selectedItem = navItem;
          }
          if (this.selectedItem && this.selectedItem.value === fieldRule) {
            selectedItemInList = true;
          }
        }.bind(this));
      }
      fieldRuleNavItems = _.sortBy(fieldRuleNavItems, ['name']);
      this.navigationItemList.push({
        name: _.get(translations, 'ruleBuilderLeftNav.fieldRules'),
        children: fieldRuleNavItems,
        value: 'fieldRules'
      });
      if (selectedItemInList) {
        this.onNavChildItemClick(this.selectedItem);
      } else {
        navItem = this.navigationItemList[0];
        if (navItem.value === 'fieldRules') {
          if (navItem.children && navItem.children.length > 0) {
            firstChildItem = navItem.children[0];
            this.onNavChildItemClick(firstChildItem);
          }
        } else {
          this.onNavItemClick(navItem.value);
        }
      }
    };
    this.onNavItemClick = function (itemValue) {
      var item = _.find(this.navigationItemList, function (navigationItem) {
        return navigationItem.value === itemValue;
      });
      $rootScope.$broadcast(umStudioConstant.event.FORM_RULE_SELECTED);
      this.notifyChange(item);
    };
    this.onNavChildItemClick = function (item, focusOnRuleName, isNewRule) {
      $rootScope.$broadcast(umStudioConstant.event.FIELD_RULE_SELECTED, item.value, focusOnRuleName, isNewRule);
      this.notifyChange(item);
    };
    this.notifyChange = function (item) {
      this.selectedItem = item;
    };
    this.hasChildren = function (item) {
      return this.hasFieldRules(item) || item.value === 'fieldRules';
    };
    this.hasFieldRules = function (item) {
      return !_.isEmpty(item.children);
    };
    this.onDeleteFieldRuleClick = function (navItem, childNavItemToDelete, fieldRuleToDelete) {
      function doDeleteFieldRule() {
        var index,
          nextSelectedIndex,
          nextSelectedItem = null,
          nextSelectedChildItem = null,
          nameSubstring;
        _.remove(this.uiFormTemplate.fieldRules, function (fieldRule) {
          return fieldRule.name === fieldRuleToDelete.name;
        });
        nameSubstring = ruleUtil.getRuleNameSubstring(fieldRuleToDelete);
        ruleUtil.cleanUpUiFieldsByTriggerRuleName(this.uiFormTemplate, nameSubstring);
        index = _.findIndex(navItem.children, function (childNavItem) {
          return childNavItem.name === childNavItemToDelete.name;
        });
        if (navItem.children.length > 1) {
          if (index === 0) {
            nextSelectedIndex = 0;
          } else if (index === navItem.children.length - 1) {
            nextSelectedIndex = navItem.children.length - 2;
          } else {
            nextSelectedIndex = index;
          }
        } else {
          nextSelectedIndex = -1;
        }
        _.remove(navItem.children, function (childNavItem) {
          return childNavItem.name === childNavItemToDelete.name;
        });
        loadingBarHandler.showLoadingBar('formEditor.saveUiFormTemplate.loadingBar');
        return configurationMediator.updateFormTemplate(this.uiFormTemplate, this.uiFormTemplate.id).then(function (uiFormTemplate) {
          loadingBarHandler.hideLoadingBar();
          return configurationActionsUtil.handleUiFormTemplateSave(uiFormTemplate, false).then(function () {
            var focusOnRuleName = false;
            $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_SAVED, uiFormTemplate);
            if (nextSelectedIndex >= 0 && navItem.children.length > 0) {
              nextSelectedChildItem = navItem.children[nextSelectedIndex];
              this.onNavChildItemClick(nextSelectedChildItem, focusOnRuleName);
            } else {
              nextSelectedItem = this.navigationItemList[0];
              if (nextSelectedItem.value !== 'fieldRules') {
                this.onNavItemClick(nextSelectedItem);
              } else {
                $rootScope.$broadcast(umStudioConstant.event.RESET_RULE_SELECTION);
              }
            }
          }.bind(this));
        }.bind(this));
      }
      modalUtil.showConfirmationModal(/*submissionId*/null, /*quoteId*/null, /*notificationName*/null, 'ruleBuilderLeftNav.deleteConfirmation', /*logAction*/null, /*hideLoadingBar*/true, doDeleteFieldRule.bind(this));
    };
    this.onNewRuleClick = function () {
      var newFieldRule = ruleMediator.createFieldRule(this.uiFormTemplate.fieldRules),
        newFieldRuleNavItem = {
          name: newFieldRule.name,
          children: null,
          value: newFieldRule
        },
        fieldRuleListNavItem = _.find(this.navigationItemList, function (navigationItem) {
          return navigationItem.value === 'fieldRules';
        }),
        focusOnRuleName = true,
        isNewRule = true;
      if (_.isNil(this.uiFormTemplate.fieldRules)) {
        this.uiFormTemplate.fieldRules = [];
      }
      this.uiFormTemplate.fieldRules.push(newFieldRule);
      if (!_.isNil(fieldRuleListNavItem)) {
        fieldRuleListNavItem.children.push(newFieldRuleNavItem);
        this.onNavChildItemClick(newFieldRuleNavItem, focusOnRuleName, isNewRule);
      }
      $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    };
    $scope.$on(coreConstant.event.COLLAPSIBLE_LEFT_NAV_OPENED, function () {
      $element.addClass('open');
    });
    $scope.$on(coreConstant.event.COLLAPSIBLE_LEFT_NAV_CLOSED, function () {
      $element.removeClass('open');
    });
    $scope.$on(umStudioConstant.event.CREATE_NEW_FIELD_RULE, function () {
      this.onNewRuleClick();
    }.bind(this));
    $scope.$on(formViewerConstant.event.formBuilder.FORM_TEMPLATE_SAVED, function () {
      this.constructNavigationItemList();
    }.bind(this));
  }.bind(this));
};
RuleBuilderLeftNavController.$inject = ["$scope", "$element", "$rootScope", "$state", "authorizationConstants", "coreConstant", "currentUserModel", "formViewerConstant", "localization", "modalUtil", "ruleMediator", "ruleUtil", "umStudioConstant", "configurationMediator", "configurationActionsUtil", "loadingBarHandler", "uiFormTemplateModel"];
angular.module('ums.configuration').controller('ruleBuilderLeftNavController', RuleBuilderLeftNavController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2393:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/rule/reviewRule/validateRuleModal.tpl.html';
var html = "<div class=\"validateRuleModal\">\n\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title\">\n            <span ui-translate>ruleHeader.reviewRule.reviewRuleModal.title</span>\n        </h3>\n        <button class=\"close\"\n                ng-click=\"$dismiss()\">\n            <span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </div>\n\n    <div class=\"tabs\">\n        <ul class=\"nav nav-tabs\">\n            <li ng-class=\"{active: viewModel.ruleTabSelected}\"\n                class = \"rulesText\" >\n                <a data-toggle=\"tab\"\n                   ng-click=\"viewModel.ruleTabSelected=true\">\n                    <span ui-translate>ruleHeader.reviewRule.reviewRuleModal.rulesText</span>\n                </a>\n            </li>\n            <li ng-class=\"{active: !viewModel.ruleTabSelected}\"\n                class = \"errors\">\n                <a data-toggle=\"tab\"\n                   ng-click=\"viewModel.ruleTabSelected=false\">\n                    <span ui-translate>ruleHeader.reviewRule.reviewRuleModal.errors</span>\n                </a>\n            </li>\n        </ul>\n    </div>\n\n    <div class=\"tab-content\">\n        <div class=\"content tab-pane fade in active\">\n            <p class=\"ruleCodeText\" ng-show=\"viewModel.ruleTabSelected\">\n                {{ ::viewModel.ruleText }}\n            </p>\n            <p class=\"errorText\" ng-show=\"!viewModel.ruleTabSelected\">\n                {{ ::viewModel.error }}\n            </p>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-primary doneButton\"\n                ng-click=\"$dismiss()\">{{ ::viewModel.done }}\n        </button>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2394:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ValidateRuleModalController = function ValidateRuleModalController($rootScope, $scope, options, localization, coreConstant) {
  $scope.viewModel = {
    ruleText: options.ruleText,
    error: options.error,
    done: '',
    ruleTabSelected: options.ruleText && !options.error
  };
  localization.getTranslationByKey('ruleHeader').then(function (translations) {
    $scope.viewModel.done = _.get(translations, 'reviewRule.reviewRuleModal.ok');
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ValidateRuleModalController.$inject = ["$rootScope", "$scope", "options", "localization", "coreConstant"];
angular.module('ums.configuration').controller('validateRuleModalController', ValidateRuleModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2395:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/preview/formPreview.tpl.html';
var html = "<div class=\"\">form preview</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2396:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2397);
__webpack_require__(2398);
__webpack_require__(2419);
__webpack_require__(2454);

/*@ngInject*/
var FormBuilderController = function FormBuilderController($scope, $stateParams, coreConstant) {
  $scope.viewModel = {
    uiFormTemplateId: parseInt($stateParams.uiFormTemplateId),
    isCollapsibleLeftNavOpen: true
  };
  $scope.$on(coreConstant.event.COLLAPSIBLE_LEFT_NAV_OPENED, function () {
    $scope.viewModel.isCollapsibleLeftNavOpen = true;
  });
  $scope.$on(coreConstant.event.COLLAPSIBLE_LEFT_NAV_CLOSED, function () {
    $scope.viewModel.isCollapsibleLeftNavOpen = false;
  });
};
FormBuilderController.$inject = ["$scope", "$stateParams", "coreConstant"];
angular.module('ums.configuration').controller('formBuilderController', FormBuilderController);

/***/ }),

/***/ 2397:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/form/formBuilder.tpl.html';
var html = "<div class=\"formBuilder\">\n\n    <div class=\"formBuilderLeftNavContainer\"\n         ng-class=\"{ open: viewModel.isCollapsibleLeftNavOpen }\">\n        <ui-form-builder-left-nav></ui-form-builder-left-nav>\n    </div>\n\n    <div class=\"formBuilderContainer\">\n        <ui-form-viewer form-id=\"{{ viewModel.uiFormTemplateId }}\"\n                        is-configurable-form=\"true\"\n                        printable=\"false\"\n                        display-form-name=\"false\">\n        </ui-form-viewer>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2398:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2399);
__webpack_require__(2400);
__webpack_require__(2401);
__webpack_require__(2418);
var ComponentPaletteComponent = {
  templateUrl: '/configuration/formEditor/content/form/componentPalette/componentPalette.tpl.html',
  controller: 'componentPaletteController',
  bindings: {
    formTemplateType: '<'
  }
};
angular.module('ums.configuration').component('uiComponentPalette', ComponentPaletteComponent);

/***/ }),

/***/ 2399:
/***/ (function(module) {

module.exports = JSON.parse("{\"componentPalette\":{\"section\":{\"label\":\"Section\"},\"label\":{\"label\":\"Label\"},\"spacer\":{\"label\":\"Spacer\"},\"textInput\":{\"label\":\"Text Input\"},\"textArea\":{\"label\":\"Text Area\"},\"yesNoQuestion\":{\"label\":\"Yes/No Question\"},\"checkBox\":{\"label\":\"Check Box\"},\"checkBoxGroup\":{\"label\":\"Check Box Group\"},\"radioButtonGroup\":{\"label\":\"Radio Button Group\"},\"dropDown\":{\"label\":\"Drop Down\"},\"multiSelect\":{\"label\":\"Multi Select\"},\"rowRepeater\":{\"label\":\"Row Repeater\"},\"dateCalendar\":{\"label\":\"Date Calendar\"},\"classCodePicker\":{\"label\":\"Class Code Picker\"},\"functionButton\":{\"label\":\"Function Button\"},\"urlLink\":{\"label\":\"URL Link\"},\"uploadAttachment\":{\"label\":\"Upload Attachment\"},\"formSummaryGrid\":{\"label\":\"Form Summary Grid\"}}}");

/***/ }),

/***/ 2400:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/form/componentPalette/componentPalette.tpl.html';
var html = "<div class=\"paletteButtons\">\n\n    <div class=\"paletteButtonContainer\"\n         ng-repeat=\"paletteButton in $ctrl.paletteButtons\">\n\n        <div class=\"btn btn-link paletteButton\"\n             ui-draggable-component-button\n             ng-click=\"$ctrl.onPaletteButtonClick(paletteButton)\">\n\n            <div class=\"paletteButtonIcon\">\n                <img src=\"{{  paletteButton.iconSrc }}\" />\n            </div>\n            <div class=\"paletteButtonLabel\">\n                {{ ::paletteButton.label }}\n            </div>\n\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2401:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var sectionIcon = __webpack_require__(2402);
var labelIcon = __webpack_require__(2403);
var spacerIcon = __webpack_require__(2404);
var textInputIcon = __webpack_require__(2405);
var textAreaIcon = __webpack_require__(2406);
var yesNoQuestionIcon = __webpack_require__(2407);
var checkboxIcon = __webpack_require__(2408);
var checkboxGroupIcon = __webpack_require__(780);
var multiSelectIcon = __webpack_require__(780);
var radioButtonGroupIcon = __webpack_require__(2409);
var dropdownIcon = __webpack_require__(2410);
var rowRepeaterIcon = __webpack_require__(2411);
var dateCalendarIcon = __webpack_require__(2412);
var classCodePickerIcon = __webpack_require__(2413);
var functionButtonIcon = __webpack_require__(2414);
var urlLinkIcon = __webpack_require__(2415);
var uploadAttachmentIcon = __webpack_require__(2416);
var formSummaryGridIcon = __webpack_require__(2417);

/*@ngInject*/
var ComponentPaletteController = function ComponentPaletteController($element, localization, fieldType) {
  $element.addClass('componentPalette');
  localization.getTranslations().then(function (translations) {
    // Hardcoded for now, but we could imagine a scenario in the future where we could build this with input from
    // a call to the server, etc.
    this.paletteButtons = [{
      name: 'section',
      label: _.get(translations, 'componentPalette.section.label'),
      iconSrc: sectionIcon,
      type: -1,
      formTemplateType: this.formTemplateType
    }, {
      name: 'label',
      label: _.get(translations, 'componentPalette.label.label'),
      iconSrc: labelIcon,
      type: fieldType.LABEL,
      formTemplateType: this.formTemplateType
    }, {
      name: 'spacer',
      label: _.get(translations, 'componentPalette.spacer.label'),
      iconSrc: spacerIcon,
      type: fieldType.SPACER,
      formTemplateType: this.formTemplateType
    }, {
      name: 'textInput',
      label: _.get(translations, 'componentPalette.textInput.label'),
      iconSrc: textInputIcon,
      type: fieldType.TEXT_INPUT,
      formTemplateType: this.formTemplateType
    }, {
      name: 'textArea',
      label: _.get(translations, 'componentPalette.textArea.label'),
      iconSrc: textAreaIcon,
      type: fieldType.TEXT_AREA,
      formTemplateType: this.formTemplateType
    }, {
      name: 'yesNoQuestion',
      label: _.get(translations, 'componentPalette.yesNoQuestion.label'),
      iconSrc: yesNoQuestionIcon,
      type: fieldType.YES_NO,
      formTemplateType: this.formTemplateType
    }, {
      name: 'checkBox',
      label: _.get(translations, 'componentPalette.checkBox.label'),
      iconSrc: checkboxIcon,
      type: fieldType.CHECK_BOX,
      formTemplateType: this.formTemplateType
    }, {
      name: 'checkBoxGroup',
      label: _.get(translations, 'componentPalette.checkBoxGroup.label'),
      iconSrc: checkboxGroupIcon,
      type: fieldType.CHECK_BOX_GROUP,
      formTemplateType: this.formTemplateType
    }, {
      name: 'radioButtonGroup',
      label: _.get(translations, 'componentPalette.radioButtonGroup.label'),
      iconSrc: radioButtonGroupIcon,
      type: fieldType.RADIO_BUTTON_GROUP,
      formTemplateType: this.formTemplateType
    }, {
      name: 'dropDown',
      label: _.get(translations, 'componentPalette.dropDown.label'),
      iconSrc: dropdownIcon,
      type: fieldType.DROP_DOWN,
      formTemplateType: this.formTemplateType
    }, {
      name: 'multiSelect',
      label: _.get(translations, 'componentPalette.multiSelect.label'),
      iconSrc: multiSelectIcon,
      type: fieldType.MULTI_SELECT,
      formTemplateType: this.formTemplateType
    }, {
      name: 'rowRepeater',
      label: _.get(translations, 'componentPalette.rowRepeater.label'),
      iconSrc: rowRepeaterIcon,
      type: fieldType.ROWREPEATER,
      formTemplateType: this.formTemplateType
    }, {
      name: 'dateCalendar',
      label: _.get(translations, 'componentPalette.dateCalendar.label'),
      iconSrc: dateCalendarIcon,
      type: fieldType.CALENDAR,
      formTemplateType: this.formTemplateType
    }, {
      name: 'classCodePicker',
      label: _.get(translations, 'componentPalette.classCodePicker.label'),
      iconSrc: classCodePickerIcon,
      type: fieldType.CLASSCODEFINDER,
      formTemplateType: this.formTemplateType
    }, {
      name: 'functionButton',
      label: _.get(translations, 'componentPalette.functionButton.label'),
      iconSrc: functionButtonIcon,
      type: fieldType.FUNCTION_BUTTON,
      formTemplateType: this.formTemplateType
    }, {
      name: 'urlLink',
      label: _.get(translations, 'componentPalette.urlLink.label'),
      iconSrc: urlLinkIcon,
      type: fieldType.LINK_BUTTON,
      formTemplateType: this.formTemplateType
    }, {
      name: 'uploadAttachment',
      label: _.get(translations, 'componentPalette.uploadAttachment.label'),
      iconSrc: uploadAttachmentIcon,
      type: fieldType.UPLOAD_ATTACHMENT_BUTTON,
      formTemplateType: this.formTemplateType
    }, {
      name: 'formSummaryGrid',
      label: _.get(translations, 'componentPalette.formSummaryGrid.label'),
      iconSrc: formSummaryGridIcon,
      type: fieldType.FORM_SUMMARY_GRID,
      formTemplateType: this.formTemplateType
    }];
    this.onPaletteButtonClick = function (paletteButton) {
      // TODO
    };
  }.bind(this));
};
ComponentPaletteController.$inject = ["$element", "localization", "fieldType"];
angular.module('ums.configuration').controller('componentPaletteController', ComponentPaletteController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2402:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a5df482844e38fdf0bdeb9ce66dfa71c.svg";

/***/ }),

/***/ 2403:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "add7d299797f1d1b3b088c4acddec8d1.svg";

/***/ }),

/***/ 2404:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0458b5dfd575cd15678bbe5229003658.svg";

/***/ }),

/***/ 2405:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9beecdb8eabcdbc4c903c7d9d0ce626d.svg";

/***/ }),

/***/ 2406:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b120ede04e2683d241bca78d83dfe045.svg";

/***/ }),

/***/ 2407:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "27e8bff24d1a1ba3f46e64d76654b6ed.svg";

/***/ }),

/***/ 2408:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8b7df82467ec1c80d4b26afead5ae1a5.svg";

/***/ }),

/***/ 2409:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5a51ab0e59762e4a3da69663a8fe0d0e.svg";

/***/ }),

/***/ 2410:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "974b95b7f51c1f91fb0d7cbb9e830b97.svg";

/***/ }),

/***/ 2411:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "967522eb2cc5e23d6da9f047db5c1e94.svg";

/***/ }),

/***/ 2412:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d6ab2a3a919ef25c5f06ddf5600d4efc.svg";

/***/ }),

/***/ 2413:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "51ad9e82ebe60d5894362c488ddf0a6d.svg";

/***/ }),

/***/ 2414:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4b5e9dab3461eeb8251cca2c717e1172.svg";

/***/ }),

/***/ 2415:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5ee8ea6ce074335babb3d86acd34c72d.svg";

/***/ }),

/***/ 2416:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4da653cff5ba5e650961a19b256e7f9d.svg";

/***/ }),

/***/ 2417:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f76ccb0bf1200004103cd8a6272b5c4b.svg";

/***/ }),

/***/ 2418:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, _) {/*@ngInject*/
var UIDraggableComponentButtonDirective = function UIDraggableComponentButtonDirective($rootScope, $timeout, fieldType, formMediator, formViewerConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    var element = $($elm),
      componentFieldTemplate,
      sectionFieldTemplate,
      rowRepeaterFieldTemplate,
      isSection,
      isRowRepeater;
    element.attr('draggable', 'true');
    function init() {
      var formTemplateType = $scope.paletteButton.formTemplateType;
      isSection = $scope.paletteButton.type === -1;
      isRowRepeater = $scope.paletteButton.type === fieldType.ROWREPEATER;
      if (isSection) {
        getSectionFieldTemplate(formTemplateType);
      } else if (isRowRepeater) {
        getRowRepeaterFieldTemplate(formTemplateType);
      } else {
        getComponentFieldTemplate(formTemplateType);
      }
    }
    function onDragStart(event) {
      var dataTransfer = event.originalEvent.dataTransfer,
        dragConfiguration;
      if (isSection) {
        dragConfiguration = buildSectionDragConfiguration();
      } else if (isRowRepeater) {
        dragConfiguration = buildRowRepeaterDragConfiguration();
      } else {
        dragConfiguration = buildComponentDragConfiguration();
      }
      element.addClass('dragging');
      dataTransfer.effectAllowed = 'move';
      event.originalEvent.dataTransfer.setData('text', JSON.stringify(dragConfiguration));
      formMediator.setCurrentDragItem(dragConfiguration);
    }
    function buildComponentDragConfiguration() {
      var dragConfiguration;
      dragConfiguration = {
        dragType: formViewerConstant.configuration.dragOperationType.INSERT,
        formStructureType: formViewerConstant.configuration.formStructureType.COMPONENT,
        componentType: $scope.paletteButton.type,
        uiField: componentFieldTemplate
      };
      return dragConfiguration;
    }
    function buildSectionDragConfiguration() {
      var dragConfiguration,
        newSectionFieldTemplate = _.cloneDeep(sectionFieldTemplate);
      dragConfiguration = {
        dragType: formViewerConstant.configuration.dragOperationType.INSERT,
        formStructureType: formViewerConstant.configuration.formStructureType.SECTION,
        uiSection: newSectionFieldTemplate
      };
      return dragConfiguration;
    }
    function buildRowRepeaterDragConfiguration() {
      var dragConfiguration,
        newRowRepeaterFieldTemplate = _.cloneDeep(rowRepeaterFieldTemplate);
      dragConfiguration = {
        dragType: formViewerConstant.configuration.dragOperationType.INSERT,
        formStructureType: formViewerConstant.configuration.formStructureType.ROW_REPEATER,
        uiRow: newRowRepeaterFieldTemplate
      };
      return dragConfiguration;
    }
    function getComponentFieldTemplate(formTemplateType) {
      formMediator.getUiFieldByType($scope.paletteButton.type, formTemplateType).then(function (uiField) {
        componentFieldTemplate = uiField;
      });
    }
    function getSectionFieldTemplate(formTemplateType) {
      formMediator.buildEmptySectionTemplate(formTemplateType).then(function (uiSection) {
        sectionFieldTemplate = uiSection;
      });
    }
    function getRowRepeaterFieldTemplate(formTemplateType) {
      formMediator.buildRowRepeaterTemplate(formTemplateType).then(function (uiRow) {
        rowRepeaterFieldTemplate = uiRow;
      });
    }
    function onDragEnd() {
      element.removeClass('dragging');
      init();
    }
    element.on('dragstart', onDragStart);
    element.on('dragend', onDragEnd);
    $scope.$on(formViewerConstant.event.formBuilder.DISABLE_DRAGGABLE_ELEMENTS, function () {
      element.attr('draggable', 'false');
    });
    $scope.$on(formViewerConstant.event.formBuilder.ENABLE_DRAGGABLE_ELEMENTS, function () {
      element.attr('draggable', 'true');
    });
    $scope.$on('$destroy', function () {
      element.off('dragstart', onDragStart);
      element.off('dragend', onDragEnd);
    });
    init();
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
UIDraggableComponentButtonDirective.$inject = ["$rootScope", "$timeout", "fieldType", "formMediator", "formViewerConstant"];
angular.module('ums.configuration').directive('uiDraggableComponentButton', UIDraggableComponentButtonDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4), __webpack_require__(0)))

/***/ }),

/***/ 2419:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2420);
__webpack_require__(2421);
__webpack_require__(2422);
__webpack_require__(2423);
__webpack_require__(2424);
__webpack_require__(2425);
__webpack_require__(2426);
__webpack_require__(781);
__webpack_require__(781);
var ComponentSettingsComponent = {
  templateUrl: '/configuration/formEditor/content/form/componentSettings/componentSettings.tpl.html',
  controller: 'componentSettingsController',
  bindings: {
    selectedField: '<',
    selectedFieldStructure: '<',
    fieldStructure: '<',
    scrollableContainerSelector: '<'
  }
};
angular.module('ums.configuration').component('uiComponentSettings', ComponentSettingsComponent);

/***/ }),

/***/ 2420:
/***/ (function(module) {

module.exports = JSON.parse("{\"componentSettings\":{\"headers\":{\"coreSettings\":\"Core\",\"displaySettings\":\"Display\",\"editabilitySettings\":\"Editability\",\"visibilitySettings\":\"Visibility\",\"requiredSettings\":\"Required\",\"valueSettings\":\"Value\",\"validationSettings\":\"Validation\",\"componentSpecificSettings\":\"Component Specific Settings\"},\"structureType\":{\"SECTION\":\"Section\"},\"fieldType\":{\"0\":\"Text Input\",\"1\":\"Text Area\",\"2\":\"Yes No Question\",\"3\":\"Drop Down\",\"5\":\"Check Box\",\"6\":\"Check Box Group\",\"7\":\"Calendar\",\"9\":\"Label\",\"10\":\"Row Repeater\",\"11\":\"Section Repeater\",\"12\":\"Class Code Finder\",\"13\":\"Radio Button Group\",\"14\":\"Spacer\",\"17\":\"Function Button\",\"20\":\"Link Button\",\"21\":\"Upload Attachment Button\",\"24\":\"Form Summary Grid\"},\"fieldReferences\":\"View {0} Field Reference{1}\"}}");

/***/ }),

/***/ 2421:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/form/componentSettings/componentSettings.tpl.html';
var html = "<ui-option-group ng-if=\"$ctrl.showCoreSettings && !$ctrl.isLoading\"\n                 ng-class=\"{ fieldReferencesExist: $ctrl.fieldReferenceCount !== 0 }\"\n                 option-group-name=\"'coreSettings'\"\n                 display-header=\"true\"\n                 header-title-key=\"'componentSettings.headers.coreSettings'\"\n                 settings=\"$ctrl.coreSettings\"\n                 scrollable-container-selector=\"$ctrl.scrollableContainerSelector\"\n                 selected-field=\"::$ctrl.selectedField\"\n                 selected-field-structure=\"::$ctrl.selectedFieldStructure\"></ui-option-group>\n\n<div ng-if=\"$ctrl.fieldReferenceCount !== 0 && !$ctrl.isLoading\"\n     class=\"fieldReferences\">\n    <a ng-click=\"$ctrl.openFieldReferencePopup()\">{{ ::$ctrl.fieldReferenceText }}</a>\n</div>\n\n<ui-option-group ng-if=\"$ctrl.showDisplaySettings && !$ctrl.isLoading\"\n                 selected-field=\"::$ctrl.selectedField\"\n                 selected-field-structure=\"::$ctrl.selectedFieldStructure\"\n                 option-group-name=\"'displaySettings'\"\n                 display-header=\"true\"\n                 header-title-key=\"'componentSettings.headers.displaySettings'\"\n                 settings=\"$ctrl.displaySettings\"\n                 scrollable-container-selector=\"$ctrl.scrollableContainerSelector\"></ui-option-group>\n\n<ui-option-group ng-if=\"$ctrl.showVisibilitySettings && !$ctrl.isLoading\"\n                 selected-field=\"::$ctrl.selectedField\"\n                 selected-field-structure=\"::$ctrl.selectedFieldStructure\"\n                 option-group-name=\"'visibilitySettings'\"\n                 display-header=\"true\"\n                 header-title-key=\"'componentSettings.headers.visibilitySettings'\"\n                 settings=\"$ctrl.visibilitySettings\"\n                 scrollable-container-selector=\"$ctrl.scrollableContainerSelector\"></ui-option-group>\n\n<ui-option-group ng-if=\"$ctrl.showEditabilitySettings && !$ctrl.isLoading\"\n                 selected-field=\"::$ctrl.selectedField\"\n                 selected-field-structure=\"::$ctrl.selectedFieldStructure\"\n                 option-group-name=\"'editabilitySettings'\"\n                 display-header=\"true\"\n                 header-title-key=\"'componentSettings.headers.editabilitySettings'\"\n                 settings=\"$ctrl.editabilitySettings\"\n                 scrollable-container-selector=\"$ctrl.scrollableContainerSelector\"></ui-option-group>\n\n<ui-option-group ng-if=\"$ctrl.showRequiredSettings && !$ctrl.isLoading\"\n                 selected-field=\"::$ctrl.selectedField\"\n                 selected-field-structure=\"::$ctrl.selectedFieldStructure\"\n                 option-group-name=\"'requiredSettings'\"\n                 display-header=\"true\"\n                 header-title-key=\"'componentSettings.headers.requiredSettings'\"\n                 settings=\"$ctrl.requiredSettings\"\n                 scrollable-container-selector=\"$ctrl.scrollableContainerSelector\"></ui-option-group>\n\n<ui-option-group ng-if=\"$ctrl.showValidationSettings && !$ctrl.isLoading\"\n                 selected-field=\"::$ctrl.selectedField\"\n                 selected-field-structure=\"::$ctrl.selectedFieldStructure\"\n                 option-group-name=\"'validationSettings'\"\n                 display-header=\"true\"\n                 header-title-key=\"'componentSettings.headers.validationSettings'\"\n                 settings=\"$ctrl.validationSettings\"\n                 scrollable-container-selector=\"$ctrl.scrollableContainerSelector\"></ui-option-group>\n\n<ui-option-group ng-if=\"$ctrl.showValueSettings && !$ctrl.isLoading\"\n                 selected-field=\"::$ctrl.selectedField\"\n                 selected-field-structure=\"::$ctrl.selectedFieldStructure\"\n                 option-group-name=\"'valueSettings'\"\n                 display-header=\"true\"\n                 header-title-key=\"'componentSettings.headers.valueSettings'\"\n                 settings=\"$ctrl.valueSettings\"\n                 scrollable-container-selector=\"$ctrl.scrollableContainerSelector\"></ui-option-group>\n\n<ui-option-group ng-if=\"$ctrl.showComponentSpecificSettings && !$ctrl.isLoading\"\n                 selected-field=\"::$ctrl.selectedField\"\n                 selected-field-structure=\"::$ctrl.selectedFieldStructure\"\n                 option-group-name=\"'componentSpecificSettings'\"\n                 display-header=\"true\"\n                 header-title-key=\"'componentSettings.headers.componentSpecificSettings'\"\n                 settings=\"$ctrl.componentSpecificSettings\"\n                 scrollable-container-selector=\"$ctrl.scrollableContainerSelector\"></ui-option-group>\n\n<div class=\"loading\" ng-if=\"$ctrl.isLoading\">\n    <div class=\"icon-spinner\"></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2422:
/***/ (function(module, exports) {

var ComponentSettingsConstant = {
  optionGroups: {
    CORE_SETTINGS: 'OptionGroupConstant.coreSettings',
    DISPLAY_SETTINGS: 'OptionGroupConstant.displaySettings',
    EDITABILITY_SETTINGS: 'OptionGroupConstant.editabilitySettings',
    VISIBILITY_SETTINGS: 'OptionGroupConstant.visibilitySettings',
    REQUIRED_SETTINGS: 'OptionGroupConstant.requiredSettings',
    VALIDATION_SETTINGS: 'OptionGroupConstant.validationSettings',
    VALUE_SETTINGS: 'OptionGroupConstant.valueSettings',
    COMPONENT_SPECIFIC_SETTINGS: 'OptionGroupConstant.componentSpecificSettings'
  }
};
angular.module('ums.configuration').constant('componentSettingsConstant', ComponentSettingsConstant);

/***/ }),

/***/ 2423:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ComponentSettingsController = function ComponentSettingsController($scope, $element, $stateParams, $uibModal, $q, xmlUtil, localization, dataSetType, componentSettingsMediator, inputType, displayConditionOperator, formViewerModel, configurationConstant, formTemplateStatus, fieldTemplateComponentSettingOwningClass, formMediator, componentSettingsUtil, componentSettingsConstant, authorizationConstants, currentUserModel, coreMediator, configurationMediator, modalUtil, displayConditionLogicalOperator) {
  var _this = this;
  $element.addClass('componentSettings');
  this.isLoading = true;
  localization.getTranslationByKey('componentSettings').then(function (translations) {
    _this.init = function (uiField) {
      var _this2 = this;
      var isUnsavedComponent = typeof uiField.fieldTemplate.id === 'string';
      this.isLoading = true;
      this.fieldReferenceCount = 0;
      this.fieldReferenceText = '';
      this.settings = {};
      this.displayConditionsSettings = {};
      this.settingsNeedingDataSets = {};
      this.owningClassPropertyNameMap = {};
      this.owningClassPropertyNameMap[fieldTemplateComponentSettingOwningClass.FIELD_TEMPLATE] = {};
      this.owningClassPropertyNameMap[fieldTemplateComponentSettingOwningClass.UI_FIELD] = {};
      this.coreSettings = [];
      this.displaySettings = [];
      this.editabilitySettings = [];
      this.visibilitySettings = [];
      this.requiredSettings = [];
      this.valueSettings = [];
      this.validationSettings = [];
      this.componentSpecificSettings = [];
      this.showCoreSettings = false;
      this.showDisplaySettings = false;
      this.showEditabilitySettings = false;
      this.showVisibilitySettings = false;
      this.showRequiredSettings = false;
      this.showValueSettings = false;
      this.showValidationSettings = false;
      this.showComponentSpecificSettings = false;
      this.userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);
      if (!isUnsavedComponent) {
        formMediator.findReferenceCountByFieldTemplateId(uiField.fieldTemplate.id).then(function (count) {
          _this2.fieldReferenceCount = count;
          if (_this2.fieldReferenceCount !== 0) {
            _this2.fieldReferenceText = _.get(translations, 'fieldReferences');
            _this2.fieldReferenceText = _.replace(_this2.fieldReferenceText, '{0}', _this2.fieldReferenceCount);
            if (_this2.fieldReferenceCount === 1) {
              _this2.fieldReferenceText = _.replace(_this2.fieldReferenceText, '{1}', '');
            } else {
              _this2.fieldReferenceText = _.replace(_this2.fieldReferenceText, '{1}', 's');
            }
          }
        });
      }
      componentSettingsMediator.getFieldTemplateComponentSettings(uiField.fieldTemplate.type, $stateParams.uiFormTemplateId).then(function (result) {
        _.each(result.settings, function (setting) {
          _this2.processComponentSetting(setting, uiField);

          // Special processing needed for populating drop down setting values with static data sets
          if ((setting.inputType === inputType.DROP_DOWN || setting.inputType === inputType.MULTI_SELECT_SET) && !_.isNil(setting.dataSetNameFromSetting)) {
            if (!_.has(_this2.settingsNeedingDataSets, setting.dataSetNameFromSetting)) {
              _this2.settingsNeedingDataSets[setting.dataSetNameFromSetting] = [];
            }
            _this2.settingsNeedingDataSets[setting.dataSetNameFromSetting].push(setting.settingName);
          }

          // Build a mapping of settingName -> setting that has a display condition dependent on that setting name
          // This will be used later when triggering these display conditions efficiently.
          _this2.buildDisplayConditionsMapping(setting);

          // Push each setting into their appropriate option group:
          _this2.addToOptionGroup(setting);
        });
        _this2.processDataSetSettings(_this2.settings).then(function () {
          _this2.setIsActiveForAllSettings();
          _this2.restoreDefaultValueForInactiveSettings();
          _this2.evaluateOptionGroupVisibilities();
        });
      }).finally(function () {
        _this2.isLoading = false;
      });
    };
    _this.setIsActiveForAllSettings = function () {
      var _this3 = this;
      _.forOwn(this.settings, function (setting) {
        setting.isActive = _this3.isSettingActive(setting);
      });
    };
    _this.restoreDefaultValueForInactiveSettings = function () {
      var _this4 = this;
      _.forOwn(this.settings, function (setting) {
        var suppressFormEvents = true;
        if (!setting.isActive && setting.inputType !== inputType.BUTTON && setting.value !== setting.defaultValue) {
          setting.value = setting.defaultValue;
          var skipUpdateSettingObject = _this4.shouldSkipUpdateSettingObject(setting);
          _this4.processOptionGroupInputValueChange({
            name: setting.settingName,
            value: setting.defaultValue
          }, suppressFormEvents, skipUpdateSettingObject);
        }
      });
    };
    _this.shouldSkipUpdateSettingObject = function (settingToCheck) {
      var skipUpdateSettingObject = false,
        propertyName = settingToCheck.propertyName;
      if (!settingToCheck.isActive) {
        if (!_.isNil(settingToCheck.xmlSubProperty)) {
          propertyName += '.' + settingToCheck.xmlRootNodeName + '.' + settingToCheck.xmlSubProperty;
        }
        _.each(this.owningClassPropertyNameMap[settingToCheck.owningClass][propertyName], function (setting) {
          if (settingToCheck.settingName !== setting.settingName) {
            if (setting.isActive) {
              skipUpdateSettingObject = true;
              return false;
            }
          }
        });
      }
      return skipUpdateSettingObject;
    };
    _this.processComponentSetting = function (setting, uiField) {
      var formStructure = formViewerModel.getFormStructure($stateParams.uiFormTemplateId);
      var fullSettingPropertyName = setting.propertyName;
      if (!_.isNil(setting.xmlSubProperty)) {
        fullSettingPropertyName += '.' + setting.xmlRootNodeName + '.' + setting.xmlSubProperty;
      }
      this.settings[setting.settingName] = setting;
      if (_.isEmpty(this.owningClassPropertyNameMap[setting.owningClass][fullSettingPropertyName])) {
        this.owningClassPropertyNameMap[setting.owningClass][fullSettingPropertyName] = [];
      }
      this.owningClassPropertyNameMap[setting.owningClass][fullSettingPropertyName].push(setting);
      setting.value = this.getSettingValue(setting, uiField);
      setting.disabled = !this.userCanManageForms || setting.disabledWhenInProduction && formStructure.uiFormTemplate.formTemplate.status === formTemplateStatus.IN_PRODUCTION;
      if (setting.disabled && setting.settingName !== 'requiredFieldLevel') {
        setting.disabled = setting.disabled && uiField.id !== -1;
      }
      if (setting.inputType === inputType.CHECK_BOX) {
        setting.defaultValue = setting.defaultValue === 'true';
      } else {
        setting.defaultValue = _.isNil(setting.defaultValue) ? '' : setting.defaultValue;
      }
      var dynamicValues = this.getDynamicValues(setting, formStructure.uiFormTemplate.formTemplate.type);
      if (setting.settingName === 'summaryColumns') {
        this.initFieldOptions(setting);
      }
      if (!_.isNil(dynamicValues)) {
        setting.defaultValue = _.first(_.values(dynamicValues['Default']));
        setting.values = dynamicValues[setting.settingName];
      }
    };
    _this.buildDisplayConditionsMapping = function (setting) {
      var _this5 = this;
      if (!_.isEmpty(setting.displayConditions)) {
        _.each(setting.displayConditions, function (displayCondition) {
          var otherSetting = _this5.settings[displayCondition.componentSettingName];

          // Make sure the display condition value is the correct type.
          if (otherSetting.inputType === inputType.CHECK_BOX) {
            displayCondition.value = displayCondition.value === 'true' || displayCondition.value === true;
          }
          if (!_.has(_this5.displayConditionsSettings, displayCondition.componentSettingName)) {
            _this5.displayConditionsSettings[displayCondition.componentSettingName] = [];
          }
          _this5.displayConditionsSettings[displayCondition.componentSettingName].push(setting.settingName);
        });
      }
    };
    _this.addToOptionGroup = function (setting) {
      switch (componentSettingsUtil.getOptionGroup(setting.settingName)) {
        case componentSettingsConstant.optionGroups.CORE_SETTINGS:
          this.coreSettings.push(setting);
          break;
        case componentSettingsConstant.optionGroups.DISPLAY_SETTINGS:
          this.displaySettings.push(setting);
          break;
        case componentSettingsConstant.optionGroups.VISIBILITY_SETTINGS:
          this.visibilitySettings.push(setting);
          break;
        case componentSettingsConstant.optionGroups.EDITABILITY_SETTINGS:
          this.editabilitySettings.push(setting);
          break;
        case componentSettingsConstant.optionGroups.REQUIRED_SETTINGS:
          this.requiredSettings.push(setting);
          break;
        case componentSettingsConstant.optionGroups.VALIDATION_SETTINGS:
          this.validationSettings.push(setting);
          break;
        case componentSettingsConstant.optionGroups.VALUE_SETTINGS:
          this.valueSettings.push(setting);
          break;
        case componentSettingsConstant.optionGroups.COMPONENT_SPECIFIC_SETTINGS:
          this.componentSpecificSettings.push(setting);
          break;
      }
    };
    _this.processDataSetSettings = function (settings) {
      var _this6 = this;
      var updatedSettings = [];
      var promises = [];
      _.each(settings, function (setting) {
        var settingNames = _this6.settingsNeedingDataSets[setting.settingName];
        if (!_.isEmpty(settingNames)) {
          var dataSetName = _this6.settings[setting.settingName].value;
          if (!_.isNil(dataSetName)) {
            var promise = coreMediator.getCachedDataSetByName(dataSetName).then(function (dataSet) {
              if (dataSet && dataSet.type !== dataSetType.STATIC) {
                _this6.selectedField.fieldTemplate.dynamicDataSet = false;
              } else {
                _this6.selectedField.fieldTemplate.dynamicDataSet = true;
              }
              _.each(settingNames, function (settingName) {
                var setting = _this6.settings[settingName];
                updatedSettings.push(setting);
                setting.values = {};
                _.each(dataSet.items, function (item) {
                  setting.values[item.name] = item.value;
                });
              });
            }).catch(function () {
              _.each(settingNames, function (settingName) {
                var setting = _this6.settings[settingName];
                updatedSettings.push(setting);
                setting.values = {};
              });
            });
            promises.push(promise);
          }
        }
      });
      var defer = $q.defer();
      $q.all(promises).finally(function () {
        defer.resolve(updatedSettings);
      });
      return defer.promise;
    };
    _this.getSettingObject = function (owningClass, uiField) {
      var settingObject = null;
      switch (owningClass) {
        case fieldTemplateComponentSettingOwningClass.FIELD_TEMPLATE:
          settingObject = uiField.fieldTemplate;
          break;
        case fieldTemplateComponentSettingOwningClass.UI_FIELD:
          settingObject = uiField;
          break;
      }
      return settingObject;
    };
    _this.initFieldOptions = function (setting) {
      var uiFieldOptions = this.selectedField['options'];
      var xmlObject = xmlUtil.parseStringWithoutFlattening(uiFieldOptions)['options'];
      var formTemplateName = _.get(xmlObject, 'formRepeaterSummary.formTemplateName');
      configurationMediator.getFieldOptions(formTemplateName).then(function (fieldOptions) {
        setting.values = {};
        setting.fieldOptions = fieldOptions;
        _.each(fieldOptions, function (fieldOption) {
          setting.values[fieldOption.fieldName] = fieldOption.fieldName;
        });
      });
    };
    _this.getSettingObjectValue = function (propertyName, settingName, xmlRootNodeName, xmlSubProperty, settingObject, type) {
      var settingValue = null;
      if (!_.isNil(xmlSubProperty)) {
        var xmlSettings = xmlUtil.parseStringWithoutFlattening(settingObject[propertyName])[xmlRootNodeName];
        _.forOwn(xmlSettings, function (value, key) {
          var option = xmlUtil.parseString(value);
          if (!_.isEmpty(option)) {
            xmlSettings[key] = option;
          }
        });
        settingValue = _.get(xmlSettings, xmlSubProperty);
        if (settingName === 'summaryColumns') {
          if (!_.isArray(settingValue)) {
            settingValue = settingValue._variableName;
          } else {
            var summaryColumnJoinedValue = _.join(_.map(settingValue, '_variableName'));
            settingValue = summaryColumnJoinedValue;
          }
        }
      } else {
        settingValue = this.getSettingObjectValueFromPropertyName(propertyName, settingObject);
      }
      return type === inputType.CHECK_BOX ? settingValue === 'true' || settingValue === true : !_.isNil(settingValue) ? settingValue.toString() : null;
    };
    _this.getSettingObjectValueFromPropertyName = function (propertyName, settingObject) {
      // Split apart (OR) concatenations in the property name
      var propertyNameOrSplits = _.split(propertyName, '||');
      var settingValue = null;
      _.each(propertyNameOrSplits, function (orPropName) {
        // Split apart property names (max 2) and concatenate them back with the proper values
        var propertyNameConcatSplits = _.split(orPropName, '::');
        if (_.size(propertyNameConcatSplits) === 2) {
          var property0Value = settingObject[propertyNameConcatSplits[0]];
          var property1Value = settingObject[propertyNameConcatSplits[1]];
          if (!_.isNil(property0Value) && !_.isNil(property1Value) && !_.isEmpty(property0Value) && !_.isEmpty(property1Value)) {
            settingValue = property0Value + '::' + property1Value;
          }
        } else {
          settingValue = settingObject[propertyNameConcatSplits[0]];
        }

        // If the setting value exists, we can return, without looking at other parts of the (OR) property name
        if (!_.isEmpty(settingValue)) {
          return false;
        }
      });
      return settingValue;
    };
    _this.getSettingValue = function (setting, uiField) {
      var settingObject = this.getSettingObject(setting.owningClass, uiField);
      var settingValue = this.getSettingObjectValue(setting.propertyName, setting.settingName, setting.xmlRootNodeName, setting.xmlSubProperty, settingObject, setting.inputType);
      return settingValue;
    };
    _this.getDynamicValues = function (setting, formTemplateType) {
      var dynamicValues = null;
      if (!_.isNil(setting.dynamicValuesFormTypeDependent)) {
        dynamicValues = setting.dynamicValuesFormTypeDependent[formTemplateType];
      }
      return dynamicValues;
    };
    _this.isSettingActive = function (setting) {
      var _this7 = this;
      var displayConditions = setting.displayConditions;
      var isSettingActive = false;
      _.each(displayConditions, function (displayCondition) {
        var otherSetting = _this7.settings[displayCondition.componentSettingName];
        var operator = displayCondition.operator;
        var value = displayCondition.value;
        if (!_.isNil(otherSetting)) {
          isSettingActive = false;
          switch (operator) {
            case displayConditionOperator.EQUALS:
              if (otherSetting.value === value) {
                isSettingActive = true;
              }
              break;
            case displayConditionOperator.NOT_EQUALS:
              if (otherSetting.value !== value) {
                isSettingActive = true;
              }
              break;
            case displayConditionOperator.NOT_EMPTY:
              if (!_.isEmpty(otherSetting.value)) {
                isSettingActive = true;
              }
              break;
            case displayConditionOperator.EMPTY_VALUE_SET:
              if (_.isEmpty(otherSetting.values)) {
                isSettingActive = true;
              }
              break;
            case displayConditionOperator.NOT_EMPTY_VALUE_SET:
              if (!_.isEmpty(otherSetting.values)) {
                isSettingActive = true;
              }
              break;
          }

          // If comparing using AND, stop looping through conditions if ANY evaluate to FALSE,
          // otherwise OR is used, and stop looping if any evaluate to TRUE
          if (setting.displayConditionComparisonOperator === displayConditionLogicalOperator.AND && !isSettingActive || setting.displayConditionComparisonOperator !== displayConditionLogicalOperator.AND && isSettingActive) {
            return false;
          }
        }
      });
      return isSettingActive || _.isEmpty(displayConditions);
    };
    _this.evaluateDisplayConditions = function (nameOfSetting, parentIsActive) {
      var _this8 = this;
      _.each(this.displayConditionsSettings[nameOfSetting], function (settingName) {
        var setting = _this8.settings[settingName];
        var wasActive = setting.isActive;
        var suppressFormEvents = true;
        setting.isActive = parentIsActive && _this8.isSettingActive(setting);

        // If the setting was not active before, and is now active, or vice versa, we should update its value to its default value (excluding buttons)
        if (setting.inputType !== inputType.BUTTON && (!wasActive && setting.isActive || wasActive && !setting.isActive)) {
          setting.value = setting.defaultValue;
          _this8.processOptionGroupInputValueChange({
            name: setting.settingName,
            value: setting.defaultValue
          }, suppressFormEvents);
          if (setting.settingName === 'summaryColumns') {
            _this8.initFieldOptions(setting);
          }
        }

        // Avoid infinite recursion on self referential conditions
        if (nameOfSetting !== settingName) {
          _this8.evaluateDisplayConditions(settingName, setting.isActive);
        }
      });
    };
    _this.evaluateOptionGroupVisibilities = function () {
      this.showCoreSettings = this.showOptionGroup(this.coreSettings);
      this.showDisplaySettings = this.showOptionGroup(this.displaySettings);
      this.showEditabilitySettings = this.showOptionGroup(this.editabilitySettings);
      this.showVisibilitySettings = this.showOptionGroup(this.visibilitySettings);
      this.showRequiredSettings = this.showOptionGroup(this.requiredSettings);
      this.showValueSettings = this.showOptionGroup(this.valueSettings);
      this.showValidationSettings = this.showOptionGroup(this.validationSettings);
      this.showComponentSpecificSettings = this.showOptionGroup(this.componentSpecificSettings);
    };
    _this.showOptionGroup = function (settings) {
      var showOptionGroup = false;
      _.each(settings, function (setting) {
        if (setting.isActive) {
          showOptionGroup = true;
          return false;
        }
      });
      return showOptionGroup;
    };
    _this.openFieldReferencePopup = function () {
      var fieldTemplateId = this.selectedField.fieldTemplate.id;
      var variableName = this.selectedField.fieldTemplate.variableName;
      return configurationMediator.getFieldReferences(fieldTemplateId).then(function (fieldTemplateReferences) {
        return modalUtil.openFieldReferencesModal('fieldReferences', fieldTemplateReferences, variableName);
      });
    };
    _this.processSummaryColumns = function (setting, settingObject, xmlObject) {
      var oldColumns = _.get(xmlObject, setting.xmlRootNodeName + '.' + setting.xmlSubProperty);
      var pickedColumns = _.split(setting.value, setting.valueDelimiter);
      var addedColumns = [];
      var removedColumns = [];
      _.each(pickedColumns, function (pickedColumn) {
        var existingColumn = _.find(oldColumns, {
          '_variableName': pickedColumn
        });
        if (!existingColumn) {
          addedColumns.push(pickedColumn);
        }
      });
      _.each(oldColumns, function (oldColumn) {
        if (!_.includes(pickedColumns, oldColumn._variableName)) {
          removedColumns.push(oldColumn);
        }
      });
      var newColumns = _.differenceBy(oldColumns, removedColumns, '_variableName');
      _.each(addedColumns, function (addedColumn) {
        var fieldOption = _.find(setting.fieldOptions, {
          'fieldName': addedColumn
        });
        if (!_.isNil(fieldOption)) {
          newColumns.push({
            _columnHeading: fieldOption.displayLabel,
            _variableName: addedColumn,
            _width: fieldOption.width ? fieldOption.width : 150
          });
        }
      });

      // Special case with a new (empty) grid or grid with all columns removed
      if (_.isEmpty(newColumns)) {
        newColumns.push({
          _columnHeading: '',
          _variableName: '',
          _width: 150
        });
      }
      _.set(xmlObject, setting.xmlRootNodeName + '.' + setting.xmlSubProperty, newColumns);
      return xmlObject;
    };
    _this.processOptionGroupInputValueChange = function (optionGroupInput, suppressFormEvents, skipUpdateSettingObject) {
      var _this9 = this;
      var setting = this.settings[optionGroupInput.name];
      if (setting.inputType === inputType.NUMBER) {
        optionGroupInput.value = parseFloat(optionGroupInput.value);
      }
      setting.value = optionGroupInput.value;
      if (!skipUpdateSettingObject) {
        var settingObject = this.getSettingObject(setting.owningClass, this.selectedField);
        var isXmlSubProperty = !_.isNil(setting.xmlSubProperty);
        if (isXmlSubProperty) {
          var xmlObject = {};
          // We must properly parse the existing xml values, update the appropriate value and push the
          // updated xml string onto the object.
          xmlObject[setting.xmlRootNodeName] = {}; // Root the object with the xmlRootNodeName
          xmlObject[setting.xmlRootNodeName] = xmlUtil.parseStringWithoutFlattening(settingObject[setting.propertyName])[setting.xmlRootNodeName];
          if (_.isNil(xmlObject[setting.xmlRootNodeName])) {
            xmlObject[setting.xmlRootNodeName] = {};
          }
          if (setting.settingName === 'summaryColumns') {
            xmlObject = this.processSummaryColumns(setting, settingObject, xmlObject);
          } else {
            _.set(xmlObject, setting.xmlRootNodeName + '.' + setting.xmlSubProperty, setting.value);
          }
          settingObject[setting.propertyName] = xmlUtil.toXmlString(xmlObject);
        } else {
          if (setting.settingName === 'linkTo') {
            var propertyNameOrSplits = _.split(setting.propertyName, '||');
            var propertyNameConcatSplits = _.split(propertyNameOrSplits[0], '::');
            if (_.includes(setting.value, '::')) {
              var settingValueSplits = _.split(setting.value, '::');
              settingObject[propertyNameConcatSplits[0]] = settingValueSplits[0];
              settingObject[propertyNameConcatSplits[1]] = settingValueSplits[1];
              settingObject[propertyNameOrSplits[1]] = null;
            } else {
              settingObject[propertyNameOrSplits[1]] = setting.value;
              settingObject[propertyNameConcatSplits[0]] = null;
              settingObject[propertyNameConcatSplits[1]] = null;
            }
          } else {
            settingObject[setting.propertyName] = setting.value;
          }
        }
      }
      this.processDataSetSettings([setting]).then(function (updatedSettings) {
        _.each(updatedSettings, function (updatedSetting) {
          _this9.evaluateDisplayConditions(updatedSetting.settingName, /*parentIsActive*/true);
        });
      });
      this.evaluateDisplayConditions(optionGroupInput.name, /*parentIsActive*/true);
      this.evaluateOptionGroupVisibilities();
      formMediator.updateFieldStructureConfiguration(this.selectedFieldStructure, suppressFormEvents);
    };
    $scope.$on(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, function (event, optionGroupInput) {
      _this.processOptionGroupInputValueChange(optionGroupInput);
    });
    _this.$onChanges = function (changes) {
      var isRowRepeater = this.selectedFieldStructure.repeating;
      var selectedFieldExists = !_.isNil(changes.selectedField);
      var currentValueExists = !_.isNil(changes.selectedField.currentValue);
      var currentStructureId = null,
        previousStructureId = null;
      if (isRowRepeater) {
        currentStructureId = _.get(changes, 'selectedFieldStructure.currentValue.rowStructureId');
        previousStructureId = _.get(changes, 'selectedFieldStructure.previousValue.rowStructureId');
      } else {
        currentStructureId = _.get(changes, 'selectedFieldStructure.currentValue.fieldStructureId');
        previousStructureId = _.get(changes, 'selectedFieldStructure.previousValue.fieldStructureId');
      }
      if (selectedFieldExists && currentValueExists && currentStructureId !== previousStructureId) {
        this.init(this.selectedField);
      }
    };
    _this.init(_this.selectedField);
  });
};
ComponentSettingsController.$inject = ["$scope", "$element", "$stateParams", "$uibModal", "$q", "xmlUtil", "localization", "dataSetType", "componentSettingsMediator", "inputType", "displayConditionOperator", "formViewerModel", "configurationConstant", "formTemplateStatus", "fieldTemplateComponentSettingOwningClass", "formMediator", "componentSettingsUtil", "componentSettingsConstant", "authorizationConstants", "currentUserModel", "coreMediator", "configurationMediator", "modalUtil", "displayConditionLogicalOperator"];
angular.module('ums.configuration').controller('componentSettingsController', ComponentSettingsController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2424:
/***/ (function(module, exports) {

/*@ngInject*/
var ComponentSettingsMediator = function ComponentSettingsMediator(fieldTemplateComponentRepository) {
  this.getFieldTemplateComponentSettings = function (fieldType, uiFormTemplateId) {
    return fieldTemplateComponentRepository.getFieldTemplateComponentSettings(fieldType, uiFormTemplateId);
  };
  this.getFieldTemplateComponentTypes = function () {
    return fieldTemplateComponentRepository.getFieldTemplateComponentTypes();
  };
};
ComponentSettingsMediator.$inject = ["fieldTemplateComponentRepository"];
angular.module('ums.configuration').service('componentSettingsMediator', ComponentSettingsMediator);

/***/ }),

/***/ 2425:
/***/ (function(module, exports) {

/*@ngInject*/
var ComponentSettingsUtil = function ComponentSettingsUtil(componentSettingsConstant) {
  this.getOptionGroup = function (settingName) {
    // These option groups are not defined on the server, so we hard code them here. If in the future
    // they are added server-side, it wouldn't be difficult to change this.
    // UMS-19602
    switch (settingName) {
      case 'variableName':
      case 'flags':
      case 'syncToProperty':
        return componentSettingsConstant.optionGroups.CORE_SETTINGS;
      case 'displayLabel':
      case 'labelFontStyle':
      case 'labelPosition':
      case 'tooltipText':
      case 'labelWidth':
      case 'width':
      case 'spacerWidth':
        return componentSettingsConstant.optionGroups.DISPLAY_SETTINGS;
      case 'agencyVisible':
      case 'carrierVisible':
      case 'conditional':
      case 'showForProducts':
      case 'showRule':
        return componentSettingsConstant.optionGroups.VISIBILITY_SETTINGS;
      case 'agencyEditableFieldLevel':
      case 'carrierEditableFieldLevel':
      case 'disableExpressions':
        return componentSettingsConstant.optionGroups.EDITABILITY_SETTINGS;
      case 'requiredFieldLevel':
      case 'requiredLevelExpression':
        return componentSettingsConstant.optionGroups.REQUIRED_SETTINGS;
      case 'validator':
      case 'editRegularExpression':
      case 'numberDomain':
      case 'allowNegative':
      case 'addPercent':
      case 'minimumValueForRangeValidation':
      case 'maximumValueForRangeValidation':
      case 'addRounding':
      case 'addDollarSign':
      case 'dataSetType':
      case 'dataSetNames':
      case 'otherValidator':
      case 'maxChars':
        return componentSettingsConstant.optionGroups.VALIDATION_SETTINGS;
      case 'textDefaultValue':
      case 'checkboxDefaultValue':
      case 'yesNoDefaultValue':
      case 'valueExpression':
      case 'linkTo':
      case 'linkRefreshable':
      case 'dynamicDataSetDefault':
      case 'dataSetDefaultValue':
      case 'dataSetTextDefaultValue':
      case 'multiSelectDataSetDefaultValue':
      case 'multiSelectDataSetTextDefaultValue':
        return componentSettingsConstant.optionGroups.VALUE_SETTINGS;
      case 'prompt':
      case 'height':
      case 'spacerHeight':
      case 'logAccess':
      case 'parameters':
      case 'functionClass':
      case 'attachmentType':
      case 'isDropTargetChecked':
      case 'dropTargetHeight':
      case 'dropTargetPrompt':
      case 'isImageDisplayChecked':
      case 'imageHeight':
      case 'imageWidth':
      case 'showRowNumber':
      case 'rowsPerPage':
      case 'showAddButton':
      case 'showDeleteButton':
      case 'showImportButton':
      case 'showExportButton':
      case 'exportParameters':
      case 'maxRowsToDisplay':
      case 'formRepeaterSummary':
      case 'showYesText':
      case 'showNoText':
      case 'yesText':
      case 'noText':
      case 'enableTimeEntry':
      case 'classCodeType':
      case 'classCodeLabel':
      case 'maxWidth':
      case 'minWidth':
      case 'confirmationTitle':
      case 'confirmationMessage':
      case 'yesButtonLabel':
      case 'noButtonLabel':
      case 'processingIndicatorText':
      case 'dropDownOtherTrigger':
      case 'textOtherTrigger':
      case 'otherPrompt':
      case 'summaryColumns':
      case 'rowRepeaterRequired':
      case 'encryptedValue':
      case 'dropdownExecutor':
      case 'dropdownExecutorPrompt':
      case 'dropdownExecutorParameters':
      case 'dropdownExecutorConfirmationTitle':
      case 'dropdownExecutorConfirmationMessage':
      case 'dropdownExecutorYesButtonLabel':
      case 'dropdownExecutorNoButtonLabel':
      case 'dropdownExecutorProcessingIndicatorText':
      case 'formSummaryShowRequiredCountColumn':
      case 'formSummaryShowFormNumberColumn':
      case 'businessCard':
      case 'organizationCard':
      case 'richText':
        return componentSettingsConstant.optionGroups.COMPONENT_SPECIFIC_SETTINGS;
    }
  };
};
ComponentSettingsUtil.$inject = ["componentSettingsConstant"];
angular.module('ums.configuration').service('componentSettingsUtil', ComponentSettingsUtil);

/***/ }),

/***/ 2426:
/***/ (function(module, exports) {

/*@ngInject*/
var FieldTemplateComponentRepository = function FieldTemplateComponentRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getFieldTemplateComponentSettings = function (fieldType, uiFormTemplateId) {
    var url = '/rest/fieldTemplateComponent/settings',
      config = {
        params: {
          fieldType: fieldType,
          uiFormTemplateId: uiFormTemplateId
        }
      };
    return this.get(url, config);
  };
  this.getFieldTemplateComponentTypes = function () {
    var url = '/rest/fieldTemplateComponent/types';
    return this.get(url);
  };
};
FieldTemplateComponentRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('fieldTemplateComponentRepository', FieldTemplateComponentRepository);

/***/ }),

/***/ 2427:
/***/ (function(module) {

module.exports = JSON.parse("{\"optionGroup\":{\"booleanRadioButtons\":{\"true\":\"True\",\"false\":\"False\"}}}");

/***/ }),

/***/ 2428:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroup.tpl.html';
var html = "<div class=\"optionGroupContainer {{ ::$ctrl.optionGroupName }}OptionGroupContainer\">\n    <div class=\"optionGroupHeader\"\n         ng-if=\"$ctrl.displayHeader\">\n        <div class=\"optionGroupHeaderTitle\">{{ $ctrl.getHeaderTitle() }}</div>\n    </div>\n\n    <div class=\"{{ ::setting.settingName }}\"\n         ng-if=\"setting.isActive\"\n         ng-repeat=\"setting in $ctrl.settings\"\n         ng-switch on=\"setting.inputType\">\n\n        <!-- String Input -->\n        <ui-option-group-text-input selected-field=\"::$ctrl.selectedField\"\n                                    selected-field-structure=\"::$ctrl.selectedFieldStructure\"\n                                    name=\"::setting.settingName\"\n                                    label=\"::setting.label\"\n                                    input-type=\"::setting.inputType\"\n                                    input-limit=\"::setting.inputLimit\"\n                                    value=\"::setting.value\"\n                                    selected-field=\"::$ctrl.selectedField\"\n                                    trim=\"::setting.trim\"\n                                    is-disabled=\"::setting.disabled\"\n                                    ng-switch-when=\"0\"></ui-option-group-text-input>\n\n        <!-- Number Input -->\n        <ui-option-group-text-input selected-field=\"::$ctrl.selectedField\"\n                                    name=\"::setting.settingName\"\n                                    label=\"::setting.label\"\n                                    input-type=\"::setting.inputType\"\n                                    input-limit=\"::setting.inputLimit\"\n                                    value=\"::setting.value\"\n                                    is-disabled=\"::setting.disabled\"\n                                    ng-switch-when=\"1\"></ui-option-group-text-input>\n\n        <!-- Boolean Input -->\n        <ui-option-group-radio-buttons selected-field=\"::$ctrl.selectedField\"\n                                       name=\"::setting.settingName\"\n                                       label=\"::setting.label\"\n                                       group-name=\"::setting.settingName\"\n                                       options=\"::$ctrl.booleanRadioButtonOptions\"\n                                       value=\"::setting.value\"\n                                       is-disabled=\"::setting.disabled\"\n                                       ng-switch-when=\"2\"></ui-option-group-radio-buttons>\n\n        <!-- Button Input -->\n        <ui-option-group-button selected-field=\"::$ctrl.selectedField\"\n                                name=\"::setting.settingName\"\n                                label=\"::setting.label\"\n                                button-link-text=\"setting.value\"\n                                default-button-link-text=\"::setting.defaultValue\"\n                                is-disabled=\"::setting.disabled\"\n                                ng-switch-when=\"3\"></ui-option-group-button>\n\n        <!-- Radio Button Input -->\n        <ui-option-group-radio-buttons selected-field=\"::$ctrl.selectedField\"\n                                       name=\"::setting.settingName\"\n                                       label=\"::setting.label\"\n                                       group-name=\"::setting.settingName\"\n                                       options=\"::setting.values\"\n                                       value=\"::setting.value\"\n                                       is-disabled=\"::setting.disabled\"\n                                       ng-switch-when=\"4\"></ui-option-group-radio-buttons>\n\n        <!-- Drop Down Input -->\n        <ui-option-group-drop-down selected-field=\"::$ctrl.selectedField\"\n                                   name=\"::setting.settingName\"\n                                   label=\"::setting.label\"\n                                   values=\"setting.values\"\n                                   value=\"::setting.value\"\n                                   is-disabled=\"::setting.disabled\"\n                                   scrollable-container-selector=\"::$ctrl.scrollableContainerSelector\"\n                                   allow-clear=\"::setting.allowClearDropdown\"\n                                   allow-new-values=\"::setting.allowNewValues\"\n                                   ng-switch-when=\"5\"></ui-option-group-drop-down>\n\n        <!-- Check Box Input -->\n        <ui-option-group-checkbox selected-field=\"::$ctrl.selectedField\"\n                                  name=\"::setting.settingName\"\n                                  label=\"::setting.label\"\n                                  value=\"::setting.value\"\n                                  is-disabled=\"::setting.disabled\"\n                                  ng-switch-when=\"6\"></ui-option-group-checkbox>\n\n        <!-- Multi Select Input -->\n        <ui-option-group-multi-select selected-field=\"::$ctrl.selectedField\"\n                                      name=\"::setting.settingName\"\n                                      label=\"::setting.label\"\n                                      values=\"setting.values\"\n                                      value=\"::setting.value\"\n                                      value-delimiter=\"::setting.valueDelimiter\"\n                                      is-disabled=\"::setting.disabled\"\n                                      default-prompt-value=\"::setting.defaultPromptValue\"\n                                      ng-switch-when=\"7\"></ui-option-group-multi-select>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2429:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var OptionGroupController = function OptionGroupController($element, localization) {
  $element.addClass('optionGroup');
  this.booleanRadioButtonOptions = {};
  localization.getTranslations().then(function (translations) {
    this.booleanRadioButtonOptions[_.get(translations, 'optionGroup.booleanRadioButtons.true')] = 'true';
    this.booleanRadioButtonOptions[_.get(translations, 'optionGroup.booleanRadioButtons.false')] = 'false';
    this.getHeaderTitle = function () {
      return _.get(translations, this.headerTitleKey);
    };
  }.bind(this));
};
OptionGroupController.$inject = ["$element", "localization"];
angular.module('ums.configuration').controller('optionGroupController', OptionGroupController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2430:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2431);
__webpack_require__(2432);
__webpack_require__(2433);
var OptionGroupButtonComponent = {
  templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupButton/optionGroupButton.tpl.html',
  controller: 'optionGroupButtonController',
  bindings: {
    selectedField: '<',
    name: '<',
    label: '<',
    buttonLinkText: '<',
    defaultButtonLinkText: '<',
    isDisabled: '<'
  }
};
angular.module('ums.configuration').component('uiOptionGroupButton', OptionGroupButtonComponent);

/***/ }),

/***/ 2431:
/***/ (function(module) {

module.exports = JSON.parse("{\"optionGroupButton\":{\"field\":\"Field\",\"property\":\"Property\"}}");

/***/ }),

/***/ 2432:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupButton/optionGroupButton.tpl.html';
var html = "<div class=\"optionRow\">\n    <div class=\"optionGroupButtonLabel\">{{ ::$ctrl.label }}</div>\n\n    <div ng-if=\"$ctrl.name !== 'linkTo'\"\n         class=\"optionGroupButtonField\"\n         ng-class=\"{ disabled: $ctrl.isDisabled }\">\n\n        <a title=\"{{ $ctrl.tooltip }}\"\n           ng-class=\"{ disabled: $ctrl.isDisabled }\"\n           ng-click=\"$ctrl.click()\">{{ $ctrl.linkText }}</a>\n    </div>\n\n    <div class=\"btn-group buttonBar\"\n         ng-if=\"$ctrl.name === 'linkTo'\">\n        <label class=\"btn btn-xs\"\n               ng-class=\"{ disabled: $ctrl.isDisabled }\"\n               ng-disabled=\"$ctrl.isDisabled\"\n               ng-model=\"$ctrl.fieldPropertyModel\"\n               uib-btn-radio=\"'forms'\"\n               ui-translate>optionGroupButton.field</label>\n        <label class=\"btn btn-xs\"\n               ng-class=\"{ disabled: $ctrl.isDisabled }\"\n               ng-disabled=\"$ctrl.isDisabled\"\n               ng-model=\"$ctrl.fieldPropertyModel\"\n               uib-btn-radio=\"'objects'\"\n               ui-translate>optionGroupButton.property</label>\n    </div>\n</div>\n\n<div class=\"linkBox\"\n     ng-if=\"$ctrl.name === 'linkTo'\">\n    <ui-multi-step-selector-widget\n        mode=\"$ctrl.fieldPropertyModel\"\n        step-1-item-name=\"$ctrl.step1ItemName\"\n        step-2-item-name=\"$ctrl.step2ItemName\"\n        is-disabled=\"$ctrl.isDisabled\">\n    </ui-multi-step-selector-widget>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2433:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var OptionGroupButtonController = function OptionGroupButtonController($rootScope, $scope, $state, $timeout, $element, $uibModal, localization, configurationConstant) {
  $element.addClass('optionGroupButton');
  var timeoutList = [];
  localization.getTranslationByKey('optionGroupButton').then(function (translations) {
    this.step1ItemName = '';
    this.step2ItemName = '';
    this.init = function () {
      var valueArray, delimiter;
      this.defaultMode = 'forms';
      if (!_.isNil(this.selectedField.fieldTemplate.linkFormTemplateUniqueName) && !_.isNil(this.selectedField.fieldTemplate.linkVariableName)) {
        this.fieldPropertyModel = 'forms';
      } else if (!_.isNil(this.selectedField.fieldTemplate.linkPropertyPath)) {
        this.fieldPropertyModel = 'objects';
      } else {
        this.fieldPropertyModel = this.defaultMode;
      }
      if (this.name === 'linkTo') {
        if (!_.isNil(this.buttonLinkText)) {
          if (this.fieldPropertyModel === 'forms') {
            delimiter = '::';
          } else {
            delimiter = '.';
          }
          valueArray = _.split(this.buttonLinkText, delimiter);
          this.step1ItemName = valueArray[0];
          this.step2ItemName = valueArray[1];
        }
      }
      this.buildButtonLinkText();
    };
    this.$onChanges = function () {
      this.buildButtonLinkText();
    };
    this.buildButtonLinkText = function () {
      if (this.buttonLinkText) {
        if (this.buttonLinkText.length > 25) {
          this.linkText = this.buttonLinkText.substring(0, 25) + '...';
          this.tooltip = this.buttonLinkText;
        } else {
          this.linkText = this.buttonLinkText;
          this.tooltip = '';
        }
      } else {
        this.linkText = this.defaultButtonLinkText;
        this.tooltip = '';
      }
    };
    this.click = function () {
      if (this.defaultButtonLinkText === 'Edit Expression') {
        $uibModal.open({
          templateUrl: '/configuration/javaScriptExpression/javaScriptExpressionTemplate.tpl.html',
          controller: 'javaScriptExpressionController',
          windowClass: 'javaScriptExpressionModal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            fieldTemplate: function () {
              return this.selectedField.fieldTemplate;
            }.bind(this),
            expressionName: function () {
              return this.name;
            }.bind(this),
            expressionValue: function () {
              var propertyName = this.name;
              // special case that setting name is different from property name
              if ('disableExpressions' === propertyName) {
                propertyName = 'propertyExpression';
              }
              return this.selectedField.fieldTemplate[propertyName];
            }.bind(this)
          }
        });
      } else if (this.defaultButtonLinkText === 'Edit Regular Expression') {
        $uibModal.open({
          templateUrl: '/configuration/regularExpression/regularExpressionTemplate.tpl.html',
          controller: 'regularExpressionController',
          windowClass: 'regularExpressionModal',
          backdrop: 'static',
          keyboard: false,
          resolve: {
            fieldTemplate: function () {
              return this.selectedField.fieldTemplate;
            }.bind(this),
            propertyName: function () {
              return this.name;
            }.bind(this),
            propertyValue: function () {
              var value = null;
              if (this.buttonLinkText !== 'Edit Regular Expression') {
                value = this.buttonLinkText;
              }
              return value;
            }.bind(this)
          }
        });
      } else if (this.defaultButtonLinkText === 'Edit Rule') {
        $state.go('configuration.formEditor.rules', {
          ruleName: this.selectedField.fieldTemplate.triggerRuleName
        });
      }
    };
    if (this.name === 'linkTo') {
      timeoutList.push($timeout(function () {
        $scope.$on(configurationConstant.event.SELECTOR_WIDGET_UPDATED, function (event, item1Name, item2) {
          var value = null;
          if (this.fieldPropertyModel === 'forms' && !_.isNil(item1Name) && !_.isNil(item2.fieldName)) {
            value = item1Name + '::' + item2.fieldName;
          } else if (!_.isNil(item1Name) && !_.isNil(item2.propertyName)) {
            value = item1Name + '.' + item2.propertyName;
          }
          $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
            name: this.name,
            value: value
          });
        }.bind(this));
      }.bind(this), 0));
    }
    $scope.$on('$destroy', function () {
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
    this.init();
  }.bind(this));
};
OptionGroupButtonController.$inject = ["$rootScope", "$scope", "$state", "$timeout", "$element", "$uibModal", "localization", "configurationConstant"];
angular.module('ums.configuration').controller('optionGroupButtonController', OptionGroupButtonController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2434:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2435);
__webpack_require__(2436);
__webpack_require__(2437);
var OptionGroupCheckboxComponent = {
  templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupCheckbox/optionGroupCheckbox.tpl.html',
  controller: 'optionGroupCheckboxController',
  bindings: {
    selectedField: '<',
    name: '<',
    label: '<',
    value: '<',
    isDisabled: '<'
  }
};
angular.module('ums.configuration').component('uiOptionGroupCheckbox', OptionGroupCheckboxComponent);

/***/ }),

/***/ 2435:
/***/ (function(module) {

module.exports = JSON.parse("{\"optionGroupCheckbox\":{}}");

/***/ }),

/***/ 2436:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupCheckbox/optionGroupCheckbox.tpl.html';
var html = "<div class=\"optionGroupCheckboxLabel\">{{ ::$ctrl.label }}</div>\n<div class=\"optionGroupCheckboxField\">\n    <input type=\"checkbox\"\n           class=\"{{::$ctrl.getClassName()}}\"\n           ng-model=\"$ctrl.checkboxValue\"\n           ng-change=\"$ctrl.handleChange()\"\n           ng-disabled=\"$ctrl.isDisabled\"/>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2437:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var OptionGroupCheckboxController = function OptionGroupCheckboxController($rootScope, $element, localization, configurationConstant) {
  $element.addClass('optionGroupCheckbox');
  localization.getTranslationByKey('optionGroupCheckbox').then(function (translations) {
    this.init = function () {
      this.checkboxValue = this.value === 'true' || this.value === true;
    };
    this.handleChange = function () {
      $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
        name: this.name,
        value: this.checkboxValue
      });
    };
    this.getClassName = function () {
      return _.lowerFirst(this.label).replace(/\s/g, '') + 'Checkbox';
    };
    this.init();
  }.bind(this));
};
OptionGroupCheckboxController.$inject = ["$rootScope", "$element", "localization", "configurationConstant"];
angular.module('ums.configuration').controller('optionGroupCheckboxController', OptionGroupCheckboxController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2438:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2439);
__webpack_require__(2440);
__webpack_require__(2441);
var OptionGroupDropDownComponent = {
  templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupDropDown/optionGroupDropDown.tpl.html',
  controller: 'optionGroupDropDownController',
  bindings: {
    selectedField: '<',
    name: '<',
    label: '<',
    values: '<',
    value: '<',
    isDisabled: '<',
    scrollableContainerSelector: '<',
    allowClear: '<',
    allowNewValues: '<'
  }
};
angular.module('ums.configuration').component('uiOptionGroupDropDown', OptionGroupDropDownComponent);

/***/ }),

/***/ 2439:
/***/ (function(module) {

module.exports = JSON.parse("{\"optionGroupDropDown\":{\"placeholder\":\"Select\",\"createNewLabel\":\"(Create New)\"}}");

/***/ }),

/***/ 2440:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupDropDown/optionGroupDropDown.tpl.html';
var html = "<div class=\"optionGroupDropDownLabel\">{{ ::$ctrl.label }}</div>\n<ui-select class=\"optionGroupDropDownField dropdownComponentSelect {{ ::$ctrl.name }}\"\n           theme=\"select2\"\n           ng-model=\"$ctrl.dropdownSelectedValue\"\n           on-select=\"$ctrl.handleSelect()\"\n           append-to-body=\"true\"\n           placeholder=\"{{ ::$ctrl.placeholder }}\"\n           dropdown-unselect-item\n           dropdown-handle-focus\n           ui-hide-select-on-scroll\n           ui-hide-select-on-scroll-selector=\"{{ ::$ctrl.scrollableContainerSelector }}\"\n           ng-disabled=\"$ctrl.isDisabled\"\n           title=\"{{ $ctrl.tooltip }}\"\n           ng-class=\"{'error':!$ctrl.isValid }\">\n    <ui-select-match placeholder=\"{{ ::$ctrl.placeholder }}\"\n                     allow-clear=\"{{ ::$ctrl.allowClear }}\">\n        <span ng-bind=\"$select.selected.name\"></span>\n    </ui-select-match>\n    <ui-select-choices refresh=\"$ctrl.filterItems($select.search)\"\n                       refresh-delay=\"250\"\n                       repeat=\"item in $ctrl.filteredItemsList\">\n        <span ng-bind=\"item.name\"></span>\n        <span ng-if=\"item.isCreateNew\"\n              class=\"createNewLabel\"\n              ui-translate>optionGroupDropDown.createNewLabel</span>\n    </ui-select-choices>\n</ui-select>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2441:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var OptionGroupDropDownController = function OptionGroupDropDownController($rootScope, $scope, $element, $timeout, localization, configurationConstant, coreConstant) {
  $element.addClass('optionGroupDropDown');
  localization.getTranslationByKey('optionGroupDropDown').then(function (translations) {
    var timeoutList = [];
    this.isValid = true;
    this.init = function () {
      if (_.isNil(this.value) || this.value === '[select]') {
        this.value = '';
      }
      this.placeholder = _.get(translations, 'placeholder');
      this.initItemsList(this.value);
      timeoutList.push($timeout(function () {
        $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue);
      }.bind(this), 0));
    };
    this.initItemsList = function (selectedValue) {
      var valueMatch;
      this.itemsList = _.map(_.keys(this.values), function (key) {
        return {
          name: key,
          value: this.values[key]
        };
      }.bind(this));
      if (this.allowNewValues) {
        valueMatch = _.find(this.itemsList, function (item) {
          return item.value === selectedValue;
        });
        if (_.isNil(valueMatch)) {
          this.itemsList.push({
            name: selectedValue,
            value: selectedValue
          });
        }
      }
      if (!_.isEmpty(selectedValue)) {
        this.dropdownSelectedValue = _.find(this.itemsList, {
          value: selectedValue
        });
        if (_.isNil(this.dropdownSelectedValue) && !_.isNil(this.value)) {
          this.placeholder = this.value;
          this.isValid = false;
        }
      } else {
        this.dropdownSelectedValue = '';
      }
      this.filteredItemsList = this.itemsList;
      this.buildTooltip();
    };
    this.buildTooltip = function () {
      this.tooltip = '';
      if (!_.isNil(this.dropdownSelectedValue) && !_.isNil(this.dropdownSelectedValue.name)) {
        if (this.dropdownSelectedValue.name.length > 45) {
          this.tooltip = this.dropdownSelectedValue.name;
        }
      }
    };
    this.handleSelect = function () {
      if (!_.isNil(this.dropdownSelectedValue)) {
        this.initItemsList(this.dropdownSelectedValue.value);
      }
      $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
        name: this.name,
        value: !_.isNil(this.dropdownSelectedValue) ? this.dropdownSelectedValue.value : null
      });
      $scope.$broadcast(coreConstant.event.dropdown.DROPDOWN_ITEM_CHANGED, this.dropdownSelectedValue);
      this.isValid = true;
    };
    this.filterItems = function (searchText) {
      var filteredItemsList = [],
        newValueMatch;
      if (!_.isEmpty(searchText)) {
        filteredItemsList = _.filter(this.itemsList, function (item) {
          return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
        });
        if (this.allowNewValues) {
          // Add the new value to the filtered list if the searchText entered does not match anything in
          // the current list
          newValueMatch = _.find(filteredItemsList, function (item) {
            return item.name.toLowerCase() === searchText.toLowerCase();
          });
          if (_.isNil(newValueMatch)) {
            filteredItemsList.push({
              name: searchText,
              value: searchText,
              isCreateNew: true
            });
          }
        }
      } else {
        filteredItemsList = this.itemsList;
      }
      this.filteredItemsList = filteredItemsList;
    };
    this.$onChanges = function (changes) {
      if (!_.isNil(changes.values)) {
        this.init();
      }
    };
    $scope.$on('$destroy', function () {
      _.each(timeoutList, function (item) {
        $timeout.cancel(item);
      });
    });
    this.init();
  }.bind(this));
};
OptionGroupDropDownController.$inject = ["$rootScope", "$scope", "$element", "$timeout", "localization", "configurationConstant", "coreConstant"];
angular.module('ums.configuration').controller('optionGroupDropDownController', OptionGroupDropDownController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2442:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2443);
__webpack_require__(2444);
__webpack_require__(2445);
var OptionGroupMultiSelectComponent = {
  templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupMultiSelect/optionGroupMultiSelect.tpl.html',
  controller: 'optionGroupMultiSelectController',
  bindings: {
    selectedField: '<',
    name: '<',
    label: '<',
    values: '<',
    value: '<',
    valueDelimiter: '<',
    isDisabled: '<',
    defaultPromptValue: '<'
  }
};
angular.module('ums.configuration').component('uiOptionGroupMultiSelect', OptionGroupMultiSelectComponent);

/***/ }),

/***/ 2443:
/***/ (function(module) {

module.exports = JSON.parse("{\"optionGroupMultiSelect\":{\"placeholder\":\"Select\"}}");

/***/ }),

/***/ 2444:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupMultiSelect/optionGroupMultiSelect.tpl.html';
var html = "<div class=\"optionGroupMultiSelectLabel\">{{ ::$ctrl.label }}</div>\n<ui-multi-select items-list=\"$ctrl.itemsList\"\n                 selected-value=\"$ctrl.value\"\n                 item-name=\"::$ctrl.name\"\n                 prompt-value=\"::$ctrl.placeholder\"\n                 is-disabled=\"$ctrl.isDisabled\"\n                 append-to-body=\"true\"\n                 delimiter=\"::$ctrl.valueDelimiter\"\n                 title=\"{{ $ctrl.tooltip }}\"></ui-multi-select>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2445:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var OptionGroupMultiSelectController = function OptionGroupMultiSelectController($rootScope, $scope, $element, localization, coreConstant, configurationConstant) {
  $element.addClass('optionGroupMultiSelect');
  localization.getTranslationByKey('optionGroupMultiSelect').then(function (translations) {
    this.init = function () {
      if (_.isNil(this.value)) {
        this.value = '';
      }
      this.placeholder = _.isNil(this.defaultPromptValue) ? _.get(translations, 'placeholder') : this.defaultPromptValue;
      this.initItemsList(this.value);
    };
    this.initItemsList = function (selectedValue) {
      this.itemsList = _.map(_.keys(this.values), function (key) {
        return {
          name: key,
          value: this.values[key]
        };
      }.bind(this));
    };
    this.buildTooltip = function (value) {
      this.tooltip = '';
      if (!_.isNil(value)) {
        if (value.length > 45) {
          this.tooltip = value;
        }
      }
    };
    this.$onChanges = function (changes) {
      if (!_.isNil(changes.values)) {
        this.init();
      }
    };
    $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
      if (this.name === itemName) {
        var tempItemList = _.filter(this.itemsList, function (item) {
            return item.selected;
          }),
          values = _.map(tempItemList, 'value');
        values = _.join(values, this.valueDelimiter);
        if (this.value !== values) {
          this.value = values;
          $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
            name: this.name,
            value: this.value
          });
        }
      }
    }.bind(this));
    $scope.$on(coreConstant.event.MULTI_SELECT_BUTTON_LABEL_UPDATED, function (event, itemName, buttonLabel) {
      if (this.name === itemName) {
        this.buildTooltip(buttonLabel);
      }
    }.bind(this));
    this.init();
  }.bind(this));
};
OptionGroupMultiSelectController.$inject = ["$rootScope", "$scope", "$element", "localization", "coreConstant", "configurationConstant"];
angular.module('ums.configuration').controller('optionGroupMultiSelectController', OptionGroupMultiSelectController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2446:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2447);
__webpack_require__(2448);
__webpack_require__(2449);
var OptionGroupRadioButtonsComponent = {
  templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupRadioButtons/optionGroupRadioButtons.tpl.html',
  controller: 'optionGroupRadioButtonsController',
  bindings: {
    selectedField: '<',
    name: '<',
    label: '<',
    groupName: '<',
    options: '<',
    value: '<',
    isDisabled: '<'
  }
};
angular.module('ums.configuration').component('uiOptionGroupRadioButtons', OptionGroupRadioButtonsComponent);

/***/ }),

/***/ 2447:
/***/ (function(module) {

module.exports = JSON.parse("{\"optionGroupRadioButtons\":{}}");

/***/ }),

/***/ 2448:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupRadioButtons/optionGroupRadioButtons.tpl.html';
var html = "<div class=\"optionGroupRadioButtonsLabel\">{{ ::$ctrl.label }}</div>\n<div class=\"optionGroupRadioButtonsContainer\">\n    <div class=\"optionGroupRadioButtonsField\">\n        <label ng-class=\"{ disabled: $ctrl.isDisabled }\"\n               ng-repeat=\"(key, value) in $ctrl.options\">\n            <input type=\"radio\"\n                   ng-class=\"{ disabled: $ctrl.isDisabled }\"\n                   name=\"{{ ::$ctrl.groupName }}\"\n                   ng-model=\"$ctrl.radioButtonValue\"\n                   ng-value=\"::value\"\n                   ng-change=\"$ctrl.handleChange()\"\n                   ng-disabled=\"$ctrl.isDisabled\"/>\n            {{ ::key }}\n        </label>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2449:
/***/ (function(module, exports) {

/*@ngInject*/
var OptionGroupRadioButtonsController = function OptionGroupRadioButtonsController($rootScope, $element, localization, configurationConstant) {
  $element.addClass('optionGroupRadioButtons');
  localization.getTranslationByKey('optionGroupRadioButtons').then(function (translations) {
    this.init = function () {
      this.radioButtonValue = this.value || '';
    };
    this.handleChange = function () {
      $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
        name: this.name,
        value: this.radioButtonValue
      });
    };
    this.init();
  }.bind(this));
};
OptionGroupRadioButtonsController.$inject = ["$rootScope", "$element", "localization", "configurationConstant"];
angular.module('ums.configuration').controller('optionGroupRadioButtonsController', OptionGroupRadioButtonsController);

/***/ }),

/***/ 2450:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2451);
__webpack_require__(2452);
__webpack_require__(2453);
var OptionGroupTextInputComponent = {
  templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupTextInput/optionGroupTextInput.tpl.html',
  controller: 'optionGroupTextInputController',
  bindings: {
    selectedField: '<',
    selectedFieldStructure: '<',
    name: '<',
    label: '<',
    inputType: '<',
    enableNumberSpinner: '<',
    inputLimit: '<',
    value: '<',
    trim: '<',
    isDisabled: '<'
  }
};
angular.module('ums.configuration').component('uiOptionGroupTextInput', OptionGroupTextInputComponent);

/***/ }),

/***/ 2451:
/***/ (function(module) {

module.exports = JSON.parse("{\"optionGroupTextInput\":{}}");

/***/ }),

/***/ 2452:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupTextInput/optionGroupTextInput.tpl.html';
var html = "<div class=\"optionGroupTextInputLabel\">{{ ::$ctrl.label }}</div>\n<div class=\"optionGroupTextInputField\">\n    <input type=\"{{ ::$ctrl.type }}\"\n           ui-max-chars=\"{{ ::$ctrl.inputLimit }}\"\n           ng-model=\"$ctrl.value\"\n           ng-blur=\"$ctrl.handleChange()\"\n           ui-enter=\"$ctrl.handleChange()\"\n           ng-disabled=\"$ctrl.isDisabled\"/>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2453:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var OptionGroupTextInputController = function OptionGroupTextInputController($rootScope, $element, $uibModal, localization, configurationConstant, configurationMediator, modalUtil, inputType) {
  $element.addClass('optionGroupTextInput');
  localization.getTranslationByKey('optionGroupTextInput').then(function (translations) {
    var currentValue;
    this.init = function () {
      currentValue = this.value;
      if (this.inputType === inputType.NUMBER) {
        this.type = 'number';
      } else {
        this.type = 'text';
      }
    };
    this.handleChange = function () {
      var fieldTemplateId = this.selectedField.fieldTemplate.id,
        variableName = this.selectedField.fieldTemplate.variableName,
        isNumericValue = this.inputType === inputType.NUMBER,
        isNegativeNumericValue = _.indexOf(this.value, '-') !== -1,
        isNumberRange = this.selectedField.fieldTemplate.validator === 'number range',
        isPercent = this.selectedField.fieldTemplate.validator === 'percent';
      if (isNumericValue && isNegativeNumericValue && !isNumberRange && !isPercent) {
        this.value = '0';
      }
      if (this.trim) {
        this.value = _.trim(this.value);
      }
      if (currentValue !== this.value) {
        if (this.name === 'variableName' && this.selectedFieldStructure.originalVariableName === currentValue) {
          configurationMediator.getFieldReferences(fieldTemplateId).then(function (fieldTemplateReferences) {
            if (fieldTemplateReferences.length > 0) {
              modalUtil.openFieldReferencesModal('fieldReferencesConfirmVariableChange', fieldTemplateReferences, variableName, true).then(function (isConfirmed) {
                if (isConfirmed) {
                  this.broadcastInputValueChange();
                } else {
                  this.value = currentValue;
                }
              }.bind(this));
            } else {
              this.broadcastInputValueChange();
            }
          }.bind(this));
        } else {
          this.broadcastInputValueChange();
        }
      }
    };
    this.broadcastInputValueChange = function () {
      currentValue = this.value;
      $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
        name: this.name,
        value: this.value
      });
    };
    this.init();
  }.bind(this));
};
OptionGroupTextInputController.$inject = ["$rootScope", "$element", "$uibModal", "localization", "configurationConstant", "configurationMediator", "modalUtil", "inputType"];
angular.module('ums.configuration').controller('optionGroupTextInputController', OptionGroupTextInputController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2454:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2455);
__webpack_require__(2456);
__webpack_require__(2457);
var FormBuilderLeftNavComponent = {
  templateUrl: '/configuration/formEditor/content/form/leftNav/formBuilderLeftNav.tpl.html',
  controller: 'formBuilderLeftNavController',
  bindings: {}
};
angular.module('ums.configuration').component('uiFormBuilderLeftNav', FormBuilderLeftNavComponent);

/***/ }),

/***/ 2455:
/***/ (function(module) {

module.exports = JSON.parse("{\"formBuilderLeftNav\":{\"insertComponent\":\"Insert Component\",\"componentSettings\":\"Component Settings\",\"componentSettingsSubText\":\"Select a field to edit\"}}");

/***/ }),

/***/ 2456:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/content/form/leftNav/formBuilderLeftNav.tpl.html';
var html = "<ui-collapsible-left-nav collapsible=\"true\">\n    <ui-accordion-button label=\"$ctrl.insertComponentLabel\"\n                         value=\"'insertComponent'\"\n                         has-children=\"true\"\n                         close-other-accordions-on-open=\"true\"\n                         notify-accordion-button-click=\"$ctrl.insertComponentClicked()\">\n        <ui-component-palette form-template-type=\"$ctrl.formTemplateType\"></ui-component-palette>\n    </ui-accordion-button>\n\n    <ui-accordion-button label=\"$ctrl.componentSettingsLabel\"\n                         sub-text-label=\"{{ $ctrl.componentSettingsSubTextLabel }}\"\n                         value=\"'componentSettings'\"\n                         has-children=\"$ctrl.areComponentSettingsActive()\"\n                         is-disabled=\"!$ctrl.areComponentSettingsActive()\"\n                         close-other-accordions-on-open=\"true\"\n                         disable-chevron=\"$ctrl.isSection\"\n                         custom-icon=\"$ctrl.deleteComponentCustomIcon\"\n                         notify-custom-icon-click=\"$ctrl.componentSettingsDeleteButtonClicked()\"\n                         disable-user-interaction=\"true\">\n\n        <ui-component-settings selected-field=\"$ctrl.selectedField\"\n                               selected-field-structure=\"$ctrl.fieldStructure\"\n                               scrollable-container-selector=\"'.formBuilderLeftNav .childButtonContainer'\"></ui-component-settings>\n    </ui-accordion-button>\n</ui-collapsible-left-nav>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2457:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormBuilderLeftNavController = function FormBuilderLeftNavController($rootScope, $scope, $element, $stateParams, localization, formViewerConstant, formMediator, coreConstant, modalUtil, authorizationConstants, currentUserModel, formTemplateStatus, configurationMediator) {
  $element.addClass('formBuilderLeftNav');
  this.isSection = false;
  this.$onInit = function () {
    configurationMediator.getFormTemplateById($stateParams.uiFormTemplateId).then(function (formTemplateConfig) {
      this.formTemplateType = formTemplateConfig.formTemplate.type;
    }.bind(this));
  };
  localization.getTranslations().then(function (translations) {
    this.selectedField = null;
    this.insertComponentLabel = _.get(translations, 'formBuilderLeftNav.insertComponent');
    this.componentSettingsLabel = _.get(translations, 'formBuilderLeftNav.componentSettings');
    this.componentSettingsSubTextLabel = _.get(translations, 'formBuilderLeftNav.componentSettingsSubText');
    this.deleteComponentCustomIcon = null;
    this.areComponentSettingsActive = function () {
      return !_.isNil(this.selectedField);
    };
    this.componentSettingsDeleteButtonClicked = function () {
      var message = _.get(translations, 'componentEditor.deleteComponentConfirmation.summary'),
        title = _.get(translations, 'componentEditor.deleteComponentConfirmation.title'),
        cancelButtonLabel = _.get(translations, 'genericButtons.cancel'),
        confirmButtonLabel = _.get(translations, 'genericButtons.continue');
      function handleClose() {
        if (this.fieldStructure.repeating) {
          formMediator.deleteRow(this.fieldStructure.rootFormId, this.fieldStructure.rowStructureId);
        } else {
          formMediator.deleteField(this.fieldStructure.rootFormId, this.fieldStructure.fieldStructureId);
        }
        $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
      }
      modalUtil.showGenericConfirm({
        cancelButtonLabel: cancelButtonLabel,
        confirmActionButtonLabel: confirmButtonLabel,
        summary: message,
        title: title
      }).then(handleClose.bind(this));
    };
    this.insertComponentClicked = function () {
      $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
    };
    this.updateComponentSettings = function () {
      if (!_.isNil(this.selectedField)) {
        var userCanManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);
        this.componentSettingsSubTextLabel = _.get(translations, 'componentSettings.fieldType.' + this.selectedField.fieldTemplate.type);
        this.deleteComponentCustomIcon = null;
        if (userCanManageForms) {
          if (this.fieldStructure.parentFormStructure.uiFormTemplate.formTemplate.status === formTemplateStatus.IN_PRODUCTION) {
            if (this.selectedField.id === -1) {
              this.deleteComponentCustomIcon = 'glyphicon glyphicon-trash';
            }
          } else {
            this.deleteComponentCustomIcon = 'glyphicon glyphicon-trash';
          }
        }
        $rootScope.$broadcast(coreConstant.event.OPEN_ACCORDION_BUTTON, {
          value: 'componentSettings'
        });
      } else {
        this.componentSettingsSubTextLabel = _.get(translations, 'formBuilderLeftNav.componentSettingsSubText');
        this.deleteComponentCustomIcon = null;
        $rootScope.$broadcast(coreConstant.event.CLOSE_ACCORDION_BUTTON, {
          value: 'componentSettings'
        });
      }
    };
    $scope.$on(coreConstant.event.COLLAPSIBLE_LEFT_NAV_OPENED, function () {
      $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
    });
    $scope.$on(coreConstant.event.COLLAPSIBLE_LEFT_NAV_CLOSED, function () {
      $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, null);
    });
    $scope.$on(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, function (event, fieldStructure) {
      this.isSection = false;
      if (_.isNil(fieldStructure)) {
        this.selectedField = null;
      } else {
        this.selectedField = fieldStructure.uiField;
        this.fieldStructure = fieldStructure;
      }
      this.updateComponentSettings();
    }.bind(this));
    $scope.$on(formViewerConstant.configuration.event.CREATE_NEW_COMPONENT, function (event, newComponent) {
      this.isSection = false;
      this.selectedField = newComponent.fieldStructure.uiField;
      this.fieldStructure = newComponent.fieldStructure;
      this.updateComponentSettings();
      $rootScope.$broadcast(formViewerConstant.configuration.event.FIELD_SELECTION_CHANGE, newComponent.fieldStructure);
    }.bind(this));
    $scope.$on(formViewerConstant.configuration.event.SECTION_SELECTION_CHANGE, function (event, sectionStructure) {
      this.selectedField = sectionStructure.sectionTemplate;
      this.fieldStructure = sectionStructure;
      this.componentSettingsSubTextLabel = _.get(translations, 'componentSettings.structureType.SECTION');
    }.bind(this));
    $scope.$on(formViewerConstant.configuration.event.ROW_SELECTION_CHANGE, function (event, rowStructure) {
      if (rowStructure.repeating) {
        this.selectedField = rowStructure.rowTemplate.repeaterField;
        this.fieldStructure = rowStructure;
      } else {
        this.selectedField = null;
        this.fieldStructure = null;
      }
      this.updateComponentSettings();
    }.bind(this));
    $scope.$on(formViewerConstant.configuration.event.DELETE_SECTION, function (event) {
      this.selectedField = null;
      this.fieldStructure = null;
      this.componentSettingsSubTextLabel = '';
    }.bind(this));
  }.bind(this));
};
FormBuilderLeftNavController.$inject = ["$rootScope", "$scope", "$element", "$stateParams", "localization", "formViewerConstant", "formMediator", "coreConstant", "modalUtil", "authorizationConstants", "currentUserModel", "formTemplateStatus", "configurationMediator"];
angular.module('ums.configuration').controller('formBuilderLeftNavController', FormBuilderLeftNavController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2458:
/***/ (function(module, exports) {

/*@ngInject*/
var UiFormTemplateModel = function UiFormTemplateModel($rootScope) {
  var uiFormTemplate,
    ruleType = 'formRule',
    selectedFieldRuleName;
  this.getUiFormTemplate = function () {
    return this.uiFormTemplate;
  };
  this.setUiFormTemplate = function (uiFormTemplate) {
    this.uiFormTemplate = uiFormTemplate;
  };
  this.setCurrentSelectedRule = function (ruleType) {
    this.ruleType = ruleType;
  };
  this.getCurrentSelectedRule = function (ruleType) {
    return this.ruleType;
  };
  this.setSelectedFieldRuleName = function (selectedFieldRuleName) {
    this.selectedFieldRuleName = selectedFieldRuleName;
  };
  this.getSelectedFieldRuleName = function () {
    return this.selectedFieldRuleName;
  };
};
UiFormTemplateModel.$inject = ["$rootScope"];
angular.module('umCore').service('uiFormTemplateModel', UiFormTemplateModel);

/***/ }),

/***/ 2459:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2460);
__webpack_require__(2461);
__webpack_require__(2462);
__webpack_require__(2463);
__webpack_require__(2464);
__webpack_require__(2465);
var FormEditorHeaderComponent = {
  templateUrl: '/configuration/formEditor/header/formEditorHeader.tpl.html',
  controller: 'formEditorHeaderController',
  bindings: {}
};
angular.module('ums').component('uiFormEditorHeader', FormEditorHeaderComponent);

/***/ }),

/***/ 2460:
/***/ (function(module) {

module.exports = JSON.parse("{\"formEditorHeader\":{\"backButton\":\"Back\",\"typeLabel\":\"Type:\",\"statusLabel\":\"Status:\",\"versionLabel\":\"Version:\",\"displayNameLabel\":\"Display Name:\",\"effectiveDateLabel\":\"Effective Dates:\",\"templateStatus\":{\"0\":\"Draft\",\"1\":\"In Production\",\"2\":\"Published\"},\"invalidLabel\":\"(Invalid)\",\"unsavedChanges\":\"Unsaved changes\",\"saveOrDiscardChangesBeforePublishing\":\"Save or Discard changes before publishing.\"},\"formEditor\":{\"actions\":{\"form template settings\":\"Form Template Settings\",\"delete\":\"Delete\",\"mark in production\":\"Mark In Production\",\"test draft form templates\":\"Test Draft Form Templates\",\"save\":\"Save\",\"discard\":\"Discard\",\"save as new version\":\"Save As New Version\",\"export\":\"Export\",\"show form references\":\"Show Form References\",\"reload form rules\":\"Reload Form Rules\",\"reload field rules\":\"Reload Field Rules\",\"publish form templates\":\"Publish\",\"name\":\"Actions\"},\"discard\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"success\":\"Your changes have been discarded.\"},\"createFormTemplateSet\":{\"loadingBar\":\"Creating Form Template Set...\",\"confirmationTitle\":\"Create Form Template Set\",\"confirmationConfirmActionButtonLabel\":\"Ok\",\"confirmation\":\"A new form template set (ID={0}) has been successfully created.\"},\"saveUiFormTemplate\":{\"loadingBar\":\"Saving Form Template...\",\"confirmationTitle\":\"Form Template Validation Error\",\"confirmationConfirmActionButtonLabel\":\"Ok\",\"saveSucceeded\":\"Form Template Saved\",\"saveSucceededWithErrors\":\"Your form template changes were successfully saved, however the following errors were found (these will need to be fixed before the form template can be published in a form template set).\",\"saveFailedWithErrors\":\"Your form template changes could not be saved because of the following errors:\",\"duplicateUniqueNameVersionCombination\":\"A form template with the same unique name \\\"{formTemplateUniqueName}\\\" and version number \\\"{formTemplateVersionNumber}\\\" already exists.\",\"emptyDisplayName\":\"Please specify a form template display name.\",\"emptyPrecedingFieldOrPreceedingFormTypeMismatch\":\"Please specify a preceding field for this form template, choosing a field from a form template which is of type \\\"{formTemplateType}\\\"\",\"triggerRuleNotConfigured\":\"Please configure a valid form template rule defining the condition(s) under which instances of this form template will be displayed.\",\"triggerRuleError\":\"Please configure a valid form template rule defining the condition(s) under which instances of this form template will be displayed.\",\"invalidFieldRule\":\"Please configure a valid form template field rule.\"},\"deleteFormTemplate\":{\"loadingBar\":\"Deleting Form Template...\",\"resultMessage\":\"Successfully deleted form template\"},\"markFormTemplateInProduction\":{\"loadingBar\":\"Marking Form Template In Production...\",\"title\":\"Mark Form Template In Production\",\"summary\":\"Marking this form template 'In Production' will prevent you from deleting this form template or any of its field templates and from making any changes that would affect the required field count. This action cannot be reverted. Are you sure you want to continue?\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"resultMessage\":\"Successfully marked form template in production.\"},\"exportFormTemplate\":{\"loadingBar\":\"Exporting Form Template...\",\"successMessage\":\"Successfully exported form template\"}}}");

/***/ }),

/***/ 2461:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormEditorHeaderController = function FormEditorHeaderController($rootScope, $scope, $element, $stateParams, $state, localization, configurationMediator, formViewerConstant, uIFormTemplateAction, configurationActionsUtil, modalUtil, coreConstant, formViewerModel, loadingBarHandler, uiFormTemplateModel, coreMediator) {
  $element.addClass('formEditorHeader');
  localization.getTranslations().then(function (translations) {
    this.formTemplateConfig = null;
    this.formTemplate = null;
    this.uiFormTemplateId = $stateParams.uiFormTemplateId;
    this.formTemplateUniqueName = '';
    this.hasEffectiveDate = false;
    this.formTemplateTypeLabel = null;
    this.enableSaveAndDiscard = false;
    this.shortDateFormat = coreMediator.getPreferenceByName('view.shortDateFormat');
    this.actions = [];
    this.actionSubTexts = {};
    this.context = {
      identifier: 'formEditor',
      actions: {},
      fallthrough: null,
      model: {
        contextType: coreConstant.CONTEXT_NONE
      }
    };
    this.context.actions[coreConstant.CONTEXT_NONE] = '';
    this.loadActions = function () {
      configurationMediator.loadUiFormTemplateActions('com.firstbest.underwriting.form.ui.UIFormTemplate:' + this.uiFormTemplateId).then(function (actions) {
        var allActions = [];
        allActions.push({
          actions: actions.actions,
          contextType: this.context.model.contextType
        });
        this.processActions(allActions, /*enableSaveAndDiscard*/false);
      }.bind(this));
    };
    this.loadFormTemplate = function () {
      configurationMediator.getFormTemplateById($stateParams.uiFormTemplateId).then(function (formTemplateConfig) {
        this.formTemplateConfig = formTemplateConfig;
        this.formTemplate = formTemplateConfig.formTemplate;
        this.formTemplateUniqueName = formTemplateConfig.formTemplate.uniqueName;
        this.formTemplateId = formTemplateConfig.formTemplate.id;
        this.hasEffectiveDate = this.formTemplate.effectiveDateRangeBegin && this.formTemplate.effectiveDateRangeEnd;
        this.formTemplateTypeLabel = _.get(translations, 'formTemplateBrowser.type.' + this.formTemplate.type);
        this.formTemplateStatus = _.get(translations, 'formEditorHeader.templateStatus.' + this.formTemplate.status);
        this.invalidFormTemplate = !_.isNil(this.formTemplate.valid) && !this.formTemplate.valid;
      }.bind(this));
    };
    this.processActions = function (actions, enableSaveAndDiscard) {
      this.actions = actions;
      this.actionSubTexts = {};
      _.each(this.actions, function (subAction) {
        _.each(subAction.actions, function (action) {
          if (action.name === uIFormTemplateAction.SAVE || action.name === uIFormTemplateAction.DISCARD) {
            action.enabled = enableSaveAndDiscard;
          }
          if (action.name === uIFormTemplateAction.PUBLISH_FORM_TEMPLATES || action.name === uIFormTemplateAction.TEST_DRAFT_FORM_TEMPLATES) {
            action.enabled = !enableSaveAndDiscard;
            if (!action.enabled) {
              action.notes = _.get(translations, 'formEditorHeader.saveOrDiscardChangesBeforePublishing');
            }
          }
          if (action.name === uIFormTemplateAction.SAVE && action.enabled) {
            this.actionSubTexts[action.name] = {
              class: 'unsavedChanges',
              text: _.get(translations, 'formEditorHeader.unsavedChanges')
            };
          }
        }.bind(this));
      }.bind(this));
      this.actionsTimeLastModified = new Date().getTime();
    };
    this.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case uIFormTemplateAction.SAVE:
            configurationActionsUtil.saveUiFormTemplate(this.uiFormTemplateId, false);
            break;
          case uIFormTemplateAction.SAVE_AS_NEW_VERSION:
            configurationActionsUtil.saveUiFormTemplate(this.uiFormTemplateId, true);
            break;
          case uIFormTemplateAction.SHOW_FORM_REFERENCES:
            configurationActionsUtil.showFormReferences('formReferences', this.uiFormTemplateId, this.formTemplateUniqueName);
            break;
          case uIFormTemplateAction.PUBLISH_FORM_TEMPLATES:
            configurationActionsUtil.publishFormTemplates('formEditor.createFormTemplateSet.loadingBar', [this.formTemplate]);
            break;
          case uIFormTemplateAction.TEST_DRAFT_FORM_TEMPLATES:
            configurationActionsUtil.createTestFormTemplateSet();
            break;
          case uIFormTemplateAction.RELOAD_FORM_RULES:
            configurationActionsUtil.reloadFormRules();
            break;
          case uIFormTemplateAction.RELOAD_FIELD_RULES:
            configurationActionsUtil.reloadFieldRules();
            break;
          case uIFormTemplateAction.FORM_TEMPLATE_SETTINGS:
            configurationActionsUtil.showFormTemplateSettings(this.uiFormTemplateId);
            break;
          case uIFormTemplateAction.DELETE:
            configurationActionsUtil.deleteFormTemplate(this.uiFormTemplateId, this.formTemplateUniqueName, _.get(translations, 'formEditor'), 'formEditor.deleteFormTemplate.loadingBar');
            break;
          case uIFormTemplateAction.MARK_IN_PRODUCTION:
            configurationActionsUtil.markFormTemplateInProduction(this.uiFormTemplateId, 'formEditor.markFormTemplateInProduction', _.get(translations, 'formEditor'));
            break;
          case uIFormTemplateAction.EXPORT:
            configurationActionsUtil.exportFormTemplate(this.formTemplateId, 'formEditor.exportFormTemplate.loadingBar');
            break;
          case uIFormTemplateAction.DISCARD:
            modalUtil.showConfirmationModal(null, null, null, 'formEditor.discard', null, true, function () {
              $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'formEditor.discard.success'));
              $state.reload();
            });
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
    $scope.$on(formViewerConstant.event.FORM_TEMPLATE_INVALIDATED, function () {
      this.invalidFormTemplate = true;
    }.bind(this));
    $scope.$on(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED, function (event, uiFormTemplate) {
      if (!_.isNil(uiFormTemplate)) {
        this.invalidFormTemplate = !uiFormTemplate.formTemplate.valid;
      }
      this.enableSaveAndDiscard = true;
      this.processActions(this.actions, this.enableSaveAndDiscard);
    }.bind(this));
    $scope.$on(formViewerConstant.event.formBuilder.FORM_TEMPLATE_SAVED, function (event, uiFormTemplate) {
      if (!_.isNil(uiFormTemplate)) {
        this.invalidFormTemplate = !uiFormTemplate.formTemplate.valid;
      }
      this.enableSaveAndDiscard = false;
      this.processActions(this.actions, this.enableSaveAndDiscard);
    }.bind(this));
    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
      var isCurrentStateFormEditor = _.startsWith(fromState.name, 'configuration.formEditor'),
        isTargetSameAsCurrent = toState.name === fromState.name,
        formStructure,
        uiFormTemplate;
      if (toState.name === 'login') {
        return;
      }
      if (this.enableSaveAndDiscard && isCurrentStateFormEditor && !isTargetSameAsCurrent) {
        event.preventDefault();
        formStructure = formViewerModel.getFormStructure(this.uiFormTemplateId);
        if (formStructure) {
          configurationActionsUtil.populateUiFormTemplateModel(this.uiFormTemplateId);
          uiFormTemplate = formStructure.uiFormTemplate;
        } else {
          uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();
        }
        loadingBarHandler.showLoadingBar('formEditor.saveUiFormTemplate.loadingBar');
        if (_.isNil(uiFormTemplate.id)) {
          configurationMediator.createFormTemplate(uiFormTemplate).then(function (uiFormTemplate) {
            loadingBarHandler.hideLoadingBar();
            configurationActionsUtil.handleUiFormTemplateSave(uiFormTemplate, false).then(function () {
              this.enableSaveAndDiscard = false;
              this.processActions(this.actions, this.enableSaveAndDiscard);
              $state.go(toState, toParams);
            }.bind(this));
          }.bind(this));
        } else {
          configurationMediator.updateFormTemplate(uiFormTemplate, uiFormTemplate.id).then(function (uiFormTemplate) {
            loadingBarHandler.hideLoadingBar();
            configurationActionsUtil.handleUiFormTemplateSave(uiFormTemplate, false).then(function () {
              this.enableSaveAndDiscard = false;
              this.processActions(this.actions, this.enableSaveAndDiscard);
              $state.go(toState, toParams);
            }.bind(this));
          }.bind(this));
        }
      }
    }.bind(this));
    this.loadActions();
    this.loadFormTemplate();
  }.bind(this));
};
FormEditorHeaderController.$inject = ["$rootScope", "$scope", "$element", "$stateParams", "$state", "localization", "configurationMediator", "formViewerConstant", "uIFormTemplateAction", "configurationActionsUtil", "modalUtil", "coreConstant", "formViewerModel", "loadingBarHandler", "uiFormTemplateModel", "coreMediator"];
angular.module('ums.configuration').controller('formEditorHeaderController', FormEditorHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2462:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/header/formEditorHeader.tpl.html';
var html = "<div class=\"templateDetailsRow\">\n\n    <div class=\"loadingContainer\"\n         ng-class=\"{ loading: !$ctrl.formTemplate }\">\n\n        <!--Status-->\n        <div class=\"templateNameColumn\">\n\n            <button type=\"button\" class=\"btn-link backButton\"\n                    ui-sref=\"configuration.formTemplateBrowser\">\n\n                <span class=\"glyphicon glyphicon-arrow-left\"></span>\n                <span ui-translate>formTemplateBrowser.title</span>\n            </button>\n\n            <div class=\"templateName\" uib-tooltip=\"{{ $ctrl.formTemplate.uniqueName }}\">{{ $ctrl.formTemplate.uniqueName }}</div>\n        </div>\n\n        <div class=\"templateDetailsColumn\">\n\n            <!--Status-->\n            <div class=\"detailColumn\">\n\n                <div class=\"detailLabel\"\n                     ui-translate>formEditorHeader.statusLabel\n                </div>\n\n                <div class=\"detailValue\">\n                    <span class=\"status\">{{ $ctrl.formTemplateStatus }}</span>\n                    <span class=\"invalidLabel\"\n                          ng-if=\"$ctrl.invalidFormTemplate\"\n                          ui-translate>formEditorHeader.invalidLabel</span>\n                </div>\n            </div>\n\n            <!--Version-->\n            <div class=\"detailColumn\">\n\n                <div class=\"detailLabel\"\n                     ui-translate>formEditorHeader.versionLabel\n                </div>\n\n                <div class=\"detailValue \">\n                    <span class=\"version\">\n                        {{ $ctrl.formTemplate.version }}\n                    </span>\n                </div>\n            </div>\n\n            <!--Type-->\n            <div class=\"detailColumn\">\n                <div class=\"detailLabel\"\n                     ui-translate>formEditorHeader.typeLabel\n                </div>\n\n                <div class=\"detailValue type\">\n                    {{ $ctrl.formTemplateTypeLabel }}\n                </div>\n            </div>\n\n            <!--Display Name-->\n            <div class=\"detailColumn\">\n                <div class=\"detailLabel\"\n                     ui-translate>formEditorHeader.displayNameLabel\n                </div>\n\n                <div class=\"detailValue displayName\"\n                     uib-tooltip=\"{{ $ctrl.formTemplate.displayName }}\">{{ $ctrl.formTemplate.displayName }}</div>\n            </div>\n\n            <!--Effective Date-->\n            <div class=\"detailColumn\" ng-if=\"$ctrl.hasEffectiveDate\">\n                <div class=\"detailLabel\"\n                     ui-translate>formEditorHeader.effectiveDateLabel\n                </div>\n\n                <div class=\"detailValue\">\n                    {{ $ctrl.formTemplate.effectiveDateRangeBegin | utcDateFilter: $ctrl.shortDateFormat }} - {{\n                    $ctrl.formTemplate.effectiveDateRangeEnd | utcDateFilter: $ctrl.shortDateFormat }}\n                </div>\n            </div>\n        </div>\n\n        <div class=\"actionButtonColumn\">\n            <action-buttons-bar context=\"$ctrl.context\"\n                                actions=\"$ctrl.actions\"\n                                action-sub-texts=\"$ctrl.actionSubTexts\"\n                                notify-action-clicked=\"$ctrl.handleAction(action, file)\"\n                                time-last-modified=\"$ctrl.actionsTimeLastModified\"></action-buttons-bar>\n        </div>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2463:
/***/ (function(module, exports) {

/*@ngInject*/
var FormActionRepository = function FormActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadActions = function (uri) {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: uri
        }
      };
    return this.get(url, config);
  };
};
FormActionRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('formActionRepository', FormActionRepository);

/***/ }),

/***/ 2464:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/header/errorModal/formTemplateErrorModal.tpl.html';
var html = "<base-modal\n    modal-title=\"title\"\n    ok=\"okButton\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"formTemplateErrorModal\" ui-browser-detection>\n\n        <label class=\"errorSummary\">{{::viewModel.summary}}</label>\n        <div class=\"errorListContainer\">\n            <ul class=\"errorList\">\n                <li class=\"errorListItem\" ng-repeat=\"error in viewModel.errors\">\n                    <label class=\"errorLabel\">{{::error}}</label>\n                </li>\n            </ul>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2465:
/***/ (function(module, exports) {

/*@ngInject*/
var FormTemplateErrorModalController = function FormTemplateErrorModalController($rootScope, $scope, coreConstant, options) {
  $scope.title = options.title;
  $scope.okButton = options.confirmActionButtonLabel;
  $scope.viewModel = {
    summary: options.summary,
    errors: options.errors
  };
  $scope.onConfirm = function () {
    $scope.$close();
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
FormTemplateErrorModalController.$inject = ["$rootScope", "$scope", "coreConstant", "options"];
angular.module('umCore').controller('formTemplateErrorModalController', FormTemplateErrorModalController);

/***/ }),

/***/ 2466:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2467);
__webpack_require__(2468);
__webpack_require__(2469);
var FormEditorNavComponent = {
  templateUrl: '/configuration/formEditor/nav/formEditorNav.tpl.html',
  controller: 'formEditorNavController',
  bindings: {}
};
angular.module('ums').component('uiFormEditorNav', FormEditorNavComponent);

/***/ }),

/***/ 2467:
/***/ (function(module) {

module.exports = JSON.parse("{\"formEditorNav\":{\"form\":\"Form\",\"rules\":\"Rules\",\"preview\":\"Preview\"}}");

/***/ }),

/***/ 2468:
/***/ (function(module, exports) {

/*@ngInject*/
var FormEditorNavController = function FormEditorNavController($scope, $element, $state) {
  $element.addClass('formEditorNav');
  this.isActive = function (buttonName) {
    return $state.includes(buttonName);
  };
};
FormEditorNavController.$inject = ["$scope", "$element", "$state"];
angular.module('ums.configuration').controller('formEditorNavController', FormEditorNavController);

/***/ }),

/***/ 2469:
/***/ (function(module, exports) {

var path = '/configuration/formEditor/nav/formEditorNav.tpl.html';
var html = "\n<button type=\"button\"\n        class=\"btn btn-link navButton formButton\"\n        ui-sref=\"configuration.formEditor.form\"\n        ng-class=\"{ active: $ctrl.isActive('configuration.formEditor.form') }\">\n    <span ui-translate>formEditorNav.form</span>\n</button>\n\n<button type=\"button\"\n        class=\"btn btn-link navButton rulesButton\"\n        ui-sref=\"configuration.formEditor.rules\"\n        ng-class=\"{ active: $ctrl.isActive('configuration.formEditor.rules') }\">\n    <span ui-translate>formEditorNav.rules</span>\n</button>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2470:
/***/ (function(module) {

module.exports = JSON.parse("{\"formReferences\":{\"title\":\"Form References\",\"summary\":\"Found {referencesCount} reference(s) for fields on {formTemplateUniqueName}.\",\"nameHeader\":\"Name\",\"typeHeader\":\"Type\",\"versionHeader\":\"Version\",\"statusHeader\":\"Status\",\"type\":{\"1\":\"Field Expression\",\"2\":\"Linked Field\",\"3\":\"Rule\",\"4\":\"Scoring Rule\",\"5\":\"Supplemental Form\",\"6\":\"Dynamic Data Set\"},\"status\":{\"0\":\"Draft\",\"1\":\"In Production\",\"2\":\"Published\"},\"confirmButtonLabel\":\"OK\"},\"formReferencesDelete\":{\"title\":\"Delete Form\",\"summary\":\"Found {referencesCount} reference(s) for fields on {formTemplateUniqueName}. Are you sure you want to delete this form?\",\"confirmButtonLabel\":\"Yes\",\"cancelButtonLabel\":\"No\"},\"formReferencesMarkInProductionInvalid\":{\"title\":\"Mark In Production\",\"summary\":\"Some form templates could not be marked in production (because they are not published yet or already in production). See the list below.\",\"confirmButtonLabel\":\"OK\"},\"formReferencesUniqueNameChange\":{\"title\":\"Form References\",\"summary\":\"Found {referencesCount} reference(s) for fields on {formTemplateUniqueName}. Are you sure you want to rename this form?\",\"confirmButtonLabel\":\"Yes\",\"cancelButtonLabel\":\"No\"}}");

/***/ }),

/***/ 2471:
/***/ (function(module, exports) {

var path = '/configuration/formReferences/formReferencesModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\"\n    ok-button-class=\"viewModel.buttonClass\">\n\n    <div ui-browser-detection>\n\n        <div class=\"messageBox\">\n            <span>{{::viewModel.formReferencesMessage}}</span>\n        </div>\n\n        <div class=\"referencesContainer\" ng-if=\"viewModel.formReferenceList.length > 0\">\n\n            <div class=\"tableHeader\">\n                <div class=\"typeHeader\"\n                     ng-if=\"viewModel.displayTypeColumn\"\n                     ui-grid-sortable-header\n                     request-params=\"viewModel.formParams\"\n                     item-name=\"type\"\n                     item-label=\"formReferences.typeHeader\"\n                     on-toggle=\"onSort($event, params)\"></div>\n\n                <div class=\"nameHeader\"\n                     ui-grid-sortable-header\n                     request-params=\"viewModel.formParams\"\n                     item-name=\"name\"\n                     item-label=\"formReferences.nameHeader\"\n                     on-toggle=\"onSort($event, params)\"></div>\n\n                <div class=\"versionHeader\"\n                     ui-grid-sortable-header\n                     request-params=\"viewModel.formParams\"\n                     item-name=\"version\"\n                     item-label=\"formReferences.versionHeader\"\n                     on-toggle=\"onSort($event, params)\"></div>\n\n                 <div class=\"statusHeader\"\n                     ng-if=\"viewModel.displayStatusColumn\"\n                     ui-grid-sortable-header\n                     request-params=\"viewModel.formParams\"\n                     item-name=\"status\"\n                     item-label=\"formReferences.statusHeader\"\n                     on-toggle=\"onSort($event, params)\"></div>\n            </div>\n            <div class=\"formTemplateTable\">\n\n\n                <div class=\"formReferencesRow\" ng-repeat=\"formReference in viewModel.formReferenceList\">\n                    <div class=\"typeColumn\"\n                         ng-if=\"viewModel.displayTypeColumn\">\n                        <span>{{::getType(formReference.type)}}</span>\n                    </div>\n                    <div class=\"nameColumn\">\n                        <span><a ng-click=\"openFormTemplate(formReference.referenceUri)\">{{::formReference.name}}</a></span>\n                    </div>\n                    <div class=\"versionColumn\">\n                        <span>{{::formReference.version}}</span>\n                    </div>\n                    <div class=\"statusColumn\"\n                        ng-if=\"viewModel.displayStatusColumn\">\n                        <span>{{::getStatus(formReference.status)}}</span>\n                    </div>\n                </div>\n\n            </div>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2472:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormReferencesController = function FormReferencesController($rootScope, $scope, $state, options, coreConstant, configurationMediator, localization, navigationStateModel) {
  localization.getTranslationsByKeys([this.translationsKey, 'formReferences']).then(function (translations) {
    $scope.viewModel = {
      title: options.title,
      cancelButton: options.cancelButtonLabel,
      okButton: options.confirmButtonLabel,
      buttonClass: options.showConfirmationButtons ? 'btn-success' : '',
      formReferencesMessage: options.summary,
      displayTypeColumn: false,
      displayStatusColumn: false,
      formParams: {
        key: 'name',
        sortType: 'asc'
      }
    };
    $scope.onSort = function (event, params) {
      $scope.viewModel.formParams = params;
      $scope.viewModel.formReferenceList = _.orderBy($scope.viewModel.formReferenceList, [params.key], [params.sortType]);
    };
    $scope.getType = function (type) {
      return translations.type[type];
    };
    $scope.getStatus = function (status) {
      return translations.status[status];
    };
    $scope.onConfirm = function () {
      $scope.$close();
    };
    $scope.openFormTemplate = function (referenceUri) {
      var referenceArray = _.split(referenceUri, ':'),
        navigationModel = {};
      if (_.endsWith(referenceArray[0], 'UIFormTemplate')) {
        navigationModel = {
          parentState: 'configuration.formTemplateBrowser',
          currentState: 'configuration.formEditor.form',
          data: {
            uiFormTemplateId: referenceArray[1]
          }
        };
        $state.go('configuration.formEditor.form', {
          uiFormTemplateId: referenceArray[1]
        });
        navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
        $scope.$dismiss();
      }
    };
    $scope.onCancel = function () {
      $scope.$dismiss();
    };
    $scope.init = function () {
      $scope.viewModel.formReferenceList = _.orderBy(options.formReferenceList, [$scope.viewModel.formParams.key], [$scope.viewModel.formParams.sortType]);
      _.each($scope.viewModel.formReferenceList, function (formReference) {
        if (!_.isNil(formReference.type)) {
          $scope.viewModel.displayTypeColumn = true;
        }
        if (!_.isNil(formReference.status)) {
          $scope.viewModel.displayStatusColumn = true;
        }
      });
    };
    $scope.init();
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
FormReferencesController.$inject = ["$rootScope", "$scope", "$state", "options", "coreConstant", "configurationMediator", "localization", "navigationStateModel"];
angular.module('ums.configuration').controller('formReferencesController', FormReferencesController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2473:
/***/ (function(module, exports) {

/*@ngInject*/
var FormReferencesRepository = function FormReferencesRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getFormReferences = function (uiFormTemplateId) {
    var url = '/rest/UIFormTemplate/' + uiFormTemplateId + '/findReferences';
    return this.get(url);
  };
};
FormReferencesRepository.$inject = ["baseRepository"];
angular.module('umCore').service('formReferencesRepository', FormReferencesRepository);

/***/ }),

/***/ 2474:
/***/ (function(module) {

module.exports = JSON.parse("{\"formTemplateBrowser\":{\"title\":\"Manage Form Templates\",\"columns\":{\"type\":\"Type\",\"products\":\"Products\",\"uniqueName\":\"Unique Name\",\"displayName\":\"Display Name\",\"version\":\"Version\",\"visibility\":\"Visibility\",\"name\":\"Name\",\"lastModifiedDate\":\"Last Modified Date\"},\"emptyGrid\":\"No matching form templates\",\"recordCountText\":\"Showing startIndex to endIndex of total Form Template\",\"recordsCountText\":\"Showing startIndex to endIndex of total Form Templates\",\"allProducts\":\"All Products\",\"clearButton\":\"Clear All\",\"placeholder\":\"Select\",\"textInputFilter\":{\"nameSubstring\":{\"placeholder\":\"Search\"}},\"bulkActionLabel\":\"Form Templates Selected\",\"bulkActionCancelButtonLabel\":\"Cancel\",\"actions\":{\"name\":\"Actions\",\"new form\":\"New Form\",\"delete\":\"Delete\",\"import\":\"Import\",\"export\":\"Export\",\"backup\":\"Backup\",\"mark in production\":\"Mark in Production\",\"publish form templates\":\"Publish Form Templates\",\"test draft form templates\":\"Test Draft Form Templates\",\"reload form rules\":\"Reload Form Rules\",\"reload field rules\":\"Reload Field Rules\"},\"createFormTemplateSet\":{\"loadingBar\":\"Creating Form Template Set...\",\"confirmationTitle\":\"Create Form Template Set\",\"confirmationConfirmActionButtonLabel\":\"Ok\",\"confirmation\":\"A new form template set (ID={0}) has been successfully created.\",\"bulkActionLabel\":\"Publish\"},\"createTestFormTemplateSet\":{\"loadingBar\":\"Creating Form Template Set...\",\"confirmationTitle\":\"Create Form Template Set\",\"confirmationConfirmActionButtonLabel\":\"Ok\",\"confirmation\":\"A new form template set (ID={0}) has been successfully created.\"},\"importFormTemplates\":{\"loadingBar\":\"Importing Form Templates...\",\"title\":\"Import Form Templates\",\"summary\":\"Are you sure you want to import form templates from the selected file?\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"successMessageSingular\":\"Successfully imported {0} form template\",\"successMessagePlural\":\"Successfully imported {0} form templates\",\"errorModal\":{\"confirmActionButtonLabel\":\"OK\",\"summary\":\"{0} form template(s) imported\\n{1} form template(s) not imported\\n\\n{2}\",\"title\":\"Import Forms\"}},\"exportFormTemplates\":{\"loadingBar\":\"Exporting Form Templates...\",\"successMessage\":\"Successfully Exported Form Templates\",\"bulkActionLabel\":\"Export\"},\"markInProduction\":{\"loadingBar\":\"Marking Form Templates In Production...\",\"successMessage\":\"Successfully Marked Form Templates In Production\",\"title\":\"Mark Form Templates In Production\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"summary\":\"Are you sure you want to mark form templates in production?\",\"bulkActionLabel\":\"Mark In Production\"},\"reloadFormRules\":{\"loadingBar\":\"Reloading Form Rules...\",\"successMessage\":\"Successfully reloaded form rules\",\"title\":\"Reload Form Rules\",\"summary\":\"Are you sure you want to reload form rules?\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"validateCheckBox\":\"Validate rules\"},\"reloadFieldRules\":{\"loadingBar\":\"Reloading Field Rules...\",\"successMessage\":\"Successfully reloaded field rules\",\"title\":\"Reload Field Rules\",\"summary\":\"Are you sure you want to reload field rules?\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"validateCheckBox\":\"Validate rules\"},\"type\":{\"0\":\"Invalid\",\"1\":\"Application\",\"2\":\"Rating\",\"3\":\"Quoting\",\"4\":\"PreQualification Input\",\"5\":\"Declination Letter\",\"6\":\"WCIRB XMod Report\",\"7\":\"Underwriting Authority\",\"9\":\"Worksheet\",\"10\":\"Lost Letter\",\"11\":\"Predictive Analytics\",\"12\":\"Non-Renewal Letter\",\"13\":\"Agency Authority\",\"14\":\"Correspondence\",\"15\":\"Agent Rating\",\"16\":\"Agent Binding\",\"18\":\"Binding\",\"19\":\"Issuance\",\"20\":\"PreQualification Output\",\"21\":\"Carrier Authority\",\"22\":\"Account Overview\",\"24\":\"Account Worksheet\",\"25\":\"D & B Financial Stress Score Report\",\"26\":\"NCCI XMod Report\",\"27\":\"Risk Meter Report\",\"28\":\"Policy Form\",\"29\":\"Endorsement Issuance\",\"31\":\"Rejection Letter\",\"32\":\"Proposal/Binder Section\",\"33\":\"Rewrite/Reissue Issuance\",\"34\":\"Pricing\",\"35\":\"Experian Report\",\"36\":\"Experian Commercial Credit Report\",\"37\":\"Valen Report\",\"38\":\"Cancellation\",\"39\":\"Submission\",\"40\":\"ISO Passport Report\",\"41\":\"Endorsement\",\"42\":\"User\",\"43\":\"Organization\",\"44\":\"Declination\",\"45\":\"Mark as Lost\",\"46\":\"Rewrite/Reissue\"},\"backup\":{\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\",\"name\":\"Form Templates\"}}}");

/***/ }),

/***/ 2475:
/***/ (function(module, exports) {

var path = '/configuration/formTemplateBrowser/formTemplateBrowser.tpl.html';
var html = "<ui-grid-data-browser\n    identifier=\"'formTemplateBrowser'\"\n    columns=\"columns\"\n    state-params=\"stateParams\"\n    advanced-filter-type=\"advancedFilterType\"\n    filter-type=\"filterType\"\n    translations=\"translations\"\n    initial-request-params=\"initialRequestParams\"\n    load-items-handler=\"loadItemsHandler\"\n    load-actions-handler=\"loadActionsHandler\"\n    notify-handle-action=\"handleAction(action, file)\"\n    notify-handle-bulk-action=\"handleBulkAction(action, selectedItems, excludedItems, filterUri)\">\n</ui-grid-data-browser>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2476:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FormTemplateBrowserController = function FormTemplateBrowserController($rootScope, $scope, $uibModal, $filter, localization, advancedFilterType, filterType, uIFormTemplateAction, configurationMediator, configurationActionsUtil, databaseDownloadSectionName, modalUtil, gridDataBrowserConstant) {
  localization.getTranslationByKey('formTemplateBrowser').then(function (translations) {
    $scope.columns = [{
      name: 'type',
      label: _.get(translations, 'columns.type'),
      className: 'colType',
      getValue: function getValue(item) {
        return _.get(translations, 'type.' + item.type);
      }
    }, {
      name: 'products',
      label: _.get(translations, 'columns.products'),
      className: 'colProducts',
      getValue: function getValue(item) {
        var products = '';
        if (_.isEmpty(item.productTemplates)) {
          products = _.get(translations, 'allProducts');
        } else {
          products = item.productTemplateShortNames;
        }
        return products;
      }
    }, {
      name: 'uniqueName',
      label: _.get(translations, 'columns.uniqueName'),
      className: 'colUniqueName',
      getValue: function getValue(item) {
        return item.uniqueName;
      }
    }, {
      name: 'displayName',
      label: _.get(translations, 'columns.displayName'),
      className: 'colDisplayName',
      getValue: function getValue(item) {
        return item.displayName;
      }
    }, {
      name: 'version',
      label: _.get(translations, 'columns.version'),
      className: 'colVersion',
      getValue: function getValue(item) {
        return item.version;
      }
    }, {
      name: 'visibility',
      label: _.get(translations, 'columns.visibility'),
      className: 'colVisibility',
      getValue: function getValue(item) {
        return item.visibility;
      }
    }, {
      name: 'lastModifiedBy',
      label: _.get(translations, 'columns.name'),
      className: 'colName',
      getValue: function getValue(item) {
        return item.lastModifiedBy;
      }
    }, {
      name: 'lastModifiedDate',
      label: _.get(translations, 'columns.lastModifiedDate'),
      className: 'colLastModifiedDate',
      getValue: function getValue(item) {
        return $filter('date')(item.timeLastModified, 'MM/dd/yy hh:mma');
      }
    }];
    $scope.advancedFilterType = advancedFilterType.FORM_TEMPLATE_BROWSER;
    $scope.filterType = filterType.TYPE_FORMTEMPLATE_FILTER;
    $scope.stateParams = {
      browser: 'configuration.formTemplateBrowser',
      getDetailState: function getDetailState(formTemplate) {
        return {
          name: 'configuration.formEditor.form',
          params: {
            uiFormTemplateId: formTemplate.id
          }
        };
      }
    };
    $scope.translations = {
      title: _.get(translations, 'title'),
      recordCountText: _.get(translations, 'recordCountText'),
      recordsCountText: _.get(translations, 'recordsCountText'),
      emptyGrid: _.get(translations, 'emptyGrid'),
      bulkActionLabel: _.get(translations, 'bulkActionLabel'),
      bulkActionCancelButtonLabel: _.get(translations, 'bulkActionCancelButtonLabel')
    };
    $scope.initialRequestParams = {
      key: 'type',
      startIndex: 0,
      pageSize: 25,
      sortType: 'asc'
    };
    $scope.loadActionsHandler = function () {
      return configurationMediator.loadFormTemplateBrowserActions().then(function (actions) {
        _.each(actions.actions, function (action) {
          if (action.name === uIFormTemplateAction.EXPORT) {
            action.isBulkAction = true;
            action.bulkActionLabel = _.get(translations, 'exportFormTemplates.bulkActionLabel');
          }
          if (action.name === uIFormTemplateAction.MARK_IN_PRODUCTION) {
            action.isBulkAction = true;
            action.bulkActionLabel = _.get(translations, 'markInProduction.bulkActionLabel');
          }
          if (action.name === uIFormTemplateAction.PUBLISH_FORM_TEMPLATES) {
            action.isBulkAction = true;
            action.bulkActionLabel = _.get(translations, 'createFormTemplateSet.bulkActionLabel');
          }
        });
        actions.hiddenInputActions = {};
        actions.hiddenInputActions[uIFormTemplateAction.IMPORT] = 'application/xml';
        return actions;
      });
    };
    $scope.loadItemsHandler = function (filterUri, requestParams) {
      return configurationMediator.getUiFormTemplatesByFilterUri(filterUri, requestParams);
    };
    $scope.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case uIFormTemplateAction.NEW_FORM:
            $uibModal.open({
              templateUrl: '/configuration/formTemplateSettings/formTemplateSettingsTemplate.tpl.html',
              controller: 'formTemplateSettingsController',
              windowClass: 'formTemplateSettingsModal',
              resolve: {
                options: {
                  formTemplateId: null
                }
              }
            });
            break;
          case uIFormTemplateAction.RELOAD_FORM_RULES:
            configurationActionsUtil.reloadFormRules();
            break;
          case uIFormTemplateAction.RELOAD_FIELD_RULES:
            configurationActionsUtil.reloadFieldRules();
            break;
          case uIFormTemplateAction.IMPORT:
            configurationActionsUtil.importFormTemplates(file, translations);
            break;
          case uIFormTemplateAction.BACKUP:
            configurationActionsUtil.backup(databaseDownloadSectionName.FORM_TEMPLATES, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
            break;
          case uIFormTemplateAction.TEST_DRAFT_FORM_TEMPLATES:
            configurationActionsUtil.createTestFormTemplateSet();
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
    $scope.handleBulkAction = function (action, selectedItems, excludedItems, filterUri) {
      if (action.enabled) {
        switch (action.name) {
          case uIFormTemplateAction.EXPORT:
            configurationActionsUtil.exportFormTemplates(selectedItems, filterUri, excludedItems, 'formTemplateBrowser.exportFormTemplates.loadingBar').then(function () {
              $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
            });
            break;
          case uIFormTemplateAction.MARK_IN_PRODUCTION:
            configurationActionsUtil.markFormTemplatesInProduction(selectedItems, filterUri, excludedItems).then(function () {
              $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
            });
            break;
          case uIFormTemplateAction.PUBLISH_FORM_TEMPLATES:
            configurationActionsUtil.publishFormTemplates('formTemplateBrowser.createFormTemplateSet.loadingBar', selectedItems, filterUri, excludedItems).then(function () {
              $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
            });
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
            break;
        }
      }
    };
  });
};
FormTemplateBrowserController.$inject = ["$rootScope", "$scope", "$uibModal", "$filter", "localization", "advancedFilterType", "filterType", "uIFormTemplateAction", "configurationMediator", "configurationActionsUtil", "databaseDownloadSectionName", "modalUtil", "gridDataBrowserConstant"];
angular.module('ums.configuration').controller('formTemplateBrowserController', FormTemplateBrowserController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2477:
/***/ (function(module, exports) {

/*@ngInject*/
var FormTemplateBrowserActionRepository = function FormTemplateBrowserActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadActions = function () {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.underwriting.form.ui.UIFormTemplate:null'
        }
      };
    return this.get(url, config);
  };
};
FormTemplateBrowserActionRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('formTemplateBrowserActionRepository', FormTemplateBrowserActionRepository);

/***/ }),

/***/ 2478:
/***/ (function(module, exports) {

/*@ngInject*/
var FormTemplateSetRepository = function FormTemplateSetRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.publishFormTemplates = function (formTemplateIds) {
    var url = '/rest/FormTemplateSet/publishFormTemplates',
      config = {
        params: {
          resultType: 'brief',
          uiFormTemplateIds: formTemplateIds
        }
      };
    return this.post(url, {}, config);
  };
  this.publishFormTemplatesByFilterUri = function (filterUri, excludedFormTemplateIds) {
    var url = '/rest/FormTemplateSet/publishFormTemplates',
      config = {
        params: {
          filterUri: filterUri,
          resultType: 'brief',
          excludedFormTemplateIds: excludedFormTemplateIds
        }
      };
    return this.post(url, {}, config);
  };
  this.createTestFormTemplateSet = function () {
    var url = '/rest/FormTemplateSet/createTestFormTemplateSet';
    return this.post(url);
  };
  this.markAllFormTemplatesInProduction = function () {
    var url = '/rest/FormTemplateSet/markCurrentFormTemplateSetInProduction';
    return this.post(url);
  };
};
FormTemplateSetRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('formTemplateSetRepository', FormTemplateSetRepository);

/***/ }),

/***/ 2479:
/***/ (function(module, exports) {

var path = '/configuration/reloadRulesModal/reloadRulesModal.tpl.html';
var html = "<base-modal\n    modal-title=\"viewModel.title\"\n    ok=\"viewModel.okButton\"\n    cancel=\"viewModel.cancelButton\"\n    on-confirm=\"onConfirm()\"\n    on-cancel=\"onCancel()\">\n\n\n\n    <div class=\"reloadRulesModalContent\">\n        <div class=\"modal-body\">\n            <div class=\"summary\" ng-if=\"viewModel.summary\"\n                 ng-bind-html=\"viewModel.summary\"></div>\n            <div class=\"rulesValidateCheckbox\">\n                <label>\n                    <input type=\"checkbox\" ng-model=\"viewModel.validate\">\n                     {{::viewModel.validateCheckBox}}\n                </label>\n            </div>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2480:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ReloadRulesModalController = function ReloadRulesModalController($rootScope, $scope, coreConstant, options, localization) {
  localization.getTranslationsByKeys([options.localizationRoot]).then(function (translations) {
    $scope.viewModel = {
      title: _.get(translations, 'title'),
      cancelButton: _.get(translations, 'cancel'),
      okButton: _.get(translations, 'confirm'),
      summary: _.get(translations, 'summary'),
      validateCheckBox: _.get(translations, 'validateCheckBox'),
      validate: false
    };
    $scope.onConfirm = function () {
      $scope.$close({
        validate: $scope.viewModel.validate
      });
    };
    $scope.onCancel = function () {
      $scope.$dismiss();
    };
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
ReloadRulesModalController.$inject = ["$rootScope", "$scope", "coreConstant", "options", "localization"];
angular.module('ums.configuration').controller('reloadRulesModalController', ReloadRulesModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2481:
/***/ (function(module) {

module.exports = JSON.parse("{\"formTemplateSettings\":{\"newTemplateTitle\":\"Create Form Template\",\"title\":\"Form Template Settings\",\"formTemplateTypes\":\"Type\",\"formTemplateTypesPrompt\":\"Please Choose\",\"selectTypePrompt\":\"Select Type\",\"uniqueName\":\"Unique Name\",\"displayName\":\"Display Name\",\"requiredHeading\":\"Required?\",\"required\":\"Required\",\"conditionallyRequired\":\"Conditionally Required\",\"supplemental\":\"Supplemental\",\"precedingFormAndField\":\"Preceding Form and Field\",\"precedingFormPrompt\":\"Select Form\",\"precedingField\":\"Preceding Field\",\"precedingFieldPrompt\":\"Select Field\",\"productsAndCoverages\":\"Products & Coverages\",\"allProducts\":\"All Products\",\"selectProducts\":\"Select Products\",\"selectProductsPrompt\":\"Select Product\",\"order\":\"Order\",\"viewOrderForm\":\"View Order Form\",\"saveButton\":\"Save\",\"createFormTemplate\":\"Create Form Template\",\"cancelButton\":\"Cancel\",\"dynamicName\":\"Dynamic Name\",\"staticName\":\"Static Name\",\"sortFormNames\":\"Sort Form Names\",\"flags\":\"Flags\",\"effectiveDateRange\":\"Effective Date Range\",\"includedInEndorsement\":\"Include in Endorsements\",\"proposalLevel\":\"Proposal-level\",\"repeatable\":\"Repeatable\",\"allowDirectNavigation\":\"Allow Direct Navigation\",\"statusLabel\":\"Status:\",\"version\":\"Version:\",\"status\":{\"0\":\"Draft\",\"1\":\"Production\",\"2\":\"Published\"},\"triggerRuleNameSupplemental\":\"Supplemental Form Trigger\",\"triggerRuleNameConditionallyRequired\":\"Conditionally Required Form Trigger\",\"formTemplateLinkForm\":\"Link Form\",\"linkFormPlaceholder\":\"Select Form Template\"}}");

/***/ }),

/***/ 2482:
/***/ (function(module, exports) {

var path = '/configuration/formTemplateSettings/formTemplateSettingsTemplate.tpl.html';
var html = "<div class=\"formTemplateSettings\">\n\n    <div class=\"modal-header\">\n        <h3 class=\"title\">{{viewModel.title}}</h3>\n        <div class=\"statusVersionBox\"\n            ng-if=\"viewModel.displayStatusVersionBox\">\n            <span class=\"statusLabel\" ui-translate>formTemplateSettings.statusLabel</span>\n            <span class=\"status\">{{viewModel.statusValue}}</span>\n            <span class=\"versionLabel\" ui-translate>formTemplateSettings.version</span>\n            <span class=\"version\">{{viewModel.versionValue}}</span>\n        </div>\n        <button class=\"close\"\n                ng-click=\"onCancel()\">\n            <span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </div>\n\n    <div ui-browser-detection class=\"modal-body\">\n\n        <div class=\"formTemplateBox\">\n            <div class=\"leftBox\">\n                <div class=\"formTemplateRow type\">\n                    <div class=\"formTemplateLabel\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.selectedFormTemplate}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>formTemplateSettings.formTemplateTypes</span>\n                    </div>\n\n                    <ui-select class=\"dropdownFormComponent dropdownComponentSelect\"\n                               theme=\"select2\"\n                               ng-model=\"viewModel.selectedFormTemplate\"\n                               ng-change=\"onSelectFormTemplateType()\">\n\n                        <ui-select-match placeholder=\"{{ ::viewModel.formTemplateTypesPrompt }}\"\n                                         allow-clear=\"true\">\n                            <span>{{ viewModel.selectedFormTemplate.name }}</span>\n                        </ui-select-match>\n\n                        <ui-select-choices\n                            repeat=\"item in (viewModel.formTemplateTypeList | filter: $select.search) track by $index\">\n                            <span>{{ item.name }}</span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n\n                <div class=\"formTemplateRow uniqueName\">\n\n                    <div class=\"formTemplateLabel\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.uniqueName}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>formTemplateSettings.uniqueName</span>\n                    </div>\n                    <input type=\"text\"\n                           ng-disabled=\"viewModel.isInProduction || !viewModel.canManageForms\"\n                           ng-model=\"viewModel.uniqueName\"\n                           ng-blur=\"handleUniqueNameBlur()\"\n                           value=\"{{ viewModel.uniqueName }}\">\n                </div>\n\n                <div class=\"formTemplateRow displayName\">\n                    <div class=\"formTemplateLabel\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.displayName}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>formTemplateSettings.displayName</span>\n                    </div>\n                    <input type=\"text\"\n                           ng-disabled=\"!viewModel.canManageForms\"\n                           ng-model=\"viewModel.displayName\"\n                           value=\"{{ viewModel.displayName }}\">\n                </div>\n\n                <div class=\"formTemplateRow required\">\n                    <div class=\"formTemplateLabel\">\n                        <span>Required?</span>\n                    </div>\n\n                    <div class=\"radioButtonGroup\" ng-disabled=\"viewModel.isInProduction\">\n                        <input type=\"radio\"\n                               ng-disabled=\"viewModel.isInProduction || !viewModel.canManageForms\"\n                               ng-model=\"viewModel.requiredRadioButtonValue\"\n                               value=\"required\"\n                               ng-click=\"handleFormTemplateVisibilityChange('required')\"\n                               class=\"requiredRadioButton\">\n                        <span ui-translate>formTemplateSettings.required</span>\n                        <input type=\"radio\"\n                               ng-disabled=\"viewModel.isInProduction || !viewModel.canManageForms\"\n                               ng-model=\"viewModel.requiredRadioButtonValue\"\n                               value=\"conditionallyRequired\"\n                               ng-click=\"handleFormTemplateVisibilityChange('conditionallyRequired')\"\n                               class=\"conditionallyRequiredRadioButton\">\n                        <span ui-translate>formTemplateSettings.conditionallyRequired</span>\n                        <input type=\"radio\"\n                               ng-disabled=\"viewModel.isInProduction || !viewModel.canManageForms\"\n                               ng-model=\"viewModel.requiredRadioButtonValue\"\n                               value=\"supplemental\"\n                               ng-click=\"handleFormTemplateVisibilityChange('supplemental')\"\n                               class=\"supplementalRadioButton\">\n                        <span ui-translate>formTemplateSettings.supplemental</span>\n                    </div>\n                </div>\n\n                <div class=\"formTemplateRow precedingFormAndField\"\n                     ng-if=\"viewModel.requiredRadioButtonValue === 'supplemental'\">\n\n                    <div class=\"formTemplateLabel\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.precedingFieldVariableName}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>formTemplateSettings.precedingFormAndField</span>\n                    </div>\n\n                    <div class=\"precedingForm\">\n                        <div class=\"formTemplateColunm\">\n                            <ui-multi-step-selector-widget mode=\"viewModel.selectorWidgetMode\"\n                                                step-1-item-name=\"viewModel.precedingFieldFormTemplateUniqueName\"\n                                                step-2-item-name=\"viewModel.precedingFieldVariableName\"></ui-multi-step-selector-widget>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"formTemplateRow productsAndCoverages\" ng-if=\"viewModel.displayProductSelection\">\n                    <div class=\"formTemplateLabel\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{getSelectedProductName()}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>formTemplateSettings.productsAndCoverages</span>\n                    </div>\n\n                    <div class=\"radioButtonGroup\">\n                        <input type=\"radio\"\n                               ng-model=\"viewModel.productRadioButtonValue\"\n                               ng-disabled=\"!viewModel.canManageForms\"\n                               value=\"allProducts\"\n                               ng-click=\"handleProductClick($event)\">\n                        <span ui-translate>formTemplateSettings.allProducts</span>\n                        <input type=\"radio\"\n                               ng-model=\"viewModel.productRadioButtonValue\"\n                               ng-disabled=\"!viewModel.canManageForms\"\n                               value=\"multiProducts\"\n                               ng-click=\"handleProductClick($event)\">\n                        <span ui-translate>formTemplateSettings.selectProducts</span>\n                    </div>\n                </div>\n\n                <div class=\"formTemplateRow\"\n                     ng-if=\"viewModel.displayProductSelection && viewModel.displayProductSelectionDropDown\"\n                     ng-disabled=\"!viewModel.canManageForms\">\n                    <ui-multi-select class=\"multiSelect\"\n                                     is-disabled=\"!viewModel.canManageForms\"\n                                     items-list=\"viewModel.productList\"\n                                     prompt-value=\"viewModel.promptValue\"\n                                     selected-value=\"viewModel.selectedProductsValue\"\n                                     item-name=\"viewModel.itemName\">\n                    </ui-multi-select>\n                </div>\n\n            </div>\n\n            <!--rightBox-->\n\n            <div class=\"rightBox\">\n\n                <div class=\"checkBox effectiveDateRange\" ng-class=\"{formTemplateRow: !viewModel.effectiveDateRange}\">\n                    <ui-required-indicator class=\"requiredIndicator\"\n                                           ng-if=\"viewModel.effectiveDateRangeCheckBox\"\n                                           value=\"{{viewModel.effectiveDateRangeBegin || viewModel.effectiveDateRangeEnd}}\">\n                    </ui-required-indicator>\n                    <input type=\"checkbox\"\n                           ng-disabled=\"!viewModel.canManageForms\"\n                           ng-model=\"viewModel.effectiveDateRangeCheckBox\"\n                           value=\"{{ viewModel.effectiveDateRangeCheckBox }}\"\n                           ng-change=\"onEffectiveDateRangeCheckBoxClicked()\">\n                    <span class=\"formTemplateLabel\" ui-translate>formTemplateSettings.effectiveDateRange</span>\n                </div>\n\n                <div class=\"dateRangeBox\">\n                    <ui-date-range class=\"dateRange\"\n                                   ng-if=\"viewModel.effectiveDateRangeCheckBox\"\n                                   date-value=\"viewModel.effectiveDateRange\"\n                                   value-updated=\"dateRangeUpdated(value)\"\n                                   allow-independent-dates=\"true\"\n                                   allow-date-clearing=\"true\"\n                                   timezone-mode=\"'utc'\">\n                    </ui-date-range>\n                </div>\n\n                <div class=\"formTemplateRow\">\n                    <div class=\"formTemplateLabel\">\n                        <span ui-translate>formTemplateSettings.order</span>\n                    </div>\n                    <div class=\"order\">\n                        <input type=\"text\"\n                               ng-disabled=\"!viewModel.canManageForms\"\n                               class=\"orderField\"\n                               ng-model=\"viewModel.ordering\"\n                               value=\"{{viewModel.ordering}}\">\n                    </div>\n                </div>\n\n                <div class=\"formTemplateRow flags\">\n                    <div class=\"formTemplateLabel\">\n                        <span ui-translate>formTemplateSettings.flags</span>\n                    </div>\n                    <input type=\"text\"\n                           ng-disabled=\"!viewModel.canManageForms\"\n                           ng-model=\"viewModel.flags\"\n                           value=\"{{ viewModel.flags }}\">\n                </div>\n\n                <div class=\"formTemplateRow checkBox proposalLevel\"\n                     ng-if=\"displayProposalLevel()\">\n                    <input type=\"checkbox\"\n                           ng-disabled=\"!viewModel.canManageForms\"\n                           ng-model=\"viewModel.proposalLevel\"\n                           value=\"{{ viewModel.proposalLevel }}\">\n                    <span class=\"formTemplateLabel\" ui-translate>formTemplateSettings.proposalLevel</span>\n                </div>\n\n                <div class=\"formTemplateRow checkBox includedInEndorsement\"\n                     ng-if=\"displayIncludeInEndorsements()\">\n                    <input type=\"checkbox\"\n                           ng-disabled=\"!viewModel.canManageForms\"\n                           ng-model=\"viewModel.includedInEndorsement\"\n                           value=\"{{ viewModel.includedInEndorsement }}\">\n                    <span class=\"formTemplateLabel\" ui-translate>formTemplateSettings.includedInEndorsement</span>\n                </div>\n\n                <div class=\"formTemplateRow formRepeatable checkBox\">\n                    <input type=\"checkbox\"\n                           ng-disabled=\"!canEnableRepeatableCheckbox()\"\n                           ng-checked=\"viewModel.formRepeatable\"\n                           ng-model=\"viewModel.formRepeatable\"\n                           ng-change=\"onRepeatableClick()\"\n                           value=\"{{ viewModel.formRepeatable }}\">\n                    <span class=\"formTemplateLabel\" ui-translate>formTemplateSettings.repeatable</span>\n                </div>\n\n                <div class=\"formTemplateRow linkForm\" ng-if=\"viewModel.displayLinkForm\">\n                    <div class=\"formTemplateLabel\">\n                        <span ui-translate>formTemplateSettings.formTemplateLinkForm</span>\n                    </div>\n\n                    <ui-select class=\"dropdownFormComponent dropdownComponentSelect\"\n                               theme=\"select2\"\n                               ng-model=\"viewModel.selectedLinkFormItem\">\n\n                        <ui-select-match placeholder=\"{{ ::viewModel.linkFormPlaceholder }}\"\n                                         allow-clear=\"true\">\n                            <span>{{ viewModel.selectedLinkFormItem.name }}</span>\n                        </ui-select-match>\n\n                        <ui-select-choices\n                            repeat=\"item in (viewModel.linkFormList | filter: $select.search) track by $index\">\n                            <span>{{ item.name }}</span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n\n                <div class=\"formTemplateRow checkBox allowDirectNavigation\"\n                     ng-if=\"viewModel.formRepeatable\">\n                    <input type=\"checkbox\"\n                           ng-disabled=\"viewModel.isInProduction || !viewModel.canManageForms\"\n                           ng-model=\"viewModel.allowDirectNavigation\"\n                           value=\"{{ viewModel.allowDirectNavigation}}\">\n                    <span class=\"formTemplateLabel\"\n                          ng-disabled=\"viewModel.isInProduction\"\n                          ui-translate>formTemplateSettings.allowDirectNavigation</span>\n                </div>\n\n                <div class=\"formTemplateRow dynamicName\"\n                     ng-if=\"viewModel.formRepeatable\">\n                    <div class=\"formTemplateLabel\">\n                        <span ui-translate>formTemplateSettings.dynamicName</span>\n                    </div>\n                    <input type=\"text\"\n                           ng-disabled=\"!viewModel.canManageForms\"\n                           ng-model=\"viewModel.dynamicName\"\n                           value=\"{{ viewModel.dynamicName }}\">\n                </div>\n\n                <div class=\"formTemplateRow staticName\"\n                     ng-if=\"viewModel.formRepeatable\">\n                    <div class=\"formTemplateLabel\">\n                        <span ui-translate>formTemplateSettings.staticName</span>\n                    </div>\n                    <input type=\"text\"\n                           ng-disabled=\"!viewModel.canManageForms\"\n                           ng-model=\"viewModel.staticName\"\n                           value=\"{{ viewModel.staticName }}\">\n                    <div class=\"sortFormNames\" ng-if=\"viewModel.formRepeatable\">\n                        <input type=\"checkbox\"\n                               ng-disabled=\"!viewModel.canManageForms\"\n                               ng-model=\"viewModel.sortFormNames\"\n                               value=\"{{viewModel.sortFormNames}}\">\n                        <span ui-translate>formTemplateSettings.sortFormNames</span>\n                    </div>\n                </div>\n\n            </div>\n\n        </div>\n    </div>\n    <!--Footer-->\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-success\"\n                ng-click=\"onConfirm()\"\n                ng-disabled=\"!canEnableConfirmButton() || !viewModel.canManageForms\">\n            <span>{{viewModel.confirmButtonLabel}}</span>\n        </button>\n        <button class=\"btn btn-default\"\n                ng-click=\"onCancel()\">\n            <span ui-translate>formTemplateSettings.cancelButton</span>\n        </button>\n    </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2483:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var moment = __webpack_require__(2);
/*@ngInject*/
var FormTemplateSettingsController = function FormTemplateSettingsController($rootScope, $scope, $state, $stateParams, $uibModalInstance, localization, coreConstant, formViewerConstant, coreMediator, configurationMediator, formMediator, formTemplateType, fieldType, formTemplateStatus, options, dateUtil, authorizationConstants, navigationStateModel, configurationConstant, configurationActionsUtil, formViewerModel, uiFormTemplateModel, currentUserModel) {
  var originalUniqueName = null;
  $scope.viewModel = {
    promptValue: '',
    title: '',
    confirmButtonLabel: '',
    formTemplateTypesPrompt: '',
    formTemplateTypeList: null,
    productList: [],
    selectedProductsValue: '',
    selectedFormTemplateType: null,
    defaultRequired: 'required',
    requiredRadioButtonValue: 'required',
    productRadioButtonValue: 'allProducts',
    displayProductSelection: true,
    displayProductSelectionDropDown: false,
    uniqueName: '',
    displayName: '',
    ordering: -1,
    isAllProductsSelected: true,
    effectiveDateRangeCheckBox: false,
    effectiveDateRange: null,
    effectiveDateRangeBegin: null,
    effectiveDateRangeEnd: null,
    type: null,
    formTemplateConfig: null,
    itemName: 'formTemplateSetting',
    selectedProducts: [],
    allowDirectNavigation: false,
    formRepeatable: false,
    displayStatusVersionBox: false,
    canManageForms: false,
    includedInEndorsement: false,
    proposalLevel: false,
    conditional: false,
    selectorWidgetMode: 'forms',
    precedingFieldFormTemplateUniqueName: null,
    precedingFieldVariableName: null,
    selectedFormTemplate: null,
    triggerRuleName: null,
    displayLinkForm: false,
    linkFormList: null,
    selectedLinkFormItem: null,
    linkFormPlaceholder: '',
    isInProduction: false
  };
  $scope.viewModel.canManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);
  function init() {
    localization.getTranslationByKey('formTemplateSettings').then(function (translations) {
      var formStructure;
      if (!_.isNil(options.formTemplateId)) {
        formStructure = formViewerModel.getFormStructure(options.formTemplateId);
        if (formStructure && formStructure.uiFormTemplate) {
          parseFormTemplateConfig(formStructure.uiFormTemplate);
        } else if (_.isNil(uiFormTemplateModel.getUiFormTemplate()) || uiFormTemplateModel.getUiFormTemplate().id !== parseInt($stateParams.uiFormTemplateId)) {
          configurationMediator.getFormTemplateById($stateParams.uiFormTemplateId).then(function (uiFormTemplate) {
            uiFormTemplateModel.setUiFormTemplate(uiFormTemplate);
            parseFormTemplateConfig(uiFormTemplate);
          });
        } else {
          parseFormTemplateConfig(uiFormTemplateModel.getUiFormTemplate());
        }
      } else {
        $scope.viewModel.selectedFormTemplateType = formTemplateType.APPLICATION;
        loadData();
      }
      $scope.viewModel.promptValue = translations.selectProducts;
      $scope.viewModel.title = _.isNil(options.formTemplateId) ? translations.newTemplateTitle : translations.title;
      $scope.viewModel.confirmButtonLabel = _.isNil(options.formTemplateId) ? translations.createFormTemplate : translations.saveButton;
      $scope.viewModel.linkFormPlaceholder = translations.linkFormPlaceholder;
      $scope.viewModel.formTemplateTypesPrompt = translations.formTemplateTypesPrompt;
      function parseFormTemplateConfig(formTemplateConfig) {
        $scope.viewModel.formTemplateConfig = formTemplateConfig;
        $scope.viewModel.conditional = formTemplateConfig.conditional;
        $scope.viewModel.uniqueName = formTemplateConfig.formTemplate.uniqueName;
        $scope.viewModel.displayName = formTemplateConfig.formTemplate.displayName;
        $scope.viewModel.precedingFieldFormTemplateUniqueName = formTemplateConfig.precedingFieldFormTemplateUniqueName;
        $scope.viewModel.precedingFieldVariableName = formTemplateConfig.precedingFieldVariableName;
        $scope.viewModel.ordering = formTemplateConfig.ordering;
        $scope.viewModel.displayStatusVersionBox = true;
        $scope.viewModel.statusValue = translations.status[formTemplateConfig.formTemplate.status];
        $scope.viewModel.versionValue = formTemplateConfig.formTemplate.version;
        $scope.viewModel.dynamicName = formTemplateConfig.formTemplate.dynamicNameTemplate;
        $scope.viewModel.staticName = formTemplateConfig.formTemplate.staticName;
        $scope.viewModel.flags = formTemplateConfig.formTemplate.flags;
        $scope.viewModel.allowDirectNavigation = formTemplateConfig.formTemplate.allowDirectNavigation;
        $scope.viewModel.formRepeatable = formTemplateConfig.formRepeatable;
        $scope.viewModel.selectedFormTemplateType = formTemplateConfig.formTemplate.type;
        originalUniqueName = $scope.viewModel.uniqueName;
        if (formTemplateConfig.formTemplate.root) {
          $scope.viewModel.requiredRadioButtonValue = $scope.viewModel.conditional ? 'conditionallyRequired' : 'required';
        } else {
          $scope.viewModel.requiredRadioButtonValue = 'supplemental';
        }
        $scope.viewModel.displayIncludeInEndorsements = $scope.displayIncludeInEndorsements();
        $scope.viewModel.includedInEndorsement = formTemplateConfig.formTemplate.includedInEndorsement;
        $scope.viewModel.displayIncludeInEndorsements = $scope.displayProposalLevel();
        $scope.viewModel.proposalLevel = formTemplateConfig.formTemplate.proposalLevel;
        if (!_.isNil(formTemplateConfig.formTemplate.effectiveDateRangeBegin) || !_.isNil(formTemplateConfig.formTemplate.effectiveDateRangeEnd)) {
          $scope.viewModel.effectiveDateRange = dateUtil.formatUtcDateRangeString(formTemplateConfig.formTemplate.effectiveDateRangeBegin, formTemplateConfig.formTemplate.effectiveDateRangeEnd);
          $scope.viewModel.effectiveDateRangeCheckBox = true;
          $scope.viewModel.effectiveDateRangeBegin = formTemplateConfig.formTemplate.effectiveDateRangeBegin;
          $scope.viewModel.effectiveDateRangeEnd = formTemplateConfig.formTemplate.effectiveDateRangeEnd;
        }
        if (_.isEmpty(formTemplateConfig.formTemplate.productTemplates)) {
          $scope.viewModel.displayProductSelectionDropDown = false;
          $scope.viewModel.isAllProductsSelected = true;
          $scope.viewModel.selectedProducts = null;
          $scope.viewModel.productRadioButtonValue = 'allProducts';
        } else {
          $scope.viewModel.selectedProducts = formTemplateConfig.formTemplate.productTemplates;
          $scope.viewModel.displayProductSelectionDropDown = true;
          $scope.viewModel.productRadioButtonValue = 'multiProducts';
          $scope.viewModel.isAllProductsSelected = false;
        }
        $scope.viewModel.sortFormNames = formTemplateConfig.sortRepeatableFormNames;
        $scope.viewModel.status = formTemplateConfig.formTemplate.status;
        if (formTemplateConfig.formTemplate.status === formTemplateStatus.IN_PRODUCTION) {
          $scope.viewModel.isInProduction = true;
        }
        loadData();
      }
      function loadData() {
        var typeDynamicDataSetParams = {
            name: 'Advanced Filter form template types'
          },
          linkFormDynamicDataSetParams = {
            name: 'Application Repeating Form Templates'
          };
        $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
        coreMediator.getDynamicDataSetItems(typeDynamicDataSetParams).then(function (result) {
          $scope.viewModel.formTemplateTypeList = result;
          _.each(result, function (item) {
            if (_.parseInt(item.value) === $scope.viewModel.selectedFormTemplateType) {
              $scope.viewModel.selectedFormTemplateName = item.name;
              $scope.viewModel.selectedFormTemplateType = item.type;
              $scope.viewModel.selectedFormTemplate = item;
              $scope.onSelectFormTemplateType();
            }
          });
        });
        coreMediator.getDynamicDataSetItems(linkFormDynamicDataSetParams).then(function (result) {
          $scope.viewModel.linkFormList = result;
          if (isFormTemplateConfigExist()) {
            _.each(result, function (item) {
              if (item.value === $scope.viewModel.formTemplateConfig.formTemplate.linkFormTemplateUniqueName) {
                $scope.viewModel.selectedLinkFormItem = item;
              }
            });
          }
        });
        function isFormTemplateConfigExist() {
          return !_.isNil($scope.viewModel.formTemplateConfig);
        }
      }
    });
  }
  $scope.handleFormTemplateVisibilityChange = function (value) {
    localization.getTranslationByKey('formTemplateSettings').then(function (translations) {
      if (value !== 'required') {
        $scope.viewModel.formRepeatable = false;
        $scope.viewModel.triggerRuleName = value === 'supplemental' ? translations.triggerRuleNameSupplemental : translations.triggerRuleNameConditionallyRequired;
      }
    });
  };
  $scope.displayIncludeInEndorsements = function () {
    return $scope.viewModel.selectedFormTemplateType === formTemplateType.APPLICATION && $scope.viewModel.requiredRadioButtonValue !== 'supplemental';
  };
  $scope.displayProposalLevel = function () {
    return $scope.viewModel.selectedFormTemplateType === formTemplateType.RATING || $scope.viewModel.selectedFormTemplateType === formTemplateType.PRICING || $scope.viewModel.selectedFormTemplateType === formTemplateType.QUOTING || $scope.viewModel.selectedFormTemplateType === formTemplateType.UNDERWRITER_BINDING;
  };
  $scope.handleUniqueNameBlur = function () {
    if (originalUniqueName !== $scope.viewModel.uniqueName && $scope.viewModel.formTemplateConfig) {
      configurationActionsUtil.showFormReferences('formReferencesUniqueNameChange', $scope.viewModel.formTemplateConfig.id, originalUniqueName, /*showConfirmationButtons*/true).then(function () {
        // Confirm button pressed
      }, function () {
        // Cancel button pressed
        $scope.viewModel.uniqueName = originalUniqueName;
      });
    }
  };
  $scope.onSelectFormTemplateType = function () {
    if (!_.isNil($scope.viewModel.selectedFormTemplate)) {
      $scope.viewModel.selectedFormTemplateType = parseInt($scope.viewModel.selectedFormTemplate.value);
      $scope.viewModel.selectedFormTemplateName = $scope.viewModel.selectedFormTemplate.name;
      $scope.handleLinkFormVisibilityChange();
      var ownerUri = 'com.firstbest.underwriting.form.FormTemplateType:' + $scope.viewModel.selectedFormTemplate.value,
        typeDynamicDataSetParams = {
          name: 'Product Templates By FormTemplateType',
          ownerUri: ownerUri
        },
        count = 0,
        productValues = '';
      coreMediator.getDynamicDataSetItems(typeDynamicDataSetParams).then(function (result) {
        $scope.viewModel.displayProductSelection = result.length > 0;
        if (!_.isNil(options.formTemplateId)) {
          _.each($scope.viewModel.formTemplateConfig.formTemplate.productTemplates, function (product) {
            if (count === 0) {
              productValues = product.id;
            } else {
              productValues += '::' + product.id;
            }
            count++;
          });
          $scope.viewModel.selectedProductsValue = productValues;
        }
        $scope.viewModel.productList = result;
      });
    }
  };
  $scope.onEffectiveDateRangeCheckBoxClicked = function () {
    $scope.viewModel.effectiveDateRange = null;
    $scope.viewModel.effectiveDateRangeBegin = null;
    $scope.viewModel.effectiveDateRangeEnd = null;
  };
  $scope.dateRangeUpdated = function (value) {
    $scope.viewModel.effectiveDateRangeBegin = dateUtil.parseDateRangeStartDateToMilliseconds(value);
    $scope.viewModel.effectiveDateRangeEnd = dateUtil.parseDateRangeEndDateToMilliseconds(value);
  };
  $scope.onRepeatableClick = function () {
    $scope.handleLinkFormVisibilityChange();
  };
  $scope.handleLinkFormVisibilityChange = function () {
    if ($scope.viewModel.selectedFormTemplateType !== formTemplateType.RATING || !$scope.viewModel.formRepeatable) {
      $scope.viewModel.selectedLinkFormItem = null;
      $scope.viewModel.displayLinkForm = false;
    } else {
      $scope.viewModel.displayLinkForm = true;
    }
  };
  $scope.onConfirm = function () {
    var formStructure,
      uiFormTemplate = {};
    if (!_.isNil(options.formTemplateId)) {
      formStructure = formViewerModel.getFormStructure(options.formTemplateId);
      if (formStructure) {
        configurationActionsUtil.populateUiFormTemplateModel(options.formTemplateId);
        uiFormTemplate = formStructure.uiFormTemplate;
      } else {
        uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();
      }
    } else {
      uiFormTemplate.formTemplate = {};
      uiFormTemplate.formTemplate.status = formTemplateStatus.DRAFT;
    }
    uiFormTemplate.formTemplate.type = $scope.viewModel.selectedFormTemplateType;
    uiFormTemplate.formTemplate.uniqueName = $scope.viewModel.uniqueName;
    uiFormTemplate.formTemplate.displayName = $scope.viewModel.displayName;
    uiFormTemplate.formTemplate.includedInEndorsement = $scope.displayIncludeInEndorsements() ? $scope.viewModel.includedInEndorsement : false;
    uiFormTemplate.formTemplate.proposalLevel = $scope.displayProposalLevel() ? $scope.viewModel.proposalLevel : false;
    if ($scope.viewModel.effectiveDateRangeCheckBox) {
      uiFormTemplate.formTemplate.effectiveDateRangeBegin = $scope.viewModel.effectiveDateRangeBegin;
      uiFormTemplate.formTemplate.effectiveDateRangeEnd = $scope.viewModel.effectiveDateRangeEnd;
    } else {
      uiFormTemplate.formTemplate.effectiveDateRangeBegin = null;
      uiFormTemplate.formTemplate.effectiveDateRangeEnd = null;
    }
    if ($scope.viewModel.displayProductSelection) {
      if ($scope.viewModel.isAllProductsSelected) {
        uiFormTemplate.formTemplate.productTemplates = null;
        uiFormTemplate.formTemplate.appliesToAllProductTemplates = true;
      } else {
        uiFormTemplate.formTemplate.productTemplates = $scope.viewModel.selectedProducts;
        uiFormTemplate.formTemplate.appliesToAllProductTemplates = false;
      }
    }
    uiFormTemplate.formTemplate.root = $scope.viewModel.requiredRadioButtonValue !== 'supplemental';
    if ($scope.viewModel.requiredRadioButtonValue === 'supplemental') {
      uiFormTemplate.precedingFieldFormTemplateUniqueName = $scope.viewModel.precedingFieldFormTemplateUniqueName;
      uiFormTemplate.precedingFieldVariableName = $scope.viewModel.precedingFieldVariableName;
    } else {
      uiFormTemplate.precedingFieldFormTemplateUniqueName = null;
      uiFormTemplate.precedingFieldVariableName = null;
    }
    uiFormTemplate.conditional = $scope.viewModel.requiredRadioButtonValue === 'conditionallyRequired';
    if ($scope.viewModel.requiredRadioButtonValue === 'required') {
      uiFormTemplate.triggerRule = null;
    } else if (_.isNil(uiFormTemplate.triggerRule)) {
      uiFormTemplate.triggerRule = {
        objectUri: '/Rule',
        name: $scope.viewModel.triggerRuleName,
        condition: {
          objectUri: '/CompositeCondition',
          subconditions: []
        }
      };
    }
    if (!$scope.viewModel.formRepeatable || $scope.viewModel.requiredRadioButtonValue !== 'required') {
      uiFormTemplate.sortRepeatableFormNames = false;
      uiFormTemplate.formTemplate.dynamicNameTemplate = '';
      uiFormTemplate.formTemplate.staticName = '';
      //for non-repeatable forms, this property should be set to true
      uiFormTemplate.formTemplate.allowDirectNavigation = true;
      $scope.viewModel.formRepeatable = false;
      uiFormTemplate.formRepeatable = false;
    } else {
      uiFormTemplate.formRepeatable = $scope.viewModel.formRepeatable;
      uiFormTemplate.formTemplate.dynamicNameTemplate = $scope.viewModel.dynamicName;
      uiFormTemplate.formTemplate.staticName = $scope.viewModel.staticName;
      uiFormTemplate.sortRepeatableFormNames = $scope.viewModel.sortFormNames;
      uiFormTemplate.formTemplate.allowDirectNavigation = $scope.viewModel.allowDirectNavigation;
    }
    uiFormTemplate.formTemplate.linkFormTemplateUniqueName = $scope.viewModel.selectedLinkFormItem ? $scope.viewModel.selectedLinkFormItem.value : null;
    uiFormTemplate.formTemplate.flags = $scope.viewModel.flags;
    uiFormTemplate.ordering = $scope.viewModel.ordering;
    if (_.isNil(options.formTemplateId)) {
      uiFormTemplate.formTemplate.version = 1;
      formMediator.buildNewUiSectionList(uiFormTemplate.formTemplate.type).then(function (result) {
        uiFormTemplate.sections = result;
        formMediator.clearIdsFromSectionList(uiFormTemplate.sections);
        configurationMediator.createFormTemplate(uiFormTemplate).then(function (result) {
          configurationActionsUtil.handleUiFormTemplateSave(result, false);
          if (result.id) {
            var navigationModel = {
              parentState: 'configuration.formTemplateBrowser',
              currentState: 'configuration.formEditor.form',
              data: {
                uiFormTemplateId: result.id
              }
            };
            $state.go('configuration.formEditor.form', {
              uiFormTemplateId: result.id
            });
            navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
            $uibModalInstance.close();
          }
        });
      });
    } else {
      uiFormTemplate.id = $scope.viewModel.formTemplateConfig.id;
      configurationMediator.updateFormTemplate(uiFormTemplate, $scope.viewModel.formTemplateConfig.id).then(function (result) {
        configurationActionsUtil.handleUiFormTemplateSave(result, true);
        if (_.isNil(formStructure)) {
          uiFormTemplateModel.setUiFormTemplate(result);
        }
        $uibModalInstance.close();
      });
    }
  };
  $scope.handleProductClick = function (event) {
    $scope.viewModel.isAllProductsSelected = event.currentTarget.value === 'allProducts';
    $scope.viewModel.selectedProductsValue = '';
    $scope.viewModel.selectedProducts = [];
    $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_CLEAR, $scope.viewModel.itemName);
    if ($scope.viewModel.isAllProductsSelected) {
      $scope.viewModel.displayProductSelectionDropDown = false;
    } else {
      $scope.viewModel.displayProductSelectionDropDown = true;
    }
  };
  $scope.getSelectedProductName = function () {
    if (!_.isNil($scope.viewModel.selectedProducts) && $scope.viewModel.selectedProducts.length === 0 && !$scope.viewModel.isAllProductsSelected) {
      return '';
    }
    return 'product';
  };
  $scope.isRepeatableCheckboxEnabled = function () {
    return $scope.canEnableRepeatableCheckbox();
  };
  $scope.canEnableRepeatableCheckbox = function () {
    return !$scope.viewModel.isInProduction && $scope.viewModel.canManageForms && $scope.viewModel.requiredRadioButtonValue === 'required';
  };
  $scope.canEnableConfirmButton = function () {
    var hasSelectedFormTemplate = !_.isNil($scope.viewModel.selectedFormTemplate);
    var hasDisplayName = !_.isEmpty($scope.viewModel.displayName);
    var hasUniqueName = !_.isEmpty($scope.viewModel.uniqueName);
    var isEffectiveDateActive = $scope.viewModel.effectiveDateRangeCheckBox;
    var hasEffectiveDateRangeBegin = !_.isNil($scope.viewModel.effectiveDateRangeBegin);
    var hasEffectiveDateRangeEnd = !_.isNil($scope.viewModel.effectiveDateRangeEnd);
    var isEffectiveDateValid = isEffectiveDateActive ? hasEffectiveDateRangeBegin || hasEffectiveDateRangeEnd : true;
    var isSupplemental = $scope.viewModel.requiredRadioButtonValue === 'supplemental';
    var hasPrecedingFieldFormTemplateUniqueName = !_.isEmpty($scope.viewModel.precedingFieldFormTemplateUniqueName);
    var hasPrecedingFieldVariableName = !_.isNil($scope.viewModel.precedingFieldVariableName);
    var isSupplementalValid = isSupplemental ? hasPrecedingFieldFormTemplateUniqueName && hasPrecedingFieldVariableName : true;
    var hasEmptySelectedProductList = _.size($scope.viewModel.selectedProducts) === 0;
    var isAllProductSelected = $scope.viewModel.isAllProductsSelected;
    var isProductSelectionValid = !isAllProductSelected ? !hasEmptySelectedProductList : true;
    return hasSelectedFormTemplate && hasDisplayName && hasUniqueName && isEffectiveDateValid && isProductSelectionValid && isSupplementalValid;
  };
  $scope.$on('modal.closing', function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $scope.onCancel = function () {
    $uibModalInstance.close();
  };
  $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, _.debounce(function (event, itemName) {
    var productObj = {};
    if (itemName === $scope.viewModel.itemName) {
      $scope.viewModel.selectedProducts = [];
      _.each($scope.viewModel.productList, function (product) {
        if (product.selected) {
          productObj = {};
          productObj.id = product.value;
          productObj.name = product.name;
          $scope.viewModel.selectedProducts.push(productObj);
        }
      });
    }
  }), 500);
  $scope.$on(configurationConstant.event.SELECTOR_WIDGET_UPDATED, function (event, item1Name, item2) {
    $scope.viewModel.precedingFieldFormTemplateUniqueName = item1Name;
    $scope.viewModel.precedingFieldVariableName = item2.fieldName;
  });
  init();
};
FormTemplateSettingsController.$inject = ["$rootScope", "$scope", "$state", "$stateParams", "$uibModalInstance", "localization", "coreConstant", "formViewerConstant", "coreMediator", "configurationMediator", "formMediator", "formTemplateType", "fieldType", "formTemplateStatus", "options", "dateUtil", "authorizationConstants", "navigationStateModel", "configurationConstant", "configurationActionsUtil", "formViewerModel", "uiFormTemplateModel", "currentUserModel"];
angular.module('umCore').controller('formTemplateSettingsController', FormTemplateSettingsController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2484:
/***/ (function(module, exports, __webpack_require__) {

var ManageOperationComponent = {
  templateUrl: '/configuration/manageOperation/manageOperation.tpl.html',
  controller: 'manageOperationController',
  bindings: {
    hasViewDetailHistoryPermission: '<',
    hasManageBackupRestorePermission: '<',
    hasManageImportDataPermission: '<',
    hasGenerateDataDictionaryPermission: '<'
  }
};
angular.module('ums.configuration').component('uiManageOperation', ManageOperationComponent);
__webpack_require__(2485);
__webpack_require__(2486);
__webpack_require__(2487);
__webpack_require__(2488);
__webpack_require__(2492);
__webpack_require__(2496);
__webpack_require__(2500);
__webpack_require__(2504);

/***/ }),

/***/ 2485:
/***/ (function(module) {

module.exports = JSON.parse("{\"manageOperation\":{\"history\":\"Detailed History\",\"backup\":\"Backup\",\"restore\":\"Restore\",\"importClassCodes\":\"Import Class Codes\",\"manageAMBestCarriers\":\"Manage A.M. Best Carriers\",\"generateDataDictionary\":\"Generate Data Dictionary\"}}");

/***/ }),

/***/ 2486:
/***/ (function(module, exports) {

var path = '/configuration/manageOperation/manageOperation.tpl.html';
var html = "<div class=\"manageOperation\" ng-click=\"$ctrl.onIconClick($event)\">\n\n    <i class=\"fa fa-cog manageOperationIcon\"\n       aria-hidden=\"true\"></i>\n</div>\n\n<div class=\"arrowUp\" ng-if=\"$ctrl.isOpen\"></div>\n\n<div class=\"manageOperationPopout\"\n     ng-if=\"$ctrl.isOpen\"\n     ui-auto-close\n     on-close=\"$ctrl.onIconClick()\"\n     is-open=\"$ctrl.isOpen\">\n\n    <ul class=\"content\">\n\n        <li class=\"menuRow\"\n            ng-if=\"$ctrl.hasViewDetailHistoryPermission\"\n            ng-click=\"$ctrl.showHistoryModal()\">\n            <span ui-translate>manageOperation.history</span>\n        </li>\n\n        <li class=\"menuRow\"\n            ng-if=\"$ctrl.hasManageBackupRestorePermission\"\n            ng-click=\"$ctrl.backup()\">\n            <span ui-translate>manageOperation.backup</span>\n        </li>\n\n        <li class=\"menuRow\"\n            ng-if=\"$ctrl.hasManageBackupRestorePermission\"\n            ng-click=\"$ctrl.restore()\">\n            <span ui-translate>manageOperation.restore</span>\n        </li>\n\n        <li class=\"menuRow\"\n            ng-if=\"$ctrl.hasManageImportDataPermission\"\n            ng-click=\"$ctrl.importClassCodesModal()\">\n            <span ui-translate>manageOperation.importClassCodes</span>\n        </li>\n\n        <li class=\"menuRow\"\n            ng-if=\"$ctrl.hasGenerateDataDictionaryPermission\"\n            ng-click=\"$ctrl.generateDataDictionary()\">\n            <span ui-translate>manageOperation.generateDataDictionary</span>\n        </li>\n        <!--<li class=\"menuRow\">\n            <span ui-translate>{{::$ctrl.i18n.manageOperation.manageAMBestCarriers}}</span>\n        </li>-->\n    </ul>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2487:
/***/ (function(module, exports) {

/*@ngInject*/
var ManageOperationController = function ManageOperationController(localization, $element, $uibModal) {
  $element.addClass('manageOperation');
  this.isOpen = false;
  this.onIconClick = function () {
    this.isOpen = !this.isOpen;
  };
  this.backup = function () {
    this.closeDropDown();
    $uibModal.open({
      templateUrl: '/configuration/manageOperation/backup/backupModal.tpl.html',
      controller: 'backupModalController',
      windowClass: 'backupModal',
      resolve: {},
      keyboard: false,
      backdrop: 'static'
    });
  };
  this.restore = function () {
    this.closeDropDown();
    $uibModal.open({
      templateUrl: '/configuration/manageOperation/restore/restoreModal.tpl.html',
      controller: 'restoreModalController',
      windowClass: 'restoreModal',
      resolve: {},
      keyboard: false,
      backdrop: 'static'
    });
  };
  this.showHistoryModal = function () {
    this.closeDropDown();
    $uibModal.open({
      templateUrl: '/configuration/manageOperation/detailedHistory/detailedHistoryModal.tpl.html',
      controller: 'detailedHistoryModalController',
      windowClass: 'detailedHistoryModal',
      resolve: {},
      keyboard: false,
      backdrop: 'static'
    });
  };
  this.importClassCodesModal = function () {
    this.closeDropDown();
    $uibModal.open({
      templateUrl: '/configuration/manageOperation/importClassCodes/importClassCodesModal.tpl.html',
      controller: 'importClassCodesModalController',
      windowClass: 'importClassCodesModal',
      resolve: {},
      keyboard: false,
      backdrop: 'static'
    });
  };
  this.generateDataDictionary = function () {
    this.closeDropDown();
    $uibModal.open({
      templateUrl: '/configuration/manageOperation/generateDataDictionary/generateDataDictionaryModal.tpl.html',
      controller: 'generateDataDictionaryModalController',
      windowClass: 'generateDataDictionaryModal',
      resolve: {},
      keyboard: false,
      backdrop: 'static'
    });
  };
  this.closeDropDown = function () {
    this.isOpen = false;
  };
};
ManageOperationController.$inject = ["localization", "$element", "$uibModal"];
angular.module('ums.configuration').controller('manageOperationController', ManageOperationController);

/***/ }),

/***/ 2488:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2489);
__webpack_require__(2490);
__webpack_require__(2491);

/*@ngInject*/
var BackupModalController = function BackupModalController($rootScope, $scope, coreMediator, localization, coreConstant, configurationActionsUtil) {
  localization.getTranslationByKey('backup').then(function (translations) {
    $scope.viewModel = {
      configurationContentList: [],
      configurationContentPrompt: translations.configurationContentPrompt,
      selectedConfigurationContent: '',
      title: translations.title,
      cancelButton: translations.cancelButton,
      backupButton: translations.backupButton
    };
    function loadConfigurationContent() {
      coreMediator.getDynamicDataSetItems({
        name: 'Database Section Names'
      }).then(function (databaseSectionNames) {
        $scope.viewModel.configurationContentList = databaseSectionNames;
      });
    }
    $scope.onCancel = function () {
      $scope.$dismiss();
    };
    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
      $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });
    $scope.canEnableConfirmButton = function () {
      return $scope.viewModel.selectedConfigurationContent;
    };
    $scope.onBackup = function () {
      $scope.$dismiss();
      configurationActionsUtil.backup($scope.viewModel.selectedConfigurationContent.name, $scope.viewModel.selectedConfigurationContent.name, translations.loadingBar, translations.successMessage);
    };
    loadConfigurationContent();
    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  });
};
BackupModalController.$inject = ["$rootScope", "$scope", "coreMediator", "localization", "coreConstant", "configurationActionsUtil"];
angular.module('ums.configuration').controller('backupModalController', BackupModalController);

/***/ }),

/***/ 2489:
/***/ (function(module) {

module.exports = JSON.parse("{\"backup\":{\"title\":\"Backup\",\"configurationContent\":\"Configuration Content\",\"backupButton\":\"Backup\",\"cancelButton\":\"Cancel\",\"configurationContentPrompt\":\"Please Choose\",\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\"}}");

/***/ }),

/***/ 2490:
/***/ (function(module, exports) {

var path = '/configuration/manageOperation/backup/backupModal.tpl.html';
var html = "<base-modal modal-title=\"viewModel.title\"\n            ok=\"viewModel.backupButton\"\n            cancel=\"viewModel.cancelButton\"\n            is-confirm-disabled=\"!canEnableConfirmButton()\"\n            ok-button-class=\"okButtonClass\"\n            on-confirm=\"onBackup()\"\n            on-cancel=\"onCancel()\">\n    <div class=\"row\">\n        <div class=\"rowItem\">\n            <span ui-translate>backup.configurationContent</span>\n        </div>\n\n        <ui-select class=\"dropdownFormComponent dropdownComponentSelect\"\n                   theme=\"select2\"\n                   ng-model=\"viewModel.selectedConfigurationContent\"\n                   ng-change=\"handleChange()\"\n                   on-select=\"handleChange()\"\n                   append-to-body=\"true\">\n\n            <ui-select-match placeholder=\"{{::viewModel.configurationContentPrompt }}\"\n                             allow-clear=\"true\">\n                <span>{{viewModel.selectedConfigurationContent.name}}</span>\n            </ui-select-match>\n\n            <ui-select-choices repeat=\"item in (viewModel.configurationContentList | filter: $select.search) track by $index\">\n                <span ng-click=\"onSelectRuleSet(item)\">{{ item.name }}</span>\n            </ui-select-choices>\n        </ui-select>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2491:
/***/ (function(module, exports) {

/*@ngInject*/
var BackupRepository = function BackupRepository(baseRepository, temporaryLoginTokenRepository) {
  angular.extend(this, baseRepository);
  this.backup = function (sectionName) {
    var _this = this;
    var url = '/database/DatabaseDownloadServlet',
      config = {
        params: {
          sectionName: sectionName
        }
      };
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this.get(url, config);
    });
  };
};
BackupRepository.$inject = ["baseRepository", "temporaryLoginTokenRepository"];
angular.module('ums.configuration').service('backupRepository', BackupRepository);

/***/ }),

/***/ 2492:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2493);
__webpack_require__(2494);
__webpack_require__(2495);

/*@ngInject*/
var DetailedHistoryModalController = function DetailedHistoryModalController($rootScope, $scope, $controller, $filter, $timeout, $window, coreMediator, coreConstant, detailedHistoryRepository, localization) {
  localization.getTranslationByKey('detailedHistory').then(function (translations) {
    var searchFieldsFilters = [{
      name: _.get(translations, 'searchFieldsFilters.byUser'),
      value: 1
    }, {
      name: _.get(translations, 'searchFieldsFilters.byType'),
      value: 4
    }, {
      name: _.get(translations, 'searchFieldsFilters.byMessage'),
      value: 2
    }];
    $scope.columns = [{
      name: 'timeCreated',
      label: _.get(translations, 'grid.columns.colDate'),
      className: 'colDate',
      getValue: function getValue(item) {
        return $filter('date')(item.timeCreated, 'MM/dd/yy hh:mma');
      }
    }, {
      name: 'actorName',
      label: _.get(translations, 'grid.columns.colUser'),
      className: 'colUser',
      getValue: function getValue(item) {
        return item.actorName;
      }
    }, {
      name: 'eventType',
      label: _.get(translations, 'grid.columns.colType'),
      className: 'colType',
      getValue: function getValue(item) {
        return item.eventType;
      }
    }, {
      name: 'eventAction',
      label: _.get(translations, 'grid.columns.colAction'),
      className: 'colAction',
      getValue: function getValue(item) {
        return item.eventAction;
      }
    }, {
      name: 'message',
      label: _.get(translations, 'grid.columns.colMessage'),
      className: 'colMessage colDefault',
      getValue: function getValue(item) {
        return item.message;
      }
    }, {
      name: 'details',
      label: _.get(translations, 'grid.columns.colDetails'),
      className: 'colDetails colDefault',
      getValue: function getValue(item) {
        return item.details;
      }
    }];
    $scope.viewModel = {
      controller: this,
      searchFieldsFilters: searchFieldsFilters,
      selectedFieldFilter: searchFieldsFilters[0],
      timeRangeCriterionTemplate: {
        'type': 1,
        'name': 'Date Range',
        'description': null,
        'required': false,
        'dataSetName': 'Date Range',
        'isDynamicDataSet': false,
        'variableName': 'tmeRange',
        'uiType': 8,
        'defaultShow': false,
        'allowedRolesConcat': ''
      },
      totalRecords: 0,
      requestParams: {
        searchString: '',
        filterFields: 1,
        startIndex: 0,
        pageSize: 25,
        numberOfRows: 25,
        key: 'timeCreated',
        sortType: 'desc',
        timeRange: ''
      },
      items: null,
      isGridEmpty: false
    };
    $scope.setStartIndex = function (startIndex) {
      $scope.viewModel.requestParams.startIndex = startIndex;
    };
    $scope.onFieldFilterChange = function (filter) {
      $scope.viewModel.selectedFieldFilter = filter;
      $scope.viewModel.requestParams.filterFields = filter.value;
      $scope.onFilterChange();
    };
    function loadRecords() {
      $scope.isLoading = true;
      $scope.viewModel.items = [];
      detailedHistoryRepository.getDetailedHistory($scope.viewModel.requestParams).then(function (result) {
        $scope.viewModel.items = result.records;
        $scope.viewModel.totalRecords = result.totalRecords;
        $scope.viewModel.isGridEmpty = result.records.length === 0;
        $scope.isLoading = false;
      });
    }
    ;
    $scope.resetGridHeaders = function (requestParams) {
      $scope.viewModel.requestParams.key = requestParams.key;
      $scope.viewModel.requestParams.sortType = requestParams.sortType;
      $scope.onFilterChange();
    };
    $scope.onFilterChange = function () {
      loadRecords();
    };
    $scope.onClearSearch = function () {
      $scope.viewModel.requestParams.searchString = '';
      $scope.onFilterChange();
    };
    $scope.onPagingChange = function (event, params) {
      $scope.viewModel.requestParams.startIndex = params.startIndex;
      loadRecords();
    };
    $scope.onSortChange = function ($event, params) {
      $scope.viewModel.requestParams.key = params.key;
      $scope.viewModel.requestParams.sortType = params.sortType;
      loadRecords();
    };
    $scope.onDownloadUrlClick = function (downloadType) {
      if (downloadType === 'csv') {
        detailedHistoryRepository.getDownloadUrl($scope.viewModel.requestParams, 'csv').then(function (url) {
          $window.open(url, '_blank');
        });
      } else if (downloadType === 'xls') {
        detailedHistoryRepository.getDownloadUrl($scope.viewModel.requestParams, 'xls').then(function (url) {
          $window.open(url, '_blank');
        });
      }
    };
    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
      $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });
    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
    $scope.$on(coreConstant.event.FILTER_UPDATED, function (event) {
      $scope.viewModel.requestParams.timeRange = $scope.viewModel.timeRangeCriterionTemplate.value;
      $scope.onFilterChange();
    });
    loadRecords();
  });
};
DetailedHistoryModalController.$inject = ["$rootScope", "$scope", "$controller", "$filter", "$timeout", "$window", "coreMediator", "coreConstant", "detailedHistoryRepository", "localization"];
angular.module('ums.configuration').controller('detailedHistoryModalController', DetailedHistoryModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2493:
/***/ (function(module) {

module.exports = JSON.parse("{\"detailedHistory\":{\"title\":\"Detailed History\",\"grid\":{\"emptyMessage\":\"No matching items.\",\"columns\":{\"colAction\":\"Action\",\"colDate\":\"Date\",\"colDetails\":\"Details\",\"colMessage\":\"Message\",\"colType\":\"Type\",\"colUser\":\"User\"}},\"searchFieldsFilters\":{\"byUser\":\"By User\",\"byType\":\"By Type\",\"byMessage\":\"By Message\"},\"downloadCsv\":\"Download CSV\",\"downloadExcel\":\"Download Excel\"}}");

/***/ }),

/***/ 2494:
/***/ (function(module, exports) {

var path = '/configuration/manageOperation/detailedHistory/detailedHistoryModal.tpl.html';
var html = "<div class=\"detailedHistoryModal\" >\n    <div class=\"titlebarWidget\">\n        <div class=\"modal-header\">\n            <h3 class=\"modal-title\" ui-translate>detailedHistory.title</h3>\n            <button class=\"close\" ng-click=\"$dismiss()\">\n                <span class=\"glyphicon glyphicon-remove\"></span>\n            </button>\n        </div>\n    </div>\n\n    <div class=\"modal-body landing gridWindow\">\n        <div class=\"landingHeader\">\n            <div class=\"search has-feedback\">\n                <input type=\"search\"\n                       ng-model=\"viewModel.requestParams.searchString\"\n                       ng-model-options=\"{ debounce: viewModel.searchDelayInMilliSeconds }\"\n                       class=\"form-control\"\n                       ng-change=\"onFilterChange()\"\n                       placeholder=\"{{ ::viewModel.searchPlaceholder }}\" />\n                <span ng-if=\"viewModel.requestParams.searchString === ''\"\n                      class=\"glyphicon glyphicon-search form-control-feedback\"></span>\n                <span ng-if=\"viewModel.requestParams.searchString !== ''\"\n                      ng-click='onClearSearch()' class=\"glyphicon glyphicon-remove form-control-feedback \"></span>\n            </div>\n\n            <div class=\"filter\"\n                 uib-dropdown>\n                Filter:\n                <button class=\"btn-link activeFilter\" uib-dropdown-toggle>\n                    <span>{{ viewModel.selectedFieldFilter.name }}</span>\n                    <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                </button>\n                <ul uib-dropdown-menu>\n                    <li ng-repeat=\"filter in viewModel.searchFieldsFilters\"\n                        ng-click='onFieldFilterChange(filter)'><a>{{filter.name}}</a></li>\n                </ul>\n            </div>\n\n            <div class=\"filter dropdown\">\n                <ui-date-filter\n                    criterion-template=\"viewModel.timeRangeCriterionTemplate\"\n                    submission=\"viewModel.submission\"\n                    advanced-filter-type=\"viewModel.advancedFilterType\">\n                </ui-date-filter>\n            </div>\n\n            <div class=\"actionButtonList\" uib-dropdown>\n\n                <button type=\"button\"\n                        class=\"btn btn-xs\"\n                        uib-dropdown-toggle>\n                    <span class=\"glyphicon glyphicon-cog\"></span>\n                </button>\n\n                <ul class=\"dropdown-menu-right\" uib-dropdown-menu>\n                    <!--Download Links-->\n                    <li role=\"menuitem\">\n                        <a uib-dropdown\n                           auto-close=\"outsideClick\"\n                           ng-click=\"onDownloadUrlClick('csv')\">\n                            <span ui-translate>detailedHistory.downloadCsv</span>\n                        </a>\n                    </li>\n                    <li role=\"menuitem\">\n                        <a uib-dropdown\n                           auto-close=\"outsideClick\"\n                           ng-click=\"onDownloadUrlClick('xls')\">\n                            <span ui-translate>detailedHistory.downloadExcel</span>\n                        </a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n\n        <div class=\"grid\">\n            <div class=\"gridContainer\">\n                <div class=\"columnHeader\">\n                    <div class=\"columnRow\">\n                        <div ng-repeat=\"column in columns track by $index\"\n                             class=\"{{ ::column.className }}\"\n                             ui-grid-sortable-header\n                             request-params=\"viewModel.requestParams\"\n                             item-name=\"{{ ::column.name }}\"\n                             item-label=\"{{ ::column.label }}\"\n                             on-toggle=\"onSortChange($event, params)\"></div>\n                    </div>\n                </div>\n\n                <div class=\"datagrid table\"\n                     ux-datagrid=\"viewModel.items\"\n                     ng-if=\"!isLoading\"\n                     ui-scroll-detection\n                     ui-scroll-detection-target=\".columnHeader\">\n\n                    <script type=\"template/html\"\n                            data-template-item=\"item\"\n                            data-template-name=\"default\">\n\n                        <div class=\"rowDrawerWrapper\"\n                             ng-class=\"{ selected: item.selected && $ctrl.isDrawerOpen }\">\n\n                            <div class=\"columnRow\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <div ng-repeat=\"column in columns\"\n                                     class=\"col {{ ::column.className }}\"\n                                     uib-tooltip=\"{{ ::column.getValue(item) }}\"\n                                     tooltip-append-to-body=\"true\"\n                                     tooltip-popup-delay=\"500\"\n                                     tooltip-enable=\"{{ item['enableTooltip.' + column.name] }}\"\n                                     ui-is-tooltip-enabled=\"item['enableTooltip.' + column.name]\">\n                                    <span class=\"columnText longText\">{{ ::column.getValue(item) }}</span>\n                                </div>\n                            </div>\n                        </div>\n                    </script>\n                </div>\n\n                <ui-grid-paging-component\n                    ng-if=\"!viewModel.isGridEmpty\"\n                    start-index=\"viewModel.requestParams.startIndex\"\n                    page-size=\"viewModel.requestParams.pageSize\"\n                    total-records=\"viewModel.totalRecords\"\n                    record-count-text=\"viewModel.recordCountText\"\n                    records-count-text=\"viewModel.recordsCountText\"\n                    on-change=\"onPagingChange($event, params)\"></ui-grid-paging-component>\n\n                <div class=\"gridEmpty\"\n                     ng-if=\"viewModel.isGridEmpty && !viewModel.isLoading\" ui-translate>detailedHistory.grid.emptyMessage</div>\n\n                <div class=\"icon-spinner\"\n                     ng-if=\"viewModel.isLoading\"></div>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2495:
/***/ (function(module, exports) {

var DetailedHistoryRepository = function DetailedHistoryRepository(baseRepository, sortUtil, coreMediator) {
  angular.extend(this, baseRepository);
  this.getParams = function (requestParams) {
    var params = {
      filterText: requestParams.searchString,
      filterFields: requestParams.filterFields,
      timeRange: requestParams.timeRange,
      startIndex: requestParams.startIndex,
      numberOfRows: requestParams.numberOfRows
    };
    return params;
  };
  this.getDetailedHistory = function (requestParams) {
    var params = this.getParams(requestParams);
    var url = '/rest/Audit/configurationLogs',
      config = {
        params: params
      };
    return this.get(url, config).then(function (responseData) {
      var sortedRecords = responseData.records.sort(sortUtil.naturalSortObject(requestParams.key));
      if (requestParams.sortType === 'desc') {
        sortedRecords.reverse();
      }
      responseData.records = sortedRecords;
      return responseData;
    });
  };
  this.getDownloadUrl = function (requestParams, type) {
    var paramsString = '&currentState=administrator',
      params = this.getParams(requestParams);
    for (var key in params) {
      var value = params[key];
      if (value && value != '') {
        paramsString += "&".concat(key, "=").concat(encodeURIComponent(value));
      }
    }
    return coreMediator.getSingleUseToken().then(function (token) {
      paramsString += "&t=".concat(encodeURIComponent(token));
      return "/auditLogData/DetailedHistory.".concat(type, "?exportType=").concat(type).concat(paramsString);
    });
  };
};
DetailedHistoryRepository.$inject = ["baseRepository", "sortUtil", "coreMediator"];
angular.module('ums.configuration').service('detailedHistoryRepository', DetailedHistoryRepository);

/***/ }),

/***/ 2496:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2497);
__webpack_require__(2498);
__webpack_require__(2499);

/*@ngInject*/
var RestoreModalController = function RestoreModalController($rootScope, $scope, coreConstant, localization, $timeout, attachmentUtil, modalUtil, configurationMediator, loadingBarHandler) {
  localization.getTranslationByKey('restore').then(function (translations) {
    $scope.viewModel = {
      title: translations.title,
      cancelButton: translations.cancelButton,
      confirmButton: translations.confirmButton,
      or: translations.or,
      dragAndDrop: translations.dragAndDrop,
      uploadedFile: null,
      chooseFileString: translations.restoreFile,
      attachment: {},
      restoreMode: '',
      acceptedTypes: ['.dbinit', '.xml']
    };
    $scope.onCancel = function () {
      $scope.$dismiss();
    };
    $scope.fileSelected = function (file) {
      if (file) {
        storeUploadedFile(file);
      }
    };
    $scope.onConfirm = function () {
      $scope.$close();
      loadingBarHandler.showLoadingBar(translations.loadingBar + ' ' + $scope.viewModel.attachment.name);
      configurationMediator.restore($scope.viewModel.restoreMode, $scope.viewModel.uploadedFile).then(function () {
        loadingBarHandler.hideLoadingBar();
        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, translations.successMessage + ' ' + $scope.viewModel.attachment.name);
      }, function () {
        // On Error
        loadingBarHandler.hideLoadingBar();
      });
    };
    $scope.canEnableConfirmButton = function () {
      return $scope.viewModel.attachment.name && $scope.viewModel.restoreMode;
    };
    $scope.onUpdateField = function () {
      if ($scope.viewModel.attachment && $scope.viewModel.attachment.id) {
        $scope.updateAttachment($scope.viewModel.attachment);
      }
    };
    function storeUploadedFile(uploadedFile) {
      var allowFile = attachmentUtil.validateAttachmentType(uploadedFile, _.get(translations, 'unacceptableType'), $scope.viewModel.acceptedTypes);
      if (allowFile) {
        $timeout(function () {
          $scope.viewModel.uploadedFile = uploadedFile;
          if (!$scope.viewModel.attachment) {
            $scope.viewModel.attachment = {};
          }
          $scope.viewModel.attachment.name = uploadedFile.name;
          $scope.viewModel.attachment.size = uploadedFile.size;
        }, 0);
      }
    }
    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
      $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });
    $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
      if (file) {
        storeUploadedFile(file);
      }
    });
    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  });
};
RestoreModalController.$inject = ["$rootScope", "$scope", "coreConstant", "localization", "$timeout", "attachmentUtil", "modalUtil", "configurationMediator", "loadingBarHandler"];
angular.module('ums.configuration').controller('restoreModalController', RestoreModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2497:
/***/ (function(module) {

module.exports = JSON.parse("{\"restore\":{\"title\":\"Restore\",\"restoreFile\":\"Choose File\",\"restoreMode\":\"Restore Mode\",\"refresh\":\"Refresh\",\"insert\":\"Insert\",\"cleanInsert\":\"Clean Insert\",\"confirmButton\":\"Restore\",\"cancelButton\":\"Cancel\",\"or\":\"or\",\"dragAndDrop\":\"Drag and Drop File Here\",\"chooseFile\":\"Choose File\",\"unacceptableType\":{\"unacceptableTypeMessage\":\"File {name} is not a supported document type for restore\",\"unacceptableTypeTitle\":\"Alert\",\"unacceptableTypeConfirmActionButtonLabel\":\"OK\"},\"loadingBar\":\"Restoring\",\"successMessage\":\"Successfully restored\"}}");

/***/ }),

/***/ 2498:
/***/ (function(module, exports) {

var path = '/configuration/manageOperation/restore/restoreModal.tpl.html';
var html = "<base-modal modal-title=\"viewModel.title\"\n            ok=\"viewModel.confirmButton\"\n            cancel=\"viewModel.cancelButton\"\n            is-confirm-disabled=\"!canEnableConfirmButton()\"\n            ok-button-class=\"okButtonClass\"\n            on-confirm=\"onConfirm()\"\n            on-cancel=\"onCancel()\">\n\n    <div class=\"dockPanelContent attachmentBox\" ui-browser-detection>\n        <!--Content-->\n        <div class=\"modal-body contentContainer\">\n            <span ui-translate>restore.restoreFile</span>\n            <div class=\"dockPanelInnerContent\">\n                <div class=\"dragDropBox\"\n                     ui-drop-zone\n                     file=\"{{viewModel.uploadedFile}}\">\n                    <span>{{::viewModel.dragAndDrop}}</span>\n                    <span>{{::viewModel.or}}</span>\n                    <div>\n                        <input type=\"file\"\n                               class=\"btn btn-primary btn-sm hiddenFileInput\"\n                               name=\"' + scope.valueName + '_file\"\n                               ui-custom-on-change=\"fileSelected(file)\"/>\n                        <input type=\"button\"\n                               class=\"btn btn-primary btn-sm\"\n                               value=\"{{::viewModel.chooseFileString}}\"/>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent narrow\"\n         ng-if=\"viewModel.attachment.id ||viewModel.attachment.name\">\n        <div class=\"dockPanelCellSide\">\n            <span class=\"glyphicon glyphicon-file\"></span>\n        </div>\n        <div class=\"dockPanelCellContent\">\n            <span ng-if=\"!viewModel.nameEditMode\">\n                {{viewModel.attachment.name}}\n            </span>\n        </div>\n    </div>\n    <div class=\"restoreMode\">\n        <div class=\"formTemplateLabel\">\n            <span ui-translate>restore.restoreMode</span>\n        </div>\n\n        <div class=\"radioButtonGroup\">\n            <input type=\"radio\"\n                   ng-model=\"viewModel.restoreMode\"\n                   value=\"REFRESH\">\n            <span ui-translate>restore.refresh</span>\n            <input type=\"radio\"\n                   ng-model=\"viewModel.restoreMode\"\n                   value=\"INSERT\">\n            <span ui-translate>restore.insert</span>\n            <input type=\"radio\"\n                   ng-model=\"viewModel.restoreMode\"\n                   value=\"CLEAN_INSERT\">\n            <span ui-translate>restore.cleanInsert</span>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2499:
/***/ (function(module, exports) {

/*@ngInject*/
var RestoreRepository = function RestoreRepository(baseRepository, temporaryLoginTokenRepository) {
  angular.extend(this, baseRepository);
  this.restore = function (operation, file) {
    var _this = this;
    var url = '/databaseUpload/databaseUploadServlet',
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        params: {
          operation: operation,
          mode: 'unmarshal'
        },
        headers: {
          'Content-Type': undefined
        }
      };
    formData.append('file', file);
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this.post(url, formData, config);
    });
  };
};
RestoreRepository.$inject = ["baseRepository", "temporaryLoginTokenRepository"];
angular.module('ums.configuration').service('restoreRepository', RestoreRepository);

/***/ }),

/***/ 2500:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2501);
__webpack_require__(2502);
__webpack_require__(2503);

/*@ngInject*/
var ImportClassCodesModalController = function ImportClassCodesModalController($rootScope, $scope, coreConstant, $timeout, localization, attachmentUtil, modalUtil, configurationMediator, loadingBarHandler, xmlUtil) {
  localization.getTranslationByKey('importClassCodes').then(function (translations) {
    $scope.viewModel = {
      title: translations.title,
      cancelButton: translations.cancelButton,
      confirmButton: translations.confirmButton,
      or: translations.or,
      dragAndDrop: translations.dragAndDrop,
      uploadedFile: null,
      importFileString: translations.chooseFile,
      attachment: {},
      acceptedTypes: ['.txt']
    };
    $scope.onCancel = function () {
      $scope.$dismiss();
    };
    $scope.fileSelected = function (file) {
      if (file) {
        storeUploadedFile(file);
      }
    };
    $scope.onConfirm = function () {
      $scope.$close();
      loadingBarHandler.showLoadingBar(translations.loadingBar + ' ' + $scope.viewModel.attachment.name);
      configurationMediator.importClassCodes($scope.viewModel.uploadedFile).then(function (result) {
        loadingBarHandler.hideLoadingBar();
        if (parseInt(xmlUtil.parseString(result).status) === -1) {
          var config = {
            confirmActionButtonLabel: translations.okButtonLabel,
            summary: xmlUtil.parseString(result).message,
            title: translations.errorTitle
          };
          modalUtil.showGenericConfirm(config);
        } else {
          $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, translations.successMessage + ' ' + $scope.viewModel.attachment.name);
        }
      }, function () {
        // On Error
        loadingBarHandler.hideLoadingBar();
      });
    };
    $scope.canEnableConfirmButton = function () {
      return $scope.viewModel.attachment.name && $scope.viewModel.attachment.size;
    };
    function storeUploadedFile(uploadedFile) {
      var allowFile = attachmentUtil.validateAttachmentType(uploadedFile, _.get(translations, 'unacceptableType'), $scope.viewModel.acceptedTypes);
      if (allowFile) {
        $timeout(function () {
          $scope.viewModel.uploadedFile = uploadedFile;
          if (!$scope.viewModel.attachment) {
            $scope.viewModel.attachment = {};
          }
          $scope.viewModel.attachment.name = uploadedFile.name;
          $scope.viewModel.attachment.size = uploadedFile.size;
        }, 0);
      }
    }
    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
      $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });
    $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
      if (file) {
        storeUploadedFile(file);
      }
    });
    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  });
};
ImportClassCodesModalController.$inject = ["$rootScope", "$scope", "coreConstant", "$timeout", "localization", "attachmentUtil", "modalUtil", "configurationMediator", "loadingBarHandler", "xmlUtil"];
angular.module('ums.configuration').controller('importClassCodesModalController', ImportClassCodesModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2501:
/***/ (function(module) {

module.exports = JSON.parse("{\"importClassCodes\":{\"title\":\"Import Class Codes\",\"confirmButton\":\"Import\",\"cancelButton\":\"Cancel\",\"or\":\"or\",\"dragAndDrop\":\"Drag and Drop File Here\",\"chooseFile\":\"Choose File\",\"unacceptableType\":{\"unacceptableTypeMessage\":\"File {name} is not a supported document type for import\",\"unacceptableTypeTitle\":\"Alert\",\"unacceptableTypeConfirmActionButtonLabel\":\"OK\"},\"loadingBar\":\"Importing Class Codes\",\"successMessage\":\"Successfully Imported Class Codes\",\"note\":\"File types: Tab delimited .txt\",\"okButtonLabel\":\"OK\",\"errorTitle\":\"Error\"}}");

/***/ }),

/***/ 2502:
/***/ (function(module, exports) {

var path = '/configuration/manageOperation/importClassCodes/importClassCodesModal.tpl.html';
var html = "<base-modal modal-title=\"viewModel.title\"\n            ok=\"viewModel.confirmButton\"\n            cancel=\"viewModel.cancelButton\"\n            is-confirm-disabled=\"!canEnableConfirmButton()\"\n            ok-button-class=\"okButtonClass\"\n            on-confirm=\"onConfirm()\"\n            on-cancel=\"onCancel()\">\n\n    <div class=\"dockPanelContent attachmentBox\" ui-browser-detection>\n        <!--Content-->\n        <div class=\"modal-body contentContainer\">\n            <div class=\"dockPanelInnerContent\">\n                <div class=\"dragDropBox\"\n                     ui-drop-zone\n                     file=\"{{viewModel.uploadedFile}}\">\n                    <span>{{::viewModel.dragAndDrop}}</span>\n                    <span>{{::viewModel.or}}</span>\n                    <div>\n                        <input type=\"file\"\n                               accept=\"text/plain\"\n                               class=\"btn btn-primary btn-sm hiddenFileInput\"\n                               name=\"' + scope.valueName + '_file\"\n                               ui-custom-on-change=\"fileSelected(file)\"/>\n                        <input type=\"button\"\n                               class=\"btn btn-primary btn-sm\"\n                               value=\"{{::viewModel.importFileString}}\"/>\n                    </div>\n\n                </div>\n            </div>\n            <span ui-translate>importClassCodes.note</span>\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent narrow\"\n         ng-if=\"viewModel.attachment.id ||viewModel.attachment.name\">\n        <div class=\"dockPanelCellSide\">\n            <span class=\"glyphicon glyphicon-file\"></span>\n        </div>\n        <div class=\"dockPanelCellContent\">\n            <span ng-if=\"!viewModel.nameEditMode\">\n                {{viewModel.attachment.name}}\n            </span>\n        </div>\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2503:
/***/ (function(module, exports) {

/*@ngInject*/
var ImportClassCodesRepository = function ImportClassCodesRepository(baseRepository, temporaryLoginTokenRepository) {
  angular.extend(this, baseRepository);
  this.importClassCodes = function (file) {
    var _this = this;
    var url = '/classCodeUpload/ClassCodeUploadServlet',
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        params: {},
        headers: {
          'Content-Type': undefined
        }
      };
    formData.append('file', file);
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this.post(url, formData, config);
    });
  };
};
ImportClassCodesRepository.$inject = ["baseRepository", "temporaryLoginTokenRepository"];
angular.module('ums.configuration').service('importClassCodesRepository', ImportClassCodesRepository);

/***/ }),

/***/ 2504:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2505);
__webpack_require__(2506);
__webpack_require__(2507);

/*@ngInject*/
var GenerateDataDictionaryModalController = function GenerateDataDictionaryModalController($rootScope, $scope, coreConstant, localization, modalUtil, configurationMediator, loadingBarHandler) {
  localization.getTranslationByKey('generateDataDictionary').then(function (translations) {
    $scope.viewModel = {
      title: translations.title,
      message: translations.message,
      confirmButton: translations.confirmButton,
      cancelButton: translations.cancelButton
    };
    $scope.onCancel = function () {
      $scope.$dismiss();
    };
    $scope.onConfirm = function () {
      $scope.$close();
      loadingBarHandler.showLoadingBar(translations.loadingBar);
      configurationMediator.generateDataDictionary().then(function () {
        loadingBarHandler.hideLoadingBar();
        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, translations.successMessage);
      }, function () {
        // On Error
        loadingBarHandler.hideLoadingBar();
      });
    };
    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
      $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });
    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  });
};
GenerateDataDictionaryModalController.$inject = ["$rootScope", "$scope", "coreConstant", "localization", "modalUtil", "configurationMediator", "loadingBarHandler"];
angular.module('ums.configuration').controller('generateDataDictionaryModalController', GenerateDataDictionaryModalController);

/***/ }),

/***/ 2505:
/***/ (function(module) {

module.exports = JSON.parse("{\"generateDataDictionary\":{\"title\":\"Generate Data Dictionary\",\"message\":\"Are you sure you want to generate data dictionary?\",\"confirmButton\":\"Generate Data Dictionary\",\"cancelButton\":\"Cancel\",\"loadingBar\":\"Generating Data Dictionary\",\"successMessage\":\"Successfully generated data dictionary\"}}");

/***/ }),

/***/ 2506:
/***/ (function(module, exports) {

var path = '/configuration/manageOperation/generateDataDictionary/generateDataDictionaryModal.tpl.html';
var html = "<base-modal modal-title=\"viewModel.title\"\n            ok=\"viewModel.confirmButton\"\n            cancel=\"viewModel.cancelButton\"\n            on-confirm=\"onConfirm()\"\n            on-cancel=\"onCancel()\">\n\n    <div class=\"modalContent\">\n        <div class=\"summary\">\n            <p>{{ viewModel.message }}</p>\n        </div>\n    </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2507:
/***/ (function(module, exports) {

/*@ngInject*/
var GenerateDataDictionaryRepository = function GenerateDataDictionaryRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.generateDataDictionary = function () {
    var url = '/rest/Integration/generateDataDictionary';
    return this.post(url);
  };
};
GenerateDataDictionaryRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('generateDataDictionaryRepository', GenerateDataDictionaryRepository);

/***/ }),

/***/ 2508:
/***/ (function(module) {

module.exports = JSON.parse("{\"jsExpression\":{\"disableExpressions\":\"Disable Expression\",\"requiredLevelExpression\":\"Required Expression\",\"valueExpression\":\"Value Expression\",\"title\":\" for \",\"cancelButtonLabel\":\"Cancel\",\"confirmButtonLabel\":\"Save and Close\",\"saveButtonLabel\":\"Save\",\"function\":\"Function\",\"functionPlaceholder\":\"Select a function\",\"formAndField\":\"Form Field(s)\",\"addToScript\":\"Add to Script\",\"functions\":{\"sum\":\"sum([val1, val2,...]) calculate the sum value of any array of numbers\",\"max\":\"max([val1, val2,...]) calculate the maximum value of any array of numbers\",\"min\":\"min([val1, val2,...]) calculate the minmum value of any array of numbers\",\"average\":\"average([val1, val2,...]) calculate the average value of any array of numbers\",\"Math.round\":\"Math.round(value) return the closest integer with rounding\",\"Math.ceil\":\"Math.ceil(value) return the smallest integer that is greater than or equal to the argument\",\"Math.floor\":\"Math.floor(value) return the largest integer that is less than or equal to the argument\",\"-\":\"One value minus one or more single values\",\"*\":\"One value multiplied by one or more single values\",\"/\":\"One value divided by one or more single values\",\"fieldValue\":\"return the value of a single field\",\"fieldValues\":\"return the values of a single repeater field as an array\",\"field\":\"return the Field object by field name\"},\"editorPlaceholder\":\"Use the controls above to create a JavaScript expression\",\"exampleFormat\":\"ex: $#,###.##\"}}");

/***/ }),

/***/ 2509:
/***/ (function(module, exports) {

var path = '/configuration/javaScriptExpression/javaScriptExpressionTemplate.tpl.html';
var html = "<base-modal\n    modal-title=\"expressionViewModel.title\"\n    ok=\"expressionViewModel.okButton\"\n    cancel=\"expressionViewModel.cancelButton\"\n    third-button=\"expressionViewModel.saveButton\"\n    third-button-class=\"'btn-default'\"\n    is-confirm-disabled=\"!expressionViewModel.isChanged || expressionViewModel.hasError\"\n    is-third-button-disabled=\"!expressionViewModel.isChanged || expressionViewModel.hasError\"\n    on-third-button=\"onSave()\"\n    on-confirm=\"onSaveAndClose()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"jsExpressionBox\" ui-browser-detection>\n\n        <div class=\"jsTools\">\n            <div class=\"jsFunction\">\n                <span ui-translate class=\"selector-label\">jsExpression.function</span>\n                <ui-select class=\"dropdownFormComponent dropdownComponentSelect functionDropdown\"\n                           theme=\"select2\"\n                           append-to-body=\"true\"\n                           dropdown-unselect-item\n                           dropdown-handle-focus\n                           ui-hide-select-on-scroll\n                           ng-model=\"expressionViewModel.selectedFunction\"\n                           on-select=\"onSelectFunction($item)\">\n\n                    <ui-select-match placeholder=\"{{ ::expressionViewModel.functionPlaceholder }}\"\n                                     allow-clear=\"true\">\n                        <span>{{ selectedFunction.name }}</span>\n                    </ui-select-match>\n\n                    <ui-select-choices\n                        group-by=\"'group'\"\n                        repeat=\"item in (functionList | filter: $select.search) track by $index\">\n                        <span>{{ item.name }}</span>\n                    </ui-select-choices>\n                </ui-select>\n                <span class=\"selector-description\">{{ selectedFunction.description }}</span>\n            </div>\n\n            <div class=\"jsFields\">\n                <span ui-translate class=\"selector-label\">jsExpression.formAndField</span>\n                <ui-multi-step-selector-widget\n                    ng-repeat=\"field in fields\"\n                    is-disabled=\"!expressionViewModel.fieldSelectorEnabled\"\n                    mode=\"'forms'\"\n                    step-1-item-name=\"field.item1Name\"\n                    step-2-item-name=\"field.item2Name\"\n                    step2-multi-select=\"expressionViewModel.fieldMuliSelectEnabled\"></ui-multi-step-selector-widget>\n            </div>\n\n            <div class=\"jsActions\">\n                <button type=\"button\"\n                        class=\"btn btn-primary\"\n                        ng-disabled=\"!expressionViewModel.addToScriptEnabled\"\n                        ng-click=\"onAddToScript()\">\n                    <span ui-translate>jsExpression.addToScript</span>\n                </button>\n            </div>\n        </div>\n\n        <div class=\"jsExpression\"\n             ui-ace=\"{\n                require: ['ace/ext/language_tools'],\n                onLoad: onAceLoaded\n             }\"\n             placeholder=\"Create a javascript-based expression to return decide the value of the selected property\"></div>\n\n        <div class=\"value-format\" ng-hide=\"!isActive('valueExpression')\">\n            <input type=\"text\"\n                   placeholder=\"Value Format\"\n                   ng-model=\"expressionViewModel.valueFormat\"\n                   ng-change=\"onValueFormatChange()\">\n            <a href=\"/umhelp/UMStudioHelp/index.html#topics/configuration/forms/c_format_value_expression.html\" target=\"_blank\" class=\"value-format\"><i class=\"fa fa-info-circle\"></i></a>\n            <span ui-translate class=\"example\">jsExpression.exampleFormat</span>\n        </div>\n   </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2510:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var JavaScriptExpressionController = function JavaScriptExpressionController($rootScope, $scope, $state, $stateParams, $timeout, localization, coreConstant, configurationConstant, configurationActionsUtil, formViewerConstant, configurationMediator, fieldTemplate, expressionName, expressionValue, javascriptApplicableExpressions, javascriptExpressionType) {
  var timeoutList = [],
    translations;
  $scope.expressionViewModel = {
    title: '',
    okButton: '',
    cancelButton: '',
    saveButton: '',
    functionPlaceholder: '',
    valueFormat: fieldTemplate.valueFormat,
    addToScriptEnabled: false,
    fieldMuliSelectEnabled: true,
    fieldSelectorEnabled: true,
    isChanged: false,
    hasError: false
  };
  $scope.uiFormTemplate = null;
  $scope.jsBuilderOptions = null;
  $scope.fieldTemplate = fieldTemplate;
  $scope.expressionName = expressionName;
  $scope.expessionValue = expressionValue;
  $scope.fields = [];
  function init() {
    localization.getTranslationsByKeys(['jsExpression']).then(function (result) {
      translations = result;
      $scope.expressionViewModel.title = translations[$scope.expressionName] + translations.title + $scope.fieldTemplate.variableName;
      $scope.expressionViewModel.okButton = translations['confirmButtonLabel'];
      $scope.expressionViewModel.cancelButton = translations['cancelButtonLabel'];
      $scope.expressionViewModel.saveButton = translations['saveButtonLabel'];
      $scope.expressionViewModel.functionPlaceholder = translations['functionPlaceholder'];
      $scope.expressionViewModel.editorPlaceholder = translations['editorPlaceholder'];
    });
    configurationMediator.getFormTemplateById($stateParams.uiFormTemplateId).then(function (uiFormTemplate) {
      $scope.uiFormTemplate = uiFormTemplate;
      addField();
    });
    configurationMediator.getJsBuilderOptions($stateParams.uiFormTemplateId).then(function (jsBuliderOptions) {
      if ($scope.expressionName === 'disableExpressions') {
        _.remove(jsBuliderOptions, {
          applicableExpressions: javascriptApplicableExpressions.REQUIRED_EXPRESSION
        });
      } else if ($scope.expressionName === 'requiredLevelExpression') {
        _.remove(jsBuliderOptions, {
          applicableExpressions: javascriptApplicableExpressions.DISABLE_EXPRESSION
        });
      } else {
        _.remove(jsBuliderOptions, {
          applicableExpressions: javascriptApplicableExpressions.REQUIRED_EXPRESSION
        });
        _.remove(jsBuliderOptions, {
          applicableExpressions: javascriptApplicableExpressions.DISABLE_EXPRESSION
        });
      }
      $scope.functionList = jsBuliderOptions;
    });
  }
  function addField() {
    $scope.fields.push({
      'item1Name': $scope.uiFormTemplate.formTemplate.uniqueName,
      'item2Name': ''
    });
  }
  function resetInputs() {
    $scope.selectedFunction = undefined;
    $scope.expressionViewModel.selectedFunction = $scope.selectedFunction;
    $scope.fields = [];
    addField();
    $scope.expressionViewModel.addToScriptEnabled = false;
  }
  function removeField(index) {
    $scope.fields.splice(index, 1);
  }
  function checkEditorPlaceHolder() {
    var shouldShow = !$scope.editor.session.getValue().length;
    var node = $scope.editor.renderer.emptyMessageNode;
    if (!shouldShow && node) {
      $scope.editor.renderer.scroller.removeChild($scope.editor.renderer.emptyMessageNode);
      $scope.editor.renderer.emptyMessageNode = null;
    } else if (shouldShow && !node) {
      node = $scope.editor.renderer.emptyMessageNode = document.createElement('div');
      node.textContent = $scope.expressionViewModel.editorPlaceholder;
      node.className = 'ace_invisible ace_emptyMessage';
      node.style.padding = '0 9px';
      $scope.editor.renderer.scroller.appendChild(node);
    }
  }
  function updateFieldTemplate() {
    var expression = $scope.editor.getValue();
    if ($scope.isActive('valueExpression')) {
      $scope.fieldTemplate.valueFormat = $scope.expressionViewModel.valueFormat;
    }
    $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
      name: $scope.expressionName,
      value: expression
    });
  }
  function saveFormTemplate() {
    var saveAs = false;
    configurationActionsUtil.saveUiFormTemplate($scope.uiFormTemplate.id, saveAs);
  }
  $scope.onSave = function () {
    updateFieldTemplate();
    saveFormTemplate();
  };
  $scope.onSaveAndClose = function () {
    $scope.onSave();
    $scope.$dismiss();
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.isActive = function (buttonName) {
    return buttonName.indexOf($scope.expressionName) >= 0;
  };
  $scope.onAceLoaded = function (editor) {
    $scope.editor = editor;
    ace.config.set('basePath', 'js/ace');
    $scope.editor.session.setMode('ace/mode/javascript');
    $scope.editor.setTheme('ace/theme/chrome');
    $scope.editor.session.setUseWrapMode(true);
    $scope.editor.setShowPrintMargin(false);
    $scope.editor.$blockScrolling = Infinity;
    $scope.editor.session.on('changeAnnotation', $scope.onSessionAnnotationChange);
    $scope.editor.session.on('change', $scope.onSessionEditorChange);
    if ($scope.expessionValue) {
      $scope.editor.setValue($scope.expessionValue);
      $scope.editor.clearSelection();
    }
    checkEditorPlaceHolder();
  };
  $scope.onSessionAnnotationChange = function () {
    var hasError,
      hasChange = false;
    var annotations = [];
    _.each($scope.editor.session.getAnnotations(), function (annotation) {
      if (annotation.type === 'error') {
        hasError = true;
      }
      if (annotation.type === 'warning' && (annotation.text.indexOf('!==') > 0 || annotation.text.indexOf('===') > 0)) {
        // '!==' and '===' doesn't work with current JS engine
        hasChange = true;
      } else {
        annotations.push(annotation);
      }
    });
    if (hasChange) {
      $scope.editor.session.setAnnotations(annotations);
    }
    if ($scope.expressionViewModel.hasError !== hasError) {
      $scope.expressionViewModel.hasError = hasError;
      $timeout(function () {}, 0);
    }
  };
  $scope.onSessionEditorChange = function () {
    if ($scope.expressionViewModel.isChanged !== true) {
      $scope.expressionViewModel.isChanged = true;
      $timeout(function () {}, 0);
    }
    checkEditorPlaceHolder();
  };
  $scope.onValueFormatChange = function () {
    $scope.expressionViewModel.isChanged = true;
  };
  function splitFields(fieldNamesConcat) {
    var fieldNames = [];
    if (fieldNamesConcat) {
      fieldNames = _.split(fieldNamesConcat, ', ');
    }
    return fieldNames;
  }
  function getFieldNames() {
    var fieldNames = [];
    _.each($scope.fields, function (field, index) {
      if (field.item2Name !== null && field.item2Name !== '') {
        var names = splitFields(field.item2Name);
        _.each(names, function (name) {
          var fieldFullName = name;
          if ($scope.uiFormTemplate.formTemplate.uniqueName !== field.item1Name) {
            fieldFullName = $scope.fields[index].item1Name + '::' + name;
          }
          fieldNames.push(fieldFullName);
        });
      }
    });
    return fieldNames;
  }
  function checkActionButtons() {
    var fieldCount = getFieldNames().length;
    $scope.expressionViewModel.fieldSelectorEnabled = true;
    $scope.expressionViewModel.fieldMuliSelectEnabled = true;
    if ($scope.selectedFunction && $scope.selectedFunction.type === 'function') {
      if ($scope.selectedFunction.group === 'Field Functions') {
        $scope.expressionViewModel.addToScriptEnabled = fieldCount > 0;
      } else {
        $scope.expressionViewModel.addToScriptEnabled = true;
      }
      if ($scope.selectedFunction.operandCount === '1' || $scope.selectedFunction.operandCount === 'Exactly 1') {
        $scope.expressionViewModel.fieldMuliSelectEnabled = false;
        if ($scope.fields.length > 1) {
          $scope.fields = $scope.fields.slice(0, 1);
        }
      }
    } else if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.CONSTANT) {
      $scope.expressionViewModel.addToScriptEnabled = true;
      $scope.expressionViewModel.fieldSelectorEnabled = false;
    } else if ($scope.selectedFunction || fieldCount > 0) {
      if ($scope.selectedFunction && $scope.selectedFunction.operandCount === '2+' && fieldCount < 2) {
        $scope.expressionViewModel.addToScriptEnabled = false;
      } else {
        $scope.expressionViewModel.addToScriptEnabled = true;
      }
    } else {
      $scope.expressionViewModel.addToScriptEnabled = false;
    }

    // switching from single field to multiple, need to add new field selector
    if ($scope.expressionViewModel.fieldMuliSelectEnabled && $scope.fields.length === 1 && $scope.fields[0].item2Name) {
      addField();
    }
    ;
  }
  $scope.onSelectFunction = function (value) {
    $scope.selectedFunction = value;
    $scope.expressionViewModel.selectedFunction = $scope.selectedFunction;
    if (value) {
      $scope.selectedFunction.description = translations.functions[$scope.selectedFunction.value];
    }
    checkActionButtons();
  };
  $scope.$on(configurationConstant.event.SELECTOR_WIDGET_UPDATED, function (event, item1Name, item2, isMultiSelect) {
    var item2Name = '';
    var index = event.targetScope.$parent.$index;
    if (isMultiSelect) {
      item2Name = item2;
    } else {
      if (item2.propertyName) {
        item2Name = item2.propertyName;
      } else {
        item2Name = item2.fieldName;
      }
    }
    $scope.fields[index].item1Name = item1Name;
    $scope.fields[index].item2Name = item2Name;
    if ($scope.fields.length !== index + 1 && !item1Name && !item2Name) {
      removeField(index);
    } else if ($scope.fields.length === index + 1 && item1Name && item2Name && $scope.fields.length < 5) {
      addField();
    }
    checkActionButtons();
  });
  $scope.$on(configurationConstant.event.FORM_COMPONENT_SELECTED, function (event) {
    var index = event.targetScope.$parent.$index; // todo refactor this
    $scope.fields[index].item2Name = event.targetScope.$ctrl.selectedStep2ItemName;
    checkActionButtons();
  });
  $scope.onAddToScript = function () {
    var fieldNames = getFieldNames(),
      fieldCount = fieldNames.length,
      useArray,
      fieldFunction = 'fieldValue';
    if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.FUNCTION && $scope.selectedFunction.group === 'Field Functions') {
      fieldFunction = $scope.selectedFunction.value;
    }
    if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.FUNCTION && $scope.selectedFunction.group !== 'Field Functions') {
      $scope.editor.insert($scope.selectedFunction.value + '(');
    }
    if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.CONSTANT) {
      $scope.editor.insert($scope.selectedFunction.value);
      fieldCount = 0;
    }

    // insert text for the fields
    useArray = false;
    if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.FUNCTION && $scope.selectedFunction.group !== 'Field Functions') {
      if ($scope.selectedFunction.operandCount === '1' || $scope.selectedFunction.operandCount === 'Exactly 1') {
        if (fieldCount > 1) {
          fieldCount = 1;
        }
      } else if (fieldCount === 1) {
        fieldFunction = 'fieldValues';
      } else {
        useArray = true;
      }
    }
    if (useArray) {
      $scope.editor.insert('[');
    }
    for (var i = 0; i < fieldCount; i++) {
      $scope.editor.insert(fieldFunction + '("' + fieldNames[i] + '")');
      if (i < fieldCount - 1) {
        if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.OPERATOR) {
          $scope.editor.insert(' ' + $scope.selectedFunction.value + ' ');
        } else {
          $scope.editor.insert(', ');
        }
      }
    }
    if (useArray) {
      $scope.editor.insert(']');
    }
    if ($scope.selectedFunction && $scope.selectedFunction.type === javascriptExpressionType.FUNCTION && $scope.selectedFunction.group !== 'Field Functions') {
      $scope.editor.insert(')');
    }
    $scope.expressionViewModel.isChanged = true;
    resetInputs();
  };
  $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function (event) {
    $scope.$dismiss();
  });
  $scope.$on('$destroy', function () {
    $scope.editor.session.off('changeAnnotation', $scope.onSessionAnnotationChange);
    $scope.editor.session.off('change', $scope.onSessionEditorChange);
    $scope.editor = null;
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  init();
};
JavaScriptExpressionController.$inject = ["$rootScope", "$scope", "$state", "$stateParams", "$timeout", "localization", "coreConstant", "configurationConstant", "configurationActionsUtil", "formViewerConstant", "configurationMediator", "fieldTemplate", "expressionName", "expressionValue", "javascriptApplicableExpressions", "javascriptExpressionType"];
angular.module('umCore').controller('javaScriptExpressionController', JavaScriptExpressionController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2511:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2512);
__webpack_require__(2513);
__webpack_require__(2514);
var MultiStepSelectorWidgetComponent = {
  templateUrl: '/configuration/multiStepSelectorWidget/multiStepSelectorWidget.tpl.html',
  controller: 'multiStepSelectorWidgetController',
  bindings: {
    mode: '<',
    step1ItemName: '<',
    step2ItemName: '<',
    step2MultiSelect: '<',
    isDisabled: '<',
    name: '<'
  }
};
angular.module('ums.configuration').component('uiMultiStepSelectorWidget', MultiStepSelectorWidgetComponent);

/***/ }),

/***/ 2512:
/***/ (function(module) {

module.exports = JSON.parse("{\"multiStepSelectorWidget\":{\"searchForAForm\":\"Step 1: Search for a form\",\"searchForAProperty\":\"Step 1: Search for a Property\",\"searchForAObject\":\"Step 1: Search for a Object\",\"searchForAField\":\"Step 2: Search for a field\",\"selectAFormField\":\"Select a form field\",\"selectAObjectProperty\":\"Select a object property\",\"changeButton\":\"Change\",\"selectedForm\":\"Selected Form\",\"selectedObject\":\"Selected Object\"}}");

/***/ }),

/***/ 2513:
/***/ (function(module, exports) {

var path = '/configuration/multiStepSelectorWidget/multiStepSelectorWidget.tpl.html';
var html = "<div class=\"selectorWidget\"\n     title=\"{{ $ctrl.tooltip }}\">\n    <div uib-dropdown\n         class=\"uib-dropdown\"\n         ng-class=\"{'dropup' : $ctrl.isDropup()}\">\n        <button class=\"selectFormButton\"\n                uib-dropdown-toggle\n                ng-click=\"$ctrl.openForm($event)\"\n                ng-disabled=\"$ctrl.isDisabled\">\n            <div class=\"dropdownInnerWrapper\">\n                <div class=\"dropdownLabel dropDownPrompt\"\n                      ng-class=\"{placeholder: !$ctrl.showClearIcon}\"\n                      ui-tooltip>{{$ctrl.dropDownPrompt}}</div>\n                <div ng-if=\"!$ctrl.showClearIcon\"\n                      ng-disabled=\"$ctrl.isShowClearIconDisabled\"\n                      class=\"glyphicon glyphicon-chevron-down\"></div>\n\n            </div>\n        </button>\n\n        <span ng-if=\"$ctrl.showClearIcon && !$ctrl.isDisabled\"\n              class=\"glyphicon glyphicon-remove btn-xs\"\n              ng-click=\"$ctrl.removeSelection($event)\"></span>\n\n        <div class=\"selectorMenu\"\n             uib-dropdown-menu\n             dropdown-append-to-body=\"true\"\n             aria-labelledby=\"simple-dropdown\"\n             ng-click=\"$ctrl.selectorMenuClick($event)\">\n\n            <div ng-if=\"$ctrl.displayStep1Section\"\n                 ng-click=\"$event.stopPropagation()\">\n                <div class=\"searchBox\">\n                    <span class=\"glyphicon glyphicon-search\"></span>\n                    <input type=\"text\"\n                           class=\"searchInput\"\n                           ng-model=\"$ctrl.step1SearchValue\"\n                           ng-model-options=\"{ debounce: $ctrl.searchDelayInMilliSeconds }\"\n                           ng-change=\"$ctrl.step1SearchChange()\"\n                           ui-auto-focus=\"true\"\n                           ui-set-focus=\"step1SearchFocus\"\n                           placeholder=\"{{$ctrl.searchForStep1}}\"/>\n                </div>\n\n                <ul class=\"searchItems\" ng-if=\"$ctrl.displayStep1Items\">\n                    <li ng-click=\"$ctrl.selectStep1Item(itemName, $event)\"\n                        ng-repeat=\"itemName in $ctrl.step1ItemsFilter\">\n                        <label class=\"itemName\">{{itemName}}</label>\n                    </li>\n                </ul>\n            </div>\n\n            <div ng-if=\"!$ctrl.displayStep1Section\"\n                 class=\"selectedItem\"\n                 ng-click=\"$event.stopPropagation()\">\n                <label>\n                    <span>{{$ctrl.selectedStep1Label}}</span>\n                    <button class=\"btn btn-link\"\n                            ng-click=\"$ctrl.change($event)\" ui-translate>\n                        multiStepSelectorWidget.changeButton\n                    </button>\n                </label>\n                <label class=\"selectedStep1ItemName\">{{$ctrl.selectedStep1ItemName}}</label>\n            </div>\n\n            <div ng-if=\"$ctrl.displayStep2Section && !$ctrl.displayStep2MultiSelect\"\n                 ng-click=\"step2BoxClick($event)\">\n                <div class=\"searchBox\">\n                    <span class=\"glyphicon glyphicon-search\"></span>\n                    <input type=\"text\"\n                           class=\"searchInput\"\n                           ng-model=\"$ctrl.step2SearchValue\"\n                           ng-model-options=\"{ debounce: $ctrl.searchDelayInMilliSeconds }\"\n                           ng-change=\"$ctrl.step2SearchChange()\"\n                           ui-auto-focus=\"true\"\n                           ui-set-focus=\"step2SearchFocus\"\n                           placeholder=\"{{$ctrl.searchForStep2}}\" ng-click=\"$event.stopPropagation()\"/>\n                </div>\n\n                <ul class=\"searchItems\">\n                    <li ng-click=\"$ctrl.selectStep2Item(item, $event)\"\n                        ng-repeat=\"item in $ctrl.step2ItemsFilter\"\n                        ng-class=\"{'selectedStep2Item': $ctrl.selectedStep2ItemName === item.fieldName || $ctrl.selectedStep2ItemName === item.propertyName}\">\n                        <label class=\"itemName\">{{$ctrl.getItemName(item)}}</label>\n                    </li>\n                </ul>\n            </div>\n\n            <div class=\"multiSelectStep2\"\n                 ng-if=\"$ctrl.displayStep2Section && $ctrl.displayStep2MultiSelect\"\n                 ng-click=\"$event.stopPropagation()\">\n                <ui-multi-select class=\"multiSelect\"\n                                 items-list=\"$ctrl.step2MultiItemsFilter\"\n                                 prompt-value=\"$ctrl.searchForStep2\"\n                                 selected-value=\"$ctrl.selectedStep2ItemName\"\n                                 append-to-body=\"false\"\n                                 auto-expand=\"false\"\n                                 item-name=\"$ctrl.itemName\">\n                </ui-multi-select>\n\n            </div>\n        </div>\n    </div>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2514:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {/*@ngInject*/
var MultiStepSelectorWidgetController = function MultiStepSelectorWidgetController($rootScope, $scope, configurationConstant, configurationMediator, localization, coreConstant) {
  localization.getTranslationByKey('multiStepSelectorWidget').then(function (translations) {
    this.init = function () {
      this.dropDownPrompt = this.mode === 'forms' ? translations.selectAFormField : translations.selectAObjectProperty;
      this.searchForStep1 = this.mode === 'forms' ? translations.searchForAForm : translations.searchForAObject;
      this.searchForStep2 = this.mode === 'forms' ? translations.searchForAField : translations.searchForAProperty;
      this.selectedStep1Label = this.mode === 'forms' ? translations.selectedForm : translations.selectedObject;
      this.isWidgetOpen = false;
      this.step1Items = [];
      this.step1ItemsFilter = [];
      this.step2Items = [];
      this.step2ItemsFilter = [];
      this.displayStep1Section = false;
      this.displayStep1Items = false;
      this.displayStep2Section = false;
      this.searchDelayInMilliSeconds = 750;
      this.step1SearchValue = _.isNil(this.step1ItemName) ? '' : this.step1ItemName;
      this.step2SearchValue = '';
      this.widgetOpened = false;
      this.selectedStep2ItemName = '';
      this.itemName = 'multiStepSelector';
      this.displayStep2MultiSelect = this.step2MultiSelect;
      this.tooltip = '';
      this.showClearIcon = false;
      if (!_.isEmpty(this.step1ItemName)) {
        if (!_.isEmpty(this.step2ItemName)) {
          this.dropDownPrompt = this.getDropDownPrompt(this.step1ItemName, this.step2ItemName);
          this.showClearIcon = true;
        } else {
          this.selectStep1Item(this.step1ItemName);
        }
      }
    };
    this.$onChanges = function (changes) {
      if (changes.mode) {
        if (!_.isUndefined(changes.mode.currentValue) && !_.isUndefined(changes.mode.previousValue)) {
          this.step1ItemName = null;
          this.step2ItemName = null;
          this.showClearIcon = false;
          $scope.$emit(configurationConstant.event.SELECTOR_WIDGET_UPDATED, '', {});
        }
        this.reset();
        this.init();
      }
      if (!_.isNil(changes.step2MultiSelect) && changes.step2MultiSelect.previousValue !== changes.step2MultiSelect.currentValue) {
        var step2MultiList = _.filter(this.step2MultiItemsFilter, function (item) {
            return item.selected;
          }),
          _step2MultiItemsFilter;
        this.displayStep2MultiSelect = changes.step2MultiSelect.currentValue;
        if (changes.step2MultiSelect.previousValue === true && step2MultiList.length !== 0) {
          if (step2MultiList.length > 1) {
            this.step1ItemName = null;
            this.step2ItemName = null;
            this.showClearIcon = false;
            this.init();
            this.reset();
            $scope.$emit(configurationConstant.event.SELECTOR_WIDGET_UPDATED, null, []);
          } else {
            this.selectStep1Item(this.step1ItemName);
            this.selectedStep2ItemName = step2MultiList[0].name;
            this.dropDownPrompt = this.getDropDownPrompt(this.step1ItemName, step2MultiList[0].name);
            this.showClearIcon = true;
          }
        }
        if (changes.step2MultiSelect.previousValue === false) {
          _step2MultiItemsFilter = this.step2MultiItemsFilter;
          this.step2MultiItemsFilter = [];
          _.each(_step2MultiItemsFilter, function (item) {
            if (item.name === this.selectedStep2ItemName) {
              item.selected = true;
            }
            this.step2MultiItemsFilter.push(item);
          }.bind(this));
          this.selectedStep2ItemName = this.step2ItemName;
        }
      }
    };
    this.openForm = function (event) {
      event.stopPropagation();
      if (this.step1SearchValue !== '' && _.isNil(this.selectedStep1ItemName)) {
        this.step1SearchValue = '';
        this.step1SearchChange();
      }
      if (this.step2SearchValue !== '') {
        this.step2SearchValue = '';
        this.step2SearchChange();
      }
      if (!this.widgetOpened) {
        if (!_.isNil(this.step1ItemName) && !_.isNil(this.step2ItemName) && this.step1ItemName !== '' && this.step2ItemName !== '') {
          this.selectedStep2ItemName = this.step2ItemName;
          this.selectStep1Item(this.step1ItemName, event);
        } else {
          if (_.isNil(this.step1ItemName) || _.isEmpty(this.step1ItemName)) {
            this.loadStep1Data();
          }
        }
        this.widgetOpened = true;
      }
      if (!_.isNil(this.step1ItemName) && !_.isNil(this.selectedStep1ItemName)) {
        $scope.$broadcast('step2SearchFocus');
      } else {
        $scope.$broadcast('step1SearchFocus');
      }
    };
    this.removeSelection = function (event) {
      event.stopPropagation();
      this.change(event);
      this.dropDownPrompt = this.mode === 'forms' ? translations.selectAFormField : translations.selectAObjectProperty;
      $scope.$emit(configurationConstant.event.SELECTOR_WIDGET_UPDATED, '', {}, false, this.name);
      this.showClearIcon = false;
    };
    this.selectorMenuClick = function (event) {
      if (event.target.getAttribute('class').match('multiSelectButton')) {
        event.stopPropagation();
      }
    };
    this.multiSelectStep2Click = function (event) {
      if (event.target.getAttribute('class').match('multiSelectStep2')) {
        event.stopPropagation();
      }
    };
    this.step1SearchChange = function () {
      if (this.mode === 'objects') {
        this.step1ItemsFilter = _.filter(this.step1Items, function (item) {
          return _.lowerCase(item).indexOf(_.lowerCase(this.step1SearchValue)) !== -1;
        }.bind(this));
      } else {
        this.loadStep1Data();
      }
    };
    this.step2SearchChange = function () {
      var itemName;
      this.step2ItemsFilter = _.filter(this.step2Items, function (item) {
        itemName = item.fieldName ? item.fieldName : item.propertyName;
        return _.toUpper(itemName).indexOf(_.toUpper(this.step2SearchValue)) !== -1;
      }.bind(this));
    };
    this.change = function (event) {
      event.stopPropagation();
      this.tooltip = '';
      this.reset();
    };
    this.reset = function () {
      this.step1Items = [];
      this.step2Items = [];
      this.displayStep1Section = false;
      this.displayStep2Section = false;
      this.step1SearchValue = '';
      this.step2SearchValue = '';
      this.loadStep1Data();
      this.selectedStep1ItemName = null;
      this.selectedStep2ItemName = null;
      this.searchForStep1 = this.mode === 'forms' ? translations.searchForAForm : translations.searchForAObject;
      this.searchForStep2 = this.mode === 'forms' ? translations.searchForAField : translations.searchForAProperty;
      this.selectedStep1Label = this.mode === 'forms' ? translations.selectedForm : translations.selectedObject;
    };
    this.getItemName = function (item) {
      if (this.mode === 'forms') {
        return item.fieldName;
      } else if (this.mode === 'objects') {
        return item.propertyName;
      }
    };
    this.loadStep1Data = function () {
      if (this.mode === 'forms') {
        this.displayStep1Section = true;
        if (this.step1SearchValue !== '') {
          this.displayStep1Items = true;
          configurationMediator.getUIFormTemplatesByMatchingName(this.step1SearchValue).then(function (result) {
            this.step1ItemsFilter = result;
          }.bind(this));
        } else {
          this.displayStep1Items = false;
          this.step1ItemsFilter = [];
        }
      } else if (this.mode === 'objects') {
        this.displayStep1Section = true;
        this.displayStep1Items = true;
        configurationMediator.getObjectNames(this.step1SearchValue).then(function (result) {
          this.step1ItemsFilter = result;
          this.step1Items = result;
        }.bind(this));
      }
    };
    this.selectStep1Item = function (itemName, event) {
      if (event) {
        event.stopPropagation();
      }
      this.displayStep1Section = false;
      this.displayStep2Section = true;
      this.selectedStep1ItemName = itemName;
      this.dropDownPrompt = this.getDropDownPrompt(itemName, this.selectedStep2ItemName);
      this.showClearIcon = true;
      if (this.mode === 'forms') {
        configurationMediator.getFieldOptions(itemName).then(function (result) {
          this.step2Items = result;
          this.step2ItemsFilter = result;
          this.step2MultiItemsFilter = [];
          _.each(result, function (item) {
            var obj = {};
            obj.name = item.fieldName;
            obj.value = item.fieldName;
            this.step2MultiItemsFilter.push(obj);
          }.bind(this));
          $scope.$emit(configurationConstant.event.FORM_COMPONENT_SELECTED, this.selectedStep1ItemName, null);
        }.bind(this));
      } else if (this.mode === 'objects') {
        configurationMediator.getObjectPropertyValues(itemName).then(function (result) {
          this.step2Items = result;
          this.step2ItemsFilter = result;
        }.bind(this));
      }
    };
    this.checkStep1AndStep2Selected = function () {
      return this.dropDownPrompt === translations.selectAFormField || this.dropDownPrompt === translations.selectAFormField || this.step1AndStep2Selected;
    };
    this.selectStep2Item = function (item, event) {
      this.dropDownPrompt = this.getDropDownPrompt(this.selectedStep1ItemName, this.mode === 'forms' ? item.fieldName : item.propertyName);
      this.selectedStep2ItemName = this.getItemName(item);
      $scope.$emit(configurationConstant.event.SELECTOR_WIDGET_UPDATED, this.selectedStep1ItemName, item, false, this.name);
    };
    this.step2BoxClick = function (event) {
      if (_.isNil(event.target.getAttribute('class'))) {
        event.stopPropagation();
      }
    };
    this.getDropDownPrompt = function (item1, item2) {
      var dropDownPrompt;
      if (_.isEmpty(item2)) {
        dropDownPrompt = '(' + item1 + ')';
      } else {
        dropDownPrompt = (!_.isEmpty(item2) ? item2 + ' ' : '') + '(' + item1 + ')';
      }
      // Recalculate the tooltip here as well
      if (dropDownPrompt.length > 40) {
        this.tooltip = dropDownPrompt;
      } else {
        this.tooltip = '';
      }
      return dropDownPrompt;
    };
    this.isDropup = function () {
      var dropmenu = $('.uib-dropdown');
      if (dropmenu.offset().top + dropmenu.outerHeight() + 300 /*height of the selectorMenu*/ > $(window).innerHeight() + $(window).scrollTop()) {
        return true;
      }
      return false;
    };
    $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
      if (this.itemName === itemName) {
        this.refreshDropDownPrompt(itemName);
      }
    }.bind(this));
    $scope.$on(coreConstant.event.REFRESH_MULTI_SELECT, function (event, step1Name, step2Name, name) {
      if (name === this.name) {
        this.step1ItemName = step1Name;
        this.step2ItemName = step2Name;
        this.init();
        if (_.isEmpty(this.step1ItemName)) {
          this.dropDownPrompt = this.mode === 'forms' ? translations.selectAFormField : translations.selectAObjectProperty;
          $scope.$emit(configurationConstant.event.SELECTOR_WIDGET_UPDATED, '', {}, false, this.name);
          this.showClearIcon = false;
        }
      }
    }.bind(this));
    this.refreshDropDownPrompt = function (itemName) {
      var step2MultiList = _.filter(this.step2MultiItemsFilter, function (item) {
          return item.selected;
        }),
        truncatedNames = '',
        names = _.map(step2MultiList, 'name');
      names = _.join(names, ', ');
      truncatedNames = _.truncate(names, {
        length: 75,
        seperator: /,? +/
      });
      if (!_.isUndefined(this.selectedStep1ItemName)) {
        this.dropDownPrompt = this.getDropDownPrompt(this.selectedStep1ItemName, truncatedNames);
      }
      $scope.$emit(configurationConstant.event.SELECTOR_WIDGET_UPDATED, this.selectedStep1ItemName, names, true);
    };
    this.init();
  }.bind(this));
};
MultiStepSelectorWidgetController.$inject = ["$rootScope", "$scope", "configurationConstant", "configurationMediator", "localization", "coreConstant"];
angular.module('ums.configuration').controller('multiStepSelectorWidgetController', MultiStepSelectorWidgetController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),

/***/ 2515:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2516);
__webpack_require__(2517);
__webpack_require__(2518);
__webpack_require__(2519);
__webpack_require__(2520);
__webpack_require__(2521);
__webpack_require__(2522);
__webpack_require__(2523);
__webpack_require__(2526);

/*@ngInject*/
var OrganizationBrowserController = function OrganizationBrowserController($rootScope, $scope, $timeout, $state, $stateParams, advancedFilterType, filterType, advancedFilterMediator, coreConstant, advancedFilterModel, configurationMediator, localization, navigationStateModel, modalUtil, organizationAction, organizationBrowserActionUtil, organizationUtil, configurationActionsUtil, databaseDownloadSectionName, organizationStatus) {
  localization.getTranslationByKey('organizationBrowser').then(function (translations) {
    $scope.viewModel = {
      isLoading: true,
      filterModel: null,
      organizations: [],
      totalOrganizations: 0,
      isGridEmpty: true,
      recordCountText: _.get(translations, 'recordCountText.' + $stateParams.organizationType),
      recordsCountText: _.get(translations, 'recordsCountText.' + $stateParams.organizationType),
      requestParams: {
        key: 'name',
        startIndex: 0,
        pageSize: 25,
        sortType: 'asc'
      },
      shortDateTimeFormat: 'MM/dd/yy hh:mma',
      title: _.get(translations, 'title.' + $stateParams.organizationType),
      codeColumnHeader: _.get(translations, 'columns.code.' + $stateParams.organizationType),
      emptyGridLabel: _.get(translations, 'emptyGrid.' + $stateParams.organizationType),
      organizationTypeString: organizationUtil.getOrganizationTypeString($stateParams.organizationType)
    };
    $scope.viewModel.advancedFilterType = $scope.viewModel.organizationTypeString + ' ' + advancedFilterType.ORGANIZATION_BROWSER;
    $scope.viewModel.advancedFilterTranslationKey = $scope.viewModel.organizationTypeString + 'Browser';
    $scope.actions = [];
    $scope.hiddenInputActions = {};
    $scope.context = {
      identifier: 'organizationBrowser',
      actions: {},
      fallthrough: null,
      model: {
        contextType: coreConstant.CONTEXT_NONE
      }
    };
    $scope.context.actions[coreConstant.CONTEXT_NONE] = '';
    function loadActions() {
      configurationMediator.loadOrganizationActions($stateParams.organizationType).then(function (actions) {
        var allActions = [];
        allActions.push({
          actions: actions.actions,
          contextType: $scope.context.model.contextType
        });
        $scope.actions = allActions;
        $scope.hiddenInputActions = {};
        $scope.hiddenInputActions[organizationAction.IMPORT_CARRIER_LOAS] = 'application/xml';
        $scope.hiddenInputActions[organizationAction.IMPORT_MGA_CARRIER_LOAS] = 'application/xml';
        $scope.actionsTimeLastModified = new Date().getTime();
      });
    }
    function loadOrganizations() {
      $scope.viewModel.isLoading = true;
      configurationMediator.getOrganizationsByFilterUriAndOrganizationType($scope.viewModel.filterModel.filter.uri, $stateParams.organizationType, $scope.viewModel.requestParams).then(function (organizations) {
        _.each(organizations.records, function (organization) {
          organization.isDraftStatus = organization.status === organizationStatus.STATUS_DRAFT;
          organization.name = _.isEmpty(organization.name) ? _.get(translations, 'draftOrganizationName') : organization.name;
        });
        $scope.viewModel.organizations = organizations.records;
        $scope.viewModel.totalOrganizations = organizations.totalRecords;
        $scope.viewModel.isGridEmpty = $scope.viewModel.totalOrganizations === 0;
        $timeout(function () {
          $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
          $scope.viewModel.isLoading = false;
        }, 0);
      });
    }
    function loadFilter() {
      var existingFilterModel = advancedFilterModel.getAdvancedFilterModel($scope.viewModel.advancedFilterType);
      if (!_.isNil(existingFilterModel) && !_.isNil(existingFilterModel.filter)) {
        $scope.viewModel.filterModel = existingFilterModel;
        loadOrganizations();
      } else {
        advancedFilterMediator.getFilters(filterType.TYPE_ORGANIZATION_FILTER).then(function (filters) {
          var filter = _.first(filters);
          if (filter) {
            advancedFilterMediator.getFilterTemplates(filter.filterTemplateId).then(function (filterTemplate) {
              advancedFilterModel.buildFilter($scope.viewModel.advancedFilterType, filterTemplate, filter, true);
              $scope.viewModel.filterModel = advancedFilterModel.getAdvancedFilterModel($scope.viewModel.advancedFilterType);
              loadOrganizations();
            });
          }
        });
      }
    }
    function handleFilterSave(event, filter) {
      advancedFilterModel.getAdvancedFilterModel($scope.viewModel.advancedFilterType).filter = filter;
      $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
    }
    $scope.$on(coreConstant.event.FILTER_SAVED, handleFilterSave);
    $scope.getStatus = function (item) {
      return _.get(translations, 'status.' + item.status);
    };
    $scope.onPagingChange = function ($event, params) {
      $scope.viewModel.requestParams.startIndex = params.startIndex;
      loadOrganizations();
    };
    $scope.onSortChange = function (event, params) {
      $scope.viewModel.requestParams.key = params.key;
      $scope.viewModel.requestParams.sortType = params.sortType;
      loadOrganizations();
    };
    function resetNavigationState() {
      navigationStateModel.saveViewState('configuration.organizationBrowser.' + $scope.viewModel.organizationTypeString, null);
    }
    $scope.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case organizationAction.NEW_AGENCY_ORGANIZATION:
          case organizationAction.NEW_CARRIER_ORGANIZATION:
          case organizationAction.NEW_MGA_AGENCY_ORGANIZATION:
          case organizationAction.NEW_MGA_CARRIER_ORGANIZATION:
            organizationBrowserActionUtil.createOrganization($stateParams.organizationType);
            break;
          case organizationAction.EXPORT_CARRIER_LOAS:
            organizationBrowserActionUtil.exportCarrierLOAs(false).then(function () {
              loadActions();
            });
            break;
          case organizationAction.IMPORT_CARRIER_LOAS:
            organizationBrowserActionUtil.importCarrierLOAs(file, false).then(function () {
              loadActions();
            });
            break;
          case organizationAction.EXPORT_MGA_CARRIER_LOAS:
            organizationBrowserActionUtil.exportCarrierLOAs(true).then(function () {
              loadActions();
            });
            break;
          case organizationAction.IMPORT_MGA_CARRIER_LOAS:
            organizationBrowserActionUtil.importCarrierLOAs(file, true).then(function () {
              loadActions();
            });
            break;
          case organizationAction.BACKUP:
            configurationActionsUtil.backup(databaseDownloadSectionName.ORGANIZATIONS, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
    $scope.onClickRow = function (event, organization) {
      var navigationModel = {
        parentState: 'configuration.organizationBrowser:' + $stateParams.organizationType,
        currentState: 'configuration.manageOrganization',
        data: {
          organizationId: organization.id,
          organizationType: parseInt($stateParams.organizationType)
        }
      };
      $state.go('configuration.manageOrganization', {
        organizationId: organization.id,
        organizationType: $stateParams.organizationType
      });
      navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
    };
    loadActions();
    resetNavigationState();
    loadFilter();
  });
  $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
    $scope.$apply();
  });
};
OrganizationBrowserController.$inject = ["$rootScope", "$scope", "$timeout", "$state", "$stateParams", "advancedFilterType", "filterType", "advancedFilterMediator", "coreConstant", "advancedFilterModel", "configurationMediator", "localization", "navigationStateModel", "modalUtil", "organizationAction", "organizationBrowserActionUtil", "organizationUtil", "configurationActionsUtil", "databaseDownloadSectionName", "organizationStatus"];
angular.module('ums.configuration').controller('organizationBrowserController', OrganizationBrowserController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2516:
/***/ (function(module) {

module.exports = JSON.parse("{\"organizationBrowser\":{\"draftOrganizationName\":\"Draft\",\"title\":{\"1\":\"Manage Agencies/Brokerages\",\"2\":\"Manage Carriers\",\"3\":\"Manage MGAs\",\"4\":\"Manage MGA Agencies/Brokerages\"},\"columns\":{\"name\":\"Name\",\"city\":\"City\",\"state\":\"State\",\"parentName\":\"Parent\",\"code\":{\"1\":\"Agency Number\",\"2\":\"Carrier Code\",\"3\":\"Carrier Code\",\"4\":\"Agency Number\"},\"status\":\"Status\",\"timeLastModified\":\"Last Updated\"},\"emptyGrid\":{\"1\":\"No matching Agencies/Brokerages\",\"2\":\"No matching Carriers\",\"3\":\"No matching MGAs\",\"4\":\"No matching MGA Agencies/Brokerages\"},\"recordCountText\":{\"1\":\"Showing startIndex to endIndex of total Agency/Brokerage\",\"2\":\"Showing startIndex to endIndex of total Carrier\",\"3\":\"Showing startIndex to endIndex of total MGA\",\"4\":\"Showing startIndex to endIndex of total MGA Agency/Brokerage\"},\"recordsCountText\":{\"1\":\"Showing startIndex to endIndex of total Agencies/Brokerages\",\"2\":\"Showing startIndex to endIndex of total Carriers\",\"3\":\"Showing startIndex to endIndex of total MGAs\",\"4\":\"Showing startIndex to endIndex of total MGA Agencies/Brokerages\"},\"actions\":{\"name\":\"Actions\",\"new agency organization\":\"New Agency/Brokerage\",\"new carrier organization\":\"New Carrier\",\"new mga agency organization\":\"New MGA Agency/Brokerage\",\"new mga carrier organization\":\"New MGA\",\"importCarrierLOAs\":\"Import Carrier LOAs\",\"exportCarrierLOAs\":\"Export Carrier LOAs\",\"importMgaCarrierLOAs\":\"Import MGA Carrier LOAs\",\"exportMgaCarrierLOAs\":\"Export MGA Carrier LOAs\",\"backup\":\"Backup\"},\"status\":{\"0\":\"Inactive\",\"1\":\"Active\",\"2\":\"Draft\"},\"importCarrierLOAs\":{\"loadingBar\":\"Importing LOAs...\",\"successMessageSingular\":\"Successfully imported 1 LOA\",\"successMessagePlural\":\"Successfully imported {0} LOAs\",\"errorModal\":{\"confirmActionButtonLabel\":\"OK\",\"summary\":\"{0} LOA(s) were successfully imported, however {1} LOA(s) had failures:\\n\\n{2}\",\"title\":\"Import LOAs\"}},\"exportCarrierLOAs\":{\"loadingBar\":\"Exporting LOAs...\",\"successMessage\":\"Successfully exported LOAs\"},\"backup\":{\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\",\"name\":\"Organizations\"}},\"carrierBrowser\":{\"textInputFilter\":{\"nameOrCodeSubstring\":{\"placeholder\":\"Search Name or Code\"}}},\"agencyBrowser\":{\"textInputFilter\":{\"nameOrCodeSubstring\":{\"placeholder\":\"Search Name or Number\"}}},\"mgaAgencyBrowser\":{\"textInputFilter\":{\"nameOrCodeSubstring\":{\"placeholder\":\"Search Name or Number\"}}},\"mgaCarrierBrowser\":{\"textInputFilter\":{\"nameOrCodeSubstring\":{\"placeholder\":\"Search Name or Code\"}}}}");

/***/ }),

/***/ 2517:
/***/ (function(module, exports, __webpack_require__) {

var path = '/configuration/organizationBrowser/organizationBrowser.tpl.html';
var html = "<div class=\"organizationBrowser {{ ::viewModel.organizationTypeString }}\">\n\n    <!-- Header -->\n    <div class=\"header\">\n        <div class=\"headerContent\">\n            <div class=\"headerLabel\">{{ ::viewModel.title }}</div>\n\n            <action-buttons-bar context=\"context\"\n                                actions=\"actions\"\n                                hidden-input-actions=\"hiddenInputActions\"\n                                notify-action-clicked=\"handleAction(action, file)\"\n                                time-last-modified=\"actionsTimeLastModified\"></action-buttons-bar>\n        </div>\n    </div>\n\n    <!-- Tools -->\n    <div class=\"tools\">\n        <div class=\"toolsContent\">\n            <ui-advanced-filter-list\n                class=\"advancedFilterListWrapper\"\n                filter-model=\"viewModel.filterModel\"\n                show-all-templates=\"true\"\n                advanced-filter-type=\"viewModel.advancedFilterType\"\n                translations-key=\"viewModel.advancedFilterTranslationKey\"\n                allow-clear-filter=\"true\"\n                one-clear-filter=\"true\"\n                clear-filter-is-link=\"true\">\n            </ui-advanced-filter-list>\n        </div>\n    </div>\n\n    <!-- Grid -->\n    <div class=\"grid\">\n\n        <div class=\"gridContainer\">\n\n            <!-- Grid Header -->\n            <div class=\"columnHeader\">\n\n                <div class=\"columnRow\">\n\n                    <div class=\"colHover\"></div>\n\n                    <div class=\"colName\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"name\"\n                         item-label=\"organizationBrowser.columns.name\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colCity\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"city\"\n                         item-label=\"organizationBrowser.columns.city\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colState\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"state\"\n                         item-label=\"organizationBrowser.columns.state\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colParent\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"parentName\"\n                         item-label=\"organizationBrowser.columns.parentName\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colCode\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"code\"\n                         item-label=\"{{ ::viewModel.codeColumnHeader }}\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colStatus\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"status\"\n                         item-label=\"organizationBrowser.columns.status\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colTimeLastModified\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"timeLastModified\"\n                         item-label=\"organizationBrowser.columns.timeLastModified\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                </div>\n            </div>\n\n\n            <div class=\"datagrid table\"\n                 ux-datagrid=\"viewModel.organizations\"\n                 ng-if=\"!viewModel.isLoading\"\n                 ui-scroll-detection\n                 ui-scroll-detection-target=\".columnHeader\">\n\n                <script type=\"template/html\"\n                        data-template-item=\"item\"\n                        data-template-name=\"default\">\n\n                    <div class=\"columnRow\">\n\n                        <div class=\"columnRowWrapper\">\n\n                            <div class=\"col colName\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.name }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.nameTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.nameTooltip\">{{ ::item.name }}</span>\n                            </div>\n\n                            <div class=\"col colCity\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.city }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.cityTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.cityTooltip\">{{ ::item.city }}</span>\n                            </div>\n\n                            <div class=\"col colState\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.state }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.stateTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.stateTooltip\">{{ ::item.state }}</span>\n                            </div>\n\n                            <div class=\"col colParent\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.parentName }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.parentNameTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.parentNameTooltip\">{{ ::item.parentName }}</span>\n                            </div>\n\n                            <div class=\"col colCode\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.code }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.codeTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.codeTooltip\">{{ ::item.code }}</span>\n                            </div>\n\n                            <div class=\"col colStatus\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::getStatus(item) }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.statusTooltip }}\"\n                                      ng-class=\"{'draftStatus': item.isDraftStatus}\"\n                                      ui-is-tooltip-enabled=\"item.statusTooltip\">{{ ::getStatus(item) }}</span>\n                            </div>\n\n                            <div class=\"col colTimeLastModified\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.timeLastModified | date: viewModel.shortDateTimeFormat }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.timeLastModifiedTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.timeLastModifiedTooltip\">{{ ::item.timeLastModified | date: viewModel.shortDateTimeFormat }}</span>\n                            </div>\n                        </div>\n                    </div>\n                </script>\n            </div>\n\n            <ui-grid-paging-component\n                ng-hide=\"viewModel.totalOrganizations === 0\"\n                start-index=\"viewModel.requestParams.startIndex\"\n                page-size=\"viewModel.requestParams.pageSize\"\n                total-records=\"viewModel.totalOrganizations\"\n                record-count-text=\"viewModel.recordCountText\"\n                records-count-text=\"viewModel.recordsCountText\"\n                on-change=\"onPagingChange($event, params)\"></ui-grid-paging-component>\n\n            <div class=\"gridEmpty\"\n                 ng-if=\"viewModel.isGridEmpty && !viewModel.isLoading\">{{ ::viewModel.emptyGridLabel }}\n            </div>\n\n            <div class=\"icon-spinner\"\n                 ng-if=\"viewModel.isLoading\">\n                <img src=\"" + __webpack_require__(52) + "\"/>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2518:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var OrganizationBrowserActionRepository = function OrganizationBrowserActionRepository(baseRepository, organizationUtil, temporaryLoginTokenRepository) {
  angular.extend(this, baseRepository);
  this.loadActions = function (organizationType, organizationId) {
    var id = _.isNil(organizationId) ? null : organizationId,
      url = '/rest/Actions',
      config = {
        params: {
          uri: organizationUtil.getOwnerUri(organizationType, organizationId),
          registrationIdentifier: !_.isNil(organizationId) ? '/Organization/' + organizationId : null
        }
      };
    return this.get(url, config);
  };
  this.createNewOrganization = function (organizationType) {
    var url = '/rest/Organization/create',
      body = {},
      config = {
        params: {
          organizationType: organizationType
        }
      };
    return this.post(url, body, config);
  };
  this.importCarrierLOAs = function (file, isMga) {
    var _this = this;
    var url = '/importLOA/CarrierLOAImportServlet',
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        params: {
          fileName: file.name,
          size: file.size,
          isMga: isMga
        },
        // When you assign undefined, the content type defaults to multipart/form-data
        headers: {
          'Content-Type': undefined
        }
      };
    formData.append('file', file);
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this.post(url, formData, config);
    });
  };
  this.exportCarrierLOAs = function (isMga) {
    var _this2 = this;
    var url = '/exportLOA/CarrierLOAExportServlet',
      config = {
        params: {
          isMga: isMga
        }
      };
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this2.get(url, config);
    });
  };
};
OrganizationBrowserActionRepository.$inject = ["baseRepository", "organizationUtil", "temporaryLoginTokenRepository"];
angular.module('ums.configuration').service('organizationBrowserActionRepository', OrganizationBrowserActionRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2519:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var OrganizationBrowserActionUtil = function OrganizationBrowserActionUtil($rootScope, $state, configurationMediator, coreConstant, modalUtil, localization, loadingBarHandler, fileExportUtil) {
  var _this = this;
  localization.getTranslationByKey('organizationBrowser').then(function (translations) {
    _this.createOrganization = function (organizationType) {
      var promise = configurationMediator.createNewOrganization(organizationType).then(function (organization) {
        $state.go('configuration.manageOrganization', {
          organizationId: organization.id,
          organizationType: organizationType
        });
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    };
    _this.importCarrierLOAs = function (file, isMga) {
      var promise;
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'importCarrierLOAs.loadingBar'));
      promise = configurationMediator.importCarrierLOAs(file, isMga).then(function (result) {
        var resultSplits = _.split(result, '\n'),
          successfulImports = parseInt(_.trim(resultSplits[1].substring(_.indexOf(resultSplits[1], '-') + 1))),
          failedImports = parseInt(_.trim(resultSplits[2].substring(_.indexOf(resultSplits[2], '-') + 1))),
          failedReasons,
          config,
          summary;
        if (failedImports === 0) {
          loadingBarHandler.concludeNotificationLoadingBar(_.replace(_.get(translations, 'importCarrierLOAs.' + (successfulImports === 1 ? 'successMessageSingular' : 'successMessagePlural')), '{0}', successfulImports));
        } else {
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);

          // Remove the first 4 entries of the resultSplits array, which is everything except the failed reasons,
          // then join those reasons back together to display in the client:
          resultSplits.splice(0, 4);
          failedReasons = _.join(resultSplits, '\n');
          summary = _.get(translations, 'importCarrierLOAs.errorModal.summary');
          summary = _.replace(summary, '{0}', successfulImports);
          summary = _.replace(summary, '{1}', failedImports);
          summary = _.replace(summary, '{2}', failedReasons);
          config = {
            confirmActionButtonLabel: _.get(translations, 'importCarrierLOAs.errorModal.confirmActionButtonLabel'),
            summary: summary,
            title: _.get(translations, 'importCarrierLOAs.errorModal.title')
          };
          modalUtil.showGenericConfirm(config);
        }
      }, function () {
        // On Error
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    };
    _this.exportCarrierLOAs = function (isMga) {
      var promise;
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'exportCarrierLOAs.loadingBar'));
      promise = configurationMediator.exportCarrierLOAs(isMga).then(function (result) {
        var filename = 'carrierLOAExport.xml';
        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'exportCarrierLOAs.successMessage'));
        fileExportUtil.saveAs(result, 'application/xml', filename);
      }, function () {
        // On Error
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    };
  });
};
OrganizationBrowserActionUtil.$inject = ["$rootScope", "$state", "configurationMediator", "coreConstant", "modalUtil", "localization", "loadingBarHandler", "fileExportUtil"];
angular.module('ums.configuration').service('organizationBrowserActionUtil', OrganizationBrowserActionUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2520:
/***/ (function(module, exports) {

/*@ngInject*/
var OrganizationRepository = function OrganizationRepository($q, baseRepository, databaseDownloadSectionName, temporaryLoginTokenRepository) {
  angular.extend(this, baseRepository);
  var closeOrganizationPersistentConnectionPromises = {};
  this.getOrganizationsByFilterUriAndOrganizationType = function (filterUri, organizationType, requestParams) {
    var url = '/rest/Organization/filter',
      config = {
        params: {
          filterUri: filterUri,
          organizationType: organizationType,
          sortBy: requestParams.key,
          sortDirection: requestParams.sortType,
          startIndex: requestParams.startIndex,
          numberOfRows: requestParams.pageSize
        }
      };
    return this.get(url, config);
  };
  this.loadOrganizationById = function (organizationId) {
    var _this = this;
    var url = "/rest/Organization/".concat(organizationId),
      config = {
        params: {
          registrationIdentifier: "/Organization/".concat(organizationId)
        }
      },
      closeOrganizationPersistentConnectionPromise = closeOrganizationPersistentConnectionPromises[organizationId] || $q.when();
    return closeOrganizationPersistentConnectionPromise.then(function () {
      return _this.get(url, config);
    });
  };
  this.closeOrganizationPersistentConnection = function (organizationId) {
    var url = "/rest/Organization/".concat(organizationId, "/List"),
      config = {
        params: {
          registrationIdentifier: "/Organization/".concat(organizationId)
        }
      },
      promise = this.delete(url, config);
    closeOrganizationPersistentConnectionPromises[organizationId] = promise;
    return promise;
  };
  this.upgradeForms = function (organizationId) {
    var url = "/rest/Organization/".concat(organizationId, "/upgradeForms");
    return this.post(url);
  };
  this.getForms = function (organizationId) {
    var url = "/rest/Organization/".concat(organizationId, "/formSummaries");
    return this.get(url);
  };
  this.backupOrganizations = function () {
    var _this2 = this;
    var url = '/database/DatabaseDownloadServlet',
      config = {
        params: {
          sectionName: databaseDownloadSectionName.ORGANIZATIONS
        }
      };
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this2.get(url, config);
    });
  };
};
OrganizationRepository.$inject = ["$q", "baseRepository", "databaseDownloadSectionName", "temporaryLoginTokenRepository"];
angular.module('ums.configuration').service('organizationRepository', OrganizationRepository);

/***/ }),

/***/ 2521:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var OrganizationStateModel = function OrganizationStateModel($rootScope, $state) {
  var stateModelStorage, organizationId, organizationType, organizationForm, isVisibleForChat;
  this.init = function () {
    stateModelStorage = {};
    organizationId = null;
    organizationType = null;
    organizationForm = null;
    isVisibleForChat = true;
  };
  this.saveViewState = function (stateName, stateModel) {
    stateModelStorage[stateName] = _.cloneDeep(stateModel);
  };
  this.restoreViewState = function (stateName, viewModel) {
    var previousState = stateModelStorage[stateName];
    if (previousState) {
      _.merge(viewModel, previousState);
    }
  };
  this.getPreviousViewState = function (stateName) {
    return stateModelStorage[stateName];
  };
  this.savePreviousOrganization = function (id, type, formId) {
    organizationId = id;
    organizationType = type;
    organizationForm = formId;
  };
  this.getPreviousOrganization = function () {
    return {
      organizationId: organizationId,
      organizationType: organizationType,
      formId: organizationForm
    };
  };
  this.hasPreviousOrganization = function () {
    return organizationId !== null;
  };
  this.resetPreviousOrganization = function () {
    organizationId = null;
    organizationType = null;
    organizationForm = null;
    delete stateModelStorage[$state.name];
  };
  this.init();
};
OrganizationStateModel.$inject = ["$rootScope", "$state"];
angular.module('ums.configuration').service('organizationStateModel', OrganizationStateModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2522:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var OrganizationUtil = function OrganizationUtil(organizationType) {
  var organizationTypeToOrganizationTypeString = {};
  organizationTypeToOrganizationTypeString[organizationType.AGENCY] = organizationType.AGENCY_STRING;
  organizationTypeToOrganizationTypeString[organizationType.CARRIER] = organizationType.CARRIER_STRING;
  organizationTypeToOrganizationTypeString[organizationType.MGA_AGENCY] = organizationType.MGA_AGENCY_STRING;
  organizationTypeToOrganizationTypeString[organizationType.MGA_CARRIER] = organizationType.MGA_CARRIER_STRING;
  this.getOrganizationTypeString = function (type) {
    return organizationTypeToOrganizationTypeString[type];
  };
  this.getTitleFromStateParam = function (paramOrganizationType) {
    var agency = 'organization.manageAgencies',
      carrier = 'organization.manageCarriers',
      mgaAgency = 'organization.manageMGAAgencies',
      mgaCarrier = 'organization.manageMGACarriers',
      result;
    switch (paramOrganizationType) {
      case organizationType.AGENCY:
        result = agency;
        break;
      case organizationType.CARRIER:
        result = carrier;
        break;
      case organizationType.MGA_AGENCY:
        result = mgaAgency;
        break;
      case organizationType.MGA_CARRIER:
        result = mgaCarrier;
        break;
    }
    return result;
  };
  this.getOwnerUri = function (type, organizationId) {
    var agency = 'com.firstbest.underwriting.agent.Agency:',
      carrier = 'com.firstbest.underwriting.carrier.Carrier:',
      result;
    type = parseInt(type);
    switch (type) {
      case organizationType.AGENCY:
      case organizationType.MGA_AGENCY:
        result = agency;
        break;
      case organizationType.CARRIER:
      case organizationType.MGA_CARRIER:
        result = carrier;
        break;
    }
    result += !_.isNil(organizationId) ? organizationId : organizationTypeToOrganizationTypeString[type];
    return result;
  };
  this.isValidNavigationItem = function (item) {
    return item.formTemplateAllowDirectNavigation && item.root;
  };
};
OrganizationUtil.$inject = ["organizationType"];
angular.module('ums.configuration').service('organizationUtil', OrganizationUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2523:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2524);
__webpack_require__(2525);
var OrganizationMenuComponent = {
  templateUrl: '/configuration/organizationBrowser/menu/organizationMenu.tpl.html',
  controller: 'organizationMenuController',
  bindings: {
    organizationId: '<',
    defaultSelectedValue: '<',
    onSelectedItemChange: '&',
    onMenuHasSingleItem: '&',
    onMenuHasMultipleItems: '&'
  }
};
angular.module('ums.configuration').component('uiOrganizationMenu', OrganizationMenuComponent);

/***/ }),

/***/ 2524:
/***/ (function(module, exports) {

var path = '/configuration/organizationBrowser/menu/organizationMenu.tpl.html';
var html = "<ui-collapsible-left-nav collapsible=\"false\"\n                         ng-class=\"{ open: $ctrl}\">\n    <ui-accordion-button ng-repeat=\"item in $ctrl.navigationItemList\"\n                         label=\"item.formTemplateDisplayName || item.name\"\n                         value=\"item.id\"\n                         has-children=\"$ctrl.hasChildren(item)\"\n                         is-open=\"$ctrl.isItemOpen(item)\"\n                         notify-accordion-button-click=\"$ctrl.onNavItemClick(value)\"\n                         is-active=\"$ctrl.selectedItem && $ctrl.selectedItem.id === item.id\"\n                         required-field-count=\"item.requiredFieldCount\"\n                         on-required-field-count-click=\"$ctrl.onRequiredIndicatorClicked($event, item)\"\n                         ng-class=\"{open: $ctrl.isItemOpen(item)}\">\n\n        <div class=\"navigationRow\"\n             ng-repeat=\"childItem in item.children\"\n             ng-class=\"{ 'selected': $ctrl.isActive(childItem)}\">\n\n            <button class=\"btn-link navigationLabel \"\n\n                    ng-click=\"$ctrl.onNavChildItemClick(childItem)\"\n                    ng-class=\"{ 'active': $ctrl.isActive(childItem)}\">\n                <div class=\"activeBar\"></div>\n                <span class=\"buttonLabel\">{{ ::childItem.formTemplateDisplayName }}</span>\n            </button>\n            <div class=\"requiredFieldContainer\"\n                 ng-click=\"$ctrl.onRequiredIndicatorClicked($event, childItem)\">\n                <div class=\"label label-warning\"\n                     ng-if=\"childItem.requiredFieldCount > 0\" ng-bind=\"childItem.requiredFieldCount\"></div>\n            </div>\n        </div>\n    </ui-accordion-button>\n</ui-collapsible-left-nav>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2525:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var OrganizationMenuController = function OrganizationMenuController($rootScope, $scope, $element, $state, $stateParams, coreConstant, loadingBarHandler, localization, manageOrganizationMediator, formViewerConstant, organizationUtil) {
  $element.addClass('organizationMenu');
  this.navigationItemList = [];
  this.selectedItem = null;
  this.$onInit = function () {
    var _this = this;
    localization.getTranslations().then(function (translations) {
      _this.processList = function (formSummaries) {
        var _this2 = this;
        formSummaries = _.filter(formSummaries, organizationUtil.isValidNavigationItem);
        var groupedList = _.groupBy(formSummaries, function (formSummary) {
          return _.get(translations, 'organization.manage.formTemplateType.' + formSummary.formTemplateType);
        });
        this.navigationItemList = [];
        if (formSummaries.length === 1) {
          this.onMenuHasSingleItem();
        } else {
          this.onMenuHasMultipleItems();
        }
        _.each(groupedList, function (item) {
          var itemToPush,
            selectedChild = null;
          if (item.length === 1) {
            itemToPush = item[0];
          } else {
            itemToPush = {
              name: _.get(translations, 'organization.manage.formTemplateType.' + item[0].formTemplateType),
              children: item,
              isOpen: false
            };
          }
          if (!_.isNil(itemToPush)) {
            if (!_.isNil(itemToPush.totalRequiredFieldCount)) {
              itemToPush.requiredFieldCount = itemToPush.totalRequiredFieldCount;
            }
            var requiredFieldCount = 0;
            if ($stateParams.formId) {
              if (itemToPush.id && $stateParams.formId === itemToPush.id.toString()) {
                _this2.selectedItem = itemToPush;
              } else if (itemToPush.children) {
                _.each(itemToPush.children, function (item) {
                  if (!_.isNil(item.totalRequiredFieldCount)) {
                    item.requiredFieldCount = item.totalRequiredFieldCount;
                  }
                  requiredFieldCount += item.requiredFieldCount;
                  if (item.id && $stateParams.formId === item.id.toString()) {
                    selectedChild = item;
                  }
                });
                if (selectedChild) {
                  _this2.selectedItem = selectedChild;
                }
                itemToPush.requiredFieldCount = requiredFieldCount;
              }
            } else if (itemToPush.children) {
              _.each(itemToPush.children, function (item) {
                if (!_.isNil(item.totalRequiredFieldCount)) {
                  item.requiredFieldCount = item.totalRequiredFieldCount;
                }
                requiredFieldCount += item.requiredFieldCount;
              });
              itemToPush.requiredFieldCount = requiredFieldCount;
            }
            _this2.navigationItemList.push(itemToPush);
          }
        });
      };
    });
    $scope.$on(coreConstant.event.UPDATE_ORGANIZATION, function (event, result) {
      if (result.id === _this.organizationId) {
        _this.getOrganizationForms();
      }
    });
    $scope.$on(formViewerConstant.event.FORM_DATA_READY, function (event, fieldModel) {
      _this.getOrganizationForms();
    });
    $scope.$on(formViewerConstant.event.UPDATE_ROOT_FORM, function (event, fieldModel) {
      _this.getOrganizationForms();
    });
    this.loadOrganizationForms();
  };
  this.onRequiredIndicatorClicked = function (event, navItem) {
    var isChangingState = false;
    if (navItem.children) {
      isChangingState = navItem.id !== this.selectedItem.id;
      _.each(navItem.children, function (item) {
        if (item.requiredFieldCount > 0) {
          navItem = item;
          return false;
        }
      });
    } else {
      isChangingState = navItem.id !== this.selectedItem.id;
    }
    this.onNavChildItemClick(navItem);
    if (isChangingState) {
      $rootScope.$broadcast('showNextRequiredFieldAfterFormLoad');
      $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD_AFTER_FORM_LOAD);
    } else {
      $rootScope.$broadcast('showNextRequiredField');
      $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD, navItem.id.toString());
    }
  };
  this.validatedSelectedItem = function () {
    function isItemInList(itemList, targetValue) {
      var _this3 = this;
      var result = false;
      _.each(itemList, function (item) {
        if (item.id === targetValue) {
          result = true;
        } else if (item.children) {
          result = isItemInList.call(_this3, item.children, targetValue);
        }
      });
      return result;
    }
    if (!this.selectedItem) {
      if (this.defaultSelectedValue) {
        this.selectedItem = _.find(this.navigationItemList, {
          id: this.defaultSelectedValue
        });
      } else {
        this.selectedItem = this.navigationItemList[0];
      }
    } else {
      var selectedItemExists = isItemInList.call(this, this.navigationItemList, this.selectedItem.id);
      if (!selectedItemExists) {
        this.selectedItem = this.navigationItemList[0];
      }
    }
  };
  this.onNavItemClick = function (itemValue) {
    var item = _.find(this.navigationItemList, function (navigationItem) {
      return navigationItem.id === itemValue;
    });
    if (!item.children) {
      this.notifyChange(item);
    }
  };
  this.onNavChildItemClick = function (item) {
    this.notifyChange(item);
  };
  this.notifyChange = function (item) {
    this.selectedItem = item;
    this.onSelectedItemChange({
      datasetItem: this.selectedItem
    });
  };
  this.hasChildren = function (item) {
    return !_.isEmpty(item.children);
  };
  this.isActive = function (childItem) {
    return this.defaultSelectedValue === parseInt(childItem.id);
  };
  this.isItemOpen = function (item) {
    var _this4 = this;
    var result = false;
    if (item.id === this.defaultSelectedValue && this.hasChildren(item)) {
      result = true;
    } else {
      _.each(item.children, function (item) {
        if (item.id === _this4.defaultSelectedValue) {
          result = true;
        }
      });
    }
    return result;
  };
  this.getOrganizationForms = function () {
    var _this5 = this;
    return manageOrganizationMediator.getForms(this.organizationId).then(function (result) {
      _this5.processList(result);
    });
  };
  this.loadOrganizationForms = function () {
    var _this6 = this;
    loadingBarHandler.showLoadingBar();
    this.getOrganizationForms().then(function () {
      _this6.validatedSelectedItem();
      if (_this6.selectedItem) {
        _this6.notifyChange(_this6.selectedItem);
      }
      loadingBarHandler.hideLoadingBar();
    });
  };
};
OrganizationMenuController.$inject = ["$rootScope", "$scope", "$element", "$state", "$stateParams", "coreConstant", "loadingBarHandler", "localization", "manageOrganizationMediator", "formViewerConstant", "organizationUtil"];
angular.module('ums.configuration').controller('organizationMenuController', OrganizationMenuController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2526:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2527);
__webpack_require__(2528);
__webpack_require__(2529);
__webpack_require__(2530);
__webpack_require__(2531);
__webpack_require__(2532);
__webpack_require__(2533);
__webpack_require__(2534);
__webpack_require__(2535);
__webpack_require__(2536);

/*@ngInject*/
var ManageOrganizationController = function ManageOrganizationController($rootScope, $scope, $state, $stateParams, coreConstant, coreMediator, formSetMediator, formViewerConstant, loadingBarHandler, localization, modalUtil, navigationStateModel, organizationAction, organizationActionUtil, manageOrganizationMediator, organizationType, organizationStatus, organizationUtil) {
  localization.getTranslations().then(function (translations) {
    $scope.viewModel = {
      organization: null,
      organizationType: parseInt($stateParams.organizationType),
      formId: parseInt($stateParams.formId),
      formName: null,
      organizationId: $stateParams.organizationId,
      showFormNavigation: true,
      backButtonLabel: _.get(translations, 'organizationBrowser.title.' + $stateParams.organizationType)
    };
    $scope.actions = [];
    $scope.context = {
      identifier: 'organization',
      actions: {},
      fallthrough: null,
      model: {
        contextType: coreConstant.CONTEXT_NONE
      }
    };
    $scope.context.actions[coreConstant.CONTEXT_NONE] = '';
    function loadActions() {
      manageOrganizationMediator.loadOrganizationActions($stateParams.organizationType, $stateParams.organizationId).then(function (actions) {
        processActions(actions);
      });
    }
    function processActions(actions) {
      var allActions = [];
      allActions.push({
        actions: actions.actions,
        contextType: $scope.context.model.contextType
      });
      $scope.actions = allActions;
      $scope.actionsTimeLastModified = new Date().getTime();
    }
    $scope.upgradeForms = function () {
      if (!_.isNaN($scope.viewModel.formId)) {
        loadingBarHandler.showLoadingBar('loadingBar.defaultMessage');
        manageOrganizationMediator.upgradeForms($stateParams.organizationId).then(function (numberOfFormsUpgraded) {
          loadActions();
          if (numberOfFormsUpgraded > 0) {
            var formsText = numberOfFormsUpgraded === 1 ? _.get(translations, 'formsViewer.formUpgrade.singularMessage') : _.get(translations, 'formsViewer.formUpgrade.pluralMessage');
            var message = _.get(translations, 'formsViewer.formUpgrade.message');
            message = _.replace(message, '{1}', numberOfFormsUpgraded);
            message = _.replace(message, '{2}', formsText);
            modalUtil.showGenericConfirm({
              title: _.get(translations, 'formsViewer.formUpgrade.title'),
              summary: message,
              confirmActionButtonLabel: _.get(translations, 'formsViewer.formUpgrade.confirmActionButtonLabel')
            }).then(function () {
              $state.reload();
            });
          }
        }).finally(function () {
          loadingBarHandler.hideLoadingBar();
        });
      }
    };
    $scope.onSelectedFormChange = function (datasetItem) {
      var formId = datasetItem.id,
        upgradeForms = _.isNaN($scope.viewModel.formId);
      $state.go('configuration.manageOrganization.form', {
        formId: formId
      });
      $scope.viewModel.formId = formId;
      $scope.viewModel.formName = datasetItem.name;
      manageOrganizationMediator.savePreviousOrganization($scope.viewModel.organization.id, $scope.viewModel.organizationType, $scope.viewModel.formId);
      if (upgradeForms) {
        $scope.upgradeForms();
      }
    };
    $scope.navigateToOrganizationList = function () {
      $state.go('configuration.organizationBrowser', {
        organizationType: $stateParams.organizationType
      });
      manageOrganizationMediator.resetPreviousOrganization();
      navigationStateModel.saveViewState('configuration.organizationBrowser:' + $stateParams.organizationType, null);
    };
    $scope.onMenuHasSingleItem = function () {
      $scope.viewModel.showFormNavigation = false;
    };
    $scope.onMenuHasMultipleItems = function () {
      $scope.viewModel.showFormNavigation = true;
    };
    $scope.getOrganizationStatus = function () {
      if (!_.isNil($scope.viewModel.organization)) {
        return _.get(translations, 'organization.manage.status.' + $scope.viewModel.organization.status);
      } else {
        return '';
      }
    };
    $scope.organizationStatusIsInactive = function () {
      if (!_.isNil($scope.viewModel.organization)) {
        return $scope.viewModel.organization.status === 0;
      } else {
        return false;
      }
    };
    $scope.$on(coreConstant.event.UPDATE_ORGANIZATION, function (event, organization) {
      if (organization.id === parseInt($stateParams.organizationId)) {
        $scope.viewModel.organization = organization;
        $scope.viewModel.organization.isDraftStatus = organization.status === organizationStatus.STATUS_DRAFT;
      }
    });
    $scope.$on(coreConstant.event.DELETE_ORGANIZATION, function (event, organization) {
      if (organization.id === parseInt($stateParams.organizationId)) {
        $scope.navigateToOrganizationList();
      }
    });
    $scope.$on('$destroy', function () {
      manageOrganizationMediator.closeOrganizationPersistentConnection($stateParams.organizationId);
    });
    manageOrganizationMediator.loadOrganizationById($stateParams.organizationId).then(function (organization) {
      $scope.viewModel.organization = organization;
      $scope.viewModel.organization.isDraftStatus = organization.status === organizationStatus.STATUS_DRAFT;
    });
    $scope.$on(coreConstant.event.UPDATE_ACTIONS_MESSAGE, function (event, updateActionsMessage, entityType, entityId) {
      if ((entityType === organizationType.AGENCY_STRING || entityType === organizationType.CARRIER_STRING || entityType === organizationType.MGA_CARRIER_STRING || entityType === organizationType.MGA_AGENCY_STRING) && parseInt($stateParams.organizationId) === entityId) {
        processActions(updateActionsMessage.actions);
      }
    });

    /*
     * reloadOrganization redisplays the organization's forms.
     * if formId or formName is specified, then the form with
     * that id or name is displayed; otherwise, the first form
     * is displayed.
     * The reason for specifying a form name is that some actions
     * (e.g., "Edit", "Discard", "Save") return a different set
     * of forms because of the carrier's modification-form-set.
     */
    function reloadOrganization(formId, formName) {
      manageOrganizationMediator.getForms($scope.viewModel.organizationId).then(function (result) {
        var nextFormId;
        result = _.filter(result, organizationUtil.isValidNavigationItem);
        nextFormId = result[0].id;
        if (formId || formName) {
          _.each(result, function (item) {
            if (item.id === formId || item.name === formName) {
              nextFormId = item.id;
              return false;
            }
            return true;
          });
        }
        $state.go('configuration.manageOrganization.form', {
          formId: nextFormId
        }, {
          reload: true
        });
      });
    }
    function performOrganizationFormSetChanges(organizationActionType) {
      var promise = organizationActionUtil.getFormSetId($stateParams.organizationId).then(function (formSetId) {
        function handleDiscardConfirm() {
          loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'organization.discardOrganizationChangesLoadingBar'));
          var promise = formSetMediator.discardChanges(formSetId).then(function () {
            reloadOrganization($scope.viewModel.formId, $scope.viewModel.formName);
            loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'organization.discardOrganizationChangesSuccessLoadingBar'));
          });
          $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
          return promise;
        }
        if (organizationActionType === organizationAction.EDIT) {
          var _promise = formSetMediator.startChanges(formSetId).then(function () {
            reloadOrganization($scope.viewModel.formId, $scope.viewModel.formName);
          });
          $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, _promise);
        } else if (organizationActionType === organizationAction.SAVE_CHANGES) {
          loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'organization.saveOrganizationChangesLoadingBar'));
          var _promise2 = formSetMediator.applyChanges(formSetId).then(function () {
            reloadOrganization($scope.viewModel.formId, $scope.viewModel.formName);
            loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'organization.saveOrganizationChangesSuccessLoadingBar'));
          });
          $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, _promise2);
        } else if (organizationActionType === organizationAction.CANCEL_EDIT) {
          modalUtil.showConfirmationModal(null, null, null, 'organization.discard', null, /*hideLoadingBar*/true, handleDiscardConfirm);
        }
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
    }
    $scope.handleAction = function (action) {
      if (action.enabled) {
        switch (action.name) {
          case organizationAction.ACTIVATE:
            organizationActionUtil.activateOrganization($stateParams.organizationId, false).then(function () {
              $state.reload();
            });
            break;
          case organizationAction.CANCEL:
            organizationActionUtil.cancel($stateParams.organizationId);
            break;
          case organizationAction.DEACTIVATE:
            organizationActionUtil.deactivateOrganization($stateParams.organizationId, false);
            break;
          case organizationAction.EDIT:
            performOrganizationFormSetChanges(organizationAction.EDIT);
            break;
          case organizationAction.SAVE_CHANGES:
            performOrganizationFormSetChanges(organizationAction.SAVE_CHANGES);
            break;
          case organizationAction.CANCEL_EDIT:
            performOrganizationFormSetChanges(organizationAction.CANCEL_EDIT);
            break;
          case organizationAction.EDIT_EMAIL_SIGNATURE:
            organizationActionUtil.editEmailSignature($scope.viewModel.organization);
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
    $scope.$on(coreConstant.event.RELOAD_ACTIONS, function () {
      loadActions();
    });
    $scope.upgradeForms();
  });
};
ManageOrganizationController.$inject = ["$rootScope", "$scope", "$state", "$stateParams", "coreConstant", "coreMediator", "formSetMediator", "formViewerConstant", "loadingBarHandler", "localization", "modalUtil", "navigationStateModel", "organizationAction", "organizationActionUtil", "manageOrganizationMediator", "organizationType", "organizationStatus", "organizationUtil"];
angular.module('ums.configuration').controller('manageOrganizationController', ManageOrganizationController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2527:
/***/ (function(module) {

module.exports = JSON.parse("{\"organization\":{\"actions\":{\"name\":\"Actions\",\"deactivate\":\"Deactivate\",\"cancel\":\"Cancel\",\"activate\":\"Activate\",\"startChanges\":\"Edit\",\"applyChanges\":\"Save\",\"discardChanges\":\"Discard\",\"editEmailSignature\":\"Email Signature\"},\"cancelModal\":{\"cancel\":\"No\",\"confirm\":\"Yes\",\"summary\":\"Are you sure you want to delete this organization?\",\"title\":\"Delete Organization\",\"loadingBar\":\"Deleting organization...\"},\"deactivateModal\":{\"cancel\":\"No\",\"confirm\":\"Yes\",\"summary\":\"Are you sure you want to deactivate this organization?\",\"title\":\"Deactivate Organization\"},\"discard\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"success\":\"Your changes have been discarded.\"},\"discardOrganizationChangesLoadingBar\":\"Discarding changes\",\"discardOrganizationChangesSuccessLoadingBar\":\"Successfully discarded changes\",\"activateOrganizationChangesLoadingBar\":\"Activating organization\",\"activateOrganizationChangesSuccessLoadingBar\":\"Successfully activated organization\",\"deactivateOrganizationChangesLoadingBar\":\"Deactivating organization\",\"deactivateOrganizationChangesSuccessLoadingBar\":\"Successfully deactivated organization\",\"dropdown\":{\"label\":\"Organizations\"},\"manage\":{\"backButton\":\"Back\",\"statusLabel\":\"Status\",\"status\":{\"0\":\"Inactive\",\"1\":\"Active\",\"2\":\"Draft\"},\"formTemplateType\":{\"13\":\"Agency/Brokerage Authority\",\"21\":\"Carrier Authority\",\"43\":\"Organization Form\"}},\"saveOrganizationChangesLoadingBar\":\"Saving organization\",\"saveOrganizationChangesSuccessLoadingBar\":\"Successfully saved organization\"}}");

/***/ }),

/***/ 2528:
/***/ (function(module, exports) {

var path = '/configuration/organizationBrowser/manageOrganization/manageOrganization.tpl.html';
var html = "<div class=\"manageOrganization\">\n\n    <!--Header-->\n    <div class=\"header\">\n\n        <div class=\"organizationInfo\">\n\n            <div class=\"leftColumn\">\n                <button class=\"btn btn-link backButton\"\n                        ng-click=\"navigateToOrganizationList()\">\n                    <span class=\"glyphicon glyphicon-arrow-left\"></span>\n                    <span>{{ ::viewModel.backButtonLabel }}</span>\n                </button>\n\n                <span class=\"organizationName\">{{ viewModel.organization.name }}</span>\n            </div>\n\n            <div class=\"organizationStatus\">\n                <span class=\"statusLabel\">\n                    <span ui-translate>organization.manage.statusLabel</span>:</span>\n                <span class=\"currentStatus\"\n                      ng-class=\"{ 'inactiveOrganization': organizationStatusIsInactive(), 'draftStatus': viewModel.organization.isDraftStatus }\"\n                      ng-bind=\"getOrganizationStatus()\"></span>\n            </div>\n        </div>\n\n        <action-buttons-bar context=\"context\"\n                            actions=\"actions\"\n                            notify-action-clicked=\"handleAction(action, file)\"\n                            time-last-modified=\"actionsTimeLastModified\"></action-buttons-bar>\n    </div>\n\n    <div class=\"bottomContent\">\n\n        <!--Form Navigation-->\n        <div class=\"formNavigation\"\n             ng-show=\"viewModel.showFormNavigation\">\n\n            <ui-organization-menu\n                ng-if=\"viewModel.organization\"\n                organization-id=\"viewModel.organization.id\"\n                default-selected-value=\"viewModel.formId\"\n                on-selected-item-change=\"onSelectedFormChange(datasetItem)\"\n                on-menu-has-single-item=\"onMenuHasSingleItem()\"\n                on-menu-has-multiple-items=\"onMenuHasMultipleItems()\">\n            </ui-organization-menu>\n\n        </div>\n\n        <!--Form-->\n        <div class=\"organizationFormContainer\" ui-view=\"mainContent\"></div>\n\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2529:
/***/ (function(module, exports) {

/*@ngInject*/
var ManageOrganizationMediator = function ManageOrganizationMediator(organizationBrowserActionRepository, organizationRepository, organizationStateModel) {
  this.loadOrganizationList = function (params) {
    return organizationRepository.loadOrganizationList(params);
  };
  this.createNewOrganization = function (organizationType) {
    return organizationRepository.createNewOrganization(organizationType);
  };
  this.savePreviousOrganization = function (id, organizationType, formId) {
    organizationStateModel.savePreviousOrganization(id, organizationType, formId);
  };
  this.getPreviousOrganization = function () {
    return organizationStateModel.getPreviousOrganization();
  };
  this.saveViewState = function (stateName, stateModel) {
    organizationStateModel.saveViewState(stateName, stateModel);
  };
  this.restoreViewState = function (stateName, viewModel) {
    return organizationStateModel.restoreViewState(stateName, viewModel);
  };
  this.getPreviousViewState = function (stateName) {
    return organizationStateModel.getPreviousViewState(stateName);
  };
  this.hasPreviousOrganization = function () {
    return organizationStateModel.hasPreviousOrganization();
  };
  this.resetPreviousOrganization = function () {
    return organizationStateModel.resetPreviousOrganization();
  };
  this.loadOrganizationActions = function (organizationType, organizationId) {
    return organizationBrowserActionRepository.loadActions(organizationType, organizationId);
  };
  this.loadOrganizationById = function (organizationId) {
    return organizationRepository.loadOrganizationById(organizationId);
  };
  this.closeOrganizationPersistentConnection = function (organizationId) {
    return organizationRepository.closeOrganizationPersistentConnection(organizationId);
  };
  this.upgradeForms = function (organizationId) {
    return organizationRepository.upgradeForms(organizationId);
  };
  this.getForms = function (organizationId) {
    return organizationRepository.getForms(organizationId);
  };
};
ManageOrganizationMediator.$inject = ["organizationBrowserActionRepository", "organizationRepository", "organizationStateModel"];
angular.module('ums.configuration').service('manageOrganizationMediator', ManageOrganizationMediator);

/***/ }),

/***/ 2530:
/***/ (function(module, exports) {

/*@ngInject*/
var OrganizationActionMediator = function OrganizationActionMediator(organizationActionRepository) {
  this.deactivateOrganization = function (organizationId, propagateStatusToChildren) {
    return organizationActionRepository.deactivateOrganization(organizationId, propagateStatusToChildren);
  };
  this.activateOrganization = function (organizationId, propagateStatusToChildren) {
    return organizationActionRepository.activateOrganization(organizationId, propagateStatusToChildren);
  };
  this.deleteOrganization = function (organizationId) {
    return organizationActionRepository.deleteOrganization(organizationId);
  };
  this.getFormSetId = function (organizationId) {
    return organizationActionRepository.getFormSetId(organizationId);
  };
  this.updateEmailSignatureById = function (organizationId, emailSignature) {
    return organizationActionRepository.updateEmailSignatureById(organizationId, emailSignature);
  };
};
OrganizationActionMediator.$inject = ["organizationActionRepository"];
angular.module('ums.configuration').service('organizationActionMediator', OrganizationActionMediator);

/***/ }),

/***/ 2531:
/***/ (function(module, exports) {

/*@ngInject*/
var OrganizationActionRepository = function OrganizationActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.deactivateOrganization = function (organizationId, propagateStatusToChildren) {
    var url = '/rest/Organization/' + organizationId + '/deactivate',
      config = {
        params: {
          propagateStatusToChildren: propagateStatusToChildren
        }
      };
    return this.post(url, {}, config);
  };
  this.activateOrganization = function (organizationId, propagateStatusToChildren) {
    var url = '/rest/Organization/' + organizationId + '/activate',
      config = {
        params: {
          propagateStatusToChildren: propagateStatusToChildren
        }
      };
    return this.post(url, {}, config);
  };
  this.deleteOrganization = function (organizationId) {
    var url = '/rest/Organization/' + organizationId;
    return this.delete(url);
  };
  this.getFormSetId = function (organizationId) {
    var url = '/rest/Organization/' + organizationId + '/formset';
    return this.get(url);
  };
  this.updateEmailSignatureById = function (organizationId, emailSignature) {
    var url = '/rest/Organization/' + organizationId + '/emailSignature';
    return this.post(url, emailSignature);
  };
};
OrganizationActionRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('organizationActionRepository', OrganizationActionRepository);

/***/ }),

/***/ 2532:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var OrganizationActionUtil = function OrganizationActionUtil($rootScope, $state, $uibModal, loadingBarHandler, modalUtil, organizationActionMediator, manageOrganizationMediator, uiPerformanceLoggerConstant, coreConstant, localization) {
  var _this = this;
  localization.getTranslations().then(function (translations) {
    _this.cancel = function (organizationId) {
      modalUtil.showConfirmationModal(/*submissionId*/null, /*quoteId*/null, /*notificationName*/null, 'organization.cancelModal', uiPerformanceLoggerConstant.DELETE_ORGANIZATION, /*hideLoadingBar*/false, function () {
        return organizationActionMediator.deleteOrganization(organizationId).then(function () {
          $state.go('configuration.organizationBrowser', {
            organizationType: $state.params.organizationType
          });
        });
      });
    };
    _this.deactivateOrganization = function (organizationId) {
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.DEACTIVATE_ORGANIZATION);
      modalUtil.showConfirmationModal(null, null, null, 'organization.deactivateModal', uiPerformanceLoggerConstant.DEACTIVATE_ORGANIZATION, /*hideLoadingBar*/true, function () {
        var promise;
        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'organization.deactivateOrganizationChangesLoadingBar'));
        promise = organizationActionMediator.deactivateOrganization(organizationId).then(onSuccess, onError);
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
      });
      function onSuccess() {
        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'organization.deactivateOrganizationChangesSuccessLoadingBar'));
        $state.reload();
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.DEACTIVATE_ORGANIZATION, coreConstant.uiPeformanceLogger.SUCCESS);
      }
      function onError() {
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.DEACTIVATE_ORGANIZATION, coreConstant.uiPeformanceLogger.FAIL);
      }
    };
    _this.activateOrganization = function (organizationId) {
      var promise;
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'organization.activateOrganizationChangesLoadingBar'));
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ACTIVATE_ORGANIZATION);
      promise = organizationActionMediator.activateOrganization(organizationId).then(onSuccess, onError);
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
      function onSuccess() {
        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'organization.activateOrganizationChangesSuccessLoadingBar'));
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ACTIVATE_ORGANIZATION, coreConstant.uiPeformanceLogger.SUCCESS);
      }
      function onError() {
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
        $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.ACTIVATE_ORGANIZATION, coreConstant.uiPeformanceLogger.FAIL);
      }
    };
    _this.getFormSetId = function (organizationId) {
      return organizationActionMediator.getFormSetId(organizationId);
    };
    _this.editEmailSignature = function (organization) {
      var modalInstance = $uibModal.open({
        templateUrl: '/configuration/organizationBrowser/manageOrganization/emailSignatureModal/emailSignatureModal.tpl.html',
        controller: 'emailSignatureModalController',
        windowClass: 'emailSignatureModal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          options: {
            emailSignature: organization.defaultEmailSignature
          }
        }
      });
      modalInstance.result.then(function (result) {
        localization.getTranslationByKey('emailSignatureModal').then(function (translations) {
          var promise;
          function onSuccess() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPDATE_EMAIL_SIGNATURE, coreConstant.uiPeformanceLogger.SUCCESS);
            loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'updatingEmailSignatureSuccessLoadingBar'));
          }
          function onError() {
            $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPDATE_EMAIL_SIGNATURE, coreConstant.uiPeformanceLogger.FAIL);
          }
          loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'updatingEmailSignatureLoadingBar'));
          $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPDATE_EMAIL_SIGNATURE, organization.id);
          promise = organizationActionMediator.updateEmailSignatureById(organization.id, result.emailSignature).then(onSuccess, onError);
          $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
          return promise;
        });
      });
    };
  });
};
OrganizationActionUtil.$inject = ["$rootScope", "$state", "$uibModal", "loadingBarHandler", "modalUtil", "organizationActionMediator", "manageOrganizationMediator", "uiPerformanceLoggerConstant", "coreConstant", "localization"];
angular.module('ums.configuration').service('organizationActionUtil', OrganizationActionUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2533:
/***/ (function(module) {

module.exports = JSON.parse("{\"emailSignatureModal\":{\"title\":\"Email Signature\",\"okButtonLabel\":\"Save\",\"cancelButtonLabel\":\"Cancel\",\"updatingEmailSignatureLoadingBar\":\"Updating Email Signature\",\"updatingEmailSignatureSuccessLoadingBar\":\"Email Signature Updated\",\"emailSignatureNotConfigured\":\"Email Signature Not Configured\"}}");

/***/ }),

/***/ 2534:
/***/ (function(module, exports) {

var path = '/configuration/organizationBrowser/manageOrganization/emailSignatureModal/emailSignatureModal.tpl.html';
var html = "<base-modal modal-title=\"viewModel.title\"\n            ok=\"viewModel.okButtonLabel\"\n            cancel=\"viewModel.cancelButtonLabel\"\n            is-confirm-disabled=\"viewModel.isConfirmDisabled\"\n            on-confirm=\"onConfirm()\"\n            on-cancel=\"onCancel()\">\n\n    <summernote ng-if=\"viewModel.canUpdateEmailSignature\"\n                class=\"summernote-editor\"\n                config=\"summernoteOptions\"\n                ng-model=\"viewModel.emailSignature\">\n    </summernote>\n\n    <div ng-if=\"!viewModel.canUpdateEmailSignature && viewModel.emailSignatureConfigured\"\n         class=\"readOnlyEmailSignature\"\n         ng-bind-html=\"viewModel.emailSignature | nl2br\"></div>\n\n    <div ng-if=\"!viewModel.canUpdateEmailSignature && !viewModel.emailSignatureConfigured\"\n         class=\"emailSignatureNotConfigured\">\n        {{ viewModel.emailSignatureNotConfigured }}\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2535:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(65);
__webpack_require__(66);
__webpack_require__(78);

/*@ngInject*/
var EmailSignatureModalController = function EmailSignatureModalController($scope, $stateParams, options, localization, organizationType, currentUserModel, authorizationConstants) {
  function init() {
    var canUpdateEmailSignature = false;
    $scope.originalEmailSignature = _.isEmpty(options.emailSignature) ? '' : options.emailSignature;
    $scope.viewModel = {
      isConfirmDisabled: true,
      emailSignature: $scope.originalEmailSignature,
      emailSignatureConfigured: !_.isEmpty($scope.originalEmailSignature)
    };
    $scope.summernoteOptions = {
      toolbar: [['style', ['style']], ['font', ['bold', 'underline', 'italic', 'clear']], ['fontname', ['fontname']], ['color', ['color']], ['para', ['ul', 'ol', 'paragraph']], ['insert', ['link', 'attachment']]],
      dialogsInBody: true,
      disableResizeEditor: true,
      disableLinkTarget: true,
      defaultLinkTargetNewWindow: true,
      disableDragAndDrop: true,
      fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Impact', 'Lato', 'Tahoma', 'Times New Roman', 'Verdana'],
      onCreateLink: function onCreateLink(linkUrl) {
        return encodeURI(linkUrl);
      },
      onCreateLinkText: function onCreateLinkText(linkText) {
        return encodeURI(linkText);
      }
    };
    switch (parseInt($stateParams.organizationType)) {
      case organizationType.AGENCY:
        canUpdateEmailSignature = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_AGENCY_BROKERAGE);
        break;
      case organizationType.CARRIER:
        canUpdateEmailSignature = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_CARRIERS);
        break;
      case organizationType.MGA_AGENCY:
        canUpdateEmailSignature = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_MGA_AGENCY_BROKERAGE);
        break;
      case organizationType.MGA_CARRIER:
        canUpdateEmailSignature = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_MGA_CARRIERS);
        break;
    }
    $scope.viewModel.canUpdateEmailSignature = canUpdateEmailSignature;
    localization.getTranslationByKey('emailSignatureModal').then(function (translations) {
      $scope.viewModel.title = _.get(translations, 'title');
      $scope.viewModel.okButtonLabel = _.get(translations, 'okButtonLabel');
      $scope.viewModel.cancelButtonLabel = _.get(translations, 'cancelButtonLabel');
      $scope.viewModel.emailSignatureNotConfigured = _.get(translations, 'emailSignatureNotConfigured');
    });
  }
  $scope.onConfirm = function () {
    $scope.$close({
      emailSignature: $scope.viewModel.emailSignature
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$watch('viewModel.emailSignature', function () {
    if ($scope.viewModel.emailSignature !== $scope.originalEmailSignature) {
      $scope.viewModel.isConfirmDisabled = false;
    } else {
      $scope.viewModel.isConfirmDisabled = true;
    }
  });
  init();
};
EmailSignatureModalController.$inject = ["$scope", "$stateParams", "options", "localization", "organizationType", "currentUserModel", "authorizationConstants"];
angular.module('ums.configuration').controller('emailSignatureModalController', EmailSignatureModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2536:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2537);

/*@ngInject*/
var ManageOrganizationFormViewerController = function ManageOrganizationFormViewerController($scope, $stateParams) {
  $scope.viewModel = {
    formId: parseInt($stateParams.formId)
  };
};
ManageOrganizationFormViewerController.$inject = ["$scope", "$stateParams"];
angular.module('ums.configuration').controller('manageOrganizationFormViewerController', ManageOrganizationFormViewerController);

/***/ }),

/***/ 2537:
/***/ (function(module, exports) {

var path = '/configuration/organizationBrowser/manageOrganization/formViewer/manageOrganizationFormViewer.tpl.html';
var html = "<ui-form-viewer form-id=\"{{ ::viewModel.formId }}\"\n                printable=\"false\"\n                display-form-name=\"true\">\n</ui-form-viewer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2538:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2539);
__webpack_require__(2540);
__webpack_require__(2541);
__webpack_require__(2542);
__webpack_require__(2543);

/*@ngInject*/
var PermissionsEditorController = function PermissionsEditorController($rootScope, $scope, $stateParams, authorizationConstants, configurationConstant, currentUserModel, localization, permissionsModel, permissionsRepository, userType, formatUtil) {
  $scope.viewModel = {
    userType: parseInt($stateParams.userType),
    permissions: null,
    requestParams: {},
    filteredAuthorizations: [],
    placeholder: 'Search',
    isGridEmpty: false,
    isLoading: true,
    hasManagePermission: false
  };
  function init() {
    var userType = $scope.viewModel.userType;
    permissionsRepository.loadPermissionsByUserType(userType).then(function (permissions) {
      permissionsModel.setPermissions(permissions);
      $scope.viewModel.permissions = permissions;
      $scope.filterAuthorizations();
    });
    localization.getTranslationByKey('permissionsEditor').then(function (translations) {
      $scope.viewModel.placeholder = _.get(translations, 'placeholder');
    });
  }
  $scope.handleSelect = function () {
    permissionsModel.setPermissions($scope.viewModel.permissions);
    $rootScope.$broadcast(configurationConstant.event.PERMISSIONS_UPDATED);
  };
  $scope.filterAuthorizations = function () {
    var filterText = _.toLower($scope.viewModel.filterText),
      authorizations = $scope.viewModel.permissions.authorizationSummaries;
    $scope.viewModel.isLoading = true;
    $scope.viewModel.filteredAuthorizations = _.filter(authorizations, function (authorization) {
      var description = _.toLower(authorization.description);
      $scope.viewModel.isLoading = false;
      return _.isEmpty(filterText) || _.includes(description, filterText);
    });
    $scope.viewModel.isGridEmpty = _.isEmpty($scope.viewModel.filteredAuthorizations);
  };
  $scope.getPermissionCheckboxClass = function (name, assignedAuthorization) {
    var permissionName = name.replace(/ /g, '');
    return permissionName + '_' + assignedAuthorization.roleDescription + ' ' + assignedAuthorization.authorizationAssigned;
  };
  $scope.hasManagePermission = function (hasPermission) {
    $scope.viewModel.hasManagePermission = hasPermission;
  };
  $scope.getSelector = function (roleName) {
    return formatUtil.formatAsSelector(roleName);
  };
  init();
};
PermissionsEditorController.$inject = ["$rootScope", "$scope", "$stateParams", "authorizationConstants", "configurationConstant", "currentUserModel", "localization", "permissionsModel", "permissionsRepository", "userType", "formatUtil"];
angular.module('ums.configuration').controller('permissionsEditorController', PermissionsEditorController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2539:
/***/ (function(module) {

module.exports = JSON.parse("{\"permissionsEditor\":{\"emptyGrid\":\"No matching permissions\",\"placeholder\":\"Search\"}}");

/***/ }),

/***/ 2540:
/***/ (function(module, exports, __webpack_require__) {

var path = '/configuration/permissionsEditor/permissionsEditor.tpl.html';
var html = "<div class=\"permissionsEditor\">\n    <div class=\"header\">\n        <ui-permissions-editor-header\n            user-type=\"viewModel.userType\"\n            has-manage-permission = \"hasManagePermission(hasPermission)\">\n        </ui-permissions-editor-header>\n    </div>\n\n    <div class=\"filterContainer\">\n        <div class=\"filter\">\n            <span class=\"glyphicon glyphicon-search filterSearch\"></span>\n            <input type=\"text\"\n                   class=\"filterInput\"\n                   ng-model=\"viewModel.filterText\"\n                   ng-change=\"filterAuthorizations()\"\n                   placeholder=\"{{::viewModel.placeholder}}\"\n            />\n        </div>\n    </div>\n\n    <div class=\"grid\">\n\n        <div class=\"gridContainer\">\n\n            <!-- Grid Header -->\n            <div class=\"columnHeader\">\n                <div class=\"columnRow\">\n\n                    <div class=\"colHeader permissionHeader\">\n                    </div>\n\n                    <div ng-repeat=\"roleName in ::viewModel.permissions.roleNames track by roleName\"\n                         class=\"col header {{ ::getSelector(roleName) }}\"\n                         ng-class=\"roleName\">{{::roleName}}\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"datagrid table\"\n                 ux-datagrid=\"viewModel.filteredAuthorizations\"\n                 ng-if=\"!viewModel.isLoading\"\n                 ui-scroll-detection\n                 ui-scroll-detection-target=\".columnHeader\">\n\n                <script type=\"template/html\"\n                        data-template-item=\"item\"\n                        data-template-name=\"default\">\n\n                    <div class=\"columnRow\">\n                        <div class=\"col authorizationName\">{{::item.description}}</div>\n                        <div\n                            ng-repeat=\"assignedAuthorization in item.assignedAuthorizationSummaries track by $index\"\n                            class=\"col authorizationColumn {{ ::getSelector(assignedAuthorization.roleDescription) }}\">\n                            <input type=\"checkbox\"\n                                   class=\"permissionCheckbox {{getPermissionCheckboxClass(item.description,assignedAuthorization)}}\"\n                                   ng-model=\"assignedAuthorization.authorizationAssigned\"\n                                   ng-change=\"handleSelect()\"\n                                   ng-disabled=\"!viewModel.hasManagePermission\">\n                        </div>\n                    </div>\n                </script>\n            </div>\n\n            <div class=\"gridEmpty\"\n                 ng-if=\"viewModel.isGridEmpty && !viewModel.isLoading\" ui-translate>permissionsEditor.emptyGrid\n            </div>\n\n            <div class=\"icon-spinner\"\n                 ng-if=\"viewModel.isLoading\">\n                <img src=\"" + __webpack_require__(52) + "\"/>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2541:
/***/ (function(module, exports) {

/*@ngInject*/
var PermissionsModel = function PermissionsModel() {
  var permissions = {};
  this.getPermissions = function () {
    return permissions;
  };
  this.setPermissions = function (permissionsSummary) {
    permissions = permissionsSummary;
  };
};
angular.module('ums.configuration').service('permissionsModel', PermissionsModel);

/***/ }),

/***/ 2542:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var PermissionsRepository = function PermissionsRepository(baseRepository, databaseDownloadSectionName, temporaryLoginTokenRepository) {
  angular.extend(this, baseRepository);
  this.loadPermissionsByUserType = function (userType) {
    var url = '/rest/Permission',
      config = {
        params: {
          userType: userType
        }
      };
    return this.get(url, config);
  };
  this.updatePermissions = function (permissions) {
    var url = '/rest/Permission';
    return this.post(url, permissions);
  };
  this.loadPermissionActions = function (userType) {
    var id = _.isNil(userType) ? null : userType,
      url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.authorization.Authorization:' + userType
        }
      };
    return this.get(url, config);
  };
  this.backupPermissions = function () {
    var _this = this;
    var url = '/database/DatabaseDownloadServlet',
      config = {
        params: {
          sectionName: databaseDownloadSectionName.ASSIGNED_AUTHORIZATIONS
        }
      };
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this.get(url, config);
    });
  };
};
PermissionsRepository.$inject = ["baseRepository", "databaseDownloadSectionName", "temporaryLoginTokenRepository"];
angular.module('ums.configuration').service('permissionsRepository', PermissionsRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2543:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2544);
__webpack_require__(2545);
__webpack_require__(2546);
var PermissionsEditorHeaderComponent = {
  templateUrl: '/configuration/permissionsEditor/header/permissionsEditorHeader.tpl.html',
  controller: 'permissionsEditorHeaderController',
  bindings: {
    userType: '<',
    hasManagePermission: '&'
  }
};
angular.module('ums.configuration').component('uiPermissionsEditorHeader', PermissionsEditorHeaderComponent);

/***/ }),

/***/ 2544:
/***/ (function(module) {

module.exports = JSON.parse("{\"permissionsEditorHeader\":{\"title\":\"Manage Permissions:\",\"typeLabel\":\"Type:\",\"actions\":{\"name\":\"Actions\",\"discard\":\"Discard\",\"save\":\"Save\",\"backup\":\"Backup\"},\"unsavedChanges\":\"Unsaved changes\",\"discardConfirmation\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"success\":\"Your changes have been discarded.\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"savePermissions\":{\"loadingBar\":\"Saving Permissions...\",\"savingPermissionsSuccessLoadingBar\":\"Successfully saved permissions\"},\"userTypeName\":{\"1\":\"Agency/Brokerage\",\"2\":\"Service Team\",\"3\":\"System\",\"4\":\"Underwriting\"},\"backup\":{\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\",\"name\":\"Permission\"}}}");

/***/ }),

/***/ 2545:
/***/ (function(module, exports) {

var path = '/configuration/permissionsEditor/header/permissionsEditorHeader.tpl.html';
var html = "<div class=\"headerRow\">\n    <!--Status-->\n    <div class=\"nameColumn\">\n        <div class=\"permissionsTitle\"\n             ui-translate>\n            permissionsEditorHeader.title\n        </div>\n        <div class=\"permissionsName\">{{ ::$ctrl.userTypeName }}</div>\n    </div>\n\n\n    <action-buttons-bar context=\"$ctrl.context\"\n                        actions=\"$ctrl.actions\"\n                        action-sub-texts=\"$ctrl.actionSubTexts\"\n                        notify-action-clicked=\"$ctrl.handleAction(action, file)\"\n                        time-last-modified=\"$ctrl.actionsTimeLastModified\"></action-buttons-bar>\n\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2546:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var PermissionsEditorHeaderController = function PermissionsEditorHeaderController($scope, $rootScope, $element, $state, $uibModal, coreConstant, localization, configurationConstant, modalUtil, configurationMediator, permissionAction, permissionsModel, configurationActionsUtil, coreMediator, databaseDownloadSectionName) {
  var _this4 = this;
  $element.addClass('permissionsEditorHeader');
  this.translations = null;
  this.actions = null;
  this.context = {
    identifier: 'permissionsEditorHeader',
    actions: {},
    fallthrough: null,
    model: {
      contextType: coreConstant.CONTEXT_NONE
    }
  };
  this.context.actions[coreConstant.CONTEXT_NONE] = '';
  this.actionSubTexts = {};
  this.permissionsUpdated = false;
  this.actionsTimeLastModified = '';
  this.$onInit = function () {
    var _this = this;
    localization.getTranslationByKey('permissionsEditorHeader').then(function (translations) {
      _this.translations = translations;
      _this.userTypeName = _.get(_this.translations, "userTypeName.".concat(_this.userType));
      _this.actions = [];
      _this.loadActions();
    });
  };
  this.loadActions = function () {
    var _this2 = this;
    configurationMediator.loadPermissionActions(this.userType).then(function (actions) {
      _this2.actions = [];
      _this2.actions.push({
        actions: actions.actions,
        contextType: _this2.context.model.contextType
      });
      var hasManagePermission = actions.actions.length > 0;
      _this2.hasManagePermission({
        hasPermission: hasManagePermission
      });
      _this2.actionsTimeLastModified = new Date().getTime();
      _this2.processActions(_this2.actions);
    });
  };
  this.processActions = function (actions) {
    var _this3 = this;
    this.actions = actions;
    this.actionSubTexts = {};
    _.each(this.actions, function (subAction) {
      _.each(subAction.actions, function (action) {
        if (action.name === permissionAction.SAVE || action.name === permissionAction.DISCARD) {
          action.enabled = _this3.permissionsUpdated;
        }
        if (action.name === permissionAction.SAVE && _this3.permissionsUpdated) {
          _this3.actionSubTexts[action.name] = {
            class: 'unsavedChanges',
            text: _.get(_this3.translations, 'unsavedChanges')
          };
        }
      });
    });
    this.actionsTimeLastModified = new Date().getTime();
  };
  $scope.$on(configurationConstant.event.PERMISSIONS_UPDATED, function () {
    _this4.permissionsUpdated = true;
    _this4.processActions(_this4.actions);
  });
  this.handleAction = function (action) {
    var _this5 = this;
    if (action.enabled) {
      switch (action.name) {
        case permissionAction.BACKUP:
          configurationActionsUtil.backup(databaseDownloadSectionName.ASSIGNED_AUTHORIZATIONS, _.get(this.translations, 'backup.name'), _.get(this.translations, 'backup.loadingBar'), _.get(this.translations, 'backup.successMessage'));
          break;
        case permissionAction.SAVE:
          configurationActionsUtil.updatePermissions(permissionsModel.getPermissions()).then(function () {
            _this5.permissionsUpdated = false;
            _this5.loadActions();
            coreMediator.refreshUserDetails();
          });
          break;
        case permissionAction.DISCARD:
          modalUtil.showConfirmationModal(null, null, null, 'permissionsEditorHeader.discardConfirmation', null, true, function () {
            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(_this5.translations, 'discardConfirmation.success'));
            _this5.permissionsUpdated = false;
            return $state.reload();
          });
          break;
        default:
          modalUtil.showActionNotImplementedModal(action.name);
          break;
      }
    }
  };
  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    var isCurrentStatePermissionManager = _.startsWith(fromState.name, 'configuration.permissionsEditor'),
      isTargetSameAsCurrent = toState.name === fromState.name;
    if (toState.name === 'login') {
      return;
    }
    if (_this4.permissionsUpdated && isCurrentStatePermissionManager && !isTargetSameAsCurrent && permissionsModel.getPermissions()) {
      event.preventDefault();
      configurationActionsUtil.updatePermissions(permissionsModel.getPermissions()).then(function () {
        _this4.permissionsUpdated = false;
        _this4.loadActions();
        $state.go(toState, toParams);
      });
    } else {
      if (isCurrentStatePermissionManager && isTargetSameAsCurrent && _this4.permissionsUpdated) {
        configurationActionsUtil.updatePermissions(permissionsModel.getPermissions()).then(function () {
          $state.reload();
        });
      }
    }
  });
};
PermissionsEditorHeaderController.$inject = ["$scope", "$rootScope", "$element", "$state", "$uibModal", "coreConstant", "localization", "configurationConstant", "modalUtil", "configurationMediator", "permissionAction", "permissionsModel", "configurationActionsUtil", "coreMediator", "databaseDownloadSectionName"];
angular.module('ums.configuration').controller('permissionsEditorHeaderController', PermissionsEditorHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2547:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2548);
__webpack_require__(2549);
__webpack_require__(2550);
__webpack_require__(2551);

/*@ngInject*/
var ProductTemplateBrowserController = function ProductTemplateBrowserController($scope, $state, $filter, advancedFilterType, filterType, configurationMediator, configurationActionsUtil, localization, productTemplateAction, modalUtil, databaseDownloadSectionName) {
  localization.getTranslationByKey('productTemplateBrowser').then(function (translations) {
    $scope.columns = [{
      name: 'name',
      label: _.get(translations, 'columns.name'),
      className: 'colName',
      getValue: function getValue(item) {
        return item.name;
      }
    }, {
      name: 'type',
      label: _.get(translations, 'columns.type'),
      className: 'colType',
      getValue: function getValue(item) {
        var type;
        if (item.selectableOnQuote && item.selectableOnSubmission) {
          type = 'both';
        } else if (item.selectableOnQuote) {
          type = 'quote';
        } else {
          type = 'submission';
        }
        return _.get(translations, 'type.' + type);
      }
    }, {
      name: 'status',
      label: _.get(translations, 'columns.status'),
      className: 'colStatus',
      getValue: function getValue(item) {
        var status = item.active ? 'active' : 'inactive';
        return _.get(translations, 'status.' + status);
      }
    }, {
      name: 'lastModifiedBy',
      label: _.get(translations, 'columns.lastModifiedBy'),
      className: 'colLastModifiedBy',
      getValue: function getValue(item) {
        return item.lastModifiedBy;
      }
    }, {
      name: 'timeLastModified',
      label: _.get(translations, 'columns.timeLastModified'),
      className: 'colTimeLastModified',
      getValue: function getValue(item) {
        return $filter('date')(item.timeLastModified, 'MM/dd/yy hh:mma');
      }
    }];
    $scope.advancedFilterType = advancedFilterType.PRODUCT_TEMPLATE_BROWSER;
    $scope.filterType = filterType.TYPE_PRODUCT_TEMPLATE_FILTER;
    $scope.stateParams = {
      browser: 'configuration.productTemplateBrowser',
      getDetailState: function getDetailState(productTemplate) {
        return {
          name: 'configuration.productTemplateEditor',
          params: {
            productTemplateName: productTemplate.name,
            productTemplateId: productTemplate.id
          }
        };
      }
    };
    $scope.translations = {
      title: _.get(translations, 'title'),
      recordCountText: _.get(translations, 'recordCountText'),
      recordsCountText: _.get(translations, 'recordsCountText'),
      emptyGrid: _.get(translations, 'emptyGrid')
    };
    $scope.initialRequestParams = {
      key: 'name',
      startIndex: 0,
      pageSize: 25,
      sortType: 'asc'
    };
    $scope.loadActionsHandler = function () {
      return configurationMediator.loadProductTemplateActions();
    };
    $scope.loadItemsHandler = function (filterUri, requestParams) {
      return configurationMediator.getProductTemplatesByFilterUri(filterUri, requestParams);
    };
    $scope.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case productTemplateAction.NEW_PRODUCT_TEMPLATE:
            $state.go('configuration.productTemplateEditor');
            break;
          case productTemplateAction.BACKUP:
            configurationActionsUtil.backup(databaseDownloadSectionName.PRODUCT_TEMPLATES, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
  });
};
ProductTemplateBrowserController.$inject = ["$scope", "$state", "$filter", "advancedFilterType", "filterType", "configurationMediator", "configurationActionsUtil", "localization", "productTemplateAction", "modalUtil", "databaseDownloadSectionName"];
angular.module('ums.configuration').controller('productTemplateBrowserController', ProductTemplateBrowserController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2548:
/***/ (function(module) {

module.exports = JSON.parse("{\"productTemplateBrowser\":{\"title\":\"Manage Product Templates\",\"columns\":{\"name\":\"Product\",\"type\":\"Type\",\"status\":\"Status\",\"lastModifiedBy\":\"Last Edited By\",\"timeLastModified\":\"Last Modified Date\"},\"emptyGrid\":\"No matching product templates\",\"recordCountText\":\"Showing startIndex to endIndex of total Product Template\",\"recordsCountText\":\"Showing startIndex to endIndex of total Product Templates\",\"textInputFilter\":{\"nameSubstring\":{\"placeholder\":\"Search Products\"}},\"actions\":{\"name\":\"Actions\",\"new product template\":\"New Product\",\"backup\":\"Backup\"},\"type\":{\"submission\":\"Submittable\",\"quote\":\"Quotable\",\"both\":\"Both\"},\"status\":{\"inactive\":\"Inactive\",\"active\":\"Active\"},\"backup\":{\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\",\"name\":\"Product Templates\"}}}");

/***/ }),

/***/ 2549:
/***/ (function(module, exports) {

var path = '/configuration/productTemplateBrowser/productTemplateBrowser.tpl.html';
var html = "<ui-grid-data-browser\n    identifier=\"'productTemplateBrowser'\"\n    columns=\"columns\"\n    state-params=\"stateParams\"\n    advanced-filter-type=\"advancedFilterType\"\n    filter-type=\"filterType\"\n    translations=\"translations\"\n    initial-request-params=\"initialRequestParams\"\n    load-items-handler=\"loadItemsHandler\"\n    load-actions-handler=\"loadActionsHandler\"\n    notify-handle-action=\"handleAction(action, file)\">\n</ui-grid-data-browser>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2550:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ProductTemplateBrowserActionRepository = function ProductTemplateBrowserActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadActions = function (productTemplateId) {
    var id = _.isNil(productTemplateId) ? null : productTemplateId,
      url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.underwriting.product.ProductTemplate:' + id
        }
      };
    return this.get(url, config);
  };
};
ProductTemplateBrowserActionRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('productTemplateBrowserActionRepository', ProductTemplateBrowserActionRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2551:
/***/ (function(module, exports) {

/*@ngInject*/
var ProductTemplateRepository = function ProductTemplateRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getProductTemplatesByFilterUri = function (filterUri, requestParams) {
    var url = '/rest/ProductTemplate/filter',
      config = {
        params: {
          filterUri: filterUri,
          sortBy: requestParams.key,
          sortDirection: requestParams.sortType,
          startIndex: requestParams.startIndex,
          numberOfRows: requestParams.pageSize
        }
      };
    return this.get(url, config);
  };
};
ProductTemplateRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('productTemplateRepository', ProductTemplateRepository);

/***/ }),

/***/ 2552:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2553);
__webpack_require__(2554);
__webpack_require__(2555);
__webpack_require__(2556);
__webpack_require__(2557);

/*@ngInject*/
var ProductTemplateEditorController = function ProductTemplateEditorController($rootScope, $scope, $state, $stateParams, $window, localization, configurationMediator, productTypes, coreConstant, configurationConstant, productTemplateEditorModel, dataSetUtil, currentUserModel, authorizationConstants, $uibModal, coreMediator) {
  var translations,
    backdatingRange = _.range(-365, 1),
    futureDatingRange = _.range(0, 366),
    pendingBoundaryRange = _.range(0, 367),
    policyPeriodBoundary = _.range(0, 2001),
    quoteSectionOrderingRange = _.range(0, 301);
  $scope.viewModel = {
    hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.AUTHORIZATION_CONFIGURATOR_MANAGE_PRODUCT_TEMPLATES),
    quoteTemplateClickedForUpload: false,
    binderTemplateClickedForUpload: false,
    selectFileToUpload: '',
    id: '',
    productInfo: {
      productName: '',
      productNamePrompt: '',
      productShortName: '',
      productShortNamePrompt: '',
      externalProductName: '',
      externalProductNamePrompt: '',
      status: 'active',
      allowMultipleQuotesInProposal: 'yes',
      productType: 'both'
    },
    quotingDetails: {
      quotableForProducts: {
        quotableForProductList: [],
        selectedQuotableForProduct: [],
        initialSelectedQuotableForProduct: null,
        quotableForProductsPrompt: '',
        itemName: 'quotableForProduct'
      },
      enableRefreshQuote: 'yes',
      showForm: true
    },
    externalReport: {
      report: {
        reportList: [],
        selectedReport: [],
        itemName: 'report',
        prompt: ''
      },
      reportList: [],
      showForm: true
    },
    rating: {
      ratingAdapter: {
        ratingAdapterList: [],
        selectedRatingAdapter: '',
        prompt: ''
      },
      ratingOutputForm: {
        rationOutputFormList: [],
        selectedRatingOutputForm: '',
        prompt: ''
      },
      useAgentRatingFormsForAgentQuoting: 'no',
      useRateStatusWhenRating: 'no',
      showForm: true
    },
    pricing: {
      enablePricingInput: 'no',
      showForm: true
    },
    quoting: {
      quotingAdapter: {
        quotingAdapterList: [],
        selectedQuotingAdapter: '',
        prompt: ''
      },
      enableAgentQuotingOfAllQuotes: 'no',
      showForm: true,
      quoteSectionOrdering: {
        value: 0,
        optionList: quoteSectionOrderingRange
      },
      quoteTemplateFileName: '',
      quoteTemplateFile: null,
      quoteTemplateFileUrl: null,
      quoteFileTemplateId: 0
    },
    binding: {
      enableBindingInput: 'no',
      enableBinder: 'no',
      enableAgentBindingInput: 'no',
      enableAgentBindingOfAllQuotes: 'no',
      allowBindingOfMultiplePolicies: 'no',
      showForm: true,
      binderTemplateFileName: '',
      binderTemplateFile: null,
      binderTemplateFileUrl: null,
      binderFileTemplateId: 0
    },
    issuance: {
      policyAdapter: {
        policyAdapterList: [],
        selectedPolicyAdapter: '',
        prompt: ''
      },
      enableIssuanceInput: 'no',
      showForm: true
    },
    cancellation: {
      enableAutoRequestCancellation: 'no',
      daysBeforeExpirationToAutoRequestCancellation: 1,
      disableCancellationRequest: true,
      autoRequestCancellationReason: {
        autoRequestCancellationReasonList: [],
        selectedAutoRequestCancellation: '',
        prompt: ''
      },
      allowCancellationOnPolicyExpirationDate: 'no',
      requiredFieldStyle: 'hidden',
      showForm: true
    },
    endorsement: {
      allowEndorsementOnPolicyExpirationDate: 'no',
      showForm: true
    },
    effectiveDateRange: {
      backdatingBoundaryProducer: {
        value: 0,
        optionList: backdatingRange,
        checked: true
      },
      futuredatingBoundaryProducer: {
        value: 0,
        optionList: futureDatingRange,
        checked: true
      },
      submitPendingBoundaryProducer: {
        value: 0,
        optionList: pendingBoundaryRange,
        checked: true
      },
      backdatingBoundaryUnderwriter: {
        value: 0,
        optionList: backdatingRange,
        checked: true
      },
      futuredatingBoundaryUnderwriter: {
        value: 0,
        optionList: futureDatingRange,
        checked: true
      },
      submitPendingBoundaryUnderwriter: {
        value: 0,
        optionList: pendingBoundaryRange,
        checked: true
      },
      policyPeriodBoundary: {
        value: 0,
        optionList: policyPeriodBoundary,
        selectedDateType: 'days',
        checked: true
      },
      policyPeriodDateTypeList: [],
      showForm: true,
      showOnlyPolicyPeriodBoundary: true
    }
  };
  localization.getTranslationByKey('productTemplateForm').then(function (result) {
    translations = result;
    $scope.viewModel.productInfo.productNamePrompt = _.get(translations, 'productInformation.productNamePrompt');
    $scope.viewModel.productInfo.productShortNamePrompt = _.get(translations, 'productInformation.productShortNamePrompt');
    $scope.viewModel.productInfo.externalProductNamePrompt = _.get(translations, 'productInformation.externalProductNamePrompt');
    $scope.viewModel.quotingDetails.quotableForProducts.quotableForProductsPrompt = _.get(translations, 'quotingDetails.quotableForProductsPrompt');
    $scope.viewModel.externalReport.report.prompt = _.get(translations, 'externalReports.reportListPrompt');
    $scope.viewModel.rating.ratingOutputForm.prompt = _.get(translations, 'rating.ratingOutputForm.prompt');
    $scope.viewModel.rating.ratingAdapter.prompt = _.get(translations, 'rating.ratingAdapter.prompt');
    $scope.viewModel.quoting.quotingAdapter.prompt = _.get(translations, 'quoting.quotingAdapter.prompt');
    $scope.viewModel.issuance.policyAdapter.prompt = _.get(translations, 'issuance.policyAdapter.prompt');
    $scope.viewModel.cancellation.autoRequestCancellationReason.prompt = _.get(translations, 'cancellation.autoRequestCancellationReasonPrompt');
    $scope.viewModel.effectiveDateRange.policyPeriodDateTypeList.push(_.get(translations, 'effectiveDateRange.dateType.days'));
    $scope.viewModel.effectiveDateRange.policyPeriodDateTypeList.push(_.get(translations, 'effectiveDateRange.dateType.months'));
    $scope.viewModel.selectFileToUpload = _.get(translations, 'selectFileToUpload');
  }.bind(this));
  function init() {
    productTemplateEditorModel.setProductTemplate(null);
    productTemplateEditorModel.isValid = false;
    productTemplateEditorModel.hasUnsavedChanges = false;
    if (!_.isEmpty($stateParams.productTemplateName)) {
      configurationMediator.loadProductTemplateById($stateParams.productTemplateId).then(function (productTemplate) {
        populationForm(productTemplate);
        productTemplateEditorModel.setProductTemplate(productTemplate);
        loadDataSets();
        if ($scope.viewModel.productInfo.productType === productTypes.QUOTEABLE) {
          $scope.viewModel.externalReport.showForm = false;
          $scope.viewModel.effectiveDateRange.showForm = false;
          $scope.viewModel.effectiveDateRange.showOnlyPolicyPeriodBoundary = true;
          controlFormVisibility(true);
        } else {
          $scope.viewModel.externalReport.showForm = true;
          $scope.viewModel.effectiveDateRange.showForm = true;
          if ($scope.viewModel.productInfo.productType === productTypes.SUBMITABLE) {
            controlFormVisibility(false);
          } else {
            //both
            $scope.viewModel.effectiveDateRange.showOnlyPolicyPeriodBoundary = true;
            controlFormVisibility(true);
          }
        }
      });
    } else {
      productTemplateEditorModel.setProductTemplate(null);
      loadDataSets();
    }
  }
  function loadDataSets() {
    loadSubmittableProductsDataSet();
    dataSetUtil.getDataSet({
      name: 'Rating Adapters'
    }).then(function (dataset) {
      $scope.viewModel.rating.ratingAdapter.ratingAdapterList = dataset.items;
      _.each($scope.viewModel.rating.ratingAdapter.ratingAdapterList, function (ratingAdapterItem) {
        if (_.isNil(productTemplateEditorModel.getProductTemplate()) && ratingAdapterItem.name === 'Default Rating Adapter') {
          $scope.viewModel.rating.ratingAdapter.selectedRatingAdapter = ratingAdapterItem;
        } else if (!_.isNil(productTemplateEditorModel.getProductTemplate()) && productTemplateEditorModel.getProductTemplate().ratingAdapterBeanName === ratingAdapterItem.value) {
          $scope.viewModel.rating.ratingAdapter.selectedRatingAdapter = ratingAdapterItem;
        }
      });
    });
    dataSetUtil.getDataSet({
      name: 'External Reports'
    }).then(function (dataset) {
      var selectedReports;
      $scope.viewModel.externalReport.reportList = dataset.items;
      _.each($scope.viewModel.externalReport.reportList, function (externalReportGenerator) {
        if (!_.isNil(productTemplateEditorModel.getProductTemplate()) && _.includes(productTemplateEditorModel.getProductTemplate().externalReportGeneratorBeanNames, externalReportGenerator.value)) {
          if (_.isNil(selectedReports)) {
            selectedReports = externalReportGenerator.value;
          } else {
            selectedReports += '::' + externalReportGenerator.value;
          }
        }
      });
      $scope.viewModel.externalReport.report.selectedReport = selectedReports;
    });
    dataSetUtil.getDataSet({
      name: 'Quoting Adapters'
    }).then(function (dataset) {
      $scope.viewModel.quoting.quotingAdapter.quotingAdapterList = dataset.items;
      _.each($scope.viewModel.quoting.quotingAdapter.quotingAdapterList, function (quoteAdapter) {
        if (_.isNil(productTemplateEditorModel.getProductTemplate()) && quoteAdapter.name === 'Default Quote Adapter') {
          $scope.viewModel.quoting.quotingAdapter.selectedQuotingAdapter = quoteAdapter;
        } else if (!_.isNil(productTemplateEditorModel.getProductTemplate()) && productTemplateEditorModel.getProductTemplate().quoteAdapterBeanName === quoteAdapter.value) {
          $scope.viewModel.quoting.quotingAdapter.selectedQuotingAdapter = quoteAdapter;
        }
      });
    });
    dataSetUtil.getDataSet({
      name: 'Policy Adapters'
    }).then(function (dataset) {
      $scope.viewModel.issuance.policyAdapter.policyAdapterList = dataset.items;
      _.each($scope.viewModel.issuance.policyAdapter.policyAdapterList, function (policyAdapter) {
        if (_.isNil(productTemplateEditorModel.getProductTemplate()) && policyAdapter.name === 'Default Policy Adapter') {
          $scope.viewModel.issuance.policyAdapter.selectedPolicyAdapter = policyAdapter;
        } else if (!_.isNil(productTemplateEditorModel.getProductTemplate()) && productTemplateEditorModel.getProductTemplate().policyAdapterBeanName === policyAdapter.value) {
          $scope.viewModel.issuance.policyAdapter.selectedPolicyAdapter = policyAdapter;
        }
      });
    });
    dataSetUtil.getDataSet({
      name: 'Rating Forms'
    }).then(function (dataset) {
      $scope.viewModel.rating.ratingOutputForm.rationOutputFormList = dataset.items;
      _.each($scope.viewModel.rating.ratingOutputForm.rationOutputFormList, function (rationOutputForm) {
        if (!_.isNil(productTemplateEditorModel.getProductTemplate()) && rationOutputForm.name === productTemplateEditorModel.getProductTemplate().ratingOutputFormName) {
          $scope.viewModel.rating.ratingOutputForm.selectedRatingOutputForm = rationOutputForm;
        }
      });
    });
    dataSetUtil.getDataSet({
      name: 'Cancellation Reasons'
    }).then(function (dataset) {
      $scope.viewModel.cancellation.autoRequestCancellationReason.autoRequestCancellationReasonList = dataset.items;
      _.each($scope.viewModel.cancellation.autoRequestCancellationReason.autoRequestCancellationReasonList, function (autoRequestCancellationReason) {
        if (!_.isNil(productTemplateEditorModel.getProductTemplate()) && autoRequestCancellationReason.name === productTemplateEditorModel.getProductTemplate().autoRequestCancellationReason) {
          $scope.viewModel.cancellation.autoRequestCancellationReason.selectedAutoRequestCancellation = autoRequestCancellationReason;
        }
      });
    });
  }
  function isFieldValid() {
    var result = false,
      // we need to always return something if the method is intended to return something
      hasProductInfo = !_.isEmpty($scope.viewModel.productInfo.productName) && !_.isEmpty($scope.viewModel.productInfo.productShortName),
      isSubmitableProduct = $scope.viewModel.productInfo.productType === productTypes.SUBMITABLE,
      hasRatingAdapter = !_.isNil($scope.viewModel.rating.ratingAdapter.selectedRatingAdapter),
      hasQuotingAdapter = !_.isNil($scope.viewModel.quoting.quotingAdapter.selectedQuotingAdapter),
      hasPolicyAdapter = !_.isNil($scope.viewModel.issuance.policyAdapter.selectedPolicyAdapter),
      hasRatingQuotingAndPolicyAdapter = hasRatingAdapter && hasQuotingAdapter && hasPolicyAdapter,
      cancellationViewModel = $scope.viewModel.cancellation,
      shouldEnableAutoRequestCancellation = cancellationViewModel.enableAutoRequestCancellation === 'yes',
      hasAutoRequestCancelationSelection = !_.isNil(cancellationViewModel.autoRequestCancellationReason.selectedAutoRequestCancellation) && !_.isEmpty(cancellationViewModel.autoRequestCancellationReason.selectedAutoRequestCancellation);
    if (hasProductInfo) {
      if (isSubmitableProduct) {
        result = true;
      } else if (hasRatingQuotingAndPolicyAdapter) {
        if (shouldEnableAutoRequestCancellation) {
          if (hasAutoRequestCancelationSelection) {
            result = true;
          }
        } else {
          result = true;
        }
      }
    }
    return result;
  }
  function updateProductTemplateModel() {
    var productTemplate = {},
      ratingOutputFormDataItem = $scope.viewModel.rating.ratingOutputForm.selectedRatingOutputForm,
      selectedRatingAdapterDataItem = $scope.viewModel.rating.ratingAdapter.selectedRatingAdapter,
      selectedQuotingAdapterDataItem = $scope.viewModel.quoting.quotingAdapter.selectedQuotingAdapter,
      selectedPolicyAdapterDataItem = $scope.viewModel.issuance.policyAdapter.selectedPolicyAdapter,
      selectedAutoRequestCancellationDataItem = $scope.viewModel.cancellation.autoRequestCancellationReason.selectedAutoRequestCancellation,
      selectedDateType = $scope.viewModel.effectiveDateRange.policyPeriodBoundary.selectedDateType;
    var unlimited = 'Unlimited';
    if (!_.isNil(productTemplateEditorModel.getProductTemplate())) {
      productTemplate.id = productTemplateEditorModel.getProductTemplate().id;
    }
    productTemplate.name = $scope.viewModel.productInfo.productName;
    productTemplate.shortName = $scope.viewModel.productInfo.productShortName;
    productTemplate.externalName = $scope.viewModel.productInfo.externalProductName;
    productTemplate.active = $scope.viewModel.productInfo.status === 'active';
    productTemplate.allowMultiQuoteProposals = $scope.viewModel.productInfo.allowMultipleQuotesInProposal === 'yes';
    if ($scope.viewModel.productInfo.productType === productTypes.SUBMITABLE) {
      productTemplate.selectableOnSubmission = true;
      productTemplate.selectableOnQuote = false;
    } else if ($scope.viewModel.productInfo.productType === productTypes.QUOTEABLE) {
      productTemplate.selectableOnQuote = true;
      productTemplate.selectableOnSubmission = false;
    } else {
      productTemplate.selectableOnSubmission = true;
      productTemplate.selectableOnQuote = true;
    }

    // Quotable for products
    // Set submissionProductTemplates
    // Convert collection value to :: separated Ids
    productTemplate.submissionProductTemplates = _.join(_.map($scope.viewModel.quotingDetails.quotableForProducts.selectedQuotableForProduct, 'value'), '::');
    productTemplate.enableRefreshQuote = $scope.viewModel.quotingDetails.enableRefreshQuote === 'yes';
    productTemplate.quoteSectionOrdering = $scope.viewModel.quoting.quoteSectionOrdering.value;

    // Report List
    if ($scope.viewModel.externalReport.report.selectedReports && $scope.viewModel.externalReport.report.selectedReports.length > 0) {
      // Convert collection value to :: separated external report bean name
      productTemplate.externalReportGeneratorBeanNames = _.replace(_.map($scope.viewModel.externalReport.report.selectedReports, 'value').toString(), new RegExp(',', 'g'), '::');
    } else if ($scope.viewModel.externalReport.report.selectedReports && $scope.viewModel.externalReport.report.selectedReports.length === 0) {
      productTemplate.externalReportGeneratorBeanNames = null;
    }
    productTemplate.useAgentRatingFormsForAgentQuoting = $scope.viewModel.rating.useAgentRatingFormsForAgentQuoting === 'yes';
    productTemplate.ratingOutputFormName = dataSetUtil.getDataItemValue(ratingOutputFormDataItem);
    productTemplate.ratingAdapterBeanName = dataSetUtil.getDataItemValue(selectedRatingAdapterDataItem);
    productTemplate.useRateStatusWhenRating = $scope.viewModel.rating.useRateStatusWhenRating === 'yes';
    productTemplate.agentQuoteAllQuotes = $scope.viewModel.quoting.enableAgentQuotingOfAllQuotes === 'yes';
    productTemplate.pricingFormEnabled = $scope.viewModel.pricing.enablePricingInput === 'yes';
    productTemplate.quoteAdapterBeanName = dataSetUtil.getDataItemValue(selectedQuotingAdapterDataItem);
    productTemplate.bindingFormEnabled = $scope.viewModel.binding.enableBindingInput === 'yes';
    productTemplate.binderEnabled = $scope.viewModel.binding.enableBinder === 'yes';
    productTemplate.agentBindingFormEnabled = $scope.viewModel.binding.enableAgentBindingInput === 'yes';
    productTemplate.agentBindAllQuotes = $scope.viewModel.binding.enableAgentBindingOfAllQuotes === 'yes';
    productTemplate.allowBindingMultiplePolicies = $scope.viewModel.binding.allowBindingOfMultiplePolicies === 'yes';
    productTemplate.policyAdapterBeanName = dataSetUtil.getDataItemValue(selectedPolicyAdapterDataItem);
    productTemplate.issuanceFormEnabled = $scope.viewModel.issuance.enableIssuanceInput === 'yes';
    productTemplate.autoRequestCancellationFlag = $scope.viewModel.cancellation.enableAutoRequestCancellation === 'yes';
    productTemplate.autoRequestCancellationDaysBeforeExpiration = $scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation;
    productTemplate.autoRequestCancellationReason = dataSetUtil.getDataItemValue(selectedAutoRequestCancellationDataItem);
    productTemplate.allowCancellationOnPolicyExpirationDate = $scope.viewModel.cancellation.allowCancellationOnPolicyExpirationDate === 'yes';
    productTemplate.allowEndorsementOnPolicyExpirationDate = $scope.viewModel.endorsement.allowEndorsementOnPolicyExpirationDate === 'yes';
    productTemplate.producerBackdateBoundary = $scope.viewModel.effectiveDateRange.backdatingBoundaryProducer.checked ? unlimited : $scope.viewModel.effectiveDateRange.backdatingBoundaryProducer.value;
    productTemplate.producerFuturedateBoundary = $scope.viewModel.effectiveDateRange.futuredatingBoundaryProducer.checked ? unlimited : $scope.viewModel.effectiveDateRange.futuredatingBoundaryProducer.value;
    productTemplate.producerSubmitPendingBoundary = $scope.viewModel.effectiveDateRange.submitPendingBoundaryProducer.checked ? unlimited : $scope.viewModel.effectiveDateRange.submitPendingBoundaryProducer.value;
    productTemplate.uwBackdateBoundary = $scope.viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.checked ? unlimited : $scope.viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.value;
    productTemplate.uwFuturedateBoundary = $scope.viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.checked ? unlimited : $scope.viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.value;
    productTemplate.uwSubmitPendingBoundary = $scope.viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.checked ? unlimited : $scope.viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.value;
    productTemplate.policyDateRangeBoundary = $scope.viewModel.effectiveDateRange.policyPeriodBoundary.checked ? unlimited : $scope.viewModel.effectiveDateRange.policyPeriodBoundary.value;
    productTemplate.policyDateRangeBoundaryUnit = !_.isEmpty(selectedDateType) ? selectedDateType : $scope.viewModel.effectiveDateRange.policyPeriodBoundary.checked ? 'days' : null;
    productTemplate.quoteTemplateFileName = $scope.viewModel.quoting.quoteTemplateFileName;
    productTemplate.binderTemplateFileName = $scope.viewModel.binding.binderTemplateFileName;
    productTemplate.quoteFileTemplateId = $scope.viewModel.quoting.quoteFileTemplateId;
    productTemplate.binderFileTemplateId = $scope.viewModel.binding.binderFileTemplateId;
    productTemplateEditorModel.setProductTemplate(productTemplate);
    productTemplateEditorModel.setQuoteTemplateFile($scope.viewModel.quoting.quoteTemplateFile);
    productTemplateEditorModel.setBinderTemplateFile($scope.viewModel.binding.binderTemplateFile);
  }
  function populationForm(productTemplate) {
    $scope.viewModel.id = productTemplate.id;
    $scope.viewModel.productInfo.productName = productTemplate.name;
    $scope.viewModel.productInfo.productShortName = productTemplate.shortName;
    $scope.viewModel.productInfo.externalProductName = productTemplate.externalName;
    $scope.viewModel.productInfo.status = productTemplate.active ? 'active' : 'inactive';
    $scope.viewModel.productInfo.allowMultipleQuotesInProposal = productTemplate.allowMultiQuoteProposals ? 'yes' : 'no';
    if (productTemplate.selectableOnSubmission && productTemplate.selectableOnQuote) {
      $scope.viewModel.productInfo.productType = 'both';
    } else {
      if (productTemplate.selectableOnSubmission) {
        $scope.viewModel.productInfo.productType = productTypes.SUBMITABLE;
      } else {
        $scope.viewModel.productInfo.productType = productTypes.QUOTEABLE;
      }
    }
    $scope.viewModel.quotingDetails.enableRefreshQuote = productTemplate.enableRefreshQuote ? 'yes' : 'no';
    $scope.viewModel.quoting.quoteSectionOrdering.value = productTemplate.quoteSectionOrdering;
    $scope.viewModel.rating.useAgentRatingFormsForAgentQuoting = productTemplate.useAgentRatingFormsForAgentQuoting ? 'yes' : 'no';
    $scope.viewModel.rating.ratingOutputForm.selectedRatingOutputForm = productTemplate.ratingOutputFormName;
    $scope.viewModel.rating.useRateStatusWhenRating = productTemplate.useRateStatusWhenRating ? 'yes' : 'no';
    $scope.viewModel.pricing.enablePricingInput = productTemplate.pricingFormEnabled ? 'yes' : 'no';
    $scope.viewModel.quoting.enableAgentQuotingOfAllQuotes = productTemplate.agentQuoteAllQuotes ? 'yes' : 'no';
    $scope.viewModel.binding.enableBindingInput = productTemplate.bindingFormEnabled ? 'yes' : 'no';
    $scope.viewModel.binding.enableBinder = productTemplate.binderEnabled ? 'yes' : 'no';
    $scope.viewModel.binding.enableAgentBindingInput = productTemplate.agentBindingFormEnabled ? 'yes' : 'no';
    $scope.viewModel.binding.enableAgentBindingOfAllQuotes = productTemplate.agentBindAllQuotes ? 'yes' : 'no';
    $scope.viewModel.binding.allowBindingOfMultiplePolicies = productTemplate.allowBindingMultiplePolicies ? 'yes' : 'no';
    $scope.viewModel.issuance.enableIssuanceInput = productTemplate.issuanceFormEnabled ? 'yes' : 'no';
    $scope.viewModel.cancellation.enableAutoRequestCancellation = productTemplate.autoRequestCancellationFlag ? 'yes' : 'no';
    if ($scope.viewModel.cancellation.enableAutoRequestCancellation === 'yes') {
      $scope.viewModel.cancellation.disableCancellationRequest = false;
      $scope.viewModel.cancellation.requiredFieldStyle = '';
    } else {
      $scope.viewModel.cancellation.disableCancellationRequest = true;
      $scope.viewModel.cancellation.requiredFieldStyle = 'hidden';
    }
    $scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation = productTemplate.autoRequestCancellationDaysBeforeExpiration;
    $scope.viewModel.cancellation.autoRequestCancellationReason.selectedAutoRequestCancellation = productTemplate.autoRequestCancellationReason;
    $scope.viewModel.cancellation.allowCancellationOnPolicyExpirationDate = productTemplate.allowCancellationOnPolicyExpirationDate ? 'yes' : 'no';
    $scope.viewModel.endorsement.allowEndorsementOnPolicyExpirationDate = productTemplate.allowEndorsementOnPolicyExpirationDate ? 'yes' : 'no';
    if (productTemplate.producerBackdateBoundary === 'Unlimited') {
      $scope.viewModel.effectiveDateRange.backdatingBoundaryProducer.checked = true;
      $scope.viewModel.effectiveDateRange.backdatingBoundaryProducer.value = '';
    } else {
      $scope.viewModel.effectiveDateRange.backdatingBoundaryProducer.checked = false;
      $scope.viewModel.effectiveDateRange.backdatingBoundaryProducer.value = productTemplate.producerBackdateBoundary;
    }
    if (productTemplate.producerFuturedateBoundary === 'Unlimited') {
      $scope.viewModel.effectiveDateRange.futuredatingBoundaryProducer.checked = true;
      $scope.viewModel.effectiveDateRange.futuredatingBoundaryProducer.value = '';
    } else {
      $scope.viewModel.effectiveDateRange.futuredatingBoundaryProducer.checked = false;
      $scope.viewModel.effectiveDateRange.futuredatingBoundaryProducer.value = productTemplate.producerFuturedateBoundary;
    }
    if (productTemplate.producerSubmitPendingBoundary === 'Unlimited') {
      $scope.viewModel.effectiveDateRange.submitPendingBoundaryProducer.checked = true;
      $scope.viewModel.effectiveDateRange.submitPendingBoundaryProducer.value = '';
    } else {
      $scope.viewModel.effectiveDateRange.submitPendingBoundaryProducer.checked = false;
      $scope.viewModel.effectiveDateRange.submitPendingBoundaryProducer.value = productTemplate.producerSubmitPendingBoundary;
    }
    if (productTemplate.uwBackdateBoundary === 'Unlimited') {
      $scope.viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.checked = true;
      $scope.viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.value = '';
    } else {
      $scope.viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.checked = false;
      $scope.viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.value = productTemplate.uwBackdateBoundary;
    }
    if (productTemplate.uwFuturedateBoundary === 'Unlimited') {
      $scope.viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.checked = true;
      $scope.viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.value = '';
    } else {
      $scope.viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.checked = false;
      $scope.viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.value = productTemplate.uwFuturedateBoundary;
    }
    if (productTemplate.uwSubmitPendingBoundary === 'Unlimited') {
      $scope.viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.checked = true;
      $scope.viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.value = '';
    } else {
      $scope.viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.checked = false;
      $scope.viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.value = productTemplate.uwSubmitPendingBoundary;
    }
    if (productTemplate.policyDateRangeBoundary === 'Unlimited') {
      $scope.viewModel.effectiveDateRange.policyPeriodBoundary.checked = true;
      $scope.viewModel.effectiveDateRange.policyPeriodBoundary.value = '';
      $scope.viewModel.effectiveDateRange.policyPeriodBoundary.selectedDateType = '';
    } else {
      $scope.viewModel.effectiveDateRange.policyPeriodBoundary.checked = false;
      $scope.viewModel.effectiveDateRange.policyPeriodBoundary.value = productTemplate.policyDateRangeBoundary;
      $scope.viewModel.effectiveDateRange.policyPeriodBoundary.selectedDateType = !_.isEmpty(productTemplate.policyDateRangeBoundaryUnit) ? productTemplate.policyDateRangeBoundaryUnit : 'days';
    }
    $scope.viewModel.quoting.quoteTemplateFileName = productTemplate.quoteTemplateFileName;
    $scope.viewModel.quoting.quoteFileTemplateId = productTemplate.quoteFileTemplateId;
    $scope.viewModel.binding.binderTemplateFileName = productTemplate.binderTemplateFileName;
    $scope.viewModel.binding.binderFileTemplateId = productTemplate.binderFileTemplateId;
  }
  function getDownloadUrl(templateType) {
    var templateFileName, templateFileId, templateFileNamePath, templateFileNameParameter;
    if (templateType === 'quote') {
      templateFileName = $scope.viewModel.quoting.quoteTemplateFileName;
      templateFileId = $scope.viewModel.quoting.quoteFileTemplateId;
    } else if (templateType === 'binder') {
      templateFileName = $scope.viewModel.binding.binderTemplateFileName;
      templateFileId = $scope.viewModel.binding.binderFileTemplateId;
    }
    return coreMediator.getSingleUseToken().then(function (token) {
      templateFileNamePath = templateFileName ? '/' + encodeURIComponent(templateFileName) : '';
      templateFileNameParameter = templateFileName ? ' filename="' + encodeURIComponent(templateFileName) + '"' : '';
      return "/productTemplateFileDownload".concat(templateFileNamePath, "?id=").concat(templateFileId, "&t=").concat(encodeURIComponent(token), "&contentDisposition=inline;").concat(templateFileNameParameter);
    });
  }
  function loadSubmittableProductsDataSet() {
    return dataSetUtil.getDataSet({
      name: 'Product Templates By Type',
      search: productTypes.SUBMITABLE
    }).then(function (dataset) {
      var selectedProducts = [],
        currentProductTemplate = productTemplateEditorModel.getProductTemplate();

      // Filter out the current product template.
      $scope.viewModel.quotingDetails.quotableForProducts.quotableForProductList = _.filter(dataset.items, function (productTemplate) {
        if (currentProductTemplate) {
          return currentProductTemplate.id !== parseInt(productTemplate.value);
        }
        return true;
      });
      _.each($scope.viewModel.quotingDetails.quotableForProducts.quotableForProductList, function (quoteableForProduct) {
        if (!_.isNil(currentProductTemplate) && _.includes(currentProductTemplate.submissionProductTemplateIds, parseInt(quoteableForProduct.value))) {
          $scope.viewModel.quotingDetails.quotableForProducts.selectedQuotableForProduct.push(quoteableForProduct);
          selectedProducts.push(quoteableForProduct.value);
        }
      });
      $scope.viewModel.quotingDetails.quotableForProducts.initialSelectedQuotableForProduct = _.join(selectedProducts, '::');
    });
  }
  function controlFormVisibility(show) {
    $scope.viewModel.quotingDetails.showForm = show;
    $scope.viewModel.rating.showForm = show;
    $scope.viewModel.pricing.showForm = show;
    $scope.viewModel.quoting.showForm = show;
    $scope.viewModel.binding.showForm = show;
    $scope.viewModel.issuance.showForm = show;
    $scope.viewModel.cancellation.showForm = show;
    $scope.viewModel.endorsement.showForm = show;
  }
  $scope.onEnableAutoRequestCancellationChange = function () {
    $scope.handleChange();
    if ($scope.viewModel.cancellation.enableAutoRequestCancellation === 'yes') {
      $scope.viewModel.cancellation.disableCancellationRequest = false;
      $scope.viewModel.cancellation.requiredFieldStyle = '';
    } else {
      $scope.viewModel.cancellation.requiredFieldStyle = 'hidden';
      $scope.viewModel.cancellation.disableCancellationRequest = true;
    }
  };
  $scope.onEnableAutoRequestCancellationChange = function () {
    $scope.handleChange();
    if ($scope.viewModel.cancellation.enableAutoRequestCancellation === 'yes') {
      $scope.viewModel.cancellation.disableCancellationRequest = false;
      $scope.viewModel.cancellation.requiredFieldStyle = '';
    } else {
      $scope.viewModel.cancellation.requiredFieldStyle = 'hidden';
      $scope.viewModel.cancellation.disableCancellationRequest = true;
    }
  };
  $scope.onToggleUnlimitedEffectiveDateCheckbox = function (effectiveDateContext) {
    var isPolicyPeriodBoundary = _.has(effectiveDateContext, 'selectedDateType');
    if (effectiveDateContext['checked']) {
      effectiveDateContext['value'] = '';
      if (isPolicyPeriodBoundary) {
        effectiveDateContext['selectedDateType'] = '';
      }
    } else {
      effectiveDateContext['value'] = 0;
      if (isPolicyPeriodBoundary) {
        effectiveDateContext['selectedDateType'] = $scope.viewModel.effectiveDateRange.policyPeriodDateTypeList[0];
      }
    }
    $scope.handleChange();
  };
  $scope.handleChange = function () {
    productTemplateEditorModel.hasUnsavedChanges = true;
    productTemplateEditorModel.isValid = isFieldValid();
    updateProductTemplateModel();
    $rootScope.$broadcast(configurationConstant.event.PRODUCT_TEMPLATE_UPDATED);
  };
  $scope.onProductTypeChange = function () {
    if ($scope.viewModel.productInfo.productType === productTypes.QUOTEABLE) {
      $scope.viewModel.externalReport.showForm = false;
      $scope.viewModel.effectiveDateRange.showForm = false;
      $scope.viewModel.effectiveDateRange.showOnlyPolicyPeriodBoundary = true;
      controlFormVisibility(true);
    } else {
      $scope.viewModel.externalReport.showForm = true;
      $scope.viewModel.effectiveDateRange.showForm = true;
      if ($scope.viewModel.productInfo.productType === productTypes.SUBMITABLE) {
        controlFormVisibility(false);
      } else {
        $scope.viewModel.effectiveDateRange.showOnlyPolicyPeriodBoundary = true;
        controlFormVisibility(true);
      }
    }
    loadSubmittableProductsDataSet().then(function () {
      $scope.handleChange();
    });
  };
  $scope.onEnableAutoRequestCancellationChange = function () {
    $scope.handleChange();
    if ($scope.viewModel.cancellation.enableAutoRequestCancellation === 'yes') {
      $scope.viewModel.cancellation.disableCancellationRequest = false;
      $scope.viewModel.cancellation.requiredFieldStyle = '';
    } else {
      $scope.viewModel.cancellation.requiredFieldStyle = 'hidden';
      $scope.viewModel.cancellation.disableCancellationRequest = true;
    }
  };
  $scope.handleDaysBeforeExpirationToAutoRequestCancellation = function () {
    $scope.handleChange();
    if (_.isNaN(parseInt($scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation))) {
      $scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation = 0;
    } else {
      if (parseInt($scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation) < 0) {
        $scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation = 0;
      } else if (parseInt($scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation) > 300) {
        $scope.viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation = 300;
      }
    }
    $scope.handleChange();
  };
  $scope.onPolicyPeriodBoundarySelectItem = function (item) {
    $scope.viewModel.effectiveDateRange.policyPeriodBoundary.selectedDateType = item;
    $scope.handleChange();
  };
  $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
    if (itemName === $scope.viewModel.quotingDetails.quotableForProducts.itemName) {
      $scope.viewModel.quotingDetails.quotableForProducts.selectedQuotableForProduct = [];
      _.each($scope.viewModel.quotingDetails.quotableForProducts.quotableForProductList, function (quotableForProducts) {
        if (quotableForProducts.selected) {
          $scope.viewModel.quotingDetails.quotableForProducts.selectedQuotableForProduct.push(quotableForProducts);
        }
      });
    } else if (itemName === $scope.viewModel.externalReport.report.itemName) {
      $scope.viewModel.externalReport.report.selectedReports = [];
      _.each($scope.viewModel.externalReport.reportList, function (report) {
        if (report.selected) {
          $scope.viewModel.externalReport.report.selectedReports.push(report);
        }
      });
    }
    $scope.handleChange();
  });
  $scope.$on(coreConstant.event.FILE_UPLOADED, function (event, file) {
    if ($scope.viewModel.quoteTemplateClickedForUpload) {
      $scope.viewModel.quoting.quoteTemplateFileName = file.name;
      $scope.viewModel.quoting.quoteTemplateFile = file.uploadedFile;
      // Just a placeholder to make sure quoteFileTemplate needs to saved
      $scope.viewModel.quoting.quoteFileTemplateId = -1;
    } else if ($scope.viewModel.binderTemplateClickedForUpload) {
      $scope.viewModel.binding.binderTemplateFileName = file.name;
      $scope.viewModel.binding.binderTemplateFile = file.uploadedFile;
      // Just a placeholder to make sure binderFileTemplate needs to saved
      $scope.viewModel.binding.binderFileTemplateId = -1;
    }
    $scope.handleChange();
    $scope.viewModel.quoteTemplateClickedForUpload = false;
    $scope.viewModel.binderTemplateClickedForUpload = false;
  });
  $scope.openFileDialogBox = function (templateName) {
    if (templateName === 'quote') {
      $scope.viewModel.quoteTemplateClickedForUpload = true;
    } else if (templateName === 'binder') {
      $scope.viewModel.binderTemplateClickedForUpload = true;
    }
    $uibModal.open({
      templateUrl: '/configuration/uploadDocument/uploadDocumentModal.tpl.html',
      controller: 'uploadDocumentModalController',
      windowClass: 'uploadDocumentModal',
      resolve: {},
      keyboard: false,
      backdrop: 'static'
    });
  };
  $scope.onCloseButtonClicked = function (closeTemplate) {
    if (closeTemplate === 'quote') {
      $scope.viewModel.quoting.quoteTemplateFile = null;
      $scope.viewModel.quoting.quoteTemplateFileName = null;
      $scope.viewModel.quoting.quoteFileTemplateId = null;
    } else if (closeTemplate === 'binder') {
      $scope.viewModel.binding.binderTemplateFile = null;
      $scope.viewModel.binding.binderTemplateFileName = null;
      $scope.viewModel.binding.binderFileTemplateId = null;
    }
    $scope.handleChange();
  };
  $scope.onTemplateFileDownloadClick = function (templateType) {
    if (templateType === 'quote') {
      getDownloadUrl('quote').then(function (url) {
        $window.open(url, '_blank');
      });
    } else if (templateType === 'binder') {
      getDownloadUrl('binder').then(function (url) {
        $window.open(url, '_blank');
      });
    }
  };
  $scope.displayQuoteDocTemplateButton = function () {
    return $scope.viewModel.quoting.quoteTemplateFileName === '' || $scope.viewModel.quoting.quoteTemplateFileName === null;
  };
  $scope.displayQuoteDocTemplateLink = function () {
    return $scope.viewModel.quoting.quoteTemplateFileName !== '' && $scope.viewModel.quoting.quoteTemplateFileName !== null && $scope.viewModel.quoting.quoteFileTemplateId !== -1;
  };
  $scope.displayQuoteDocTemplateFileName = function () {
    return $scope.viewModel.quoting.quoteTemplateFileName !== '' && $scope.viewModel.quoting.quoteTemplateFileName !== null && $scope.viewModel.quoting.quoteFileTemplateId == -1;
  };
  $scope.displayBinderDocTemplateButton = function () {
    return $scope.viewModel.binding.binderTemplateFileName === '' || $scope.viewModel.binding.binderTemplateFileName === null;
  };
  $scope.displayBinderDocTemplateLink = function () {
    return $scope.viewModel.binding.binderTemplateFileName !== '' && $scope.viewModel.binding.binderTemplateFileName !== null && $scope.viewModel.binding.binderFileTemplateId !== -1;
  };
  $scope.displayBinderDocTemplateFileName = function () {
    return $scope.viewModel.binding.binderTemplateFileName !== '' && $scope.viewModel.binding.binderTemplateFileName !== null && $scope.viewModel.binding.binderFileTemplateId == -1;
  };
  init();
};
ProductTemplateEditorController.$inject = ["$rootScope", "$scope", "$state", "$stateParams", "$window", "localization", "configurationMediator", "productTypes", "coreConstant", "configurationConstant", "productTemplateEditorModel", "dataSetUtil", "currentUserModel", "authorizationConstants", "$uibModal", "coreMediator"];
angular.module('ums.configuration').controller('productTemplateEditorController', ProductTemplateEditorController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2553:
/***/ (function(module) {

module.exports = JSON.parse("{\"productTemplateForm\":{\"productInformation\":{\"headingTitle\":\"Product Information\",\"productName\":\"Product Name\",\"productNamePrompt\":\"Product Name\",\"productShortName\":\"Product Short Name\",\"productShortNamePrompt\":\"Short Name\",\"externalProductName\":\"External Product Name\",\"externalProductNamePrompt\":\"External Product Name\",\"status\":{\"name\":\"Status\",\"active\":\"Active\",\"inactive\":\"Inactive\"},\"allowMultipleQuotesInProposal\":{\"name\":\"Allow Multiple Quotes in Proposal\",\"yes\":\"Yes\",\"no\":\"No\"},\"productType\":{\"name\":\"Product Type\",\"submittable\":\"Submittable\",\"quotable\":\"Quotable\",\"both\":\"Both\"}},\"quotingDetails\":{\"headingTitle\":\"Quoting Details\",\"quotableForProducts\":\"Quotable for Products\",\"quotableForProductsPrompt\":\"Select Products\",\"enableRefreshQuote\":{\"name\":\"Enable Refresh Quote\",\"yes\":\"Yes\",\"no\":\"No\"}},\"externalReports\":{\"headingTitle\":\"External Reports\",\"reportList\":\"Reports List\",\"reportListPrompt\":\"Select Report\"},\"rating\":{\"headingTitle\":\"Rating\",\"useAgentRatingFormsForAgentQuoting\":{\"name\":\"Use Agent Rating Forms for Agent Quoting\",\"yes\":\"Yes\",\"no\":\"No\"},\"ratingAdapter\":{\"name\":\"Rating Adapter\",\"prompt\":\"Please Choose\"},\"ratingOutputForm\":{\"name\":\"Rating Output Form Name\",\"prompt\":\"Please Choose\"},\"useRateStatusWhenRating\":{\"name\":\"Use Rate Status When Rating\",\"yes\":\"Yes\",\"no\":\"No\"},\"enableAgentQuotingOfAllQuotes\":{\"name\":\"Enable Agent Quoting of All Quotes\",\"yes\":\"Yes\",\"no\":\"No\"}},\"pricing\":{\"headingTitle\":\"Pricing\",\"enablePricingInput\":{\"name\":\"Enable Pricing Input\",\"yes\":\"Yes\",\"no\":\"No\"}},\"quoting\":{\"headingTitle\":\"Quoting\",\"quotingAdapter\":{\"name\":\"Quoting Adapter\",\"prompt\":\"Please Choose\"},\"quoteSectionOrdering\":\"Quote Section Ordering\",\"quoteDocumentTemplate\":\"Quote Document Template\"},\"Binding\":{\"headingTitle\":\"Binding\",\"enableBindingInput\":{\"name\":\"Enable Binding Input\",\"yes\":\"Yes\",\"no\":\"No\"},\"enableBinder\":{\"name\":\"Enable Binder\",\"yes\":\"Yes\",\"no\":\"No\"},\"enableAgentBindingInput\":{\"name\":\"Enable Agent Binding Input\",\"yes\":\"Yes\",\"no\":\"No\"},\"enableAgentBindingOfAllQuotes\":{\"name\":\"Enable Agent Binding of All Quotes\",\"yes\":\"Yes\",\"no\":\"No\"},\"allowBindingOfMultiplePolicies\":{\"name\":\"Allow Binding of Multiple Policies\",\"yes\":\"Yes\",\"no\":\"No\"},\"binderDocumentTemplate\":\"Binder Document Template\"},\"issuance\":{\"headingTitle\":\"Issuance\",\"policyAdapter\":{\"name\":\"Policy Adapter\",\"prompt\":\"Please Choose\"},\"enableIssuanceInput\":{\"name\":\"Enable Issuance Input\",\"yes\":\"Yes\",\"no\":\"No\"}},\"cancellation\":{\"headingTitle\":\"Cancellation\",\"enableAutoRequestCancellation\":{\"name\":\"Enable Auto request Cancellation\",\"yes\":\"Yes\",\"no\":\"No\"},\"daysBeforeExpirationToAutoRequestCancellation\":\"Days Before Expiration to Auto Request Cancellation\",\"autoRequestCancellationReason\":\"Auto request cancellation reason\",\"autoRequestCancellationReasonPrompt\":\"Please Choose\",\"allowCancellationOnPolicyExpirationDate\":{\"name\":\"Allow Cancellation on Policy Expiration Date\",\"yes\":\"Yes\",\"no\":\"No\"}},\"endorsement\":{\"headingTitle\":\"Endorsement\",\"allowEndorsementOnPolicyExpirationDate\":{\"name\":\"Allow Endorsement on Policy Expiration Date\",\"yes\":\"Yes\",\"no\":\"No\"}},\"effectiveDateRange\":{\"headingTitle\":\"Effective Date Range\",\"unlimited\":\"Unlimited\",\"backdatingBoundaryProducer\":\"Backdating Boundary - Producer\",\"futuredatingBoundaryProducer\":\"Futuredating Boundary - Producer\",\"submitPendingBoundaryProducer\":\"Submit Pending Boundary - Producer\",\"backdatingBoundaryUnderwriter\":\"Backdating Boundary - Underwriter\",\"futuredatingBoundaryUnderwriter\":\"Futuredating Boundary - Underwriter\",\"submitPendingBoundaryUnderwriter\":\"Submit Pending Boundary - Underwriter\",\"policyPeriodBoundary\":\"Policy Period Boundary\",\"dateType\":{\"days\":\"days\",\"months\":\"months\",\"prompt\":\"Please Choose\"}},\"selectFileToUpload\":\"Select File To Upload\"}}");

/***/ }),

/***/ 2554:
/***/ (function(module, exports) {

var path = '/configuration/productTemplateEditor/productTemplateEditor.tpl.html';
var html = "<div class=\"productTemplateEditor\">\n    <div class=\"header\">\n        <ui-product-template-editor-header\n            product-template-name=\"viewModel.productInfo.productName\">\n        </ui-product-template-editor-header>\n\n    </div>\n    <div class=\"formContainer\">\n        <fieldset class=\"subContainer\" ng-disabled=\"{{::!viewModel.hasManagePermission}}\">\n\n            <!--Product Information-->\n            <div class=\"content\">\n                <div>\n                    <span class=\"title\" ui-translate>productTemplateForm.productInformation.headingTitle</span>\n                    <div class=\"requiredRow\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.productInfo.productName}}\">\n                        </ui-required-indicator>\n                        <div class=\"rowItem productNameLabel\">\n                            <span ui-translate>productTemplateForm.productInformation.productName</span>\n                        </div>\n\n                        <input type=\"text\"\n                               ng-model=\"viewModel.productInfo.productName\"\n                               ng-change=\"handleChange()\"\n                               value=\"{{ viewModel.productInfo.productName }}\"\n                               placeholder=\"{{::viewModel.productInfo.productNamePrompt}}\"\n                               class=\"textInput productName\">\n                    </div>\n                    <div class=\"requiredRow\">\n                        <ui-required-indicator class=\"requiredIndicator productShortNameLabel\"\n                                               value=\"{{viewModel.productInfo.productShortName}}\">\n                        </ui-required-indicator>\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.productInformation.productShortName</span>\n                        </div>\n\n                        <input type=\"text\"\n                               ng-model=\"viewModel.productInfo.productShortName\"\n                               ng-change=\"handleChange()\"\n                               value=\"{{ viewModel.productInfo.productShortName }}\"\n                               placeholder=\"{{::viewModel.productInfo.productShortNamePrompt}}\"\n                               class=\"textInput productShortName\">\n                    </div>\n                    <div class=\"row\">\n\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.productInformation.externalProductName</span>\n                        </div>\n\n                        <input type=\"text\"\n                               ng-model=\"viewModel.productInfo.externalProductName\"\n                               ng-change=\"handleChange()\"\n                               value=\"{{ viewModel.productInfo.externalProductName }}\"\n                               placeholder=\"{{::viewModel.productInfo.externalProductNamePrompt}}\"\n                               class=\"textInput externalProductName\">\n                    </div>\n                    <div class=\"row status\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.productInformation.status.name</span>\n                        </div>\n\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.productInfo.status\"\n                                   value=\"active\"\n                                   ng-change=\"handleChange()\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>productTemplateForm.productInformation.status.active</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.productInfo.status\"\n                                   value=\"inactive\"\n                                   ng-change=\"handleChange()\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.productInformation.status.inactive</span>\n                        </div>\n                    </div>\n                    <div class=\"row allowingMultipleQuotesInProposal\">\n                        <div class=\"rowItem\">\n                        <span\n                            ui-translate>productTemplateForm.productInformation.allowMultipleQuotesInProposal.name</span>\n                        </div>\n\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   class = \"allowingMultipleQuotes\"\n                                   ng-model=\"viewModel.productInfo.allowMultipleQuotesInProposal\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"yes\"\n                                   class = \"allowMultipleQuotesInProposalYes\" >\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>productTemplateForm.productInformation.allowMultipleQuotesInProposal.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle notAllowMultipleQuotes\"\n                                   ng-change=\"handleChange()\"\n                                   ng-model=\"viewModel.productInfo.allowMultipleQuotesInProposal\"\n                                   value=\"no\"\n                                   class = \"allowMultipleQuotesInProposalNo\" >\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>productTemplateForm.productInformation.allowMultipleQuotesInProposal.no</span>\n                        </div>\n                    </div>\n                    <div class=\"row productType\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.productInformation.productType.name</span>\n                        </div>\n\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.productInfo.productType\"\n                                   value=\"Submmitable\"\n                                   ng-change=\"onProductTypeChange(value)\"\n                                   class=\"productTypeSubmittable\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.productInformation.productType.submittable</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle productTypeQuotable\"\n                                   ng-model=\"viewModel.productInfo.productType\"\n                                   value=\"Quoteable\"\n                                   ng-change=\"onProductTypeChange(value)\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.productInformation.productType.quotable</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.productInfo.productType\"\n                                   value=\"both\"\n                                   ng-change=\"onProductTypeChange(value)\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.productInformation.productType.both</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"separator\" ng-if=\"viewModel.quotingDetails.showForm\"></div>\n\n            <!--Quoting Details-->\n            <div class=\"content\" ng-if=\"viewModel.quotingDetails.showForm\">\n                <div>\n                    <span class=\"title\" ui-translate>productTemplateForm.quotingDetails.headingTitle</span>\n                    <div class=\"row\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.quotingDetails.quotableForProducts</span>\n                        </div>\n\n                        <ui-multi-select\n                            items-list=\"viewModel.quotingDetails.quotableForProducts.quotableForProductList\"\n                            class=\"multiSelectDropdown\"\n                            item-name=\"viewModel.quotingDetails.quotableForProducts.itemName\"\n                            prompt-value=\"viewModel.quotingDetails.quotableForProducts.quotableForProductsPrompt\"\n                            append-to-body=\"true\"\n                            ui-hide-select-on-scroll-selector=\".formContainer\"\n                            selected-value=\"viewModel.quotingDetails.quotableForProducts.initialSelectedQuotableForProduct\"\n                            is-disabled=\"::!viewModel.hasManagePermission\">\n                        </ui-multi-select>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.quotingDetails.enableRefreshQuote.name</span>\n                        </div>\n\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.quotingDetails.enableRefreshQuote\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"yes\"\n                                    class=\"enableRefreshQuoteYes\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.quotingDetails.enableRefreshQuote.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.quotingDetails.enableRefreshQuote\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"no\"\n                                   class=\"enableRefreshQuoteNo\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.quotingDetails.enableRefreshQuote.no</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"separator\" ng-if=\"viewModel.externalReport.showForm\"></div>\n\n            <!--External Reports-->\n            <div class=\"content\" ng-if=\"viewModel.externalReport.showForm\">\n                <div>\n                    <span class=\"title\" ui-translate>productTemplateForm.externalReports.headingTitle</span>\n                    <div class=\"row\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.externalReports.reportList</span>\n                        </div>\n\n                        <ui-multi-select items-list=\"viewModel.externalReport.reportList\"\n                                         class=\"multiSelectDropdown externalReports reportList\"\n                                         item-name=\"viewModel.externalReport.report.itemName\"\n                                         prompt-value=\"viewModel.externalReport.report.prompt\"\n                                         selected-value=\"viewModel.externalReport.report.selectedReport\"\n                                         is-disabled=\"::!viewModel.hasManagePermission\">\n                        </ui-multi-select>\n                    </div>\n                </div>\n            </div>\n            <div class=\"separator\" ng-if=\"viewModel.rating.showForm\"></div>\n\n            <!--Rating-->\n            <div class=\"content\" ng-if=\"viewModel.rating.showForm\">\n                <div>\n                    <span class=\"title\" ui-translate>productTemplateForm.rating.headingTitle</span>\n                    <div class=\"row useAgentRatingFormsForAgentQuoting\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.rating.useAgentRatingFormsForAgentQuoting.name</span>\n                        </div>\n\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.rating.useAgentRatingFormsForAgentQuoting\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"yes\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.rating.useAgentRatingFormsForAgentQuoting.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.rating.useAgentRatingFormsForAgentQuoting\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"no\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.rating.useAgentRatingFormsForAgentQuoting.no</span>\n                        </div>\n                    </div>\n                    <div class=\"requiredRow\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{ viewModel.rating.ratingAdapter.selectedRatingAdapter }}\">\n                        </ui-required-indicator>\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.rating.ratingAdapter.name</span>\n                        </div>\n\n                        <ui-select class=\"dropdownFormComponent dropdownComponentSelect productTemplateDropdown\"\n                                   theme=\"select2\"\n                                   ng-model=\"viewModel.rating.ratingAdapter.selectedRatingAdapter\"\n                                   ng-change=\"handleChange()\"\n                                   append-to-body=\"true\"\n                                   ui-hide-select-on-scrollratingOutputForm\n                                   ui-hide-select-on-scroll-selector=\".formContainer\"\n                                   ng-disabled=\"::!viewModel.hasManagePermission\">\n\n                            <ui-select-match allow-clear=\"true\"\n                                             placeholder=\"{{ ::viewModel.rating.ratingAdapter.prompt}}\">\n                                <span class = \"selectedRatingAdapterName\">{{ viewModel.rating.ratingAdapter.selectedRatingAdapter.name }}</span>\n                            </ui-select-match>\n\n                            <ui-select-choices\n                                repeat=\"item in (viewModel.rating.ratingAdapter.ratingAdapterList | filter: $select.search) track by $index\">\n                                <span>{{item.name}}</span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.rating.ratingOutputForm.name</span>\n                        </div>\n\n                        <ui-select class=\"dropdownFormComponent dropdownComponentSelect productTemplateDropdown\"\n                                   theme=\"select2\"\n                                   ng-model=\"viewModel.rating.ratingOutputForm.selectedRatingOutputForm\"\n                                   append-to-body=\"true\"\n                                   ng-change=\"handleChange()\"\n                                   ui-hide-select-on-scroll\n                                   ui-hide-select-on-scroll-selector=\".formContainer\"\n                                   ng-disabled=\"::!viewModel.hasManagePermission\">\n\n                            <ui-select-match allow-clear=\"true\"\n                                             placeholder=\"{{::viewModel.rating.ratingOutputForm.prompt}}\">\n                                <span>{{viewModel.rating.ratingOutputForm.selectedRatingOutputForm.name}}</span>\n                            </ui-select-match>\n\n                            <ui-select-choices\n                                repeat=\"item in (viewModel.rating.ratingOutputForm.rationOutputFormList | filter: $select.search) track by $index\">\n                                <span>{{item.name}}</span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n\n                    <div class=\"row useRateStatusWhenRating\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.rating.useRateStatusWhenRating.name</span>\n                        </div>\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.rating.useRateStatusWhenRating\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"yes\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.rating.useRateStatusWhenRating.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle statusInActive\"\n                                   ng-change=\"handleChange()\"\n                                   ng-model=\"viewModel.rating.useRateStatusWhenRating\"\n                                   value=\"no\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.rating.useRateStatusWhenRating.no</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"separator\" ng-if=\"viewModel.pricing.showForm\"></div>\n\n            <!--Pricing-->\n            <div class=\"content\" ng-if=\"viewModel.pricing.showForm\">\n                <div>\n                    <span class=\"title\" ui-translate>productTemplateForm.pricing.headingTitle</span>\n                    <div class=\"row enablePricingInputOption\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.pricing.enablePricingInput.name</span>\n                        </div>\n\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.pricing.enablePricingInput\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"yes\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>productTemplateForm.pricing.enablePricingInput.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.pricing.enablePricingInput\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"no\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>productTemplateForm.pricing.enablePricingInput.no</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"separator\" ng-if=\"viewModel.quoting.showForm\"></div>\n\n            <!--Quoting-->\n            <div class=\"content\" ng-if=\"viewModel.quoting.showForm\">\n                <div>\n                    <span class=\"title\" ui-translate>productTemplateForm.quoting.headingTitle</span>\n                    <div class=\"requiredRow\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.quoting.quotingAdapter.selectedQuotingAdapter}}\">\n                        </ui-required-indicator>\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.quoting.quotingAdapter.name</span>\n                        </div>\n                        <ui-select class=\"dropdownFormComponent dropdownComponentSelect productTemplateDropdown quotingAdapter\"\n                                   theme=\"select2\"\n                                   ng-model=\"viewModel.quoting.quotingAdapter.selectedQuotingAdapter\"\n                                   ng-change=\"handleChange()\"\n                                   append-to-body=\"true\"\n                                   ui-hide-select-on-scroll\n                                   ui-hide-select-on-scroll-selector=\".formContainer\"\n                                   ng-disabled=\"::!viewModel.hasManagePermission\">\n                            <ui-select-match allow-clear=\"true\"\n                                             placeholder=\"{{ ::viewModel.quoting.quotingAdapter.prompt}}\">\n                                <span class=\"selectedQuotingAdapterName\">{{viewModel.quoting.quotingAdapter.selectedQuotingAdapter.name}}</span>\n                            </ui-select-match>\n\n                            <ui-select-choices\n                                repeat=\"item in (viewModel.quoting.quotingAdapter.quotingAdapterList | filter: $select.search) track by $index\">\n                                <span>{{item.name}}</span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                    <div class=\"row ratingEnableAgentQuotingOfAllQuotes\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.rating.enableAgentQuotingOfAllQuotes.name</span>\n                        </div>\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.quoting.enableAgentQuotingOfAllQuotes\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"yes\"\n                                    class=\"enableAgentQuotingOfAllQuotesYes\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.rating.enableAgentQuotingOfAllQuotes.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.quoting.enableAgentQuotingOfAllQuotes\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"no\"\n                                    class=\"enableAgentQuotingOfAllQuotesNo\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.rating.enableAgentQuotingOfAllQuotes.no</span>\n                        </div>\n                    </div>\n\n\n                    <div class=\"row\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.quoting.quoteSectionOrdering</span>\n                        </div>\n                        <div class=\"dateRangeContainer\">\n                            <ui-select class=\"dropdownFormComponent dropdownComponentSelect quoteSectionOrdering\"\n                                       theme=\"select2\"\n                                       ng-model=\"viewModel.quoting.quoteSectionOrdering.value\"\n                                       ng-change=\"handleChange()\"\n                                       append-to-body=\"true\"\n                                       ui-hide-select-on-scroll>\n\n                                <ui-select-match>\n                                    <span>{{ viewModel.quoting.quoteSectionOrdering.value }}</span>\n                                </ui-select-match>\n\n                                <ui-select-choices\n                                    repeat=\"item in (viewModel.quoting.quoteSectionOrdering.optionList | filter: $select.search) track by $index\">\n                                    <span>{{ item }}</span>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.quoting.quoteDocumentTemplate</span>\n                        </div>\n                        <div class=\"docTemplate quoteDocTemplateButton\" ng-if=\"displayQuoteDocTemplateButton()\">\n                            <input type=\"button\" value=\"{{viewModel.selectFileToUpload}}\" ng-click=\"openFileDialogBox('quote')\" class=\"btn btn-sm ng-empty\"\n                                   ng-trim=\"false\">\n                        </div>\n                        <div class=\"docTemplate\" ng-if=\"displayQuoteDocTemplateLink()\">\n                            <span>\n                                <a ng-click=\"onTemplateFileDownloadClick('quote')\">{{ viewModel.quoting.quoteTemplateFileName }}</a>\n                            </span>\n                            <span class=\"closeButton glyphicon glyphicon-remove\" ng-click=\"onCloseButtonClicked('quote')\"></span>\n                        </div>\n                        <div class=\"docTemplate\" ng-if=\"displayQuoteDocTemplateFileName()\">\n                            {{ viewModel.quoting.quoteTemplateFileName }}\n                            <span class=\"closeButton glyphicon glyphicon-remove\" ng-click=\"onCloseButtonClicked('quote')\"></span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"separator\" ng-if=\"viewModel.binding.showForm\"></div>\n            <!--Binding-->\n            <div class=\"content\" ng-if=\"viewModel.binding.showForm\">\n                <div>\n                    <span class=\"title\" ui-translate>productTemplateForm.Binding.headingTitle</span>\n                    <div class=\"row enableBindingInput\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.Binding.enableBindingInput.name</span>\n                        </div>\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.binding.enableBindingInput\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"yes\"\n                                    class=\"enableBindingInputYes\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>productTemplateForm.Binding.enableBindingInput.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.binding.enableBindingInput\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"no\"\n                                    class=\"enableBindingInputNo\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>productTemplateForm.Binding.enableBindingInput.no</span>\n                        </div>\n                    </div>\n                    <div class=\"row enableBinder\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.Binding.enableBinder.name</span>\n                        </div>\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.binding.enableBinder\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"yes\"\n                                    class=\"enableBinderYes\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>productTemplateForm.Binding.enableBinder.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.binding.enableBinder\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"no\"\n                                    class=\"enableBinderNo\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>productTemplateForm.Binding.enableBinder.no</span>\n                        </div>\n                    </div>\n                    <div class=\"row enableAgentBindingInput\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.Binding.enableAgentBindingInput.name</span>\n                        </div>\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.binding.enableAgentBindingInput\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"yes\"\n                                    class=\"enableAgentBindingInputYes\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.Binding.enableAgentBindingInput.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.binding.enableAgentBindingInput\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"no\"\n                                    class=\"enableAgentBindingInputNo\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.Binding.enableAgentBindingInput.no</span>\n                        </div>\n                    </div>\n                    <div class=\"row enableAgentBindingOfAllQuotes\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.Binding.enableAgentBindingOfAllQuotes.name</span>\n                        </div>\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.binding.enableAgentBindingOfAllQuotes\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"yes\"\n                                   class=\"enableAgentBindingOfAllQuotesYes\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.Binding.enableAgentBindingOfAllQuotes.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle enableAgentBindingOfAllQuotesNo\"\n                                   ng-model=\"viewModel.binding.enableAgentBindingOfAllQuotes\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"no\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.Binding.enableAgentBindingOfAllQuotes.no</span>\n                        </div>\n                    </div>\n                    <div class=\"row allowBindingMultiplePolicies\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.Binding.allowBindingOfMultiplePolicies.name</span>\n                        </div>\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.binding.allowBindingOfMultiplePolicies\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"yes\"\n                                    class=\"allowBindingOfMultiplePoliciesYes\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.Binding.allowBindingOfMultiplePolicies.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle allowBindingOfMultiplePoliciesNo\"\n                                   ng-model=\"viewModel.binding.allowBindingOfMultiplePolicies\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"no\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.Binding.allowBindingOfMultiplePolicies.no</span>\n                        </div>\n                    </div>\n                    <div class=\"row binderDocumentTemplate\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.Binding.binderDocumentTemplate</span>\n                        </div>\n                        <div class=\"docTemplate binderDocTemplateButton\" ng-if=\"displayBinderDocTemplateButton()\">\n                            <input type=\"button\" value=\"{{viewModel.selectFileToUpload}}\" ng-click=\"openFileDialogBox('binder')\" class=\"btn btn-sm ng-empty\"\n                                   ng-trim=\"false\">\n                        </div>\n                        <div class=\"docTemplate\" ng-if=\"displayBinderDocTemplateLink()\">\n                            <span>\n                                <a ng-click=\"onTemplateFileDownloadClick('binder')\">{{ viewModel.binding.binderTemplateFileName }}</a>\n                            </span>\n                            <span class=\"closeButton glyphicon glyphicon-remove\" ng-click=\"onCloseButtonClicked('binder')\"></span>\n                        </div>\n                        <div class=\"docTemplate\" ng-if=\"displayBinderDocTemplateFileName()\">\n                            {{ viewModel.binding.binderTemplateFileName }}\n                            <span class=\"closeButton glyphicon glyphicon-remove\" ng-click=\"onCloseButtonClicked('binder')\"></span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"separator\" ng-if=\"viewModel.issuance.showForm\"></div>\n\n            <!--Issuance-->\n            <div class=\"content\" ng-if=\"viewModel.issuance.showForm\">\n                <div>\n                    <span class=\"title\" ui-translate>productTemplateForm.issuance.headingTitle</span>\n                    <div class=\"requiredRow\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.issuance.policyAdapter.selectedPolicyAdapter}}\">\n                        </ui-required-indicator>\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.issuance.policyAdapter.name</span>\n                        </div>\n                        <ui-select class=\"dropdownFormComponent dropdownComponentSelect productTemplateDropdown\"\n                                   theme=\"select2\"\n                                   ng-model=\"viewModel.issuance.policyAdapter.selectedPolicyAdapter\"\n                                   ng-change=\"handleChange()\"\n                                   on-select=\"handleChange()\"\n                                   append-to-body=\"true\"\n                                   ui-hide-select-on-scroll\n                                   ui-hide-select-on-scroll-selector=\".formContainer\"\n                                   ng-disabled=\"::!viewModel.hasManagePermission\">\n\n                            <ui-select-match allow-clear=\"true\"\n                                             placeholder=\"{{ ::viewModel.issuance.policyAdapter.prompt}}\">\n                                <span class = \"policyAdapterDropdownValue\">{{viewModel.issuance.policyAdapter.selectedPolicyAdapter.name}}</span>\n                            </ui-select-match>\n\n                            <ui-select-choices\n                                repeat=\"item in (viewModel.issuance.policyAdapter.policyAdapterList | filter: $select.search) track by $index\">\n                                <span>{{item.name}}</span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                    <div class=\"row enableIssuanceInput\">\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.issuance.enableIssuanceInput.name</span>\n                        </div>\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.issuance.enableIssuanceInput\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"yes\"\n                                    class=\"enableIssuanceInputYes\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>productTemplateForm.issuance.enableIssuanceInput.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-change=\"handleChange()\"\n                                   ng-model=\"viewModel.issuance.enableIssuanceInput\"\n                                   value=\"no\"\n                                    class=\"enableIssuanceInputNo\">\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>productTemplateForm.issuance.enableIssuanceInput.no</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"separator\" ng-if=\"viewModel.cancellation.showForm\"></div>\n\n            <!--Cancellation-->\n            <div class=\"content\" ng-if=\"viewModel.cancellation.showForm\">\n                <div>\n                    <span class=\"title\" ui-translate>productTemplateForm.cancellation.headingTitle</span>\n                    <div class=\"row enableAutoRequestCancellation\">\n                        <div class=\"rowItem\">\n                            <span\n                                ui-translate>productTemplateForm.cancellation.enableAutoRequestCancellation.name</span>\n                        </div>\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.cancellation.enableAutoRequestCancellation\"\n                                   value=\"yes\"\n                                   ng-change=\"onEnableAutoRequestCancellationChange()\"\n                                    class=\"enableAutoRequestCancellationYes\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.cancellation.enableAutoRequestCancellation.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle enableAutoRequestCancellationNo\"\n                                   ng-change=\"onEnableAutoRequestCancellationChange()\"\n                                   ng-model=\"viewModel.cancellation.enableAutoRequestCancellation\"\n                                   value=\"no\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.cancellation.enableAutoRequestCancellation.no</span>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"rowItem\">\n                    <span\n                        ui-translate>productTemplateForm.cancellation.daysBeforeExpirationToAutoRequestCancellation</span>\n                        </div>\n                        <input type=\"text\"\n                               class=\"daysBeforeExpirationToAutoRequestCancellation\"\n                               ng-model=\"viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation\"\n                               ng-blur=\"handleDaysBeforeExpirationToAutoRequestCancellation()\"\n                               ng-disabled=\"viewModel.cancellation.disableCancellationRequest || !viewModel.hasManagePermission\"\n                               value=\"{{ viewModel.cancellation.daysBeforeExpirationToAutoRequestCancellation }}\">\n                    </div>\n                    <div class=\"requiredRow\">\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               ng-class=\"{'requiredIndicatorDisable':viewModel.cancellation.requiredFieldStyle === 'hidden'}\"\n                                               visible=\"false\"\n                                               value=\"{{viewModel.cancellation.autoRequestCancellationReason.selectedAutoRequestCancellation}}\">\n                        </ui-required-indicator>\n                        <div class=\"rowItem\">\n                            <span ui-translate>productTemplateForm.cancellation.autoRequestCancellationReason</span>\n                        </div>\n                        <ui-select class=\"dropdownFormComponent dropdownComponentSelect productTemplateDropdown autoRequestCancellationReason\"\n                                   theme=\"select2\"\n                                   ng-model=\"viewModel.cancellation.autoRequestCancellationReason.selectedAutoRequestCancellation\"\n                                   ng-change=\"handleChange()\"\n                                   on-select=\"handleChange()\"\n                                   append-to-body=\"true\"\n                                   ui-hide-select-on-scroll\n                                   ui-hide-select-on-scroll-selector=\".formContainer\"\n                                   ng-disabled=\"viewModel.cancellation.disableCancellationRequest || !viewModel.hasManagePermission\">\n\n                            <ui-select-match\n                                placeholder=\"{{ ::viewModel.cancellation.autoRequestCancellationReason.prompt}}\"\n                                allow-clear=\"true\">\n                                <span>{{viewModel.cancellation.autoRequestCancellationReason.selectedAutoRequestCancellation.name}}</span>\n                            </ui-select-match>\n\n                            <ui-select-choices\n                                repeat=\"item in (viewModel.cancellation.autoRequestCancellationReason.autoRequestCancellationReasonList | filter: $select.search) track by $index\">\n                                <span>{{ item.name }}</span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                    <div class=\"row allowCancellationOnPolicyExpirationDate\">\n                        <div class=\"rowItem\">\n                    <span\n                        ui-translate>productTemplateForm.cancellation.allowCancellationOnPolicyExpirationDate.name</span>\n                        </div>\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.cancellation.allowCancellationOnPolicyExpirationDate\"\n                                   ng-change=\"handleChange()\"\n                                   value=\"yes\"\n                                    class=\"allowCancellationOnPolicyExpirationDateYes\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.cancellation.allowCancellationOnPolicyExpirationDate.yes</span>\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-change=\"handleChange()\"\n                                   ng-model=\"viewModel.cancellation.allowCancellationOnPolicyExpirationDate\"\n                                   value=\"no\"\n                                    class=\"allowCancellationOnPolicyExpirationDateNo\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.cancellation.allowCancellationOnPolicyExpirationDate.no</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"separator\" ng-if=\"viewModel.endorsement.showForm\"></div>\n\n            <!--Endorsement-->\n            <div class=\"content\" ng-if=\"viewModel.endorsement.showForm\">\n                <div>\n                    <span class=\"title\" ui-translate>productTemplateForm.endorsement.headingTitle</span>\n                    <div class=\"row allowEndorsementOnPolicyExpirationDate\">\n                        <div class=\"rowItem\">\n                    <span\n                        ui-translate>productTemplateForm.endorsement.allowEndorsementOnPolicyExpirationDate.name</span>\n                        </div>\n                        <div class=\"radioButtonGroup\">\n                            <input type=\"radio\"\n                                   ng-change=\"handleChange()\"\n                                   ng-model=\"viewModel.endorsement.allowEndorsementOnPolicyExpirationDate\"\n                                   value=\"yes\"\n                                    class=\"allowEndorsementOnPolicyExpirationDateYes\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.endorsement.allowEndorsementOnPolicyExpirationDate.yes</span>\n                            <input type=\"radio\"\n                                   ng-change=\"handleChange()\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.endorsement.allowEndorsementOnPolicyExpirationDate\"\n                                   value=\"no\"\n                                    class=\"allowEndorsementOnPolicyExpirationDateNo\">\n                            <span class=\"radioButtonLabel\" ui-translate>productTemplateForm.endorsement.allowEndorsementOnPolicyExpirationDate.no</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"separator\"\n                 ng-if=\"viewModel.effectiveDateRange.showForm || viewModel.effectiveDateRange.showOnlyPolicyPeriodBoundary\"></div>\n\n            <!--Effective Date Range-->\n            <div class=\"content\">\n\n                <div class=\"title\"\n                     ng-if=\"viewModel.effectiveDateRange.showForm || viewModel.effectiveDateRange.showOnlyPolicyPeriodBoundary\"\n                    ui-translate>productTemplateForm.effectiveDateRange.headingTitle\n                </div>\n\n                <!--Backdating Boundary Producer-->\n                <div class=\"row\" ng-if=\"viewModel.effectiveDateRange.showForm\">\n\n                    <div class=\"rowItem\">\n                        <span ui-translate>productTemplateForm.effectiveDateRange.backdatingBoundaryProducer</span>\n                    </div>\n\n                    <div class=\"dateRangeContainer\">\n                        <ui-select class=\"dropdownFormComponent dropdownComponentSelect backdatingBoundaryProducerDropdown\"\n                                   theme=\"select2\"\n                                   ng-model=\"viewModel.effectiveDateRange.backdatingBoundaryProducer.value\"\n                                   ng-change=\"handleChange()\"\n                                   append-to-body=\"true\"\n                                   ui-hide-select-on-scroll\n                                   ng-disabled=\"viewModel.effectiveDateRange.backdatingBoundaryProducer.checked || !viewModel.hasManagePermission\">\n\n                            <ui-select-match>\n                                <span>{{ viewModel.effectiveDateRange.backdatingBoundaryProducer.value }}</span>\n                            </ui-select-match>\n\n                            <ui-select-choices\n                                repeat=\"item in (viewModel.effectiveDateRange.backdatingBoundaryProducer.optionList | filter: $select.search) track by $index\">\n                                <span>{{ item }}</span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n\n                    <label class=\"dateRangeCheckbox\">\n                        <input type=\"checkbox\"\n                               ng-model=\"viewModel.effectiveDateRange.backdatingBoundaryProducer.checked\"\n                               ng-change=\"onToggleUnlimitedEffectiveDateCheckbox(viewModel.effectiveDateRange.backdatingBoundaryProducer)\"\n                               class=\"backdatingBoundaryProducer\">\n\n                        <span ui-translate>productTemplateForm.effectiveDateRange.unlimited</span>\n                    </label>\n                </div>\n\n                <!--Future Dating Boundary Producer-->\n                <div class=\"row\" ng-if=\"viewModel.effectiveDateRange.showForm\">\n\n                    <div class=\"rowItem\">\n                        <span ui-translate>productTemplateForm.effectiveDateRange.futuredatingBoundaryProducer</span>\n                    </div>\n\n                    <div class=\"dateRangeContainer\">\n                        <ui-select class=\"dropdownFormComponent dropdownComponentSelect futuredatingBoundaryProducerDropdown\"\n                                   theme=\"select2\"\n                                   ng-model=\"viewModel.effectiveDateRange.futuredatingBoundaryProducer.value\"\n                                   ng-change=\"handleChange()\"\n                                   append-to-body=\"true\"\n                                   ui-hide-select-on-scroll\n                                   ng-disabled=\"viewModel.effectiveDateRange.futuredatingBoundaryProducer.checked || !viewModel.hasManagePermission\">\n\n                            <ui-select-match>\n                                <span>{{ viewModel.effectiveDateRange.futuredatingBoundaryProducer.value }}</span>\n                            </ui-select-match>\n\n                            <ui-select-choices\n                                repeat=\"item in (viewModel.effectiveDateRange.futuredatingBoundaryProducer.optionList | filter: $select.search) track by $index\">\n                                <span>{{ item }}</span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n\n                    <label class=\"dateRangeCheckbox\">\n                        <input type=\"checkbox\"\n                               ng-model=\"viewModel.effectiveDateRange.futuredatingBoundaryProducer.checked\"\n                               ng-change=\"onToggleUnlimitedEffectiveDateCheckbox(viewModel.effectiveDateRange.futuredatingBoundaryProducer)\"\n                               class=\"futuredatingBoundaryProducer\">\n\n                        <span ui-translate>productTemplateForm.effectiveDateRange.unlimited</span>\n                    </label>\n                </div>\n\n                <!--Submit Pending Boundary Producer-->\n                <div class=\"row\" ng-if=\"viewModel.effectiveDateRange.showForm\">\n                    <div class=\"rowItem\">\n                        <span ui-translate>productTemplateForm.effectiveDateRange.submitPendingBoundaryProducer</span>\n                    </div>\n                    <div class=\"dateRangeContainer\">\n                        <ui-select class=\"dropdownFormComponent dropdownComponentSelect submitPendingBoundaryProducerDropdown\"\n                                   theme=\"select2\"\n                                   ng-model=\"viewModel.effectiveDateRange.submitPendingBoundaryProducer.value\"\n                                   ng-change=\"handleChange()\"\n                                   append-to-body=\"true\"\n                                   ui-hide-select-on-scroll\n                                   ng-disabled=\"viewModel.effectiveDateRange.submitPendingBoundaryProducer.checked || !viewModel.hasManagePermission\">\n\n                            <ui-select-match>\n                                <span>{{ viewModel.effectiveDateRange.submitPendingBoundaryProducer.value }}</span>\n                            </ui-select-match>\n\n                            <ui-select-choices\n                                repeat=\"item in (viewModel.effectiveDateRange.submitPendingBoundaryProducer.optionList | filter: $select.search) track by $index\">\n                                <span>{{ item }}</span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n\n\n                    <label class=\"dateRangeCheckbox\">\n                        <input type=\"checkbox\"\n                               ng-model=\"viewModel.effectiveDateRange.submitPendingBoundaryProducer.checked\"\n                               ng-change=\"onToggleUnlimitedEffectiveDateCheckbox(viewModel.effectiveDateRange.submitPendingBoundaryProducer)\"\n                               class=\"submitPendingBoundaryProducer\">\n\n                        <span ui-translate>productTemplateForm.effectiveDateRange.unlimited</span>\n                    </label>\n                </div>\n\n                <!--Backdating Boundary Underwriter-->\n                <div class=\"row\" ng-if=\"viewModel.effectiveDateRange.showForm\">\n\n                    <div class=\"rowItem\">\n                        <span ui-translate>productTemplateForm.effectiveDateRange.backdatingBoundaryUnderwriter</span>\n                    </div>\n\n                    <div class=\"dateRangeContainer\">\n                        <ui-select class=\"dropdownFormComponent dropdownComponentSelect backdatingBoundaryUnderwriterDropdown\"\n                                   theme=\"select2\"\n                                   ng-model=\"viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.value\"\n                                   ng-change=\"handleChange()\"\n                                   append-to-body=\"true\"\n                                   ui-hide-select-on-scroll\n                                   ng-disabled=\"viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.checked || !viewModel.hasManagePermission\">\n\n                            <ui-select-match>\n                                <span>{{ viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.value }}</span>\n                            </ui-select-match>\n\n                            <ui-select-choices\n                                repeat=\"item in (viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.optionList | filter: $select.search) track by $index\">\n                                <span>{{ item }}</span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n\n                    <label class=\"dateRangeCheckbox\">\n                        <input type=\"checkbox\"\n                               ng-model=\"viewModel.effectiveDateRange.backdatingBoundaryUnderwriter.checked\"\n                               ng-change=\"onToggleUnlimitedEffectiveDateCheckbox(viewModel.effectiveDateRange.backdatingBoundaryUnderwriter)\"\n                               class=\"backdatingBoundaryUnderwriter\">\n\n                        <span ui-translate>productTemplateForm.effectiveDateRange.unlimited</span>\n                    </label>\n                </div>\n\n                <!--Future Dating Boundary Underwriter-->\n                <div class=\"row\" ng-if=\"viewModel.effectiveDateRange.showForm\">\n                    <div class=\"rowItem\">\n                        <span ui-translate>productTemplateForm.effectiveDateRange.futuredatingBoundaryUnderwriter</span>\n                    </div>\n                    <div class=\"dateRangeContainer\">\n                        <ui-select class=\"dropdownFormComponent dropdownComponentSelect futuredatingBoundaryUnderwriterDropdown\"\n                                   theme=\"select2\"\n                                   ng-model=\"viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.value\"\n                                   ng-change=\"handleChange()\"\n                                   append-to-body=\"true\"\n                                   ui-hide-select-on-scroll\n                                   ng-disabled=\"viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.checked || !viewModel.hasManagePermission\">\n\n                            <ui-select-match>\n                                <span>{{ viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.value }}</span>\n                            </ui-select-match>\n\n                            <ui-select-choices\n                                repeat=\"item in (viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.optionList | filter: $select.search) track by $index\">\n                                <span>{{ item }}</span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n\n                    <label class=\"dateRangeCheckbox\">\n                        <input type=\"checkbox\"\n                               ng-model=\"viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter.checked\"\n                               ng-change=\"onToggleUnlimitedEffectiveDateCheckbox(viewModel.effectiveDateRange.futuredatingBoundaryUnderwriter)\"\n                               class=\"futuredatingBoundaryUnderwriter\">\n\n                        <span ui-translate>productTemplateForm.effectiveDateRange.unlimited</span>\n                    </label>\n                </div>\n\n                <!--Submit Pending Boundary Underwriter-->\n                <div class=\"row\" ng-if=\"viewModel.effectiveDateRange.showForm\">\n                    <div class=\"rowItem\">\n                        <span\n                            ui-translate>productTemplateForm.effectiveDateRange.submitPendingBoundaryUnderwriter</span>\n                    </div>\n                    <div class=\"dateRangeContainer\">\n                        <ui-select class=\"dropdownFormComponent dropdownComponentSelect submitPendingBoundaryUnderwriterDropdown\"\n                                   theme=\"select2\"\n                                   ng-model=\"viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.value\"\n                                   ng-change=\"handleChange()\"\n                                   append-to-body=\"true\"\n                                   ui-hide-select-on-scroll\n                                   ng-disabled=\"viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.checked || !viewModel.hasManagePermission\">\n\n                            <ui-select-match>\n                                <span>{{ viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.value }}</span>\n                            </ui-select-match>\n\n                            <ui-select-choices\n                                repeat=\"item in (viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.optionList | filter: $select.search) track by $index\">\n                                <span>{{ item }}</span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n\n                    <label class=\"dateRangeCheckbox\">\n                        <input type=\"checkbox\"\n                               ng-model=\"viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter.checked\"\n                               ng-change=\"onToggleUnlimitedEffectiveDateCheckbox(viewModel.effectiveDateRange.submitPendingBoundaryUnderwriter)\"\n                               class=\"submitPendingBoundaryUnderwriter\">\n\n                        <span ui-translate>productTemplateForm.effectiveDateRange.unlimited</span>\n                    </label>\n                </div>\n\n                <!--Policy Period Boundary-->\n                <div class=\"row\" ng-if=\"viewModel.effectiveDateRange.showOnlyPolicyPeriodBoundary\">\n\n                    <div class=\"rowItem\">\n                        <span ui-translate>productTemplateForm.effectiveDateRange.policyPeriodBoundary</span>\n                    </div>\n\n                    <div>\n                        <ui-select class=\"dropdownFormComponent dropdownComponentSelect policyPeriodBoundaryDropdown\"\n                                   theme=\"select2\"\n                                   ng-model=\"viewModel.effectiveDateRange.policyPeriodBoundary.value\"\n                                   ng-change=\"handleChange()\"\n                                   append-to-body=\"true\"\n                                   ui-hide-select-on-scroll\n                                   ng-disabled=\"viewModel.effectiveDateRange.policyPeriodBoundary.checked || !viewModel.hasManagePermission\">\n\n                            <ui-select-match>\n                                <span>{{ viewModel.effectiveDateRange.policyPeriodBoundary.value }}</span>\n                            </ui-select-match>\n\n                            <ui-select-choices\n                                repeat=\"item in (viewModel.effectiveDateRange.policyPeriodBoundary.optionList | filter: $select.search) track by $index\">\n                                <span>{{ item }}</span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n\n                    <ui-select class=\"dropdownFormComponent dropdownComponentSelect policyPeriodBoundarySelectedDateType\"\n                               theme=\"select2\"\n                               ng-model=\"viewModel.effectiveDateRange.policyPeriodBoundary.selectedDateType\"\n                               ng-change=\"handleChange()\"\n                               append-to-body=\"true\"\n                               ui-hide-select-on-scroll\n                               ng-disabled=\"viewModel.effectiveDateRange.policyPeriodBoundary.checked || !viewModel.hasManagePermission\">\n\n                        <ui-select-match>\n                            <span>{{viewModel.effectiveDateRange.policyPeriodBoundary.selectedDateType}}</span>\n                        </ui-select-match>\n\n                        <ui-select-choices\n                            repeat=\"item in viewModel.effectiveDateRange.policyPeriodDateTypeList track by $index\">\n                            <span>{{ item }}</span>\n                        </ui-select-choices>\n                    </ui-select>\n\n                    <label class=\"dateRangeCheckbox\">\n                        <input type=\"checkbox\"\n                               ng-model=\"viewModel.effectiveDateRange.policyPeriodBoundary.checked\"\n                               ng-change=\"onToggleUnlimitedEffectiveDateCheckbox(viewModel.effectiveDateRange.policyPeriodBoundary)\"\n                               class=\"policyPeriodBoundary\">\n\n                        <span ui-translate>productTemplateForm.effectiveDateRange.unlimited</span>\n                    </label>\n                </div>\n            </div>\n        </fieldset>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2555:
/***/ (function(module, exports) {

/*@ngInject*/
var ProductTemplateEditorRepository = function ProductTemplateEditorRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadProductTemplateById = function (productTemplateId) {
    var url = '/rest/ProductTemplate/' + productTemplateId;
    return this.get(url);
  };
  this.createProductTemplate = function (productTemplate) {
    var url = '/rest/ProductTemplate';
    return this.post(url, productTemplate);
  };
  this.updateProductTemplate = function (productTemplate) {
    var url = '/rest/ProductTemplate/' + productTemplate.id;
    return this.post(url, productTemplate);
  };
  this.updateDocumentTemplates = function (productTemplate, quoteFile, binderFile) {
    var url = '/rest/ProductTemplate/' + productTemplate.id + '/documentTemplates',
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        // When you assign undefined, the content type defaults to multipart/form-data
        headers: {
          'Content-Type': undefined
        },
        params: {
          quoteFileTemplateId: productTemplate.quoteFileTemplateId,
          binderFileTemplateId: productTemplate.binderFileTemplateId
        }
      };
    formData.append('quoteFile', quoteFile);
    formData.append('binderFile', binderFile);
    return this.post(url, formData, config);
  };
};
ProductTemplateEditorRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('productTemplateEditorRepository', ProductTemplateEditorRepository);

/***/ }),

/***/ 2556:
/***/ (function(module, exports) {

/*@ngInject*/
var ProductTemplateEditorModel = function ProductTemplateEditorModel() {
  var productTemplate = {},
    quoteTemplateFile,
    binderTemplateFile;
  this.hasUnsavedChanges = false;
  this.isValid = false;
  this.getProductTemplate = function () {
    return productTemplate;
  };
  this.setProductTemplate = function (template) {
    productTemplate = template;
  };
  this.getQuoteTemplateFile = function () {
    return quoteTemplateFile;
  };
  this.setQuoteTemplateFile = function (templateFile) {
    quoteTemplateFile = templateFile;
  };
  this.getBinderTemplateFile = function () {
    return binderTemplateFile;
  };
  this.setBinderTemplateFile = function (templateFile) {
    binderTemplateFile = templateFile;
  };
};
angular.module('ums.configuration').service('productTemplateEditorModel', ProductTemplateEditorModel);

/***/ }),

/***/ 2557:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2558);
__webpack_require__(2559);
__webpack_require__(2560);
var ProductTemplateEditorHeaderComponent = {
  templateUrl: '/configuration/productTemplateEditor/header/productTemplateEditorHeader.tpl.html',
  controller: 'productTemplateEditorHeaderController',
  bindings: {
    productTemplateName: '<'
  }
};
angular.module('ums.configuration').component('uiProductTemplateEditorHeader', ProductTemplateEditorHeaderComponent);

/***/ }),

/***/ 2558:
/***/ (function(module) {

module.exports = JSON.parse("{\"productTemplateEditorHeader\":{\"title\":\"Manage Product Templates\",\"typeLabel\":\"Type:\",\"actions\":{\"name\":\"Actions\",\"discard\":\"Discard\",\"save\":\"Save\",\"new product template\":\"New Product\"},\"unsavedChanges\":\"Unsaved changes\",\"invalidProductTemplate\":\"The product template is invalid. Please correct or discard your changes before leaving this page.\",\"discardConfirmation\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"success\":\"Your changes have been discarded.\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"saveProductTemplate\":{\"loadingBar\":\"Saving Product Template...\",\"savingProductTemplateSuccessLoadingBar\":\"Successfully saved product template\"}}}");

/***/ }),

/***/ 2559:
/***/ (function(module, exports) {

var path = '/configuration/productTemplateEditor/header/productTemplateEditorHeader.tpl.html';
var html = "<div class=\"headerRow\">\n    <!--Status-->\n    <div class=\"nameColumn\">\n        <button type=\"button\"\n                class=\"btn-link backButton\"\n                ui-sref=\"configuration.productTemplateBrowser\">\n            <span class=\"glyphicon glyphicon-arrow-left\"></span>\n            <span ui-translate>productTemplateEditorHeader.title</span>\n        </button>\n        <div class=\"productTemplateName\" uib-tooltip=\"{{ $ctrl.productTemplateName }}\">{{ $ctrl.productTemplateName }}</div>\n    </div>\n\n    <div class=\"actionButtonColumn\">\n        <action-buttons-bar context=\"$ctrl.context\"\n                            actions=\"$ctrl.actions\"\n                            action-sub-texts=\"$ctrl.actionSubTexts\"\n                            notify-action-clicked=\"$ctrl.handleAction(action, file)\"\n                            time-last-modified=\"$ctrl.actionsTimeLastModified\"></action-buttons-bar>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2560:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ProductTemplateEditorHeaderController = function ProductTemplateEditorHeaderController($rootScope, $scope, $element, $stateParams, $state, $uibModal, localization, configurationConstant, configurationMediator, coreConstant, modalUtil, productTemplateAction, productTemplateEditorModel, configurationActionsUtil) {
  var _this4 = this;
  $element.addClass('productTemplateEditorHeader');
  this.translations = null;
  this.actions = [];
  this.context = {
    identifier: 'productTemplateEditorHeader',
    actions: {},
    fallthrough: null,
    model: {
      contextType: coreConstant.CONTEXT_NONE
    }
  };
  this.context.actions[coreConstant.CONTEXT_NONE] = '';
  this.actionSubTexts = {};
  this.actionsTimeLastModified = '';
  this.$onInit = function () {
    var _this = this;
    localization.getTranslationByKey('productTemplateEditorHeader').then(function (translations) {
      _this.translations = translations;
      _this.actions = [];
      _this.loadActions();
    });
  };
  this.loadActions = function () {
    var _this2 = this;
    var allActions = [];
    if (_.isEmpty($stateParams.productTemplateName)) {
      var staticActions = [];
      staticActions.push({
        buttonBarAction: true,
        context: null,
        contextOrdering: 0,
        enabled: true,
        groupName: null,
        groupOrdering: 0,
        importantAction: false,
        iwantToAction: false,
        labelKey: null,
        name: 'discard',
        nextAction: false,
        notes: null,
        ordering: 0,
        previousAction: true,
        valid: true
      });
      staticActions.push({
        buttonBarAction: true,
        context: null,
        contextOrdering: 0,
        enabled: true,
        groupName: null,
        groupOrdering: 0,
        importantAction: false,
        iwantToAction: false,
        labelKey: null,
        name: 'save',
        nextAction: true,
        notes: null,
        ordering: 0,
        previousAction: false,
        valid: true
      });
      allActions.push({
        actions: staticActions,
        contextType: this.context.model.contextType
      });
      this.actions = allActions;
      this.actionsTimeLastModified = new Date().getTime();
      this.processActions(allActions, false);
    } else {
      configurationMediator.loadProductTemplateActions($stateParams.productTemplateName).then(function (actions) {
        allActions.push({
          actions: actions.actions,
          contextType: _this2.context.model.contextType
        });
        _this2.actions = allActions;
        _this2.actionsTimeLastModified = new Date().getTime();
        _this2.processActions(allActions, false);
      });
    }
  };
  this.processActions = function (actions) {
    var _this3 = this;
    this.actions = actions;
    this.actionSubTexts = {};
    _.each(this.actions, function (subAction) {
      _.each(subAction.actions, function (action) {
        if (action.name === productTemplateAction.SAVE) {
          action.enabled = productTemplateEditorModel.hasUnsavedChanges && productTemplateEditorModel.isValid;
        } else if (action.name === productTemplateAction.DISCARD) {
          action.enabled = !productTemplateEditorModel.getProductTemplate() || productTemplateEditorModel.hasUnsavedChanges;
        }
        if (action.name === productTemplateAction.SAVE && productTemplateEditorModel.hasUnsavedChanges) {
          _this3.actionSubTexts[action.name] = {
            class: 'unsavedChanges',
            text: _.get(_this3.translations, 'unsavedChanges')
          };
        }
      });
    });
    this.actionsTimeLastModified = new Date().getTime();
  };
  $scope.$on(configurationConstant.event.PRODUCT_TEMPLATE_UPDATED, function () {
    _this4.processActions(_this4.actions);
  });
  this.handleAction = function (action) {
    var _this5 = this;
    if (action.enabled) {
      switch (action.name) {
        case productTemplateAction.SAVE:
          //fetch the data from productTemplateEditorModel
          configurationActionsUtil.saveProductTemplate(productTemplateEditorModel.getProductTemplate()).then(function (productTemplate) {
            $stateParams.productTemplateName = productTemplate.name;
            $stateParams.productTemplateId = productTemplate.id;
            $state.reload();
          });
          break;
        case productTemplateAction.DISCARD:
          modalUtil.showConfirmationModal(null, null, null, 'productTemplateEditorHeader.discardConfirmation', null, true, function () {
            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(_this5.translations, 'discardConfirmation.success'));
            productTemplateEditorModel.hasUnsavedChanges = false;
            if (productTemplateEditorModel.getProductTemplate() && productTemplateEditorModel.getProductTemplate().id) {
              $state.reload();
            } else {
              $state.go('configuration.productTemplateBrowser', {});
            }
          });
          break;
        default:
          modalUtil.showActionNotImplementedModal(action.name);
          break;
      }
    }
  };
  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    var isCurrentStateProductTemplateManager = _.startsWith(fromState.name, 'configuration.productTemplateEditor'),
      isTargetSameAsCurrent = toState.name === fromState.name;
    if (toState.name === 'login') {
      return;
    }
    if (productTemplateEditorModel.hasUnsavedChanges && isCurrentStateProductTemplateManager && !isTargetSameAsCurrent && productTemplateEditorModel.getProductTemplate()) {
      event.preventDefault();
      if (productTemplateEditorModel.isValid) {
        configurationActionsUtil.saveProductTemplate(productTemplateEditorModel.getProductTemplate()).then(function () {
          productTemplateEditorModel.hasUnsavedChanges = false;
          productTemplateEditorModel.isValid = false;
          $state.go(toState, toParams);
        });
      } else {
        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(_this4.translations, 'invalidProductTemplate'));
      }
    } else {
      // there are no changes to be saved, do nothing
    }
  });
};
ProductTemplateEditorHeaderController.$inject = ["$rootScope", "$scope", "$element", "$stateParams", "$state", "$uibModal", "localization", "configurationConstant", "configurationMediator", "coreConstant", "modalUtil", "productTemplateAction", "productTemplateEditorModel", "configurationActionsUtil"];
angular.module('ums.configuration').controller('productTemplateEditorHeaderController', ProductTemplateEditorHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2561:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2562);
__webpack_require__(2563);
__webpack_require__(2564);
__webpack_require__(2565);
__webpack_require__(2572);
/*@ngInject*/
var PopupNotificationBrowserController = function PopupNotificationBrowserController($scope, $rootScope, $state, $timeout, localization, coreConstant, configurationMediator, notificationPreferencesType, notificationPreferencesAction, navigationStateModel, modalUtil, configurationActionsUtil, databaseDownloadSectionName, popupStateModel) {
  localization.getTranslationByKey('popupNotificationBrowser').then(function (translations) {
    $scope.viewModel = {
      popupNotifications: null,
      totalPopupNotification: 0,
      recordCountText: _.get(translations, 'recordCountText'),
      recordsCountText: _.get(translations, 'recordsCountText'),
      isGridEmpty: true,
      requestParams: {
        key: 'name',
        startIndex: 0,
        pageSize: 25,
        sortType: 'asc',
        searchString: ''
      },
      searchPrompt: _.get(translations, 'searchPrompt'),
      shortDateTimeFormat: 'MM/dd/yy hh:mma'
    };
    $scope.actions = [];
    $scope.context = {
      identifier: 'popupNotificationBrowser',
      actions: {},
      fallthrough: null,
      model: {
        contextType: coreConstant.CONTEXT_NONE
      }
    };
    $scope.context.actions[coreConstant.CONTEXT_NONE] = '';
    function loadActions() {
      configurationMediator.loadPopupNotificationActions().then(function (actions) {
        var allActions = [];
        allActions.push({
          actions: actions.actions,
          contextType: $scope.context.model.contextType
        });
        $scope.actions = allActions;
        $scope.actionsTimeLastModified = new Date().getTime();
      });
    }
    function loadPopups() {
      $scope.viewModel.isLoading = true;
      configurationMediator.loadPopupNotification($scope.viewModel.requestParams).then(function (popupNotifications) {
        $scope.viewModel.popupNotifications = popupNotifications.records;
        $scope.viewModel.totalPopupNotification = popupNotifications.totalRecords;
        $scope.viewModel.isGridEmpty = $scope.viewModel.popupNotifications.length === 0;
        $timeout(function () {
          $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
          $scope.viewModel.isLoading = false;
        }, 0);
      });
      popupStateModel.saveViewState('configuration.popupBrowser', null);
      navigationStateModel.saveViewState('configuration.popupBrowser', null);
    }
    function checkPreviousViewState() {
      popupStateModel.restoreViewState($state.name, $scope.viewModel);
      loadPopups();
    }
    $scope.onPagingChange = function ($event, params) {
      $scope.viewModel.requestParams.startIndex = params.startIndex;
      popupStateModel.saveViewState('configuration.popupBrowser', null);
      loadPopups();
    };
    $scope.onSortChange = function (event, params) {
      $scope.viewModel.requestParams.key = params.key;
      $scope.viewModel.requestParams.sortType = params.sortType;
      popupStateModel.saveViewState('configuration.popupBrowser', null);
      loadPopups();
    };
    $scope.onClickRow = function (event, item) {
      var navigationModel = {
        parentState: 'configuration.popupBrowser',
        currentState: 'configuration.managePopup',
        data: {
          templateId: item.id
        }
      };
      $state.go('configuration.managePopup', {
        templateId: item.id
      });
      popupStateModel.saveViewState(navigationModel.parentState, $scope.viewModel);
      navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
    };
    $scope.onSearchInputChange = _.debounce(function () {
      $scope.viewModel.requestParams.startIndex = 0;
      $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
      loadPopups();
    }, 200);
    $scope.$on('$destroy', function () {
      popupStateModel.saveViewState($state.name, $scope.viewModel);
    });
    $scope.onClearSearchTerm = function () {
      $scope.viewModel.requestParams.searchString = '';
      $scope.viewModel.requestParams.startIndex = 0;
      $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
      loadPopups();
    };
    $scope.getStatus = function (item) {
      return item.enabled ? _.get(translations, 'status.active') : _.get(translations, 'status.inactive');
    };
    $scope.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case notificationPreferencesAction.NEW_POPUP:
            $state.go('configuration.managePopup');
            break;
          case notificationPreferencesAction.BACKUP:
            configurationActionsUtil.backup(databaseDownloadSectionName.NOTIFICATION_POPUP_TEMPLATES, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
    loadActions();
    checkPreviousViewState();
  });
  $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
    $scope.$apply();
  });
};
PopupNotificationBrowserController.$inject = ["$scope", "$rootScope", "$state", "$timeout", "localization", "coreConstant", "configurationMediator", "notificationPreferencesType", "notificationPreferencesAction", "navigationStateModel", "modalUtil", "configurationActionsUtil", "databaseDownloadSectionName", "popupStateModel"];
angular.module('ums.configuration').controller('popupNotificationBrowserController', PopupNotificationBrowserController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2562:
/***/ (function(module) {

module.exports = JSON.parse("{\"popupNotificationBrowser\":{\"title\":\"Manage Pop-ups\",\"actions\":{\"name\":\"Actions\",\"New Popup\":\"New Pop Up\",\"backup\":\"Backup\"},\"columns\":{\"name\":\"Name\",\"popupTitle\":\"Pop-Up Title\",\"status\":\"Status\",\"lastEditedBy\":\"Last Edited By\",\"lastModifiedDate\":\"Last Modified Date\"},\"recordCountText\":\"Showing startIndex to endIndex of total Pop up\",\"recordsCountText\":\"Showing startIndex to endIndex of total Pop ups\",\"emptyGrid\":\"No matching Pop Up\",\"status\":{\"active\":\"Active\",\"inactive\":\"Inactive\"},\"backup\":{\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\",\"name\":\"Pop-up\"},\"searchPrompt\":\"Search name, title or message\"}}");

/***/ }),

/***/ 2563:
/***/ (function(module, exports, __webpack_require__) {

var path = '/configuration/popupNotification/popupNotificationBrowser.tpl.html';
var html = "<div class=\"popupNotificationBrowser\">\n    <div class=\"header\">\n        <div class=\"headerContent\">\n            <div class=\"headerLabel\" ui-translate>popupNotificationBrowser.title</div>\n            <action-buttons-bar context=\"context\"\n                                actions=\"actions\"\n                                notify-action-clicked=\"handleAction(action, file)\"\n                                time-last-modified=\"actionsTimeLastModified\"></action-buttons-bar>\n        </div>\n    </div>\n    <div class=\"tools\">\n        <div class=\"toolsContent\">\n            <div class=\"popupNotificationSearch\">\n                <span class=\"glyphicon glyphicon-search\"></span>\n                <input type=\"text\"\n                       ng-model=\"viewModel.requestParams.searchString\"\n                       placeholder=\"{{::viewModel.searchPrompt}}\"\n                       ng-change=\"onSearchInputChange()\"/>\n                <span class=\"glyphicon glyphicon-remove\"\n                   ng-if=\"viewModel.requestParams.searchString\"\n                   ng-click=\"onClearSearchTerm()\"></span>\n            </div>\n        </div>\n    </div>\n    <div class=\"grid\">\n        <div class=\"gridContainer\">\n            <div class=\"columnHeader\">\n                <div class=\"columnRow\">\n                    <div class=\"colHover\"></div>\n                    <div class=\"colName\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"name\"\n                         item-label=\"popupNotificationBrowser.columns.name\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                    <div class=\"colPopupTitle\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"title\"\n                         item-label=\"popupNotificationBrowser.columns.popupTitle\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                    <div class=\"colStatus\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"enabled\"\n                         item-label=\"popupNotificationBrowser.columns.status\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                    <div class=\"colLastEditedBy\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"lastModifiedBy\"\n                         item-label=\"popupNotificationBrowser.columns.lastEditedBy\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                    <div class=\"colLastModifiedDate\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"timeLastModified\"\n                         item-label=\"popupNotificationBrowser.columns.lastModifiedDate\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                </div>\n            </div>\n\n            <div class=\"datagrid table\"\n                 ux-datagrid=\"viewModel.popupNotifications\"\n                 ng-if=\"!viewModel.isLoading\"\n                 ui-scroll-detection\n                 ui-scroll-detection-target=\".columnHeader\">\n\n                <script type=\"template/html\"\n                        data-template-item=\"item\"\n                        data-template-name=\"default\">\n\n                    <div class=\"columnRow\">\n                        <div class=\"columnRowWrapper\">\n                            <div class=\"col colName\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.name }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.nameTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.nameTooltip\">{{ ::item.name }}</span>\n\n                            </div>\n                            <div class=\"col colPopupTitle\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.title }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.titleTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.titleTooltip\">{{ ::item.title }}</span>\n                            </div>\n                            <div class=\"col colStatus\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.status }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.statusTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.statusTooltip\">{{getStatus(item)}}</span>\n                            </div>\n                            <div class=\"col colLastEditedBy\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.lastModifiedBy.name }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.lastModifiedByTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.lastEditedByTooltip\">{{::item.lastModifiedBy.name}}</span>\n                            </div>\n                            <div class=\"col colLastModifiedDate\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.timeLastModified | date: viewModel.shortDateTimeFormat }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.timeLastModifiedTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.lastModifiedDateTooltip\">{{::item.timeLastModified | date: viewModel.shortDateTimeFormat }}</span>\n                            </div>\n                        </div>\n                    </div>\n                </script>\n            </div>\n\n            <ui-grid-paging-component\n                start-index=\"viewModel.requestParams.startIndex\"\n                page-size=\"viewModel.requestParams.pageSize\"\n                total-records=\"viewModel.totalPopupNotification\"\n                record-count-text=\"viewModel.recordCountText\"\n                records-count-text=\"viewModel.recordsCountText\"\n                on-change=\"onPagingChange($event, params)\"></ui-grid-paging-component>\n\n            <div class=\"gridEmpty\"\n                 ng-if=\"viewModel.isGridEmpty && !viewModel.isLoading\" ui-translate>popupNotificationBrowser.emptyGrid</div>\n\n            <div class=\"icon-spinner\"\n                 ng-if=\"viewModel.isLoading\">\n                <img src=\"" + __webpack_require__(52) + "\"/>\n            </div>\n        </div>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2564:
/***/ (function(module, exports) {

/*@ngInject*/
var PopupNotificationRepository = function PopupNotificationRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadPopupNotificationActions = function () {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.underwriting.notification.NotificationPopupTemplate'
        }
      };
    return this.get(url, config);
  };
  this.loadPopupNotification = function (requestParams) {
    var url = '/rest/NotificationPopupTemplate',
      config = {
        params: {
          sortBy: requestParams.key,
          sortDirection: requestParams.sortType,
          startIndex: requestParams.startIndex,
          numberOfRows: requestParams.pageSize,
          searchString: requestParams.searchString
        }
      };
    return this.get(url, config);
  };
};
PopupNotificationRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('popupNotificationRepository', PopupNotificationRepository);

/***/ }),

/***/ 2565:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2566);
__webpack_require__(2567);
__webpack_require__(2568);

/*@ngInject*/
var ManagePopupNotificationController = function ManagePopupNotificationController($rootScope, $scope, $stateParams, localization, configurationConstant, notificationPreferencesAction, notificationPopupTemplateRepository, notificationPopupTemplateModel, currentUserModel, authorizationConstants) {
  localization.getTranslations('managePopupNotification').then(function (translations) {
    $scope.viewModel = {
      backButtonLabel: _.get(translations, 'backButtonLabel'),
      notificationPreferencesAction: notificationPreferencesAction,
      isReadOnly: !currentUserModel.hasAuthorization(authorizationConstants.MANAGE_POPUP_NOTIFICATIONS),
      templateId: $stateParams.templateId,
      notificationPopupTemplate: {
        enabled: true,
        include: 'everyone',
        deletable: true
      },
      namePrompt: translations.managePopupNotification.namePrompt,
      titlePrompt: translations.managePopupNotification.titlePrompt,
      messagePrompt: translations.managePopupNotification.messagePrompt
    };
    notificationPopupTemplateModel.notificationPopupTemplate = $scope.viewModel.notificationPopupTemplate;
    if ($stateParams.templateId) {
      notificationPopupTemplateRepository.getNotificationPopupTemplate($stateParams.templateId).then(function (notificationPopupTemplate) {
        notificationPopupTemplate.include = 'everyone';
        if (notificationPopupTemplate.excludeConsole) {
          if (notificationPopupTemplate.excludeConsole === 'Underwriter') {
            notificationPopupTemplate.include = 'onlyProducer';
          } else if (notificationPopupTemplate.excludeConsole === 'Producer') {
            notificationPopupTemplate.include = 'onlyUnderwriter';
          }
        }
        $scope.viewModel.notificationPopupTemplate = _.cloneDeep(notificationPopupTemplate);
        notificationPopupTemplateModel.reset();
        notificationPopupTemplateModel.notificationPopupTemplate = $scope.viewModel.notificationPopupTemplate;
        if (notificationPopupTemplateModel.notificationPopupTemplate.body) {
          notificationPopupTemplateModel.notificationPopupTemplate.body = notificationPopupTemplateModel.notificationPopupTemplate.body.replace(/\\n/g, '\r\n');
        }
        $rootScope.$broadcast(configurationConstant.event.EMAIL_TEMPLATE_UPDATED);
      });
    }
  });
  $scope.handleChange = function () {
    var notificationPopupTemplate = notificationPopupTemplateModel.notificationPopupTemplate;
    if (notificationPopupTemplate.include === 'everyone') {
      notificationPopupTemplate.excludeConsole = null;
    } else if (notificationPopupTemplate.include === 'onlyProducer') {
      notificationPopupTemplate.excludeConsole = 'Underwriter';
    } else if (notificationPopupTemplate.include === 'onlyUnderwriter') {
      notificationPopupTemplate.excludeConsole = 'Producer';
    }
    notificationPopupTemplateModel.hasUnsavedChanges = true;
    notificationPopupTemplateModel.isValid = isValid();
    $rootScope.$broadcast(configurationConstant.event.EMAIL_TEMPLATE_UPDATED);
  };
  function isValid() {
    var hasName = !_.isEmpty(notificationPopupTemplateModel.notificationPopupTemplate.name),
      hasStatus = notificationPopupTemplateModel.notificationPopupTemplate.enabled != null,
      hasTitle = !_.isEmpty(notificationPopupTemplateModel.notificationPopupTemplate.title),
      hasMessage = !_.isEmpty(notificationPopupTemplateModel.notificationPopupTemplate.body),
      hasInclude = !_.isEmpty(notificationPopupTemplateModel.notificationPopupTemplate.include);
    var result = false; // we need to always return something if the method is intended to return something

    if (hasName && hasStatus && hasTitle && hasMessage && hasInclude) {
      result = true;
    }
    return result;
  }
};
ManagePopupNotificationController.$inject = ["$rootScope", "$scope", "$stateParams", "localization", "configurationConstant", "notificationPreferencesAction", "notificationPopupTemplateRepository", "notificationPopupTemplateModel", "currentUserModel", "authorizationConstants"];
angular.module('ums.configuration').controller('managePopupNotificationController', ManagePopupNotificationController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2566:
/***/ (function(module) {

module.exports = JSON.parse("{\"managePopupNotification\":{\"backButtonLabel\":\"Manage Popup\",\"name\":\"Name\",\"namePrompt\":\"Pop-up Name\",\"status\":\"Status\",\"statusValues\":{\"active\":\"Active\",\"inactive\":\"Inactive\"},\"title\":\"Title\",\"titlePrompt\":\"Pop-up Title\",\"include\":\"Include\",\"includeValues\":{\"everyone\":\"Everyone\",\"onlyUnderwriter\":\"Only Underwriter\",\"onlyProducer\":\"Only Producer\"},\"message\":\"Message\",\"messagePrompt\":\"Pop-up Message\"}}");

/***/ }),

/***/ 2567:
/***/ (function(module, exports) {

var path = '/configuration/popupNotification/managePopupNotification/managePopupNotification.tpl.html';
var html = "<div class=\"managePopupNotification\">\n\n    <!--Header-->\n    <div class=\"header\">\n\n        <ui-manage-popup-notification-header template-id=\"viewModel.templateId\"></ui-manage-popup-notification-header>\n    </div>\n\n    <div class=\"formContainer\">\n\n        <fieldset class=\"subContainer\">\n\n            <div class=\"content\">\n\n                <div>\n\n                    <div class=\"requiredRow\">\n\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.notificationPopupTemplate.name}}\">\n                        </ui-required-indicator>\n\n                        <div class=\"rowItem\">\n                            <span ui-translate>managePopupNotification.name</span>\n                        </div>\n\n                        <input type=\"text\"\n                               ng-model=\"viewModel.notificationPopupTemplate.name\"\n                               ng-disabled=\"!viewModel.notificationPopupTemplate.deletable\"\n                               ng-change=\"handleChange()\"\n                               value=\"{{ viewModel.notificationPopupTemplate.name }}\"\n                               placeholder=\"{{::viewModel.namePrompt}}\"\n                               class=\"textInput popupNotificationName\">\n                    </div>\n\n                    <div class=\"requiredRow\">\n\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.notificationPopupTemplate.enabled!==null}}\">\n                        </ui-required-indicator>\n\n                        <div class=\"rowItem\">\n                            <span ui-translate>managePopupNotification.status</span>\n                        </div>\n\n                        <div class=\"radioButtonGroup\">\n\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.notificationPopupTemplate.enabled\"\n                                   class=\"activePopUp\"\n                                   data-ng-value=\"true\"\n                                   ng-change=\"handleChange()\"\n                                   ng-disabled=\"::viewModel.isReadOnly\">\n\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>managePopupNotification.statusValues.active</span>\n\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle inActivePopUp\"\n                                   ng-model=\"viewModel.notificationPopupTemplate.enabled\"\n                                   data-ng-value=\"false\"\n                                   ng-change=\"handleChange()\"\n                                   ng-disabled=\"::viewModel.isReadOnly\">\n\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>managePopupNotification.statusValues.inactive</span>\n                        </div>\n                    </div>\n\n                    <div class=\"requiredRow\">\n\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.notificationPopupTemplate.title}}\">\n                        </ui-required-indicator>\n\n                        <div class=\"rowItem\">\n                            <span ui-translate>managePopupNotification.title</span>\n                        </div>\n\n                        <input type=\"text\"\n                               ng-model=\"viewModel.notificationPopupTemplate.title\"\n                               ng-change=\"handleChange()\"\n                               value=\"{{ viewModel.notificationPopupTemplate.title }}\"\n                               placeholder=\"{{::viewModel.titlePrompt}}\"\n                               class=\"textInput popupNotificationTitle\"\n                               ng-disabled=\"::viewModel.isReadOnly\">\n                    </div>\n\n                    <div class=\"requiredRow message\">\n\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.notificationPopupTemplate.body}}\">\n                        </ui-required-indicator>\n\n                        <div class=\"rowItem\">\n                            <span ui-translate>managePopupNotification.message</span>\n                        </div>\n\n                        <textarea ng-model=\"viewModel.notificationPopupTemplate.body\"\n                                  ng-change=\"handleChange()\"\n                                  value=\"{{ viewModel.notificationPopupTemplate.body }}\"\n                                  placeholder=\"{{::viewModel.messagePrompt}}\"\n                                  class=\"textInput popupNotificationMessage\"\n                                  ng-disabled=\"::viewModel.isReadOnly\"></textarea>\n                    </div>\n\n                    <div class=\"requiredRow\">\n\n                        <ui-required-indicator class=\"requiredIndicator\"\n                                               value=\"{{viewModel.notificationPopupTemplate.include}}\">\n                        </ui-required-indicator>\n\n                        <div class=\"rowItem\">\n                            <span ui-translate>managePopupNotification.include</span>\n                        </div>\n\n                        <div class=\"radioButtonGroup includeType\">\n\n                            <input type=\"radio\"\n                                   ng-model=\"viewModel.notificationPopupTemplate.include\"\n                                   class=\"everyoneOption\"\n                                   value=\"everyone\"\n                                   ng-change=\"handleChange()\"\n                                   ng-disabled=\"::viewModel.isReadOnly\">\n\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>managePopupNotification.includeValues.everyone</span>\n\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.notificationPopupTemplate.include\"\n                                   value=\"onlyUnderwriter\"\n                                   ng-change=\"handleChange()\"\n                                   ng-disabled=\"::viewModel.isReadOnly\">\n\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>managePopupNotification.includeValues.onlyUnderwriter</span>\n\n                            <input type=\"radio\"\n                                   class=\"radioButtonStyle\"\n                                   ng-model=\"viewModel.notificationPopupTemplate.include\"\n                                   value=\"onlyProducer\"\n                                   ng-change=\"handleChange()\"\n                                   ng-disabled=\"::viewModel.isReadOnly\">\n\n                            <span class=\"radioButtonLabel\"\n                                  ui-translate>managePopupNotification.includeValues.onlyProducer</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </fieldset>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2568:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2569);
__webpack_require__(2570);
__webpack_require__(2571);
var ManagePopupNotificationHeaderComponent = {
  templateUrl: '/configuration/popupNotification/managePopupNotification/header/managePopupNotificationHeader.tpl.html',
  controller: 'managePopupNotificationHeaderController',
  bindings: {
    templateId: '<'
  }
};
angular.module('ums.configuration').component('uiManagePopupNotificationHeader', ManagePopupNotificationHeaderComponent);

/***/ }),

/***/ 2569:
/***/ (function(module) {

module.exports = JSON.parse("{\"managePopupNotificationHeader\":{\"title\":\"Manage Pop-ups\",\"typeLabel\":\"Type:\",\"actions\":{\"name\":\"Actions\",\"discard\":\"Discard\",\"save\":\"Save\",\"delete\":\"Delete\"},\"unsavedChanges\":\"Unsaved changes\",\"invalidNotificationPopupTemplate\":\"The popup template is invalid. Please correct or discard your changes before leaving this page.\",\"discardConfirmation\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"success\":\"Your changes have been discarded.\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"deleteConfirmation\":{\"title\":\"Delete Popup Template\",\"summary\":\"Are you sure you want to delete the popup template?\",\"success\":\"The popup template has been deleted.\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"saveNotificationPopupTemplate\":{\"loadingBar\":\"Saving popup notification...\",\"savingNotificationPopupTemplateSuccessLoadingBar\":\"Successfully saved popup notification\"}}}");

/***/ }),

/***/ 2570:
/***/ (function(module, exports) {

var path = '/configuration/popupNotification/managePopupNotification/header/managePopupNotificationHeader.tpl.html';
var html = "<div class=\"headerRow\">\n    <!--Status-->\n    <div class=\"nameColumn\">\n        <button type=\"button\"\n                class=\"btn-link backButton\"\n                ng-click=\"$ctrl.navigateToPopup()\">\n            <span class=\"glyphicon glyphicon-arrow-left\"></span>\n            <span ui-translate>managePopupNotificationHeader.title</span>\n        </button>\n        <div class=\"popupTemplateName\" uib-tooltip=\"{{ $ctrl.notificationPopupTemplateModel.notificationPopupTemplate.name }}\">{{ $ctrl.notificationPopupTemplateModel.notificationPopupTemplate.name }}</div>\n    </div>\n\n    <div class=\"actionButtonColumn\">\n        <action-buttons-bar context=\"$ctrl.context\"\n                            actions=\"$ctrl.actions\"\n                            action-sub-texts=\"$ctrl.actionSubTexts\"\n                            notify-action-clicked=\"$ctrl.handleAction(action, file)\"\n                            time-last-modified=\"$ctrl.actionsTimeLastModified\"></action-buttons-bar>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2571:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ManagePopupNotificationHeaderController = function ManagePopupNotificationHeaderController($rootScope, $scope, $element, $stateParams, $state, $uibModal, localization, configurationConstant, notificationPopupTemplateRepository, notificationPopupTemplateModel, configurationMediator, coreConstant, modalUtil, notificationPreferencesAction, configurationActionsUtil, loadingBarHandler, navigationStateModel) {
  var _this2 = this;
  $element.addClass('managePopupNotificationHeader');
  this.notificationPopupTemplateModel = notificationPopupTemplateModel;
  this.translations = null;
  this.actions = [];
  this.context = {
    identifier: 'managePopupNotificationHeader',
    actions: {},
    fallthrough: null,
    model: {
      contextType: coreConstant.CONTEXT_NONE
    }
  };
  this.context.actions[coreConstant.CONTEXT_NONE] = '';
  this.actionSubTexts = {};
  this.actionsTimeLastModified = '';
  this.$onInit = function () {
    var _this = this;
    localization.getTranslationByKey('managePopupNotificationHeader').then(function (translations) {
      _this.translations = translations;
      _this.actions = [];
      _this.loadActions();
    });
  };
  $scope.$on(configurationConstant.event.EMAIL_TEMPLATE_UPDATED, function () {
    _this2.processActions(_this2.actions);
  });
  this.loadActions = function () {
    var _this3 = this;
    var templateId = $stateParams.templateId;
    if (!templateId) {
      // new template, pass a dummy id
      templateId = -1;
    }
    notificationPopupTemplateRepository.loadActions(templateId).then(function (actions) {
      var allActions = [];
      allActions.push({
        actions: actions.actions,
        contextType: _this3.context.model.contextType
      });
      _this3.actions = allActions;
      _this3.actionsTimeLastModified = new Date().getTime();
      _this3.processActions(allActions, false);
    });
  };
  this.processActions = function (actions) {
    var _this4 = this;
    this.actions = actions;
    this.actionSubTexts = {};
    _.each(this.actions, function (subAction) {
      _.each(subAction.actions, function (action) {
        if (action.name === notificationPreferencesAction.SAVE) {
          action.enabled = notificationPopupTemplateModel.hasUnsavedChanges && notificationPopupTemplateModel.isValid;
        } else if (action.name === notificationPreferencesAction.DISCARD) {
          action.enabled = notificationPopupTemplateModel.hasUnsavedChanges || !$stateParams.templateId;
        } else if (action.name === notificationPreferencesAction.DELETE) {
          action.enabled = !_.isEmpty($stateParams.templateId);
        }
        if (action.name === notificationPreferencesAction.SAVE && notificationPopupTemplateModel.hasUnsavedChanges) {
          _this4.actionSubTexts[action.name] = {
            class: 'unsavedChanges',
            text: _.get(_this4.translations, 'unsavedChanges')
          };
        }
      });
    });
    this.actionsTimeLastModified = new Date().getTime();
  };
  $scope.$on(configurationConstant.event.PRODUCT_TEMPLATE_UPDATED, function () {
    _this2.processActions(_this2.actions);
  });
  this.handleAction = function (action) {
    var _this5 = this;
    if (action.enabled) {
      switch (action.name) {
        case notificationPreferencesAction.SAVE:
          configurationActionsUtil.saveNotificationPopupTemplate(notificationPopupTemplateModel.notificationPopupTemplate).then(function (popupTemplate) {
            if (!_.isNil(popupTemplate)) {
              $stateParams.templateId = popupTemplate.id;
            }
            $state.reload();
          });
          break;
        case notificationPreferencesAction.DISCARD:
          modalUtil.showConfirmationModal(null, null, null, 'managePopupNotificationHeader.discardConfirmation', null, true, function () {
            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(_this5.translations, 'discardConfirmation.success'));
            notificationPopupTemplateModel.hasUnsavedChanges = false;
            if ($stateParams.templateId) {
              $state.reload();
            } else {
              $state.go('configuration.popupBrowser', {});
            }
          });
          break;
        case notificationPreferencesAction.DELETE:
          modalUtil.showConfirmationModal(null, null, null, 'managePopupNotificationHeader.deleteConfirmation', null, true, function () {
            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(_this5.translations, 'deleteConfirmation.success'));
            return notificationPopupTemplateRepository.deleteNotificationPopupTemplate(notificationPopupTemplateModel.notificationPopupTemplate.id).then(function (popupTemplate) {
              notificationPopupTemplateModel.hasUnsavedChanges = false;
              $state.go('configuration.popupBrowser', {});
            });
          });
          break;
        default:
          modalUtil.showActionNotImplementedModal(action.name);
          break;
      }
    }
  };
  this.navigateToPopup = function () {
    $state.go('configuration.popupBrowser', null);
    navigationStateModel.saveViewState('configuration.popupBrowser', null);
  };
  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    var isCurrentStateNotificationPopupTemplateManager = _.startsWith(fromState.name, 'configuration.managePopup'),
      isTargetSameAsCurrent = toState.name === fromState.name;
    if (toState.name === 'login') {
      return;
    }
    if (notificationPopupTemplateModel.hasUnsavedChanges && isCurrentStateNotificationPopupTemplateManager && !isTargetSameAsCurrent && notificationPopupTemplateModel.notificationPopupTemplate) {
      event.preventDefault();
      if (notificationPopupTemplateModel.isValid) {
        loadingBarHandler.showNotificationLoadingBar(_.get(_this2.translations, 'saveNotificationPopupTemplate.loadingBar'));
        notificationPopupTemplateRepository.saveNotificationPopupTemplate(notificationPopupTemplateModel.notificationPopupTemplate).then(function () {
          loadingBarHandler.concludeNotificationLoadingBar(_.get(_this2.translations, 'saveNotificationPopupTemplate.savingNotificationPopupTemplateSuccessLoadingBar'));
          notificationPopupTemplateModel.reset();
          $state.go(toState, toParams);
        });
      } else {
        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(_this2.translations, 'invalidNotificationPopupTemplate'));
      }
    } else {
      // there are no changes to be saved, do nothing
    }
  });
};
ManagePopupNotificationHeaderController.$inject = ["$rootScope", "$scope", "$element", "$stateParams", "$state", "$uibModal", "localization", "configurationConstant", "notificationPopupTemplateRepository", "notificationPopupTemplateModel", "configurationMediator", "coreConstant", "modalUtil", "notificationPreferencesAction", "configurationActionsUtil", "loadingBarHandler", "navigationStateModel"];
angular.module('ums.configuration').controller('managePopupNotificationHeaderController', ManagePopupNotificationHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2572:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var PopupStateModel = function PopupStateModel($state) {
  var stateModelStorage, templateId;
  this.init = function () {
    stateModelStorage = {};
    templateId = null;
  };
  this.saveViewState = function (stateName, stateModel) {
    stateModelStorage[stateName] = _.cloneDeep(stateModel);
  };
  this.restoreViewState = function (stateName, viewModel) {
    var previousState = stateModelStorage[stateName];
    if (previousState) {
      return _.merge(viewModel, previousState);
    }
  };
  this.init();
};
PopupStateModel.$inject = ["$state"];
angular.module('ums.configuration').service('popupStateModel', PopupStateModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2573:
/***/ (function(module, exports) {

/*@ngInject*/
var NotificationPopupTemplateModel = function NotificationPopupTemplateModel() {
  this.notificationPopupTemplate = {};
  this.hasUnsavedChanges = false;
  this.isValid = false;
  this.reset = function () {
    this.notificationPopupTemplate = {};
    this.hasUnsavedChanges = false;
    this.isValid = false;
  };
};
angular.module('ums.configuration').service('notificationPopupTemplateModel', NotificationPopupTemplateModel);

/***/ }),

/***/ 2574:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2575);
__webpack_require__(2576);

/*@ngInject*/
var RegularExpressionController = function RegularExpressionController($rootScope, $scope, $state, $stateParams, $timeout, localization, coreConstant, configurationConstant, configurationActionsUtil, formViewerConstant, configurationMediator, fieldTemplate, propertyName, propertyValue) {
  var timeoutList = [],
    translations;
  $scope.expressionViewModel = {
    title: '',
    okButton: '',
    cancelButton: '',
    saveButton: '',
    regexpPlaceholder: '',
    testDataPlaceholder: '',
    value: propertyValue,
    testData: '',
    isChanged: false,
    hasError: false
  };
  $scope.uiFormTemplate = null;
  $scope.fieldTemplate = fieldTemplate;
  function init() {
    localization.getTranslationsByKeys(['regularExpression']).then(function (result) {
      translations = result;
      $scope.expressionViewModel.title = translations.title + $scope.fieldTemplate.variableName;
      $scope.expressionViewModel.okButton = translations['confirmButtonLabel'];
      $scope.expressionViewModel.cancelButton = translations['cancelButtonLabel'];
      $scope.expressionViewModel.regexpPlaceholder = translations['regexpPlaceholder'];
      $scope.expressionViewModel.testDataPlaceholder = translations['testDataPlaceholder'];
    });
    configurationMediator.getFormTemplateById($stateParams.uiFormTemplateId).then(function (uiFormTemplate) {
      $scope.uiFormTemplate = uiFormTemplate;
    });
  }
  function updateFieldTemplate() {
    var value = $scope.expressionViewModel.value;
    $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
      name: propertyName,
      value: value
    });
  }
  $scope.onExpressionChange = function () {
    $scope.expressionViewModel.isChanged = true;
  };
  $scope.onTest = function () {
    var regExp = $scope.expressionViewModel.value;
    var value = $scope.expressionViewModel.testData;
    // call rest to test the regular expression
    configurationMediator.validateRegExp(regExp, value).then(function (results) {
      var testResult = 'testSuccess';
      if (results && results.length > 0) {
        testResult = 'testFailure';
      }
      $scope.expressionViewModel.testResult = translations[testResult];
      $scope.expressionViewModel.testResultClass = testResult;
    });
  };
  $scope.onDone = function () {
    updateFieldTemplate();
    $scope.$dismiss();
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$on(coreConstant.event.LOGOUT_COMPLETE, function (event) {
    $scope.$dismiss();
  });
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
  init();
};
RegularExpressionController.$inject = ["$rootScope", "$scope", "$state", "$stateParams", "$timeout", "localization", "coreConstant", "configurationConstant", "configurationActionsUtil", "formViewerConstant", "configurationMediator", "fieldTemplate", "propertyName", "propertyValue"];
angular.module('umCore').controller('regularExpressionController', RegularExpressionController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2575:
/***/ (function(module) {

module.exports = JSON.parse("{\"regularExpression\":{\"title\":\"Regular Expression for \",\"cancelButtonLabel\":\"Cancel\",\"confirmButtonLabel\":\"Done\",\"regularExpression\":\"Regular Expression\",\"testData\":\"Test Data\",\"test\":\"Test\",\"testSuccess\":\"Success! Test Data is valid for Regular Expression entered\",\"testFailure\":\"Test Failed. Test data does not match Regular Expression\",\"editorPlaceholder\":\"Use the controls above to create a JavaScript expression\",\"help\":[\"<b>Commonly Used Regular Expression Characters</b><br/>\",\"\\\\ (backslash) escapes the special meaning of special characters.<br/>\",\". (period) matches any single character.<br/>\",\"* (asterisk) matches the previous item, repeated zero or more times.<br/>\",\"+ (plus sign) matches the previous item, repeated one or more times.<br/>\",\"? (question mark) matches the previous item, repeated one or zero times.<br/>\",\"| (pipe) matches either the left or the right side of the expression.<br/>\",\"(group) groups characters.<br/>\",\"\\\\d matches a decimal digit.<br/>\",\"\\\\D matches any character that is not a digit.<br/>\"]}}");

/***/ }),

/***/ 2576:
/***/ (function(module, exports) {

var path = '/configuration/regularExpression/regularExpressionTemplate.tpl.html';
var html = "<base-modal\n    modal-title=\"expressionViewModel.title\"\n    ok=\"expressionViewModel.okButton\"\n    cancel=\"expressionViewModel.cancelButton\"\n    is-confirm-disabled=\"!expressionViewModel.isChanged || expressionViewModel.hasError\"\n    on-confirm=\"onDone()\"\n    on-cancel=\"onCancel()\">\n\n    <div class=\"regexpBox\" ui-browser-detection>\n\n        <div class=\"regexpTools\">\n            <div class=\"input-item regularExpression\">\n                <span ui-translate class=\"selector-label\">regularExpression.regularExpression</span>\n                <textarea ng-model=\"expressionViewModel.value\"\n                          ng-change=\"onExpressionChange()\"></textarea>\n            </div>\n\n            <div class=\"input-item testData\">\n                <span ui-translate class=\"selector-label\">regularExpression.testData</span>\n                <input ui-max-chars=\"100\"\n                       ng-model=\"expressionViewModel.testData\"/>\n            </div>\n\n            <div class=\"actions\">\n                <button type=\"button\"\n                        class=\"btn btn-primary\"\n                        ng-disabled=\"!expressionViewModel.value\"\n                        ng-click=\"onTest()\">\n                    <span ui-translate>regularExpression.test</span>\n                </button>\n            </div>\n        </div>\n        <div class=\"regexpMessage\">\n            <span ng-show=\"expressionViewModel.testResultClass==='testSuccess'\">\n                <i class=\"fa fa-check-circle-o\" style=\"color:green\"></i>\n            </span>\n            <span class=\"fa-stack\" ng-show=\"expressionViewModel.testResultClass==='testFailure'\">\n                <i class=\"fa fa-close fa-stack-1x\" style=\"color:red\"></i>\n                <i class=\"fa fa-circle-o fa-stack-1x\" style=\"color:red\"></i>\n            </span>\n            <span class=\"{{expressionViewModel.testResultClass}}\">{{expressionViewModel.testResult}}</span>\n        </div>\n\n        <div class=\"regexpHelp\" ui-translate>regularExpression.help</div>\n\n   </div>\n\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2577:
/***/ (function(module, exports) {

/*@ngInject*/
var ObjectRepository = function ObjectRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getObjectNames = function (matchingName) {
    var url = '/rest/Object/';
    return this.get(url);
  };
  this.getObjectPropertyValues = function (objectName) {
    var url = '/rest/Object/' + objectName;
    return this.get(url);
  };
};
ObjectRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('objectRepository', ObjectRepository);

/***/ }),

/***/ 2578:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2579);
__webpack_require__(2580);

/*@ngInject*/
var RuleBuilderController = function RuleBuilderController($rootScope, $scope, $stateParams, ruleModel, ruleUtil, configurationConstant, currentUserModel, authorizationConstants, umStudioConstant, ruleEntryStatus, loadingBarHandler, configurationMediator, $uibModal, localization) {
  $scope.viewModel = {
    rule: null,
    topLevelRuleCondition: {},
    ruleActions: {},
    ruleSetName: '',
    translations: null
  };
  function init() {
    ruleModel.buildRule($stateParams.ruleId).then(function () {
      var rule = ruleModel.getRule($stateParams.ruleId);
      $scope.viewModel.rule = rule;
      $scope.viewModel.topLevelRuleCondition = rule.condition;
      $scope.viewModel.ruleActions = rule.actions;
      $scope.viewModel.ruleSetName = ruleUtil.getRuleSetName(rule);
      $scope.viewModel.canUserManageFormRules = canManageFormRules();
    });
    localization.getTranslationByKey('ruleBuilderHeader').then(function (translations) {
      $scope.viewModel.translations = translations;
    }.bind(this));
  }
  function canManageFormRules() {
    var rule = ruleModel.getRule(parseInt($stateParams.ruleId));
    return currentUserModel.hasAuthorization(authorizationConstants.MANAGE_RULES) && rule.status !== ruleEntryStatus.STATUS_INACTIVE;
  }
  $scope.$on('$destroy', function () {
    ruleModel.reset($stateParams.ruleId);
  });
  $scope.$on(configurationConstant.event.RULE_MODEL_UPDATED, function (event, ruleId) {
    var rule = null;
    if (parseInt($stateParams.ruleId) === ruleId) {
      rule = ruleModel.getRule(ruleId);
      $scope.viewModel.topLevelRuleCondition = rule.condition;
      $scope.viewModel.ruleActions = rule.actions;
      $scope.viewModel.ruleSetName = ruleUtil.getRuleSetName(rule);
    }
  });
  $scope.$on(umStudioConstant.event.RULE_STATUS_UPDATED, function () {
    $scope.viewModel.canUserManageFormRules = canManageFormRules();
  });
  $scope.$on(umStudioConstant.event.RULE_UPDATED, function () {
    ruleModel.setUnsavedChanges($stateParams.ruleId, /*hasUnsavedChanges*/true);
  });
  $scope.handleChange = function () {
    $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
  };
  $scope.generateRuleObject = function () {
    $scope.viewModel.ruleObjectString = JSON.stringify($scope.viewModel.topLevelRuleCondition, null, 4);
  };
  $scope.reviewRule = function () {
    var rule = ruleModel.getRule(parseInt($stateParams.ruleId));
    loadingBarHandler.showNotificationLoadingBar(_.get($scope.viewModel.translations, 'reviewRuleNotificationMessage'));
    return configurationMediator.validateRule(rule).then(function (result) {
      showValidateRuleModal(result);
    }).finally(function () {
      loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
    });
  };
  function showValidateRuleModal(validateRuleResult) {
    var instance = $uibModal.open({
      templateUrl: '/configuration/formEditor/content/rule/reviewRule/validateRuleModal.tpl.html',
      controller: 'validateRuleModalController',
      windowClass: 'validateRuleModal',
      resolve: {
        options: function options() {
          return {
            ruleText: validateRuleResult.ruleText,
            error: validateRuleResult.errors
          };
        }
      }
    });
    return instance.result;
  }
  init();
};
RuleBuilderController.$inject = ["$rootScope", "$scope", "$stateParams", "ruleModel", "ruleUtil", "configurationConstant", "currentUserModel", "authorizationConstants", "umStudioConstant", "ruleEntryStatus", "loadingBarHandler", "configurationMediator", "$uibModal", "localization"];
angular.module('ums.configuration').controller('ruleBuilderController', RuleBuilderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2579:
/***/ (function(module, exports) {

var path = '/configuration/ruleBuilder/ruleBuilder.tpl.html';
var html = "<div class=\"ruleBuilder\">\n    <ui-rule-builder-header></ui-rule-builder-header>\n\n    <div class=\"rule\">\n        <div class=\"reviewRow\">\n\n            <!--Priority-->\n            <span class=\"priority\">\n                <span class=\"priorityLabel\"\n                     ui-translate>ruleBuilderHeader.priorityLabel\n                </span>\n                <span class=\"detailValue priorityValue\">\n                  <input type=\"number\"\n                         ng-model=\"viewModel.rule.priority\"\n                         value=\"{{ viewModel.rule.priority }}\"\n                         ng-change=\"handleChange()\"/>\n                </span>\n            </span>\n\n            <span class=\"review btn-link\" ui-translate\n                  ng-click=\"reviewRule()\">\n                  ruleHeader.review\n            </span>\n        </div>\n\n        <div class=\"ruleConditions\">\n            <ui-rule-condition-group rule-condition-group=\"viewModel.topLevelRuleCondition\"\n                                     is-top-level=\"true\"\n                                     can-user-manage-form-rules=\"viewModel.canUserManageFormRules\">\n            </ui-rule-condition-group>\n        </div>\n\n        <div class=\"ruleActions\">\n\n            <ui-rule-action-group rule-action-group=\"viewModel.ruleActions\"\n                                  rule-set-name=\"viewModel.ruleSetName\"\n                                  can-user-manage-form-rules=\"viewModel.canUserManageFormRules\">\n            </ui-rule-action-group>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2580:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2581);
__webpack_require__(2582);
__webpack_require__(2583);
__webpack_require__(2584);
__webpack_require__(2585);
var RuleBuilderHeaderComponent = {
  templateUrl: '/configuration/ruleBuilder/header/ruleBuilderHeader.tpl.html',
  controller: 'ruleBuilderHeaderController',
  bindings: {}
};
angular.module('ums').component('uiRuleBuilderHeader', RuleBuilderHeaderComponent);

/***/ }),

/***/ 2581:
/***/ (function(module) {

module.exports = JSON.parse("{\"ruleBuilderHeader\":{\"title\":\"Manage Rules\",\"descriptionLabel\":\"Description:\",\"backButton\":\"Back\",\"statusLabel\":\"Status:\",\"ruleSetLabel\":\"Rule Set:\",\"priorityLabel\":\"Priority:\",\"status\":{\"0\":\"Inactive\",\"1\":\"Active\",\"2\":\"Invalid\",\"4\":\"Debug\"},\"actions\":{\"name\":\"Actions\",\"discard\":\"Discard\",\"save\":\"Save\",\"deactivate\":\"Deactivate\",\"activate\":\"Activate\",\"rule settings\":\"Rule Settings\",\"delete\":\"Delete\",\"review\":\"Review\",\"redeploy\":\"Redeploy\"},\"discard\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"success\":\"Your changes have been discarded.\"},\"delete\":{\"title\":\"Delete Rule\",\"summary\":\"Are you sure you want to delete this rule?\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"success\":\"Successfully deleted rule\"},\"deleteRuleLoadingBar\":\"Deleting rule\",\"deleteRuleSuccessLoadingBar\":\"Successfully deleted rule\",\"savingRuleLoadingBar\":\"Saving rule\",\"savingRuleSuccessLoadingBar\":\"Successfully saved rule\",\"savingRuleSuccessWithValidationErrorsLoadingBar\":\"The rule has been saved with one or more error(s) and has been marked as invalid\",\"unsavedChanges\":\"Unsaved changes\",\"reviewRuleNotificationMessage\":\"Validating rule\"}}");

/***/ }),

/***/ 2582:
/***/ (function(module, exports) {

var path = '/configuration/ruleBuilder/header/ruleBuilderHeader.tpl.html';
var html = "<div class=\"headerRow\">\n\n    <!--Status-->\n    <div class=\"nameColumn\">\n        <button type=\"button\"\n                class=\"btn-link backButton\"\n                ui-sref=\"configuration.rulesBrowser\">\n            <span class=\"glyphicon glyphicon-arrow-left\"></span>\n            <span ui-translate>ruleBuilderHeader.title</span>\n        </button>\n\n        <div class=\"ruleName\" uib-tooltip=\"{{ $ctrl.rule.name }}\">{{ $ctrl.rule.name }}</div>\n    </div>\n\n    <div class=\"ruleDetailsColumn\">\n\n        <!--Status-->\n        <div class=\"detailColumn\">\n            <div class=\"detailLabel statusLabel\"\n                 ui-translate>ruleBuilderHeader.statusLabel\n            </div>\n\n            <div ng-class=\"{'detailValue statusValue statusValueInvalid': $ctrl.getStatus() === 'Invalid',\n                            'detailValue statusValue' : $ctrl.getStatus() !== 'Invalid' }\">{{ $ctrl.getStatus() }}\n            </div>\n        </div>\n\n        <!--Description-->\n        <div class=\"detailColumn\">\n            <div class=\"detailLabel descriptionLabel\"\n                 ui-translate>ruleBuilderHeader.descriptionLabel\n            </div>\n\n            <div class=\"detailValue descriptionValue\"\n                 uib-tooltip=\"{{ $ctrl.rule.description }}\">\n                <span>{{ $ctrl.rule.description }}</span>\n            </div>\n        </div>\n\n        <!--Rule Set-->\n        <div class=\"detailColumn\">\n            <div class=\"detailLabel ruleSetLabel\"\n                 ui-translate>ruleBuilderHeader.ruleSetLabel\n            </div>\n\n            <div class=\"detailValue ruleSetValue\">{{ $ctrl.getRuleSet() }}\n            </div>\n        </div>\n    </div>\n\n    <div class=\"actionButtonColumn\">\n        <action-buttons-bar context=\"$ctrl.context\"\n                            actions=\"$ctrl.actions\"\n                            action-sub-texts=\"$ctrl.actionSubTexts\"\n                            notify-action-clicked=\"$ctrl.handleAction(action, file)\"\n                            time-last-modified=\"$ctrl.actionsTimeLastModified\"></action-buttons-bar>\n    </div>\n\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2583:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RuleBuilderHeaderController = function RuleBuilderHeaderController($rootScope, $scope, $element, $stateParams, $state, $uibModal, localization, configurationConstant, configurationMediator, coreConstant, ruleActionsUtil, ruleModel, modalUtil, ruleAction, ruleUtil, umStudioConstant) {
  var _this4 = this;
  $element.addClass('ruleBuilderHeader');
  this.rule = null;
  this.translations = null;
  this.actions = [];
  this.context = {
    identifier: 'ruleBuilderHeader',
    actions: {},
    fallthrough: null,
    model: {
      contextType: coreConstant.CONTEXT_NONE
    }
  };
  this.context.actions[coreConstant.CONTEXT_NONE] = '';
  this.actionSubTexts = {};
  this.$onInit = function () {
    var _this = this;
    localization.getTranslationByKey('ruleBuilderHeader').then(function (translations) {
      _this.rule = ruleModel.getRule($stateParams.ruleId);
      _this.translations = translations;
      _this.loadActions();
    });
  };
  this.loadActions = function () {
    var _this2 = this;
    configurationMediator.loadRuleBuilderActions("com.firstbest.rules.model.Rule:".concat($stateParams.ruleId)).then(function (actions) {
      var allActions = [];
      allActions.push({
        actions: actions.actions,
        contextType: _this2.context.model.contextType
      });
      _this2.processActions(allActions, /*enableSaveAndDiscard*/false);
    });
  };
  this.processActions = function (actions) {
    var _this3 = this;
    this.actions = actions;
    this.actionSubTexts = {};
    _.each(this.actions, function (subAction) {
      _.each(subAction.actions, function (action) {
        if (action.name === ruleAction.SAVE) {
          action.enabled = false;
          if (ruleModel.hasUnsavedChanges($stateParams.ruleId)) {
            _this3.actionSubTexts[action.name] = {
              class: 'unsavedChanges',
              text: _.get(_this3.translations, 'unsavedChanges')
            };
            action.enabled = true;
          }
        }
        if (action.name === ruleAction.DISCARD) {
          action.enabled = false;
          if (ruleModel.hasUnsavedChanges($stateParams.ruleId)) {
            action.enabled = true;
          }
        }
      });
    });
    this.actionsTimeLastModified = new Date().getTime();
  };
  this.getStatus = function () {
    if (!_.isNil(this.rule)) {
      return _.get(this.translations, 'status.' + this.rule.status);
    }
    return '';
  };
  this.getRuleSet = function () {
    return ruleUtil.getRuleSetName(this.rule);
  };
  this.handleAction = function (action, file) {
    if (action.enabled) {
      switch (action.name) {
        case ruleAction.SAVE:
          ruleActionsUtil.saveRule(this.rule).then(function () {
            $rootScope.$broadcast(umStudioConstant.event.RULE_STATUS_UPDATED);
          });
          break;
        case ruleAction.DISCARD:
          ruleActionsUtil.discardChanges();
          break;
        case ruleAction.DELETE:
          ruleActionsUtil.delete(this.rule);
          break;
        case ruleAction.RULE_SETTINGS:
          $uibModal.open({
            templateUrl: '/configuration/ruleTemplateSettings/ruleTemplateSettings.tpl.html',
            controller: 'ruleTemplateSettingsController',
            windowClass: 'ruleTemplateSettingsModal',
            resolve: {
              options: {
                rule: this.rule
              }
            }
          });
          break;
        case ruleAction.DEACTIVATE:
          ruleActionsUtil.deactivateRule(this.rule);
          break;
        case ruleAction.ACTIVATE:
          ruleActionsUtil.activateRule(this.rule);
          break;
        case ruleAction.REDEPLOY:
          ruleUtil.redeployRuleSets(this.rule.parentId);
          break;
        default:
          modalUtil.showActionNotImplementedModal(action.name);
          break;
      }
    }
  };
  $scope.$on(configurationConstant.event.RULE_MODEL_UPDATED, function (event, ruleId) {
    if (parseInt($stateParams.ruleId) === ruleId) {
      _this4.rule = ruleModel.getRule(ruleId);
    }
    _this4.processActions(_this4.actions);
  });
  $scope.$on(umStudioConstant.event.RULE_UPDATED, function () {
    _this4.processActions(_this4.actions);
  });
  $scope.$on(umStudioConstant.event.RULE_STATUS_UPDATED, function () {
    _this4.loadActions();
  });
  $scope.$on(umStudioConstant.event.RULE_VARIABLE_VALUE_CHANGED, function () {
    _this4.processActions(_this4.actions);
  });
  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    var isCurrentStateRuleBuilder = _.startsWith(fromState.name, 'configuration.ruleBuilder'),
      isTargetSameAsCurrent = toState.name === fromState.name;
    if (toState.name === 'login') {
      return;
    }
    if (ruleModel.hasUnsavedChanges($stateParams.ruleId) && isCurrentStateRuleBuilder && !isTargetSameAsCurrent) {
      event.preventDefault();
      ruleActionsUtil.saveRule(_this4.rule).then(function () {
        $state.go(toState, toParams);
      });
    }
  });
};
RuleBuilderHeaderController.$inject = ["$rootScope", "$scope", "$element", "$stateParams", "$state", "$uibModal", "localization", "configurationConstant", "configurationMediator", "coreConstant", "ruleActionsUtil", "ruleModel", "modalUtil", "ruleAction", "ruleUtil", "umStudioConstant"];
angular.module('ums.configuration').controller('ruleBuilderHeaderController', RuleBuilderHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2584:
/***/ (function(module, exports) {

/*@ngInject*/
var RuleActionRepository = function RuleActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadRuleAction = function (uri) {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: uri
        }
      };
    return this.get(url, config);
  };
};
RuleActionRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('ruleActionRepository', RuleActionRepository);

/***/ }),

/***/ 2585:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RuleActionsUtil = function RuleActionsUtil($rootScope, $state, ruleMediator, ruleModel, localization, loadingBarHandler, ruleEntryStatus, modalUtil, coreConstant, umStudioConstant) {
  var _this = this;
  localization.getTranslationByKey('ruleBuilderHeader').then(function (translations) {
    _this.translations = translations;
    _this.saveRule = function (rule) {
      var _this2 = this;
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'savingRuleLoadingBar'));
      var promise = ruleMediator.updateRule(rule).then(function (updatedRule) {
        ruleModel.updateRule(updatedRule);
        if (updatedRule.status === ruleEntryStatus.STATUS_INVALID) {
          loadingBarHandler.concludeNotificationLoadingBar(_.get(_this2.translations, 'savingRuleSuccessWithValidationErrorsLoadingBar'));
        } else {
          loadingBarHandler.concludeNotificationLoadingBar(_.get(_this2.translations, 'savingRuleSuccessLoadingBar'));
        }
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    };
    _this.discardChanges = function () {
      var _this3 = this;
      modalUtil.showConfirmationModal(null, null, null, 'ruleBuilderHeader.discard', null, true, function () {
        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(_this3.translations, 'discard.success'));
        $state.reload();
      });
    };
    _this.delete = function (rule) {
      modalUtil.showConfirmationModal(rule.id, null, null, 'ruleBuilderHeader.delete', null, /*hideLoadingBar*/true, handleDeleteConfirm);
      function handleDeleteConfirm() {
        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'deleteRuleLoadingBar'));
        return ruleMediator.deleteRule(rule.id).then(function () {
          loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'deleteRuleSuccessLoadingBar'));
          $state.go('configuration.rulesBrowser', {});
        });
      }
    };
    _this.activateRule = function (rule) {
      return ruleMediator.activateRule(rule.id).then(function (updatedRule) {
        ruleModel.updateRule(updatedRule);
        $rootScope.$broadcast(umStudioConstant.event.RULE_STATUS_UPDATED);
      });
    };
    _this.deactivateRule = function (rule) {
      return ruleMediator.deactivateRule(rule.id).then(function (updatedRule) {
        ruleModel.updateRule(updatedRule);
        $rootScope.$broadcast(umStudioConstant.event.RULE_STATUS_UPDATED);
      });
    };
  });
};
RuleActionsUtil.$inject = ["$rootScope", "$state", "ruleMediator", "ruleModel", "localization", "loadingBarHandler", "ruleEntryStatus", "modalUtil", "coreConstant", "umStudioConstant"];
angular.module('ums.configuration').service('ruleActionsUtil', RuleActionsUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2586:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2587);
__webpack_require__(2588);
__webpack_require__(2589);
__webpack_require__(2590);
__webpack_require__(2591);
__webpack_require__(2592);

/*@ngInject*/
var RulesBrowserController = function RulesBrowserController($scope, $uibModal, $filter, advancedFilterType, configurationMediator, filterType, localization, modalUtil, ruleAction, ruleUtil, configurationActionsUtil, databaseDownloadSectionName) {
  localization.getTranslationByKey('rulesBrowser').then(function (translations) {
    $scope.columns = [{
      name: 'name',
      label: _.get(translations, 'columns.name'),
      className: 'colName',
      getValue: function getValue(item) {
        return item.name;
      }
    }, {
      name: 'ruleSetName',
      label: _.get(translations, 'columns.ruleSet'),
      className: 'colRuleSet',
      getValue: function getValue(item) {
        return item.ruleSetName;
      }
    }, {
      name: 'tags',
      label: _.get(translations, 'columns.tags'),
      className: 'colTags',
      getColumnItems: function getColumnItems(item) {
        return item.tags;
      },
      getValue: function getValue(item) {
        return item.name;
      },
      isTag: function isTag(item) {
        return true;
      }
    }, {
      name: 'priority',
      label: _.get(translations, 'columns.priority'),
      className: 'colPriority',
      getValue: function getValue(item) {
        return item.priority;
      }
    }, {
      name: 'status',
      label: _.get(translations, 'columns.status'),
      className: 'colStatus',
      getValue: function getValue(item) {
        return _.get(translations, 'status.' + item.status);
      }
    }, {
      name: 'lastModifiedBy',
      label: _.get(translations, 'columns.lastModifiedBy'),
      className: 'colLastModifiedBy',
      getValue: function getValue(item) {
        return item.lastModifiedBy;
      }
    }, {
      name: 'timeLastModified',
      label: _.get(translations, 'columns.timeLastModified'),
      className: 'colTimeLastModified',
      getValue: function getValue(item) {
        return $filter('date')(item.timeLastModified, 'MM/dd/yy hh:mma');
      }
    }];
    $scope.advancedFilterType = advancedFilterType.RULES_BROWSER;
    $scope.filterType = filterType.TYPE_RULE_FILTER;
    $scope.stateParams = {
      browser: 'configuration.rulesBrowser',
      getDetailState: function getDetailState(rule) {
        return {
          name: 'configuration.ruleBuilder',
          params: {
            ruleId: rule.id,
            ruleSetName: rule.ruleSetName
          }
        };
      }
    };
    $scope.translations = {
      title: _.get(translations, 'title'),
      recordCountText: _.get(translations, 'recordCountText'),
      recordsCountText: _.get(translations, 'recordsCountText'),
      emptyGrid: _.get(translations, 'emptyGrid')
    };
    $scope.initialRequestParams = {
      key: 'name',
      startIndex: 0,
      pageSize: 25,
      sortType: 'asc'
    };
    $scope.loadActionsHandler = function () {
      return configurationMediator.loadRulesBrowserActions();
    };
    $scope.loadItemsHandler = function (filterUri, requestParams) {
      return configurationMediator.getRulesByFilterUri(filterUri, requestParams);
    };
    $scope.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case ruleAction.NEW_RULE:
            $uibModal.open({
              templateUrl: '/configuration/ruleTemplateSettings/ruleTemplateSettings.tpl.html',
              controller: 'ruleTemplateSettingsController',
              windowClass: 'ruleTemplateSettingsModal',
              resolve: {
                options: {
                  ruleTemplateId: null
                }
              }
            });
            break;
          case ruleAction.REDEPLOY:
            ruleUtil.redeployRuleSets();
            break;
          case ruleAction.BACKUP:
            configurationActionsUtil.backup(databaseDownloadSectionName.RULE_SETS, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
  });
};
RulesBrowserController.$inject = ["$scope", "$uibModal", "$filter", "advancedFilterType", "configurationMediator", "filterType", "localization", "modalUtil", "ruleAction", "ruleUtil", "configurationActionsUtil", "databaseDownloadSectionName"];
angular.module('ums.configuration').controller('rulesBrowserController', RulesBrowserController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2587:
/***/ (function(module) {

module.exports = JSON.parse("{\"rulesBrowser\":{\"title\":\"Manage Rules\",\"columns\":{\"name\":\"Name\",\"ruleSet\":\"Rule Set\",\"tags\":\"Tags\",\"priority\":\"Priority\",\"status\":\"Status\",\"lastModifiedBy\":\"Last Edited By\",\"timeLastModified\":\"Last Modified Date\"},\"emptyGrid\":\"No matching rules\",\"recordCountText\":\"Showing startIndex to endIndex of total rules\",\"recordsCountText\":\"Showing startIndex to endIndex of total rules\",\"clearButton\":\"Clear All\",\"status\":{\"0\":\"Inactive\",\"1\":\"Active\",\"2\":\"Invalid\",\"3\":\"Debug\"},\"textInputFilter\":{\"nameOrTag\":{\"placeholder\":\"Search name or tags\"}},\"selectFilter\":{\"ruleSets\":{\"placeholder\":\"All Rule Sets\"},\"statuses\":{\"placeholder\":\"All Statuses\"}},\"backup\":{\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\",\"name\":\"Rule Sets\"},\"actions\":{\"name\":\"Actions\",\"new rule\":\"New Rule\",\"redeploy\":\"Redeploy\",\"newRule\":\"new rule\",\"backup\":\"Backup\"}}}");

/***/ }),

/***/ 2588:
/***/ (function(module, exports) {

var path = '/configuration/rulesBrowser/rulesBrowser.tpl.html';
var html = "<ui-grid-data-browser\n    identifier=\"'rulesBrowser'\"\n    columns=\"columns\"\n    state-params=\"stateParams\"\n    advanced-filter-type=\"advancedFilterType\"\n    filter-type=\"filterType\"\n    translations=\"translations\"\n    initial-request-params=\"initialRequestParams\"\n    load-items-handler=\"loadItemsHandler\"\n    load-actions-handler=\"loadActionsHandler\"\n    notify-handle-action=\"handleAction(action, file)\">\n</ui-grid-data-browser>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2589:
/***/ (function(module, exports) {

/*@ngInject*/
var RulesBrowserActionRepository = function RulesBrowserActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadActions = function () {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.rules.model.Rule:null'
        }
      };
    return this.get(url, config);
  };
};
RulesBrowserActionRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('rulesBrowserActionRepository', RulesBrowserActionRepository);

/***/ }),

/***/ 2590:
/***/ (function(module) {

module.exports = JSON.parse("{\"redeployRuleSets\":{\"cancelButton\":\"Cancel\",\"loadingBar\":\"Redeploying {numRuleSets} Rule Sets\",\"redeployRuleSetsButton\":\"Redeploy Rule Sets\",\"ruleSetsDataSetName\":\"Advanced Filter Rule Set\",\"selectAll\":\"Select All\",\"successMessage\":\"Successfully Redeployed {numRuleSets} Rule Sets\",\"title\":\"Redeploy Rule Sets\"}}");

/***/ }),

/***/ 2591:
/***/ (function(module, exports) {

var path = '/configuration/rulesBrowser/redeployRuleSets/redeployRuleSets.tpl.html';
var html = "<div class=\"redeployRuleSetsContent\">\n    <div class=\"modal-header\">\n        <h3 class=\"title\"><span ui-translate>redeployRuleSets.title</span></h3>\n        <button class=\"close\"\n                ng-click=\"onCancel()\">\n            <span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </div>\n\n    <div ui-browser-detection class=\"modal-body\">\n        <div class=\"redeployRuleSetsContainer\">\n            <div class=\"selectAllContainer\">\n                <label class=\"checkboxLabel\">\n                    <input class=\"checkbox selectAllCheckbox\"\n                           type=\"checkbox\"\n                           ng-model=\"viewModel.selectAllCheckbox\"\n                           ng-change=\"onSelectAll()\"\n                    />\n                    {{ ::viewModel.selectAll }}\n                </label>\n            </div>\n            <div class=\"ruleSetsContainer\">\n                <div class=\"ruleSetContainer\"\n                     ng-repeat=\"ruleSetItem in viewModel.ruleSetItemList\">\n                    <label class=\"checkboxLabel\">\n                        <input class=\"checkbox ruleSetCheckbox\"\n                               type=\"checkbox\"\n                               ng-model=\"ruleSetItem.selected\"\n                               ng-change=\"onSelectCheckbox(ruleSetItem)\"\n                        />\n                        {{ ruleSetItem.label }}\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"modal-footer\">\n    <button class=\"btn btn-primary\"\n            ng-click=\"onConfirm()\"\n            ng-disabled=\"!canEnableConfirmButton()\">\n        <span ui-translate>redeployRuleSets.redeployRuleSetsButton</span>\n    </button>\n    <button class=\"btn btn-default\"\n            ng-click=\"onCancel()\">\n        <span ui-translate>redeployRuleSets.cancelButton</span>\n    </button>\n</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2592:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var RedeployRuleSetsController = function RedeployRuleSetsController($rootScope, $scope, localization, coreConstant, dataSetUtil, options) {
  var translations;
  $scope.viewModel = {
    ruleSetItemList: [],
    selectAll: '',
    selectAllCheckbox: false
  };
  localization.getTranslationByKey('redeployRuleSets').then(function (result) {
    var submissionUri = null,
      variableName = null,
      ruleSetsDataSetName,
      dataSetParams = null;
    translations = result;
    ruleSetsDataSetName = translations.ruleSetsDataSetName;
    dataSetParams = dataSetUtil.getDataSetParamsByName(ruleSetsDataSetName, variableName, submissionUri);
    $scope.viewModel.selectAll = translations.selectAll;
    function processDataItems(dataItems) {
      $scope.viewModel.ruleSetItemList = [];
      _.each(dataItems, function (dataItem) {
        var selected = options.defaultRuleSetId && options.defaultRuleSetId === parseInt(dataItem.value) ? true : false;
        $scope.viewModel.ruleSetItemList.push({
          label: dataItem.name,
          ruleSetId: dataItem.value,
          selected: selected
        });
      });
    }
    dataSetUtil.getDataItems(dataSetParams).then(processDataItems);
  });
  $scope.onSelectAll = function () {
    _.each($scope.viewModel.ruleSetItemList, function (ruleSetItem) {
      ruleSetItem.selected = $scope.viewModel.selectAllCheckbox;
    });
  };
  $scope.onSelectCheckbox = function (ruleSetItem) {
    var uncheckedCheckboxes = [];
    if (!ruleSetItem.selected) {
      $scope.viewModel.selectAllCheckbox = false;
    } else {
      uncheckedCheckboxes = _.filter($scope.viewModel.ruleSetItemList, function (ruleSetItem) {
        return !ruleSetItem.selected;
      });
      if (uncheckedCheckboxes.length === 0) {
        $scope.viewModel.selectAllCheckbox = true;
      }
    }
  };
  $scope.onConfirm = function () {
    var ruleSetIds = _.map(_.filter($scope.viewModel.ruleSetItemList, function (ruleSetItem) {
      return ruleSetItem.selected;
    }), 'ruleSetId');
    $scope.$close({
      ruleSetIds: ruleSetIds
    });
  };
  $scope.canEnableConfirmButton = function () {
    var anyRuleSetSelected = false;
    _.each($scope.viewModel.ruleSetItemList, function (ruleSetItem) {
      if (ruleSetItem.selected) {
        anyRuleSetSelected = true;
      }
    });
    return anyRuleSetSelected;
  };
  $scope.$on('modal.closing', function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
};
RedeployRuleSetsController.$inject = ["$rootScope", "$scope", "localization", "coreConstant", "dataSetUtil", "options"];
angular.module('ums.configuration').controller('redeployRuleSetsController', RedeployRuleSetsController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2593:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2594);
__webpack_require__(2595);

/*@ngInject*/
var RuleTemplateSettingsController = function RuleTemplateSettingsController($rootScope, $scope, $uibModalInstance, localization, coreConstant, dataSetUtil, ruleModel, ruleEntryStatus, ruleMediator, ruleActionsUtil, options, $state, navigationStateModel) {
  var translations;
  $scope.viewModel = {
    rule: {},
    title: '',
    ruleSetItemList: [],
    ruleName: '',
    selectedRuleSet: null,
    tagItems: [],
    addTagItems: [],
    newTag: '',
    selectedRuleTemplateName: '',
    description: '',
    hasChanges: false,
    addTag: ''
  };
  function initViewModelFromRule(rule) {
    $scope.viewModel.rule = rule;
    $scope.viewModel.ruleName = rule.name;
    $scope.viewModel.description = rule.description;
    $scope.viewModel.tagItems = rule.tags;
  }
  localization.getTranslationByKey('ruleTemplateSettings').then(function (result) {
    translations = result;
    $scope.viewModel.addTag = translations.addTag;
    function loadData() {
      $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
      if (!options.rule) {
        $scope.viewModel.title = translations.newRuleTitle;
        $scope.viewModel.saveButton = translations.createNewRule;
      } else {
        $scope.viewModel.title = translations.updateRuleTitle;
        $scope.viewModel.saveButton = translations.updateRule;
        initViewModelFromRule(options.rule);
      }
      var ruleDataSetName = 'Advanced Filter Rule Set',
        submissionUri = null,
        variableName = 'ruleSets',
        dataSetParams = dataSetUtil.getDataSetParamsByName(ruleDataSetName, variableName, submissionUri);
      dataSetUtil.getDataItems(dataSetParams).then(function (items) {
        $scope.viewModel.ruleSetItemList = items;
        if ($scope.viewModel.rule.id) {
          _.each(items, function (ruleSet) {
            if (parseInt(ruleSet.value) === $scope.viewModel.rule.parentId) {
              $scope.viewModel.selectedRuleSet = ruleSet;
            }
          });
        }
      }.bind(this));
    }
    $scope.viewModel.selectedRuleTemplateName = translations.selectRuleSet;
    loadData();
  });
  $scope.addNewTag = function (item) {
    var customTag = {};
    if ($scope.viewModel.tagItems.length < 10) {
      if (item.hasOwnProperty('customTagName')) {
        customTag.name = item.name.replace(/['"]+/g, '');
        customTag.type = 'custom';
        $scope.viewModel.tagItems.push(customTag);
      } else {
        $scope.viewModel.tagItems.push(item);
      }
      $scope.viewModel.newTag = '';
      $scope.viewModel.addTagItems = [];
      $scope.viewModel.addTag = translations.addTag;
    } else {
      $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'tagsCountExceededMessage'));
    }
    $scope.handleChange();
  };
  $scope.onDeleteTag = function (tag) {
    _.remove($scope.viewModel.tagItems, function (item) {
      return item.name === tag.name;
    });
    $scope.handleChange();
    $scope.viewModel.newTag = '';
    $scope.viewModel.addTagItems = [];
  };
  $scope.addTag = function () {
    return new Promise(function (resolve, reject) {
      var count = 0,
        tagItemList = [];
      if ($scope.viewModel.tagItems.length === 0) {
        resolve(tagItemList);
      } else {
        _.forEach($scope.viewModel.tagItems, function (item) {
          if (item.hasOwnProperty('type')) {
            ruleMediator.createTag({
              name: item.name
            }).then(function (result) {
              tagItemList.push(result);
              count++;
              if (count === $scope.viewModel.tagItems.length) {
                count = 0;
                resolve(tagItemList);
              }
            }.bind(this));
          } else {
            tagItemList.push(item);
            count++;
            if (count === $scope.viewModel.tagItems.length) {
              count = 0;
              resolve(tagItemList);
            }
          }
        });
      }
    });
  };
  $scope.onConfirm = function () {
    $scope.addTag().then(function (tagItemList) {
      var rule = $scope.viewModel.rule;
      rule.name = $scope.viewModel.ruleName;
      rule.parentPath = $scope.viewModel.selectedRuleSet.name;
      rule.parentId = parseInt($scope.viewModel.selectedRuleSet.value);
      rule.description = $scope.viewModel.description;
      rule.tags = tagItemList;
      rule.objectUri = '/Rule';
      if (!rule.id) {
        rule.status = ruleEntryStatus.STATUS_ACTIVE;
        rule.condition = ruleMediator.createFieldRule().condition;
      }
      if (!rule.id) {
        ruleMediator.createRule(rule).then(function (result) {
          $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'ruleSuccessfullyCreated'));
          $uibModalInstance.close();
          var navigationModel = {
            parentState: 'configuration.rulesBrowser',
            currentState: 'configuration.ruleBuilder',
            data: {
              ruleId: result.id,
              ruleSetName: result.parentPath
            }
          };
          $state.go('configuration.ruleBuilder', {
            ruleId: result.id,
            ruleSetName: result.parentPath
          });
          navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
        });
      } else {
        ruleActionsUtil.saveRule($scope.viewModel.rule).then(function (result) {
          $uibModalInstance.close();
        });
      }
    });
  };
  $scope.onSelectRuleSet = function (item) {
    $scope.viewModel.selectedRuleSet = item;
    $scope.viewModel.selectedRuleSet.name = item.name;
  };
  $scope.handleChange = function () {
    $scope.viewModel.hasChanges = true;
  };
  $scope.canEnableConfirmButton = function () {
    return !_.isEmpty($scope.viewModel.ruleName) && !_.isEmpty($scope.viewModel.selectedRuleSet) && $scope.viewModel.hasChanges;
  };
  $scope.$on('modal.closing', function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $scope.onCancel = function () {
    $uibModalInstance.close();
  };
  $scope.onTagNameChange = function () {
    var isNewTagExist = false,
      tag = {};
    if (_.isEmpty($scope.viewModel.newTag)) {
      $scope.viewModel.addTagItems = [];
    } else {
      ruleMediator.getMatchingTags($scope.viewModel.newTag).then(function (result) {
        $scope.viewModel.addTagItems = result;
        //removing the already added tag from the list
        _.forEach($scope.viewModel.tagItems, function (item) {
          _.remove($scope.viewModel.addTagItems, function (tag) {
            return item.id === tag.id;
          });
        });
        _.forEach($scope.viewModel.addTagItems, function (tagItem) {
          if (tagItem.name === $scope.viewModel.newTag) {
            isNewTagExist = true;
          }
        });
        _.forEach($scope.viewModel.tagItems, function (tagItem) {
          if (tagItem.name === $scope.viewModel.newTag) {
            isNewTagExist = true;
          }
        });
        if (!isNewTagExist) {
          tag.id = null;
          tag.name = '"' + $scope.viewModel.newTag + '"';
          tag.customTagName = translations.createNewTag;
          $scope.viewModel.addTagItems.push(tag);
        }
      });
    }
  };
};
RuleTemplateSettingsController.$inject = ["$rootScope", "$scope", "$uibModalInstance", "localization", "coreConstant", "dataSetUtil", "ruleModel", "ruleEntryStatus", "ruleMediator", "ruleActionsUtil", "options", "$state", "navigationStateModel"];
angular.module('ums.configuration').controller('ruleTemplateSettingsController', RuleTemplateSettingsController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2594:
/***/ (function(module) {

module.exports = JSON.parse("{\"ruleTemplateSettings\":{\"newRuleTitle\":\"Create New Rule\",\"updateRuleTitle\":\"Rule Settings\",\"name\":\"Name\",\"ruleSet\":\"Rule Set\",\"description\":\"Description\",\"tags\":\"Tags\",\"addTag\":\"Add a Tag...\",\"createNewRule\":\"Create New Rule\",\"updateRule\":\"Save\",\"cancelButton\":\"Cancel\",\"tagsCountExceededMessage\":\"The number of tags cannot be greater than 10\",\"ruleSuccessfullyCreated\":\"Successfully saved rule\",\"ruleSuccessfullyUpdated\":\"Rule has been updated successfully\",\"selectRuleSet\":\"Select Rule Set\",\"createNewTag\":\"(Create New Tag)\"}}");

/***/ }),

/***/ 2595:
/***/ (function(module, exports) {

var path = '/configuration/ruleTemplateSettings/ruleTemplateSettings.tpl.html';
var html = "<div class=\"ruleTemplate\">\n    <div class=\"modal-header\">\n        <h3 class=\"title\"><span>{{::viewModel.title}}</span></h3>\n        <button class=\"close\"\n                ng-click=\"onCancel()\">\n            <span class=\"glyphicon glyphicon-remove\"></span>\n        </button>\n    </div>\n\n    <div ui-browser-detection class=\"modal-body\">\n        <div class=\"ruleTemplateBox\">\n            <div class=\"leftBox\">\n                <div class=\"ruleTemplateRow name\">\n                    <div class=\"ruleTemplateLabel\">\n                        <ui-required-indicator class=\"requiredIndicator requiredIndicatorForName\"\n                                               value=\"{{viewModel.ruleName}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>ruleTemplateSettings.name</span>\n                    </div>\n\n                    <input type=\"text\"\n                           ng-model=\"viewModel.ruleName\"\n                           ng-change=\"handleChange()\"\n                           ng-blur=\"handleUniqueNameBlur()\"\n                           value=\"{{ viewModel.ruleName }}\"\n                           class=\"componentWidth ruleNameInput\">\n                </div>\n\n                <div class=\"ruleTemplateRow description\">\n\n                    <div class=\"ruleTemplateLabel\">\n                        <span ui-translate>ruleTemplateSettings.description</span>\n                    </div>\n                    <textarea ng-model=\"viewModel.description\"\n                              ng-change=\"handleChange()\"\n                              ng-blur=\"$ctrl.updateFieldValue()\"\n                              ui-remote-change-notification\n                              ng-focus=\"$ctrl.handleFocus()\"\n                              class=\"componentWidth ruleDescriptionInput\"></textarea>\n                </div>\n            </div>\n\n            <div class=\"rightBox\">\n                <div class=\"ruleTemplateRow ruleSet\">\n                    <div class=\"ruleTemplateLabel\">\n                        <ui-required-indicator class=\"requiredIndicator requiredIndicatorForRuleSet\"\n                                               value=\"{{viewModel.selectedRuleSet.name}}\">\n                        </ui-required-indicator>\n                        <span ui-translate>ruleTemplateSettings.ruleSet</span>\n                    </div>\n\n                    <ui-select class=\"dropdownFormComponent dropdownComponentSelect ruleSetDropdown\"\n                               theme=\"select2\"\n                               ng-model=\"viewModel.selectedRuleSet\"\n                               ng-change=\"handleChange()\"\n                               on-select=\"handleChange()\"\n                               append-to-body=\"true\">\n\n                        <ui-select-match placeholder=\"{{ ::viewModel.selectedRuleTemplateName }}\"\n                                         allow-clear=\"true\">\n                            <span>{{viewModel.selectedRuleSet.name}}</span>\n                        </ui-select-match>\n\n                        <ui-select-choices repeat=\"item in (viewModel.ruleSetItemList | filter: $select.search) track by $index\">\n                            <span ng-click=\"onSelectRuleSet(item)\">{{ item.name }}</span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n\n                <div class=\"ruleTemplateRow ruleTags\">\n                    <div class=\"ruleTemplateLabel\">\n                        <span ui-translate>ruleTemplateSettings.tags</span>\n                    </div>\n                    <div class=\"tagLayout\">\n                        <div class=\"tagContainer\" ng-repeat=\"tag in viewModel.tagItems\">\n                            <div class=\"tag\"\n                                 uib-tooltip=\"{{ tag.name }}\"\n                                 tooltip-append-to-body=\"true\"\n                                 tooltip-placement=\"bottom auto\"\n                                 tooltip-append-to-body=\"true\"\n                                 tooltip-popup-delay=\"500\">\n                                <span class=\"tagLabel\">{{ tag.name }}</span>\n                                <button class=\"close\"\n                                        ng-click=\"onDeleteTag(tag)\">\n                                    <span class=\"glyphicon glyphicon-remove\"></span>\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div uib-dropdown\n                         dropdown-append-to-body=\"true\">\n                        <input type=\"text\" uib-dropdown-toggle class=\"form-control newTag\"\n                               placeholder=\"{{::viewModel.addTag}}\"\n                               ng-model=\"viewModel.newTag\"\n                               maxlength=\"255\"\n                               ng-change=\"onTagNameChange()\">\n\n                        <ul class=\"dropdown-menu tagMenu\"\n                            uib-dropdown-menu ng-show=\"viewModel.addTagItems.length > 0\">\n                            <li class=\"tagDropdown\" ng-repeat=\"itemName in viewModel.addTagItems\" ng-click=\"addNewTag(itemName)\">\n                                <label class=\"tagItem\">{{itemName.name}}</label>\n                                <label class=\"customTagName\">{{itemName.customTagName}}</label>\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-success createNewRule\"\n                ng-click=\"onConfirm()\"\n                ng-disabled=\"!canEnableConfirmButton()\">\n            <span>{{::viewModel.saveButton}}</span>\n        </button>\n        <button class=\"btn btn-default cancelButton\"\n                ng-click=\"onCancel()\">\n            <span ui-translate>ruleTemplateSettings.cancelButton</span>\n        </button>\n    </div>\n</div>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2596:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2597);
__webpack_require__(2598);
__webpack_require__(2599);

/*@ngInject*/
var ScoringRulesBrowserController = function ScoringRulesBrowserController($rootScope, $scope, $timeout, $state, dateUtil, $filter, localization, coreConstant, configurationActionsUtil, configurationMediator, databaseDownloadSectionName, navigationStateModel, sectionTemplateAction, modalUtil, userMediator, dataSetUtil, scoringRuleActions, coreMediator) {
  $scope.viewModel = {
    isLoading: true,
    scoringRules: [],
    categoryList: [],
    selectedCategoryList: [],
    selectedCategoryIds: [],
    categoryName: 'scoringFolder',
    totalScoringRules: 0,
    isGridEmpty: true,
    nameSearchString: '',
    requestParams: {
      key: 'name',
      startIndex: 0,
      pageSize: 25,
      sortType: 'asc',
      selectedCategoryList: []
    },
    shortDateFormat: coreMediator.getPreferenceByName('view.shortDateFormat'),
    searchDelayInMilliSeconds: 750
  };
  localization.getTranslationByKey('scoringRulesBrowser').then(function (translations) {
    $scope.viewModel.recordCountText = _.get(translations, 'recordCountText');
    $scope.viewModel.recordsCountText = _.get(translations, 'recordsCountText');
    $scope.viewModel.namePromptMessage = _.get(translations, 'namePromptMessage');
    $scope.viewModel.categoriesPromptMessage = _.get(translations, 'categoriesPromptMessage');
    $scope.viewModel.clearAll = _.get(translations, 'clearAll');
    $scope.actions = [];
    $scope.context = {
      identifier: 'scoringRulesBrowser',
      actions: {},
      fallthrough: null,
      model: {
        contextType: coreConstant.CONTEXT_NONE
      }
    };
    $scope.context.actions[coreConstant.CONTEXT_NONE] = '';
    function loadActions() {
      configurationMediator.loadScoringRulesActions().then(function (actions) {
        var allActions = [];
        allActions.push({
          actions: actions.actions,
          contextType: $scope.context.model.contextType
        });
        $scope.actions = allActions;
        $scope.actionsTimeLastModified = new Date().getTime();
      });
    }
    function loadScoringRules() {
      var viewModel = userMediator.restoreViewState('configuration.scoringRulesBrowser', $scope.viewModel);
      if (!_.isNil(viewModel)) {
        $scope.viewModel = viewModel;
      }
      $scope.viewModel.selectedCategoryList = _.join($scope.viewModel.selectedCategoryIds, '::');
      $scope.viewModel.requestParams.nameSearchString = $scope.viewModel.nameSearchString;
      $scope.viewModel.requestParams.selectedCategoryList = $scope.viewModel.selectedCategoryIds;
      $scope.viewModel.isLoading = true;
      configurationMediator.getScoringRulesByParam($scope.viewModel.requestParams).then(function (scoringRules) {
        $scope.viewModel.scoringRules = scoringRules.records;
        $scope.viewModel.totalScoringRules = scoringRules.totalRecords;
        $scope.viewModel.isGridEmpty = $scope.viewModel.totalScoringRules === 0;
        $timeout(function () {
          $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
          $scope.viewModel.isLoading = false;
        }, 0);
      });
    }
    function loadCategoryList() {
      dataSetUtil.getDataSet({
        name: 'Scoring Rule Folders'
      }).then(function (dataset) {
        $scope.viewModel.categoryList = dataset.items;
      });
    }
    $scope.getEffectiveDates = function (item) {
      var effectiveDateRangeBegin = $filter('utcDateFilter')(item.effectiveDateRangeBegin, $scope.viewModel.shortDateFormat);
      var to = $scope.getToString(item);
      var effectiveDateRangeEnd = $filter('utcDateFilter')(item.effectiveDateRangeEnd, $scope.viewModel.shortDateFormat);
      return "".concat(effectiveDateRangeBegin, " ").concat(to, " ").concat(effectiveDateRangeEnd);
    };
    $scope.getToString = function (item) {
      return !_.isNil(item.effectiveDateRangeBegin) && !_.isNil(item.effectiveDateRangeEnd) ? ' ' + _.get(translations, 'to') + ' ' : ' ';
    };

    /*
     * debounce is called here explicitly instead of using
     * "ng-model-options={debounce}" so that the debounce timer
     * can be cancelled. See the clearSearch function below.
     */
    $scope.searchChange = _.debounce(function () {
      userMediator.saveViewState('configuration.scoringRulesBrowser', {
        nameSearchString: $scope.viewModel.nameSearchString
      });
      $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
    }, $scope.viewModel.searchDelayInMilliSeconds);
    $scope.onPagingChange = function ($event, params) {
      $scope.viewModel.requestParams.startIndex = params.startIndex;
      loadScoringRules();
    };
    $scope.onSortChange = function (event, params) {
      $scope.viewModel.requestParams.key = params.key;
      $scope.viewModel.requestParams.sortType = params.sortType;
      userMediator.saveViewState('configuration.scoringRulesBrowser', $scope.viewModel);
      loadScoringRules();
    };
    function resetNavigationState() {
      navigationStateModel.saveViewState('configuration.scoringRulesBrowser', null);
    }
    $scope.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case scoringRuleActions.CREATE:
            $state.go('configuration.manageScoringRules', {
              scoringRuleId: -1
            });
            break;
          case scoringRuleActions.BACKUP:
            configurationActionsUtil.backup(databaseDownloadSectionName.SCORING, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
    $scope.onClickRow = function (event, item) {
      $state.go('configuration.manageScoringRules', {
        scoringRuleId: item.id
      });
      navigationStateModel.saveViewState('configuration.scoringRulesBrowser', null);
    };
    $scope.clearSearch = function () {
      /*
       * The call to searchChange.cancel handles the scenario where
       * the user types some text in the search box, and then clicks
       * the clear button before the debounce timer goes off. Without
       * that call, the scoring rules are fetched twice, once as
       * a result of this method, with nameSearchString='', and
       * then again when the debounce timer goes off, with nameSearchString
       * set to the text typed in the search box, which effectively
       * undoes the click of the clear button. With that call,
       * the debounce timer is cancelled and the search box is cleared.
       */
      $scope.searchChange.cancel();
      /*
       * It is necessary to clear $scope.viewModel.selectedCategoryIds
       * as well as clearing selectedCategoryIds in the view-state
       * because userMediator.restoreViewState merges those two arrays.
       */
      $scope.viewModel.selectedCategoryIds = [];
      userMediator.saveViewState('configuration.scoringRulesBrowser', {
        selectedCategoryIds: [],
        nameSearchString: ''
      });
      $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
    };
    $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
      $scope.viewModel.selectedCategoryIds = [];
      _.each($scope.viewModel.categoryList, function (category) {
        if (category.selected) {
          $scope.viewModel.selectedCategoryIds.push(category.value);
        }
      });
      $scope.viewModel.selectedCategoryList = _.join($scope.viewModel.selectedCategoryIds, '::');
      userMediator.saveViewState('configuration.scoringRulesBrowser', {
        selectedCategoryIds: $scope.viewModel.selectedCategoryIds
      });
      $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
    });
    $scope.$on('$destroy', function () {
      userMediator.saveViewState('configuration.scoringRulesBrowser', $scope.viewModel);
    });
    loadCategoryList();
    loadActions();
    loadScoringRules();
    resetNavigationState();
  });
  $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
    $scope.$apply();
  });
};
ScoringRulesBrowserController.$inject = ["$rootScope", "$scope", "$timeout", "$state", "dateUtil", "$filter", "localization", "coreConstant", "configurationActionsUtil", "configurationMediator", "databaseDownloadSectionName", "navigationStateModel", "sectionTemplateAction", "modalUtil", "userMediator", "dataSetUtil", "scoringRuleActions", "coreMediator"];
angular.module('ums.configuration').controller('scoringRulesBrowserController', ScoringRulesBrowserController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2597:
/***/ (function(module) {

module.exports = JSON.parse("{\"scoringRulesBrowser\":{\"title\":\"Manage Scoring Rules\",\"columns\":{\"name\":\"Name\",\"scoringFolderName\":\"Category\",\"effectiveDates\":\"Effective Dates\",\"lastModifiedBy\":\"Last Edited By\",\"lastModifiedDate\":\"Last Modified Date\"},\"emptyGrid\":\"No matching Scoring Rules\",\"recordCountText\":\"Showing startIndex to endIndex of total Scoring Rules\",\"recordsCountText\":\"Showing startIndex to endIndex of total Scoring Rules\",\"actions\":{\"name\":\"Actions\",\"create\":\"New Scoring Rule\",\"backup\":\"Backup\"},\"backup\":{\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\",\"name\":\"Scoring Rules\"},\"namePromptMessage\":\"Search Name\",\"categoriesPromptMessage\":\"All Categories\",\"to\":\"to\",\"clearAll\":\"Clear All\"}}");

/***/ }),

/***/ 2598:
/***/ (function(module, exports, __webpack_require__) {

var path = '/configuration/scoringRules/scoringRulesBrowser.tpl.html';
var html = "<div class=\"scoringRulesBrowser\">\n\n    <!-- Header -->\n    <div class=\"header\">\n        <div class=\"headerContent\">\n            <div class=\"headerLabel\" ui-translate>scoringRulesBrowser.title</div>\n\n            <action-buttons-bar context=\"context\"\n                                actions=\"actions\"\n                                notify-action-clicked=\"handleAction(action, file)\"\n                                time-last-modified=\"actionsTimeLastModified\"></action-buttons-bar>\n        </div>\n    </div>\n\n    <!-- Tools -->\n    <div class=\"tools\">\n\n        <div class=\"toolsContent\">\n\n            <div class=\"nameSearchStringInput\">\n                <span class=\"glyphicon glyphicon-search\"></span>\n                <input type=\"text\"\n                       ng-model=\"viewModel.nameSearchString\"\n                       ng-change=\"searchChange()\"\n                       placeholder=\"{{ ::viewModel.namePromptMessage }}\">\n            </div>\n\n            <ui-multi-select\n                items-list=\"viewModel.categoryList\"\n                class=\"multiSelectDropdown allCategoriesSearch\"\n                item-name=\"viewModel.categoryName\"\n                prompt-value=\"viewModel.categoriesPromptMessage\"\n                append-to-body=\"true\"\n                selected-value=\"viewModel.selectedCategoryList\"\n            </ui-multi-select>\n\n        </div>\n        <div class=\"clearSearch\">\n            <a class=\"clearSearchLink\"\n               ng-click=\"clearSearch()\">{{::viewModel.clearAll}}\n            </a>\n        </div>\n    </div>\n\n    <!-- Grid -->\n    <div class=\"grid\">\n\n        <div class=\"gridContainer\">\n\n            <!-- Grid Header -->\n            <div class=\"columnHeader\">\n\n                <div class=\"columnRow\">\n\n                    <div class=\"colHover\"></div>\n\n                    <div class=\"colName\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"name\"\n                         item-label=\"scoringRulesBrowser.columns.name\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colScoringFolderName\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"scoringFolderId\"\n                         item-label=\"scoringRulesBrowser.columns.scoringFolderName\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colEffectiveDates\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"effectiveDateRangeBegin\"\n                         item-label=\"scoringRulesBrowser.columns.effectiveDates\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colLastModifiedBy\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"lastModifiedBy.name\"\n                         item-label=\"scoringRulesBrowser.columns.lastModifiedBy\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colTimeLastModified\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"timeLastModified\"\n                         item-label=\"scoringRulesBrowser.columns.lastModifiedDate\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                </div>\n            </div>\n\n\n            <div class=\"datagrid table\"\n                 ux-datagrid=\"viewModel.scoringRules\"\n                 ng-if=\"!viewModel.isLoading\"\n                 ui-scroll-detection\n                 ui-scroll-detection-target=\".columnHeader\">\n\n                <script type=\"template/html\"\n                        data-template-item=\"item\"\n                        data-template-name=\"default\">\n\n                    <div class=\"columnRow\">\n\n                        <div class=\"columnRowWrapper\">\n\n                            <div class=\"col colName\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.name }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.nameTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.nameTooltip\">{{ ::item.name }}</span>\n                            </div>\n\n                            <div class=\"col colScoringFolderName\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{  ::item.scoringFolderName  }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.scoringFolderNameTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.scoringFolderNameTooltip\">{{ ::item.scoringFolderName }}</span>\n                            </div>\n\n                            <div class=\"col colEffectiveDates\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{::getEffectiveDates(item) }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.effectiveDatesTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.effectiveDatesTooltip\">{{ ::getEffectiveDates(item) }}</span>\n                            </div>\n\n                            <div class=\"col colLastModifiedBy\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.lastModifiedBy.name }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.lastModifiedByTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.lastModifiedByTooltip\">{{ ::item.lastModifiedBy.name }}</span>\n                            </div>\n\n                            <div class=\"col colTimeLastModified\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.timeLastModified | date: viewModel.shortDateTimeFormat }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.timeLastModified }}\"\n                                      ui-is-tooltip-enabled=\"item.timeLastModifiedTooltip\">{{ ::item.timeLastModified | date: viewModel.shortDateTimeFormat }}</span>\n                            </div>\n                        </div>\n                    </div>\n                </script>\n            </div>\n\n            <ui-grid-paging-component\n                ng-hide=\"viewModel.totalScoringRules === 0\"\n                start-index=\"viewModel.requestParams.startIndex\"\n                page-size=\"viewModel.requestParams.pageSize\"\n                total-records=\"viewModel.totalScoringRules\"\n                record-count-text=\"viewModel.recordCountText\"\n                records-count-text=\"viewModel.recordsCountText\"\n                on-change=\"onPagingChange($event, params)\"></ui-grid-paging-component>\n\n            <div class=\"gridEmpty\"\n                 ng-if=\"viewModel.isGridEmpty && !viewModel.isLoading\" ui-translate>scoringRulesBrowser.emptyGrid\n            </div>\n\n            <div class=\"icon-spinner\"\n                 ng-if=\"viewModel.isLoading\">\n                <img src=\"" + __webpack_require__(52) + "\"/>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2599:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ScoringRulesRepository = function ScoringRulesRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadActions = function (scoringRuleId) {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.underwriting.scoring.ScoringRule:' + (_.isNil(scoringRuleId) ? null : scoringRuleId)
        }
      };
    return this.get(url, config);
  };
  this.getScoringRulesByParam = function (requestParams) {
    var url = '/rest/ScoringRule',
      config = {
        params: {
          searchString: requestParams.nameSearchString,
          folderIds: requestParams.selectedCategoryList,
          sortBy: requestParams.key,
          sortDirection: requestParams.sortType,
          startIndex: requestParams.startIndex,
          numberOfRows: requestParams.pageSize
        }
      };
    return this.get(url, config);
  };
  this.getScoringRuleById = function (scoringRuleId) {
    var url = '/rest/ScoringRule/' + scoringRuleId;
    return this.get(url);
  };
  this.saveScoringRule = function (scoringRule) {
    var url = '/rest/ScoringRule/',
      body = scoringRule,
      config = {
        params: {}
      };
    // body.formulas = null;
    if (!_.isNil(scoringRule.id)) {
      url += scoringRule.id;
    }
    return this.post(url, body, config);
  };
  this.deleteScoringRule = function (scoringRuleId) {
    var url = '/rest/ScoringRule/' + scoringRuleId;
    return this.delete(url);
  };
};
ScoringRulesRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('scoringRulesRepository', ScoringRulesRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2600:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, moment) {__webpack_require__(2601);
__webpack_require__(2602);
__webpack_require__(2603);
__webpack_require__(2604);
__webpack_require__(2605);
__webpack_require__(2606);

/*@ngInject*/
var ManageScoringRulesController = function ManageScoringRulesController($scope, $rootScope, $stateParams, $uibModal, scoringRulesEditorModel, coreConstant, localization, configurationConstant, dateUtil, configurationMediator, fieldType, dataSetUtil, $timeout, dataSetType, xmlUtil, authorizationConstants, currentUserModel) {
  var translations,
    timeoutList = [];
  $scope.viewModel = {
    name: '',
    namePrompt: '',
    category: '',
    categoryPrompt: '',
    effectiveDateRange: '',
    effectiveDateRangeStart: null,
    effectiveStartDatePrompt: null,
    effectiveDateRangeEnd: '',
    effectiveEndDatePrompt: '',
    formName: '',
    variableName: '',
    selectorWidgetMode: 'forms',
    form: {
      name: '',
      variableName: ''
    },
    endDateValidationErrorMessage: null,
    fieldValidator: null,
    fieldValueScoringList: [],
    categoryList: [],
    selectedCategory: '',
    filteredCategoryItemsList: [],
    minPrompt: '',
    maxPrompt: '',
    valuePrompt: '',
    scorePrompt: '',
    showRefresh: false,
    dataSetItems: [],
    applyScoring: 'always',
    operators: [],
    selectedOperator: '',
    selectOperatorPrompt: '',
    triggerForm: {
      name: '',
      variableName: ''
    },
    multiStepComponentName: 'triggerForm',
    inputFormField: 'inputFormField',
    isDataSetField: false,
    triggerDataSetList: [],
    itemName: 'dataSetList',
    selectedDataSet: [],
    selectedTriggerDataSetValues: [],
    selectDataSetPrompt: '',
    triggerFieldValue: '',
    showApplyScoring: false,
    populatedScoringFormulas: [],
    emptyObj: {
      value: '',
      score: '',
      min: '',
      max: '',
      isValid: true
    },
    showInputFormField: false,
    formFieldDataSets: [],
    addValuePrompt: '',
    dateInitialized: false,
    hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_SCORING),
    classCodeMockFieldStructure: {
      uiField: null,
      fieldModel: {
        value: []
      },
      dynamicProperties: {}
    },
    classCodeMockEffectiveDate: new Date(),
    isClassCodePicker: false,
    showClassCode: false,
    selectedClassCodesValues: '',
    flags: '',
    flagsPrompt: ''
  };
  localization.getTranslationByKey('manageScoringRules').then(function (result) {
    translations = result;
    $scope.viewModel.namePrompt = _.get(translations, 'namePrompt');
    $scope.viewModel.categoryPrompt = _.get(translations, 'categoryPrompt');
    $scope.viewModel.effectiveStartDatePrompt = _.get(translations, 'effectiveStartDatePrompt');
    $scope.viewModel.effectiveEndDatePrompt = _.get(translations, 'effectiveEndDatePrompt');
    $scope.viewModel.inputFormFieldPrompt = _.get(translations, 'inputFormFieldPrompt');
    $scope.viewModel.endDateValidationErrorMessage = _.get(translations, 'endDateValidationErrorMessage');
    $scope.viewModel.minPrompt = _.get(translations, 'minPrompt');
    $scope.viewModel.maxPrompt = _.get(translations, 'maxPrompt');
    $scope.viewModel.valuePrompt = _.get(translations, 'valuePrompt');
    $scope.viewModel.scorePrompt = _.get(translations, 'scorePrompt');
    $scope.viewModel.selectOperatorPrompt = _.get(translations, 'selectOperatorPrompt');
    $scope.viewModel.selectDataSetPrompt = _.get(translations, 'selectDataSetPrompt');
    $scope.viewModel.inputFormFieldErrorMessage = _.get(translations, 'inputFormFieldErrorMessage');
    $scope.viewModel.warningLabel = _.get(translations, 'warningLabel');
    $scope.viewModel.warningMessage = _.get(translations, 'warningMessage');
    $scope.viewModel.deleteAll = _.get(translations, 'deleteAll');
    $scope.viewModel.doNotDelete = _.get(translations, 'doNotDelete');
    $scope.viewModel.addValuePrompt = _.get(translations, 'addValuePrompt');
    $scope.viewModel.flagsPrompt = _.get(translations, 'flagsPrompt');
    $scope.viewModel.operators = [{
      name: _.get(translations, 'isInList'),
      value: 0
    }, {
      name: _.get(translations, 'contains'),
      value: 1
    }, {
      name: _.get(translations, 'matches'),
      value: 2
    }];
    init();
  });
  function loadCategoryList() {
    dataSetUtil.getDataSet({
      name: 'Scoring Rule Folders'
    }).then(function (dataset) {
      $scope.viewModel.categoryList = dataset.items;
    });
  }
  function init() {
    $scope.viewModel.fieldValueScoringList = [];
    scoringRulesEditorModel.buildScoringRule(_.isEmpty($stateParams.scoringRuleId) ? -1 : $stateParams.scoringRuleId);
  }
  function fillScoringInputGrid() {
    var fieldValue = {};
    $scope.viewModel.fieldValueScoringList = [];
    $scope.viewModel.populatedScoringFormulas = [];
    configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName($scope.viewModel.scoringRule.formTemplateUniqueName, $scope.viewModel.scoringRule.variableName).then(function (uiField) {
      if (isFieldWithoutValidatorAndDataset(uiField) || uiField.fieldTemplate.validator === 'number' || uiField.fieldTemplate.validator === 'percent' || uiField.fieldTemplate.validator === 'currency' || uiField.fieldTemplate.validator === 'number with commas' || uiField.fieldTemplate.validator === 'number range') {
        $scope.fieldValidator = 'numberValidator';
        _.each($scope.viewModel.scoringRule.formulas, function (formula) {
          fieldValue = {};
          fieldValue.type = 'Range';
          fieldValue.id = formula.id;
          fieldValue.min = !_.isNil(formula.minValue) ? formula.minValue : '';
          fieldValue.max = !_.isNil(formula.maxValue) ? formula.maxValue : '';
          fieldValue.score = !_.isNil(formula.score) ? formula.score : '';
          if (isMinMaxValid(fieldValue)) {
            fieldValue.isValid = true;
          } else {
            fieldValue.isValid = false;
          }
          $scope.viewModel.populatedScoringFormulas.push(fieldValue);
        });
        $scope.viewModel.fieldValueScoringList = _.map($scope.viewModel.populatedScoringFormulas, _.clone);
        $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
      } else {
        if (uiField.fieldTemplate.type === fieldType.CHECK_BOX || uiField.fieldTemplate.type === fieldType.YES_NO) {
          _.each($scope.viewModel.scoringRule.formulas, function (formula) {
            fieldValue = {};
            fieldValue.type = 'Discrete';
            fieldValue.id = formula.id;
            fieldValue.value = !_.isNil(formula.value) ? formula.value : '';
            fieldValue.score = !_.isNil(formula.score) ? formula.score : '';
            if (_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
              fieldValue.isValid = false;
            } else if (!_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
              fieldValue.isValid = true;
            } else if (!_.isEmpty(String(fieldValue.value)) && !_.isEmpty(String(fieldValue.score))) {
              fieldValue.isValid = true;
            } else {
              fieldValue.isValid = false;
            }
            $scope.viewModel.fieldValueScoringList.push(fieldValue);
          });
        } else {
          if (!_.isEmpty(uiField.fieldTemplate.dataSetName)) {
            fillRefreshDataset(uiField.fieldTemplate.dataSetName);
          }
          _.each($scope.viewModel.scoringRule.formulas, function (formula) {
            fieldValue = {};
            fieldValue.type = 'Discrete';
            fieldValue.id = formula.id;
            fieldValue.value = !_.isNil(formula.value) ? formula.value : '';
            fieldValue.score = !_.isNil(formula.score) ? formula.score : '';
            if (_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
              fieldValue.isValid = false;
            } else if (!_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
              fieldValue.isValid = true;
            } else if (!_.isEmpty(String(fieldValue.value)) && !_.isEmpty(String(fieldValue.score))) {
              fieldValue.isValid = true;
            } else {
              fieldValue.isValid = false;
            }
            $scope.viewModel.populatedScoringFormulas.push(fieldValue);
          });
          $scope.viewModel.fieldValueScoringList = _.map($scope.viewModel.populatedScoringFormulas, _.clone);
        }
        $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
      }
    });
    function fillRefreshDataset(dataSetName) {
      var dataSetParams = {
        name: dataSetName
      };
      $scope.viewModel.showRefresh = false;
      if (dataSetUtil.getDataSetType(dataSetParams.name) !== dataSetType.REPEATING_FORM && dataSetUtil.getDataSetType(dataSetParams.name) !== dataSetType.CUSTOM) {
        dataSetUtil.getDataSet(dataSetParams).then(function (result) {
          var fieldValue = {};
          _.each(result.items, function (formula) {
            fieldValue = {};
            fieldValue.type = 'Discrete';
            fieldValue.id = formula.id;
            fieldValue.value = !_.isNil(formula.value) ? formula.value : '';
            fieldValue.score = !_.isNil(formula.score) ? formula.score : '';
            if (_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
              fieldValue.isValid = false;
            } else if (!_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
              fieldValue.isValid = true;
            } else if (!_.isEmpty(String(fieldValue.value)) && !_.isEmpty(String(fieldValue.score))) {
              fieldValue.isValid = true;
            } else {
              fieldValue.isValid = false;
            }
            $scope.viewModel.formFieldDataSets.push(fieldValue);
          });
          $scope.viewModel.showRefresh = true;
        });
      }
    }
    $scope.viewModel.populatedScoringFormulas.sort(function (item1, item2) {
      var item1Value = item1.value.toUpperCase();
      var item2Value = item2.value.toUpperCase();
      if (item1Value < item2Value) {
        return -1;
      }
      if (item1Value > item2Value) {
        return 1;
      }
      return 0;
    });
  }
  $scope.onItemChange = function () {
    var formulas = [];
    $scope.formulasValid = true;
    _.each($scope.viewModel.fieldValueScoringList, function (formula) {
      var newFormula = {};
      if ($scope.fieldValidator === 'numberValidator') {
        if (isMinMaxValid(formula)) {
          newFormula.type = 'Range';
          if (!_.isNaN(parseInt(formula.min))) {
            newFormula.minValue = parseInt(formula.min);
          }
          if (!_.isNaN(parseInt(formula.max))) {
            newFormula.maxValue = parseInt(formula.max);
          }
          if (!_.isNaN(parseInt(formula.score))) {
            newFormula.score = parseInt(formula.score);
          }
          if (parseFloat(formula.min) > parseFloat(formula.max)) {
            $scope.formulasValid = false;
          }
          formulas.push(newFormula);
        } else {
          if (!(_.isEmpty(String(formula.min)) && _.isEmpty(String(formula.max)) && _.isEmpty(String(formula.score)))) {
            $scope.formulasValid = false;
          }
        }
      } else {
        if (_.isEmpty(String(formula.value)) && _.isEmpty(String(formula.score))) {
          return;
        }
        newFormula.type = 'Discrete';
        if (!_.isEmpty(formula.value)) {
          newFormula.value = formula.value;
        }
        if (!_.isNaN(parseInt(formula.score))) {
          newFormula.score = parseInt(formula.score);
        }
        if (_.isEmpty(String(formula.value)) && !_.isEmpty(String(formula.score))) {
          $scope.formulasValid = false;
        }
        formulas.push(newFormula);
      }
    });
    $scope.viewModel.scoringRule.formulas = formulas;
    $scope.handleChange();
  };
  function fillScoringFormulasWithDataSet() {
    var formulas = [];
    $scope.formulasValid = true;
    if ($scope.fieldValidator !== 'numberValidator' && !_.isNil($scope.viewModel.scoringRule.formTemplateUniqueName) && !_.isNil($scope.viewModel.scoringRule.variableName)) {
      configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName($scope.viewModel.scoringRule.formTemplateUniqueName, $scope.viewModel.scoringRule.variableName).then(function (uiField) {
        if (!_.isEmpty(uiField.fieldTemplate.dataSetName)) {
          var dataSetParams = {
            name: uiField.fieldTemplate.dataSetName
          };
          if (dataSetUtil.getDataSetType(dataSetParams.name) !== dataSetType.REPEATING_FORM && dataSetUtil.getDataSetType(dataSetParams.name) !== dataSetType.CUSTOM) {
            dataSetUtil.getDataSet(dataSetParams).then(function (result) {
              _.each(result.items, function (formula) {
                var newFormula = {};
                newFormula.type = 'Discrete';
                newFormula.id = formula.id;
                newFormula.value = !_.isNil(formula.value) ? formula.value : '';
                newFormula.score = !_.isNil(formula.score) ? formula.score : '';
                formulas.push(newFormula);
              });
            });
          }
        }
      });
      $scope.viewModel.scoringRule.formulas = formulas;
    }
  }
  $scope.onOperatorChange = function (operator) {
    var isInList = _.get(translations, 'isInList');
    $scope.viewModel.scoringRule.triggerFieldValue = '';
    $scope.viewModel.selectedOperator = operator;
    $scope.viewModel.scoringRule.triggerOperator = operator.value;
    if (operator.name === isInList) {
      if ($scope.viewModel.isClassCodePicker) {
        configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName($scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName, $scope.viewModel.scoringRule.triggerFieldVariableName).then(function (uiField) {
          $scope.viewModel.classCodeMockFieldStructure.uiField = uiField;
          $scope.viewModel.classCodeMockFieldStructure.fieldModel.value = [];
          $scope.viewModel.selectedTriggerDataSetValues = null;
          $scope.viewModel.showClassCode = true;
          $rootScope.$broadcast(coreConstant.event.RELOAD_CLASS_CODE_MULTI_SELECT);
        });
      }
      $scope.viewModel.isDataSetField = $scope.viewModel.triggerDataSetList.length > 0;
    } else {
      $scope.viewModel.showClassCode = false;
      $scope.viewModel.isDataSetField = false;
      $scope.viewModel.selectedDataSet = [];
    }
  };
  $scope.onDataSetChange = function (dataSet) {
    $scope.viewModel.selectedDataSet = dataSet;
  };
  $scope.getOperator = function () {
    if (!_.isNil($scope.viewModel.selectedOperator) && $scope.viewModel.selectedOperator !== '') {
      return $scope.viewModel.selectedOperator.name;
    }
    return $scope.viewModel.selectOperatorPrompt;
  };
  $scope.getDataSet = function (item) {
    return $scope.viewModel.selectedDataSet = item;
  };
  $scope.filterItems = function (searchText) {
    var filteredItemsList = [],
      newValueMatch;
    if (!_.isEmpty(searchText)) {
      filteredItemsList = _.filter($scope.viewModel.categoryList, function (item) {
        return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
      });

      // Add the new value to the filtered list if the searchText entered does not match anything in
      // the current list
      newValueMatch = _.find(filteredItemsList, function (item) {
        return item.name.toLowerCase() === searchText.toLowerCase();
      });
      if (_.isNil(newValueMatch)) {
        filteredItemsList.push({
          name: searchText,
          value: searchText,
          isCreateNew: true
        });
      }
    } else {
      filteredItemsList = $scope.viewModel.categoryList;
    }
    $scope.viewModel.filteredCategoryItemsList = filteredItemsList;
  };
  $scope.handleSelect = function () {
    if ($scope.viewModel.selectedCategory && $scope.viewModel.selectedCategory.isCreateNew) {
      $scope.viewModel.selectedCategory.isCreateNew = false;
      $scope.viewModel.categoryList.push($scope.viewModel.selectedCategory);
      $scope.viewModel.filteredCategoryItemsList = $scope.viewModel.categoryList;
    }
    $scope.handleChange();
  };
  $scope.dateRangeUpdated = function (value) {
    var dateArray = _.split(value, '::');
    if (dateArray[1] !== ' ' && dateArray[0] !== 'ALL') {
      $scope.viewModel.scoringRule.effectiveDateRangeBegin = moment.utc(dateArray[1].split('+')[0]);
    } else {
      $scope.viewModel.scoringRule.effectiveDateRangeBegin = null;
    }
    if (dateArray[0] !== 'ALL') {
      $scope.viewModel.scoringRule.effectiveDateRangeEnd = moment.utc(dateArray[2].split('+')[0]);
    } else {
      $scope.viewModel.scoringRule.effectiveDateRangeEnd = null;
    }
    if (dateUtil.isBefore($scope.viewModel.scoringRule.effectiveDateRangeEnd, $scope.viewModel.scoringRule.effectiveDateRangeBegin)) {
      $scope.viewModel.scoringRule.effectiveDateRangeEnd = null;
    }
    if ($scope.viewModel.dateInitialized === false) {
      $scope.viewModel.dateInitialized = true;
    } else {
      $scope.handleChange();
    }
  };
  $scope.onTextInputFocused = function (event) {
    unSelectAllRow();
  };
  $scope.valueScoreItemBlur = function (event, item) {
    if ($scope.fieldValidator === 'numberValidator') {
      $scope.rangeItemBlur(event, item);
    } else {
      if (_.isEmpty(String(item.value)) && _.isEmpty(String(item.score))) {
        item.isValid = true;
      } else {
        if (item.value !== '-') {
          if ($scope.viewModel.fieldValueScoringList.length > 1) {
            var valueArray = [],
              matchValueArray = [];
            _.each($scope.viewModel.fieldValueScoringList, function (fieldValue) {
              if (_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
                fieldValue.isValid = true;
              } else if (_.isEmpty(String(fieldValue.value)) && !_.isEmpty(String(fieldValue.score))) {
                fieldValue.isValid = false;
              } else {
                if (valueArray.length !== 0 && valueArray.indexOf(fieldValue.value) !== -1) {
                  matchValueArray.push(fieldValue.value);
                } else {
                  valueArray.push(fieldValue.value);
                }
                fieldValue.isValid = true;
              }
            });
            _.each(matchValueArray, function (value) {
              _.each($scope.viewModel.fieldValueScoringList, function (fieldValue) {
                if (value === fieldValue.value && !_.isEmpty(fieldValue.value)) {
                  fieldValue.isValid = false;
                }
              });
            });
          } else {
            item.isValid = true;
          }
        } else {
          item.isValid = false;
        }
      }
    }
    if (allFieldValueScoringListItemsValid()) {
      removeEmptyLastRows();
      $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
    }
    $scope.onItemChange();
  };
  $scope.rangeItemBlur = function (event, item) {
    item.tooltip = '';
    if (_.isEmpty(String(item.min)) && _.isEmpty(String(item.max)) && _.isEmpty(String(item.score))) {
      return true;
    }
    if (isMinMaxValid(item)) {
      if (!_.isEmpty(String(item.min)) && !_.isEmpty(String(item.max))) {
        if (parseFloat(item.min) > parseFloat(item.max)) {
          $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'rangeValidationMessage'));
          item.isValid = false;
          item.tooltip = _.get(translations, 'rangeValidationMessage');
        } else {
          if (_.isEmpty(String(item.score))) {
            item.isValid = false;
          } else {
            item.isValid = true;
          }
        }
      } else {
        item.isValid = true;
      }
    } else {
      item.isValid = false;
    }
    $scope.onItemChange();
  };
  function isMinMaxValid(item) {
    if (!_.isEmpty(String(item.min)) && !_.isEmpty(String(item.max)) && !_.isEmpty(String(item.score))) {
      return true;
    } else if (_.isEmpty(String(item.min)) && !_.isEmpty(String(item.max)) && !_.isEmpty(String(item.score)) || !_.isEmpty(String(item.min)) && _.isEmpty(String(item.max)) && !_.isEmpty(String(item.score))) {
      return true;
    }
    return false;
  }
  $scope.addItem = function (event, item) {
    var items = [];
    if (!isEmptyDataItem(item)) {
      _.each($scope.viewModel.fieldValueScoringList, function (fieldValueScoring) {
        if (!isEmptyDataItem(fieldValueScoring)) {
          items.push(fieldValueScoring);
        }
      });
      $scope.viewModel.fieldValueScoringList = items;
    }
    if (allFieldValueScoringListItemsValid()) {
      removeEmptyLastRows();
      $scope.viewModel.fieldValueScoringList(getEmptyObj());
    }
  };
  function allFieldValueScoringListItemsValid() {
    var result = true,
      isEmptyRowExist = false;
    _.each($scope.viewModel.fieldValueScoringList, function (fieldValueScoring) {
      if (isEmptyDataItem(fieldValueScoring)) {
        isEmptyRowExist = true;
      }
      if (!fieldValueScoring.isValid) {
        result = false;
      }
    });
    if (!isEmptyRowExist && result) {
      return true;
    }
    return false;
  }
  function unSelectAllRow() {
    _.each($scope.viewModel.fieldValueScoringList, function (fieldValue) {
      fieldValue.selected = false;
    });
  }
  $scope.onScoringItemSelected = function (event, item) {
    if ($scope.viewModel.fieldValueScoringList.length > 1) {
      if (event.ctrlKey) {
        item.selected = !item.selected;
      } else if (event.shiftKey) {
        item.selected = true;
      } else {
        unSelectAllRow();
        if ($scope.fieldValidator === 'numberValidator') {
          if (_.isEmpty(String(item.min)) && _.isEmpty(String(item.max)) && _.isEmpty(String(item.score))) {
            item.selected = false;
          } else {
            item.selected = true;
          }
        } else {
          if (_.isEmpty(String(item.value)) && _.isEmpty(String(item.score))) {
            item.selected = false;
          } else {
            item.selected = true;
          }
        }
      }
    }
  };
  $scope.onFieldKeyPress = function ($event) {
    var keyCode = $event.which || $event.keyCode;
    if (!isMinus(keyCode) && !isDecimal(keyCode) && !isBackspace(keyCode) && !isTab(keyCode) && isOutOfRange(keyCode)) {
      $event.preventDefault();
    }
  };
  $scope.onScoreKeyPress = function ($event) {
    var keyCode = $event.which || $event.keyCode;
    if (!isMinus(keyCode) && !isBackspace(keyCode) && !isTab(keyCode) && isOutOfRange(keyCode)) {
      $event.preventDefault();
    }
  };
  function isMinus(keyCode) {
    return keyCode === 45;
  }
  function isDecimal(keyCode) {
    return keyCode === 46;
  }
  function isBackspace(keyCode) {
    return keyCode === 8;
  }
  function isTab(keyCode) {
    return keyCode === 9;
  }
  function isOutOfRange(keyCode) {
    return keyCode < 48 || keyCode > 57;
  }
  $scope.handleDeleteKeyEventAction = function () {
    var result = false,
      emptyRowPresent = false;
    timeoutList.push($timeout(function () {
      _.remove($scope.viewModel.fieldValueScoringList, function (fieldValue) {
        if (fieldValue.selected) {
          result = true;
          return result;
        }
      });
      if (result) {
        _.each($scope.viewModel.fieldValueScoringList, function (fieldValue) {
          if (isEmptyDataItem(fieldValue)) {
            emptyRowPresent = true;
          }
        });
        if (!emptyRowPresent) {
          $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
        }
        $scope.onItemChange();
      }
    }), 0);
  };
  function isEmptyDataItem(item) {
    if ($scope.fieldValidator === 'numberValidator') {
      return _.isEmpty(String(item.min)) && _.isEmpty(String(item.max)) && _.isEmpty(String(item.score));
    } else {
      return _.isEmpty(String(item.value)) && _.isEmpty(String(item.score));
    }
  }
  function removeEmptyLastRows() {
    _.remove($scope.viewModel.fieldValueScoringList, function (fieldValueScoring) {
      return isEmptyDataItem(fieldValueScoring);
    });
  }
  $scope.$on(configurationConstant.event.SCORING_RULE_UPDATED, function (event, scoringRuleId) {
    var scoringRule = scoringRulesEditorModel.getScoringRule(scoringRuleId);
    $scope.viewModel.scoringRule = scoringRule;
    if (parseInt(scoringRuleId) !== -1 && !$scope.viewModel.dateInitialized) {
      dataSetUtil.getDataSet({
        name: 'Scoring Rule Folders'
      }).then(function (dataset) {
        $scope.viewModel.categoryList = dataset.items;
        _.each($scope.viewModel.categoryList, function (category) {
          if (parseInt(category.value) === scoringRule.scoringFolderId) {
            $scope.viewModel.selectedCategory = category;
          }
        });
      });
      if (!_.isNil(scoringRule.effectiveDateRangeBegin) || !_.isNil(scoringRule.effectiveDateRangeEnd)) {
        $scope.viewModel.effectiveDateRange = 'SPECIFIED::';
        if (!_.isNil(scoringRule.effectiveDateRangeBegin)) {
          $scope.viewModel.effectiveDateRange += dateUtil.formatShortDate(moment.utc(scoringRule.effectiveDateRangeBegin));
        }
        $scope.viewModel.effectiveDateRange += '::';
        if (!_.isNil(scoringRule.effectiveDateRangeEnd)) {
          $scope.viewModel.effectiveDateRange += dateUtil.formatShortDate(moment.utc(scoringRule.effectiveDateRangeEnd));
        }
      } else {
        $scope.viewModel.dateInitialized = true;
      }
      $timeout(function () {
        $rootScope.$broadcast(coreConstant.event.REFRESH_MULTI_SELECT, $scope.viewModel.scoringRule.formTemplateUniqueName, $scope.viewModel.scoringRule.variableName, $scope.viewModel.inputFormField);
        $rootScope.$broadcast(coreConstant.event.REFRESH_DATE_RANGE);
      }, 100);
      if ($scope.viewModel.scoringRule.formTemplateUniqueName !== '') {
        $scope.viewModel.showInputFormField = true;
      }
      $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName = scoringRule.triggerFieldFormTemplateUniqueName;
      $scope.viewModel.scoringRule.triggerFieldVariableName = scoringRule.triggerFieldVariableName;
      $scope.viewModel.selectedDataSet = [];
      if (!_.isNil($scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName) && $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName !== '') {
        var triggerFieldValues = xmlUtil.parseString(scoringRule.triggerFieldValue);
        triggerDataSet($scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName, $scope.viewModel.scoringRule.triggerFieldVariableName, triggerFieldValues.triggerFieldValue);
        $timeout(function () {
          $rootScope.$broadcast(coreConstant.event.REFRESH_MULTI_SELECT, $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName, $scope.viewModel.scoringRule.triggerFieldVariableName, $scope.viewModel.multiStepComponentName);
        }, 100);
        $scope.viewModel.applyScoring = 'OnConditionMet';
        $scope.viewModel.showApplyScoring = true;
        _.each($scope.viewModel.operators, function (operator) {
          if (scoringRule.triggerOperator === operator.value) {
            $scope.viewModel.selectedOperator = operator;
            if (operator.value === 0) {
              $scope.viewModel.isDataSetField = true;
            }
          }
        });
        $scope.viewModel.selectedTriggerDataSetValues = triggerFieldValues;
        $scope.viewModel.selectedClassCodesValues = _.join(triggerFieldValues.triggerFieldValue, ',');
        if (!$scope.viewModel.isDataSetField && !$scope.viewModel.showClassCode && triggerFieldValues.triggerFieldValue) {
          $scope.viewModel.triggerFieldValue = triggerFieldValues.triggerFieldValue;
        }
      }
      fillScoringInputGrid();
    }
  });
  $scope.$on(configurationConstant.event.SELECTOR_WIDGET_UPDATED, function (event, item1Name, item2, multiselect, name) {
    updateSelectorWidget(item1Name, item2.fieldName, name);
    $scope.onItemChange();
    $scope.handleChange();
  });
  function triggerDataSet(item1Name, item2Name, selectedDataSets) {
    resetTriggerConditionForm();
    if (_.isEmpty(item1Name)) {
      $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName = '';
      $scope.viewModel.scoringRule.triggerFieldVariableName = '';
      $scope.viewModel.classCodeMockFieldStructure.fieldModel.value = [];
      $rootScope.$broadcast(coreConstant.event.RELOAD_CLASS_CODE_MULTI_SELECT);
      return;
    }
    var fieldValue = {};
    $scope.viewModel.selectedDataSet = [];
    $scope.viewModel.isDataSetField = false;
    $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName = item1Name;
    $scope.viewModel.scoringRule.triggerFieldVariableName = item2Name;
    $scope.viewModel.triggerDataSetList = [];
    if (!_.isNil($scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName) && $scope.viewModel.scoringRule.triggerFieldVariableName) {
      configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName(item1Name, item2Name).then(function (uiField) {
        if (!_.isEmpty(uiField.fieldTemplate.dataSetName)) {
          if (!_.isEmpty(uiField.fieldTemplate.dataSetName)) {
            var dataSetParams = {
              name: uiField.fieldTemplate.dataSetName
            };
            if (dataSetUtil.getDataSetType(dataSetParams.name) !== dataSetType.CUSTOM) {
              $scope.viewModel.isDataSetField = true;
              dataSetUtil.getDataSet(dataSetParams).then(function (result) {
                $scope.viewModel.triggerDataSetList = result.items;
                if (_.isArray(selectedDataSets)) {
                  $scope.viewModel.selectedTriggerDataSetValues = selectedDataSets;
                  $scope.viewModel.selectedDataSet = _.join(selectedDataSets, '::');
                } else {
                  $scope.viewModel.selectedTriggerDataSetValues = [selectedDataSets];
                  $scope.viewModel.selectedDataSet = selectedDataSets;
                }
              });
            }
          }
        } else {
          if (uiField.fieldTemplate.type === fieldType.CHECK_BOX) {
            fieldValue = {};
            fieldValue.name = _.get(translations, 'true');
            fieldValue.value = _.get(translations, 'true');
            $scope.viewModel.triggerDataSetList.push(fieldValue);
            fieldValue = {};
            fieldValue.name = _.get(translations, 'false');
            fieldValue.value = _.get(translations, 'false');
            $scope.viewModel.triggerDataSetList.push(fieldValue);
          } else if (uiField.fieldTemplate.type === fieldType.YES_NO) {
            fieldValue = {};
            fieldValue.name = _.get(translations, 'yes');
            fieldValue.value = _.get(translations, 'yes');
            $scope.viewModel.triggerDataSetList.push(fieldValue);
            fieldValue = {};
            fieldValue.name = _.get(translations, 'no');
            fieldValue.value = _.get(translations, 'no');
            $scope.viewModel.triggerDataSetList.push(fieldValue);
          } else if (uiField.fieldTemplate.type === fieldType.CLASSCODEFINDER) {
            $scope.viewModel.isClassCodePicker = true;
            if (!_.isNil(selectedDataSets)) {
              $scope.viewModel.showClassCode = $scope.viewModel.scoringRule.triggerOperator === 0;
            }
          } else {
            if (!_.isNil(selectedDataSets) && selectedDataSets !== '') {
              $scope.viewModel.triggerFieldValue = selectedDataSets;
            }
          }
          if (!_.isNil(selectedDataSets)) {
            $scope.viewModel.selectedDataSet = [];
            if (!_.isObject(selectedDataSets)) {
              $scope.viewModel.selectedDataSet.push(selectedDataSets);
            } else {
              _.each($scope.viewModel.triggerDataSetList, function (triggerDataSet) {
                _.each(selectedDataSets, function (selectedDataSet) {
                  if (triggerDataSet.value === selectedDataSet) {
                    $scope.viewModel.selectedDataSet.push(selectedDataSet);
                  }
                });
              });
              if ($scope.viewModel.isClassCodePicker) {
                $scope.viewModel.selectedDataSet = selectedDataSets;
              }
            }
            $scope.viewModel.classCodeMockFieldStructure.uiField = uiField;
            $scope.viewModel.classCodeMockFieldStructure.fieldModel.value = _.join($scope.viewModel.selectedDataSet, '::,');
          }
          $scope.isTriggerRuleValid();
        }
      });
    }
  }
  function updateSelectorWidget(item1Name, item2, name) {
    if (name === $scope.viewModel.inputFormField) {
      $scope.fieldValidator = null;
    }
    if (name === 'triggerForm') {
      $scope.viewModel.selectedDataSet = [];
      $scope.viewModel.classCodeMockFieldStructure.fieldModel.value = null;
      $scope.viewModel.isDataSetField = false;
      triggerDataSet(item1Name, item2);
    } else {
      $scope.viewModel.scoringRule.formTemplateUniqueName = item1Name !== '' && !_.isNil(item1Name) ? item1Name : '';
      $scope.viewModel.scoringRule.variableName = item2 !== '' && !_.isNil(item2) ? item2 : '';
      $scope.viewModel.fieldValueScoringList = [];
      if (!_.isNil($scope.viewModel.scoringRule.formTemplateUniqueName) && $scope.viewModel.scoringRule.formTemplateUniqueName !== '' && !_.isNil($scope.viewModel.scoringRule.variableName) && $scope.viewModel.scoringRule.variableName !== '') {
        fillDataSet(item1Name, item2);
      } else {
        $scope.viewModel.showInputFormField = false;
        $scope.viewModel.showRefresh = false;
      }
    }
  }
  function fillDataSet(item1Name, item2Name) {
    $scope.viewModel.fieldValueScoringList = [];
    configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName(item1Name, item2Name).then(function (uiField) {
      if (uiField.fieldTemplate.type === fieldType.LABEL || uiField.fieldTemplate.type === fieldType.SPACER || uiField.fieldTemplate.type === fieldType.ROWREPEATER || uiField.fieldTemplate.type === fieldType.FUNCTION_BUTTON || uiField.fieldTemplate.type === fieldType.LINK_BUTTON || uiField.fieldTemplate.type === fieldType.FORM_SUMMARY_GRID || uiField.fieldTemplate.type === fieldType.TEXT_AREA) {
        $scope.viewModel.showInputFormField = false;
        $scope.viewModel.showRefresh = false;
        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, $scope.viewModel.inputFormFieldErrorMessage);
        $scope.viewModel.scoringRule.formTemplateUniqueName = '';
        $scope.viewModel.scoringRule.variableName = '';
        $rootScope.$broadcast(coreConstant.event.REFRESH_MULTI_SELECT, $scope.viewModel.scoringRule.formTemplateUniqueName, $scope.viewModel.scoringRule.variableName, $scope.viewModel.inputFormField);
      } else {
        if (isFieldWithoutValidatorAndDataset(uiField) || uiField.fieldTemplate.validator === 'number' || uiField.fieldTemplate.validator === 'percent' || uiField.fieldTemplate.validator === 'currency' || uiField.fieldTemplate.validator === 'number with commas' || uiField.fieldTemplate.validator === 'number range') {
          $scope.viewModel.showInputFormField = true;
          $scope.fieldValidator = 'numberValidator';
          $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
          $scope.viewModel.showRefresh = false;
        } else {
          if (!_.isEmpty(uiField.fieldTemplate.dataSetName)) {
            var dataSetParams = {
              name: uiField.fieldTemplate.dataSetName
            };
            if (dataSetUtil.getDataSetType(dataSetParams.name) === dataSetType.REPEATING_FORM || dataSetUtil.getDataSetType(dataSetParams.name) === dataSetType.CUSTOM) {
              $scope.viewModel.showInputFormField = true;
              $scope.viewModel.showRefresh = false;
              $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
            } else {
              dataSetUtil.getDataSet(dataSetParams).then(function (result) {
                var fieldValue = {};
                $scope.viewModel.showInputFormField = true;
                $scope.viewModel.showRefresh = result.items.length > 0;
                _.each(result.items, function (formula) {
                  fieldValue = {};
                  fieldValue.id = formula.id;
                  fieldValue.value = !_.isNil(formula.value) ? formula.value : '';
                  fieldValue.score = !_.isNil(formula.score) ? formula.score : '';
                  if (_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
                    fieldValue.isValid = false;
                  } else if (!_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
                    fieldValue.isValid = true;
                  } else if (!_.isEmpty(String(fieldValue.value)) && !_.isEmpty(String(fieldValue.score))) {
                    fieldValue.isValid = true;
                  } else {
                    fieldValue.isValid = false;
                  }
                  $scope.viewModel.formFieldDataSets.push(fieldValue);
                });
                $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
              });
            }
          } else {
            var fieldValue = {};
            $scope.viewModel.showRefresh = false;
            if (uiField.fieldTemplate.type === fieldType.CHECK_BOX) {
              $scope.viewModel.showInputFormField = true;
              fieldValue = {};
              fieldValue.value = _.get(translations, 'true');
              fieldValue.score = '';
              fieldValue.isValid = true;
              $scope.viewModel.fieldValueScoringList.push(fieldValue);
              fieldValue = {};
              fieldValue.value = _.get(translations, 'false');
              fieldValue.score = '';
              fieldValue.isValid = true;
              $scope.viewModel.fieldValueScoringList.push(fieldValue);
              $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
            } else if (uiField.fieldTemplate.type === fieldType.YES_NO) {
              $scope.viewModel.showInputFormField = true;
              fieldValue = {};
              fieldValue.value = _.get(translations, 'yes');
              fieldValue.score = '';
              fieldValue.isValid = true;
              $scope.viewModel.fieldValueScoringList.push(fieldValue);
              fieldValue = {};
              fieldValue.value = _.get(translations, 'no');
              fieldValue.score = '';
              fieldValue.isValid = true;
              $scope.viewModel.fieldValueScoringList.push(fieldValue);
              $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
            } else {
              $scope.viewModel.showInputFormField = true;
              $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
            }
          }
          $scope.onItemChange();
        }
      }
    });
  }
  function isFieldWithoutValidatorAndDataset(uiField) {
    return _.isEmpty(uiField.fieldTemplate.dataSetName) && (_.isNil(uiField.fieldTemplate.validator) || uiField.fieldTemplate.validator === '[select]');
  }
  function getEmptyObj() {
    var emptyObj = {};
    emptyObj.value = '';
    emptyObj.score = '';
    emptyObj.min = '';
    emptyObj.max = '';
    emptyObj.isValid = true;
    return emptyObj;
  }
  function resetTriggerConditionForm() {
    $scope.viewModel.triggerFieldValue = '';
    $scope.viewModel.selectedOperator = '';
  }
  $scope.onRefreshClick = function () {
    if ($scope.viewModel.fieldValueScoringList.length === 1 && $scope.viewModel.fieldValueScoringList[0].value === '' && $scope.viewModel.fieldValueScoringList[0].score === '') {
      if ($scope.viewModel.populatedScoringFormulas.length === 0) {
        $scope.viewModel.fieldValueScoringList = _.map($scope.viewModel.formFieldDataSets, _.clone);
        $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
      } else {
        $scope.viewModel.fieldValueScoringList = $scope.viewModel.populatedScoringFormulas;
        $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
      }
    } else {
      var matchItems = [],
        gridItems = [];
      $scope.viewModel.populatedScoringFormulas = _.map($scope.viewModel.formFieldDataSets, _.clone);
      gridItems = _.map($scope.viewModel.fieldValueScoringList, _.clone);
      _.each(gridItems, function (item) {
        _.each($scope.viewModel.populatedScoringFormulas, function (scoringFormula) {
          if (scoringFormula.value === item.value && scoringFormula.score === item.score) {
            matchItems.push(item);
          }
        });
      });
      _.remove(gridItems, function (fieldVal) {
        return fieldVal.value === '' && fieldVal.score === '';
      });
      if (matchItems.length === gridItems.length) {
        refreshGrid();
      } else {
        _.each($scope.viewModel.populatedScoringFormulas, function (scoringFormula) {
          _.remove(gridItems, function (item) {
            return scoringFormula.value === item.value && scoringFormula.score === item.score;
          });
        });
        if (gridItems.length > 0) {
          openRefreshModal(gridItems);
        }
      }
    }
    $scope.onItemChange();
  };
  function refreshGrid() {
    var populateScoringFormula = _.map($scope.viewModel.populatedScoringFormulas, _.clone);
    removeEmptyLastRows();
    _.each($scope.viewModel.fieldValueScoringList, function (item) {
      _.remove(populateScoringFormula, function (scoringFormula) {
        return scoringFormula.value.toUpperCase() === item.value.toUpperCase() && scoringFormula.score === item.score;
      });
    });
    _.each(populateScoringFormula, function (formula) {
      $scope.viewModel.fieldValueScoringList.push(formula);
    });
    $scope.viewModel.fieldValueScoringList.sort(function (item1, item2) {
      var item1Value = item1.value.toUpperCase();
      var item2Value = item2.value.toUpperCase();
      if (item1Value < item2Value) {
        return -1;
      }
      if (item1Value > item2Value) {
        return 1;
      }
      return 0;
    });
    $scope.viewModel.scoringRule.formulas = _.map($scope.viewModel.fieldValueScoringList, _.clone);
    $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
  }
  function openRefreshModal(filteredList) {
    var modalInstance = $uibModal.open({
      templateUrl: '/configuration/scoringRules/manageScoringRules/refreshModal.tpl.html',
      controller: 'refreshModalController',
      windowClass: 'refreshModal',
      resolve: {
        options: {
          title: $scope.viewModel.warningLabel,
          message: $scope.viewModel.warningMessage,
          deleteAll: $scope.viewModel.deleteAll,
          doNotDelete: $scope.viewModel.doNotDelete,
          scoringFormulas: filteredList
        }
      }
    });
    modalInstance.result.then(function (result) {
      if (!_.isNil(result)) {
        refreshGrid();
      } else {
        _.each(filteredList, function (item1) {
          _.remove($scope.viewModel.fieldValueScoringList, function (item2) {
            return item1.value === item2.value;
          });
        });
        refreshGrid();
      }
    });
  }
  $scope.handleChange = function () {
    var triggerField = {
      triggerFieldValues: {
        triggerFieldValue: []
      }
    };
    //Category
    if (!_.isNil($scope.viewModel.selectedCategory)) {
      $scope.viewModel.scoringRule.scoringFolderName = $scope.viewModel.selectedCategory.name;
      if (!_.isInteger(parseInt($scope.viewModel.selectedCategory.value))) {
        $scope.viewModel.scoringRule.scoringFolderId = -1;
      } else {
        $scope.viewModel.scoringRule.scoringFolderId = $scope.viewModel.selectedCategory.value;
      }
    } else {
      $scope.viewModel.scoringRule.scoringFolderName = null;
      $scope.viewModel.scoringRule.scoringFolderId = null;
    }
    //trigger rule - Operator
    if (!_.isEmpty($scope.viewModel.selectedOperator)) {
      $scope.viewModel.scoringRule.triggerOperator = $scope.viewModel.selectedOperator.value;
    }
    // trigger rule - triggerFieldValue i.e Single Value
    if (!_.isEmpty($scope.viewModel.triggerFieldValue)) {
      if ($scope.viewModel.scoringRule.operator === 0) {
        _.each($scope.viewModel.triggerDataSetList, function (dataset) {
          if (dataset.selected) {
            $scope.viewModel.selectedDataSet.push(dataset);
          }
        });
        triggerField.triggerFieldValues.triggerFieldValue = _.split($scope.viewModel.selectedDataSet, ',');
      } else {
        triggerField.triggerFieldValues.triggerFieldValue.push($scope.viewModel.triggerFieldValue);
      }
      $scope.viewModel.scoringRule.triggerFieldValue = xmlUtil.toXmlString(triggerField);
    } else if (!_.isEmpty($scope.viewModel.selectedTriggerDataSetValues) && _.isArray($scope.viewModel.selectedTriggerDataSetValues)) {
      triggerField.triggerFieldValues.triggerFieldValue = [];
      _.each($scope.viewModel.selectedTriggerDataSetValues, function (dataItem) {
        if (!_.isNil(dataItem)) {
          if (_.isNil(dataItem.value)) {
            triggerField.triggerFieldValues.triggerFieldValue.push(dataItem);
          } else {
            triggerField.triggerFieldValues.triggerFieldValue.push(dataItem.value);
          }
        }
      });
      $scope.viewModel.scoringRule.triggerFieldValue = xmlUtil.toXmlString(triggerField);
    } else if (!_.isEmpty($scope.viewModel.selectedClassCodesValues)) {
      var classCodeArr = $scope.viewModel.selectedClassCodesValues.split(',');
      triggerField.triggerFieldValues.triggerFieldValue = [];
      if (classCodeArr.length > 1) {
        _.each(classCodeArr, function (dataItem) {
          triggerField.triggerFieldValues.triggerFieldValue.push(dataItem);
        });
      } else {
        triggerField.triggerFieldValues.triggerFieldValue.push($scope.viewModel.selectedClassCodesValues);
      }
      $scope.viewModel.scoringRule.triggerFieldValue = xmlUtil.toXmlString(triggerField);
    } else {
      $scope.viewModel.scoringRule.triggerFieldValue = null;
    }
    if ($scope.viewModel.showApplyScoring === false) {
      $scope.viewModel.scoringRule.triggerOperator = null;
      $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName = null;
      $scope.viewModel.scoringRule.triggerFieldVariableName = null;
      $scope.viewModel.scoringRule.triggerFieldValue = null;
    }
    if (_.isNil($scope.viewModel.scoringRule.formulas)) {
      fillScoringFormulasWithDataSet();
    }
    isScoringRuleValid();
    scoringRulesEditorModel.setUnsavedChanges($scope.viewModel.scoringRule.id, true);
  };
  var isScoringRuleValid = function isScoringRuleValid() {
    var scoringRule = $scope.viewModel.scoringRule,
      isValid = true;
    if (_.isEmpty(scoringRule.name)) {
      isValid = false;
    } else if (_.isEmpty(scoringRule.scoringFolderName)) {
      isValid = false;
    } else if (_.isEmpty(scoringRule.effectiveDateRangeBegin)) {
      isValid = false;
    } else if ($scope.viewModel.showApplyScoring === true && (_.isNaN(scoringRule.triggerOperator) || _.isEmpty(scoringRule.triggerFieldFormTemplateUniqueName) || _.isEmpty(scoringRule.triggerFieldVariableName) || _.isEmpty(scoringRule.triggerFieldValue))) {
      isValid = false;
    } else if (_.isEmpty(scoringRule.formTemplateUniqueName) || _.isEmpty(scoringRule.variableName)) {
      isValid = false;
    } else if ($scope.formulasValid === false) {
      isValid = false;
    }
    scoringRulesEditorModel.setValid(scoringRule.id, isValid);
  };
  $scope.handleApplyScoringChange = function () {
    resetTriggerConditionForm();
    $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName = '';
    $scope.viewModel.scoringRule.triggerFieldVariableName = '';
    $timeout(function () {
      $rootScope.$broadcast(coreConstant.event.REFRESH_MULTI_SELECT, $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName, $scope.viewModel.scoringRule.triggerFieldVariableName, $scope.viewModel.multiStepComponentName);
    }, 100);
    if ($scope.viewModel.applyScoring === 'OnConditionMet') {
      $scope.viewModel.showApplyScoring = true;
      $scope.viewModel.showClassCode = false;
    } else {
      $scope.viewModel.showApplyScoring = false;
    }
    $scope.handleChange();
  };
  $scope.isTriggerRuleValid = function () {
    if ($scope.viewModel.scoringRule) {
      if (!isValueExist($scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName) && !isValueExist($scope.viewModel.scoringRule.triggerFieldVariableName) && _.isNil($scope.viewModel.selectedOperator.name) && _.isEmpty($scope.viewModel.triggerFieldValue)) {
        return true;
      } else {
        if (isValueExist($scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName) && isValueExist($scope.viewModel.scoringRule.triggerFieldVariableName) && !_.isNil($scope.viewModel.selectedOperator.name)) {
          if ($scope.viewModel.isDataSetField) {
            if (!_.isEmpty($scope.viewModel.selectedTriggerDataSetValues) || !_.isEmpty($scope.viewModel.selectedClassCodesValues)) {
              return true;
            }
          } else {
            if (!_.isEmpty($scope.viewModel.triggerFieldValue)) {
              return true;
            }
            if ($scope.viewModel.showClassCode) {
              if (!_.isEmpty($scope.viewModel.selectedClassCodesValues)) {
                return true;
              }
            }
          }
        }
      }
      return false;
    } else {
      return true;
    }
  };
  $scope.handleClassCodeValueChange = function (classCodeValue) {
    $scope.viewModel.selectedClassCodesValues = classCodeValue;
    $scope.handleChange();
  };
  $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
    $scope.viewModel.selectedTriggerDataSetValues = [];
    if (itemName === $scope.viewModel.itemName) {
      _.each($scope.viewModel.triggerDataSetList, function (triggerDataSet) {
        if (triggerDataSet.selected) {
          $scope.viewModel.selectedTriggerDataSetValues.push(triggerDataSet);
        }
      });
      $scope.handleChange();
    } else if (itemName === $scope.viewModel.multiStepComponentName) {
      $scope.handleChange();
    }
  });
  function isValueExist(val) {
    if (val && !_.isEmpty(val) && !_.isNil(val)) {
      return true;
    }
    return false;
  }
  $scope.$on('$destroy', function () {
    _.each(timeoutList, function (item) {
      $timeout.cancel(item);
    });
  });
  loadCategoryList();
};
ManageScoringRulesController.$inject = ["$scope", "$rootScope", "$stateParams", "$uibModal", "scoringRulesEditorModel", "coreConstant", "localization", "configurationConstant", "dateUtil", "configurationMediator", "fieldType", "dataSetUtil", "$timeout", "dataSetType", "xmlUtil", "authorizationConstants", "currentUserModel"];
angular.module('ums.configuration').controller('manageScoringRulesController', ManageScoringRulesController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(2)))

/***/ }),

/***/ 2601:
/***/ (function(module) {

module.exports = JSON.parse("{\"manageScoringRules\":{\"title\":\"Scoring Rule Information\",\"name\":\"Name\",\"namePrompt\":\"Scoring Rule Name\",\"category\":\"Category\",\"categoryPrompt\":\"Category\",\"createNewCategory\":\"(Create New Category)\",\"effectiveDateRange\":\"Effective Date Range\",\"effectiveStartDatePrompt\":\"Effective Start Date\",\"effectiveEndDatePrompt\":\"Effective End Date\",\"inputFormField\":\"Input Form Field\",\"inputFormFieldPrompt\":\"Select Input Form Field\",\"fieldValueScoring\":\"Field Value Scoring\",\"value\":\"Value\",\"score\":\"Score\",\"min\":\"Min\",\"max\":\"Max\",\"enterLabel\":\"Enter Label\",\"applySorting\":\"Apply Sorting\",\"always\":\"Always\",\"whenConditionIsMet\":\"When Condition is met\",\"effectiveDateRangeStartPrompt\":\"\",\"endDateValidationErrorMessage\":\"The End Date cannot be less the Start Date\",\"true\":\"True\",\"false\":\"False\",\"yes\":\"Yes\",\"no\":\"No\",\"rangeValidationMessage\":\"The minimum value must be lower or equal to the maximum value\",\"minPrompt\":\"Enter Min\",\"maxPrompt\":\"Enter Max\",\"valuePrompt\":\"Enter Value\",\"scorePrompt\":\"Enter Score\",\"refresh\":\"Refresh\",\"applyScoring\":\"Apply Scoring\",\"selectOperatorPrompt\":\"Select Operator\",\"selectDataSetPrompt\":\"Select DataSet\",\"isInList\":\"is in list\",\"contains\":\"contains\",\"matches\":\"matches\",\"inputFormFieldErrorMessage\":\"The selected field type is not allowed for scoring rules\",\"warningLabel\":\"Warning\",\"warningMessage\":\"Some scoring formulas are no longer part of the associated dataset. Click 'Delete All' to delete all obsolete formulas or 'Do Not Delete' to leave them intact.\",\"deleteAll\":\"Delete All\",\"doNotDelete\":\"Do Not Delete\",\"addValuePrompt\":\"Add Value\",\"flags\":\"Flags\",\"flagsPrompt\":\"Enter Flags Value\"}}");

/***/ }),

/***/ 2602:
/***/ (function(module, exports) {

var path = '/configuration/scoringRules/manageScoringRules/manageScoringRules.tpl.html';
var html = "<div class=\"manageScoringRules\" ui-delete-data-items-and-groups>\n\n    <ui-scoring-rules-editor-header-component class=\"scoringRulesEditorHeader\"></ui-scoring-rules-editor-header-component>\n\n    <div class=\"formContainer\">\n\n        <fieldset class=\"subContainer\"\n                  ng-disabled=\"::!viewModel.hasManagePermission\">\n\n            <div class=\"content\">\n\n                <div>\n\n                    <span class=\"title\" ui-translate>manageScoringRules.fieldValueScoring</span>\n\n                    <div class=\"requiredRow scoringRuleNameField\">\n\n                        <ui-required-indicator class=\"requiredIndicator scoringRuleNameRequiredIndicator\"\n                                               value=\"{{ viewModel.scoringRule.name }}\">\n                        </ui-required-indicator>\n\n                        <div class=\"rowItem\">\n                            <span ui-translate>manageScoringRules.name</span>\n                        </div>\n\n                        <input type=\"text\"\n                               ng-model=\"viewModel.scoringRule.name\"\n                               ng-change=\"handleChange()\"\n                               value=\"{{ viewModel.scoringRule.name }}\"\n                               placeholder=\"{{ ::viewModel.namePrompt }}\"\n                               ng-disabled=\"::!viewModel.hasManagePermission\"\n                               class=\"textInput\"/>\n                    </div>\n\n                    <div class=\"requiredRow\">\n\n                        <ui-required-indicator class=\"requiredIndicator scoringRuleCategoryRequiredIndicator\"\n                                               value=\"{{viewModel.selectedCategory.name}}\"></ui-required-indicator>\n\n                        <div class=\"rowItem\">\n\n                            <span ui-translate>manageScoringRules.category</span>\n                        </div>\n\n                        <div class=\"dropdownContainer\">\n\n                            <ui-select class=\"dropdownFormComponent dropdownComponentSelect scoringCategoryField\"\n                                       theme=\"select2\"\n                                       ng-model=\"viewModel.selectedCategory\"\n                                       on-select=\"handleSelect()\"\n                                       ng-change=\"handleChange()\"\n                                       append-to-body=\"true\"\n                                       ng-disabled=\"::!viewModel.hasManagePermission\">\n\n                                <ui-select-match placeholder=\"{{ ::viewModel.categoryPrompt }}\"\n                                                 allow-clear=\"true\">\n\n                                    <span>{{viewModel.selectedCategory.name}}</span>\n                                </ui-select-match>\n\n                                <ui-select-choices refresh=\"filterItems($select.search)\"\n                                                   refresh-delay=\"250\"\n                                                   repeat=\"item in viewModel.filteredCategoryItemsList\">\n\n                                    <span>{{ item.name }}</span>\n\n                                    <span ng-if=\"item.isCreateNew\"\n                                          class=\"createNewLabel\"\n                                          ui-translate>manageScoringRules.createNewCategory</span>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n\n                    </div>\n\n                    <div class=\"requiredRow\">\n\n                        <ui-required-indicator class=\"requiredIndicator effectiveDateRequiredIndicator\"\n                                               value=\"{{viewModel.scoringRule.effectiveDateRangeBegin}}\"></ui-required-indicator>\n\n                        <div class=\"rowItem\">\n\n                            <span ui-translate>manageScoringRules.effectiveDateRange</span>\n                        </div>\n\n                        <div class=\"dateRangeBox\">\n\n                            <ui-date-range class=\"dateRange\"\n                                           date-value=\"viewModel.effectiveDateRange\"\n                                           end-date-validation-error-message=\"viewModel.endDateValidationErrorMessage\"\n                                           value-updated=\"dateRangeUpdated(value)\"\n                                           allow-independent-dates=\"true\"\n                                           allow-date-clearing=\"true\"\n                                           is-disabled=\"::!viewModel.hasManagePermission\"\n                                           timezone-mode=\"'utc'\">\n                            </ui-date-range>\n                        </div>\n\n                    </div>\n\n                    <div class=\"requiredRow scoringRuleFlagsField\">\n\n                        <div class=\"noRequiredIndicatorField\">\n\n                            <div class=\"rowItem\">\n                                <span ui-translate>manageScoringRules.flags</span>\n                            </div>\n                        </div>\n\n                        <input type=\"text\"\n                               ng-model=\"viewModel.scoringRule.flags\"\n                               ng-change=\"handleChange()\"\n                               value=\"{{ viewModel.scoringRule.flags }}\"\n                               placeholder=\"{{ ::viewModel.flagsPrompt }}\"\n                               ng-disabled=\"::!viewModel.hasManagePermission\"\n                               class=\"textInput\"/>\n                    </div>\n\n                    <div class=\"applyScoring\">\n\n                        <div class=\"rowItem\">\n\n                            <span ui-translate>manageScoringRules.applyScoring</span>\n                        </div>\n\n                        <div class=\"noRequiredIndicatorField\">\n\n                            <div>\n\n                                <input type=\"radio\"\n                                       class=\"alwaysButton\"\n                                       ng-model=\"viewModel.applyScoring\"\n                                       value=\"always\"\n                                       ng-change=\"handleApplyScoringChange()\"/>\n\n                                <span ui-translate>manageScoringRules.always</span>\n                            </div>\n\n                            <div>\n\n                                <input type=\"radio\"\n                                       class=\"whenConditionIsMetButton\"\n                                       ng-model=\"viewModel.applyScoring\"\n                                       value=\"OnConditionMet\"\n                                       ng-change=\"handleApplyScoringChange()\"/>\n\n                                <span ui-translate>manageScoringRules.whenConditionIsMet</span>\n                            </div>\n\n                            <div class=\"triggerRule\"\n                                 ng-show=\"viewModel.showApplyScoring\"\n                                 ng-class=\"{'error':!isTriggerRuleValid(),'valid':isTriggerRuleValid()}\">\n\n                                <div class=\"formFieldPicker\">\n\n                                    <ui-multi-step-selector-widget class=\"scoringRuleCondition\"\n                                                                   mode=\"viewModel.selectorWidgetMode\"\n                                                                   step-1-item-name=\"viewModel.scoringRule.triggerFieldFormTemplateUniqueName\"\n                                                                   step-2-item-name=\"viewModel.scoringRule.triggerFieldVariableName\"\n                                                                   is-disabled=\"::!viewModel.hasManagePermission\"\n                                                                   name=\"viewModel.multiStepComponentName\"></ui-multi-step-selector-widget>\n                                </div>\n\n                                <div class=\"operatorDropdown\"\n                                     uib-dropdown\n                                     ng-disabled=\"::!viewModel.hasManagePermission\">\n\n                                    <div class=\"dropdownLabel\"\n                                         uib-dropdown-toggle\n                                         ng-disabled=\"::!viewModel.hasManagePermission\">\n\n                                        {{ getOperator() }}\n\n                                        <span class=\"glyphicon glyphicon-chevron-down\"></span>\n                                    </div>\n\n                                    <ul uib-dropdown-menu\n                                        ng-disabled=\"::!viewModel.hasManagePermission\">\n\n                                        <li ng-repeat=\"operator in viewModel.operators track by $index\"\n                                            ng-click=\"onOperatorChange(operator)\">\n\n                                            <button class=\"operatorLabel btn-link\">{{ operator.name }}</button>\n                                        </li>\n                                    </ul>\n                                </div>\n\n                                <div class=\"dataSetDropdown\"\n                                     uib-dropdown\n                                     ng-if=\"viewModel.isDataSetField && !viewModel.isClassCodePicker\">\n\n                                    <ui-multi-select items-list=\"viewModel.triggerDataSetList\"\n                                                     class=\"multiSelectDropdown\"\n                                                     item-name=\"viewModel.itemName\"\n                                                     prompt-value=\"viewModel.selectDataSetPrompt\"\n                                                     append-to-body=\"true\"\n                                                     ui-hide-select-on-scroll-selector=\".triggerRule\"\n                                                     selected-value=\"viewModel.selectedDataSet\"\n                                                     is-disabled=\"::!viewModel.hasManagePermission\"></ui-multi-select>\n                                </div>\n\n                                <ui-multi-select-class-code ng-if=\"viewModel.showClassCode\"\n                                                            class=\"classCode\"\n                                                            field-structure=\"viewModel.classCodeMockFieldStructure\"\n                                                            effective-date=\"viewModel.classCodeMockEffectiveDate\"\n                                                            on-select=\"handleClassCodeValueChange(classCodeValue)\">\n                                </ui-multi-select-class-code>\n\n                                <div ng-if=\"!viewModel.isDataSetField && !viewModel.showClassCode\"\n                                     class=\"triggerInputBox\">\n\n                                    <input type=\"text\"\n                                           ng-model=\"viewModel.triggerFieldValue\"\n                                           ng-change=\"handleChange()\"\n                                           class=\"triggerInput\"\n                                           placeholder=\"{{viewModel.addValuePrompt}}\"\n                                           value=\"{{ viewModel.triggerFieldValue }}\"\n                                           ng-disabled=\"::!viewModel.hasManagePermission\"/>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"requiredRow inputFormField\">\n\n                        <ui-required-indicator class=\"requiredIndicator inputFormFieldRequiredIndicator\"\n                                               value=\"{{viewModel.scoringRule.variableName}}\"></ui-required-indicator>\n\n                        <div class=\"rowItem\">\n\n                            <span ui-translate>manageScoringRules.inputFormField</span>\n                        </div>\n\n                        <div class=\"multiSelectorField\">\n\n                            <ui-multi-step-selector-widget class=\"inputFieldSelector\"\n                                                           mode=\"viewModel.selectorWidgetMode\"\n                                                           step-1-item-name=\"viewModel.scoringRule.formTemplateUniqueName\"\n                                                           step-2-item-name=\"viewModel.scoringRule.variableName\"\n                                                           name=\"viewModel.inputFormField\"\n                                                           is-disabled=\"::!viewModel.hasManagePermission\">\n                            </ui-multi-step-selector-widget>\n                        </div>\n\n                        <div ng-if=\"viewModel.showRefresh\"\n                             class=\"refreshBox\">\n\n                            <button class=\"btn\"\n                                    ng-click=\"onRefreshClick()\"\n                                    ng-disabled=\"::!viewModel.hasManagePermission\">\n\n                                <span ui-translate>manageScoringRules.refresh</span>\n                            </button>\n                        </div>\n                    </div>\n\n                    <div ng-show=\"viewModel.showInputFormField\"\n                         class=\"fieldValueScoring\">\n\n                        <div class=\"rowItem fieldValueLabel\">\n\n                            <span ui-translate>manageScoringRules.fieldValueScoring</span>\n                        </div>\n\n                        <div class=\"scoringRuleTable\">\n\n                            <div class=\"scoringRuleTableHeader\">\n\n                                <div ng-if=\"!fieldValidator\"\n                                     class=\"scoringRuleTableHeaderCell\"\n                                     ui-translate>manageScoringRules.value</div>\n\n                                <div ng-if=\"fieldValidator==='numberValidator'\"\n                                     class=\"scoringRuleTableHeaderCell\"\n                                     ui-translate>manageScoringRules.min</div>\n\n                                <div ng-if=\"fieldValidator==='numberValidator'\"\n                                     class=\"scoringRuleTableHeaderCell scoringRuleTableHeaderValue\"\n                                     ui-translate>manageScoringRules.max</div>\n\n                                <div class=\"scoringRuleTableHeaderCell scoringRuleTableHeaderValue\"\n                                     ui-translate>manageScoringRules.score</div>\n                            </div>\n\n                            <div class=\"scoringRuleRow\"\n                                 ng-repeat=\"fieldValue in viewModel.fieldValueScoringList\"\n                                 ng-class=\"{'error':!fieldValue.isValid,'valid':fieldValue.isValid}\">\n\n                                <div ng-class=\"{'selected':fieldValue.selected}\"\n                                     uib-tooltip=\"{{fieldValue.tooltip}}\"\n                                     class=\"scoringRuleGroupTableRow\">\n\n                                    <div class=\"deleteSelector\"\n                                         ng-mouseup=\"onScoringItemSelected($event, fieldValue)\">\n\n                                        <span class=\"glyphicon glyphicon-option-vertical\"></span>\n                                    </div>\n\n                                    <div ng-if=\"!fieldValidator\"\n                                         class=\"scoringRuleTableRowCell scoringRuleTableRowValue\">\n\n                                        <input type=\"text\"\n                                               class=\"scoringRuleValueInput\"\n                                               ng-model=\"fieldValue.value\"\n                                               ng-focus=\"onTextInputFocused($event)\"\n                                               ng-blur=\"valueScoreItemBlur($event, fieldValue)\"\n                                               ng-change=\"onItemChange()\"\n                                               ui-enter=\"addItem($event, fieldValue)\"\n                                               placeholder=\"{{ ::viewModel.valuePrompt }}\"\n                                               ui-max-chars=\"255\"\n                                               tabindex=\"{{ $ctrl.groupIndex + ($index * 3) + 1 }}\"\n                                               ng-disabled=\"::!viewModel.hasManagePermission\"/>\n                                    </div>\n\n                                    <div ng-if=\"fieldValidator==='numberValidator'\"\n                                         class=\"scoringRuleTableRowCell scoringRuleTableRowValue\">\n\n                                        <input type=\"text\"\n                                               class=\"scoringRuleValueInput\"\n                                               ng-keypress=\"onFieldKeyPress($event,fieldValue)\"\n                                               ng-model=\"fieldValue.min\"\n                                               ng-blur=\"rangeItemBlur($event, fieldValue)\"\n                                               ng-focus=\"onTextInputFocused($event)\"\n                                               ng-change=\"onItemChange()\"\n                                               uib-tooltip=\"{{fieldValue.errorMessage}}\"\n                                               ui-enter=\"addItem($event, fieldValue)\"\n                                               placeholder=\"{{ ::viewModel.minPrompt }}\"\n                                               ui-max-chars=\"12\"\n                                               tabindex=\"{{ $ctrl.groupIndex + ($index * 3) + 1 }}\"\n                                               ng-disabled=\"::!viewModel.hasManagePermission\"/>\n                                    </div>\n\n                                    <div ng-if=\"fieldValidator==='numberValidator'\"\n                                         class=\"scoringRuleTableRowCell scoringRuleTableRowValue\">\n\n                                        <input type=\"text\"\n                                               class=\"scoringRuleValueInput\"\n                                               ng-keypress=\"onFieldKeyPress($event,fieldValue)\"\n                                               ng-model=\"fieldValue.max\"\n                                               ng-blur=\"rangeItemBlur($event, fieldValue)\"\n                                               ng-focus=\"onTextInputFocused($event)\"\n                                               ng-change=\"onItemChange()\"\n                                               ui-enter=\"addItem($event, fieldValue)\"\n                                               placeholder=\"{{ ::viewModel.maxPrompt }}\"\n                                               ui-max-chars=\"12\"\n                                               tabindex=\"{{ $ctrl.groupIndex + ($index * 3) + 2 }}\"\n                                               ng-disabled=\"::!viewModel.hasManagePermission\"/>\n                                    </div>\n\n                                    <div class=\"scoringRuleTableRowCell scoringRuleTableRowValue\">\n\n                                        <input type=\"text\"\n                                               class=\"scoringRuleValueInput\"\n                                               ng-model=\"fieldValue.score\"\n                                               ng-keypress=\"onScoreKeyPress($event)\"\n                                               ng-blur=\"valueScoreItemBlur($event, fieldValue)\"\n                                               ng-focus=\"onTextInputFocused($event)\"\n                                               ng-change=\"onItemChange()\"\n                                               ui-enter=\"addItem($event, fieldValue)\"\n                                               ui-max-chars=\"9\"\n                                               placeholder=\"{{ ::viewModel.scorePrompt }}\"\n                                               tabindex=\"{{ $ctrl.groupIndex + ($index * 3) + 3 }}\"\n                                               ng-disabled=\"::!viewModel.hasManagePermission\"/>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </fieldset>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2603:
/***/ (function(module, exports) {

/*@ngInject*/
var ManageScoringRulesRepository = function ManageScoringRulesRepository(baseRepository) {
  angular.extend(this, baseRepository);
};
ManageScoringRulesRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('manageScoringRulesRepository', ManageScoringRulesRepository);

/***/ }),

/***/ 2604:
/***/ (function(module, exports) {

var path = '/configuration/scoringRules/manageScoringRules/refreshModal.tpl.html';
var html = "<base-modal\n    modal-title=\"title\"\n    ok=\"deleteAll\"\n    cancel=\"doNotDelete\"\n    on-confirm=\"onDeleteAll()\"\n    on-cancel=\"onDoNotDelete()\"\n    class=\"refreshModal\">\n\n    <div class=\"refreshModalContent\">\n        <div class=\"summaryText\">{{message}}</div>\n        <div ng-repeat=\"item in scoringFormulas\">\n            <span ng-if=\"item.value !=='' || item.score !==''\">\n                {{item.value}}\n            </span>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2605:
/***/ (function(module, exports) {

/*@ngInject*/
var RefreshModalController = function RefreshModalController($rootScope, $scope, options, coreConstant) {
  $scope.title = options.title;
  $scope.message = options.message;
  $scope.deleteAll = options.deleteAll;
  $scope.doNotDelete = options.doNotDelete;
  $scope.scoringFormulas = options.scoringFormulas;
  $scope.onDoNotDelete = function () {
    $scope.$close(options.scoringFormulas);
  };
  $scope.onDeleteAll = function () {
    $scope.$close(null);
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
RefreshModalController.$inject = ["$rootScope", "$scope", "options", "coreConstant"];
angular.module('ums.configuration').controller('refreshModalController', RefreshModalController);

/***/ }),

/***/ 2606:
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2607:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2608);
__webpack_require__(2609);
__webpack_require__(2610);
__webpack_require__(2611);
__webpack_require__(2612);
var ScoringRulesEditorHeaderComponent = {
  templateUrl: '/configuration/scoringRules/header/scoringRulesEditorHeader.tpl.html',
  controller: 'scoringRulesEditorHeaderController',
  bindings: {}
};
angular.module('ums').component('uiScoringRulesEditorHeaderComponent', ScoringRulesEditorHeaderComponent);

/***/ }),

/***/ 2608:
/***/ (function(module, exports) {

var path = '/configuration/scoringRules/header/scoringRulesEditorHeader.tpl.html';
var html = "<div class=\"headerRow\">\n\n    <div class=\"nameColumn\">\n\n        <button type=\"button\"\n                class=\"btn-link backButton\"\n                ui-sref=\"configuration.scoringRulesBrowser\">\n\n            <span class=\"glyphicon glyphicon-arrow-left\"></span>\n\n            <span ui-translate>scoringRulesEditorHeader.title</span>\n        </button>\n\n        <div class=\"scoringRuleName\"\n             uib-tooltip=\"{{ $ctrl.scoringRule.name }}\"\n             tooltip-placement=\"top-left\"\n             tooltip-append-to-body=\"true\">\n\n            <span>{{ $ctrl.scoringRule.name }}</span>\n        </div>\n    </div>\n\n    <div class=\"actionButtonColumn\">\n\n        <action-buttons-bar context=\"$ctrl.context\"\n                            actions=\"$ctrl.actions\"\n                            action-sub-texts=\"$ctrl.actionSubTexts\"\n                            notify-action-clicked=\"$ctrl.handleAction(action, file)\"\n                            time-last-modified=\"$ctrl.actionsTimeLastModified\"></action-buttons-bar>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2609:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ScoringRulesEditorHeaderController = function ScoringRulesEditorHeaderController($rootScope, $scope, $element, $stateParams, $state, loadingBarHandler, coreConstant, localization, scoringRulesEditorModel, configurationMediator, scoringRuleActions, scoringRuleActionsUtil, modalUtil, configurationActionsUtil, configurationConstant) {
  var _this4 = this;
  $element.addClass('scoringRulesEditorHeader');
  this.scoringRule = null;
  this.translations = null;
  this.actions = [];
  this.context = {
    identifier: 'scoringRulesEditorHeader',
    actions: {},
    fallthrough: null,
    model: {
      contextType: coreConstant.CONTEXT_NONE
    }
  };
  this.context.actions[coreConstant.CONTEXT_NONE] = '';
  this.actionSubTexts = {};
  this.$onInit = function () {
    var _this = this;
    localization.getTranslationByKey('scoringRulesEditorHeader').then(function (translations) {
      _this.scoringRule = scoringRulesEditorModel.getScoringRule(_.isEmpty($stateParams.scoringRuleId) ? -1 : $stateParams.scoringRuleId);
      _this.translations = translations;
      _this.loadActions();
    });
  };
  this.loadActions = function () {
    var _this2 = this;
    configurationMediator.loadScoringRulesActions($stateParams.scoringRuleId).then(function (actions) {
      var allActions = [];
      allActions.push({
        actions: actions.actions,
        contextType: _this2.context.model.contextType
      });
      _this2.processActions(allActions);
    });
  };
  this.processActions = function (actions) {
    var _this3 = this;
    this.actions = actions;
    this.actionSubTexts = {};
    _.each(this.actions, function (subAction) {
      _.each(subAction.actions, function (action) {
        if (action.name === scoringRuleActions.SAVE) {
          action.enabled = false;
          if (scoringRulesEditorModel.hasUnsavedChanges(_this3.scoringRule.id)) {
            _this3.actionSubTexts[action.name] = {
              class: 'unsavedChanges',
              text: _.get(_this3.translations, 'unsavedChanges')
            };
            if (scoringRulesEditorModel.isValid(parseInt(_this3.scoringRule.id))) {
              action.enabled = true;
            }
          }
        }
        if (action.name === scoringRuleActions.CREATE) {
          action.enabled = false;
          if (scoringRulesEditorModel.hasUnsavedChanges(_this3.scoringRule.id)) {
            _this3.actionSubTexts[action.name] = {
              class: 'unsavedChanges',
              text: _.get(_this3.translations, 'unsavedChanges')
            };
            if (scoringRulesEditorModel.isValid(parseInt(_this3.scoringRule.id))) {
              action.enabled = true;
            }
          }
        }
        if (action.name === scoringRuleActions.DISCARD) {
          action.enabled = scoringRulesEditorModel.hasUnsavedChanges(_this3.scoringRule.id) || _this3.scoringRule.id === '-1';
        }
        if (action.name === scoringRuleActions.COPY) {
          action.enabled = !scoringRulesEditorModel.hasUnsavedChanges(_this3.scoringRule.id) && _this3.scoringRule.id !== '-1';
          if (action.enabled === false) {
            action.notes = 'Copy is not available since there are unsaved changes';
          }
        }
      });
    });
    this.actionsTimeLastModified = new Date().getTime();
  };
  this.handleAction = function (action) {
    if (action.enabled) {
      switch (action.name) {
        case scoringRuleActions.SAVE:
          scoringRuleActionsUtil.save(this.translations, this.scoringRule);
          break;
        case scoringRuleActions.CREATE:
          scoringRuleActionsUtil.save(this.translations, this.scoringRule);
          break;
        case scoringRuleActions.DISCARD:
          scoringRuleActionsUtil.discard(this.translations);
          break;
        case scoringRuleActions.DELETE:
          scoringRuleActionsUtil.delete(this.translations, this.scoringRule.id);
          break;
        case scoringRuleActions.COPY:
          var name = _.get(this.translations, 'copyOf') + this.scoringRule.name,
            copiedScoringRule = _.clone(this.scoringRule);
          copiedScoringRule.name = name;
          scoringRuleActionsUtil.copy(this.translations, copiedScoringRule);
          break;
        default:
          modalUtil.showActionNotImplementedModal(action.name);
          break;
      }
    }
  };
  $scope.$on(configurationConstant.event.SCORING_RULE_UPDATED, function (event, scoringRuleId) {
    _this4.scoringRule = scoringRulesEditorModel.getScoringRule(scoringRuleId);
    _this4.processActions(_this4.actions);
  });
  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    var isCurrentStateScoringRuleEditor = _.startsWith(fromState.name, 'configuration.manageScoringRules'),
      isTargetSameAsCurrent = toState.name === fromState.name,
      scoringRuleId = _this4.scoringRule.id,
      hasUnsavedChanges = scoringRulesEditorModel.hasUnsavedChanges(scoringRuleId),
      isValid = scoringRulesEditorModel.isValid(scoringRuleId);
    if (toState.name === 'login') {
      return;
    }
    if (hasUnsavedChanges && isCurrentStateScoringRuleEditor && !isTargetSameAsCurrent) {
      event.preventDefault();
      if (isValid) {
        loadingBarHandler.showNotificationLoadingBar(_.get(_this4.translations, 'saveScoringRule.loadingBar'));
        if (_this4.scoringRule.id === -1) {
          _this4.scoringRule.id = null;
        }
        configurationMediator.saveScoringRule(_this4.scoringRule).then(function () {
          scoringRulesEditorModel.setUnsavedChanges(scoringRuleId, false);
          loadingBarHandler.concludeNotificationLoadingBar(_.get(_this4.translations, 'saveScoringRule.savingScoringRuleSuccessLoadingBar'));
          $state.go(toState, toParams);
        });
      } else {
        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(_this4.translations, 'invalidScoringRules'));
      }
    }
  });
  this.openGenericConfirm = function (title, summary, confirmActionButtonLabel) {
    modalUtil.showGenericConfirm({
      title: title,
      summary: summary,
      confirmActionButtonLabel: confirmActionButtonLabel
    });
  };
};
ScoringRulesEditorHeaderController.$inject = ["$rootScope", "$scope", "$element", "$stateParams", "$state", "loadingBarHandler", "coreConstant", "localization", "scoringRulesEditorModel", "configurationMediator", "scoringRuleActions", "scoringRuleActionsUtil", "modalUtil", "configurationActionsUtil", "configurationConstant"];
angular.module('ums.configuration').controller('scoringRulesEditorHeaderController', ScoringRulesEditorHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2610:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ScoringRulesEditorModel = function ScoringRulesEditorModel($rootScope, configurationMediator, configurationConstant) {
  var scoringRulesEditorModel = {};
  this.reset = function (scoringRuleId) {
    if (!_.isNil(scoringRuleId)) {
      scoringRulesEditorModel[scoringRuleId] = {
        scoringRule: null,
        isValid: false,
        hasUnsavedChanges: false
      };
    } else {
      scoringRulesEditorModel = {};
    }
  };
  this.buildScoringRule = function (scoringRuleId) {
    this.reset(scoringRuleId);
    if (_.isEmpty(scoringRuleId) || parseInt(scoringRuleId) === -1) {
      this.updateScoringRule({
        id: -1,
        name: null
      });
    } else {
      configurationMediator.getScoringRuleById(scoringRuleId).then(function (scoringRule) {
        this.updateScoringRule(scoringRule);
      }.bind(this));
    }
  };
  this.getScoringRule = function (scoringRuleId) {
    var model = scoringRulesEditorModel[scoringRuleId];
    return _.isNil(model) ? null : model.scoringRule;
  };
  this.setValid = function (scoringRuleId, valid) {
    var model = scoringRulesEditorModel[scoringRuleId];
    model.isValid = valid;
    $rootScope.$broadcast(configurationConstant.event.SCORING_RULE_UPDATED, scoringRuleId);
  };
  this.isValid = function (scoringRuleId) {
    var model = scoringRulesEditorModel[scoringRuleId];
    return _.isNil(model) || _.isNil(model.isValid) || model.isValid;
  };
  this.setUnsavedChanges = function (scoringRuleId, hasUnsavedChanges) {
    var model = scoringRulesEditorModel[scoringRuleId];
    if (!_.isNil(model)) {
      model.hasUnsavedChanges = hasUnsavedChanges;
    }
    $rootScope.$broadcast(configurationConstant.event.SCORING_RULE_UPDATED, scoringRuleId);
  };
  this.hasUnsavedChanges = function (scoringRuleId) {
    var model = scoringRulesEditorModel[scoringRuleId];
    if (model) {
      return model.hasUnsavedChanges;
    } else {
      return false;
    }
  };
  this.updateScoringRule = function (scoringRule) {
    scoringRulesEditorModel[scoringRule.id] = {
      scoringRule: _.cloneDeep(scoringRule),
      isValid: false,
      hasUnsavedChanges: false
    };
    $rootScope.$broadcast(configurationConstant.event.SCORING_RULE_UPDATED, scoringRule.id);
  };
};
ScoringRulesEditorModel.$inject = ["$rootScope", "configurationMediator", "configurationConstant"];
angular.module('ums.configuration').service('scoringRulesEditorModel', ScoringRulesEditorModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2611:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var ScoringRuleActionsUtil = function ScoringRuleActionsUtil($rootScope, $stateParams, $state, $q, loadingBarHandler, configurationMediator, scoringRulesEditorModel, modalUtil, coreConstant) {
  this.save = function (translations, scoringRule) {
    loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'saveScoringRule.loadingBar'));
    if (scoringRule.id === -1) {
      scoringRule.id = null;
    }
    return configurationMediator.saveScoringRule(scoringRule).then(function (savedScoringRule) {
      loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'saveScoringRule.savingScoringRuleSuccessLoadingBar'));
      $state.go('configuration.manageScoringRules', {
        scoringRuleId: savedScoringRule.id
      }, {
        reload: true
      });
      return savedScoringRule;
    });
  };
  this.discard = function (translations) {
    modalUtil.showConfirmationModal(null, null, null, 'scoringRulesEditorHeader.discardConfirmation', null, true, function () {
      $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'discardConfirmation.success'));
      scoringRulesEditorModel.setUnsavedChanges($stateParams.scoringRuleId, false);
      if ($stateParams.scoringRuleId && $stateParams.scoringRuleId !== '-1') {
        $state.reload();
      } else {
        $state.go('configuration.scoringRulesBrowser', {});
      }
    });
  };
  this.delete = function (translations, scoringRuleId) {
    modalUtil.showConfirmationModal(null, null, null, 'scoringRulesEditorHeader.deleteConfirmation', null, true, function () {
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'deleteConfirmation.loadingBar'));
      return configurationMediator.deleteScoringRule(scoringRuleId).then(function () {
        scoringRulesEditorModel.setUnsavedChanges(scoringRuleId, false);
        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'deleteConfirmation.success'));
        $state.go('configuration.scoringRulesBrowser', {});
      });
    });
  };
  this.copy = function (translations, scoringRule) {
    modalUtil.showConfirmationModal(null, null, null, 'scoringRulesEditorHeader.copyScoringRuleConfirmation', null, true, function () {
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'copyScoringRuleConfirmation.loadingBar'));
      scoringRule.id = null;
      return configurationMediator.saveScoringRule(scoringRule).then(function (copiedScoringRule) {
        scoringRulesEditorModel.setUnsavedChanges($stateParams.scoringRuleId, false);
        $state.go('configuration.manageScoringRules', {
          scoringRuleId: copiedScoringRule.id
        });
        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'copyScoringRuleConfirmation.success'));
      });
    });
  };
};
ScoringRuleActionsUtil.$inject = ["$rootScope", "$stateParams", "$state", "$q", "loadingBarHandler", "configurationMediator", "scoringRulesEditorModel", "modalUtil", "coreConstant"];
angular.module('ums.configuration').service('scoringRuleActionsUtil', ScoringRuleActionsUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2612:
/***/ (function(module) {

module.exports = JSON.parse("{\"scoringRulesEditorHeader\":{\"title\":\"Manage Scoring Rules\",\"unsavedChanges\":\"Unsaved changes\",\"invalidScoringRules\":\"The scoring rule is invalid. Please correct or discard your changes before leaving this page.\",\"actions\":{\"name\":\"Actions\",\"save\":\"Save\",\"discard\":\"Discard\",\"delete\":\"Delete\",\"copy\":\"Copy\",\"create\":\"Save\"},\"deleteConfirmation\":{\"title\":\"Delete Scoring Rule\",\"summary\":\"Are you sure you want to delete this scoring rule?\",\"success\":\"Successfully deleted scoring rule\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"loadingBar\":\"Deleting scoring rule\"},\"discardConfirmation\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"success\":\"Your changes have been discarded.\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"copyScoringRuleConfirmation\":{\"title\":\"Copy Scoring Rule\",\"summary\":\"Are you sure you want to copy this scoring rule?\",\"success\":\"Successfully copied scoring rule\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"saveScoringRule\":{\"loadingBar\":\"Saving scoring rule\",\"savingScoringRuleSuccessLoadingBar\":\"Successfully saved scoring rule\"},\"copyOf\":\"Copy of \"}}");

/***/ }),

/***/ 2613:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2614);
__webpack_require__(2615);
__webpack_require__(2616);
var locale = __webpack_require__(2619);

/*@ngInject*/
var RateStatusController = function RateStatusController($rootScope, $scope, $state, coreConstant, configurationMediator, localization, stateRateAction, configurationActionsUtil, databaseDownloadSectionName, coreMediator, configurationConstant, modalUtil, currentUserModel, authorizationConstants, navigationStateModel, loadingBarHandler) {
  $scope.i18n = locale;
  $scope.actions = [];
  $scope.context = {
    identifier: 'stateRate',
    actions: {},
    fallthrough: null,
    model: {
      contextType: coreConstant.CONTEXT_NONE
    }
  };
  $scope.viewModel = {
    stateRates: [],
    locations: [],
    products: [],
    statuses: [],
    requestParams: {
      key: 'state',
      startIndex: 0,
      pageSize: 25,
      sortType: 'asc'
    },
    isEmptyRow: false,
    hasUnsavedChanges: false,
    isValidToSave: true,
    isReadOnly: !currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_STATE_RATES)
  };
  $scope.context.actions[coreConstant.CONTEXT_NONE] = '';
  $scope.$on(configurationConstant.event.STATE_RATE_DELETED, function (event, stateRateID) {
    if ($scope.viewModel.stateRates.length === 1) {
      $scope.viewModel.isEmptyRow = true;
      createEmptyStateRate();
    } else {
      $scope.viewModel.stateRates = _.remove($scope.viewModel.stateRates, function (item) {
        return item.id !== stateRateID;
      });
    }
    $scope.validateAction();
  });
  $scope.$on(configurationConstant.event.STATE_RATE_COPY, function (event, stateRate) {
    var newStateRate = {
        country: stateRate.country,
        effectiveDateRangeBegin: null,
        effectiveDateRangeEnd: null,
        id: _.random(-100, -99999),
        objectUri: null,
        productTemplateShortName: stateRate.productTemplateShortName,
        rateApproved: null,
        state: stateRate.state,
        status: null,
        uri: null
      },
      count = 0,
      matchIndex = 0;
    _.each($scope.viewModel.stateRates, function (item) {
      if (item.id === stateRate.id) {
        matchIndex = count + 1;
        return;
      }
      count++;
    });
    $scope.viewModel.isEmptyRow = false;
    $scope.viewModel.stateRates.splice(matchIndex, 0, newStateRate);
    processActions($scope.actions);
  });
  $scope.validateAction = function () {
    var isDirtyData = false;
    _.each($scope.viewModel.stateRates, function (stateRate) {
      if (!isDirtyData) {
        if (_.isNil(stateRate.effectiveDateRangeBegin) || _.isNil(stateRate.effectiveDateRangeEnd) || _.isNil(stateRate.productTemplateShortName) || _.isNil(stateRate.status) || _.isNil(stateRate.state)) {
          $scope.viewModel.isValidToSave = false;
          $scope.viewModel.hasUnsavedChanges = true;
          isDirtyData = true;
        } else {
          $scope.viewModel.isValidToSave = true;
          $scope.viewModel.hasUnsavedChanges = true;
        }
      }
    });
    processActions($scope.actions);
  };
  $scope.onSortChange = function (event, params) {
    $scope.viewModel.requestParams.key = params.key;
    $scope.viewModel.requestParams.sortType = params.sortType;
    sortStateRates($scope.viewModel.stateRates);
  };
  function createEmptyStateRate() {
    $scope.viewModel.stateRates = [{
      country: null,
      effectiveDateRangeBegin: null,
      effectiveDateRangeEnd: null,
      id: _.random(-100, -99999),
      objectUri: null,
      productTemplateShortName: null,
      rateApproved: null,
      state: null,
      status: null,
      uri: null
    }];
  }
  ;
  function loadActions() {
    configurationMediator.loadStateRateActions().then(function (actions) {
      var allActions = [];
      allActions.push({
        actions: actions.actions,
        contextType: $scope.context.model.contextType
      });
      $scope.actions = allActions;
      $scope.actionsTimeLastModified = new Date().getTime();
      $scope.validateAction();
    });
  }
  ;
  function processActions(actions) {
    $scope.actions = actions;
    $scope.actionSubTexts = {};
    _.each($scope.actions, function (subAction) {
      _.each(subAction.actions, function (action) {
        if (action.name === stateRateAction.SAVE || action.name === stateRateAction.DISCARD) {
          action.enabled = false;
          if ($scope.viewModel.hasUnsavedChanges) {
            if ($scope.viewModel.isValidToSave || action.name === stateRateAction.DISCARD) {
              action.enabled = true;
            }
            if (action.name === stateRateAction.SAVE) {
              $scope.actionSubTexts[action.name] = {
                class: 'unsavedChanges',
                text: $scope.i18n.stateRate.unsavedChanges
              };
            }
          }
        }
      });
    });
    $scope.actionsTimeLastModified = new Date().getTime();
  }
  ;
  function sortStateRates(rates) {
    var stateRates = [];
    stateRates = _.orderBy(rates, [$scope.viewModel.requestParams.key], [$scope.viewModel.requestParams.sortType]);
    $scope.viewModel.stateRates = [];
    _.each(stateRates, function (user) {
      $scope.viewModel.stateRates.push(user);
    });
  }
  ;
  function resetNavigationState() {
    navigationStateModel.saveViewState('configuration.rateStatus', null);
  }
  function loadStateRates() {
    configurationMediator.loadStateRates().then(function (result) {
      $scope.viewModel.savedStateRates = _.clone(result);
      sortStateRates(result);
      if ($scope.viewModel.stateRates.length === 0) {
        $scope.viewModel.isEmptyRow = true;
        createEmptyStateRate();
      }
      coreMediator.getRemoteDataSetByName('Rate Status Locations').then(function (dataSet) {
        $scope.viewModel.locations = dataSet.items;
      });
      coreMediator.getDynamicDataSet({
        name: 'Products - Use Rate Status Enabled'
      }).then(function (dataSet) {
        $scope.viewModel.products = dataSet.items;
      });
      coreMediator.getRemoteDataSetByName('State Rate Statuses').then(function (dataSet) {
        $scope.viewModel.statuses = dataSet.items;
      });
    });
  }
  ;
  $scope.handleAction = function (action, file) {
    if (action.enabled) {
      switch (action.name) {
        case stateRateAction.SAVE:
          var stateRates = [];
          _.each($scope.viewModel.stateRates, function (item) {
            stateRates.push(item);
          });
          loadingBarHandler.showNotificationLoadingBar($scope.i18n.stateRate.saveStateRates.loadingBar);
          configurationMediator.saveStateRates(stateRates).then(function (result) {
            loadingBarHandler.concludeNotificationLoadingBar($scope.i18n.stateRate.saveStateRates.savingStateRatesLoadingBar);
            sortStateRates(result);
            $scope.viewModel.hasUnsavedChanges = false;
            $scope.viewModel.isValidToSave = false;
            processActions($scope.actions);
          });
          break;
        case stateRateAction.DISCARD:
          modalUtil.showConfirmationModal(null, null, null, 'stateRate.discardConfirmation', null, true, function () {
            $state.reload();
          });
          break;
        case stateRateAction.BACKUP:
          configurationActionsUtil.backup(databaseDownloadSectionName.STATE_RATES, $scope.i18n.stateRate.backup.name, $scope.i18n.stateRate.backup.loadingBar, $scope.i18n.stateRate.backup.successMessage);
          break;
        default:
          modalUtil.showActionNotImplementedModal(action.name);
          break;
      }
    }
  };
  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    var isCurrentStateRateStatusManager = _.startsWith(fromState.name, 'configuration.rateStatus'),
      isTargetSameAsCurrent = toState.name === fromState.name;
    if (toState.name === 'login') {
      return;
    }
    if ($scope.viewModel.hasUnsavedChanges && isCurrentStateRateStatusManager && !isTargetSameAsCurrent) {
      event.preventDefault();
      if ($scope.viewModel.isValidToSave) {
        var stateRates = [];
        _.each($scope.viewModel.stateRates, function (item) {
          if (item.id < 0) {
            item.id = null;
          }
          stateRates.push(item);
        });
        loadingBarHandler.showNotificationLoadingBar($scope.i18n.stateRate.saveStateRates.loadingBar);
        configurationMediator.saveStateRates(stateRates).then(function (result) {
          loadingBarHandler.concludeNotificationLoadingBar($scope.i18n.stateRate.saveStateRates.savingStateRatesLoadingBar);
          $scope.viewModel.isValidToSave = false;
          $scope.viewModel.hasUnsavedChanges = false;
          $state.go(toState, toParams);
        });
      }
    } else {
      // there are no changes to be saved, do nothing
    }
  }.bind(this));
  loadActions();
  loadStateRates();
  resetNavigationState();
};
RateStatusController.$inject = ["$rootScope", "$scope", "$state", "coreConstant", "configurationMediator", "localization", "stateRateAction", "configurationActionsUtil", "databaseDownloadSectionName", "coreMediator", "configurationConstant", "modalUtil", "currentUserModel", "authorizationConstants", "navigationStateModel", "loadingBarHandler"];
angular.module('ums.configuration').controller('rateStatusController', RateStatusController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2614:
/***/ (function(module, exports) {

var path = '/configuration/rateStatus/rateStatus.tpl.html';
var html = "<div class=\"rateStatusManager\">\n\n    <!-- Header -->\n    <div class=\"header\">\n        <div class=\"headerContent\">\n            <div class=\"headerLabel\" ui-translate>stateRate.title</div>\n\n            <action-buttons-bar context=\"context\"\n                                actions=\"actions\"\n                                action-sub-texts=\"actionSubTexts\"\n                                notify-action-clicked=\"handleAction(action, file)\"\n                                time-last-modified=\"actionsTimeLastModified\"></action-buttons-bar>\n        </div>\n    </div>\n\n    <!-- Grid -->\n    <div class=\"grid\">\n\n        <!-- Grid Header -->\n        <div class=\"columnHeader\">\n\n            <div class=\"colHover\"></div>\n\n            <div class=\"colLocation\"\n                 ui-grid-sortable-header\n                 request-params=\"viewModel.requestParams\"\n                 item-name=\"state\"\n                 item-label=\"stateRate.columns.location\"\n                 on-toggle=\"onSortChange($event, params)\"></div>\n\n            <div class=\"colProduct\"\n                 ui-grid-sortable-header\n                 request-params=\"viewModel.requestParams\"\n                 item-name=\"productTemplateShortName\"\n                 item-label=\"stateRate.columns.product\"\n                 on-toggle=\"onSortChange($event, params)\"></div>\n\n            <div class=\"colStatus\"\n                 ui-grid-sortable-header\n                 request-params=\"viewModel.requestParams\"\n                 item-name=\"status\"\n                 item-label=\"stateRate.columns.status\"\n                 on-toggle=\"onSortChange($event, params)\"></div>\n\n            <div class=\"colEffectiveDate \"\n                 ui-grid-sortable-header\n                 request-params=\"viewModel.requestParams\"\n                 item-name=\"effectiveDateRangeBegin\"\n                 item-label=\"stateRate.columns.effectiveDate\"\n                 on-toggle=\"onSortChange($event, params)\"></div>\n\n            <div class=\"colExpirationDate\"\n                 ui-grid-sortable-header\n                 request-params=\"viewModel.requestParams\"\n                 item-name=\"effectiveDateRangeEnd\"\n                 item-label=\"stateRate.columns.expirationDate\"\n                 on-toggle=\"onSortChange($event, params)\"></div>\n        </div>\n\n        <div class=\"gridRow\">\n            <ui-rate-status-row\n                ng-repeat=\"state in viewModel.stateRates\"\n                class=\"rateStatusRow\"\n                item=\"state\"\n                locations=\"viewModel.locations\"\n                statuses=\"viewModel.statuses\"\n                products=\"viewModel.products\"\n                is-empty-row=\"viewModel.isEmptyRow\"\n                validate-action=\"validateAction()\"\n                has-unsaved-changes=\"viewModel.hasUnsavedChanges\"\n                is-read-only=\"viewModel.isReadOnly\">\n            </ui-rate-status-row>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2615:
/***/ (function(module, exports) {

/*@ngInject*/
var RateStatusRepository = function RateStatusRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadActions = function () {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.underwriting.staterate.StateRate:null'
        }
      };
    return this.get(url, config);
  };
  this.saveStateRates = function (stateRates) {
    var url = '/rest/StateRate/update',
      body = stateRates,
      config = {
        params: {}
      };
    return this.post(url, body, config);
  };
  this.loadStateRates = function (params) {
    var url = '/rest/StateRate/List',
      config = {
        params: {}
      };
    return this.get(url, config);
  };
};
RateStatusRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('rateStatusRepository', RateStatusRepository);

/***/ }),

/***/ 2616:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(783);
__webpack_require__(2617);
__webpack_require__(2618);
__webpack_require__(784);
var RateStatusRowComponent = {
  templateUrl: '/configuration/rateStatus/rateStatusRow/rateStatusRow.tpl.html',
  controller: 'rateStatusRowController',
  bindings: {
    item: '<',
    locations: '<',
    products: '<',
    statuses: '<',
    isEmptyRow: '<?',
    isReadOnly: '<?',
    hasUnsavedChanges: '<?',
    validateAction: '&?'
  }
};
angular.module('ums.configuration').component('uiRateStatusRow', RateStatusRowComponent);

/***/ }),

/***/ 2617:
/***/ (function(module, exports) {

var path = '/configuration/rateStatus/rateStatusRow/rateStatusRow.tpl.html';
var html = "<div class=\"rowComponentContainer\"\n     ng-class=\"{singleRow: $ctrl.isEmptyRow &&  !$ctrl.rowSelected,\n                readOnly: $ctrl.isReadOnly}\"\n     um-rate-status-row-dom-manager\n     ui-click-outside=\"$ctrl.handleClose()\">\n\n    <div class=\"rowComponentInner\"\n         ng-class=\"{incomplete: $ctrl.isError, readOnly: $ctrl.isReadOnly}\">\n\n        <div ng-if=\"$ctrl.isEmptyRow && !$ctrl.rowSelected\"\n            class=\"newLabel\">\n            <span>{{::$ctrl.i18n.newLabel}}</span>\n        </div>\n\n        <div class=\"row\"\n             ng-class=\"{rowSelected: $ctrl.rowSelected}\">\n            <div class=\"location\">\n                <um-dropdown class-name=\"location\"\n                             ng-if=\"$ctrl.rowSelected && $ctrl.locations.length > 0 && !$ctrl.isReadOnly\"\n                             option-list=\"$ctrl.locations\"\n                             selected-value=\"$ctrl.locationSelectedValue.value\"\n                             on-change=\"$ctrl.onLocationValueChange(selectedOption)\">\n                </um-dropdown>\n\n                <div ng-if=\"!$ctrl.rowSelected\"\n                     class=\"locationLabelBox {{$ctrl.locationClassName}}\"\n                     ng-class=\"{unselected: !$ctrl.rowSelected}\">\n                    <span class=\"locationLabel\">{{$ctrl.locationSelectedValue.name}}</span>\n                </div>\n            </div>\n\n            <div class=\"product\">\n                <um-dropdown class-name=\"product\"\n                             ng-if=\"$ctrl.rowSelected && $ctrl.products.length > 0 && !$ctrl.isReadOnly\"\n                             option-list=\"$ctrl.products\"\n                             selected-value=\"$ctrl.productDropdownSelectedValue.value\"\n                             on-change=\"$ctrl.onProductValueChange(selectedOption)\">\n                </um-dropdown>\n                <div ng-if=\"!$ctrl.rowSelected\"\n                     class=\"productLabelBox {{$ctrl.productClassName}}\"\n                     ng-class=\"{unselected: !$ctrl.rowSelected}\">\n                    <span class=\"productLabel\">{{$ctrl.productDropdownSelectedValue.name}}</span>\n                </div>\n            </div>\n\n            <div class=\"status\">\n                <um-dropdown class-name=\"status\"\n                             ng-if=\"$ctrl.rowSelected && $ctrl.statuses.length > 0 && !$ctrl.isReadOnly\"\n                             option-list=\"$ctrl.statuses\"\n                             selected-value=\"$ctrl.statusSelectedValue.value\"\n                             on-change=\"$ctrl.onStatusValueChange(selectedOption)\"\n                             >\n                </um-dropdown>\n                <div ng-if=\"!$ctrl.rowSelected\"\n                     class=\"statusLabelBox {{$ctrl.statusClassName}}\"\n                     ng-class=\"{unselected: !$ctrl.rowSelected}\">\n                    <span class=\"statusLabel\">{{$ctrl.statusSelectedValue.name}}</span>\n                </div>\n            </div>\n\n            <div class=\"dateEffectiveBox\">\n                <div class=\"effectiveDate\"\n                     ng-if=\"$ctrl.rowSelected && !$ctrl.isReadOnly\"\n                     ui-popup-position>\n\n                    <div class=\"dateInputContainer\">\n                        <input type=\"text\"\n                               class=\"dateRange\"\n                               ng-model=\"$ctrl.effectiveDate\"\n                               ng-blur=\"$ctrl.onEffectiveDateChange()\"\n                               ng-focus=\"$ctrl.onEffectiveDateClick()\"\n                               ng-click=\"$ctrl.onEffectiveDateClick()\"\n                               placeholder=\"{{::$ctrl.startDatePlaceHolder}}\"/>\n                    </div>\n\n                    <button class=\"toggleCalendarPopup glyphicon glyphicon-calendar\"\n                            uib-popover-template=\"'/formViewer/component/calendar/calendarPopover.tpl.html'\"\n                            popover-trigger=\"none\"\n                            popover-append-to-body=\"true\"\n                            popover-placement=\"auto top\"\n                            popover-is-open=\"$ctrl.startEffectivePopupOpen\"\n                            popover-class=\"calendarPopover\"\n                            ng-click=\"$ctrl.handleEffectiveClick()\"\n                            aria-hidden=\"true\"></button>\n                </div>\n\n                <div ng-if=\"!$ctrl.rowSelected\"\n                     class=\"dateEffectiveLabelBox\"\n                     ng-class=\"{unselected: !$ctrl.rowSelected}\">\n                    <span class=\"dateEffectiveLabel\">{{$ctrl.effectiveDate}}</span>\n                </div>\n            </div>\n\n\n            <div class=\"dateExpirationBox\">\n                <div class=\"expirationDate\"\n                     ng-if=\"$ctrl.rowSelected && !$ctrl.isReadOnly\"\n                     ui-popup-position>\n\n                    <div class=\"dateInputContainer\">\n                        <input type=\"text\"\n                               class=\"dateRange\"\n                               ng-model=\"$ctrl.expirationDate\"\n                               ng-blur=\"$ctrl.onExpirationDateChange()\"\n                               ng-focus=\"$ctrl.onExpirationDateClick()\"\n                               ng-click=\"$ctrl.onExpirationDateClick()\"\n                               placeholder=\"{{::$ctrl.startDatePlaceHolder}}\"/>\n                    </div>\n\n                    <button class=\"toggleCalendarPopup glyphicon glyphicon-calendar\"\n                            uib-popover-template=\"'/formViewer/component/calendar/calendarPopover.tpl.html'\"\n                            popover-trigger=\"none\"\n                            popover-append-to-body=\"true\"\n                            popover-placement=\"auto top\"\n                            popover-is-open=\"$ctrl.startExpirationPopupOpen\"\n                            popover-class=\"calendarPopover\"\n                            ng-click=\"$ctrl.handleExpirationClick()\"\n                            aria-hidden=\"true\"></button>\n                </div>\n\n                <div ng-if=\"!$ctrl.rowSelected\"\n                     class=\"dateExpirationLabelBox\"\n                     ng-class=\"{unselected: !$ctrl.rowSelected}\">\n                    <span class=\"dateExpirationLabel\">{{$ctrl.expirationDate}}</span>\n                </div>\n            </div>\n\n\n\n            <div class=\"deleteContainer\"\n                    ng-if=\"!$ctrl.isReadOnly\">\n                <button class=\"glyphicon glyphicon-trash deleteButton\"\n                        ng-disabled=\"!$ctrl.isRowDirty && $ctrl.isEmptyRow\"\n                        ng-click=\"$ctrl.onDelete()\">\n                </button>\n            </div>\n\n            <div class=\"copyContainer\"\n                    ng-if=\"!$ctrl.isReadOnly\">\n                <button class=\"glyphicon glyphicon glyphicon-book cloneButton\"\n                        ng-click=\"$ctrl.onCopy()\">\n                </button>\n            </div>\n\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2618:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $, moment) {var locale = __webpack_require__(783);
/*@ngInject*/
var RateStatusRowController = function RateStatusRowController($rootScope, $scope, $element, $timeout, dateUtil, localization, formComponentUtil, configurationConstant) {
  this.$onInit = function () {
    this.i18n = locale;
    this.effectiveDate = _.isNil(this.item.effectiveDateRangeBegin) ? '' : this.formatUTCDateString(this.item.effectiveDateRangeBegin);
    this.expirationDate = _.isNil(this.item.effectiveDateRangeEnd) ? '' : this.formatUTCDateString(this.item.effectiveDateRangeEnd);
    this.productDropdownSelectedValue = {
      name: this.item.productTemplateShortName,
      value: this.item.productTemplateShortName
    };
    this.productClassName = _.camelCase(this.item.productTemplateShortName);
    this.startEffectivePopupOpen = false;
    this.startExpirationPopupOpen = false;
    this.isError = false;
    this.isEmptyRow = true;
    this.rowSelected = false;
    this.checkValidation();
  };
  this.$onChanges = function () {
    var _this = this;
    this.statusSelectedValue = {
      name: this.item.status,
      value: this.item.status
    };
    _.each(this.statuses, function (status) {
      if (parseInt(status.value) === _this.item.status) {
        _this.statusSelectedValue = {
          name: status.name,
          value: status.value
        };
        _this.statusClassName = _.camelCase(status.name);
      }
    });
    if (!_.isNil(this.locations)) {
      this.locationSelectedValue = {
        name: this.item.state,
        value: this.item.state
      };
      _.each(this.locations, function (location) {
        if (location.value === _this.item.state) {
          _this.locationSelectedValue = {
            name: location.name,
            value: location.value
          };
          _this.locationClassName = _.camelCase(location.name);
        }
      });
    }
  };
  this.getLocationSelectedValue = function () {
    _.each($scope.viewModel.locations, function (location) {
      if (location.id === stateRate.id) {
        matchIndex = count + 1;
        return;
      }
      count++;
    });
  };
  this.checkValidation = function () {
    if (_.isNil(formComponentUtil.dateFromInput(this.effectiveDate, false)) && _.isNil(formComponentUtil.dateFromInput(this.expirationDate, false)) && _.isNil(this.item.productTemplateShortName) && _.isNil(this.item.status) && _.isNil(this.item.state)) {
      this.isError = false;
    } else if (!_.isNil(formComponentUtil.dateFromInput(this.effectiveDate, false)) && !_.isEmpty(this.effectiveDate) && !_.isNil(formComponentUtil.dateFromInput(this.expirationDate, false)) && !_.isEmpty(this.expirationDate) && !_.isNil(this.item.productTemplateShortName) && !_.isEmpty(this.item.productTemplateShortName) && !_.isNil(this.item.status) && this.item.status !== '' && !_.isNil(this.item.state) && !_.isEmpty(this.item.state)) {
      this.isError = false;
      this.isEmptyRow = false;
    } else {
      this.isError = true;
      this.isEmptyRow = false;
    }
    if (dateUtil.isAfter(this.effectiveDate, this.expirationDate)) {
      this.isError = true;
    }
  };
  this.onLocationValueChange = function (option) {
    this.item.state = option.value;
    this.locationSelectedValue = {
      name: option.name,
      value: option.value
    };
    this.locationClassName = _.camelCase(option.name);
    this.checkValidation();
    this.hasUnsavedChanges = true;
    this.validateAction();
  };
  this.onProductValueChange = function (option) {
    this.item.productTemplateShortName = option.value;
    this.productDropdownSelectedValue = {
      name: this.item.productTemplateShortName,
      value: this.item.productTemplateShortName
    };
    this.productClassName = _.camelCase(this.item.productTemplateShortName);
    this.checkValidation();
    this.hasUnsavedChanges = true;
    this.validateAction();
  };
  this.onStatusValueChange = function (option) {
    var _this2 = this;
    this.item.status = parseInt(option.value);
    _.each(this.statuses, function (status) {
      if (parseInt(status.value) === _this2.item.status) {
        _this2.statusSelectedValue = {
          name: status.name,
          value: status.value
        };
        _this2.statusClassName = _.camelCase(status.name);
      }
    });
    this.checkValidation();
    this.hasUnsavedChanges = true;
    this.validateAction();
  };
  this.handleChange = function (event) {
    var isDaySelected = event ? $(event.target).parents('.uib-day').length > 0 : false;
    if (isDaySelected) {
      if (this.startEffectivePopupOpen) {
        this.effectiveDate = dateUtil.formatDate(this.selectedDate, false);
      }
      if (this.startExpirationPopupOpen) {
        this.expirationDate = dateUtil.formatDate(this.selectedDate, false);
      }
      this.checkValidation();
      this.startEffectivePopupOpen = false;
      this.startExpirationPopupOpen = false;
      if (this.effectiveDate !== '') {
        this.item.effectiveDateRangeBegin = this.parseDateToMilliseconds(this.effectiveDate);
      }
      if (this.expirationDate !== '') {
        this.item.effectiveDateRangeEnd = this.parseDateToMilliseconds(this.expirationDate);
      }
      this.hasUnsavedChanges = true;
      this.validateAction();
    }
  };
  this.parseDateToMilliseconds = function (date) {
    var dateTimezoneOffset = '+0000',
      newDate = moment(date + dateTimezoneOffset, 'MM/DD/YYYYZZ');
    return newDate.valueOf();
  };
  this.formatUTCDateString = function (date) {
    var momentDate = moment.utc(new Date(date)),
      isValidDate = momentDate.isValid(),
      dateString = isValidDate ? momentDate.format('MM/DD/YYYY') : ' ';
    return dateString;
  };
  this.handleBlur = function () {
    this.checkValidation();
  };
  this.onEffectiveDateChange = function () {
    if (_.isEmpty(this.effectiveDate)) {
      this.item.effectiveDateRangeBegin = null;
    } else {
      this.item.effectiveDateRangeBegin = this.parseDateToMilliseconds(this.effectiveDate);
    }
    this.checkValidation();
    this.hasUnsavedChanges = true;
    this.validateAction();
  };
  this.onExpirationDateChange = function () {
    if (_.isEmpty(this.expirationDate)) {
      this.item.effectiveDateRangeEnd = null;
    } else {
      this.item.effectiveDateRangeEnd = this.parseDateToMilliseconds(this.expirationDate);
    }
    this.checkValidation();
    this.hasUnsavedChanges = true;
    this.validateAction();
  };
  this.handleEffectiveClick = function () {
    this.startEffectivePopupOpen = true;
    this.startExpirationPopupOpen = false;
    this.selectedDate = this.effectiveDate;
  };
  this.handleExpirationClick = function () {
    this.startEffectivePopupOpen = false;
    this.startExpirationPopupOpen = true;
    this.selectedDate = this.expirationDate;
  };
  this.onEffectiveDateClick = function () {
    this.startEffectivePopupOpen = false;
    this.startExpirationPopupOpen = false;
  };
  this.onExpirationDateClick = function () {
    this.startEffectivePopupOpen = false;
    this.startExpirationPopupOpen = false;
  };
  this.onDelete = function () {
    if (this.isEmptyRow) {
      this.locationSelectedValue = {};
      this.productDropdownSelectedValue = {};
      this.statusSelectedValue = {};
      this.expirationDate = null;
      this.effectiveDate = null;
      this.item.productTemplateShortName = null;
      this.item.status = null;
      this.item.state = null;
      this.checkValidation();
      this.isError = true;
      this.hasUnsavedChanges = true;
      this.validateAction();
    } else {
      $rootScope.$broadcast(configurationConstant.event.STATE_RATE_DELETED, this.item.id);
    }
  };
  this.onCopy = function () {
    this.isEmptyRow = false;
    $rootScope.$broadcast(configurationConstant.event.STATE_RATE_COPY, this.item);
  };
  this.handleClose = function () {
    this.startEffectivePopupOpen = false;
    this.startExpirationPopupOpen = false;
    this.rowSelected = false;
  };
  this.changeState = function () {
    this.rowSelected = !this.rowSelected;
  };
  this.setDefaultState = function () {
    this.rowSelected = false;
    this.handleClose();
  };
  this.setError = function () {
    this.isError = !this.isError;
  };
};
RateStatusRowController.$inject = ["$rootScope", "$scope", "$element", "$timeout", "dateUtil", "localization", "formComponentUtil", "configurationConstant"];
angular.module('ums.configuration').controller('rateStatusRowController', RateStatusRowController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4), __webpack_require__(2)))

/***/ }),

/***/ 2619:
/***/ (function(module) {

module.exports = JSON.parse("{\"stateRate\":{\"title\":\"Manage Rate Status\",\"columns\":{\"location\":\"Location\",\"product\":\"Product\",\"status\":\"Status\",\"effectiveDate\":\"Effective Date\",\"expirationDate\":\"Expiration Date\"},\"unsavedChanges\":\"Unsaved changes\",\"actions\":{\"name\":\"Actions\",\"discard\":\"Discard\",\"save\":\"Save\",\"backup\":\"Backup\"},\"backup\":{\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\",\"name\":\"State Rates\"},\"discardConfirmation\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"success\":\"Your changes have been discarded.\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"saveStateRates\":{\"loadingBar\":\"Saving State Rates...\",\"savingStateRatesLoadingBar\":\"Successfully Saved State Rates\"}}}");

/***/ }),

/***/ 2620:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2621);
__webpack_require__(2622);
__webpack_require__(2623);
__webpack_require__(2624);

/*@ngInject*/
var SectionTemplateBrowserController = function SectionTemplateBrowserController($rootScope, $scope, $timeout, $state, localization, coreConstant, configurationActionsUtil, configurationMediator, databaseDownloadSectionName, navigationStateModel, sectionTemplateAction, modalUtil, userMediator) {
  $scope.viewModel = {
    isLoading: true,
    sectionTemplates: [],
    totalSectionTemplates: 0,
    isGridEmpty: true,
    nameSearchString: '',
    requestParams: {
      key: 'name',
      startIndex: 0,
      pageSize: 25,
      sortType: 'asc'
    },
    shortDateTimeFormat: 'MM/dd/yy hh:mma',
    searchDelayInMilliSeconds: 750
  };
  localization.getTranslationByKey('sectionTemplateBrowser').then(function (translations) {
    $scope.viewModel.recordCountText = _.get(translations, 'recordCountText');
    $scope.viewModel.recordsCountText = _.get(translations, 'recordsCountText');
    $scope.viewModel.nameSearchStringPlaceholder = _.get(translations, 'nameSearchStringPlaceholder');
    $scope.actions = [];
    $scope.context = {
      identifier: 'sectionTemplateBrowser',
      actions: {},
      fallthrough: null,
      model: {
        contextType: coreConstant.CONTEXT_NONE
      }
    };
    $scope.context.actions[coreConstant.CONTEXT_NONE] = '';
    function loadActions() {
      configurationMediator.loadSectionTemplateBrowserActions().then(function (actions) {
        var allActions = [];
        allActions.push({
          actions: actions.actions,
          contextType: $scope.context.model.contextType
        });
        $scope.actions = allActions;
        $scope.actionsTimeLastModified = new Date().getTime();
      });
    }
    function loadSectionTemplates() {
      $scope.viewModel.isLoading = true;
      userMediator.restoreViewState('configuration.sectionTemplateBrowser', $scope.viewModel);
      configurationMediator.getSectionTemplatesByName($scope.viewModel.nameSearchString, $scope.viewModel.requestParams).then(function (sectionTemplates) {
        $scope.viewModel.sectionTemplates = sectionTemplates.records;
        $scope.viewModel.totalSectionTemplates = sectionTemplates.totalRecords;
        $scope.viewModel.isGridEmpty = $scope.viewModel.totalSectionTemplates === 0;
        $timeout(function () {
          $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
          $scope.viewModel.isLoading = false;
        }, 0);
      });
    }
    $scope.getStatus = function (item) {
      var status = item.active ? 'active' : 'inactive';
      return _.get(translations, 'status.' + status);
    };
    $scope.onNameSearchStringChanged = function () {
      $scope.viewModel.startIndex = 0;
      userMediator.saveViewState('configuration.sectionTemplateBrowser', {
        nameSearchString: $scope.viewModel.nameSearchString
      });
      loadSectionTemplates();
    };
    $scope.onPagingChange = function ($event, params) {
      $scope.viewModel.requestParams.startIndex = params.startIndex;
      loadSectionTemplates();
    };
    $scope.onSortChange = function (event, params) {
      $scope.viewModel.requestParams.key = params.key;
      $scope.viewModel.requestParams.sortType = params.sortType;
      loadSectionTemplates();
    };
    function resetNavigationState() {
      navigationStateModel.saveViewState('configuration.sectionTemplateBrowser', null);
    }
    $scope.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case sectionTemplateAction.NEW_SECTION_TEMPLATE:
            $state.go('configuration.sectionTemplateEditor.properties', {
              sectionTemplateId: -1
            });
            break;
          case sectionTemplateAction.BACKUP:
            configurationActionsUtil.backup(databaseDownloadSectionName.SECTION_TEMPLATES, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
            break;
          case sectionTemplateAction.RELOAD_SECTION_RULES:
            configurationActionsUtil.reloadSectionTemplateRules();
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
    $scope.onClickRow = function (event, item) {
      var navigationModel = {
        parentState: 'configuration.sectionTemplateBrowser',
        currentState: 'configuration.sectionTemplateEditor.properties',
        data: {
          sectionTemplateId: item.id
        }
      };
      $state.go('configuration.sectionTemplateEditor.properties', {
        sectionTemplateId: item.id
      });
      navigationStateModel.saveViewState('configuration.sectionTemplateBrowser', navigationModel);
    };
    loadActions();
    loadSectionTemplates();
    resetNavigationState();
  });
  $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
    $scope.$apply();
  });
};
SectionTemplateBrowserController.$inject = ["$rootScope", "$scope", "$timeout", "$state", "localization", "coreConstant", "configurationActionsUtil", "configurationMediator", "databaseDownloadSectionName", "navigationStateModel", "sectionTemplateAction", "modalUtil", "userMediator"];
angular.module('ums.configuration').controller('sectionTemplateBrowserController', SectionTemplateBrowserController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2621:
/***/ (function(module) {

module.exports = JSON.parse("{\"sectionTemplateBrowser\":{\"title\":\"Manage Section Templates\",\"columns\":{\"name\":\"Name\",\"active\":\"Status\",\"ordinalNumber\":\"Order\",\"lastModifiedBy\":\"Last Edited By\",\"timeLastModified\":\"Last Modified Date\"},\"emptyGrid\":\"No matching section templates\",\"recordCountText\":\"Showing startIndex to endIndex of total Section Template\",\"recordsCountText\":\"Showing startIndex to endIndex of total Section Templates\",\"nameSearchStringPlaceholder\":\"Search Name\",\"actions\":{\"name\":\"Actions\",\"new section template\":\"New Section Template\",\"backup\":\"Backup\",\"reload section rules\":\"Reload Section Rules\"},\"status\":{\"active\":\"Active\",\"inactive\":\"Inactive\"},\"reloadRules\":{\"loadingBar\":\"Reloading Section Template Rules...\",\"successMessage\":\"Successfully reloaded section template rules\",\"title\":\"Reload Section Template Rules\",\"summary\":\"Are you sure you want to reload section template rules?\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"validateCheckBox\":\"Validate rules\"},\"backup\":{\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\",\"name\":\"Section Templates\"}}}");

/***/ }),

/***/ 2622:
/***/ (function(module, exports, __webpack_require__) {

var path = '/configuration/sectionTemplateBrowser/sectionTemplateBrowser.tpl.html';
var html = "<div class=\"sectionTemplateBrowser\">\n\n    <!-- Header -->\n    <div class=\"header\">\n        <div class=\"headerContent\">\n            <div class=\"headerLabel\" ui-translate>sectionTemplateBrowser.title</div>\n\n            <action-buttons-bar context=\"context\"\n                                actions=\"actions\"\n                                notify-action-clicked=\"handleAction(action, file)\"\n                                time-last-modified=\"actionsTimeLastModified\"></action-buttons-bar>\n        </div>\n    </div>\n\n    <!-- Tools -->\n    <div class=\"tools\">\n\n        <div class=\"toolsContent\">\n\n            <div class=\"nameSearchStringInput\">\n                <span class=\"glyphicon glyphicon-search\"></span>\n                <input type=\"text\"\n                       ng-model=\"viewModel.nameSearchString\"\n                       ng-model-options=\"{ debounce: viewModel.searchDelayInMilliSeconds }\"\n                       ng-change=\"onNameSearchStringChanged()\"\n                       placeholder=\"{{ ::viewModel.nameSearchStringPlaceholder }}\"></div>\n        </div>\n    </div>\n\n    <!-- Grid -->\n    <div class=\"grid\">\n\n        <div class=\"gridContainer\">\n\n            <!-- Grid Header -->\n            <div class=\"columnHeader\">\n\n                <div class=\"columnRow\">\n\n                    <div class=\"colHover\"></div>\n\n                    <div class=\"colName\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"name\"\n                         item-label=\"sectionTemplateBrowser.columns.name\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colActive\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"active\"\n                         item-label=\"sectionTemplateBrowser.columns.active\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colOrdinalNumber\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"ordinalNumber\"\n                         item-label=\"sectionTemplateBrowser.columns.ordinalNumber\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colLastModifiedBy\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"lastModifiedBy\"\n                         item-label=\"sectionTemplateBrowser.columns.lastModifiedBy\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n\n                    <div class=\"colTimeLastModified\"\n                         ui-grid-sortable-header\n                         request-params=\"viewModel.requestParams\"\n                         item-name=\"timeLastModified\"\n                         item-label=\"sectionTemplateBrowser.columns.timeLastModified\"\n                         on-toggle=\"onSortChange($event, params)\"></div>\n                </div>\n            </div>\n\n\n            <div class=\"datagrid table\"\n                 ux-datagrid=\"viewModel.sectionTemplates\"\n                 ng-if=\"!viewModel.isLoading\"\n                 ui-scroll-detection\n                 ui-scroll-detection-target=\".columnHeader\">\n\n                <script type=\"template/html\"\n                        data-template-item=\"item\"\n                        data-template-name=\"default\">\n\n                    <div class=\"columnRow\">\n\n                        <div class=\"columnRowWrapper\">\n\n                            <div class=\"col colName\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.name }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.nameTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.nameTooltip\">{{ ::item.name }}</span>\n                            </div>\n\n                            <div class=\"col colActive\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::getStatus(item) }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.activeTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.activeTooltip\">{{ ::getStatus(item) }}</span>\n                            </div>\n\n                            <div class=\"col colOrdinalNumber\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.ordinalNumber }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.ordinalNumberTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.ordinalNumberTooltip\">{{ ::item.ordinalNumber }}</span>\n                            </div>\n\n                            <div class=\"col colLastModifiedBy\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.lastModifiedBy }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.lastModifiedByTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.lastModifiedByTooltip\">{{ ::item.lastModifiedBy }}</span>\n                            </div>\n\n                            <div class=\"col colTimeLastModified\"\n                                 ng-click=\"onClickRow($event, item)\">\n                                <span class=\"columnText\"\n                                      uib-tooltip=\"{{ ::item.timeLastModified | date: viewModel.shortDateTimeFormat }}\"\n                                      tooltip-append-to-body=\"true\"\n                                      tooltip-popup-delay=\"500\"\n                                      tooltip-enable=\"{{ item.timeLastModifiedTooltip }}\"\n                                      ui-is-tooltip-enabled=\"item.timeLastModifiedTooltip\">{{ ::item.timeLastModified | date: viewModel.shortDateTimeFormat }}</span>\n                            </div>\n                        </div>\n                    </div>\n                </script>\n            </div>\n\n            <ui-grid-paging-component\n                ng-hide=\"viewModel.totalSectionTemplates === 0\"\n                start-index=\"viewModel.requestParams.startIndex\"\n                page-size=\"viewModel.requestParams.pageSize\"\n                total-records=\"viewModel.totalSectionTemplates\"\n                record-count-text=\"viewModel.recordCountText\"\n                records-count-text=\"viewModel.recordsCountText\"\n                on-change=\"onPagingChange($event, params)\"></ui-grid-paging-component>\n\n            <div class=\"gridEmpty\"\n                 ng-if=\"viewModel.isGridEmpty && !viewModel.isLoading\" ui-translate>sectionTemplateBrowser.emptyGrid\n            </div>\n\n            <div class=\"icon-spinner\"\n                 ng-if=\"viewModel.isLoading\">\n                <img src=\"" + __webpack_require__(52) + "\"/>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2623:
/***/ (function(module, exports) {

/*@ngInject*/
var SectionTemplateRepository = function SectionTemplateRepository(baseRepository, temporaryLoginTokenRepository) {
  angular.extend(this, baseRepository);
  this.getSectionTemplatesByName = function (nameSearchString, requestParams) {
    var url = '/rest/SectionTemplate',
      config = {
        params: {
          nameSearchString: nameSearchString,
          sortBy: requestParams.key,
          sortDirection: requestParams.sortType,
          startIndex: requestParams.startIndex,
          numberOfRows: requestParams.pageSize
        }
      };
    return this.get(url, config);
  };
  this.saveSectionTemplate = function (sectionTemplate) {
    var url = '/rest/SectionTemplate';
    var body = sectionTemplate,
      config = {
        params: {}
      };
    if (sectionTemplate.id) {
      url = '/rest/SectionTemplate/' + sectionTemplate.id;
    }
    return this.post(url, body, config);
  };
  this.reloadSectionTemplateRules = function (validate) {
    var url = '/rest/SectionTemplate/reloadRules',
      config = {
        params: {
          validate: validate
        }
      };
    return this.post(url, {}, config);
  };
  this.uploadQuoteDocumentTemplateFile = function (sectionTemplate, quoteDocumentTemplateFile) {
    var _this = this;
    var url = '/sectionTemplateUpload',
      formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        // When you assign undefined, the content type defaults to multipart/form-data
        headers: {
          'Content-Type': undefined
        },
        params: {
          sectionTemplateId: sectionTemplate.id,
          documentTemplateName: sectionTemplate.documentTemplateName,
          size: quoteDocumentTemplateFile.size
        }
      };
    formData.append('Filedata', quoteDocumentTemplateFile);
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this.post(url, formData, config);
    });
  };
  this.deleteSectionTemplate = function (sectionTemplateId) {
    var url = "/rest/SectionTemplate/".concat(sectionTemplateId);
    return this.delete(url);
  };
  this.markInProduction = function (sectionTemplateId) {
    var url = "/rest/SectionTemplate/".concat(sectionTemplateId, "/markInProduction");
    var config = {
      params: {}
    };
    return this.post(url, null, config);
  };
};
SectionTemplateRepository.$inject = ["baseRepository", "temporaryLoginTokenRepository"];
angular.module('ums.configuration').service('sectionTemplateRepository', SectionTemplateRepository);

/***/ }),

/***/ 2624:
/***/ (function(module, exports) {

/*@ngInject*/
var SectionTemplateBrowserActionRepository = function SectionTemplateBrowserActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadActions = function () {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.underwriting.proposal.SectionTemplate:null'
        }
      };
    return this.get(url, config);
  };
};
SectionTemplateBrowserActionRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('sectionTemplateBrowserActionRepository', SectionTemplateBrowserActionRepository);

/***/ }),

/***/ 2625:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2626);
__webpack_require__(2627);
__webpack_require__(2628);
__webpack_require__(2634);
__webpack_require__(2637);
__webpack_require__(2641);

/*@ngInject*/
var SectionTemplateEditorController = function SectionTemplateEditorController($scope, $stateParams, sectionTemplateEditorModel, configurationConstant) {
  function init() {
    sectionTemplateEditorModel.buildSectionTemplate(parseInt($stateParams.sectionTemplateId));
  }
  $scope.$on('$destroy', function () {
    sectionTemplateEditorModel.reset(parseInt($stateParams.sectionTemplateId));
  });
  init();
};
SectionTemplateEditorController.$inject = ["$scope", "$stateParams", "sectionTemplateEditorModel", "configurationConstant"];
angular.module('ums.configuration').controller('sectionTemplateEditorController', SectionTemplateEditorController);

/***/ }),

/***/ 2626:
/***/ (function(module, exports) {

var path = '/configuration/sectionTemplateEditor/sectionTemplateEditor.tpl.html';
var html = "<div class=\"sectionTemplateEditor\">\n\n    <ui-section-template-editor-header></ui-section-template-editor-header>\n\n    <ui-section-template-editor-nav></ui-section-template-editor-nav>\n\n    <div class=\"content\"\n         ui-view=\"tabView\"></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2627:
/***/ (function(module, exports) {

/*@ngInject*/
var SectionTemplateEditorRepository = function SectionTemplateEditorRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getSectionTemplateById = function (sectionTemplateId) {
    var url = '/rest/SectionTemplate/' + sectionTemplateId;
    return this.get(url);
  };
};
SectionTemplateEditorRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('sectionTemplateEditorRepository', SectionTemplateEditorRepository);

/***/ }),

/***/ 2628:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2629);
__webpack_require__(2630);
__webpack_require__(2631);
__webpack_require__(2632);
__webpack_require__(2633);
var SectionTemplateEditorHeaderComponent = {
  templateUrl: '/configuration/sectionTemplateEditor/header/sectionTemplateEditorHeader.tpl.html',
  controller: 'sectionTemplateEditorHeaderController',
  bindings: {}
};
angular.module('ums').component('uiSectionTemplateEditorHeader', SectionTemplateEditorHeaderComponent);

/***/ }),

/***/ 2629:
/***/ (function(module) {

module.exports = JSON.parse("{\"sectionTemplateEditorHeader\":{\"title\":\"Manage Section Templates\",\"inProduction\":\"In Production\",\"actions\":{\"name\":\"Actions\",\"save\":\"Save\",\"discard\":\"Discard\",\"delete\":\"Delete\",\"mark in production\":\"Mark in Production\",\"reload section rules\":\"Reload Section Rules\"},\"unsavedChanges\":\"Unsaved changes\",\"invalidSectionTemplate\":\"The section template is invalid. Please correct or discard your changes before leaving this page.\",\"saveSectionTemplate\":{\"loadingBar\":\"Saving section template\",\"savingSectionTemplateSuccessLoadingBar\":\"Successfully saved section template\"},\"deleteConfirmation\":{\"title\":\"Delete Section Template\",\"summary\":\"Are you sure you want to delete this section template?\",\"success\":\"Section template deleted.\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"loadingBar\":\"Deleting section template\"},\"discardConfirmation\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"success\":\"Your changes have been discarded.\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"invalidRule\":{\"title\":\"Section Template Validation Error\",\"summary\":\"Your section template changes could not be saved because of the following errors:\\n\\nPlease configure a valid section template rule defining the condition(s) under which instances of this section template will be displayed.\",\"saveSummary\":\"Please configure a valid section template rule defining the condition(s) under which instances of this section template will be displayed.\",\"confirmButton\":\"Ok\"},\"markInProductionConfirmation\":{\"title\":\"Mark Section Template In Production\",\"summary\":\"Marking this section template 'In Production' will prevent you from deleting it; section templates marked in production can only be made inactive. Are you sure you want to continue?\",\"success\":\"Section template marked in production.\",\"cancel\":\"No\",\"confirm\":\"Yes\",\"loadingBar\":\"Marking section template in production\"}}}");

/***/ }),

/***/ 2630:
/***/ (function(module, exports) {

var path = '/configuration/sectionTemplateEditor/header/sectionTemplateEditorHeader.tpl.html';
var html = "<div class=\"headerRow\">\n\n    <div class=\"nameColumn\">\n\n        <button type=\"button\"\n                class=\"btn-link backButton\"\n                ui-sref=\"configuration.sectionTemplateBrowser\">\n\n            <span class=\"glyphicon glyphicon-arrow-left\"></span>\n\n            <span ui-translate>sectionTemplateEditorHeader.title</span>\n        </button>\n\n        <div class=\"sectionTemplateName\"\n             uib-tooltip=\"{{ $ctrl.sectionTemplate.name }}\"\n             tooltip-placement=\"top-left\"\n             tooltip-append-to-body=\"true\">\n\n            <span>{{ $ctrl.sectionTemplate.name }}</span>\n        </div>\n    </div>\n    <div class=\"statusColumn\" ng-if=\"$ctrl.sectionTemplate.status===1\">\n        <div class=\"sectionTemplateStatus\">\n\n            <span ui-translate>sectionTemplateEditorHeader.inProduction</span>\n        </div>\n    </div>\n\n    <div class=\"actionButtonColumn\">\n\n        <action-buttons-bar context=\"$ctrl.context\"\n                            actions=\"$ctrl.actions\"\n                            action-sub-texts=\"$ctrl.actionSubTexts\"\n                            notify-action-clicked=\"$ctrl.handleAction(action, file)\"\n                            time-last-modified=\"$ctrl.actionsTimeLastModified\"></action-buttons-bar>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2631:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SectionTemplateEditorHeaderController = function SectionTemplateEditorHeaderController($rootScope, $scope, $element, $stateParams, $state, coreConstant, localization, sectionTemplateEditorModel, configurationMediator, sectionTemplateAction, modalUtil, configurationActionsUtil, configurationConstant, sectionTemplateActionsUtil, loadingBarHandler, sectionTemplateApplicabilityType) {
  var _this5 = this;
  $element.addClass('sectionTemplateEditorHeader');
  this.sectionTemplate = null;
  this.translations = null;
  this.actions = [];
  this.context = {
    identifier: 'sectionTemplateEditorHeader',
    actions: {},
    fallthrough: null,
    model: {
      contextType: coreConstant.CONTEXT_NONE
    }
  };
  this.context.actions[coreConstant.CONTEXT_NONE] = '';
  this.actionSubTexts = {};
  this.$onInit = function () {
    var _this = this;
    localization.getTranslationByKey('sectionTemplateEditorHeader').then(function (translations) {
      _this.sectionTemplate = sectionTemplateEditorModel.getSectionTemplate(parseInt($stateParams.sectionTemplateId));
      _this.translations = translations;
      _this.loadActions();
    });
  };
  this.loadActions = function () {
    var _this2 = this;
    configurationMediator.loadSectionTemplateActions($stateParams.sectionTemplateId).then(function (actions) {
      var allActions = [];
      allActions.push({
        actions: actions.actions,
        contextType: _this2.context.model.contextType
      });
      _this2.processActions(allActions);
    });
  };
  this.processActions = function (actions) {
    var _this3 = this;
    this.actions = actions;
    this.actionSubTexts = {};
    _.each(this.actions, function (subAction) {
      _.each(subAction.actions, function (action) {
        if (action.name === sectionTemplateAction.SAVE) {
          action.enabled = false;
          if (sectionTemplateEditorModel.hasUnsavedPropertiesChanges($stateParams.sectionTemplateId) || sectionTemplateEditorModel.hasUnsavedRuleChanges($stateParams.sectionTemplateId)) {
            _this3.actionSubTexts[action.name] = {
              class: 'unsavedChanges',
              text: _.get(_this3.translations, 'unsavedChanges')
            };
            if (sectionTemplateEditorModel.isValidToSave(parseInt($stateParams.sectionTemplateId))) {
              action.enabled = true;
            }
          }
        }
        if (action.name === sectionTemplateAction.DISCARD) {
          action.enabled = sectionTemplateEditorModel.hasUnsavedPropertiesChanges($stateParams.sectionTemplateId) || sectionTemplateEditorModel.hasUnsavedRuleChanges($stateParams.sectionTemplateId) || $stateParams.sectionTemplateId === '-1';
        }
      });
    });
    this.actionsTimeLastModified = new Date().getTime();
  };
  this.handleAction = function (action, file) {
    var _this4 = this;
    if (action.enabled) {
      switch (action.name) {
        case sectionTemplateAction.SAVE:
          // Scenario 1: If the section template is conditional
          if (this.sectionTemplate.applicability === sectionTemplateApplicabilityType.CONDITIONAL) {
            /*  a.If the triggerRule rule is present i.e existing sectional template, then validate the rule, save it if there are no errors
                b.If errors and the opened tab is 'rules' then simply show the pop-up to correct the rule before saving and don't save it.
                c.If errors and the opened tab is 'properties', then simply show the pop-up that the rule has errors and save the template.*/
            if (!_.isNil(this.sectionTemplate.triggerRule)) {
              configurationMediator.validateRule(this.sectionTemplate.triggerRule).then(function (result) {
                if (sectionTemplateEditorModel.hasUnsavedPropertiesChanges(_this4.sectionTemplate.id) || _.isEmpty(result.errors)) {
                  var summary = sectionTemplateEditorModel.hasUnsavedPropertiesChanges(_this4.sectionTemplate.id) ? 'invalidRule.saveSummary' : 'invalidRule.summary';
                  sectionTemplateActionsUtil.saveSectionTemplate(_this4.translations, _this4.sectionTemplate).then(function () {
                    $state.reload();
                    if (!_.isEmpty(result.errors)) {
                      _this4.openGenericConfirm(_.get(_this4.translations, 'invalidRule.title'), _.get(_this4.translations, summary), _.get(_this4.translations, 'invalidRule.confirmButton'));
                    }
                  });
                } else if (!_.isEmpty(result.errors)) {
                  _this4.openGenericConfirm(_.get(_this4.translations, 'invalidRule.title'), _.get(_this4.translations, 'invalidRule.summary'), _.get(_this4.translations, 'invalidRule.confirmButton'));
                }
              });
              // If the triggerRule rule is not present i.e new sectional template, then save the section template and show a pop-up window to correct the rule.
            } else {
              sectionTemplateActionsUtil.saveSectionTemplate(this.translations, this.sectionTemplate).then(function () {
                $state.reload();
                _this4.openGenericConfirm(_.get(_this4.translations, 'invalidRule.title'), _.get(_this4.translations, 'invalidRule.saveSummary'), _.get(_this4.translations, 'invalidRule.confirmButton'));
              });
            }
            // Scenario 2: Simply save the sectional template if it is not conditional
          } else {
            sectionTemplateActionsUtil.saveSectionTemplate(this.translations, this.sectionTemplate).then(function () {
              $state.reload();
            });
          }
          break;
        case sectionTemplateAction.DISCARD:
          sectionTemplateActionsUtil.discard(this.translations);
          break;
        case sectionTemplateAction.DELETE:
          sectionTemplateActionsUtil.delete(this.translations, this.sectionTemplate.id);
          break;
        case sectionTemplateAction.MARK_IN_PRODUCTION:
          sectionTemplateActionsUtil.markInProduction(this.translations, this.sectionTemplate.id);
          break;
        case sectionTemplateAction.RELOAD_SECTION_RULES:
          configurationActionsUtil.reloadSectionTemplateRules();
          break;
        default:
          modalUtil.showActionNotImplementedModal(action.name);
          break;
      }
    }
  };
  $scope.$on(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, function (event, sectionTemplateId) {
    if (parseInt($stateParams.sectionTemplateId) === sectionTemplateId) {
      _this5.sectionTemplate = sectionTemplateEditorModel.getSectionTemplate(sectionTemplateId);
      _this5.processActions(_this5.actions);
    }
  });
  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    var isCurrentStateSectionTemplateEditor = _.startsWith(fromState.name, 'configuration.sectionTemplateEditor'),
      isTargetSameAsCurrent = toState.name === fromState.name,
      sectionTemplateId = toParams.sectionTemplateId ? parseInt(toParams.sectionTemplateId) : parseInt($stateParams.sectionTemplateId),
      hasUnsavedPropertiesChanges = sectionTemplateEditorModel.hasUnsavedPropertiesChanges(sectionTemplateId),
      hasUnsavedRuleChanges = sectionTemplateEditorModel.hasUnsavedRuleChanges(sectionTemplateId);
    if (toState.name === 'login') {
      return;
    }
    if ((hasUnsavedPropertiesChanges || hasUnsavedRuleChanges) && isCurrentStateSectionTemplateEditor && !isTargetSameAsCurrent) {
      event.preventDefault();
      // Scenario 1: User is navigating away from properties tab
      if (sectionTemplateEditorModel.isValidToSave(sectionTemplateId) && fromState.url === '/properties') {
        // Save the section template and subsequently check for rule validation if it is a conditional section template
        sectionTemplateActionsUtil.saveSectionTemplate(_this5.translations, _this5.sectionTemplate).then(function (sectionTemplate) {
          $state.go(toState, {
            sectionTemplateId: sectionTemplate.id + ''
          });
          if (sectionTemplate.applicability === sectionTemplateApplicabilityType.CONDITIONAL) {
            configurationMediator.validateRule(sectionTemplate.triggerRule).then(function (result) {
              if (!_.isEmpty(result.errors)) {
                _this5.openGenericConfirm(_.get(_this5.translations, 'invalidRule.title'), _.get(_this5.translations, 'invalidRule.saveSummary'), _.get(_this5.translations, 'invalidRule.confirmButton'));
              }
            });
          }
        });
        // Scenario 2: User is navigating away from Rules tab
      } else if (!_.isNil(_this5.sectionTemplate.triggerRule) && fromState.url === '/rule') {
        configurationMediator.validateRule(_this5.sectionTemplate.triggerRule).then(function (result) {
          if (!_.isEmpty(result.errors)) {
            _this5.openGenericConfirm(_.get(_this5.translations, 'invalidRule.title'), _.get(_this5.translations, 'invalidRule.summary'), _.get(_this5.translations, 'invalidRule.confirmButton'));
          }
        });
      } else {
        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(_this5.translations, 'invalidSectionTemplate'));
      }
    } else {
      // there are no changes to be saved, do nothing
    }
  });
  this.openGenericConfirm = function (title, summary, confirmActionButtonLabel) {
    modalUtil.showGenericConfirm({
      title: title,
      summary: summary,
      confirmActionButtonLabel: confirmActionButtonLabel
    });
  };
};
SectionTemplateEditorHeaderController.$inject = ["$rootScope", "$scope", "$element", "$stateParams", "$state", "coreConstant", "localization", "sectionTemplateEditorModel", "configurationMediator", "sectionTemplateAction", "modalUtil", "configurationActionsUtil", "configurationConstant", "sectionTemplateActionsUtil", "loadingBarHandler", "sectionTemplateApplicabilityType"];
angular.module('ums.configuration').controller('sectionTemplateEditorHeaderController', SectionTemplateEditorHeaderController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2632:
/***/ (function(module, exports) {

/*@ngInject*/
var SectionTemplateActionRepository = function SectionTemplateActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadSectionTemplateActions = function (sectionTemplateId) {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.underwriting.proposal.SectionTemplate:' + sectionTemplateId
        }
      };
    return this.get(url, config);
  };
};
SectionTemplateActionRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('sectionTemplateActionRepository', SectionTemplateActionRepository);

/***/ }),

/***/ 2633:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SectionTemplateActionsUtil = function SectionTemplateActionsUtil($rootScope, $stateParams, $state, $q, sectionTemplateRepository, loadingBarHandler, configurationMediator, sectionTemplateEditorModel, modalUtil, coreConstant) {
  this.reloadSectionTemplateRules = function (validate) {
    return sectionTemplateRepository.reloadSectionTemplateRules(validate);
  };
  this.saveSectionTemplate = function (translations, sectionTemplate) {
    loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'saveSectionTemplate.loadingBar'));
    return configurationMediator.saveSectionTemplate(sectionTemplate).then(function (savedSectionTemplate) {
      var quoteDocumentTemplateFile = sectionTemplateEditorModel.getQuoteDocumentTemplateFile(sectionTemplate.id);
      if (sectionTemplateEditorModel.hasUnsavedQuoteDocumentTemplateFile(sectionTemplate.id)) {
        return configurationMediator.uploadQuoteDocumentTemplateFile(savedSectionTemplate, quoteDocumentTemplateFile).then(function () {
          return concludeSaveSectionTemplate(translations, savedSectionTemplate);
        });
      } else {
        return concludeSaveSectionTemplate(translations, savedSectionTemplate);
      }
    });
  };
  function concludeSaveSectionTemplate(translations, savedSectionTemplate) {
    loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'saveSectionTemplate.savingSectionTemplateSuccessLoadingBar'));
    $stateParams.sectionTemplateId = savedSectionTemplate.id;
    sectionTemplateEditorModel.updateSectionTemplate(savedSectionTemplate);
    return $q.when(savedSectionTemplate);
  }
  this.discard = function (translations) {
    modalUtil.showConfirmationModal(null, null, null, 'sectionTemplateEditorHeader.discardConfirmation', null, true, function () {
      $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'discardConfirmation.success'));
      sectionTemplateEditorModel.setUnsavedPropertiesChanges($stateParams.sectionTemplateId, false);
      sectionTemplateEditorModel.setUnsavedRuleChanges($stateParams.sectionTemplateId, false);
      sectionTemplateEditorModel.setUnsavedQuoteDocumentTemplateFile($stateParams.sectionTemplateId, false);
      if ($stateParams.sectionTemplateId && $stateParams.sectionTemplateId !== '-1') {
        $state.reload();
      } else {
        $state.go('configuration.sectionTemplateBrowser', {});
      }
    });
  };
  this.delete = function (translations, sectionTemplateId) {
    modalUtil.showConfirmationModal(null, null, null, 'sectionTemplateEditorHeader.deleteConfirmation', null, true, function () {
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'deleteConfirmation.loadingBar'));
      return configurationMediator.deleteSectionTemplate(sectionTemplateId).then(function () {
        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'deleteConfirmation.success'));
        $state.go('configuration.sectionTemplateBrowser', {});
      });
    });
  };
  this.markInProduction = function (translations, sectionTemplateId) {
    modalUtil.showConfirmationModal(null, null, null, 'sectionTemplateEditorHeader.markInProductionConfirmation', null, true, function () {
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'markInProductionConfirmation.loadingBar'));
      return configurationMediator.markSectionTemplateInProduction(sectionTemplateId).then(function (updatedSectionTemplate) {
        sectionTemplateEditorModel.updateSectionTemplate(updatedSectionTemplate);
        $state.reload();
        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'markInProductionConfirmation.success'));
      });
    });
  };
};
SectionTemplateActionsUtil.$inject = ["$rootScope", "$stateParams", "$state", "$q", "sectionTemplateRepository", "loadingBarHandler", "configurationMediator", "sectionTemplateEditorModel", "modalUtil", "coreConstant"];
angular.module('ums.configuration').service('sectionTemplateActionsUtil', SectionTemplateActionsUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2634:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2635);
__webpack_require__(2636);

/*@ngInject*/
var SectionTemplateRuleController = function SectionTemplateRuleController($rootScope, $scope, $stateParams, $uibModal, $q, configurationConstant, localization, currentUserModel, authorizationConstants, sectionTemplateEditorModel, sectionTemplateApplicabilityType, loadingBarHandler, configurationMediator, dataSetUtil, umStudioConstant, ruleMediator) {
  $scope.viewModel = {
    hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.MANAGE_CONFIG_SECTION_TEMPLATES),
    sectionTemplate: {},
    showRuleBuilder: false,
    ruleAction: null,
    sectionTemplateRuleActions: []
  };
  $scope.ruleActionObjects = null;
  function init() {
    loadModel();
    loadLocalization();
  }
  function loadModel() {
    loadDataSets().then(function () {
      loadRuleActions().then(function () {
        $scope.viewModel.sectionTemplate = sectionTemplateEditorModel.getSectionTemplate(parseInt($stateParams.sectionTemplateId));
        if (!_.isNil($scope.viewModel.sectionTemplate)) {
          $scope.viewModel.showRuleBuilder = !_.isNil($scope.viewModel.sectionTemplate.triggerRule) && $scope.viewModel.sectionTemplate.applicability === sectionTemplateApplicabilityType.CONDITIONAL;
          if ($scope.viewModel.showRuleBuilder) {
            translateRuleActionFromModel();
          }
        }
      });
    });
  }
  function loadDataSets() {
    if (_.isEmpty($scope.viewModel.sectionTemplateRuleActions)) {
      return dataSetUtil.getDataSet({
        name: 'Section Template Rule Actions'
      }).then(function (dataSet) {
        $scope.viewModel.sectionTemplateRuleActions = _.map(dataSet.items, function (item) {
          return {
            name: item.name,
            value: item.value
          };
        });
      });
    } else {
      return $q.when();
    }
  }
  function loadRuleActions() {
    if (_.isNil($scope.ruleActionObjects)) {
      $scope.ruleActionObjects = {};
      return ruleMediator.getRuleActions('proposal section rules').then(function (ruleActions) {
        _.each(ruleActions, function (ruleAction) {
          if (_.find($scope.viewModel.sectionTemplateRuleActions, {
            value: ruleAction.name
          })) {
            ruleAction.parameters[0].value.entityUri = 'com.firstbest.data.DataItem:com.firstbest.data.DataItemKey::Section Template::' + $stateParams.sectionTemplateId;
            $scope.ruleActionObjects[ruleAction.name] = ruleAction;
          }
        });
      });
    } else {
      return $q.when();
    }
  }
  function loadLocalization() {
    localization.getTranslationByKey('sectionTemplateRule').then(function (translations) {
      $scope.viewModel.placeholders = {
        ruleAction: _.get(translations, 'placeholders.ruleAction')
      };
      $scope.viewModel.reviewRuleNotificationMessage = _.get(translations, 'reviewRuleNotificationMessage');
    });
  }
  function showValidateRuleModal(validateRuleResult) {
    var instance = $uibModal.open({
      templateUrl: '/configuration/formEditor/content/rule/reviewRule/validateRuleModal.tpl.html',
      controller: 'validateRuleModalController',
      windowClass: 'validateRuleModal',
      resolve: {
        options: function options() {
          return {
            ruleText: validateRuleResult.ruleText,
            error: validateRuleResult.errors
          };
        }
      }
    });
    return instance.result;
  }
  function translateRuleActionFromModel() {
    if (!_.isEmpty($scope.viewModel.sectionTemplate.triggerRule.actions)) {
      $scope.viewModel.ruleAction = _.find($scope.viewModel.sectionTemplateRuleActions, {
        value: $scope.viewModel.sectionTemplate.triggerRule.actions[0].name
      });
    }
  }
  function translateRuleActionToModel() {
    if (!_.isNil($scope.viewModel.ruleAction)) {
      $scope.viewModel.sectionTemplate.triggerRule.actions = [$scope.ruleActionObjects[$scope.viewModel.ruleAction.value]];
    } else {
      $scope.viewModel.sectionTemplate.triggerRule.actions = [];
    }
  }
  $scope.reviewRule = function () {
    loadingBarHandler.showNotificationLoadingBar($scope.viewModel.reviewRuleNotificationMessage);
    return configurationMediator.validateRule($scope.viewModel.sectionTemplate.triggerRule).then(function (result) {
      showValidateRuleModal(result);
    }).finally(function () {
      loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
    });
  };
  $scope.onChange = function () {
    sectionTemplateEditorModel.setUnsavedRuleChanges($scope.viewModel.sectionTemplate.id, true);
    $rootScope.$broadcast(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, $scope.viewModel.sectionTemplate.id);
  };
  $scope.$on(umStudioConstant.event.RULE_UPDATED, function () {
    sectionTemplateEditorModel.setUnsavedRuleChanges($scope.viewModel.sectionTemplate.id, true);
    $rootScope.$broadcast(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, $scope.viewModel.sectionTemplate.id);
  });
  $scope.onRuleActionSelect = function () {
    translateRuleActionToModel();
    $scope.onChange();
  };
  $scope.$on(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, function (event, sectionTemplateId) {
    if (parseInt($stateParams.sectionTemplateId) === sectionTemplateId) {
      loadModel();
    }
  });
  init();
};
SectionTemplateRuleController.$inject = ["$rootScope", "$scope", "$stateParams", "$uibModal", "$q", "configurationConstant", "localization", "currentUserModel", "authorizationConstants", "sectionTemplateEditorModel", "sectionTemplateApplicabilityType", "loadingBarHandler", "configurationMediator", "dataSetUtil", "umStudioConstant", "ruleMediator"];
angular.module('ums.configuration').controller('sectionTemplateRuleController', SectionTemplateRuleController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2635:
/***/ (function(module) {

module.exports = JSON.parse("{\"sectionTemplateRule\":{\"noRuleMessage\":\"This tab is always displayed but is only relevant for conditionally applicable section templates.\",\"review\":\"Review\",\"reviewRuleNotificationMessage\":\"Validating rule\",\"then\":\"Then\",\"add\":\"Add:\",\"placeholders\":{\"ruleAction\":\"Select an Action\"}}}");

/***/ }),

/***/ 2636:
/***/ (function(module, exports) {

var path = '/configuration/sectionTemplateEditor/content/rule/sectionTemplateRule.tpl.html';
var html = "<div class=\"sectionTemplateRule\">\n\n    <div class=\"staticText\"\n         ng-if=\"!viewModel.showRuleBuilder\"\n         ui-translate>sectionTemplateRule.noRuleMessage\n    </div>\n\n    <div class=\"rule\"\n         ng-if=\"viewModel.showRuleBuilder\">\n\n        <div class=\"reviewRow\">\n\n            <span class=\"review btn-link\"\n                  ng-click=\"reviewRule()\"\n                  ui-translate>\n                  sectionTemplateRule.review\n            </span>\n        </div>\n\n        <div class=\"ruleConditions\">\n\n            <ui-rule-condition-group rule-condition-group=\"viewModel.sectionTemplate.triggerRule.condition\"\n                                     is-top-level=\"true\"\n                                     can-user-manage-form-rules=\"viewModel.hasManagePermission\">\n            </ui-rule-condition-group>\n        </div>\n\n        <div class=\"ruleActions\">\n\n            <div class=\"groupHeader\">\n\n                <div class=\"thenContainer\"\n                     ui-translate>sectionTemplateRule.then\n                </div>\n            </div>\n\n            <div class=\"groupContainer\">\n\n                <div class=\"groupBody\">\n\n                    <div class=\"ruleActionsContainer\">\n\n                        <div class=\"ruleAction\">\n\n                            <div class=\"ruleActionContainer\">\n\n                                <div class=\"parameterizedAction\">\n\n                                    <div class=\"parameterizedActionContainer\">\n\n                                        <label class=\"actionText\"\n                                               ui-translate>sectionTemplateRule.add</label>\n\n                                        <div class=\"actionContainer\">\n\n                                            <ui-select class=\"dropdownFormComponent dropdownComponentSelect sectionTemplateRuleActionsDropdown\"\n                                                       theme=\"select2\"\n                                                       ng-model=\"viewModel.ruleAction\"\n                                                       on-select=\"onRuleActionSelect()\"\n                                                       append-to-body=\"true\"\n                                                       search-enabled=\"false\"\n                                                       ui-hide-select-on-scroll\n                                                       ui-hide-select-on-scroll-selector=\".sectionTemplateRule\"\n                                                       ng-disabled=\"::!viewModel.hasManagePermission\">\n\n                                                <ui-select-match placeholder=\"{{ ::viewModel.placeholders.ruleAction }}\"\n                                                                 allow-clear=\"true\">\n                                                    <span>{{ viewModel.ruleAction.name }}</span>\n                                                </ui-select-match>\n\n                                                <ui-select-choices repeat=\"item in viewModel.sectionTemplateRuleActions track by $index\">\n                                                    <span>{{ item.name }}</span>\n                                                </ui-select-choices>\n                                            </ui-select>\n                                        </div>\n\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n\n\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2637:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2638);
__webpack_require__(2639);
__webpack_require__(2640);

/*@ngInject*/
var SectionTemplatePropertiesController = function SectionTemplatePropertiesController($rootScope, $scope, $stateParams, $q, $uibModal, $window, currentUserModel, authorizationConstants, localization, sectionTemplateApplicabilityType, sectionTemplateStageApplicability, dataSetUtil, sectionTemplateEditorModel, configurationConstant, productTypes, coreConstant, coreMediator) {
  $scope.viewModel = {
    hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.MANAGE_CONFIG_SECTION_TEMPLATES),
    sectionTemplate: {},
    applicabilities: [sectionTemplateApplicabilityType.OPTIONAL, sectionTemplateApplicabilityType.REQUIRED, sectionTemplateApplicabilityType.DEFAULT_SELECTED, sectionTemplateApplicabilityType.CONDITIONAL],
    productsMultiSelectName: 'productsMultiSelect',
    productTemplates: null,
    productsDelimiter: ',',
    sectionAdapters: [],
    formTemplates: [],
    quotableProductTemplates: [],
    quotableProductTemplatesList: [],
    allProductsItem: {
      name: '',
      value: '-1'
    },
    quoteDocumentTemplateName: null,
    quoteDocumentTemplateDownloadUrl: '',
    displayQuoteDocumentTemplateUploadButton: true,
    displayQuoteDocumentTemplateLink: false
  };
  function init() {
    loadModel();
    loadLocalization();
  }
  function loadModel() {
    loadDataSets().then(function () {
      $scope.viewModel.sectionTemplate = sectionTemplateEditorModel.getSectionTemplate(parseInt($stateParams.sectionTemplateId));
      if (!_.isNil($scope.viewModel.sectionTemplate)) {
        translateProductsFromModel();
        translateStageApplicabilityFromModel();
        translateSectionAdapterFromModel();
        translateQuoteDocumentTemplateFromModel();
      }
    });
  }
  function loadDataSets() {
    var promisesList = [];
    if (_.isEmpty($scope.viewModel.quotableProductTemplates)) {
      promisesList.push(dataSetUtil.getDataSet({
        name: 'Product Templates By Type',
        search: productTypes.QUOTEABLE
      }).then(function (dataSet) {
        $scope.viewModel.quotableProductTemplates = _.map(dataSet.items, function (item) {
          return {
            name: item.name,
            value: item.value
          };
        });
      }));
    }
    if (_.isEmpty($scope.viewModel.sectionAdapters)) {
      promisesList.push(dataSetUtil.getDataSet({
        name: 'SectionAdapter Dynamic DataSet Generator'
      }).then(function (dataSet) {
        $scope.viewModel.sectionAdapter = {
          name: '',
          value: ''
        };
        $scope.viewModel.sectionAdapters = _.map(dataSet.items, function (item) {
          return {
            name: item.name,
            value: item.value
          };
        });
      }));
    }
    if (_.isEmpty($scope.viewModel.formTemplates)) {
      promisesList.push(dataSetUtil.getDataSet({
        name: 'Proposal/Binder Section Form Template Unique Name Dynamic DataSet Generator'
      }).then(function (dataSet) {
        $scope.viewModel.formTemplates = _.map(dataSet.items, 'value');
      }));
    }
    return $q.all(promisesList);
  }
  function loadLocalization() {
    localization.getTranslationByKey('sectionTemplateProperties').then(function (translations) {
      $scope.viewModel.placeholders = {
        name: _.get(translations, 'placeholders.name'),
        description: _.get(translations, 'placeholders.description'),
        applicability: _.get(translations, 'placeholders.applicability'),
        stageApplicability: _.get(translations, 'placeholders.stageApplicability'),
        formTemplate: _.get(translations, 'placeholders.formTemplate'),
        sectionAdapter: _.get(translations, 'placeholders.sectionAdapter'),
        products: _.get(translations, 'placeholders.products'),
        multipleProductsSelected: _.get(translations, 'placeholders.multipleProductsSelected'),
        allProductsSelected: _.get(translations, 'placeholders.allProductsSelected'),
        quoteDocumentTemplate: _.get(translations, 'placeholders.quoteDocumentTemplate')
      };
      $scope.viewModel.allProductsItem.name = _.get(translations, 'labels.allProductsItemLabel');
      $scope.viewModel.stageApplicabilities = [{
        name: _.get(translations, 'labels.stageApplicability.' + sectionTemplateStageApplicability.PROPOSAL),
        value: sectionTemplateStageApplicability.PROPOSAL
      }, {
        name: _.get(translations, 'labels.stageApplicability.' + sectionTemplateStageApplicability.BINDER),
        value: sectionTemplateStageApplicability.BINDER
      }, {
        name: _.get(translations, 'labels.stageApplicability.' + sectionTemplateStageApplicability.BOTH),
        value: sectionTemplateStageApplicability.BOTH
      }];
      $scope.getApplicabilityLabel = function (value) {
        return _.get(translations, 'labels.applicability.' + value);
      };
    });
  }
  function translateStageApplicabilityToModel() {
    switch ($scope.viewModel.stageApplicability.value) {
      case sectionTemplateStageApplicability.PROPOSAL:
        $scope.viewModel.sectionTemplate.applicableToProposal = true;
        $scope.viewModel.sectionTemplate.applicableToBinder = false;
        break;
      case sectionTemplateStageApplicability.BINDER:
        $scope.viewModel.sectionTemplate.applicableToProposal = false;
        $scope.viewModel.sectionTemplate.applicableToBinder = true;
        break;
      case sectionTemplateStageApplicability.BOTH:
        $scope.viewModel.sectionTemplate.applicableToProposal = true;
        $scope.viewModel.sectionTemplate.applicableToBinder = true;
        break;
    }
  }
  function translateStageApplicabilityFromModel() {
    if ($scope.viewModel.sectionTemplate.applicableToProposal && $scope.viewModel.sectionTemplate.applicableToBinder) {
      $scope.viewModel.stageApplicability = _.find($scope.viewModel.stageApplicabilities, {
        value: sectionTemplateStageApplicability.BOTH
      });
    } else if ($scope.viewModel.sectionTemplate.applicableToProposal) {
      $scope.viewModel.stageApplicability = _.find($scope.viewModel.stageApplicabilities, {
        value: sectionTemplateStageApplicability.PROPOSAL
      });
    } else if ($scope.viewModel.sectionTemplate.applicableToBinder) {
      $scope.viewModel.stageApplicability = _.find($scope.viewModel.stageApplicabilities, {
        value: sectionTemplateStageApplicability.BINDER
      });
    }
  }
  function translateSectionAdapterToModel() {
    $scope.viewModel.sectionTemplate.adapterBeanName = $scope.viewModel.sectionAdapter.value;
  }
  function translateSectionAdapterFromModel() {
    $scope.viewModel.sectionAdapter = _.find($scope.viewModel.sectionAdapters, {
      value: $scope.viewModel.sectionTemplate.adapterBeanName
    });
  }
  function translateProductsToModel() {
    var tempItemList, productTemplateIds;
    if ($scope.viewModel.allProductsItem.selected) {
      _.map($scope.viewModel.quotableProductTemplates, function (item) {
        item.selected = true;
      });
    }
    tempItemList = _.filter($scope.viewModel.quotableProductTemplates, function (item) {
      return item.selected;
    });
    productTemplateIds = _.map(tempItemList, 'value');
    if (_.size(tempItemList) === _.size($scope.viewModel.quotableProductTemplates)) {
      // The server will expect an empty list for "all products"
      $scope.viewModel.sectionTemplate.productTemplates = [];
    } else {
      $scope.viewModel.sectionTemplate.productTemplates = _.map(productTemplateIds, function (productTemplateId) {
        return {
          id: parseInt(productTemplateId)
        };
      });
      if (_.isEmpty($scope.viewModel.sectionTemplate.productTemplates)) {
        // Setting to null here makes the required field indicator work.
        $scope.viewModel.sectionTemplate.productTemplates = null;
      }
    }
    translateProductsFromModel();
  }
  function translateProductsFromModel() {
    var productTemplates;
    $scope.viewModel.productTemplates = null;
    if (!_.isNil($scope.viewModel.sectionTemplate.productTemplates)) {
      productTemplates = _.map($scope.viewModel.sectionTemplate.productTemplates, 'id');
      if (_.isEmpty(productTemplates)) {
        productTemplates = _.map($scope.viewModel.quotableProductTemplates, 'value');
        $scope.viewModel.quotableProductTemplatesList = [];
      } else {
        $scope.viewModel.quotableProductTemplatesList = [$scope.viewModel.allProductsItem];
      }
      $scope.viewModel.quotableProductTemplatesList = $scope.viewModel.quotableProductTemplatesList.concat($scope.viewModel.quotableProductTemplates);
      $scope.viewModel.productTemplates = _.join(productTemplates, $scope.viewModel.productsDelimiter);
    }
    updateQuotableProductTemplatesList();
  }
  function updateQuotableProductTemplatesList() {
    if (_.isEmpty($scope.viewModel.sectionTemplate.productTemplates) && !_.isNil($scope.viewModel.sectionTemplate.productTemplates)) {
      $scope.viewModel.quotableProductTemplatesList = [];
    } else {
      $scope.viewModel.quotableProductTemplatesList = [$scope.viewModel.allProductsItem];
    }
    $scope.viewModel.quotableProductTemplatesList = $scope.viewModel.quotableProductTemplatesList.concat($scope.viewModel.quotableProductTemplates);
  }
  function translateQuoteDocumentTemplateToModel() {
    $scope.viewModel.sectionTemplate.documentTemplateName = $scope.viewModel.quoteDocumentTemplateName;
    $scope.viewModel.displayQuoteDocumentTemplateUploadButton = _.isEmpty($scope.viewModel.quoteDocumentTemplateName);
    $scope.viewModel.displayQuoteDocumentTemplate = !$scope.viewModel.displayQuoteDocumentTemplateUploadButton;
    $scope.viewModel.displayQuoteDocumentTemplateLink = false;
  }
  function translateQuoteDocumentTemplateFromModel() {
    $scope.viewModel.quoteDocumentTemplateName = $scope.viewModel.sectionTemplate.documentTemplateName;
    $scope.viewModel.displayQuoteDocumentTemplateUploadButton = _.isEmpty($scope.viewModel.quoteDocumentTemplateName);
    $scope.viewModel.displayQuoteDocumentTemplate = !$scope.viewModel.displayQuoteDocumentTemplateUploadButton;
    $scope.viewModel.displayQuoteDocumentTemplateLink = $scope.viewModel.displayQuoteDocumentTemplate;
  }
  function getQuoteDocumentTemplateDownloadUrl() {
    var templateFileName = $scope.viewModel.quoteDocumentTemplateName,
      validTemplateFileName = !_.isNil(templateFileName),
      templateFileNamePath = '',
      templateFileNameParameter = '',
      sectionTemplateId = $scope.viewModel.sectionTemplate.id,
      hasUnsavedQuoteDocumentTemplate = sectionTemplateEditorModel.hasUnsavedQuoteDocumentTemplateFile(sectionTemplateId);
    if (validTemplateFileName) {
      templateFileNamePath = "/".concat(encodeURIComponent(templateFileName));
      templateFileNameParameter = " filename=\"".concat(encodeURIComponent(templateFileName), "\"");
    }
    if (!hasUnsavedQuoteDocumentTemplate) {
      return coreMediator.getSingleUseToken().then(function (token) {
        return "/sectionTemplateDownload".concat(templateFileNamePath, "?sectionTemplateId=").concat(sectionTemplateId, "&t=").concat(encodeURIComponent(token), "&contentDisposition=inline;").concat(templateFileNameParameter);
      });
    } else {
      $q.resolve();
    }
  }
  $scope.onChange = function () {
    sectionTemplateEditorModel.setUnsavedPropertiesChanges($scope.viewModel.sectionTemplate.id, true);
    sectionTemplateEditorModel.setValid($scope.viewModel.sectionTemplate.id, isValid());
    $rootScope.$broadcast(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, $scope.viewModel.sectionTemplate.id);
  };
  function isValid(sectionTemplateId) {
    var result = false,
      // we need to always return something if the method is intended to return something
      hasName = !_.isEmpty($scope.viewModel.sectionTemplate.name),
      hasProductTemplates = !_.isNil($scope.viewModel.sectionTemplate.productTemplates),
      hasAdapterBeanName = !_.isEmpty($scope.viewModel.sectionTemplate.adapterBeanName),
      hasOrdinalNumber = !_.isNil($scope.viewModel.sectionTemplate.ordinalNumber);
    if (hasName && hasOrdinalNumber && hasProductTemplates && hasAdapterBeanName) {
      result = true;
    }
    return result;
  }
  ;
  $scope.onStageApplicabilitySelect = function () {
    translateStageApplicabilityToModel();
    $scope.onChange();
  };
  $scope.onSectionAdapterSelect = function () {
    translateSectionAdapterToModel();
    $scope.onChange();
  };
  $scope.openFileDialogBox = function () {
    if ($scope.viewModel.hasManagePermission) {
      $uibModal.open({
        templateUrl: '/configuration/uploadDocument/uploadDocumentModal.tpl.html',
        controller: 'uploadDocumentModalController',
        windowClass: 'uploadDocumentModal',
        resolve: {},
        keyboard: false,
        backdrop: 'static'
      });
    }
  };
  $scope.removeQuoteDocumentTemplate = function () {
    $scope.viewModel.quoteDocumentTemplateName = null;
    sectionTemplateEditorModel.setQuoteDocumentTemplateFile(parseInt($stateParams.sectionTemplateId), null);
    translateQuoteDocumentTemplateToModel();
    $scope.onChange();
  };
  $scope.onDocumentTemplateDownloadClick = function () {
    getQuoteDocumentTemplateDownloadUrl().then(function (url) {
      $window.open(url, '_blank');
    });
  };
  $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
    if ($scope.viewModel.productsMultiSelectName === itemName) {
      translateProductsToModel();
      $scope.onChange();
    }
  });
  $scope.$on(coreConstant.event.MULTI_SELECT_CLOSED, function (event, itemName) {
    if ($scope.viewModel.productsMultiSelectName === itemName) {
      $scope.viewModel.allProductsItem.selected = false;
    }
  });
  $scope.$on(coreConstant.event.FILE_UPLOADED, function (event, file) {
    $scope.viewModel.quoteDocumentTemplateName = file.name;
    sectionTemplateEditorModel.setQuoteDocumentTemplateFile(parseInt($stateParams.sectionTemplateId), file.uploadedFile);
    sectionTemplateEditorModel.setUnsavedQuoteDocumentTemplateFile(parseInt($stateParams.sectionTemplateId), true);
    translateQuoteDocumentTemplateToModel();
    $scope.onChange();
  });
  $scope.$on(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, function (event, sectionTemplateId) {
    if (parseInt($stateParams.sectionTemplateId) === sectionTemplateId) {
      loadModel();
    }
  });
  init();
};
SectionTemplatePropertiesController.$inject = ["$rootScope", "$scope", "$stateParams", "$q", "$uibModal", "$window", "currentUserModel", "authorizationConstants", "localization", "sectionTemplateApplicabilityType", "sectionTemplateStageApplicability", "dataSetUtil", "sectionTemplateEditorModel", "configurationConstant", "productTypes", "coreConstant", "coreMediator"];
angular.module('ums.configuration').controller('sectionTemplatePropertiesController', SectionTemplatePropertiesController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2638:
/***/ (function(module) {

module.exports = JSON.parse("{\"sectionTemplateProperties\":{\"labels\":{\"name\":\"Name\",\"description\":\"Description\",\"status\":{\"name\":\"Status\",\"active\":\"Active\",\"inactive\":\"Inactive\"},\"applicability\":{\"1\":\"Optional\",\"2\":\"Required\",\"3\":\"Default Selected\",\"11\":\"Conditional\",\"name\":\"Applicability\"},\"stageApplicability\":{\"0\":\"Proposal\",\"1\":\"Binder\",\"2\":\"Both\",\"name\":\"Stage Applicability\"},\"products\":\"Products\",\"ordering\":\"Ordering\",\"proposalBinderDetailsHeading\":\"Proposal/Binder Details\",\"includeInCombinedProposalBinder\":{\"name\":\"Include in combined Proposal/Binder\",\"yes\":\"Yes\",\"no\":\"No\"},\"formTemplate\":\"Form Template\",\"sectionAdapter\":\"Section Adapter\",\"quoteDocumentTemplate\":\"Quote Document Template\",\"allProductsItemLabel\":\"All Products\"},\"placeholders\":{\"name\":\"Section Template Name\",\"description\":\"Add a description\",\"applicability\":\"Select an Applicability\",\"stageApplicability\":\"Select a Stage Applicability\",\"formTemplate\":\"Select a Form Template\",\"sectionAdapter\":\"Select a Value\",\"products\":\"Select Products\",\"multipleProductsSelected\":\"Multiple Products Selected\",\"allProductsSelected\":\"All Products\",\"quoteDocumentTemplate\":\"Upload a File\"}}}");

/***/ }),

/***/ 2639:
/***/ (function(module, exports) {

var path = '/configuration/sectionTemplateEditor/content/properties/sectionTemplateProperties.tpl.html';
var html = "<div class=\"sectionTemplateProperties\">\n\n    <fieldset class=\"sectionTemplatePropertiesFieldSet\" ng-disabled=\"::!viewModel.hasManagePermission\">\n\n        <!-- General Properties -->\n        <div class=\"sectionTemplatePropertiesContent\">\n\n            <div class=\"requiredRow sectionTemplateName\">\n\n                <ui-required-indicator class=\"requiredIndicator\"\n                                       value=\"{{ viewModel.sectionTemplate.name }}\">\n                </ui-required-indicator>\n\n                <div class=\"rowLabel\">\n                    <span ui-translate>sectionTemplateProperties.labels.name</span>\n                </div>\n\n                <input class=\"textInput\"\n                       type=\"text\"\n                       ng-model=\"viewModel.sectionTemplate.name\"\n                       ng-change=\"onChange()\"\n                       ng-value=\"viewModel.sectionTemplate.name\"\n                       placeholder=\"{{ ::viewModel.placeholders.name }}\">\n            </div>\n\n            <div class=\"row sectionTemplateDescription\">\n\n                <div class=\"rowLabel\">\n                    <span ui-translate>sectionTemplateProperties.labels.description</span>\n                </div>\n\n                <textarea class=\"textArea\"\n                          ng-model=\"viewModel.sectionTemplate.description\"\n                          ng-change=\"onChange()\"\n                          ng-attr-placeholder=\"{{ ::viewModel.placeholders.description }}\"></textarea>\n            </div>\n\n            <div class=\"requiredRow sectionTemplateStatus\">\n\n                <ui-required-indicator class=\"requiredIndicator\"\n                                       value=\"{{ viewModel.sectionTemplate.active }}\">\n                </ui-required-indicator>\n\n                <div class=\"rowLabel\">\n                    <span ui-translate>sectionTemplateProperties.labels.status.name</span>\n                </div>\n\n                <div class=\"radioButtonGroup\">\n                    <input class=\"radioButton activeRadioButton\"\n                           type=\"radio\"\n                           ng-model=\"viewModel.sectionTemplate.active\"\n                           ng-value=\"true\"\n                           ng-change=\"onChange()\">\n                    <span class=\"radioButtonLabel\"\n                          ui-translate>sectionTemplateProperties.labels.status.active</span>\n                    <input class=\"radioButton inactiveRadioButton\"\n                           type=\"radio\"\n                           ng-model=\"viewModel.sectionTemplate.active\"\n                           ng-value=\"false\"\n                           ng-change=\"onChange()\">\n                    <span class=\"radioButtonLabel\"\n                          ui-translate>sectionTemplateProperties.labels.status.inactive</span>\n                </div>\n            </div>\n\n            <div class=\"requiredRow sectionTemplateApplicability\">\n\n                <ui-required-indicator class=\"requiredIndicator\"\n                                       value=\"{{ viewModel.sectionTemplate.applicability }}\">\n                </ui-required-indicator>\n\n                <div class=\"rowLabel\">\n                    <span ui-translate>sectionTemplateProperties.labels.applicability.name</span>\n                </div>\n\n                <ui-select class=\"dropdownFormComponent dropdownComponentSelect sectionTemplatePropertiesDropdown\"\n                           theme=\"select2\"\n                           ng-model=\"viewModel.sectionTemplate.applicability\"\n                           ng-change=\"onChange()\"\n                           append-to-body=\"true\"\n                           search-enabled=\"false\"\n                           ui-hide-select-on-scroll\n                           ui-hide-select-on-scroll-selector=\".sectionTemplateProperties\"\n                           ng-disabled=\"::!viewModel.hasManagePermission\">\n\n                    <ui-select-match placeholder=\"{{ ::viewModel.placeholders.applicability }}\">\n                        <span>{{ getApplicabilityLabel(viewModel.sectionTemplate.applicability) }}</span>\n                    </ui-select-match>\n\n                    <ui-select-choices repeat=\"item in viewModel.applicabilities track by $index\">\n                        <span>{{ getApplicabilityLabel(item) }}</span>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n\n            <div class=\"requiredRow sectionTemplateStageApplicability\">\n\n                <ui-required-indicator class=\"requiredIndicator\"\n                                       value=\"{{ viewModel.stageApplicability }}\">\n                </ui-required-indicator>\n\n                <div class=\"rowLabel\">\n                    <span ui-translate>sectionTemplateProperties.labels.stageApplicability.name</span>\n                </div>\n\n                <ui-select class=\"dropdownFormComponent dropdownComponentSelect sectionTemplatePropertiesDropdown\"\n                           theme=\"select2\"\n                           ng-model=\"viewModel.stageApplicability\"\n                           on-select=\"onStageApplicabilitySelect()\"\n                           append-to-body=\"true\"\n                           search-enabled=\"false\"\n                           ui-hide-select-on-scroll\n                           ui-hide-select-on-scroll-selector=\".sectionTemplateProperties\"\n                           ng-disabled=\"::!viewModel.hasManagePermission\">\n\n                    <ui-select-match placeholder=\"{{ ::viewModel.placeholders.stageApplicability }}\">\n                        <span>{{ viewModel.stageApplicability.name }}</span>\n                    </ui-select-match>\n\n                    <ui-select-choices repeat=\"item in viewModel.stageApplicabilities track by $index\">\n                        <span>{{ item.name }}</span>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n\n            <div class=\"requiredRow sectionTemplateProducts\">\n\n                <ui-required-indicator class=\"requiredIndicator\"\n                                       value=\"{{ viewModel.sectionTemplate.productTemplates }}\">\n                </ui-required-indicator>\n\n                <div class=\"rowLabel\">\n                    <span ui-translate>sectionTemplateProperties.labels.products</span>\n                </div>\n\n                <ui-multi-select items-list=\"viewModel.quotableProductTemplatesList\"\n                                 selected-value=\"viewModel.productTemplates\"\n                                 item-name=\"::viewModel.productsMultiSelectName\"\n                                 fixed-multiple-selection-button-label=\"::viewModel.placeholders.multipleProductsSelected\"\n                                 fixed-all-selected-button-label=\"::viewModel.placeholders.allProductsSelected\"\n                                 prompt-value=\"::viewModel.placeholders.products\"\n                                 is-disabled=\"::!viewModel.hasManagePermission\"\n                                 append-to-body=\"true\"\n                                 delimiter=\"::viewModel.productsDelimiter\"></ui-multi-select>\n            </div>\n\n            <div class=\"requiredRow sectionTemplateOrdering\">\n\n                <ui-required-indicator class=\"requiredIndicator\"\n                                       value=\"{{ viewModel.sectionTemplate.ordinalNumber }}\">\n                </ui-required-indicator>\n\n                <div class=\"rowLabel\">\n                    <span ui-translate>sectionTemplateProperties.labels.ordering</span>\n                </div>\n\n                <input class=\"textInput\"\n                       type=\"number\"\n                       ng-model=\"viewModel.sectionTemplate.ordinalNumber\"\n                       ng-change=\"onChange()\"\n                       ng-value=\"viewModel.sectionTemplate.ordinalNumber\">\n            </div>\n        </div>\n        <div class=\"separator\"></div>\n\n        <!-- Proposal/Binder Details -->\n        <div class=\"sectionTemplatePropertiesContent\">\n            <span class=\"headingText\" ui-translate>sectionTemplateProperties.labels.proposalBinderDetailsHeading</span>\n\n            <div class=\"row sectionTemplateIncludeInCombinedProposalBinder\">\n\n                <div class=\"rowLabel\">\n                    <span ui-translate>sectionTemplateProperties.labels.includeInCombinedProposalBinder.name</span>\n                </div>\n\n                <div class=\"radioButtonGroup\">\n                    <input class=\"radioButton\"\n                           type=\"radio\"\n                           ng-model=\"viewModel.sectionTemplate.stitchable\"\n                           ng-value=\"true\"\n                           ng-change=\"onChange()\">\n                    <span class=\"radioButtonLabel\"\n                          ui-translate>sectionTemplateProperties.labels.includeInCombinedProposalBinder.yes</span>\n                    <input class=\"radioButton\"\n                           type=\"radio\"\n                           ng-model=\"viewModel.sectionTemplate.stitchable\"\n                           ng-value=\"false\"\n                           ng-change=\"onChange()\">\n                    <span class=\"radioButtonLabel\"\n                          ui-translate>sectionTemplateProperties.labels.includeInCombinedProposalBinder.no</span>\n                </div>\n            </div>\n\n            <div class=\"row sectionTemplateFormTemplate\">\n\n                <div class=\"rowLabel\">\n                    <span ui-translate>sectionTemplateProperties.labels.formTemplate</span>\n                </div>\n\n                <ui-select class=\"dropdownFormComponent dropdownComponentSelect sectionTemplatePropertiesDropdown\"\n                           theme=\"select2\"\n                           ng-model=\"viewModel.sectionTemplate.formTemplateUniqueName\"\n                           ng-change=\"onChange()\"\n                           append-to-body=\"true\"\n                           ui-hide-select-on-scroll\n                           ui-hide-select-on-scroll-selector=\".sectionTemplateProperties\"\n                           ng-disabled=\"::!viewModel.hasManagePermission\">\n\n                    <ui-select-match placeholder=\"{{ ::viewModel.placeholders.formTemplate }}\"\n                                     allow-clear=\"true\">\n                        <span>{{ viewModel.sectionTemplate.formTemplateUniqueName }}</span>\n                    </ui-select-match>\n\n                    <ui-select-choices\n                        repeat=\"item in (viewModel.formTemplates | filter: $select.search) track by $index\">\n                        <span>{{ item }}</span>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n\n            <div class=\"requiredRow sectionTemplateSectionAdapter\">\n\n                <ui-required-indicator class=\"requiredIndicator\"\n                                       value=\"{{ viewModel.sectionAdapter }}\">\n                </ui-required-indicator>\n\n                <div class=\"rowLabel\">\n                    <span ui-translate>sectionTemplateProperties.labels.sectionAdapter</span>\n                </div>\n\n                <ui-select class=\"dropdownFormComponent dropdownComponentSelect sectionTemplatePropertiesDropdown sectionAdapterDropdown\"\n                           theme=\"select2\"\n                           ng-model=\"viewModel.sectionAdapter\"\n                           on-select=\"onSectionAdapterSelect()\"\n                           append-to-body=\"true\"\n                           ui-hide-select-on-scroll\n                           ui-hide-select-on-scroll-selector=\".sectionTemplateProperties\"\n                           ng-disabled=\"::!viewModel.hasManagePermission\">\n\n                    <ui-select-match placeholder=\"{{ ::viewModel.placeholders.sectionAdapter }}\">\n                        <span>{{ viewModel.sectionAdapter.name }}</span>\n                    </ui-select-match>\n\n                    <ui-select-choices\n                        repeat=\"item in (viewModel.sectionAdapters | filter: $select.search) track by $index\">\n                        <span>{{ item.name }}</span>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n\n            <div class=\"row sectionTemplateQuoteDocumentTemplate\">\n\n                <div class=\"rowLabel\">\n                    <span ui-translate>sectionTemplateProperties.labels.quoteDocumentTemplate</span>\n                </div>\n\n                <div class=\"quoteDocumentTemplateUploadButton\"\n                     ng-if=\"viewModel.displayQuoteDocumentTemplateUploadButton\">\n\n                    <button class=\"btn btn-primary\"\n                            ng-click=\"openFileDialogBox()\">\n                        {{ ::viewModel.placeholders.quoteDocumentTemplate }}\n                    </button>\n                </div>\n\n                <div class=\"quoteDocumentTemplate\"\n                     ng-if=\"viewModel.displayQuoteDocumentTemplate\">\n\n                    <span class=\"fileIcon glyphicon glyphicon-file\"></span>\n\n                    <div class=\"quoteDocumentTemplateLink\"\n                         ng-if=\"viewModel.displayQuoteDocumentTemplateLink\">\n                        <a ng-click=\"onDocumentTemplateDownloadClick()\">\n                            {{ viewModel.quoteDocumentTemplateName }}\n                        </a>\n                    </div>\n\n                    <div class=\"quoteDocumentTemplateName\"\n                         ng-if=\"!viewModel.displayQuoteDocumentTemplateLink\">\n                        {{ viewModel.quoteDocumentTemplateName }}\n                    </div>\n\n                    <span class=\"removeButton glyphicon glyphicon-remove\"\n                          ng-if=\"::viewModel.hasManagePermission\"\n                          ng-click=\"removeQuoteDocumentTemplate()\"></span>\n                </div>\n            </div>\n        </div>\n\n    </fieldset>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2640:
/***/ (function(module, exports) {

var SectionTemplateStageApplicability = {
  PROPOSAL: 0,
  BINDER: 1,
  BOTH: 2
};
angular.module('ums.configuration').constant('sectionTemplateStageApplicability', SectionTemplateStageApplicability);

/***/ }),

/***/ 2641:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2642);
__webpack_require__(2643);
__webpack_require__(2644);
var SectionTemplateEditorNavComponent = {
  templateUrl: '/configuration/sectionTemplateEditor/nav/sectionTemplateEditorNav.tpl.html',
  controller: 'sectionTemplateEditorNavController',
  bindings: {}
};
angular.module('ums.configuration').component('uiSectionTemplateEditorNav', SectionTemplateEditorNavComponent);

/***/ }),

/***/ 2642:
/***/ (function(module) {

module.exports = JSON.parse("{\"sectionTemplateEditorNav\":{\"properties\":\"Properties\",\"rule\":\"Rule\"}}");

/***/ }),

/***/ 2643:
/***/ (function(module, exports) {

var path = '/configuration/sectionTemplateEditor/nav/sectionTemplateEditorNav.tpl.html';
var html = "<button type=\"button\"\n        class=\"btn btn-link navButton\"\n        ui-sref=\"configuration.sectionTemplateEditor.properties\"\n        ng-class=\"{ active: $ctrl.isActive('configuration.sectionTemplateEditor.properties') }\">\n\n    <span ui-translate>sectionTemplateEditorNav.properties</span>\n</button>\n\n<button type=\"button\"\n        class=\"btn btn-link navButton rulesButton\"\n        ui-sref=\"configuration.sectionTemplateEditor.rule\"\n        ng-class=\"{ active: $ctrl.isActive('configuration.sectionTemplateEditor.rule') }\">\n\n    <span ui-translate>sectionTemplateEditorNav.rule</span>\n</button>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2644:
/***/ (function(module, exports) {

/*@ngInject*/
var SectionTemplateEditorNavController = function SectionTemplateEditorNavController($state, $element) {
  $element.addClass('sectionTemplateEditorNav');
  this.isActive = function (buttonName) {
    return $state.includes(buttonName);
  };
};
SectionTemplateEditorNavController.$inject = ["$state", "$element"];
angular.module('ums.configuration').controller('sectionTemplateEditorNavController', SectionTemplateEditorNavController);

/***/ }),

/***/ 2645:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2646);
__webpack_require__(2647);
__webpack_require__(2648);
__webpack_require__(2649);
__webpack_require__(2650);
__webpack_require__(2651);

/*@ngInject*/
var SystemPreferencesManagerController = function SystemPreferencesManagerController($rootScope, $scope, $state, authorizationConstants, configurationActionsUtil, configurationConstant, configurationMediator, coreConstant, currentUserModel, databaseDownloadSectionName, defaultPreferenceAction, defaultPreferencesType, loadingBarHandler, localization, modalUtil, navigationStateModel, systemPreferencesManagerModel, userMediator) {
  $scope.viewModel = {
    hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.MANAGE_BA_STUDIO_PREFERENCES),
    isLoading: true,
    originalSystemPreferences: [],
    systemPreferences: {},
    groupNames: [],
    isGridEmpty: true,
    searchString: '',
    searchDelayInMilliSeconds: 750
  };
  localization.getTranslationByKey('systemPreferencesManager').then(function (translations) {
    $scope.translations = translations;
    $scope.viewModel.searchStringPlaceholder = _.get(translations, 'searchStringPlaceholder');
    $scope.actions = [];
    $scope.context = {
      identifier: 'systemPreferencesManager',
      actions: {},
      fallthrough: null,
      model: {
        contextType: coreConstant.CONTEXT_NONE
      }
    };
    $scope.context.actions[coreConstant.CONTEXT_NONE] = '';
    function loadActions() {
      configurationMediator.loadSystemPreferencesManagerActions().then(function (actions) {
        var allActions = [];
        allActions.push({
          actions: actions.actions,
          contextType: $scope.context.model.contextType
        });
        $scope.processActions(allActions);
      });
    }
    $scope.processActions = function (actions) {
      $scope.actions = actions;
      $scope.actionSubTexts = {};
      _.each($scope.actions, function (subAction) {
        _.each(subAction.actions, function (action) {
          if (action.name === defaultPreferenceAction.SAVE) {
            action.enabled = false;
            if (systemPreferencesManagerModel.hasUnsavedChanges()) {
              $scope.actionSubTexts[action.name] = {
                class: 'unsavedChanges',
                text: _.get($scope.translations, 'unsavedChanges')
              };
              action.enabled = true;
            }
          }
          if (action.name === defaultPreferenceAction.DISCARD) {
            action.enabled = systemPreferencesManagerModel.hasUnsavedChanges();
          }
        });
      });
      $scope.actionsTimeLastModified = new Date().getTime();
    };
    function escapeHtml(htmlString) {
      return htmlString.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '\"').replace(/&#039;/g, '\'').replace(/&apos;/g, '\'');
    }
    function processPreferences(defaultPreferences) {
      $scope.viewModel.originalSystemPreferences = defaultPreferences;
      var processedSystemPreferences = _.cloneDeep(defaultPreferences);
      _.each(processedSystemPreferences, function (defaultPreference) {
        if (_.isNil(defaultPreference.category) || defaultPreference.category === "") {
          defaultPreference.category = 'Uncategorized';
        }
        defaultPreference.shortDescription = defaultPreference.shortDescription !== null ? escapeHtml(defaultPreference.shortDescription) : null;
        defaultPreference.completeDescription = defaultPreference.completeDescription !== null ? escapeHtml(defaultPreference.completeDescription) : null;
      });
      $scope.viewModel.systemPreferences = _.groupBy(_.sortBy(_.filter(processedSystemPreferences, function (defaultPreference) {
        var lowerSearchString = _.toLower($scope.viewModel.searchString);
        return _.toLower(defaultPreference.category).includes(lowerSearchString) || _.toLower(defaultPreference.name).includes(lowerSearchString) || _.toLower(defaultPreference.shortDescription).includes(lowerSearchString) || _.toLower(defaultPreference.completeDescription).includes(lowerSearchString);
      }), function (defaultPreference) {
        if (_.isNil(defaultPreference.shortDescription) || defaultPreference.shortDescription === "") {
          return defaultPreference.name;
        }
        return defaultPreference.shortDescription;
      }), 'category');
      $scope.viewModel.groupNames = _.uniq(_.map(_.filter(_.sortBy(processedSystemPreferences, 'category'), function (defaultPreference) {
        return $scope.viewModel.systemPreferences.hasOwnProperty(defaultPreference.category);
      }), 'category'));
      $scope.viewModel.isLoading = false;
      $scope.viewModel.isGridEmpty = _.isEmpty($scope.viewModel.systemPreferences);
    }
    function loadSystemPreferences() {
      $scope.viewModel.isLoading = true;
      userMediator.restoreViewState('configuration.systemPreferencesManager', $scope.viewModel);
      configurationMediator.getStudioPreferences().then(function (defaultPreferences) {
        systemPreferencesManagerModel.setSystemPreferences(defaultPreferences);
        processPreferences(defaultPreferences);
      });
    }
    $scope.onSearchStringChanged = function () {
      userMediator.saveViewState('configuration.systemPreferencesManager', {
        searchString: $scope.viewModel.searchString
      });
      loadSystemPreferences();
    };
    function resetNavigationState() {
      navigationStateModel.saveViewState('configuration.systemPreferencesManager', null);
    }
    $scope.handleAction = function (action, file) {
      if (action.enabled) {
        switch (action.name) {
          case defaultPreferenceAction.SAVE:
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'saveSystemPreferences.loadingBar'));
            configurationMediator.saveStudioPreferences(systemPreferencesManagerModel.getSystemPreferences()).then(function () {
              systemPreferencesManagerModel.setUnsavedChanges(false);
              $scope.processActions($scope.actions);
              loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'saveSystemPreferences.savingSystemPreferencesSuccessLoadingBar'));
            });
            break;
          case defaultPreferenceAction.DISCARD:
            modalUtil.showConfirmationModal(null, null, null, 'systemPreferencesManager.discardConfirmation', null, true, function () {
              $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'discardConfirmation.success'));
              systemPreferencesManagerModel.setUnsavedChanges(false);
              $state.reload();
            });
            break;
          case defaultPreferenceAction.BACKUP:
            configurationActionsUtil.backup(databaseDownloadSectionName.DEFAULT_PREFERENCES, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
            break;
          default:
            modalUtil.showActionNotImplementedModal(action.name);
            break;
        }
      }
    };
    $scope.$on(configurationConstant.event.SYSTEM_PREFERENCES_MANAGER_MODEL_UPDATED, function () {
      $scope.processActions($scope.actions);
    });
    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
      var isCurrentStateSystemPreferencesManager = _.startsWith(fromState.name, 'configuration.systemPreferencesManager'),
        isTargetSameAsCurrent = toState.name === fromState.name;
      if (toState.name === 'login') {
        return;
      }
      if (systemPreferencesManagerModel.hasUnsavedChanges() && isCurrentStateSystemPreferencesManager && !isTargetSameAsCurrent && systemPreferencesManagerModel.getSystemPreferences()) {
        event.preventDefault();
        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'saveSystemPreferences.loadingBar'));
        configurationMediator.saveStudioPreferences(systemPreferencesManagerModel.getSystemPreferences()).then(function () {
          systemPreferencesManagerModel.setUnsavedChanges(false);
          loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'saveSystemPreferences.savingSystemPreferencesSuccessLoadingBar'));
          $state.go(toState, toParams);
        });
      } else {
        if (isCurrentStateSystemPreferencesManager && isTargetSameAsCurrent && systemPreferencesManagerModel.hasUnsavedChanges()) {
          systemPreferencesManagerModel.setUnsavedChanges(false);
          $state.reload();
        }
      }
    });
    loadActions();
    loadSystemPreferences();
    resetNavigationState();
  });
};
SystemPreferencesManagerController.$inject = ["$rootScope", "$scope", "$state", "authorizationConstants", "configurationActionsUtil", "configurationConstant", "configurationMediator", "coreConstant", "currentUserModel", "databaseDownloadSectionName", "defaultPreferenceAction", "defaultPreferencesType", "loadingBarHandler", "localization", "modalUtil", "navigationStateModel", "systemPreferencesManagerModel", "userMediator"];
angular.module('ums.configuration').controller('systemPreferencesManagerController', SystemPreferencesManagerController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2646:
/***/ (function(module) {

module.exports = JSON.parse("{\"systemPreferencesManager\":{\"title\":\"Manage Preferences: General\",\"searchStringPlaceholder\":\"Search\",\"actions\":{\"name\":\"Actions\",\"discard\":\"Discard\",\"save\":\"Save\",\"backup\":\"Backup\"},\"backup\":{\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\",\"name\":\"Default Preferences\"},\"emptyGrid\":\"No matching Preferences\",\"saveSystemPreferences\":{\"loadingBar\":\"Saving system preferences\",\"savingSystemPreferencesSuccessLoadingBar\":\"Successfully saved system preferences\"},\"discardConfirmation\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"success\":\"Successfully discarded changes.\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"unsavedChanges\":\"Unsaved changes\"}}");

/***/ }),

/***/ 2647:
/***/ (function(module, exports) {

var path = '/configuration/systemPreferencesManager/systemPreferencesManager.tpl.html';
var html = "<div class=\"systemPreferencesManager\">\n\n    <!-- Header -->\n    <div class=\"header\">\n        <div class=\"headerContent\">\n            <div class=\"headerLabel\" ui-translate>systemPreferencesManager.title</div>\n\n            <action-buttons-bar context=\"context\"\n                                actions=\"actions\"\n                                action-sub-texts=\"actionSubTexts\"\n                                notify-action-clicked=\"handleAction(action, file)\"\n                                time-last-modified=\"actionsTimeLastModified\"></action-buttons-bar>\n        </div>\n    </div>\n\n    <!-- Tools -->\n    <div class=\"tools\">\n\n        <div class=\"toolsContent\">\n\n            <div class=\"searchStringInput\">\n                <span class=\"glyphicon glyphicon-search\"></span>\n                <input type=\"text\"\n                       ng-model=\"viewModel.searchString\"\n                       ng-model-options=\"{ debounce: viewModel.searchDelayInMilliSeconds }\"\n                       ng-change=\"onSearchStringChanged()\"\n                       placeholder=\"{{ ::viewModel.searchStringPlaceholder }}\"></div>\n        </div>\n    </div>\n\n    <div class=\"preferenceContainer\">\n        <div class=\"preferenceGroup\" ng-repeat=\"groupName in viewModel.groupNames\">\n            <div class=\"groupName\">{{ groupName }}</div>\n            <div class=\"preferenceRow\" ng-repeat=\"systemPreference in viewModel.systemPreferences[groupName]\">\n                <ui-system-preference system-preference=\"systemPreference\"\n                                      has-manage-permission=\"viewModel.hasManagePermission\">\n                </ui-system-preference>\n            </div>\n        </div>\n    </div>\n    <div class=\"gridEmpty\"\n         ng-if=\"viewModel.isGridEmpty && !viewModel.isLoading\">{{ ::translations.emptyGrid }}\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2648:
/***/ (function(module, exports) {

/*@ngInject*/
var SystemPreferencesManagerActionRepository = function SystemPreferencesManagerActionRepository(baseRepository, databaseDownloadSectionName, temporaryLoginTokenRepository) {
  angular.extend(this, baseRepository);
  this.loadActions = function () {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.user.DefaultPreferences:null'
        }
      };
    return this.get(url, config);
  };
  this.backupDefaultPreferences = function () {
    var _this = this;
    var url = '/database/DatabaseDownloadServlet',
      config = {
        params: {
          sectionName: databaseDownloadSectionName.DEFAULT_PREFERENCES
        }
      };
    return temporaryLoginTokenRepository.getSingleUseToken().then(function (token) {
      config.params.t = token;
      return _this.get(url, config);
    });
  };
};
SystemPreferencesManagerActionRepository.$inject = ["baseRepository", "databaseDownloadSectionName", "temporaryLoginTokenRepository"];
angular.module('ums.configuration').service('systemPreferencesManagerActionRepository', SystemPreferencesManagerActionRepository);

/***/ }),

/***/ 2649:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SystemPreferencesManagerModel = function SystemPreferencesManagerModel() {
  var systemPreferences = {},
    hasUnsavedChanges = false;
  this.getSystemPreferences = function () {
    return systemPreferences;
  };
  this.setSystemPreferences = function (value) {
    systemPreferences = value;
  };
  this.setSystemPreferenceValueByName = function (name, value) {
    var systemPreference = _.find(systemPreferences, {
      'name': name
    });
    var isChange = false;
    if (!_.isNil(systemPreference)) {
      isChange = systemPreference.value !== value;
      systemPreference.value = value;
    }
    if (isChange) {
      this.setUnsavedChanges(true);
    }
  };
  this.setUnsavedChanges = function (value) {
    hasUnsavedChanges = value;
  };
  this.hasUnsavedChanges = function () {
    return hasUnsavedChanges;
  };
};
angular.module('ums.configuration').service('systemPreferencesManagerModel', SystemPreferencesManagerModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2650:
/***/ (function(module, exports) {

/*@ngInject*/
var SystemPreferencesRepository = function SystemPreferencesRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getStudioPreferences = function () {
    var url = '/rest/DefaultPreference/studio',
      config = {};
    return this.get(url, config);
  };
  this.saveStudioPreferences = function (studioPreferences) {
    var url = '/rest/DefaultPreference/studio';
    var body = studioPreferences,
      config = {
        params: {}
      };
    return this.post(url, body, config);
  };
};
SystemPreferencesRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('systemPreferencesRepository', SystemPreferencesRepository);

/***/ }),

/***/ 2651:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2652);
__webpack_require__(2653);
__webpack_require__(2654);
var SystemPreferenceComponent = {
  templateUrl: '/configuration/systemPreferencesManager/systemPreference/systemPreference.tpl.html',
  controller: 'systemPreferenceController',
  bindings: {
    systemPreference: '<',
    hasManagePermission: '<'
  }
};
angular.module('ums.configuration').component('uiSystemPreference', SystemPreferenceComponent);

/***/ }),

/***/ 2652:
/***/ (function(module) {

module.exports = JSON.parse("{\"systemPreference\":{\"infoTooltipMessage\":\"{completeDescription}\\n\\nName: {name}\",\"numericValidationError\":\"This preference value must be numeric only.\"}}");

/***/ }),

/***/ 2653:
/***/ (function(module, exports) {

var path = '/configuration/systemPreferencesManager/systemPreference/systemPreference.tpl.html';
var html = "<div class=\"systemPreferenceContainer\"\n     ng-mouseover=\"$ctrl.showControls()\"\n     ng-mouseleave=\"$ctrl.hideControls()\">\n    <div class=\"leftSide\">\n        <div class=\"shortDescription\">{{ $ctrl.getShortDescription() }}</div>\n        <div ng-if=\"$ctrl.showDescription\"\n             class=\"glyphicon glyphicon-info-sign info-sign\"\n             uib-tooltip=\"{{ ::$ctrl.getTooltip() }}\"\n             tooltip-popup-delay=\"500\"\n             tooltip-append-to-body=\"true\"\n             tooltip-placement=\"auto\"></div>\n    </div>\n    <div class=\"rightSide\"\n         ng-class=\"{'dropdownActive': ($ctrl.isSingleSelect || $ctrl.isMultiSelect) && $ctrl.controlsVisible}\">\n        <div class=\"preferenceBoolean\"\n             ng-if=\"$ctrl.isCheckbox\">\n            <um-toggle-button class-name=\"{{::$ctrl.getSystemPreferenceUniqueClass()}}\"\n                              value=\"$ctrl.checkboxModel\"\n                              is-disabled=\"::!$ctrl.hasManagePermission\"\n                              on-change=\"$ctrl.handleToggleButtonClick(value)\"></um-toggle-button>\n        </div>\n        <div ng-if=\"!$ctrl.isCheckbox\">\n            <div class=\"preferenceValue\"\n                 ng-if=\"!$ctrl.controlsVisible\"\n                 tabindex=\"0\">\n                {{ $ctrl.systemPreference.value }}\n            </div>\n            <div ng-if=\"$ctrl.controlsVisible\">\n                <div ng-if=\"$ctrl.isString\">\n                    <input class=\"preferenceTextInput string {{::$ctrl.getSystemPreferenceUniqueClass()}}\"\n                           type=\"text\"\n                           ng-model=\"$ctrl.systemPreference.value\"\n                           ng-focus=\"$ctrl.freezeControls()\"\n                           ng-blur=\"$ctrl.handleTextInputChange()\"/>\n                </div>\n                <div ng-if=\"$ctrl.isNumeric\">\n                    <input class=\"preferenceTextInput numeric {{::$ctrl.getSystemPreferenceUniqueClass()}}\"\n                           type=\"number\"\n                           ng-model=\"$ctrl.numericModel\"\n                           ng-focus=\"$ctrl.freezeControls()\"\n                           ng-blur=\"$ctrl.handleTextInputChange()\"/>\n                </div>\n                <div ng-if=\"$ctrl.isSingleSelect\" class=\"preferenceDropdown singleSelectDropdown\">\n                    <um-dropdown class-name=\"{{::$ctrl.getSystemPreferenceUniqueClass()}}\"\n                                 required=\"'true'\"\n                                 option-list=\"$ctrl.preferenceOptions\"\n                                 selected-value=\"$ctrl.systemPreference.value\"\n                                 ng-click=\"$ctrl.freezeControls()\"\n                                 on-change=\"$ctrl.handleSelect(selectedOption)\"\n                                 on-close=\"$ctrl.handleDropdownClose()\">\n                    </um-dropdown>\n                </div>\n                <div ng-if=\"$ctrl.isMultiSelect\" class=\"preferenceDropdown multiSelectDropdown\">\n                    <ui-multi-select class-name=\"{{::$ctrl.getSystemPreferenceUniqueClass()}}\"\n                                     items-list=\"$ctrl.preferenceOptions\"\n                                     append-to-body=\"::true\"\n                                     selected-value=\"$ctrl.systemPreference.value\"\n                                     delimiter=\"::','\"\n                                     item-name=\"::$ctrl.getSystemPreferenceUniqueClass()\"\n                                     ng-click=\"$ctrl.freezeControls()\"></ui-multi-select>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2654:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SystemPreferenceController = function SystemPreferenceController($element, $scope, $rootScope, $stateParams, authorizationConstants, configurationConstant, coreConstant, coreMediator, currentUserModel, dataSetUtil, defaultPreferencesDataType, localization, systemPreferencesManagerModel) {
  var _this2 = this;
  $element.addClass('systemPreference');
  this.controlsVisible = false;
  this.controlsFrozen = false;
  this.valid = true;
  this.defaultPreferencesDataType = defaultPreferencesDataType;
  this.tooltip = null;
  this.errorTooltip = {};
  this.showDescription = false;
  this.isCheckbox = false;
  this.isString = false;
  this.isNumeric = false;
  this.isSingleSelect = false;
  this.isMultiSelect = false;
  this.checkboxModel = false;
  this.numericModel;
  this.hasManagePermission = false;
  this.$onInit = function () {
    var _this = this;
    this.isCheckbox = this.systemPreference.dataType === defaultPreferencesDataType.BOOLEAN;
    this.isSingleSelect = this.systemPreference.dataType === defaultPreferencesDataType.ENUM_SINGLE_SELECT;
    this.isMultiSelect = this.systemPreference.dataType === defaultPreferencesDataType.ENUM_MULTI_SELECT;
    this.isNumeric = this.systemPreference.dataType === defaultPreferencesDataType.NUMERIC;
    this.isString = this.systemPreference.dataType === defaultPreferencesDataType.STRING || _.isNil(this.systemPreference.dataType);
    this.hasManagePermission = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_BA_STUDIO_PREFERENCES);
    if (this.isCheckbox) {
      this.checkboxModel = this.systemPreference.value === 'true';
    } else if (this.isNumeric) {
      this.numericModel = parseFloat(this.systemPreference.value);
    } else if (this.isSingleSelect || this.isMultiSelect) {
      if (!_.isNil(this.systemPreference.dataSetName) && !_.isEmpty(this.systemPreference.dataSetName)) {
        dataSetUtil.getDataSet({
          name: this.systemPreference.dataSetName
        }).then(function (dataSet) {
          _this.preferenceOptions = dataSet.items;
        });
      }
    }
  };
  localization.getTranslationByKey('systemPreference').then(function (translations) {
    this.errorTooltip = {
      message: _.get(translations, 'numericValidationError'),
      type: 'errorPopover',
      delay: 500
    };
    this.getTooltip = function () {
      var message = _.get(translations, 'infoTooltipMessage');
      message = _.replace(_.replace(message, '{completeDescription}', this.systemPreference.completeDescription), '{name}', this.systemPreference.name);
      return message;
    };
  }.bind(this));
  this.getTooltip = function () {
    var message = '';
    if (!_.isNil(this.systemPreference.completeDescription) && this.systemPreference.completeDescription !== "") {
      message += this.systemPreference.completeDescription + '\n\n';
    }
    message += 'Name: ' + this.systemPreference.name;
    return message;
  };
  this.getShortDescription = function () {
    if (_.isNil(this.systemPreference.shortDescription) || this.systemPreference.shortDescription === "") {
      return this.systemPreference.name;
    }
    return this.systemPreference.shortDescription;
  };
  this.getSystemPreferenceUniqueClass = function () {
    var preferenceName = _.replace(this.systemPreference.name, /\./g, '-');
    return preferenceName;
  };
  this.handleToggleButtonClick = function (value) {
    this.checkboxModel = value;
    this.handleChange();
  };
  $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
    if (itemName === _this2.getSystemPreferenceUniqueClass()) {
      var selectedOptions = [];
      _.each(_this2.preferenceOptions, function (preferenceOption) {
        if (preferenceOption.selected) {
          selectedOptions.push(preferenceOption.value);
        }
      });
      var selectedValue = _.join(selectedOptions, ',');
      _this2.systemPreference.value = selectedValue;
      _this2.handleChange();
    }
  });
  $scope.$on(coreConstant.event.MULTI_SELECT_CLOSED, function (event, itemName) {
    if (itemName === _this2.getSystemPreferenceUniqueClass()) {
      _this2.unfreezeControls();
    }
  });
  this.handleSelect = function (selectedOption) {
    this.systemPreference.value = selectedOption.value;
    this.unfreezeControls();
    this.handleChange();
  };
  this.handleDropdownClose = function () {
    this.unfreezeControls();
  };
  this.handleChange = function () {
    if (this.isCheckbox) {
      this.systemPreference.value = this.checkboxModel.toString();
    } else if (this.isNumeric) {
      this.systemPreference.value = this.numericModel.toString();
    }
    systemPreferencesManagerModel.setSystemPreferenceValueByName(this.systemPreference.name, this.systemPreference.value);
    $rootScope.$broadcast(configurationConstant.event.SYSTEM_PREFERENCES_MANAGER_MODEL_UPDATED);
  };
  this.handleTextInputChange = function () {
    this.unfreezeControls();
    this.handleChange();
  };
  this.freezeControls = function () {
    this.controlsFrozen = true;
  };
  this.unfreezeControls = function () {
    this.controlsFrozen = false;
    this.hideControls();
  };
  this.showControls = function () {
    if (this.hasManagePermission) {
      this.controlsVisible = true;
    }
    this.showDescription = true;
  };
  this.hideControls = function () {
    if (!this.controlsFrozen) {
      this.controlsVisible = false;
    }
    this.showDescription = false;
  };
};
SystemPreferenceController.$inject = ["$element", "$scope", "$rootScope", "$stateParams", "authorizationConstants", "configurationConstant", "coreConstant", "coreMediator", "currentUserModel", "dataSetUtil", "defaultPreferencesDataType", "localization", "systemPreferencesManagerModel"];
angular.module('ums.configuration').controller('systemPreferenceController', SystemPreferenceController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2655:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2656);
__webpack_require__(2657);

/*@ngInject*/
var UploadDocumentModalController = function UploadDocumentModalController($rootScope, $scope, $timeout, coreConstant, localization, attachmentUtil) {
  var translations;
  localization.getTranslationsByKeys([this.translationsKey, 'uploadDocument']).then(function (result) {
    translations = result;
    $scope.viewModel = {
      title: translations.title,
      cancelButton: translations.cancelButton,
      uploadFileButton: translations.uploadFileButton,
      or: translations.or,
      dragAndDrop: translations.dragAndDrop,
      attachment: {},
      typeDataItems: null,
      uploadedFile: null,
      chooseFileString: translations.chooseFile,
      nameEditMode: false,
      editNameIconText: translations.editFilename
    };
    $scope.onCancel = function () {
      $scope.$dismiss();
    };
  });
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
    if (file) {
      storeUploadedFile(file);
    }
  });
  $scope.fileSelected = function (file) {
    if (file) {
      storeUploadedFile(file);
    }
  };
  function storeUploadedFile(uploadedFile) {
    var allowFile = attachmentUtil.validateAttachmentForUMStudio(uploadedFile, _.get(translations, 'unacceptableType'));
    if (allowFile) {
      $timeout(function () {
        $scope.viewModel.uploadedFile = uploadedFile;
        if (!$scope.viewModel.attachment) {
          $scope.viewModel.attachment = {};
        }
        $scope.viewModel.attachment.name = uploadedFile.name;
        $scope.viewModel.attachment.size = uploadedFile.size;
      }, 0);
    }
  }
  $scope.onUploadFileClicked = function () {
    $rootScope.$broadcast(coreConstant.event.FILE_UPLOADED, {
      uploadedFile: $scope.viewModel.uploadedFile,
      name: $scope.viewModel.attachment.name
    });
    $scope.$close();
  };
  $scope.canEnableConfirmButton = function () {
    return $scope.viewModel.attachment.name;
  };
  $scope.onUpdateField = function () {
    if ($scope.viewModel.attachment && $scope.viewModel.attachment.id) {
      $scope.updateAttachment($scope.viewModel.attachment);
    }
    $scope.viewModel.nameEditMode = false;
  };
  $scope.activateEditfilename = function () {
    $scope.viewModel.nameEditMode = true;
  };
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
UploadDocumentModalController.$inject = ["$rootScope", "$scope", "$timeout", "coreConstant", "localization", "attachmentUtil"];
angular.module('ums.configuration').controller('uploadDocumentModalController', UploadDocumentModalController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2656:
/***/ (function(module) {

module.exports = JSON.parse("{\"uploadDocument\":{\"cancelButton\":\"Cancel\",\"uploadFileButton\":\"Upload File\",\"title\":\"Upload Document\",\"chooseFile\":\"Choose File\",\"dragAndDrop\":\"Drag and Drop File Here\",\"or\":\"or\",\"unacceptableType\":{\"unacceptableTypeMessage\":\"File {name} is not a supported document type for upload.\",\"unacceptableTypeTitle\":\"Alert\",\"unacceptableTypeConfirmActionButtonLabel\":\"OK\"},\"editFilename\":\"Edit file name\"}}");

/***/ }),

/***/ 2657:
/***/ (function(module, exports) {

var path = '/configuration/uploadDocument/uploadDocumentModal.tpl.html';
var html = "<base-modal modal-title=\"viewModel.title\"\n            ok=\"viewModel.uploadFileButton\"\n            cancel=\"viewModel.cancelButton\"\n            is-confirm-disabled=\"!canEnableConfirmButton()\"\n            ok-button-class=\"okButtonClass\"\n            on-confirm=\"onUploadFileClicked()\"\n            on-cancel=\"onCancel()\"\n            class=\"uploadDocumentModal\">\n\n    <div class=\"dockPanelContent attachmentBox\" ui-browser-detection>\n        <!--Content-->\n        <div class=\"modal-body contentContainer\">\n            <div class=\"dockPanelInnerContent\">\n                <div class=\"dragDropBox\"\n                     ui-drop-zone\n                     file=\"{{::viewModel.uploadedFile}}\">\n                    <span>{{::viewModel.dragAndDrop}}</span>\n                    <span>{{::viewModel.or}}</span>\n                    <div>\n                        <input type=\"file\"\n                               class=\"btn btn-primary btn-sm hiddenFileInput\"\n                               name=\"' + scope.valueName + '_file\"\n                               ui-custom-on-change=\"fileSelected(file)\"/>\n                        <input type=\"button\"\n                               class=\"btn btn-primary btn-sm\"\n                               value=\"{{viewModel.chooseFileString}}\"/>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"dockPanelInnerContent narrow\"\n         ng-if=\"viewModel.attachment.id ||viewModel.attachment.size\">\n        <div class=\"dockPanelCellSide\">\n            <span class=\"glyphicon glyphicon-file\"></span>\n        </div>\n        <div class=\"dockPanelCellContent\">\n            <input\n                type=\"text\"\n                class=\"attachmentNameText\"\n                ng-if=\"viewModel.nameEditMode\"\n                ng-blur=\"onUpdateField()\"\n                ng-model=\"viewModel.attachment.name\"\n                ui-auto-focus=\"true\">\n\n            <a ng-if=\"!viewModel.nameEditMode\"\n               target=\"_blank\">\n                {{viewModel.attachment.name}}\n            </a>\n            <a ng-if=\"!viewModel.nameEditMode\"\n               uib-tooltip=\"{{::viewModel.editNameIconText}}\"\n               tooltip-append-to-body=\"true\"\n               class=\"attachmentEditName glyphicon glyphicon-pencil\"\n               ng-click=\"activateEditfilename()\"></a>\n        </div>\n    </div>\n</base-modal>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2658:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(2659);
__webpack_require__(2660);
__webpack_require__(2661);
__webpack_require__(2662);
var locale = __webpack_require__(2663);
var Promise = __webpack_require__(2664);

/*@ngInject*/
var FilesAndIconsManagerController = function FilesAndIconsManagerController($rootScope, $scope, $state, coreConstant, configurationMediator, configuredFileAction, modalUtil, filesAndIconsManagerModel, currentUserModel, authorizationConstants, configurationConstant, formatUtil, configurationActionsUtil, databaseDownloadSectionName, loadingBarHandler, attachmentUtil, preferenceModel) {
  var newCustomFileOrIconRowId = 0;
  $scope.i18n = locale.filesAndIconsManager;
  $scope.viewModel = {
    hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.MANAGE_CUSTOM_FILES_AND_ICONS),
    isLoading: true,
    filesAndIconsGroupings: [],
    customFilesAndIcons: [],
    controlsFrozen: false
  };
  $scope.actions = [];
  $scope.context = {
    identifier: 'filesAndIconsManager',
    actions: {},
    fallthrough: null,
    model: {
      contextType: coreConstant.CONTEXT_NONE
    }
  };
  $scope.context.actions[coreConstant.CONTEXT_NONE] = '';
  function init() {
    loadActions();
    loadConfiguredFiles();
  }
  function loadActions() {
    configurationMediator.loadFilesAndIconsManagerActions().then(function (actions) {
      var allActions = [];
      allActions.push({
        actions: actions.actions,
        contextType: $scope.context.model.contextType
      });
      processActions(allActions);
    });
  }
  function processActions(actions) {
    $scope.actions = actions;
    $scope.actionSubTexts = {};
    _.each($scope.actions, function (subAction) {
      _.each(subAction.actions, function (action) {
        if (action.name === configuredFileAction.SAVE) {
          action.enabled = false;
          if (filesAndIconsManagerModel.hasUnsavedChanges()) {
            $scope.actionSubTexts[action.name] = {
              class: 'unsavedChanges',
              text: _.get($scope.i18n, 'unsavedChanges')
            };
            if (allRequiredFieldsFilled()) {
              action.enabled = true;
            }
          }
        }
        if (action.name === configuredFileAction.DISCARD) {
          action.enabled = filesAndIconsManagerModel.hasUnsavedChanges();
        }
      });
    });
    $scope.actionsTimeLastModified = new Date().getTime();
  }
  function allRequiredFieldsFilled() {
    var allFilled = true;
    _.each(filesAndIconsManagerModel.getModifiedFileOrIcons(), function (modifiedFileOrIcon) {
      if (_.isNil(modifiedFileOrIcon.name) || _.isNil(modifiedFileOrIcon.fileName) && !modifiedFileOrIcon.required) {
        allFilled = false;
        return false;
      }
    });
    return allFilled;
  }
  function loadConfiguredFiles() {
    $scope.viewModel.isLoading = true;
    configurationMediator.getConfiguredFiles().then(function (configuredFiles) {
      filesAndIconsManagerModel.setConfiguredFiles(configuredFiles);
      processConfiguredFiles(configuredFiles);
    }).finally(function () {
      $scope.viewModel.isLoading = false;
    });
  }
  function processConfiguredFiles(configuredFiles) {
    var processedConfiguredFiles = _.cloneDeep(configuredFiles);
    $scope.viewModel.filesAndIconsGroupings = [];
    $scope.viewModel.customFilesAndIcons = [];
    var filesAndIconsMap = {};
    _.each(processedConfiguredFiles, function (configuredFile) {
      if (_.isEmpty(configuredFile.grouping)) {
        configuredFile.rowId = newCustomFileOrIconRowId++;
        $scope.viewModel.customFilesAndIcons.push(configuredFile);
      } else if (configuredFile.required) {
        if (!_.has(filesAndIconsMap, configuredFile.grouping)) {
          filesAndIconsMap[configuredFile.grouping] = [];
        }
        configuredFile.name = _.get($scope.i18n, "fileOrIconNames.".concat(configuredFile.name)) || configuredFile.name;
        filesAndIconsMap[configuredFile.grouping].push(configuredFile);
      }
    });
    _.forOwn(filesAndIconsMap, function (filesAndIcons, grouping) {
      filesAndIconsMap[grouping] = _.sortBy(filesAndIcons, 'name');
    });
    var groupings = _.sortBy(_.keys(filesAndIconsMap));
    _.each(groupings, function (grouping) {
      $scope.viewModel.filesAndIconsGroupings.push({
        grouping: _.get($scope.i18n, "groupingNames.".concat(grouping)) || grouping,
        filesAndIcons: filesAndIconsMap[grouping]
      });
    });
    $scope.viewModel.customFilesAndIcons = _.sortBy($scope.viewModel.customFilesAndIcons, 'id');
    $scope.addNewCustomFilesAndIconsRow();
  }
  $scope.handleAction = function (action, file) {
    if (action.enabled) {
      switch (action.name) {
        case configuredFileAction.SAVE:
          loadingBarHandler.showNotificationLoadingBar(_.get($scope.i18n, 'saveFilesAndIcons.loadingBar'));
          saveModifiedFileOrIcons(filesAndIconsManagerModel.getModifiedFileOrIcons()).then(function () {
            if (_.isEmpty(filesAndIconsManagerModel.getModifiedFileOrIcons())) {
              filesAndIconsManagerModel.setUnsavedChanges(false);
            }
            processActions($scope.actions);
            loadingBarHandler.concludeNotificationLoadingBar(_.get($scope.i18n, 'saveFilesAndIcons.savingSystemPreferencesSuccessLoadingBar'));
          });
          break;
        case configuredFileAction.DISCARD:
          modalUtil.showConfirmationModal(null, null, null, 'filesAndIconsManager.discardConfirmation', null, true, function () {
            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get($scope.i18n, 'discardConfirmation.success'));
            filesAndIconsManagerModel.setUnsavedChanges(false);
            filesAndIconsManagerModel.resetModifiedFileOrIcons();
            $state.reload();
          });
          break;
        case configuredFileAction.BACKUP:
          configurationActionsUtil.backup(databaseDownloadSectionName.FILES_AND_ICONS, $scope.i18n.backup.name, $scope.i18n.backup.loadingBar, $scope.i18n.backup.successMessage);
          break;
        default:
          modalUtil.showActionNotImplementedModal(action.name);
          break;
      }
    }
  };
  $scope.showControls = function (fileOrIcon) {
    if ($scope.viewModel.hasManagePermission) {
      fileOrIcon.controlsVisible = true;
    }
    fileOrIcon.showDescription = !_.isEmpty(fileOrIcon.description);
  };
  $scope.hideControls = function (fileOrIcon) {
    if (!fileOrIcon.controlsFrozen) {
      fileOrIcon.controlsVisible = false;
    }
    fileOrIcon.showDescription = false;
  };
  $scope.getClassName = function (item) {
    return formatUtil.formatAsSelector(item);
  };
  $scope.onCustomFileOrIconNameChange = function (customFileOrIcon) {
    addModifiedFileOrIcon(customFileOrIcon);
    checkForAddingNewCustomFileOrIconRow(customFileOrIcon);
  };
  $scope.onCustomFileOrIconDescriptionChange = function (customFileOrIcon) {
    addModifiedFileOrIcon(customFileOrIcon);
    checkForAddingNewCustomFileOrIconRow(customFileOrIcon);
  };
  $scope.onCustomFileOrIconIsCarrierOnlyChange = function (customFileOrIcon) {
    addModifiedFileOrIcon(customFileOrIcon);
    checkForAddingNewCustomFileOrIconRow(customFileOrIcon);
  };
  $scope.onFileOrIconDataFileSelected = function (file, fileOrIcon) {
    var acceptedTypes = preferenceModel.get('system.allowedFilesAndIconsTypes').split('::');
    var allowFile = attachmentUtil.validateAttachmentType(file, _.get($scope.i18n, 'unacceptableType'), acceptedTypes, null);
    if (allowFile) {
      fileOrIcon.fileName = file.name;
      fileOrIcon.file = file;
      addModifiedFileOrIcon(fileOrIcon);
      checkForAddingNewCustomFileOrIconRow(fileOrIcon);
    }
  };
  $scope.onFileOrIconDataFileDeleted = function (fileOrIcon) {
    fileOrIcon.fileName = null;
    fileOrIcon.file = null;
    addModifiedFileOrIcon(fileOrIcon);
  };
  $scope.onCustomFileOrIconRowDeleted = function (customFileOrIcon) {
    _.remove($scope.viewModel.customFilesAndIcons, function (item) {
      return item.rowId === customFileOrIcon.rowId;
    });
    if (!_.isNil(customFileOrIcon.id)) {
      customFileOrIcon.isDelete = true;
      addModifiedFileOrIcon(customFileOrIcon);
    } else {
      filesAndIconsManagerModel.removeFromModifiedFileOrIcons(customFileOrIcon);
    }
    filesAndIconsManagerModel.setUnsavedChanges(true);
    $scope.$broadcast(configurationConstant.event.FILES_AND_ICONS_MANAGER_MODEL_UPDATED);
  };
  $scope.isModified = function (fileOrIcon) {
    var index = findElementIndexByIdOrRowId(filesAndIconsManagerModel.getModifiedFileOrIcons(), fileOrIcon.id, fileOrIcon.rowId);
    return !_.isNil(index) && index >= 0;
  };
  function addModifiedFileOrIcon(modifiedFileOrIcon) {
    var existingModifiedFileOrIconIndex = findElementIndexByIdOrRowId(filesAndIconsManagerModel.getModifiedFileOrIcons(), modifiedFileOrIcon.id, modifiedFileOrIcon.rowId);
    if (_.isNil(existingModifiedFileOrIconIndex) || existingModifiedFileOrIconIndex === -1) {
      filesAndIconsManagerModel.addToModifiedFileOrIcons(modifiedFileOrIcon);
    }
    filesAndIconsManagerModel.setUnsavedChanges(true);
    $scope.$broadcast(configurationConstant.event.FILES_AND_ICONS_MANAGER_MODEL_UPDATED);
  }
  function findElementIndexByIdOrRowId(fileOrIconsArray, fileOrIconId, rowId) {
    return _.findIndex(fileOrIconsArray, function (item) {
      if (!_.isNil(item.id) && !_.isNil(fileOrIconId)) {
        return item.id === fileOrIconId;
      } else if (!_.isNil(item.rowId) && !_.isNil(rowId)) {
        return item.rowId === rowId;
      }
    });
  }
  function saveModifiedFileOrIcons(modifiedFileOrIcons) {
    var saveFileOrIconPromises = [];
    _.each(modifiedFileOrIcons, function (modifiedFileOrIcon) {
      var saveFileOrIconPromise;
      if (modifiedFileOrIcon.isDelete) {
        saveFileOrIconPromise = function saveFileOrIconPromise() {
          return configurationMediator.deleteConfiguredFile(modifiedFileOrIcon.id).then(function () {
            filesAndIconsManagerModel.removeFromModifiedFileOrIcons(modifiedFileOrIcon);
          });
        };
      } else {
        saveFileOrIconPromise = function saveFileOrIconPromise() {
          return configurationMediator.saveConfiguredFile(modifiedFileOrIcon).then(function (responseEntity) {
            filesAndIconsManagerModel.removeFromModifiedFileOrIcons(modifiedFileOrIcon);
            updateCustomFileOrIconWithResponseEntityData(modifiedFileOrIcon.rowId, responseEntity);
          });
        };
      }
      saveFileOrIconPromises.push(saveFileOrIconPromise);
    });
    return Promise.mapSeries(saveFileOrIconPromises, function (saveFileOrIconPromise) {
      return saveFileOrIconPromise();
    });
  }
  function updateCustomFileOrIconWithResponseEntityData(rowId, savedCustomFileOrIcon) {
    var index = findElementIndexByIdOrRowId($scope.viewModel.customFilesAndIcons, savedCustomFileOrIcon.id, rowId);
    if (!_.isNil(index) && index >= 0) {
      $scope.viewModel.customFilesAndIcons[index] = savedCustomFileOrIcon;
    }
  }
  function checkForAddingNewCustomFileOrIconRow(customFileOrIcon) {
    if (customFileOrIcon.newRow) {
      customFileOrIcon.newRow = false;
      $scope.addNewCustomFilesAndIconsRow();
    }
  }
  $scope.addNewCustomFilesAndIconsRow = function () {
    $scope.viewModel.customFilesAndIcons.push({
      newRow: true,
      rowId: newCustomFileOrIconRowId++
    });
  };
  $scope.freezeControls = function (fileOrIcon) {
    fileOrIcon.controlsFrozen = true;
  };
  $scope.unfreezeControls = function (fileOrIcon) {
    fileOrIcon.controlsFrozen = false;
    $scope.hideControls(fileOrIcon);
  };
  $scope.$on(configurationConstant.event.FILES_AND_ICONS_MANAGER_MODEL_UPDATED, function () {
    processActions($scope.actions);
  });
  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    var isCurrentStateFilesAndIconsPreferencesManager = _.startsWith(fromState.name, 'configuration.filesAndIconsManager'),
      isTargetSameAsCurrent = toState.name === fromState.name;
    if (toState.name === 'login') {
      return;
    }
    if (filesAndIconsManagerModel.hasUnsavedChanges() && isCurrentStateFilesAndIconsPreferencesManager && !isTargetSameAsCurrent && filesAndIconsManagerModel.getModifiedFileOrIcons()) {
      event.preventDefault();
      if (allRequiredFieldsFilled()) {
        loadingBarHandler.showNotificationLoadingBar(_.get($scope.i18n, 'saveFilesAndIcons.loadingBar'));
        saveModifiedFileOrIcons(filesAndIconsManagerModel.getModifiedFileOrIcons()).then(function () {
          if (_.isEmpty(filesAndIconsManagerModel.getModifiedFileOrIcons())) {
            filesAndIconsManagerModel.setUnsavedChanges(false);
            filesAndIconsManagerModel.resetModifiedFileOrIcons();
            $state.go(toState, toParams);
          }
          loadingBarHandler.concludeNotificationLoadingBar(_.get($scope.i18n, 'saveFilesAndIcons.savingSystemPreferencesSuccessLoadingBar'));
        });
      } else {
        modalUtil.showConfirmationModal(null, null, null, 'filesAndIconsManager.autoSaveRequiredFields', null, true, function () {
          $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get($scope.i18n, 'discardConfirmation.success'));
          filesAndIconsManagerModel.setUnsavedChanges(false);
          filesAndIconsManagerModel.resetModifiedFileOrIcons();
          $state.go(toState, toParams);
        });
      }
    } else {
      if (isCurrentStateFilesAndIconsPreferencesManager && isTargetSameAsCurrent && filesAndIconsManagerModel.hasUnsavedChanges()) {
        filesAndIconsManagerModel.setUnsavedChanges(false);
        $state.reload();
      }
    }
  });
  init();
};
FilesAndIconsManagerController.$inject = ["$rootScope", "$scope", "$state", "coreConstant", "configurationMediator", "configuredFileAction", "modalUtil", "filesAndIconsManagerModel", "currentUserModel", "authorizationConstants", "configurationConstant", "formatUtil", "configurationActionsUtil", "databaseDownloadSectionName", "loadingBarHandler", "attachmentUtil", "preferenceModel"];
angular.module('ums.configuration').controller('filesAndIconsManagerController', FilesAndIconsManagerController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2659:
/***/ (function(module, exports, __webpack_require__) {

var path = '/configuration/filesAndIconsManager/filesAndIconsManager.tpl.html';
var html = "<div class=\"filesAndIconsManager\">\n\n    <!-- Header -->\n    <div class=\"header\">\n\n        <div class=\"headerContent\">\n\n            <div class=\"headerLabel\">{{ ::i18n.title }}</div>\n\n            <action-buttons-bar context=\"context\"\n                                actions=\"actions\"\n                                action-sub-texts=\"actionSubTexts\"\n                                notify-action-clicked=\"handleAction(action, file)\"\n                                time-last-modified=\"actionsTimeLastModified\"></action-buttons-bar>\n        </div>\n    </div>\n\n    <div class=\"allFilesAndIconsContainer\">\n\n        <div class=\"filesAndIconsContainer\">\n\n            <div ng-repeat=\"filesAndIconsGrouping in viewModel.filesAndIconsGroupings\"\n                 class=\"filesAndIconsGrouping {{ ::getClassName(filesAndIconsGrouping.grouping) }}\">\n\n                <div class=\"filesAndIconsLabel\">{{ ::filesAndIconsGrouping.grouping }}</div>\n\n                <div class=\"fileOrIconRowContainer\"\n                     ng-repeat=\"fileOrIcon in filesAndIconsGrouping.filesAndIcons\">\n\n                    <div class=\"fileOrIconRow {{ ::getClassName(fileOrIcon.name) }}\"\n                         ng-mouseover=\"showControls(fileOrIcon)\"\n                         ng-mouseleave=\"hideControls(fileOrIcon)\">\n\n                        <div class=\"leftSide\">\n\n                            <div class=\"fileOrIconName\">{{ ::fileOrIcon.name }}</div>\n\n                            <div ng-if=\"fileOrIcon.showDescription\"\n                                 class=\"glyphicon glyphicon-info-sign info-sign\"\n                                 uib-tooltip=\"{{ ::fileOrIcon.description }}\"\n                                 tooltip-popup-delay=\"500\"\n                                 tooltip-append-to-body=\"true\"\n                                 tooltip-placement=\"auto\"></div>\n                        </div>\n\n                        <div class=\"rightSide\">\n\n                            <input type=\"file\"\n                                   class=\"hiddenUpload {{ ::getClassName(fileOrIcon.name) }}\"\n                                   ui-custom-on-change=\"onFileOrIconDataFileSelected(file, fileOrIcon)\"/>\n\n                            <div class=\"fileOrIconDataContainer\"\n                                 ng-class=\"{ 'controlsVisible': fileOrIcon.controlsVisible }\"\n                                 ui-upload>\n\n                                <div class=\"fileOrIconData\">\n\n                                    <div ng-if=\"fileOrIcon.fileName\"\n                                         class=\"fa fa-file-image-o\"></div>\n\n                                    <div ng-if=\"fileOrIcon.fileName\"\n                                         class=\"fileOrIconsDataLabel {{ ::getClassName(fileOrIcon.name) }}\">{{ fileOrIcon.fileName }}</div>\n\n                                    <div ng-if=\"!fileOrIcon.fileName\"\n                                         class=\"fileOrIconsDataLabel noFile\">{{ ::i18n.noFile }}</div>\n\n                                    <div ng-if=\"fileOrIcon.controlsVisible\"\n                                         class=\"fa fa-upload\"></div>\n                                </div>\n                            </div>\n\n                            <div ng-if=\"fileOrIcon.fileName && fileOrIcon.controlsVisible\"\n                                 class=\"fa fa-trash-o {{ ::getClassName(fileOrIcon.name) }}Delete\"\n                                 ng-click=\"onFileOrIconDataFileDeleted(fileOrIcon)\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"customFilesAndIconsContainer\">\n\n            <div class=\"filesAndIconsGrouping\">\n\n                <div class=\"filesAndIconsLabel customFilesAndIcons\">{{ ::i18n.customFilesAndIconsLabel }}</div>\n\n                <div class=\"customFilesAndIconsHeader\">\n\n                    <div class=\"customFilesAndIconsHeaderColumn customFilesAndIconsHeaderColumnName\">{{ ::i18n.customFilesAndIconsHeaderColumns.name }}</div>\n\n                    <div class=\"customFilesAndIconsHeaderColumn customFilesAndIconsHeaderColumnDescription\">{{ ::i18n.customFilesAndIconsHeaderColumns.description }}</div>\n\n                    <div class=\"customFilesAndIconsHeaderColumn customFilesAndIconsHeaderColumnCarrierOnly\">{{ ::i18n.customFilesAndIconsHeaderColumns.carrierOnly }}</div>\n\n                    <div class=\"customFilesAndIconsHeaderColumn customFilesAndIconsHeaderColumnFile\">{{ ::i18n.customFilesAndIconsHeaderColumns.file }}</div>\n                </div>\n\n                <div class=\"fileOrIconRowContainer customFileOrIcon\"\n                     ng-repeat=\"customFileOrIcon in viewModel.customFilesAndIcons\">\n\n                    <div class=\"fileOrIconRow {{ getClassName(customFileOrIcon.name) }}\"\n                         ng-mouseover=\"showControls(customFileOrIcon)\"\n                         ng-mouseleave=\"hideControls(customFileOrIcon)\">\n\n                        <div class=\"leftSide customFileOrIcon\">\n                            <ui-required-indicator class=\"requiredIndicator\"\n                                                   ng-if=\"isModified(customFileOrIcon)\"\n                                                   value=\"{{customFileOrIcon.name}}\">\n                            </ui-required-indicator>\n\n                            <input type=\"text\"\n                                   class=\"customFileOrIconName {{ ::getClassName(customFileOrIcon.name) }}Name\"\n                                   ng-class=\"{ 'controlsVisible': customFileOrIcon.controlsVisible }\"\n                                   ng-focus=\"freezeControls(customFileOrIcon)\"\n                                   ng-blur=\"unfreezeControls(customFileOrIcon)\"\n                                   ng-change=\"onCustomFileOrIconNameChange(customFileOrIcon)\"\n                                   ng-model=\"customFileOrIcon.name\"\n                                   placeholder=\"{{ customFileOrIcon.newRow ? i18n.newRowName : '' }}\"\n                                   tabindex=\"{{ $index + 1 }}\"/>\n                        </div>\n\n                        <div class=\"customFileOrIconDescriptionContainer\">\n\n                            <input type=\"text\"\n                                   class=\"customFileOrIconDescription {{ getClassName(customFileOrIcon.name) }}\"\n                                   ng-class=\"{ 'controlsVisible': customFileOrIcon.controlsVisible }\"\n                                   ng-focus=\"freezeControls(customFileOrIcon)\"\n                                   ng-blur=\"unfreezeControls(customFileOrIcon)\"\n                                   ng-change=\"onCustomFileOrIconDescriptionChange(customFileOrIcon)\"\n                                   ng-model=\"customFileOrIcon.description\"\n                                   tabindex=\"{{ $index + 2}}\"/>\n                        </div>\n\n                        <div class=\"rightSide\">\n\n                            <div class=\"customFileOrIconCarrierOnlyContainer\">\n                                <input type=\"checkbox\"\n                                       class=\"customFileOrIconCarrierOnly {{ getClassName(customFileOrIcon.carrierOnly) }}\"\n                                       ng-class=\"{ 'controlsVisible': customFileOrIcon.controlsVisible }\"\n                                       ng-focus=\"freezeControls(customFileOrIcon)\"\n                                       ng-blur=\"unfreezeControls(customFileOrIcon)\"\n                                       ng-change=\"onCustomFileOrIconIsCarrierOnlyChange(customFileOrIcon)\"\n                                       ng-model=\"customFileOrIcon.carrierOnly\"\n                                       tabindex=\"{{ $index + 3}}\"/>\n                            </div>\n\n                            <input type=\"file\"\n                                   class=\"hiddenUpload {{ getClassName(customFileOrIcon.name) }}\"\n                                   ui-custom-on-change=\"onFileOrIconDataFileSelected(file, customFileOrIcon)\"/>\n\n                            <ui-required-indicator class=\"requiredIndicator\"\n                                                   ng-if=\"isModified(customFileOrIcon)\"\n                                                   value=\"{{customFileOrIcon.fileName}}\">\n                            </ui-required-indicator>\n\n                            <div class=\"fileOrIconDataContainer\"\n                                 ng-class=\"{ 'controlsVisible': customFileOrIcon.controlsVisible }\"\n                                 ui-upload>\n\n                                <div class=\"fileOrIconData\">\n\n                                    <div ng-if=\"customFileOrIcon.fileName\"\n                                         class=\"fa fa-file-image-o\"></div>\n\n                                    <div ng-if=\"customFileOrIcon.fileName\"\n                                         class=\"fileOrIconsDataLabel {{ getClassName(customFileOrIcon.name) }}\">{{ customFileOrIcon.fileName }}</div>\n\n                                    <div ng-if=\"!customFileOrIcon.fileName && (!customFileOrIcon.newRow || customFileOrIcon.controlsVisible)\"\n                                         class=\"fileOrIconsDataLabel noFile\">{{ ::i18n.noFile }}</div>\n\n                                    <div ng-if=\"customFileOrIcon.controlsVisible\"\n                                         class=\"fa fa-upload\"></div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div ng-if=\"customFileOrIcon.controlsVisible && !customFileOrIcon.newRow\"\n                             class=\"customFileOrIconDelete\">\n\n                            <div class=\"fa fa-trash-o {{ getClassName(customFileOrIcon.name) }}Delete\"\n                                 ng-click=\"onCustomFileOrIconRowDeleted(customFileOrIcon)\"></div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"icon-spinner\"\n         ng-if=\"viewModel.isLoading\">\n        <img src=\"" + __webpack_require__(52) + "\"/>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 2660:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FilesAndIconsManagerModel = function FilesAndIconsManagerModel() {
  var configuredFiles = {},
    hasUnsavedChanges = false,
    modifiedFileOrIcons = [];
  this.getConfiguredFiles = function () {
    return configuredFiles;
  };
  this.setConfiguredFiles = function (value) {
    configuredFiles = value;
  };
  this.setUnsavedChanges = function (value) {
    hasUnsavedChanges = value;
  };
  this.hasUnsavedChanges = function () {
    return hasUnsavedChanges;
  };
  this.getModifiedFileOrIcons = function () {
    return modifiedFileOrIcons;
  };
  this.addToModifiedFileOrIcons = function (modifiedFileOrIcon) {
    modifiedFileOrIcons.push(modifiedFileOrIcon);
  };
  this.removeFromModifiedFileOrIcons = function (modifiedFileOrIcon) {
    _.remove(modifiedFileOrIcons, function (item) {
      return item.id === modifiedFileOrIcon.id || item.rowId === modifiedFileOrIcon.rowId;
    });
  };
  this.resetModifiedFileOrIcons = function () {
    modifiedFileOrIcons = [];
  };
};
angular.module('ums.configuration').service('filesAndIconsManagerModel', FilesAndIconsManagerModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2661:
/***/ (function(module, exports) {

/*@ngInject*/
var FilesAndIconsManagerActionRepository = function FilesAndIconsManagerActionRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.loadActions = function () {
    var url = '/rest/Actions',
      config = {
        params: {
          uri: 'com.firstbest.configuredfile.ConfiguredFile:null'
        }
      };
    return this.get(url, config);
  };
};
FilesAndIconsManagerActionRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('filesAndIconsManagerActionRepository', FilesAndIconsManagerActionRepository);

/***/ }),

/***/ 2662:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var FilesAndIconsManagerRepository = function FilesAndIconsManagerRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getConfiguredFiles = function () {
    var url = '/rest/ConfiguredFile/List';
    return this.get(url);
  };
  this.saveConfiguredFile = function (configuredFile) {
    var url = this.buildSaveOrUpdateUrl(configuredFile.id);
    var formData = new FormData(),
      config = {
        transformRequest: angular.identity,
        headers: {
          'Content-Type': undefined
        },
        params: {
          name: configuredFile.name,
          description: configuredFile.description,
          carrierOnly: configuredFile.carrierOnly,
          grouping: configuredFile.grouping,
          required: configuredFile.required,
          fileName: configuredFile.fileName,
          fileSize: !_.isNil(configuredFile.file) ? configuredFile.file.size : null
        }
      };
    formData.append('data', configuredFile.file);
    return this.post(url, formData, config);
  };
  this.buildSaveOrUpdateUrl = function (configureFileId) {
    return _.isNil(configureFileId) ? '/rest/ConfiguredFile' : '/rest/ConfiguredFile/' + configureFileId;
  };
  this.deleteConfiguredFile = function (configuredFileId) {
    var url = '/rest/ConfiguredFile/' + configuredFileId;
    return this.delete(url);
  };
};
FilesAndIconsManagerRepository.$inject = ["baseRepository"];
angular.module('ums.configuration').service('filesAndIconsManagerRepository', FilesAndIconsManagerRepository);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2663:
/***/ (function(module) {

module.exports = JSON.parse("{\"filesAndIconsManager\":{\"title\":\"Manage Preferences: Files & Icons\",\"unsavedChanges\":\"Unsaved changes\",\"actions\":{\"name\":\"Actions\",\"save\":\"Save\",\"discard\":\"Discard\",\"backup\":\"Backup\"},\"backup\":{\"loadingBar\":\"Backing up\",\"successMessage\":\"Successfully backed up\",\"name\":\"Files & Icons\"},\"noFile\":\"none\",\"customFilesAndIconsLabel\":\"Custom File Configuration\",\"customFilesAndIconsHeaderColumns\":{\"name\":\"Name\",\"description\":\"Description\",\"carrierOnly\":\"Carrier Only\",\"file\":\"File\"},\"saveFilesAndIcons\":{\"loadingBar\":\"Saving Files & Icons preferences\",\"savingSystemPreferencesSuccessLoadingBar\":\"Successfully saved Files & Icons preferences\"},\"discardConfirmation\":{\"title\":\"Discard Changes\",\"summary\":\"Are you sure you want to discard your changes?\",\"success\":\"Successfully discarded changes.\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"autoSaveRequiredFields\":{\"title\":\"Required Fields\",\"summary\":\"You have unsaved changes that could not be saved because there are required fields remaining.\\n\\nDo you want to discard your changes and proceed?\",\"success\":\"Successfully discarded changes.\",\"cancel\":\"No\",\"confirm\":\"Yes\"},\"unacceptableType\":{\"unacceptableTypeMessage\":\"File {name} is not a supported file type for upload.\",\"unacceptableTypeTitle\":\"Alert\",\"unacceptableTypeConfirmActionButtonLabel\":\"OK\"},\"newRowName\":\"New\",\"groupingNames\":{},\"fileOrIconNames\":{}}}");

/***/ }),

/***/ 2667:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {var moment = __webpack_require__(2);

/*@ngInject*/
var ConfigurationActionsUtil = function ConfigurationActionsUtil($rootScope, $state, $uibModal, $window, $q, modalUtil, loadingBarHandler, coreConstant, configurationMediator, notificationPopupUtil, formViewerModel, fileExportUtil, xmlUtil, sectionTemplateActionsUtil, uiFormTemplateRepository, formViewerConstant, uiPerformanceLoggerConstant, formTemplateType, formTemplateStatus, localization, uiFormTemplateModel, fieldType, umStudioConstant, productTemplateEditorRepository, productTemplateEditorModel, notificationEmailTemplateRepository, notificationPopupTemplateRepository, navigationStateModel) {
  var _this = this;
  localization.getTranslations().then(function (translations) {
    _this.showFormReferences = function (translationRoot, uiFormTemplateId, formTemplateUniqueName, showConfirmationButtons) {
      return configurationMediator.getFormReferences(uiFormTemplateId).then(function (formTemplateReferences) {
        return modalUtil.openFormReferencesModal(translationRoot, formTemplateReferences, formTemplateUniqueName, showConfirmationButtons);
      });
    };
    _this.showFormTemplateSettings = function (uiFormTemplateId) {
      var instance = $uibModal.open({
        templateUrl: '/configuration/formTemplateSettings/formTemplateSettingsTemplate.tpl.html',
        controller: 'formTemplateSettingsController',
        windowClass: 'formTemplateSettingsModal',
        resolve: {
          options: {
            formTemplateId: uiFormTemplateId
          }
        }
      });
      return instance.result;
    };
    _this.saveUiFormTemplate = function (uiFormTemplateId, saveAs) {
      var _this2 = this;
      var uiFormTemplate;
      var formStructure = formViewerModel.getFormStructure(uiFormTemplateId);
      if (formStructure) {
        this.populateUiFormTemplateModel(uiFormTemplateId);
        uiFormTemplate = formStructure.uiFormTemplate;
      } else {
        uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();
      }
      loadingBarHandler.showLoadingBar('formEditor.saveUiFormTemplate.loadingBar');
      if (_.isNil(uiFormTemplate.id) || saveAs) {
        uiFormTemplateRepository.createFormTemplate(uiFormTemplate).then(function (uiFormTemplate) {
          loadingBarHandler.hideLoadingBar();
          _this2.handleUiFormTemplateSave(uiFormTemplate, true);
          navigationStateModel.updateViewStateData('configuration.formTemplateBrowser', uiFormTemplate.id);
        });
      } else {
        uiFormTemplateRepository.updateFormTemplate(uiFormTemplate, uiFormTemplate.id).then(function (uiFormTemplate) {
          loadingBarHandler.hideLoadingBar();
          _this2.handleUiFormTemplateSave(uiFormTemplate, true);
        });
      }
    };
    _this.handleUiFormTemplateSave = function (uiFormTemplate, doTransition) {
      return new Promise(function (resolve, reject) {
        if (uiFormTemplate.formTemplate.valid === false) {
          var type = '';
          var config = {
              confirmActionButtonLabel: _.get(translations, 'formEditor.saveUiFormTemplate.confirmationConfirmActionButtonLabel'),
              summary: '',
              title: _.get(translations, 'formEditor.saveUiFormTemplate.confirmationTitle'),
              errors: []
            },
            formTemplateUniqueName = uiFormTemplate.formTemplate.uniqueName,
            formTemplateVersionNumber = uiFormTemplate.formTemplate.version,
            failingErrors = _.intersection(uiFormTemplate.formTemplate.validationErrors, ['duplicateUniqueNameVersionCombination', 'emptyDisplayName']);
          _.each(Object.keys(formTemplateType), function (key) {
            if (formTemplateType[key] === uiFormTemplate.formTemplate.type) {
              type = _.startCase(key);
            }
          });
          if (uiFormTemplate.formTemplate.status !== formTemplateStatus.DRAFT || failingErrors.length > 0) {
            config.summary = _.get(translations, 'formEditor.saveUiFormTemplate.saveFailedWithErrors');
            $rootScope.$broadcast(formViewerConstant.event.FORM_TEMPLATE_INVALIDATED);
            $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED, uiFormTemplate);
            if (doTransition) {
              $state.transitionTo($state.current, {
                uiFormTemplateId: uiFormTemplate.id
              }, {
                reload: false,
                inherit: false,
                notify: true
              });
            }
            reject();
          } else {
            $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED, uiFormTemplate);
            config.summary = _.get(translations, 'formEditor.saveUiFormTemplate.saveSucceededWithErrors');
            if (doTransition) {
              $state.transitionTo($state.current, {
                uiFormTemplateId: uiFormTemplate.id
              }, {
                reload: true,
                inherit: false,
                notify: true
              });
            }
            resolve();
          }
          _.each(uiFormTemplate.formTemplate.validationErrors, function (validationErrorCode) {
            var errorText = _.replace(_.get(translations, 'formEditor.saveUiFormTemplate.' + validationErrorCode), '{formTemplateUniqueName}', formTemplateUniqueName);
            errorText = _.replace(errorText, '{formTemplateVersionNumber}', formTemplateVersionNumber);
            errorText = _.replace(errorText, '{formTemplateType}', type);
            config.errors.push(errorText);
          });
          $uibModal.open({
            templateUrl: '/configuration/formEditor/header/errorModal/formTemplateErrorModal.tpl.html',
            controller: 'formTemplateErrorModalController',
            windowClass: 'formTemplateErrorModal',
            resolve: {
              options: function options() {
                return config;
              }
            }
          });
        } else {
          $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED, uiFormTemplate);
          if (doTransition) {
            $state.transitionTo($state.current, {
              uiFormTemplateId: uiFormTemplate.id
            }, {
              reload: true,
              inherit: false,
              notify: true
            });
          }
          $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'formEditor.saveUiFormTemplate.saveSucceeded'));
          resolve();
        }
      });
    };

    //Populates the formStructures uiFormTemplate object based the section/row/field info in the model
    _this.populateUiFormTemplateModel = function (uiFormTemplateId) {
      var formStructure = formViewerModel.getFormStructure(uiFormTemplateId),
        uiFormTemplate = formStructure.uiFormTemplate;
      function populateFields(sourceFieldList, rowId) {
        var fieldList = [];
        _.each(sourceFieldList, function (uiField, fieldOrder) {
          var isUnsavedField = uiField.id === -1;
          uiField.ordering = fieldOrder;
          if (isUnsavedField) {
            if (rowId) {
              uiField.rowId = rowId;
            } else {
              delete uiField.rowId;
            }
            delete uiField.id;
            delete uiField.fieldTemplate.id;
            delete uiField.fieldTemplate.formTemplateId;
          }
          fieldList.push(uiField);
        });
        return fieldList;
      }
      uiFormTemplate.sections = [];
      _.each(formStructure.sectionList, function (section, sectionOrder) {
        var isUnsavedSection = _.get(section, 'sectionTemplate.id') === -1;
        uiFormTemplate.sections.push(section.sectionTemplate);
        section.sectionTemplate.ordering = sectionOrder;
        section.sectionTemplate.rows = [];
        if (isUnsavedSection) {
          delete section.sectionTemplate.id;
        }
        _.each(section.rowList, function (row, rowOrder) {
          var uiFieldList;
          var isUnsavedRow = _.get(row, 'rowTemplate.id') === -1;
          if (isUnsavedRow) {
            delete row.rowTemplate.id;
          }
          row.rowTemplate.fields = [];
          if (row.repeating) {
            uiFieldList = _.map(row.rowList[0].fieldStructureList, function (fieldStructure) {
              if (fieldStructure.uiField.fieldTemplate.type === fieldType.ROWREPEATER) {
                return row.rowList[0].rowTemplate.repeaterField;
              } else {
                return fieldStructure.uiField;
              }
            });
            row.rowTemplate = {
              id: row.rowTemplate.id,
              sectionId: section.sectionTemplate.id,
              ordering: rowOrder,
              repeaterField: row.rowTemplate.repeaterField,
              fields: populateFields(uiFieldList, row.rowTemplate.id),
              repeatable: true,
              rowRepeatable: true,
              staticLayout: false
            };
          } else {
            uiFieldList = _.map(row.fieldStructureList, 'uiField');
            row.rowTemplate = {
              id: row.rowTemplate.id,
              sectionId: section.sectionTemplate.id,
              ordering: rowOrder,
              fields: populateFields(uiFieldList, row.rowTemplate.id),
              repeatable: false,
              repeaterField: null,
              rowRepeatable: false,
              staticLayout: false
            };
          }
          section.sectionTemplate.rows.push(row.rowTemplate);
        });
      });
    };
    _this.deleteFormTemplate = function (uiFormTemplateId, formTemplateUniqueName, translations, loadingBarKey) {
      configurationMediator.getFormReferences(uiFormTemplateId).then(function (formTemplateReferences) {
        modalUtil.openFormReferencesModal('formReferencesDelete', formTemplateReferences, formTemplateUniqueName, /*showConfirmationButtons*/true).then(function () {
          loadingBarHandler.showLoadingBar(loadingBarKey);
          configurationMediator.deleteUIFormTemplate(uiFormTemplateId).then(function () {
            var message = _.get(translations, 'deleteFormTemplate.resultMessage');
            $state.go('configuration.formTemplateBrowser');
            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, message);
          }).finally(function () {
            loadingBarHandler.hideLoadingBar();
          });
        });
      });
    };
    _this.markFormTemplateInProduction = function (uiFormTemplateId, translationRoot, translations) {
      function handleClose() {
        return configurationMediator.markFormTemplateInProduction(uiFormTemplateId).then(function () {
          var message = _.get(translations, 'markFormTemplateInProduction.resultMessage');

          // Temporary to refresh the "Status" UI in the header, remove once UMS-19178 is implemented.
          $state.reload();
          $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, message);
        });
      }
      return modalUtil.showConfirmationModal(/*submissionId*/null, /*quoteId*/null, /*notificationName*/null, translationRoot, /*logAction*/null, /*hideLoadingBar*/false, handleClose);
    };
    _this.importFormTemplates = function (file, translations) {
      function handleClose() {
        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'importFormTemplates.loadingBar'));
        return configurationMediator.importFormTemplates(file).then(function (result) {
          var config,
            errorSummary,
            failedReasons = '';
          var results = xmlUtil.parseString(result),
            successfulImports = parseInt(results['successCount']),
            failedImports = parseInt(results['failureCount']),
            failureDetails = results['failureDetails'];
          if (failedImports === 0) {
            loadingBarHandler.concludeNotificationLoadingBar(_.replace(_.get(translations, 'importFormTemplates.' + (successfulImports === 1 ? 'successMessageSingular' : 'successMessagePlural')), '{0}', successfulImports));
          } else {
            loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            errorSummary = _.get(translations, 'importFormTemplates.errorModal.summary');
            errorSummary = _.replace(errorSummary, '{0}', successfulImports);
            errorSummary = _.replace(errorSummary, '{1}', failedImports);
            if (_.isArray(failureDetails)) {
              _.each(failureDetails, function (detail) {
                failedReasons += detail.formTemplateUniqueName + '(' + detail.formTemplateVersion + ')\n' + detail.errorMessage + '\n\n';
              });
            } else {
              failedReasons += failureDetails.formTemplateUniqueName + '(' + failureDetails.formTemplateVersion + ')\n' + failureDetails.errorMessage + '\n\n';
            }
            errorSummary = _.replace(errorSummary, '{2}', failedReasons);
            config = {
              confirmActionButtonLabel: _.get(translations, 'importFormTemplates.errorModal.confirmActionButtonLabel'),
              summary: errorSummary,
              title: _.get(translations, 'importFormTemplates.errorModal.title')
            };
            modalUtil.showGenericConfirm(config);
          }
        }, function () {
          // On Error
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
        });
      }
      return modalUtil.showConfirmationModal(/*submissionId*/null, /*quoteId*/null, /*notificationName*/null, 'formTemplateBrowser.importFormTemplates', /*logAction*/null, /*hideLoadingBar*/true, handleClose);
    };
    _this.exportFormTemplate = function (formTemplateId, loadingBarKey) {
      var selectedFormTemplate = {
          formTemplateId: formTemplateId
        },
        selectedFormTemplates = [selectedFormTemplate];
      return this.exportFormTemplates(selectedFormTemplates, null, null, loadingBarKey);
    };
    _this.exportFormTemplates = function (selectedFormTemplates, filterUri, excludedFormTemplates, loadingBarKey) {
      var selectedFormTemplateIds = [],
        excludedFormTemplateIds = [];
      _.each(selectedFormTemplates, function (selectedFormTemplate) {
        selectedFormTemplateIds.push(selectedFormTemplate.formTemplateId);
      });
      _.each(excludedFormTemplates, function (excludedFormTemplate) {
        excludedFormTemplateIds.push(excludedFormTemplate.formTemplateId);
      });
      function saveFile(fileResult) {
        var filename = 'FormTemplates_' + moment().format('YYYYMMDDhhmmss') + '.dbinit';
        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.exportFormTemplates.successMessage'));
        fileExportUtil.saveAs(fileResult, 'application/xml', filename);
      }
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, loadingBarKey));
      if (!_.isEmpty(selectedFormTemplateIds)) {
        return configurationMediator.exportFormTemplates(selectedFormTemplateIds).then(function (result) {
          saveFile(result);
        }, function () {
          // On Error
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
        });
      } else {
        return configurationMediator.exportFormTemplatesByFilterUri(filterUri, excludedFormTemplateIds).then(function (result) {
          saveFile(result);
        }, function () {
          // On Error
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
        });
      }
    };
    _this.exportDataSet = function (dataSetName) {
      var dataSet = {
        name: dataSetName
      };
      return this.exportDataSets([dataSet]);
    };
    _this.exportDataSets = function (selectedDataSets, filterUri, excludedDataSets) {
      var selectedDataSetNames = [],
        excludedDataSetNames = [];
      _.each(selectedDataSets, function (selectedDataSet) {
        selectedDataSetNames.push(selectedDataSet.name);
      });
      _.each(excludedDataSets, function (excludedDataSet) {
        excludedDataSetNames.push(excludedDataSet.name);
      });
      function saveFile(fileResult) {
        var filename = 'Data Sets_' + moment().format('YYYYMMDDhhmmss') + '.dbinit';
        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'dataSetBrowser.export.successMessage'));
        fileExportUtil.saveAs(fileResult, 'application/xml', filename);
      }
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'dataSetBrowser.export.loadingBar'));
      if (!_.isEmpty(selectedDataSetNames)) {
        return configurationMediator.exportDataSetsByName(selectedDataSetNames).then(function (result) {
          saveFile(result);
        }, function () {
          // On Error
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
        });
      } else {
        return configurationMediator.exportDataSetsByNameWithFilter(filterUri, excludedDataSetNames).then(function (result) {
          saveFile(result);
        }, function () {
          // On Error
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
        });
      }
    };
    _this.reloadFormRules = function () {
      var modalInstance = $uibModal.open({
        templateUrl: '/configuration/reloadRulesModal/reloadRulesModal.tpl.html',
        controller: 'reloadRulesModalController',
        windowClass: 'reloadRulesModal',
        resolve: {
          options: {
            localizationRoot: 'formTemplateBrowser.reloadFormRules'
          }
        }
      });
      modalInstance.result.then(function (response) {
        var logAction = uiPerformanceLoggerConstant.RELOAD_FORM_RULES;
        function onSuccess() {
          loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.reloadFormRules.successMessage'));
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
        }
        function onError() {
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
        }
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction);
        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.reloadFormRules.loadingBar'));
        configurationMediator.reloadFormRules(response.validate).then(onSuccess, onError);
      });
    };
    _this.reloadFieldRules = function () {
      var modalInstance = $uibModal.open({
        templateUrl: '/configuration/reloadRulesModal/reloadRulesModal.tpl.html',
        controller: 'reloadRulesModalController',
        windowClass: 'reloadRulesModal',
        resolve: {
          options: function options() {
            return {
              localizationRoot: 'formTemplateBrowser.reloadFieldRules'
            };
          }
        }
      });
      modalInstance.result.then(function (response) {
        var logAction = uiPerformanceLoggerConstant.RELOAD_FORM_RULES;
        function onSuccess() {
          loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.reloadFieldRules.successMessage'));
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
        }
        function onError() {
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
        }
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction);
        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.reloadFieldRules.loadingBar'));
        configurationMediator.reloadFieldRules(response.validate).then(onSuccess, onError);
      });
    };
    _this.reloadSectionTemplateRules = function () {
      var modalInstance = $uibModal.open({
        templateUrl: '/configuration/reloadRulesModal/reloadRulesModal.tpl.html',
        controller: 'reloadRulesModalController',
        windowClass: 'reloadRulesModal',
        resolve: {
          options: function options() {
            return {
              localizationRoot: 'sectionTemplateBrowser.reloadRules'
            };
          }
        }
      });
      modalInstance.result.then(function (response) {
        var logAction = uiPerformanceLoggerConstant.RELOAD_SECTION_TEMPLATE_RULES;
        function onSuccess() {
          loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'sectionTemplateBrowser.reloadRules.successMessage'));
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
        }
        function onError() {
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
        }
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction);
        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'sectionTemplateBrowser.reloadRules.loadingBar'));
        sectionTemplateActionsUtil.reloadSectionTemplateRules(response.validate).then(onSuccess, onError);
      });
    };
    _this.publishFormTemplates = function (loadingBarKey, selectedFormTemplates, filterUri, excludedFormTemplates) {
      var selectedFormTemplateIds = [],
        excludedFormTemplateIds = [],
        deferred = $q.defer();
      _.each(selectedFormTemplates, function (selectedFormTemplate) {
        selectedFormTemplateIds.push(selectedFormTemplate.id);
      });
      _.each(excludedFormTemplates, function (excludedFormTemplate) {
        excludedFormTemplateIds.push(excludedFormTemplate.id);
      });
      loadingBarHandler.showLoadingBar(loadingBarKey);
      if (!_.isEmpty(selectedFormTemplateIds)) {
        configurationMediator.publishFormTemplates(selectedFormTemplateIds).then(function (formTemplateSet) {
          this.publishFormTemplateConfirmAction(formTemplateSet);
          deferred.resolve();
        }.bind(this), function () {
          // On Error
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
          deferred.reject();
        }).finally(function () {
          loadingBarHandler.hideLoadingBar();
          $state.reload();
        });
      } else {
        configurationMediator.publishFormTemplatesByFilterUri(filterUri, excludedFormTemplateIds).then(function (formTemplateSet) {
          this.publishFormTemplateConfirmAction(formTemplateSet);
          deferred.resolve();
        }.bind(this), function () {
          // On Error
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
          deferred.reject();
        }).finally(function () {
          loadingBarHandler.hideLoadingBar();
          $state.reload();
        });
      }
      return deferred.promise;
    };
    _this.publishFormTemplateConfirmAction = function (formTemplateSet) {
      var config = {
        confirmActionButtonLabel: _.get(translations, 'formTemplateBrowser.createFormTemplateSet.confirmationConfirmActionButtonLabel'),
        summary: _.replace(_.get(translations, 'formTemplateBrowser.createFormTemplateSet.confirmation'), '{0}', formTemplateSet.id),
        title: _.get(translations, 'formTemplateBrowser.createFormTemplateSet.confirmationTitle')
      };
      modalUtil.showGenericConfirm(config);
    };
    _this.createTestFormTemplateSet = function () {
      loadingBarHandler.showLoadingBar('formTemplateBrowser.createTestFormTemplateSet.loadingBar');
      return configurationMediator.createTestFormTemplateSet().then(function (formTemplateSet) {
        this.createTestFormTemplateSetConfirmAction(formTemplateSet);
      }.bind(this), function () {
        // On Error
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
      }).finally(function () {
        loadingBarHandler.hideLoadingBar();
        $state.reload();
      });
    };
    _this.createTestFormTemplateSetConfirmAction = function (formTemplateSet) {
      var config = {
        confirmActionButtonLabel: _.get(translations, 'formTemplateBrowser.createTestFormTemplateSet.confirmationConfirmActionButtonLabel'),
        summary: _.replace(_.get(translations, 'formTemplateBrowser.createTestFormTemplateSet.confirmation'), '{0}', formTemplateSet.id),
        title: _.get(translations, 'formTemplateBrowser.createTestFormTemplateSet.confirmationTitle')
      };
      modalUtil.showGenericConfirm(config);
    };
    _this.markFormTemplatesInProduction = function (selectedFormTemplates, filterUri, excludedFormTemplates) {
      var selectedFormTemplateIds = [],
        excludedFormTemplateIds = [],
        deferred = $q.defer();
      _.each(selectedFormTemplates, function (selectedFormTemplate) {
        selectedFormTemplateIds.push(selectedFormTemplate.id);
      });
      _.each(excludedFormTemplates, function (excludedFormTemplate) {
        excludedFormTemplateIds.push(excludedFormTemplate.id);
      });
      function handleClose() {
        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.markInProduction.loadingBar'));
        if (!_.isEmpty(selectedFormTemplateIds)) {
          configurationMediator.markFormTemplatesInProduction(selectedFormTemplateIds).then(function (result) {
            if (result) {
              loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
              modalUtil.openFormReferencesModal('formReferencesMarkInProductionInvalid', result);
            } else {
              loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.markInProduction.successMessage'));
            }
            deferred.resolve();
          }, function () {
            // On Error
            loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            deferred.reject();
          });
        } else {
          configurationMediator.markFormTemplatesInProductionByFilterUri(filterUri, excludedFormTemplateIds).then(function (result) {
            if (result) {
              loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
              modalUtil.openFormReferencesModal('formReferencesMarkInProductionInvalid', result);
            } else {
              loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.markInProduction.successMessage'));
            }
            deferred.resolve();
          }, function () {
            // On Error
            loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            deferred.reject();
          });
        }
      }
      modalUtil.showConfirmationModal(/*submissionId*/null, /*quoteId*/null, /*notificationName*/null, 'formTemplateBrowser.markInProduction', /*logAction*/null, /*hideLoadingBar*/true, handleClose);
      return deferred.promise;
    };
    _this.backup = function (sectionName, backupName, loadingBarMsg, successMsg) {
      loadingBarHandler.showNotificationLoadingBar(loadingBarMsg + ' ' + backupName);
      return configurationMediator.backup(sectionName).then(function (result) {
        var filename = backupName + '_' + moment().format('YYYYMMDDhhmmss') + '.dbinit';
        loadingBarHandler.concludeNotificationLoadingBar(successMsg + ' ' + backupName);
        fileExportUtil.saveAs(result, 'application/xml', filename);
      }, function () {
        // On Error
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
      });
    };
    _this.saveProductTemplate = function (productTemplate) {
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'productTemplateEditorHeader.saveProductTemplate.loadingBar'));
      var promise;
      if (productTemplate.id) {
        promise = updateProductTemplate(productTemplate);
      } else {
        promise = createProductTemplate(productTemplate);
      }
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    };
    function updateProductTemplate(productTemplate) {
      return productTemplateEditorRepository.updateProductTemplate(productTemplate).then(function (productTemplate) {
        var productTemplateToReturn = productTemplate,
          quoteTemplateFile = productTemplateEditorModel.getQuoteTemplateFile(),
          binderTemplateFile = productTemplateEditorModel.getBinderTemplateFile();
        // At least one of template should be selected
        if (quoteTemplateFile !== null || binderTemplateFile !== null) {
          productTemplateEditorRepository.updateDocumentTemplates(productTemplate, quoteTemplateFile, binderTemplateFile).then(function () {
            showConcludeNotificationLoadingBarAndDoLogging('productTemplateEditorHeader.saveProductTemplate.savingProductTemplateSuccessLoadingBar', uiPerformanceLoggerConstant.UPDATE_PRODUCT_TEMPLATE);
            $state.reload();
          });
        } else {
          showConcludeNotificationLoadingBarAndDoLogging('productTemplateEditorHeader.saveProductTemplate.savingProductTemplateSuccessLoadingBar', uiPerformanceLoggerConstant.UPDATE_PRODUCT_TEMPLATE);
        }
        return productTemplateToReturn;
      }, function () {
        // On Error
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
      });
    }
    function showConcludeNotificationLoadingBarAndDoLogging(translationKey, uiPerfLoggingConstant) {
      loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, translationKey));
      $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerfLoggingConstant);
    }
    function createProductTemplate(productTemplate) {
      return productTemplateEditorRepository.createProductTemplate(productTemplate).then(function (productTemplate) {
        var productTemplateToReturn = productTemplate,
          quoteTemplateFile = productTemplateEditorModel.getQuoteTemplateFile(),
          binderTemplateFile = productTemplateEditorModel.getBinderTemplateFile();
        if (quoteTemplateFile !== null || binderTemplateFile !== null) {
          productTemplateEditorRepository.updateDocumentTemplates(productTemplate, quoteTemplateFile, binderTemplateFile).then(function () {
            showConcludeNotificationLoadingBarAndDoLogging('productTemplateEditorHeader.saveProductTemplate.savingProductTemplateSuccessLoadingBar', uiPerformanceLoggerConstant.CREATE_PRODUCT_TEMPLATE);
            $state.reload();
          });
        } else {
          showConcludeNotificationLoadingBarAndDoLogging('productTemplateEditorHeader.saveProductTemplate.savingProductTemplateSuccessLoadingBar', uiPerformanceLoggerConstant.CREATE_PRODUCT_TEMPLATE);
        }
        return productTemplateToReturn;
      }, function () {
        // On Error
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
      });
    }
    _this.updatePermissions = function (permissions) {
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'permissionsEditorHeader.savePermissions.loadingBar'));
      if (permissions) {
        $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPDATE_PERMISSION);
        var promise = configurationMediator.updatePermissions(permissions).then(function () {
          loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'permissionsEditorHeader.savePermissions.savingPermissionsSuccessLoadingBar'));
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPDATE_PERMISSION, coreConstant.uiPeformanceLogger.SUCCESS);
        }, function () {
          // On Error
          loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
          $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPDATE_PERMISSION, coreConstant.uiPeformanceLogger.FAIL);
        });
        $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        return promise;
      }
    };
    _this.saveNotificationEmailTemplate = function (notificationEmailTemplate) {
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'manageEmailNotificationHeader.saveNotificationEmailTemplate.loadingBar'));
      var promise = notificationEmailTemplateRepository.saveNotificationEmailTemplate(notificationEmailTemplate).then(function (emailTemplate) {
        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'manageEmailNotificationHeader.saveNotificationEmailTemplate.savingNotificationEmailTemplateSuccessLoadingBar'));
        return emailTemplate;
      }, function () {
        // On Error
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    };
    _this.saveNotificationPopupTemplate = function (notificationPopupTemplate) {
      loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'managePopupNotificationHeader.saveNotificationPopupTemplate.loadingBar'));
      var promise = notificationPopupTemplateRepository.saveNotificationPopupTemplate(notificationPopupTemplate).then(function (popupTemplate) {
        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'managePopupNotificationHeader.saveNotificationPopupTemplate.savingNotificationPopupTemplateSuccessLoadingBar'));
        return popupTemplate;
      }, function () {
        // On Error
        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
      });
      $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
      return promise;
    };
  });
};
ConfigurationActionsUtil.$inject = ["$rootScope", "$state", "$uibModal", "$window", "$q", "modalUtil", "loadingBarHandler", "coreConstant", "configurationMediator", "notificationPopupUtil", "formViewerModel", "fileExportUtil", "xmlUtil", "sectionTemplateActionsUtil", "uiFormTemplateRepository", "formViewerConstant", "uiPerformanceLoggerConstant", "formTemplateType", "formTemplateStatus", "localization", "uiFormTemplateModel", "fieldType", "umStudioConstant", "productTemplateEditorRepository", "productTemplateEditorModel", "notificationEmailTemplateRepository", "notificationPopupTemplateRepository", "navigationStateModel"];
angular.module('ums.configuration').service('configurationActionsUtil', ConfigurationActionsUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2668:
/***/ (function(module, exports) {

angular.module('ums.configuration').constant('dataItemSortingConstant', {
  LABEL_ASC: 0,
  LABEL_DESC: 1,
  VALUE_ASC: 2,
  VALUE_DESC: 3
});

/***/ }),

/***/ 2669:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DataSetEditorModel = function DataSetEditorModel($rootScope, $timeout, coreMediator, configurationConstant, dataSetType) {
  var dataSetEditorModel = {};
  this.reset = function (dataSetName) {
    if (!_.isNil(dataSetName)) {
      dataSetEditorModel[dataSetName] = {
        dataSet: null,
        isDraggingDataItemsGroup: false,
        isDraggingDataItems: false,
        isValid: null,
        isValidToSave: null,
        isValidDynamicCriterion: null,
        isValidDynamicCriterionToSave: null,
        isValidDependencies: null,
        isValidDependenciesToSave: null,
        hasUnsavedChanges: false
      };
    } else {
      dataSetEditorModel = {};
    }
  };
  this.buildDataSet = function (dataSetName) {
    this.reset(dataSetName);
    coreMediator.getRemoteDataSetByName(dataSetName).then(function (dataSet) {
      this.updateDataSet(dataSet);
    }.bind(this));
  };
  this.getDataSet = function (dataSetName) {
    var model = dataSetEditorModel[dataSetName];
    return model.dataSet;
  };
  this.addDataItem = function (dataSetName, grouping) {
    var model = dataSetEditorModel[dataSetName],
      dataItem = {
        grouping: grouping,
        name: '',
        value: '',
        defaultPrecedence: null
      };
    model.dataSet.items.push(dataItem);
    return dataItem;
  };
  this.removeDataItem = function (dataSetName, dataItem) {
    var model = dataSetEditorModel[dataSetName],
      index = _.findIndex(model.dataSet.items, function (item) {
        return dataItem === item;
      });
    model.dataSet.items.splice(index, 1);
  };
  this.addSourceFieldDependency = function (dataSetName) {
    var model = dataSetEditorModel[dataSetName],
      sourceFieldDependency = {
        formTemplateUniqueName: '',
        fieldName: '',
        key: ''
      };
    model.dataSet.dynamicDataSetDependency.sourceFieldDependencies.push(sourceFieldDependency);
    return sourceFieldDependency;
  };
  this.removeSourceFieldDependency = function (dataSetName, sourceFieldDependency) {
    var model = dataSetEditorModel[dataSetName],
      index = _.findIndex(model.dataSet.dynamicDataSetDependency.sourceFieldDependencies, function (item) {
        return sourceFieldDependency === item;
      });
    model.dataSet.dynamicDataSetDependency.sourceFieldDependencies.splice(index, 1);

    // Property shift over the field values
    _.each(model.dataSet.items, function (dataItem) {
      _.each(dataItem.enhancedDynamicDataItemCriteriaList, function (dynamicDataItemCriteria) {
        _.each(_.range(index + 1, configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES), function (fieldValueIndex) {
          dynamicDataItemCriteria['fieldValue' + fieldValueIndex] = dynamicDataItemCriteria['fieldValue' + (fieldValueIndex + 1)];
        });
        // When removing a source field dependency, the last entry will always be null, so make sure to set it.
        dynamicDataItemCriteria['fieldValue' + configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES] = null;
      });
    });
  };
  this.moveDynamicDataItemCriteria = function (dataSetName, dynamicDataItemCriteria, destinationDataItemValue) {
    var model = dataSetEditorModel[dataSetName],
      currentDataItem = null,
      destinationDataItem = null,
      currentDynamicDataItemIndex;
    _.each(model.dataSet.items, function (dataItem) {
      if (dataItem.value === dynamicDataItemCriteria.value) {
        currentDataItem = dataItem;
      } else if (!_.isEmpty(destinationDataItemValue) && dataItem.value === destinationDataItemValue) {
        destinationDataItem = dataItem;
      }
    });
    if (!_.isNil(currentDataItem)) {
      currentDynamicDataItemIndex = _.findIndex(currentDataItem.enhancedDynamicDataItemCriteriaList, function (item) {
        return dynamicDataItemCriteria === item;
      });

      // Remove dynamicDataItemCriteria from current data item
      currentDataItem.enhancedDynamicDataItemCriteriaList.splice(currentDynamicDataItemIndex, 1);
    }
    if (!_.isNil(destinationDataItem)) {
      // Add dynamicDataItemCriteria to destination data item
      destinationDataItem.enhancedDynamicDataItemCriteriaList.push(dynamicDataItemCriteria);
    }
    dynamicDataItemCriteria.value = destinationDataItemValue;
  };
  this.setDraggingDataItemsGroup = function (dataSetName, dragging) {
    var model = dataSetEditorModel[dataSetName];
    model.isDraggingDataItemsGroup = dragging;
  };
  this.setDraggingDataItems = function (dataSetName, dragging) {
    var model = dataSetEditorModel[dataSetName];
    model.isDraggingDataItems = dragging;
  };
  this.isDraggingDataItemsGroup = function (dataSetName) {
    var model = dataSetEditorModel[dataSetName];
    return model.isDraggingDataItemsGroup;
  };
  this.isDraggingDataItems = function (dataSetName) {
    var model = dataSetEditorModel[dataSetName];
    return model.isDraggingDataItems;
  };
  this.setValid = function (dataSetName, valid) {
    var model = dataSetEditorModel[dataSetName];
    model.isValid = valid;
    model.isValidToSave = valid;
  };
  this.isValid = function (dataSetName) {
    var model = dataSetEditorModel[dataSetName];
    return model.isValid;
  };
  this.setValidDynamicCriterion = function (dataSetName, valid) {
    var model = dataSetEditorModel[dataSetName];
    model.isValidDynamicCriterion = valid;
    model.isValidDynamicCriterionToSave = valid;
  };
  this.isValidDynamicCriterion = function (dataSetName) {
    var model = dataSetEditorModel[dataSetName];
    return model.isValidDynamicCriterion;
  };
  this.setValidDependencies = function (dataSetName, valid) {
    var model = dataSetEditorModel[dataSetName];
    model.isValidDependencies = valid;
    model.isValidDependenciesToSave = valid;
  };
  this.isValidDependencies = function (dataSetName) {
    var model = dataSetEditorModel[dataSetName];
    return model.isValidDependencies;
  };
  this.renameDataSet = function (oldName, newName) {
    if (oldName !== newName) {
      dataSetEditorModel[newName] = dataSetEditorModel[oldName];
      delete dataSetEditorModel[oldName];
    }
  };
  this.setUnsavedChanges = function (dataSetName, hasUnsavedChanges) {
    var model = dataSetEditorModel[dataSetName];
    model.hasUnsavedChanges = hasUnsavedChanges;
  };
  this.hasUnsavedChanges = function (dataSetName) {
    var model = dataSetEditorModel[dataSetName];
    return model.hasUnsavedChanges;
  };
  this.isValidToSave = function (dataSetName) {
    var model = dataSetEditorModel[dataSetName];
    return _.isNil(model.isValidToSave) || model.isValidToSave;
  };
  this.isValidDynamicCriterionToSave = function (dataSetName) {
    var model = dataSetEditorModel[dataSetName];
    return _.isNil(model.isValidDynamicCriterionToSave) || model.isValidDynamicCriterionToSave;
  };
  this.isValidDependenciesToSave = function (dataSetName) {
    var model = dataSetEditorModel[dataSetName];
    return _.isNil(model.isValidDependenciesToSave) || model.isValidDependenciesToSave;
  };
  this.updateDataSet = function (dataSet) {
    var model = {
      dataSet: _.cloneDeep(dataSet),
      isDraggingDataItemsGroup: false,
      isDraggingDataItems: false,
      isValid: null,
      isValidToSave: null,
      isValidDynamicCriterion: null,
      isValidDynamicCriterionToSave: null,
      isValidDependencies: null,
      isValidDependenciesToSave: null,
      hasUnsavedChanges: false
    };
    if ((dataSet.type === dataSetType.CUSTOM || dataSet.type === dataSetType.PRODUCT_FIELD_DEPENDENT) && _.isNil(dataSet.dynamicDataSetDependency)) {
      model.dataSet.dynamicDataSetDependency = {
        productDependent: false,
        sourceFieldDependencies: []
      };
    }
    dataSetEditorModel[dataSet.name] = model;
    $rootScope.$broadcast(configurationConstant.event.DATA_SET_EDITOR_MODEL_UPDATED, dataSet.name);
  };
};
DataSetEditorModel.$inject = ["$rootScope", "$timeout", "coreMediator", "configurationConstant", "dataSetType"];
angular.module('ums.configuration').service('dataSetEditorModel', DataSetEditorModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 2670:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var DataSetManagementUtil = function DataSetManagementUtil(uuidUtil, configurationConstant) {
  this.isValidDataItem = function (dataItem) {
    return !_.isNil(dataItem.name) && dataItem.name !== '' && !_.isNil(dataItem.value) && dataItem.value !== '';
  };
  this.isValidDataItemForEvaluation = function (dataItem) {
    return !_.isNil(dataItem.name) && dataItem.name !== '' || !_.isNil(dataItem.value) && dataItem.value !== '';
  };
  this.isEmptyDataItem = function (dataItem) {
    return _.isEmpty(dataItem.name) && _.isEmpty(dataItem.value) && _.isNil(dataItem.defaultPrecedence);
  };
  this.isValidSourceFieldDependency = function (sourceFieldDependency) {
    return !_.isEmpty(sourceFieldDependency.formTemplateUniqueName) && !_.isEmpty(sourceFieldDependency.fieldName);
  };
  this.isValidDynamicDataItemCriteriaForEvaluation = function (dynamicDataItemCriteria) {
    var validValue = !_.isEmpty(dynamicDataItemCriteria.value),
      validProductName = !_.isEmpty(dynamicDataItemCriteria.productName),
      validFieldValue = false;
    _.each(_.range(1, configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES + 1), function (index) {
      if (!_.isEmpty(dynamicDataItemCriteria['fieldValue' + index])) {
        validFieldValue = true;
        return false;
      }
    });
    return validValue || validProductName || validFieldValue;
  };
  this.isValidDynamicDataItemCriteria = function (dynamicDataItemCriteria) {
    var validValue = !_.isEmpty(dynamicDataItemCriteria.value),
      validProductName = !_.isEmpty(dynamicDataItemCriteria.productName),
      validFieldValue = false;
    _.each(_.range(1, configurationConstant.dataSet.MAX_SOURCE_FIELD_DEPENDENCIES + 1), function (index) {
      if (!_.isEmpty(dynamicDataItemCriteria['fieldValue' + index])) {
        validFieldValue = true;
        return false;
      }
    });
    return validValue && (validProductName || validFieldValue);
  };
  this.generateUUID = function () {
    return uuidUtil.generateUUID().replace(/-/g, '');
  };
  this.isEntireRowEmptyValidDataItem = function (dataItem) {
    return !_.isNil(dataItem.name) && dataItem.name !== '' && !_.isNil(dataItem.value) && dataItem.value !== '';
  };
};
DataSetManagementUtil.$inject = ["uuidUtil", "configurationConstant"];
angular.module('ums.configuration').service('dataSetManagementUtil', DataSetManagementUtil);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d8d7173de71c1c8b502fbe91d0b96ea1.svg";

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75);
__webpack_require__(50);
var uirouter = __webpack_require__(53);
var ngIdle = __webpack_require__(54);
var angularSanitize = __webpack_require__(55);
var uiBootstrap = __webpack_require__(56);
var uiSelect = __webpack_require__(57);
var relativeDate = __webpack_require__(73);
var coreModule = __webpack_require__(109);

/*@ngInject*/
var umExtensionsModule = angular.module('gw-um-extensions', [angularSanitize, ngIdle, uirouter.default, uiBootstrap, uiSelect, relativeDate.default.name, 'currencyFilter', 'isoCurrency', 'dibari.angular-ellipsis', 'ux', coreModule]).config(function () {}).run(["dynamicGridExtension", function (dynamicGridExtension) {}]);
__webpack_require__(94);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
module.exports = 'gw-um-extensions';

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(93);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(570);
var GridDataBrowserComponent = {
  templateUrl: '/gridDataBrowser.tpl.html',
  controller: 'gridDataBrowserController',
  bindings: {
    identifier: '<',
    columns: '<',
    stateParams: '<',
    advancedFilterType: '<',
    filterType: '<',
    translations: '<',
    initialRequestParams: '<',
    loadFilterHandler: '<',
    loadItemsHandler: '<',
    loadActionsHandler: '<',
    notifyHandleAction: '&',
    notifyHandleBulkAction: '&',
    showSelector: '<',
    singleSelect: '<'
  }
};
angular.module('gw-um-grid-data-browser').component('uiGridDataBrowser', GridDataBrowserComponent);

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

var path = '/gridDataBrowser.tpl.html';
var html = "<div class=\"header\"\r\n     ng-show=\"!$ctrl.isBulkActionActive\">\r\n\r\n    <div class=\"headerContent\">\r\n\r\n        <div class=\"headerLabel\">{{ ::$ctrl.translations.title }}</div>\r\n\r\n        <action-buttons-bar context=\"$ctrl.context\"\r\n                            actions=\"$ctrl.actions\"\r\n                            hidden-input-actions=\"$ctrl.hiddenInputActions\"\r\n                            notify-action-clicked=\"$ctrl.handleAction(action, file)\"\r\n                            time-last-modified=\"$ctrl.actionsTimeLastModified\"></action-buttons-bar>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"header bulkActionHeader\" ng-show=\"$ctrl.isBulkActionActive\">\r\n\r\n    <div class=\"headerContent\">\r\n\r\n        <div class=\"circleText\">{{ $ctrl.bulkActionCount }}</div>\r\n\r\n        <div class=\"headerLabel bulkActionLabel\">{{ ::$ctrl.translations.bulkActionLabel }}</div>\r\n\r\n        <button ng-click=\"$ctrl.onCancelBulkAction()\" class=\"btn actionButtonsBorderWidth cancel cancelBulkAction\">\r\n            <span>{{ ::$ctrl.translations.bulkActionCancelButtonLabel }}</span>\r\n        </button>\r\n\r\n        <button ng-click=\"$ctrl.onBulkAction()\"\r\n                class=\"btn btn-primary actionButtonsBorderWidth bulkActionButton\"\r\n                ng-disabled=\"$ctrl.bulkActionCount === 0\">\r\n            <span>{{ $ctrl.activeBulkAction.bulkActionLabel }}</span>\r\n        </button>\r\n    </div>\r\n</div>\r\n\r\n<!-- Tools -->\r\n<div class=\"tools\"\r\n     ng-if=\"!$ctrl.isBulkActionActive\">\r\n\r\n    <div class=\"toolsContent\">\r\n\r\n        <ui-advanced-filter-list\r\n            class=\"advancedFilterListWrapper\"\r\n            filter-model=\"$ctrl.filterModel\"\r\n            show-all-templates=\"true\"\r\n            advanced-filter-type=\"$ctrl.advancedFilterType\"\r\n            translations-key=\"$ctrl.identifier\"\r\n            allow-clear-filter=\"true\"\r\n            one-clear-filter=\"true\"\r\n            clear-filter-is-link=\"true\">\r\n        </ui-advanced-filter-list>\r\n    </div>\r\n</div>\r\n\r\n<!-- Grid -->\r\n<div class=\"grid\">\r\n\r\n    <div class=\"gridContainer\">\r\n\r\n        <!-- Grid Header -->\r\n        <div class=\"columnHeader\">\r\n\r\n            <div class=\"columnRow\">\r\n\r\n                <div class=\"colHover\"></div>\r\n\r\n                <div class=\"col bulkActionColumn\"\r\n                     ng-show=\"$ctrl.isShowSelector()\">\r\n                    <input type=\"checkbox\"\r\n                           ng-change=\"$ctrl.onBulkActionAllCheckboxClick()\"\r\n                           ng-model=\"$ctrl.isBulkActionAllSelected\"\r\n                           ng-show=\"!$ctrl.singleSelect\">\r\n                </div>\r\n\r\n                <div ng-repeat=\"column in $ctrl.columns track by $index\"\r\n                     class=\"{{ ::column.className }}\"\r\n                     ui-grid-sortable-header\r\n                     request-params=\"$ctrl.requestParams\"\r\n                     item-name=\"{{ ::column.name }}\"\r\n                     item-label=\"{{ ::column.label }}\"\r\n                     on-toggle=\"$ctrl.onSortChange($event, params)\"></div>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"datagrid table\"\r\n             ux-datagrid=\"$ctrl.items\"\r\n             ng-if=\"!$ctrl.isLoading\"\r\n             ui-scroll-detection\r\n             ui-scroll-detection-target=\".columnHeader\"\r\n             ng-mousedown=\"$ctrl.onGridMouseDown($event)\">\r\n\r\n            <script type=\"template/html\"\r\n                    data-template-item=\"item\"\r\n                    data-template-name=\"default\">\r\n\r\n                <div class=\"columnRow\">\r\n\r\n                    <div class=\"columnRowWrapper\">\r\n\r\n                        <div class=\"col bulkActionColumn\"\r\n                             ng-if=\"$ctrl.isShowSelector()\">\r\n\r\n                            <input type=\"checkbox\"\r\n                                   ng-change=\"$ctrl.onBulkActionCheckboxClick($event, item)\"\r\n                                   ng-model=\"item.selected\"/>\r\n                        </div>\r\n\r\n                        <div ng-repeat=\"column in $ctrl.columns track by $index\"\r\n                             class=\"col {{ ::column.className }}\"\r\n                             row-index=\"{{ ::$parent.$index }}\"\r\n                             ng-click=\"$ctrl.onClickRow($event, item)\">\r\n\r\n                            <span ng-repeat=\"columnItem in (column.getColumnItems(item) || [item]) track by $index\"\r\n                                  ng-class=\"{ 'tag': column.isTag(columnItem), 'columnText': !column.isTag(columnItem)}\"\r\n                                  uib-tooltip=\"{{ ::column.getValue(columnItem) }}\"\r\n                                  tooltip-append-to-body=\"true\"\r\n                                  tooltip-popup-delay=\"500\"\r\n                                  tooltip-enable=\"{{ item['enableTooltip.' + column.name] }}\"\r\n                                  ui-is-tooltip-enabled=\"item['enableTooltip.' + column.name]\">{{ ::column.getValue(columnItem) }}</span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </script>\r\n        </div>\r\n\r\n        <ui-grid-paging-component\r\n            ng-hide=\"$ctrl.totalItems === 0\"\r\n            start-index=\"$ctrl.requestParams.startIndex\"\r\n            page-size=\"$ctrl.requestParams.pageSize\"\r\n            total-records=\"$ctrl.totalItems\"\r\n            record-count-text=\"$ctrl.translations.recordCountText\"\r\n            records-count-text=\"$ctrl.translations.recordsCountText\"\r\n            on-change=\"$ctrl.onPagingChange($event, params)\">\r\n        </ui-grid-paging-component>\r\n\r\n        <div class=\"gridEmpty\"\r\n             ng-if=\"$ctrl.isGridEmpty && !$ctrl.isLoading\">{{ ::$ctrl.translations.emptyGrid }}\r\n        </div>\r\n\r\n        <div class=\"icon-spinner\"\r\n             ng-if=\"$ctrl.isLoading\">\r\n            <img src=\"" + __webpack_require__(569) + "\"/>\r\n        </div>\r\n    </div>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2d499ab556d929865f461acb8f2a13bf.svg";

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {var locale = __webpack_require__(93);

/*@ngInject*/
var GridDataBrowserController = function GridDataBrowserController($rootScope, currentUserModel, $scope, $timeout, $element, $state, coreConstant, advancedFilterModel, advancedFilterMediator, navigationStateModel, gridDataBrowserConstant, formTemplateStatus, uIFormTemplateAction) {
  var _this11 = this;
  this.$onInit = function () {
    $element.addClass('gridDataBrowser');
    $element.addClass(this.identifier);
    this.i18n = locale;
    this.isLoading = true;
    this.filterModel = null;
    this.items = [];
    this.totalItems = 0;
    this.isGridEmpty = true;
    this.isBulkActionActive = false;
    this.activeBulkAction = null;
    this.bulkActionLabel = '';
    this.isBulkActionAllSelected = false;
    this.isBulkActionAllProcessing = false;
    this.bulkActionLastSelectedIndex = -1;
    this.bulkActionCount = 0;
    this.bulkActionSelectedItems = [];
    this.bulkActionFilterUri = null;
    this.bulkActionExcludedItems = [];
    this.requestParams = {
      key: this.initialRequestParams.key,
      startIndex: this.initialRequestParams.startIndex,
      pageSize: this.initialRequestParams.pageSize,
      sortType: this.initialRequestParams.sortType
    };
    this.actions = [];
    this.hiddenInputActions = {};
    this.context = {
      identifier: this.identifier,
      actions: {},
      fallthrough: null,
      model: {
        contextType: coreConstant.CONTEXT_NONE
      }
    };
    this.context.actions[coreConstant.CONTEXT_NONE] = '';
    this.resetNavigationState();
    this.loadFilter();
    this.loadActions();
  };
  this.isShowSelector = function () {
    return this.showSelector || this.isBulkActionActive;
  };
  this.loadActions = function () {
    var _this = this;
    this.loadActionsHandler().then(function (actions) {
      var allActions = [];
      allActions.push({
        actions: actions.actions,
        contextType: _this.context.model.contextType
      });
      _this.actions = allActions;
      _this.hiddenInputActions = actions.hiddenInputActions;
      _this.actionsTimeLastModified = new Date().getTime();
      if (allActions.length === 1 && allActions[0].actions && allActions[0].actions.length === 1 && allActions[0].actions[0].defaultExecute) {
        _this.handleAction(allActions[0].actions[0]);
      }
    });
  };
  this.loadItems = function () {
    var _this2 = this;
    this.isLoading = true;
    return this.loadItemsHandler(this.filterModel.filter.uri, this.requestParams).then(function (items) {
      _this2.items = items.records;
      _this2.totalItems = items.totalRecords;
      _this2.isGridEmpty = _this2.totalItems === 0;

      // specific to dynamicGrid
      if (!_this2.isBulkActionActive && _this2.showSelector) {
        if (_this2.items) {
          if (_this2.isBulkActionActive && _this2.activeBulkAction.name === uIFormTemplateAction.PUBLISH_FORM_TEMPLATES) {
            var originalItemslength = _this2.items.length;
            _this2.items = _.filter(_this2.items, function (item) {
              return item.isValid;
            });
            _this2.totalItems = items.totalRecords - (originalItemslength - _this2.items.length);
            _this2.isGridEmpty = _this2.totalItems === 0;
          }
          _.each(_this2.items, function (item) {
            if (item.selected && !_this2.bulkActionSelectedItems.find(function (i) {
              return i.id === item.id;
            })) {
              _this2.bulkActionSelectedItems.push(item);
            }
          });
        }
        $scope.$emit(coreConstant.event.gridSelectionChanged, _this2.bulkActionSelectedItems);
      }
      $timeout(function () {
        $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
        _this2.isLoading = false;
      }, 0);
    });
  };
  this.useFilter = function (filter) {
    var _this3 = this;
    if (!_.isNil(filter)) {
      advancedFilterMediator.getFilterTemplates(filter.filterTemplateId).then(function (filterTemplate) {
        advancedFilterModel.buildFilter(_this3.advancedFilterType, filterTemplate, filter, true);
        _this3.filterModel = advancedFilterModel.getAdvancedFilterModel(_this3.advancedFilterType);
        _this3.loadItems();
      });
    }
  };
  this.loadFilter = function () {
    var _this4 = this;
    var existingFilterModel = advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType);
    if (!this.loadFilterHandler && !_.isNil(existingFilterModel) && !_.isNil(existingFilterModel.filter)) {
      this.filterModel = existingFilterModel;
      this.loadItems();
    } else {
      if (this.loadFilterHandler) {
        this.loadFilterHandler().then(function (filter) {
          _this4.useFilter(filter);
        });
      } else {
        advancedFilterMediator.getFilters(this.filterType).then(function (filters) {
          var filter = _.first(filters);
          _this4.useFilter(filter);
        });
      }
    }
  };
  this.onClickRow = function (event, item) {
    if (this.isShowSelector()) {
      this.handleBulkActionRowSelection(event, item, true);
    } else {
      var detailState = this.stateParams.getDetailState(item);
      var navigationModel = {
        parentState: this.stateParams.browser,
        currentState: detailState.name,
        data: detailState.params
      };
      $state.go(detailState.name, detailState.params);
      navigationStateModel.saveViewState(this.stateParams.browser, navigationModel);
    }
  };
  this.onPagingChange = function (event, params) {
    var _this5 = this;
    this.requestParams.startIndex = params.startIndex;
    this.bulkActionLastSelectedIndex = -1;
    this.loadItems().then(function () {
      _this5.updateBulkActionSelection();
    });
  };
  this.onSortChange = function (event, params) {
    var _this6 = this;
    this.requestParams.key = params.key;
    this.requestParams.sortType = params.sortType;
    this.bulkActionLastSelectedIndex = -1;
    this.loadItems().then(function () {
      _this6.updateBulkActionSelection();
    });
  };
  this.resetNavigationState = function () {
    navigationStateModel.saveViewState(this.stateParams.browser, null);
  };
  this.handleAction = function (action, file) {
    if (action.isBulkAction && action.enabled) {
      if (action.name === uIFormTemplateAction.PUBLISH_FORM_TEMPLATES) {
        this.applyCriterionFilters({
          'Status': formTemplateStatus.DRAFT
        });
      }
      this.isBulkActionActive = true;
      this.activeBulkAction = action;
    } else {
      this.notifyHandleAction({
        action: action,
        file: file
      });
    }
  };
  this.onBulkAction = function () {
    this.notifyHandleBulkAction({
      action: this.activeBulkAction,
      selectedItems: this.bulkActionSelectedItems,
      excludedItems: this.bulkActionExcludedItems,
      filterUri: this.bulkActionFilterUri
    });
  };
  this.onCancelBulkAction = function () {
    this.resetBulkActionState();
  };
  this.onBulkActionCheckboxClick = function (event, item) {
    this.handleBulkActionRowSelection(event, item, false);
    if (event) {
      event.stopPropagation();
    }
  };
  this.onBulkActionAllCheckboxClick = function () {
    var _this7 = this;
    this.bulkActionSelectedItems = [];
    this.bulkActionFilterUri = null;
    this.bulkActionExcludedItems = [];
    this.isBulkActionAllProcessing = this.isBulkActionAllSelected;
    _.each(this.items, function (item) {
      item.selected = _this7.isBulkActionAllProcessing;
      // specific to dynamicGrid
      if (!_this7.isBulkActionActive && _this7.showSelector) {
        if (item.selected && _this7.bulkActionSelectedItems.indexOf(item) < 0) {
          _this7.bulkActionSelectedItems.push(item);
        } else if (_this7.bulkActionSelectedItems.indexOf(item) >= 0) {
          _this7.bulkActionSelectedItems.splice(_this7.bulkActionSelectedItems.indexOf(item), 1);
        }
      }
    });
    if (this.isBulkActionAllProcessing) {
      this.bulkActionFilterUri = this.filterModel.filter.uri;
      this.bulkActionCount = this.totalItems;
    } else {
      this.bulkActionCount = 0;
    }
    $scope.$emit(coreConstant.event.gridSelectionChanged, this.bulkActionSelectedItems);
  };
  this.updateBulkActionSelection = function () {
    var _this8 = this;
    if (this.isBulkActionAllProcessing) {
      this.bulkActionCount = this.totalItems - _.size(this.bulkActionExcludedItems);
      _.each(this.items, function (item) {
        var exclusions = _.find(_this8.bulkActionExcludedItems, function (bulkActionExcludedItem) {
          return bulkActionExcludedItem.id === item.id;
        });
        item.selected = _.isNil(exclusions);
      });
    } else {
      _.each(this.items, function (item) {
        var selected = _.find(_this8.bulkActionSelectedItems, function (bulkActionSelectedItem) {
          return bulkActionSelectedItem.id === item.id;
        });
        item.selected = !_.isNil(selected);
      });
    }
  };
  this.resetBulkActionState = function () {
    this.resetPublishFormTemplatesActionState();
    this.isBulkActionActive = false;
    this.activeBulkAction = null;
    this.isBulkActionAllSelected = false;
    this.isBulkActionAllProcessing = false;
    this.bulkActionCount = 0;
    this.bulkActionSelectedItems = [];
    this.bulkActionFilterUri = null;
    this.bulkActionExcludedItems = [];
    _.each(this.items, function (item) {
      if (item.selected) {
        item.selected = false;
      }
    });
  };
  this.handleBulkActionRowSelection = function (event, rowItem, toggleSelected) {
    var _this9 = this;
    if (this.singleSelect) {
      _.each(this.items, function (item, index) {
        if (item.id !== rowItem.id) {
          item.selected = false;
        }
      });
      rowItem.selected = true;
      this.handleBulkActionSelection(rowItem, null);
      this.bulkActionCount = 1;
    } else {
      var shiftKeyPressed = event && event.shiftKey,
        previouslySelected = this.handleBulkActionCheckboxToggle(rowItem, toggleSelected, shiftKeyPressed);
      this.handleBulkActionSelection(rowItem, previouslySelected);
      if (shiftKeyPressed) {
        this.handleBulkActionShiftKeySelection(rowItem);
      } else if (!_.isNil(event)) {
        _.each(this.items, function (item, index) {
          if (item.id === rowItem.id) {
            _this9.bulkActionLastSelectedIndex = index;
            return false;
          }
        });
      }
    }
  };
  this.handleBulkActionCheckboxToggle = function (item, toggleSelected, shiftKeyPressed) {
    var previouslySelected = false;
    if (toggleSelected && !shiftKeyPressed) {
      item.selected = !item.selected;
    } else if (shiftKeyPressed) {
      previouslySelected = toggleSelected ? item.selected : !item.selected;
      item.selected = true;
    }
    return previouslySelected;
  };
  this.handleBulkActionSelection = function (item, previouslySelected) {
    if (this.singleSelect) {
      this.bulkActionSelectedItems = [];
    }
    if (item.selected) {
      if (!previouslySelected) {
        this.bulkActionCount++;
        /* this.showSelector is direct select mode -- doesn't use exclude mode */
        if (!_.isNil(this.bulkActionFilterUri) && !this.showSelector) {
          _.remove(this.bulkActionExcludedItems, function (bulkActionExcludedItem) {
            return bulkActionExcludedItem.id === item.id;
          });
        } else {
          this.bulkActionSelectedItems.push(item);
        }
      }
    } else {
      this.isBulkActionAllSelected = false;
      this.bulkActionCount--;
      if (!_.isNil(this.bulkActionFilterUri) && !this.showSelector) {
        this.bulkActionExcludedItems.push(item);
      } else {
        _.remove(this.bulkActionSelectedItems, function (bulkActionSelectedItem) {
          return bulkActionSelectedItem.id === item.id;
        });
      }
    }
    $scope.$emit(coreConstant.event.gridSelectionChanged, this.bulkActionSelectedItems);
  };
  this.handleBulkActionShiftKeySelection = function (rowItem) {
    var _this10 = this;
    var currentSelectedIndex;
    _.each(this.items, function (item, index) {
      if (item.id === rowItem.id) {
        currentSelectedIndex = index;
        return false;
      }
    });
    _.each(this.items, function (item, index) {
      if (index < currentSelectedIndex && index > _this10.bulkActionLastSelectedIndex || index > currentSelectedIndex && index < _this10.bulkActionLastSelectedIndex) {
        if (!item.selected) {
          _this10.handleBulkActionRowSelection(null, item, true);
        }
      }
    });
  };
  this.onGridMouseDown = function (event) {
    if (event.target.offsetWidth <= event.clientX + 15) {
      $timeout(function () {
        $('.datagrid').click();
      }, 0);
    }
  };
  $scope.$on(coreConstant.event.FILTER_SAVED, function (event, filter) {
    advancedFilterModel.getAdvancedFilterModel(_this11.advancedFilterType).filter = filter;
    $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
  });
  $scope.$on(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE, function () {
    _this11.resetBulkActionState();
    _this11.loadFilter();
    $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
  });
  this.applyCriterionFilters = function (criterionFilters) {
    var currentFilterChanged;
    var filterNames = Object.keys(criterionFilters);
    var selectedCriterionTemplates = this.filterModel.selectedFilterCriterionTemplates;
    _.each(selectedCriterionTemplates, function (selectedCriterionTemplate) {
      if (_.isEmpty(filterNames)) {
        return false;
      }
      if (filterNames.includes(selectedCriterionTemplate.name)) {
        selectedCriterionTemplate.value = criterionFilters[selectedCriterionTemplate.name];
        currentFilterChanged = true;
        _.pull(filterNames, selectedCriterionTemplate.name);
      }
    });
    if (currentFilterChanged) {
      this.isLoading = true;
      this.updateFilter();
    }
  };
  this.resetPublishFormTemplatesActionState = function () {
    if (_this11.activeBulkAction.name === uIFormTemplateAction.PUBLISH_FORM_TEMPLATES) {
      _this11.applyCriterionFilters({
        'Status': ''
      });
    }
  };
  this.updateFilter = function () {
    var filter = advancedFilterModel.buildCurrentFilter(this.advancedFilterType);
    if (!advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType).temporary) {
      filter.temporary = true;
      filter.uri = null;
    }
    filter.userId = currentUserModel.getCurrentUser().userId;
    advancedFilterMediator.saveFilter(filter).then(function (filter) {
      $scope.$emit(coreConstant.event.FILTER_SAVED, filter);
    });
  };
};
GridDataBrowserController.$inject = ["$rootScope", "currentUserModel", "$scope", "$timeout", "$element", "$state", "coreConstant", "advancedFilterModel", "advancedFilterMediator", "navigationStateModel", "gridDataBrowserConstant", "formTemplateStatus", "uIFormTemplateAction"];
angular.module('gw-um-grid-data-browser').controller('gridDataBrowserController', GridDataBrowserController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

var path = '/dynamicGrid.tpl.html';
var html = "<ui-grid-data-browser\r\n    identifier=\"'dynamicGrid'\"\r\n    columns=\"columns\"\r\n    state-params=\"stateParams\"\r\n    advanced-filter-type=\"advancedFilterType\"\r\n    filter-type=\"filterType\"\r\n    translations=\"translations\"\r\n    initial-request-params=\"initialRequestParams\"\r\n    load-items-handler=\"loadItemsHandler\"\r\n    load-actions-handler=\"loadActionsHandler\"\r\n    notify-handle-action=\"handleAction(action, file)\"\r\n    notify-handle-bulk-action=\"handleBulkAction(action, selectedItems, excludedItems, filterId)\"\r\n    show-selector=\"showSelector\"\r\n    single-select=\"false\">\r\n</ui-grid-data-browser>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

var path = '/dynamicGridModal.tpl.html';
var html = "<div class=\"dynamicGridModal\">\r\n\r\n  <div class=\"dynamicGrid\">\r\n\r\n    <div class=\"modal-header\">\r\n        <h3 class=\"modal-title\">{{::title}}</h3>\r\n        <button class=\"close\"\r\n                ng-click=\"onCancel()\">\r\n            <span class=\"glyphicon glyphicon-remove\"></span>\r\n        </button>\r\n    </div>\r\n\r\n    <div ui-browser-detection class=\"modal-body\">\r\n        <ui-grid-data-browser\r\n            identifier=\"'dynamicGrid'\"\r\n            columns=\"columns\"\r\n            state-params=\"stateParams\"\r\n            advanced-filter-type=\"advancedFilterType\"\r\n            filter-type=\"filterType\"\r\n            translations=\"translations\"\r\n            initial-request-params=\"initialRequestParams\"\r\n            load-filter-handler=\"loadFilterHandler\"\r\n            load-items-handler=\"loadItemsHandler\"\r\n            load-actions-handler=\"loadActionsHandler\"\r\n            notify-handle-action=\"handleAction(action, file)\"\r\n            notify-handle-bulk-action=\"handleBulkAction(action, selectedItems, excludedItems, filterId)\"\r\n            show-selector=\"showSelector\"\r\n            single-select=\"singleSelect\">\r\n        </ui-grid-data-browser>\r\n    </div>\r\n\r\n    <!--Footer-->\r\n    <div class=\"modal-footer\">\r\n        <div class=\"resultInfo\">\r\n            <span class=\"dynamicDataResults\">{{result.totalRecords}} Results</span>\r\n            <span class=\"dynamicDataMaxDisplay\" ng-show=\"result.totalRecords>=initialRequestParams.pageSize\">(Max. Display)</span>\r\n\t\t\t<span class=\"dynamicDataSelected\" ng-show=\"!singleSelect\">| {{selected.length}} Selected</span>\r\n        </div>\r\n\r\n        <button class=\"btn btn-default cancelButton\"\r\n                ng-click=\"onCancel()\"\r\n                >{{::cancelButton}}</button>\r\n         <button class=\"btn btn-primary okButton okButton\"\r\n                 ng-disabled=\"!(selected.length>0)\"\r\n                 ng-click=\"onOk()\"\r\n                 >{{okButton}}</button>\r\n        <button class=\"btn btn-default thirdButton\"\r\n                ng-click=\"onThirdButton()\"\r\n                ng-show=\"thirdButton\"\r\n                >{{::thirdButton}}</button>\r\n    </div>\r\n\r\n  </div>\r\n\r\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

/*@ngInject*/
var DynamicDataRepository = function DynamicDataRepository(baseRepository) {
  angular.extend(this, baseRepository);
  this.getFilter = function (dataName, filterType, context) {
    var url = '/rest/DynamicData/' + dataName + '/filter/type/' + filterType,
      params = {};
    return this.post(url, context, {
      params: params
    }).then(function (result) {
      return result;
    });
  };
  this.find = function (dataName, criteria, filterUri) {
    var url = '/rest/DynamicData/' + dataName + '/filter',
      config = {
        params: {
          filterUri: filterUri
        }
      };
    return this.post(url, criteria, config).then(function (result) {
      return result;
    });
  };
  this.execute = function (dataName, actionName, target) {
    var url = '/rest/DynamicData/' + dataName + '/action/' + actionName;
    return this.post(url, target).then(function (result) {
      return result;
    });
  };
};
DynamicDataRepository.$inject = ["baseRepository"];
angular.module('gw-um-extensions').service('dynamicDataRepository', DynamicDataRepository);

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_, $) {var locale = __webpack_require__(94);

/*@ngInject*/
var DynamicGridController = function DynamicGridController($rootScope, $scope, $filter, $stateParams, options, localization, coreMediator, coreConstant, loadingBarHandler, advancedFilterType, filterType, dataSetType, dynamicDataRepository, modalUtil, gridDataBrowserConstant) {
  $scope.i18n = locale;
  $scope.translations = locale;
  $scope.title = 'Demo Dynamic Grid';
  $scope.showSelector = true;
  $scope.singleSelect = false;
  $scope.dataName = "producer";
  $scope.context = {
    submissionId: $stateParams.submissionId,
    formId: $stateParams.formId
  };
  $scope.selected = [];
  $scope.cancelButton = 'Cancel';
  $scope.okButton = 'Select';
  $scope.thirdButton = "No Match";
  $scope.columns = [];
  $scope.advancedFilterType = 'dynamicGrid';
  $scope.filterType = 101;
  $scope.initialRequestParams = {
    key: 'name',
    sortType: 'asc',
    startIndex: 0,
    pageSize: 25
  };
  if (options.customOptions) {
    if (options.customOptions.confirmationTitle) {
      $scope.title = options.customOptions.confirmationTitle;
    }
    if (options.customOptions.yesButtonLabel) {
      $scope.okButton = options.customOptions.yesButtonLabel;
    }
    if (options.customOptions.noButtonLabel) {
      $scope.cancelButton = options.customOptions.noButtonLabel;
    }
    if (options.customOptions.processingIndicatorText) {
      $scope.processingIndicatorText = options.customOptions.processingIndicatorText;
    }
    if (options.customOptions.parameters) {
      $scope.parameters = JSON.parse(options.customOptions.parameters);
      Object.assign($scope, $scope.parameters);
    }
  } else {
    $scope.view = $stateParams.view;
  }

  // get more details about the context from the function button triggering this
  if (options.context) {
    Object.assign($scope.context, options.context);
  }
  $scope.stateParams = {
    browser: 'um.dynamicGrid',
    getDetailState: function getDetailState(input) {}
  };

  // load configuration from system preference system.views.<view> using $scope.view
  if ($scope.view) {
    $scope.advancedFilterType = $scope.view;
    coreMediator.loadDefaultPreferences().then(function (preferences) {
      var prefKey = 'system.views.' + $scope.view;
      if (preferences[prefKey]) {
        var prefValue = preferences[prefKey].value;
        var viewProps = JSON.parse(prefValue);
        Object.assign($scope, viewProps);
        if (viewProps.columns) {
          _.each(viewProps.columns, function (column) {
            column.getValue = function (item) {
              return item[column.valueProp];
            };
          });
        }
      }
      // still make the function button parameters overwrite the system preferences since the button config is easier to change
      if (options.customOptions) {
        if (options.customOptions.confirmationTitle) {
          $scope.title = options.customOptions.confirmationTitle;
        }
        if (options.customOptions.yesButtonLabel) {
          $scope.okButton = options.customOptions.yesButtonLabel;
        }
        if (options.customOptions.noButtonLabel) {
          $scope.cancelButton = options.customOptions.noButtonLabel;
        }
        if (options.customOptions.processingIndicatorText) {
          $scope.processingIndicatorText = options.customOptions.processingIndicatorText;
        }
        if (options.customOptions.parameters) {
          $scope.parameters = JSON.parse(options.customOptions.parameters);
          Object.assign($scope, $scope.parameters);
        }
      }
    });
  }

  // load the default filter using $scope.context
  $scope.loadFilterHandler = function () {
    return dynamicDataRepository.getFilter($scope.dataName, $scope.filterType, $scope.context).then(function (result) {
      return result;
    });
  };

  // load grid data items
  $scope.loadItemsHandler = function (filterUri, requestParams) {
    if ($scope.width) {
      $('.modal-content').width($scope.width);
    }
    if ($scope.height) {
      $('.modal-content').height($scope.height);
    }
    var criteria = {
      sortBy: requestParams.key,
      sortDirection: requestParams.sortType,
      startIndex: requestParams.startIndex,
      maxResults: requestParams.pageSize
    };
    criteria.context = $scope.context;
    return dynamicDataRepository.find($scope.dataName, criteria, filterUri).then(function (result) {
      $scope.result = {
        totalRecords: result.count,
        records: result.items
      };
      // save the items not in current display list separately
      $scope.selectedOutOfResults = [];
      if (result.selectedItems) {
        $scope.selected = result.selectedItems;
        _.each(result.selectedItems, function (item) {
          var exists = false;
          _.each(result.items, function (existing) {
            // use toString to compare just in case some ids are saved as string, some as number
            if (item["id"] && existing["id"] && item["id"].toString() === existing["id"].toString()) {
              exists = true;
            }
          });
          if (!exists) {
            $scope.selectedOutOfResults.push(item);
          }
        });
      }
      return $scope.result;
    });
  };

  // not really used -- just to fill parameters for gridDataBrowser
  $scope.action = {
    name: "Select",
    valid: true,
    enabled: true,
    buttonBarAction: true,
    /*isBulkAction:true,*/bulkActionLabel: 'Confirm',
    defaultExecute: true
  };
  $scope.loadActionsHandler = function () {
    return coreMediator.loadDefaultPreferences().then(function (preferences) {
      return {
        actions: [$scope.action]
      };
    });
  };

  // not really used -- just to fill parameters for gridDataBrowser
  $scope.handleAction = function (action, file) {
    if (action.enabled) {
      switch
        //                default:
        //                    modalUtil.showActionNotImplementedModal(action.name);
        //                    break;
      (action.name) {}
    }
  };

  // not really used -- just to fill parameters for gridDataBrowser
  $scope.handleBulkAction = function (action, selectedItems, excludedItems, filterUri) {
    if (action.enabled) {
      switch (action.name) {
        default:
          return dynamicDataRepository.execute($scope.dataName, action.name, {
            data: selectedItems
          }).then(function (result) {
            return result;
          });
          $rootScope.$broadcast(gridDataBrowserConstant.event.BULK_ACTION_COMPLETE);
          break;
      }
    }
  };

  // track selected items independent of gridDataBrowser
  $scope.$on(coreConstant.event.gridSelectionChanged, function (event, selected) {
    $scope.selected = $scope.selectedOutOfResults.concat([]);
    // only add items not in the non-display selected set
    _.each(selected, function (item) {
      var exists = false;
      _.each($scope.selected, function (existing) {
        if (item["id"] && existing["id"] && item["id"].toString() === existing["id"].toString()) {
          exists = true;
        }
      });
      if (!exists) {
        $scope.selected.push(item);
      }
    });
  });

  // main action
  $scope.onOk = function () {
    var target = {
      name: $scope.dataName,
      context: $scope.context,
      count: $scope.selected.length,
      items: $scope.selected
    };
    loadingBarHandler.showLoadingBar($scope.processingIndicatorText);
    return dynamicDataRepository.execute($scope.dataName, $scope.okButton, target).then(function (result) {
      loadingBarHandler.hideLoadingBar();
      $scope.$close();
      return result;
    });
  };
  $scope.onThirdButton = function () {
    var target = {
      name: $scope.dataName,
      context: $scope.context,
      count: $scope.selected.length,
      items: $scope.selected
    };
    loadingBarHandler.showLoadingBar($scope.processingIndicatorText);
    return dynamicDataRepository.execute($scope.dataName, $scope.thirdButton, target).then(function (result) {
      loadingBarHandler.hideLoadingBar();
      $scope.$close();
      return result;
    });
  };
  $scope.onCancel = function () {
    $scope.$dismiss();
  };
  $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
    $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
  });
  $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};
DynamicGridController.$inject = ["$rootScope", "$scope", "$filter", "$stateParams", "options", "localization", "coreMediator", "coreConstant", "loadingBarHandler", "advancedFilterType", "filterType", "dataSetType", "dynamicDataRepository", "modalUtil", "gridDataBrowserConstant"];
angular.module('gw-um-extensions').controller('dynamicGridController', DynamicGridController);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0), __webpack_require__(4)))

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

/*@ngInject*/
var DynamicGridExtension = function DynamicGridExtension($rootScope, coreConstant, $uibModal) {
  $rootScope.$on(coreConstant.event.functionExecute, function (event, customOptions, context) {
    if (customOptions.functionClass === 'DynamicGridPopup') {
      $uibModal.open({
        templateUrl: '/dynamicGridModal.tpl.html',
        controller: 'dynamicGridController',
        windowClass: 'dynamicGridModal',
        resolve: {
          options: function options() {
            return {
              customOptions: customOptions,
              context: context
            };
          }
        },
        keyboard: false,
        backdrop: 'static'
      });
    }
  }.bind(this));
};
DynamicGridExtension.$inject = ["$rootScope", "coreConstant", "$uibModal"];
angular.module('gw-um-extensions').service('dynamicGridExtension', DynamicGridExtension);

/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e7e98b69acd9ac2c84becd2ac5965771.svg";

/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2427);
__webpack_require__(2428);
__webpack_require__(2429);
__webpack_require__(2430);
__webpack_require__(2434);
__webpack_require__(2438);
__webpack_require__(2442);
__webpack_require__(2446);
__webpack_require__(2450);
var OptionGroupComponent = {
  templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroup.tpl.html',
  controller: 'optionGroupController',
  bindings: {
    selectedField: '<',
    selectedFieldStructure: '<',
    optionGroupName: '<',
    displayHeader: '<',
    headerTitleKey: '<',
    settings: '<',
    scrollableContainerSelector: '<'
  }
};
angular.module('ums.configuration').component('uiOptionGroup', OptionGroupComponent);

/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(_) {/*@ngInject*/
var SectionTemplateEditorModel = function SectionTemplateEditorModel($rootScope, configurationMediator, configurationConstant, sectionTemplateApplicabilityType) {
  var sectionTemplateEditorModel = {};
  this.reset = function (sectionTemplateId) {
    if (!_.isNil(sectionTemplateId)) {
      sectionTemplateEditorModel[sectionTemplateId] = {
        sectionTemplate: null,
        quoteDocumentTemplateFile: null,
        isValid: null,
        isValidToSave: null,
        isValidRule: null,
        isValidRuleToSave: null,
        hasUnsavedPropertiesChanges: false,
        hasUnsavedRuleChanges: false,
        hasUnsavedQuoteDocumentTemplateFile: false
      };
    } else {
      sectionTemplateEditorModel = {};
    }
  };
  this.buildSectionTemplate = function (sectionTemplateId) {
    this.reset(sectionTemplateId);
    if (sectionTemplateId === -1) {
      // New section template
      this.updateSectionTemplate({
        id: -1,
        name: null,
        description: null,
        active: true,
        applicability: sectionTemplateApplicabilityType.OPTIONAL,
        applicableToBinder: false,
        applicableToProposal: true,
        productTemplates: [],
        ordinalNumber: null,
        stitchable: true,
        formTemplateUniqueName: null,
        adapterBeanName: null,
        documentTemplateName: null
      });
    } else {
      configurationMediator.getSectionTemplateById(sectionTemplateId).then(function (sectionTemplate) {
        this.updateSectionTemplate(sectionTemplate);
      }.bind(this));
    }
  };
  this.getSectionTemplate = function (sectionTemplateId) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    return model.sectionTemplate;
  };
  this.setValid = function (sectionTemplateId, valid) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    model.isValid = valid;
    model.isValidToSave = valid;
  };
  this.isValid = function (sectionTemplateId) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    return model.isValid;
  };
  this.setValidRule = function (sectionTemplateId, valid) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    model.isValidRule = valid;
    model.isValidRuleToSave = valid;
  };
  this.isValidRule = function (sectionTemplateId) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    return model.isValidRule;
  };
  this.setUnsavedRuleChanges = function (sectionTemplateId, hasUnsavedChanges) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    model.hasUnsavedRuleChanges = hasUnsavedChanges;
  };
  this.hasUnsavedRuleChanges = function (sectionTemplateId) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    return model.hasUnsavedRuleChanges;
  };
  this.setUnsavedPropertiesChanges = function (sectionTemplateId, hasUnsavedChanges) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    model.hasUnsavedPropertiesChanges = hasUnsavedChanges;
  };
  this.hasUnsavedPropertiesChanges = function (sectionTemplateId) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    return model.hasUnsavedPropertiesChanges;
  };
  this.isValidToSave = function (sectionTemplateId) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    return _.isNil(model.isValidToSave) || model.isValidToSave;
  };
  this.isValidRuleToSave = function (sectionTemplateId) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    return _.isNil(model.isValidRuleToSave) || model.isValidRuleToSave;
  };
  this.setQuoteDocumentTemplateFile = function (sectionTemplateId, file) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    model.quoteDocumentTemplateFile = file;
  };
  this.getQuoteDocumentTemplateFile = function (sectionTemplateId) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    return model.quoteDocumentTemplateFile;
  };
  this.setUnsavedQuoteDocumentTemplateFile = function (sectionTemplateId, hasUnsavedFile) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    model.hasUnsavedQuoteDocumentTemplateFile = hasUnsavedFile;
  };
  this.hasUnsavedQuoteDocumentTemplateFile = function (sectionTemplateId) {
    var model = sectionTemplateEditorModel[sectionTemplateId];
    return model.hasUnsavedQuoteDocumentTemplateFile;
  };
  this.updateSectionTemplate = function (sectionTemplate) {
    var model = {
      sectionTemplate: _.cloneDeep(sectionTemplate),
      quoteDocumentTemplateFile: null,
      isValid: null,
      isValidToSave: null,
      isValidRule: null,
      isValidRuleToSave: null,
      hasUnsavedPropertiesChanges: false,
      hasUnsavedRuleChanges: false,
      hasUnsavedQuoteDocumentTemplateFile: false
    };
    sectionTemplateEditorModel[sectionTemplate.id] = model;
    $rootScope.$broadcast(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, sectionTemplate.id);
  };
};
SectionTemplateEditorModel.$inject = ["$rootScope", "configurationMediator", "configurationConstant", "sectionTemplateApplicabilityType"];
angular.module('ums.configuration').service('sectionTemplateEditorModel', SectionTemplateEditorModel);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)))

/***/ }),

/***/ 783:
/***/ (function(module) {

module.exports = JSON.parse("{\"newLabel\":\"New\"}");

/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/*@ngInject*/
var RateStatusRowDomManagerDirective = function RateStatusRowDomManagerDirective($rootScope, $timeout, $document, configurationConstant) {
  var linkFunction = function linkFunction($scope, $elm, $attr) {
    function handleClick(event) {
      if (event.target.className === 'match') {
        event.preventDefault();
        return;
      } else if (isClassNameExist(event, 'rowComponentInner')) {
        $scope.$apply(function () {
          $rootScope.$broadcast(configurationConstant.event.STATE_RATE_ROW_CLICKED, $scope.$ctrl.item.id);
          $scope.$ctrl.setDefaultState();
        });
        event.preventDefault();
      } else if (isClassNameExist(event, 'locationLabelBox') || isClassNameExist(event, 'locationLabel') || isClassNameExist(event, 'productLabelBox') || isClassNameExist(event, 'productLabel') || isClassNameExist(event, 'statusLabelBox') || isClassNameExist(event, 'statusLabel') || isClassNameExist(event, 'match') || isClassNameExist(event, 'dateEffectiveLabelBox') || isClassNameExist(event, 'dateEffectiveLabel') || isClassNameExist(event, 'dateExpirationLabelBox') || isClassNameExist(event, 'dateExpirationLabel')) {
        $scope.$apply(function () {
          $rootScope.$broadcast(configurationConstant.event.STATE_RATE_ROW_CLICKED, $scope.$ctrl.item.id);
          $scope.$ctrl.changeState();
        });
        event.preventDefault();
        $timeout(function () {
          var clickTarget;
          if (isClassNameExist(event, 'locationLabel')) {
            clickTarget = $('.location .match');
          }
          if (isClassNameExist(event, 'productLabel')) {
            clickTarget = $('.product .match');
          }
          if (isClassNameExist(event, 'statusLabel')) {
            clickTarget = $('.status .match');
          }
          if (isClassNameExist(event, 'dateEffectiveLabel')) {
            clickTarget = $('.dateEffectiveBox .toggleCalendarPopup');
          }
          if (isClassNameExist(event, 'dateExpirationLabel')) {
            clickTarget = $('.dateExpirationBox .toggleCalendarPopup');
          }
          clickTarget[0].click();
        }, 0);
      }
      event.stopPropagation();
    }
    $scope.$on(configurationConstant.event.STATE_RATE_ROW_CLICKED, function (event, item) {
      if ($scope.$ctrl.item.id !== item) {
        $scope.$ctrl.rowSelected = false;
      }
    });
    function isClassNameExist(event, className) {
      return event.target.className.indexOf(className) !== -1;
    }
    function onDocumentClick(event) {
      var isHeader = $(event.target).closest('.headerContent').length > 0,
        isGridHeader = $(event.target).closest('.columnHeader').length > 0,
        isAppHeader = $(event.target).closest('.appHeader').length > 0,
        isRateStatusManager = $(event.target).closest('.rateStatusManager').length > 0,
        isElement = isHeader || isGridHeader || isAppHeader;
      if (isElement) {
        $scope.$apply(function () {
          $scope.$ctrl.setDefaultState();
        });
        event.preventDefault();
      }
    }
    if (!$scope.$ctrl.isReadOnly) {
      $elm.bind('click', handleClick);
      $document.bind('click', onDocumentClick);
    }
    $scope.$on('$destroy', function () {
      $elm.unbind('click', handleClick);
      $document.unbind('click', onDocumentClick);
    });
  };
  return {
    link: linkFunction,
    restrict: 'A'
  };
};
RateStatusRowDomManagerDirective.$inject = ["$rootScope", "$timeout", "$document", "configurationConstant"];
angular.module('ums.configuration').directive('umRateStatusRowDomManager', RateStatusRowDomManagerDirective);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))

/***/ }),

/***/ 93:
/***/ (function(module) {

module.exports = JSON.parse("{}");

/***/ }),

/***/ 94:
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"Dynamic Data\",\"columns\":{\"name\":\"Name\",\"city\":\"City\",\"number\":\"Number\",\"email\":\"Email\",\"organization\":\"Organization\",\"type\":\"Type\",\"description\":\"Description\",\"lastModifiedBy\":\"Last Edited By\",\"timeLastModified\":\"Last Modified Date\"},\"emptyGrid\":\"No matching data\",\"recordCountText\":\"Showing startIndex to endIndex of total Data\",\"recordsCountText\":\"Showing startIndex to endIndex of total Data\",\"clearButton\":\"Clear All\",\"textInputFilter\":{\"nameSubstring\":{\"placeholder\":\"Search data\"}},\"bulkActionLabel\":\"Item Selected\",\"bulkActionCancelButtonLabel\":\"Cancel\",\"selectFilter\":{\"types\":{\"placeholder\":\"All Types\"},\"productNames\":{\"placeholder\":\"All Products\"}},\"actions\":{\"name\":\"Actions\",\"Test Action\":\"Test Action\"}}");

/***/ })

},[[1837,1,2,0]]]);
});